webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var config = getParamConfig('prod');

function getParamConfig(env) {
	var data = {
		baseUrl: '',
		ip: ''
	};
	switch (env) {
		case 'dev':
			data.baseUrl = "http://127.0.0.1:7979/";
			data.ip = "http://127.0.0.1:8080/";
			break;
		case 'test':
			data.baseUrl = "https://api-testnet.iob.community/iob/";
			data.ip = "https://testnet.iob.community/";
			break;
		case 'prod':
			data.baseUrl = "https://api.iob.community/iob/";
			data.ip = "https://iob.community/";
			break;
		default:
			data.baseUrl = "http://127.0.0.1:7979/";
			data.ip = "http://127.0.0.1:8080/";
			break;
	}
	return data;
}

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);

var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAj0AAAIACAYAAABpdd1yAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAEkNJREFUeJzt3XuQ73Vdx/HXyuFiSAakIjcjTcNGEbuApONkFykZTEy0rLRgVFIjKVSmIZ1sVBJHJ5EwSQktFUNx1NSaxiIblTQBbyUVicAodzlcwnP59cdnz/jd3+7P3d/l7Hf39348ZnbO7/Pd336/n3PmnN3n+V4TAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgLmw0PcEGM9gMOh7CgDV7Z/kMUl+OMkhSQ5Msm+SPZJsT3JXkpuTXJ/kmiRfTHLv7pjIwoIf4+PY0vcEAGATOC7JM5Icm+RxSR4wxtfekuTfk3wqyd8m+erMZ8eaSMRNxp4egHVzcJKXJvntJA+e4Xq/luS8JBdmyj1A9vSMx5/WJiN6AHa7Q5Kcm+Q5a3jvd5LcmuSeJDvSjqDsl+SAtMNd38u2JOck+ZMk900yUdEzHn9am8xgMDg+yU+n/QPZ0fN02Njul/n4N+7vOas5MMm7k1w5g3W9LskrR3xukOTTSf5hcVvXJrkxLXp2dt63Z5IHJTk0ySOS/ESSpyZ59Ij13pvkBWm/h7GInvH409pkBoPB29L+cQDwXS9M8hdTfP3jk3wkyUNX+NzVaYej3p/kjim2cXiS5yV5Udqhs2GfTPL0JFvXukLRM5779T0Bxub4FsBy03xvPD3J57M8eK5IO3H5qCRvz3TBkyTXJXlN2uGzZ6dd3dX1M0m+leRJU26HEUQPAJVdkOTNQ8vuSHJikmOSfHY3bfeSJIclOWto+f2TXJ7klN203dJEDwBVXZJ2WKzrA2nnCH14nebw+iQ/lOQ/hpZfmOQP1mkOZYgeACp6X5JnDS17WZJnZulJyevh60mOTPKeoeVvSHLGOs9lrrk5IQDVnJfk5KFlJyX54ArvPTttT8y3V1nnQtqVhluTfDPtTsxXJrltjHn9WpJvJHl5Z9kbk9yUCa7sYjnRA0AlL03y4qFlT0vydyPef2raVVeT+kLaHpwLk9y+hve/Iu0S9ld1lr0rLaJ21/lFZTi8BUAVxyT5s6Flv5rRwZNMf8Xs0Un+NG2Pz6vX+DWvzvJ5vifJPlPOpTzRA0AVw/fxOTvJe9dx+69KO+T1wDW89/QkH+uMj0jylt0xqUpEDwAVnJ3ksZ3xR9Me/zCJu9Pup3PL4sfNi7+u5VESR6Xd1XmvNbz3uYvb2eXUJD831kxZQvQAMO8OS/KHnfG9SU6bYn3nJDkoycOGPg5JuwrrGUnOT3LXiK8/Mslb17Cd27P8/KNJQ42IHgDm3xlJ9u6Mz067SmpS31n89Z7Fj3sXf7017X47l6XFygFJPj5iHadm9LO4ui7N0qvKjsnyK89YI9EDwDx7UFpg7HJN2mXg01jrA6+2JfnFtCu4VvLLa1zPHw+Nf2eNX8cQ0QPAPHtukgd0xuf1MIc3jVh+7Bq//sq0mynu8uS0PT6MSfQAMM+e03l9R5KLe5jDZ0YsP2SMdbxjaHzShHMpTfQAMK8elaV7RC7L9E9Kn8Q3s/IdnfcYYx1/n6XP5zphqhkVJXoAmFdPHhp/pJdZtKcfrBQ44wbYJzqvH521nQhNh+gBYF49ofN6W0YfZtrdjsjS84p2+fKY6/mnofGPTzSbwkQPAPPqyM7rq5Pc0NM8fn7E8o+NWD7K57L0CfBHTzadukQPAPNo77Sno+8y7l6VWTk4yVkrLL864x9uuz7J/3TGj5x0UlWJHgDm0UOTPKQzvm6G617rQ0gfnXZIbaVnbZ054ba7e6seOuE6ytrS9wQAYDc4YGh88wzXfWiSH0jy8M6ynWk7EvZL8iNJnpXRh7XOSLsaaxI3dV7vP+E6yhI9AMyj/YbGW2e47pcsfkzit5JcNMW2u5e+f98U6ynJ4S0A5tGeQ+Ptvcziuz6a5PBMFzzJ0ie523ExJn9gAMyjHUPjPv6Tf2naDRE/neS/Z7TObsztHPkuViR6AJhHdw+N9+1hDjuSvD9L985Mq3u/n3tmuN4SHN4CYB7dNjQ+cIbrvjjJ45KcmOT4JCcn+eQK7zs5yf8l+YUZbvvBndd3znC9JYgeAObRTUlu74wPneG6v5LkqiQfTns0xPuTPCXJaSPe/4kkPzWjbXcvU//WjNZZhugBYB7dmeQbnfGRo944gYURyy9I8rsjPvc3SfaacrsHZOkNF2d1nlAZogeAefW1zuvHZuWbBM7aW5JcssLyhyd53ZTrPipLz026asr1lSN6AJhXV3RePzDJT67Tds/Myicvn5Hpnow+/NT4z0+xrpJEDwDz6p+Hxsev03avS/LGEZ97+RTr7d7h+YaInrGJHgDm1RVJrumMT8ro83Fm7fysvLfneZns/KLHJTmuM/54lt+LiFWIHgDm2Qc6r49I8ivrtN0bMvruy2dMsL7fHBp/cIJ1lCd6AJhn7xoav3Qdt/22EctPTfLIMdbzkCQv7Iy/mvZYC8YkegCYZ1/O0r09T0p7Avp6+EJGx8npY6znFVn6cNG3Tzyj4kQPAPPu3KHxa7N+j2F664jlp6UdblvN0Ule1hlfl+S8aSdVlegBYN59Ou3REbs8IstDaHf5WNoen2ELWdvenvOHxq9Jsm3aSVUlegCo4KwkWzvj07N+h7n+fMTyF+V7Px7j3CTHdsafTHLhrCZVkegBoIIbs/wREe9NuxR8d7s47WquYXun3chwJack+f3OeEdaJDEF0QNAFRcleUdnfL8k/5ilz7PaHe7L6Cu5Tkty+NCyE7N8j84pWfpYDSawXidyAcBGcErazQGfsDg+IMnn0g4j/dcK7/+ltOdd7TqPZp8k106w3Ten3VBwe5LB4rLtaZejd28yeFKSS4e+9g1J/mqCbTJE9ABQzVPTTi5++OL4wLRL2382yaeG3vuVGW1za5J/W2H5lzqvX5L2wNKud2e6R1fQ4fAWANVsTdvT8/XOsr2S/EuWnkezni7K8uC5JMlvrP9U5pfoAaCim9NOYh7ek3Nukn9NcvA6zeOYJNenPZOr6y+TPHud5lCG6AGgqjuS/FiW3zX5uLSrrd6U5AG7aduHJflQks8kOWToc2elPaqCGRM9AFR3QpJXrrD895LcnvbYh8fOaFtPSfLhtDsrnzj0uTvTHpPx+hltiyGiZ/NZ6HsCABvQtN8bz0nyo0m+OLR8S9pel6uSXJN2FdbT0y5zX+1ioH3SrhT79STvTPLNtEvkT1jhve9K8oNZfiI1M+Tqrc3n22mXTt6ddu8HWMmOJPsnuX/fE5nS9iS3LL4W/KxkIcmDk9wzg3X9Z9oeneekxc1Dhj7/iLQ7Oe96fMStSb6Rdn7QXWn/7vZMst/i1x6++Pp7+WzaE9Svmn76rMY3kU1mMBhsSbJH3/NgQ9uZFsYXZ/Nf+fGlJI9ZfL13nxNhQ1tI+zu/Y7U3junZaU84P3rG603a+TyvTXLFNCtZWPBjfBz29Gw+2xc/YDU7+57ADHR/D/Zsst7et/jxqCQnJ3laksen7c0Z151pV4VdlnbzwVtnNEfGIBE3mcFgsPqboLkoyy+D3Wy+mNmdQAqzsF/anp/HpN3c8KAk3592/s4eaf8pvSftyrAb0w6ZXZm213Lm/2G1p2c89vQAwNptTXL54gebjKu3AIASRA8AUILoAQBKED0AQAmiBwAoQfQAACWIHgCgBNEDAJQgegCAEkQPAFCC6AEAShA9AEAJogcAKEH0AAAliB4AoATRAwCUIHoAgBJEDwBQgugBAEoQPQBACaIHAChB9AAAJYgeAKAE0QMAlCB6AIASRA8AUILoAQBKED0AQAmiBwAoQfQAACWIHgCgBNEDAJQgegCAEkQPAFCC6AEAShA9AEAJogcAKEH0AAAliB4AoATRAwCUIHoAgBJEDwBQgugBAEoQPQBACaIHAChB9AAAJYgeAKAE0QMAlCB6AIASRA8AUILoAQBKED0AQAmiBwAoQfQAACWIHgCgBNEDAJQgegCAEkQPAFCC6AEAShA9AEAJogcAKEH0AAAliB4AoATRAwCUIHoAgBJEDwBQgugBAEoQPQBACaIHAChB9AAAJYgeAKAE0QMAlCB6AIASRA8AUILoAQBKED0AQAmiBwAoQfQAACWIHgCgBNEDAJQgegCAEkQPAFCC6AEAShA9wEY26HsCwPzY0vcEGNt+SfZN+2HgBwIr2ZnkliT79D2RGdgz7e/8QpL79zwXNq4tSW5Lcm/fE2FjW+h7AoxnMBicl+TFi8P7+pwLG9ogLRj26HsiUxok2db3JNjQFtL+rr8gydt7nsu6W1jwY3wc9vRsPnt2Xu/d2yxgfSwk2avvSbApbPbAZx04p2fzcUgLACYgegCAEkQPAFCC6AEAShA9AEAJogcAKEH0AAAliB4AoATRAwCUIHoAgBJEDwBQgugBAEoQPQBACaIHAChB9AAAJYgeAKAE0QMAlCB6AIASRA8AUILoAQBKED0AQAmiBwAoQfQAACWIHgCgBNEDAJQgegCAEkQPAFCC6AEAShA9AEAJogcAKEH0AAAliB4AoATRAwCUIHoAgBJEDwBQgugBAEoQPQBACaIHAChB9AAAJYgeAKAE0QMAlCB6AIASRA8AUILoAQBKED0AQAmiBwAoQfRsPgt9TwBgA/K9kVVt6XsCjO2vk3w1ybYkO3qeCxvTIMnNSc5McmzPc5nWjUn+KO0H2l49z4WNa/8kl/c9CTY+ZbzJDAaDvqfA5vHOJM/vexJTujrJUX1PAjaqhQU/xsfh8BbMr3n4bjgPvwdggxA9AEAJogcAKEH0AAAliB4AoATRAwCUIHoAgBJEDwBQgugBAEoQPQBACaIHAChB9AAAJYgeAKAE0QMAlCB6AIASRA8AUILoAQBKED0AQAmiBwAoQfQAACWIHgCgBNEDAJQgegCAEkQPAFCC6AEAShA9AEAJogcAKEH0AAAliB4AoATRAwCUIHoAgBJEDwBQgugBAEoQPQBACaIHAChB9AAAJYgeAKAE0QMAlCB6AIASRA8AUILoAQBKED0AQAmiBwAoQfQAACWIHgCgBNEDAJQgegCAEkQPAFCC6AEAShA9AEAJogcAKEH0AAAliB4AoATRAwCUIHoAgBJEDwBQgugBAEoQPQBACaIHAChB9AAAJYgeAKAE0QMAlCB6AIASRA8AUILoAQBKED0AQAmiBwAoQfQAACWIHgCgBNEDAJQgegCAEkQPAFCC6AEAShA9AEAJogcAKEH0AAAliB4AoATRAwCUIHoAgBJEDwBQgugBAEoQPQBACaIHAChB9AAAJYgeAKAE0QMAlCB6YH4N+p7ADMzD7wHYILb0PQHG9vwkJyS5J8n2fqfCBjVIsjXJE/ueyAwcluSCxde+X7GShSQHJTknyeU9z4UNzjeRzeeJSZ7Z9yRgneyf5IV9T4JN4UMRPazC4a3Nx+5+gOV8b2RVogcAKEH0AAAliB4AoATRAwCUIHoAgBJEDwBQgugBAEoQPQBACaIHAChB9AAAJYgeAKAE0QMAlCB6AIASRA8AUILoAQBKED0AQAmiBwAoQfQAACWIHgCgBNEDAJQgegCAEkQPAFCC6AEAShA9AEAJogcAKEH0AAAliB4AoATRAwCUIHoAgBJEDwBQgugBAEoQPQBACaIHAChB9AAAJYgeAKAE0QMAlCB6AIASRA8AUILoAQBKED0AQAmiBwAoQfQAACWIHgCgBNEDAJQgegCAEkTP5rPQ9wQANiDfG1nVlr4nwNj+N8m1SbYm2dbvVNjg5uWHwI6+J8CGtpDkYUlu6nsiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABsBP8PYu7OLqfVi8YAAAAASUVORK5CYII="

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/google_authenticator.8a57f86.jpg";

/***/ }),
/* 88 */,
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Layout_vue__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Layout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Layout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_common_Page404_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_common_Page404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_common_Page404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_common_Page500_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_common_Page500_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_common_Page500_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_common_Privacy_vue__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_common_Privacy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_common_Privacy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_common_GDPR_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_common_GDPR_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_common_GDPR_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_common_AML_vue__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_common_AML_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_common_AML_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_common_KYC_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_common_KYC_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_common_KYC_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_common_ContentPolicy_vue__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_common_ContentPolicy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_common_ContentPolicy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_about_About_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_about_About_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_about_About_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_about_Poet_vue__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_about_Poet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_about_Poet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_about_FrequentlyAskedQuestions_vue__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_about_FrequentlyAskedQuestions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_about_FrequentlyAskedQuestions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_about_Investorrelations_vue__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_about_Investorrelations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_about_Investorrelations_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_about_Contact_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_about_Contact_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_about_Contact_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_faq_LostGoogleAuthentication_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_faq_LostGoogleAuthentication_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_faq_LostGoogleAuthentication_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_user_Register_vue__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_user_Register_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_user_Register_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_user_Login_vue__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_user_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_user_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_user_Password_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_user_Password_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_user_Password_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_user_ResetPassword_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_user_ResetPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_user_ResetPassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_user_RegisterSuccess_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_user_RegisterSuccess_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_user_RegisterSuccess_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_user_Activation_vue__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_user_Activation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_user_Activation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_user_EnableAuthentication_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_user_EnableAuthentication_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_user_EnableAuthentication_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_user_ResetAuthentication_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_user_ResetAuthentication_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_user_ResetAuthentication_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_user_CloseGoogleAuthentication_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_user_CloseGoogleAuthentication_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_user_CloseGoogleAuthentication_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_user_UserKyc_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_user_UserKyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_user_UserKyc_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_user_UpdateEmail_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_user_UpdateEmail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_user_UpdateEmail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_user_UserFollow_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_user_UserFollow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_user_UserFollow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_user_UserData_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_user_UserData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_user_UserData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_user_UserSetting_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_user_UserSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_user_UserSetting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_user_UserRanking_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_user_UserRanking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__pages_user_UserRanking_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_user_UserWallet_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_user_UserWallet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__pages_user_UserWallet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_project_Project_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_project_Project_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__pages_project_Project_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_project_CreateProject_vue__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_project_CreateProject_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__pages_project_CreateProject_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_project_AuditProject_vue__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_project_AuditProject_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__pages_project_AuditProject_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_project_ProjectDetail_vue__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_project_ProjectDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__pages_project_ProjectDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_project_ProjectIndex_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_project_ProjectIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__pages_project_ProjectIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_token_Transaction_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_token_Transaction_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__pages_token_Transaction_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_token_TransactionData_vue__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_token_TransactionData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__pages_token_TransactionData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_token_Investment_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_token_Investment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__pages_token_Investment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_token_InvestmentData_vue__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_token_InvestmentData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__pages_token_InvestmentData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_request_UploadMaterial_vue__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_request_UploadMaterial_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__pages_request_UploadMaterial_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_request_UserRequest_vue__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_request_UserRequest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__pages_request_UserRequest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_microarticle_MicroArticles_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_microarticle_MicroArticles_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__pages_microarticle_MicroArticles_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_microarticle_MicroArticle_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_microarticle_MicroArticle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__pages_microarticle_MicroArticle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_post_Posts_vue__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_post_Posts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__pages_post_Posts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_post_Post_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_post_Post_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__pages_post_Post_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_post_TagPosts_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_post_TagPosts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__pages_post_TagPosts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_post_MarketPosts_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_post_MarketPosts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__pages_post_MarketPosts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_post_SearchPosts_vue__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_post_SearchPosts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__pages_post_SearchPosts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pages_post_CreatePost_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pages_post_CreatePost_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__pages_post_CreatePost_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pages_feed_Feed_vue__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pages_feed_Feed_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__pages_feed_Feed_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_ImageUpload_vue__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_ImageUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_ImageUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__pages_test_Scroll_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__pages_test_Scroll_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__pages_test_Scroll_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__pages_test_Scrolling_vue__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__pages_test_Scrolling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__pages_test_Scrolling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__pages_user_TelegramUserMessages_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__pages_user_TelegramUserMessages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__pages_user_TelegramUserMessages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__pages_user_Notification_vue__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__pages_user_Notification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__pages_user_Notification_vue__);




























































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	scrollBehavior: function scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	},

	routes: [{ path: '/', name: '', component: __WEBPACK_IMPORTED_MODULE_45__pages_post_Posts_vue___default.a }, { path: '/', name: 'home', component: __WEBPACK_IMPORTED_MODULE_45__pages_post_Posts_vue___default.a }, { path: '*', name: 'page404', component: __WEBPACK_IMPORTED_MODULE_3__pages_common_Page404_vue___default.a }, { path: '*', name: 'page500', component: __WEBPACK_IMPORTED_MODULE_4__pages_common_Page500_vue___default.a }, { path: '/about/privacy', name: 'privacy', component: __WEBPACK_IMPORTED_MODULE_5__pages_common_Privacy_vue___default.a }, { path: '/about/GDPR', name: 'GDPR', component: __WEBPACK_IMPORTED_MODULE_6__pages_common_GDPR_vue___default.a }, { path: '/about/AML', name: 'AML', component: __WEBPACK_IMPORTED_MODULE_7__pages_common_AML_vue___default.a }, { path: '/about/ContentPolicy', name: 'ContentPolicy', component: __WEBPACK_IMPORTED_MODULE_9__pages_common_ContentPolicy_vue___default.a }, { path: '/about/KYC', name: 'KYC', component: __WEBPACK_IMPORTED_MODULE_8__pages_common_KYC_vue___default.a }, { path: '/about', name: 'about', component: __WEBPACK_IMPORTED_MODULE_10__pages_about_About_vue___default.a }, { path: '/about/poet', name: 'poet', component: __WEBPACK_IMPORTED_MODULE_11__pages_about_Poet_vue___default.a }, { path: '/about/frequently-asked-questions', name: 'frequently-asked-questions', component: __WEBPACK_IMPORTED_MODULE_12__pages_about_FrequentlyAskedQuestions_vue___default.a }, { path: '/ir', name: 'investorrelations', component: __WEBPACK_IMPORTED_MODULE_13__pages_about_Investorrelations_vue___default.a }, { path: '/about/contact', name: 'contact', component: __WEBPACK_IMPORTED_MODULE_14__pages_about_Contact_vue___default.a }, { path: '/faq/authentication/lost', name: 'lostGoogleAuthentication', component: __WEBPACK_IMPORTED_MODULE_15__pages_faq_LostGoogleAuthentication_vue___default.a }, { path: '/register', name: 'register', component: __WEBPACK_IMPORTED_MODULE_16__pages_user_Register_vue___default.a }, { path: '/password', name: 'password', component: __WEBPACK_IMPORTED_MODULE_18__pages_user_Password_vue___default.a }, { path: '/resetPassword', name: 'resetPassword', component: __WEBPACK_IMPORTED_MODULE_19__pages_user_ResetPassword_vue___default.a }, { path: '/registersuccess', name: 'registersuccess', component: __WEBPACK_IMPORTED_MODULE_20__pages_user_RegisterSuccess_vue___default.a }, { path: '/activation', name: 'activation', component: __WEBPACK_IMPORTED_MODULE_21__pages_user_Activation_vue___default.a }, { path: '/user/2fa/enable', name: 'enableAuthentication', component: __WEBPACK_IMPORTED_MODULE_22__pages_user_EnableAuthentication_vue___default.a, meta: { requireAuth: true } }, { path: '/user/profile/:username', name: 'userData', component: __WEBPACK_IMPORTED_MODULE_28__pages_user_UserData_vue___default.a }, { path: '/user/settings', name: 'userSetting', component: __WEBPACK_IMPORTED_MODULE_29__pages_user_UserSetting_vue___default.a, meta: { requireAuth: true } }, { path: '/updateEmail', name: 'updateEmail', component: __WEBPACK_IMPORTED_MODULE_26__pages_user_UpdateEmail_vue___default.a }, { path: '/user/follow/:username', name: 'follow', component: __WEBPACK_IMPORTED_MODULE_27__pages_user_UserFollow_vue___default.a }, { path: '/user/wallet', name: 'wallet', component: __WEBPACK_IMPORTED_MODULE_31__pages_user_UserWallet_vue___default.a, meta: { requireAuth: true } }, { path: '/authentication/close/:emailLinkId', name: 'closeGoogleAuthentication', component: __WEBPACK_IMPORTED_MODULE_24__pages_user_CloseGoogleAuthentication_vue___default.a }, { path: '/request/new', name: 'userRequest', component: __WEBPACK_IMPORTED_MODULE_42__pages_request_UserRequest_vue___default.a }, { path: '/user/ranking', name: 'userRanking', component: __WEBPACK_IMPORTED_MODULE_30__pages_user_UserRanking_vue___default.a }, { path: '/material/upload/:requestId', name: 'uploadMaterial', component: __WEBPACK_IMPORTED_MODULE_41__pages_request_UploadMaterial_vue___default.a }, { path: '/user/kyc', name: 'userKyc', component: __WEBPACK_IMPORTED_MODULE_25__pages_user_UserKyc_vue___default.a, meta: { requireAuth: true } }, { path: '/user/notifications', name: 'notification', component: __WEBPACK_IMPORTED_MODULE_56__pages_user_Notification_vue___default.a, meta: { requireAuth: true } }, { path: '/post/create', name: 'createPost', component: __WEBPACK_IMPORTED_MODULE_50__pages_post_CreatePost_vue___default.a, meta: { requireAuth: true } }, { path: '/posts', name: 'posts', component: __WEBPACK_IMPORTED_MODULE_45__pages_post_Posts_vue___default.a }, { path: '/posts/tags/:tagName', name: 'tagPosts', component: __WEBPACK_IMPORTED_MODULE_47__pages_post_TagPosts_vue___default.a }, { path: '/posts/topics/:marketsName', name: 'marketPosts', component: __WEBPACK_IMPORTED_MODULE_48__pages_post_MarketPosts_vue___default.a }, { path: '/posts/search/:searchText', name: 'searchPosts', component: __WEBPACK_IMPORTED_MODULE_49__pages_post_SearchPosts_vue___default.a }, { path: '/feed/:username', name: 'feed', component: __WEBPACK_IMPORTED_MODULE_51__pages_feed_Feed_vue___default.a }, { path: '/post/:postingId', name: 'postingsel', component: __WEBPACK_IMPORTED_MODULE_46__pages_post_Post_vue___default.a }, { path: '/transaction', name: 'transaction', component: __WEBPACK_IMPORTED_MODULE_37__pages_token_Transaction_vue___default.a }, { path: '/transactionData/:txHash', name: 'transactionData', component: __WEBPACK_IMPORTED_MODULE_38__pages_token_TransactionData_vue___default.a }, { path: '/investment', name: 'investment', component: __WEBPACK_IMPORTED_MODULE_39__pages_token_Investment_vue___default.a, meta: { requireAuth: true } }, { path: '/investmentData/:investmentId', name: 'investmentData', component: __WEBPACK_IMPORTED_MODULE_40__pages_token_InvestmentData_vue___default.a, meta: { requireAuth: true } }, { path: '/microarticles', name: 'microArticles', component: __WEBPACK_IMPORTED_MODULE_43__pages_microarticle_MicroArticles_vue___default.a }, { path: '/microarticle/:userName/:microArticleId', name: 'microArticle', component: __WEBPACK_IMPORTED_MODULE_44__pages_microarticle_MicroArticle_vue___default.a }, { path: '/telegram/chat', name: 'telegramusermessages', component: __WEBPACK_IMPORTED_MODULE_55__pages_user_TelegramUserMessages_vue___default.a }]
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_markets__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_page__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_theme__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_search__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_user__ = __webpack_require__(185);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        markets: __WEBPACK_IMPORTED_MODULE_2__modules_markets__["a" /* default */],
        page: __WEBPACK_IMPORTED_MODULE_3__modules_page__["a" /* default */],
        theme: __WEBPACK_IMPORTED_MODULE_4__modules_theme__["a" /* default */],
        search: __WEBPACK_IMPORTED_MODULE_5__modules_search__["a" /* default */],
        user: __WEBPACK_IMPORTED_MODULE_6__modules_user__["a" /* default */]
    },
    state: {
        user: {
            id: '',
            name: '',
            token: '',
            image: '',
            locale: ''
        },
        loginModal: false },
    mutations: {
        setToken: function setToken(state, payload) {
            if (payload.hasOwnProperty('name')) {
                state.user.token = payload.name;
            }
        },
        setUserName: function setUserName(state, payload) {
            if (payload.hasOwnProperty('name')) {
                state.user.name = payload.name;
            }
        },
        setUserId: function setUserId(state, payload) {
            if (payload.hasOwnProperty('name')) {
                state.user.id = payload.name;
            }
        },
        setImage: function setImage(state, payload) {
            if (payload.hasOwnProperty('name')) {
                state.user.image = payload.name;
            }
        },
        setLocale: function setLocale(state, payload) {
            if (payload.hasOwnProperty('name')) {
                state.user.locale = payload.name;
            }
        }
    }
});

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(295)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(446),
  /* scopeId */
  "data-v-5fa20b9a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports) {

module.exports = {"common":{"follow":"Folgen","unfollow":"Folgend","confirm":"Bestätigen","cancel":"Abbrechen","clear":"Löschen","submit":"Versenden","verify":"Überprüfen","apply":"Anwenden","save":"Speichern","action":"Aktion","yes":"Ja","no":"Nein","at":"an","by":"bei","success":"Erfolg","fail":"Fehler","warning":"Warnung","loading":"Laden...","begin":"Anfang","nomore":"Keine weiteren Daten","serverError":"Entschuldigung, Serverfehler","details":"Details","search":"Suchen","edit":"Edit","copy":"Kopieren","copySuccess":"Kopieren Erfolg","copyFailure":"Der Browser unterstützt keine automatische Replikation.","serialNumber":" SerienNr.","punctuation":{"period":"."}},"header":{"searchPlaceholder":"Suche nach","posts":"Posts","microArticles":"Mikroartikeln","login":"Log in","signUp":"Anmeldung","search":"Eingabe von Text...","feed":"Mein Feed","profile":"Profil","settings":"Einstellungen","logout":"Abmeldung","usernameHint":"Benutzername/E-Mail","passwordHint":"Passwort","usernameHintEmpty":"Bitte geben Sie Ihren Benutzernamen oder Ihre E-Mail-Adresse ein","passwordHintEmpty":"Bitte gib das Passwort ein","passwordHintLength":"Das Passwort muss gleich oder länger als 8 Zeichen sein.","codeHint":"Code","rememberMe":"Erinnern Sie sich an mich","forgotPassword":"Passwort vergessen","loginButton":"LOGIN","loginButtonLoad":"LOGIN...","accountHint":"Ich habe kein Konto","googleModalTitle":"2-Faktor-Authentifizierungscode eingeben","googleModalEnterHint":"Geben Sie den Code ein, der von Ihrer Google Authenticator App generiert wurde.","googleModalContactHintBefore":"Bitte kontaktieren Sie uns","googleModalContactHintMiddle":"Kundenservice","googleModalContactHintAfter":"Wenn Sie den Zugriff auf Ihre Google Authenticator App verloren haben.","verifyCodeWrongMessage":"Falscher Verifizierungscode","loginSuccessMessage":"Anmeldung erfolgreich","userNotExistMessage":"Der Benutzer existiert nicht","passwordWrongMessage":"Falsches Passwort","accountDisableMessage":"Dein Konto ist nicht verifiziert, bitte aktiviere dein Konto","verificationCodeErrorMessage":"Falscher Code, bitte versuchen Sie es erneut.","errorCallback":{"authenticationSecret":"Bitte Passwort eingeben","randomCodeBeEmpty":"Bitte Code eingeben","randomCodeValue":"Bitte geben Sie einen Zahlenwert ein.","randomCodeDigits":"Muss 6-stellig sein"},"requiredMessage":{"userName":"Bitte gib deinen Benutzernamen oder deine E-Mail-Adresse ein.","passWord":"Bitte geben Sie das Passwort ein","passWordMin":"Die Länge des Passworts darf nicht weniger als 8 Zeichen betragen."},"resolution":"Empfohlene Auflösung","scaling":"Empfohlene Skalierung","cookieStatementMessage":"Wir verwenden Cookies, um zu verstehen, wie Sie unsere Website nutzen, um Inhalte zu personalisieren und um Ihr Erlebnis zu verbessern. Indem Sie unsere Website weiterhin nutzen, akzeptieren Sie die Verwendung von Cookies und überarbeiteten Informationen.","privacyPolicy":"Datenschutzbestimmungen","dismiss":"ablehnen","analyst":"Sie sind der Analyst","paidTitle":"Lassen Sie sich für Ihre Inhalte bezahlen. Veröffentlichen und stimmen Sie Artikel über SIP hoch, um Ihren Anteil am täglichen Belohnungspool zu erhalten.","hot":"hot","new":"neue","edit":"Beitrag erstellen","notifications":"Benachrichtigungen","menu":"Menü","announcement":{"total":"Total ","usersAwardMsg":" IOB Power an Anwender vergeben","postsAwardMsg":" IOB Power wird an Stellen vergeben"}},"left":{"tags":"Tags","showall":"mehr","Upward":"weniger"},"right":{"myWallet":"Meine Wallet","signUp":"Anmelden","login":"Log in","iobannouncements":"IOB Ankündigungen","links":"Links","myFeed":"Mein Feed","myBlog":"Mein Blog","sort":"Sortieren","hot":"Hot","new":"Neue","industryNews":"Branchen-News","IOBOfficialTelegram":"IOB Official Telegram","allTags":"Alle Tags","hotTopics":"Aktuelle Themen","about":"Über","poet":"PoET","team":"Team","iobots":"ioBots","faq":"FAQ","investorRelations":"Investor Relations","jobs":"Jobs","eventsMedia":"Veranstaltungen & Medien","advertise":"Werben","contact":"Kontakt Üs","title":"Letzte Kommentare","submitRequestMessage":"Wenn Sie eine Anfrage stellen möchten, wenden Sie sich bitte an unsere ","customerService":"Kundenservice","feedbackMessage":"Wenn Sie Kommentare oder Vorschläge haben, senden Sie bitte eine E-Mail an service@iob.vc"},"posting":{"home":"Home","hot":"Hot","new":"Neue","bonus":"Bonus","comment":"Reagieren","upvote":"Upvote","tread":"Downvote","retweet":"Repost","save":"Speichern","evaluation":"Du hast bereits abgestimmt.","forwardplacholder":"Text eingeben...","forwardMessage":"Erfolg","collectionsuccess":"Erfolg","collectionCancel":"Abholung abbrechen","noMore":"Keine Daten mehr","noResults":"Keine Ergebnisse"},"postingsel":{"category":"Kategorie","tags":"Tags","original":"Original","source":"Quelle","DISCUSSION":"Comments","follow":"Folgen Sie","unfollow":"Nachfolgend","comment":"Reagieren","edit":"Bearbeiten","upvote":"Upvote","tread":"Downvote","UporDown":"Komprimieren/Erweitern","profile":"Persönliches Profil","evaluation":"Du hast bereits abgestimmt.","Tocomment":"Text eingeben...","twitter":"Auf Twitter teilen","google":"An Google weitergeben","facebook":"Auf Facebook teilen","linkedin":"An Linkedin weitergeben","TocommentLength":"Geben Sie nicht weniger als 20 Wörter ein","TocommentMaxLength":"Geben Sie nicht mehr als 200 Wörter ein.","success":"Erfolg"},"postingcreate":{"Post":"Beitrag","Reset":"Zurücksetzen","preview":{"preview":"Vorschau","hint":{"title":"<Geben Sie hier den Titel ein>","content":"<Geben Sie hier den Inhalt ein>"}},"original":"Original","repost":"Repost","close":"Schließen","Title":"Bitte geben Sie einen Titel ein","chooseTopic":"Thema auswählen","enterUrl":"Bitte geben Sie eine URL ein","postingTitle":{"message":"Der Titel darf nicht leer sein."},"postingContent":{"message":"Der Inhalt darf nicht leer sein.","messageless":"Geben Sie nicht weniger als 20 Wörter ein."},"market":{"message":"Bitte wählen Sie ein Thema aus"},"tagName":"Tags (bis zu 5), getrennt durch Kommas, verwenden nur Buchstaben und Ziffern.","message":{"rule":"Nur Buchstaben und Ziffern verwenden","length":"Nicht mehr als 5 Tags","tagNameLength":"Die maximale Tag-Länge beträgt 24 Zeichen.","updatePost":"Tipp: Du aktualisierst deinen Beitrag. Wenn du einen neuen Beitrag posten möchtest, setze ihn bitte zurück und fahre fort.","resetPost":"Sind Sie sicher, dass Sie den bearbeiteten Inhalt löschen möchten?"},"agree":"Ich akzeptiere die","contentPolicy":"Inhaltsrichtlinie","rules":{"originalLink":{"label":"Quelllink","incorrect":"Falsches URL-Format"}},"notification":"Notification","cannotPostMessage":"Sorry, ordinary users cannot post at this time, please stay tuned!"},"userData":{"posting":"Posts","microArticle":"Mikroartikeln","comment":"Kommentar","comments":"Kommentare","reply":"Antworten","forward":"Aktien","forwarded":"Weitergeleitet","favorites":"Favoriten","upvotes":"Upvotes","downvotes":"Downvotes","referees":"Gutachter","rewardRecords":"Belohnungsaufzeichnungen","bonusRecordTableHeaders":{"actionTimestamp":"Betriebszeit","timestamp":"Belohnungszeit","record":"Aufnehmen"}},"follow":{"following":"Nachfolgend","followers":"Nachfolger","referrals":"Referrals","collections":"Favorite","followingTableMsg":"Du verfolgst noch niemanden.","followerTableMsg":"Noch folgt dir niemand.","canNotFollow":"Ich kann mir selbst nicht folgen."},"userSetting":{"changeCoverImage":"Coverbild ändern","uploadImgTitle":"Klicken Sie auf den Avatar oder ziehen Sie die Bilddatei in den Avatar-Bereich, um sie zu ändern. Dein Bild darf nicht größer als 1M sein.","uploading":"Uploading...","account":"Account","password":"Password","wallet":"Wallet","walletAddress":"Wallet Address","privacyAndSafety":"Datenschutz und Sicherheit","kyc":{"kyc":"KYC","begin":"Begin","beginMsg":"Sie haben die Echtheitszertifizierung noch nicht abgeschlossen.","underReviewMsg":"Ihre Daten werden überprüft.","underReview":"Under Review","rejected":"Abgelehnt","rejectedMsg":"Sorry, Sie haben die Überprüfung der Echtheitszertifizierung nicht bestanden, bitte bestätigen Sie diese erneut.","passed":"Passed","passedMsg":"Sie haben das Echtheitszertifikat bestanden."},"googleAuthentication":"Google Authentication","nickName":"Nickname","nickNameMsg":"Bitte gib deinen Nicknamen ein","username":"Username","email":"Email","emailAddressMsg":"Email Address","invitationCode":"Einladungscode","copyInvitationLink":"Einladungslink kopieren","token":"Token","edit":"Bearbeiten","refresh":"Refresh","language":"Sprache","avatar":"Profilbild-URL","coverImage":"Cover-Bild-URL","timeZone":"Zeit zone","passwordMsg":"Ändern Sie Ihr Passwort oder stellen Sie Ihr aktuelles Passwort wieder her.","currentPassword":"Aktuelles Passwort","newPassword":"Neues Passwort","verifyPassword":"Passwort bestätigen","forgotPassword":"Haben Sie Ihr Passwort vergessen?","saveChanges":"Änderungen speichern","walletSetMessage":"Bitte geben Sie Ihre Wallet-Adresse ein, diese kann nach der Bestätigung nicht mehr geändert werden.","confirmWalletHint":"Sind Sie sicher, dass Sie die folgende Adresse auf Ihre Wallet-Adresse setzen möchten?","balance":"Balance","privacyStatement":"<p>IOB LLC verpflichtet sich, die Privatsphäre und die Genauigkeit vertraulicher Informationen so weit wie möglich zu schützen, vorbehaltlich der Bestimmungen des Landes- und Bundesrechts pro Land und weltweit. Wenn Sie unsere Dienste in Anspruch nehmen, erklären Sie, dass Sie unsere Datenschutzerklärung gelesen, verstanden und akzeptiert haben.</p> <h1><b><b></h1><br/><p><b>Cookies</b></p> <p> <p>Wenn Sie einen Kommentar auf unserer Website hinterlassen, können Sie sich entscheiden, Ihren Namen, Ihre E-Mail-Adresse und Ihre Website in Cookies zu speichern. Diese dienen Ihrer Bequemlichkeit, so dass Sie Ihre Daten nicht erneut eingeben müssen, wenn Sie einen anderen Kommentar abgeben. Wenn Sie ein Konto haben und sich auf dieser Website anmelden, setzen wir ein temporäres Cookie, um festzustellen, ob Ihr Browser Cookies akzeptiert. Dieses Cookie enthält keine personenbezogenen Daten und wird beim Schließen Ihres Browsers verworfen. </p> Wenn Sie sich einloggen, richten wir auch mehrere Cookies ein, um Ihre Login-Daten und Ihre Bildschirmanzeigeoptionen zu speichern. Anmelde-Cookies dauern zwei Tage, und Cookies für Bildschirmoptionen gelten ein Jahr lang. Wenn Sie \"Remember Me\" wählen, bleibt Ihr Login zwei Wochen lang bestehen. Wenn Sie sich von Ihrem Konto abmelden, werden die Anmelde-Cookies entfernt. </p> <p> <p> Wenn Sie einen Artikel bearbeiten oder veröffentlichen, wird ein zusätzliches Cookie in Ihrem Browser gespeichert. Dieses Cookie enthält keine personenbezogenen Daten und zeigt lediglich die Post-ID des Artikels an, den Sie gerade bearbeitet haben. Es läuft nach einem Tag ab.</p> <p> <p>IOB verwendet Google Analytics, ein Cookie von Drittanbietern, das bestimmte Informationen verfolgt, um unsere Dienste zu verbessern.</p> <p><b> Kommentare</b></p> <p> <p>Wenn Besucher Kommentare auf der Website hinterlassen, sammeln wir die im Kommentarformular angezeigten Daten, sowie die IP-Adresse des Besuchers und die Zeichenfolge des Browser-Benutzers, um die Spam-Erkennung zu erleichtern. </p> Eine anonymisierte Zeichenfolge, die aus Ihrer E-Mail-Adresse (auch Hash genannt) erstellt wurde, kann dem Gravatar-Dienst zur Verfügung gestellt werden, um zu sehen, ob Sie sie verwenden. Die Datenschutzerklärung des Gravatar-Service finden Sie hier: https://automattic.com/privacy/. Nach der Genehmigung Ihres Kommentars ist Ihr Profilbild im Rahmen Ihres Kommentars für die Öffentlichkeit sichtbar.</p> <p><b><b>Media</b></p> <p> <p> Wenn Sie Bilder auf die Website hochladen, sollten Sie das Hochladen von Bildern mit eingebetteten Standortdaten (EXIF GPS) vermeiden. Besucher der Website können alle Standortdaten aus Bildern auf der Website herunterladen und extrahieren. </p> <h1><b><b>Die Verwendung von Daten</b></h1> <p> Wir verkaufen, vermieten, verleihen, verleihen oder geben Ihre personenbezogenen Daten nicht an Dritte weiter. Die Kommentare der Besucher können durch einen automatisierten Spam-Erkennungsdienst überprüft werden.</p> <p> <p> Wir verwenden Ihre Daten aus folgenden Gründen: </p> <ul><li><li>Um gesetzlichen und behördlichen Anforderungen nachzukommen</li> <li> <li>Um Betrug vorzubeugen</li> <li>Um Ihre Erfahrungen auf unserer Website zu optimieren</li> <li>Um Ihr Konto auf der IOB-Plattform aufzuzeichnen und zu erhalten</li></ul> <p>Die Informationen können automatisch durch Cookies gesammelt oder von Ihnen bei der Einrichtung eines Kontos ausgefüllt werden. Es gibt Informationen, die wir nicht sammeln, wie z.B. private Schlüssel oder Wallet Seed. Vertrauen Sie niemandem oder einer Nachricht, die Sie erhalten, die nach dieser Art von privaten Informationen fragt. Wenn so etwas auf unserer Website passiert, benachrichtigen Sie uns bitte sofort.</p> <p> <p>Wenn Sie einen Kommentar hinterlassen, bleiben der Kommentar und seine Metadaten auf unbestimmte Zeit erhalten. Damit wir Folgekommentare automatisch erkennen und genehmigen können, anstatt sie in eine Moderationswarteschlange zu stellen.</p> <p> <p>Für Benutzer, die sich auf unserer Website registrieren (falls vorhanden), speichern wir auch die persönlichen Daten, die sie in ihrem Benutzerprofil angeben. Alle Benutzer können ihre personenbezogenen Daten jederzeit einsehen, bearbeiten oder löschen (außer sie können ihren Benutzernamen nicht ändern). Wenn Sie ein Konto auf dieser Website haben oder Kommentare hinterlassen haben, können Sie eine exportierte Datei mit den personenbezogenen Daten, die wir über Sie gespeichert haben, anfordern, einschließlich aller Daten, die Sie uns zur Verfügung gestellt haben. Sie können auch verlangen, dass wir alle personenbezogenen Daten, die wir über Sie gespeichert haben, löschen. Dies gilt nicht für Daten, die wir für administrative, rechtliche oder sicherheitstechnische Zwecke aufbewahren müssen.</p> <h1><b><b>Was passiert, wenn sich die Datenschutzerklärung ändert</b></h1> <p>Diese Datenschutzerklärung wurde zuletzt am 30-07-2018 vom 30. Juli 2018 geändert. Wir können diese Datenschutzerklärung jederzeit und ohne Angabe von Gründen ändern. Wir empfehlen Ihnen, diese Datenschutzerklärung bei jedem Besuch der Website zu überprüfen.</p> <p> <p> <p> Wenn wir uns entscheiden, eine wesentliche Änderung an unserer Datenschutzerklärung vorzunehmen, werden wir für einen bestimmten Zeitraum nach der Änderung einen Hinweis auf der Homepage unserer Website veröffentlichen.</p> <h1><b> Datenschutz von Dritten</b></h1> <p>IOB kann Links zu anderen Websites enthalten. Einige dieser Websites können von Dritten betrieben werden. Wir stellen die Links zu Ihrer Bequemlichkeit zur Verfügung, aber wir überprüfen, kontrollieren oder überwachen nicht die Datenschutzpraktiken von Websites, die von anderen betrieben werden. Wir sind nicht verantwortlich für die Leistung von Websites, die von Dritten betrieben werden, oder für Ihren Geschäftsverkehr mit diesen. Deshalb empfehlen wir Ihnen, wann immer Sie diese Website verlassen.","emailNotifications":"E-Mail-Benachrichtigungen","receiveAuthEmail":"Authentifizierungs-E-Mail erhalten","receiveAuthEmailHint":"Kann nicht geändert werden, es sendet Ihnen eine E-Mail, wenn wir Ihre Daten per E-Mail authentifizieren wollen.","receivePushEmail":"Neuigkeiten über SIP Produkt- und Feature-Updates","receivePushEmailHint":"Wenn Sie diese Option wählen, werden wir Sie per E-Mail über SIP-Produkte und Feature-Updates informieren.","dataProtections":"Datenschutzerklärung","hideSipToken":"SIP-Token ausblenden","hideSipTokenHint":"Wenn diese Option ausgewählt ist, wird Ihr SIP-Token ausgeblendet und kann aus Sicherheitsgründen nicht kopiert werden. Deaktivieren Sie diese Option, wenn Sie kopieren möchten.","disable":"Deaktivieren","enable":"Aktivieren","enabledMsg":"Ihre 2-Faktor-Authentifizierung ist aktiviert.","disabledMsg":"Ihre 2-Faktor-Authentifizierung ist deaktiviert.","disableModalTitle":"2-Faktor-Authentifizierung deaktivieren","disableModalMsg":"Geben Sie den von Ihrer Google Authenticator App generierten Code ein.","disableModalContact":"Bitte wenden Sie sich an unseren Kundenservice, wenn Sie den Zugang zu Ihrer Google Authenticator App verloren haben.","clickToCopy":"Zum Kopieren anklicken","accountBinding":"Social Account","viewOrCopyHint":"Wenn Sie den SIP-Token anzeigen oder kopieren möchten, blenden Sie diese Option bitte unter Datenschutz und Sicherheit ein.","errorCallback":{"passWord":{"empty":"Das aktuelle Passwort darf nicht leer sein.","error":"Aktueller Passwortfehler"},"newPassWord":{"empty":"Das neue Passwort darf nicht leer sein.","value":"Mindestens 8 Zeichen, muss Kleinbuchstaben (a-z), Großbuchstaben (A-Z), Zahlen (0-9) und Symbole (z.B. @, #, $, %) enthalten."},"confirmNewPassWord":{"again":"Bitte gib dein Passwort erneut ein.","match":"Die beiden Passwörter stimmen nicht überein."},"id":"Bitte geben Sie die ID ein","secret":"Bitte geben Sie das Authentifizierungspasswort ein","code":{"empty":"Bitte geben Sie den Code ein","value":"Bitte geben Sie einen Zahlenwert ein","digits":"Muss aus 6 Ziffern bestehen"},"image":{"empty":"Die URL darf nicht leer sein.","invalid":"Invalid URL"}},"requiredMessage":{"regEmailBeEmpty":"Bitte geben Sie Ihre E-Mail-Adresse ein","regEmailFormat":"Incorrect email format"},"notice":{"updateEmail":{"title":"E-Mail erfolgreich gesendet","desc":"Der Bestätigungslink wurde an deine neue E-Mail geschickt, bitte bestätige, um dein Konto zu aktivieren."},"updatePassword":{"title":"Erfolgreich geändert","desc":"Das Passwort wurde erfolgreich geändert."}},"message":{"emailAnomaly":"Sorry, falsche E-Mail","registered":"Die E-Mail wurde registriert."}},"allPage":{"hintLost":"Die von Ihnen besuchte Seite existiert nicht.","hintGo":"Gehen Sie zum ","homepage":"homepage","hintEnd":""},"page404":{"pageNotFound":"PAGE NOT FOUND","hintMessage":"Es scheint, dass wir die gesuchte Seite nicht finden konnten. Bitte überprüfen Sie, ob Sie die URL korrekt eingegeben haben.","homepageButton":"BACK TO HOMEPAGE"},"page500":{"serverError":"SORRY, SERVER ERROR","hintMessage":"The server may have a problem, our engineers are working hard on the repair, please try it later.","homepageButton":"BACK TO HOMEPAGE"},"enableAuthentication":{"title":"2-Faktor-Authentifizierung aktivieren","step1":"Step 1.","step2":"Step 2.","step3":"Step 3.","step4":"Step 4.","step1Msg":"Installieren Sie die Google Authenticator App auf Ihrem Handy.","step2Msg":"Scannen Sie den untenstehenden QR-Code mit der Authenticator-App.","step3Msg":"Notieren Sie sich diesen geheimen Schlüssel und bewahren Sie ihn an einem sicheren Ort auf:","step4Msg":"Geben Sie den 6-stelligen Code ein, der in Ihrer Authentifikator-Applikation unten angezeigt wird:","restoreMsg":"Es kann bis zu 7 Werktage dauern, wenn Sie versuchen, 2FA ohne diesen Schlüssel wiederherzustellen (z.B. Ihr Telefon ist verloren gegangen oder gelöscht worden).","download":"Download","userGuide":"User Guide","dangerousMsg":"Verdächtiger Vorgang, bitte melden Sie sich erneut an","verificationCodeError":"Fehler im Verifizierungscode","errorCallback":{"idBeEmpty":"Bitte geben Sie die ID ein","secretBeEmpty":"Bitte geben Sie das Passwort ein","codeBeEmpty":"Bitte geben Sie den Code ein","codeValue":"Bitte geben Sie einen Zahlenwert ein","codeDigits":"Muss aus 6 Ziffern bestehen"}},"password":{"title":"Passwort zurücksetzen","emailAddress":"E-mail Addresse","agreeMsg":"Ich bestätige, dass mein Konto für mindestens 24 Stunden gesperrt ist.","agreeHint":"Bitte bestätigen Sie die Meldung zuerst.","resetButton":"Passwort zurücksetzen","sendMessage":"Erfolgreich versenden, bitte überprüfen Sie","notRegisteredMessage":"The email is not registered","failMessage":"Sorry, E-Mail-Versand fehlgeschlagen","requiredMessage":{"regEmail":"Bitte geben Sie Ihre registrierte E-Mail-Adresse ein","type":"Incorrect email format"}},"resetPassword":{"successMessage":"Passwort erfolgreich zurückgesetzt","errorCallback":{"passWord":{"empty":"Bitte geben Sie Ihr neues Passwort ein","value":"Mindestens 8 Zeichen, muss Kleinbuchstaben (a-z), Großbuchstaben (A-Z), Zahlen (0-9) und Symbole (z.B. @, #, $, %) enthalten."},"confirmPassWord":{"again":"Bitte gib dein Passwort erneut ein.","match":"Die Passwörter stimmen nicht überein."}}},"updateEmail":{"updateMsg":"Sie aktualisieren Ihre E-Mail, bitte klicken Sie auf den Link.","sureMsg":"Bestätigen Sie die E-Mail","noValidMsg":"Der Link ist nicht mehr gültig.","noRegisterNotice":"Die E-Mail ist nicht registriert oder wurde aktualisiert.","activatedNotice":"Die E-Mail wurde aktiviert.","timeOutNotice":"Die Verbindung ist unterbrochen.","successNotice":"E-Mail erfolgreich aktualisiert"},"register":{"alreadyAccount":"Haben Sie bereits ein Konto?","create":"Konto erstellen","email":"Email","username":"Username","password":"Passwort","confirmationPassword":"Passwort bestätigen","invitationCode":"Einladungscode (optional)","agree":"Ich akzeptiere die","terms":"Allgemeine Geschäftsbedingungen","signUp":"Sign Up","reset":"Reset","noActivatedMessage":"Deine E-Mail wurde registriert, aber nicht aktiviert.","sendEmailMessage":"Möchten Sie einen Aktivierungslink an Ihre E-Mail-Adresse senden??","invitationNotempty":"Bitte stimmen Sie zu, dass wir mit der Arbeit fortfahren.","registerSuccess":"Um Ihre Registrierung abzuschließen, klicken Sie bitte auf den Bestätigungslink in der E-Mail, die wir Ihnen zugesandt haben.","errorCallback":{"userName":{"empty":"Der Benutzername darf nicht leer sein.","value":"Benutzernamen sind 4-16 Bit (Buchstaben, Zahlen, Unterstrich, Minuszeichen).","exist":"Der aktuelle Benutzername wurde verwendet."},"passWord":{"empty":"Das Passwort darf nicht leer sein.","value":"Mindestens 8 Zeichen, muss Kleinbuchstaben (a-z), Großbuchstaben (A-Z), Zahlen (0-9) und Symbole (z.B. @, #, $, %) enthalten."},"repassWord":{"empty":"Bitte gib dein Passwort erneut ein.","value":"Die beiden Passwörter stimmen nicht überein"},"regEmail":{"empty":"Bitte geben Sie Ihre E-Mail-Adresse ein","format":"Incorrect email format","exist":"Die aktuelle E-Mail wurde registriert, bitte ändern Sie das Konto."}}},"registerSuccess":{"title":"E-MAIL-VERIFIZIERUNG ERFOLGREICH","message":"Deine E-Mail wurde bestätigt und dein Konto ist nun verifiziert."},"activation":{"hint":"Sie sind gerade dabei, die E-Mail zu verifizieren, klicken Sie bitte auf die untenstehende Schaltfläche.","link":"Aktivierung","valid":"Der Link ist nicht mehr gültig."},"serviceTerms":{"title":"SIP Nutzungsbedingungen","message":"<p>Website-Nutzungsbedingungen <p>1. Bedingungen <p>Mit dem Zugriff auf diese Website, die unter http://iob.community zugänglich ist, erklären Sie sich damit einverstanden, an diese Nutzungsbedingungen der Website gebunden zu sein, und erklären sich damit einverstanden, dass Sie für die Vereinbarung mit den geltenden lokalen Gesetzen verantwortlich sind. Wenn Sie mit einer dieser Bedingungen nicht einverstanden sind, ist Ihnen der Zugriff auf diese Website untersagt. Die auf dieser Website enthaltenen Materialien sind urheberrechtlich und markenrechtlich geschützt.  <Nutzungslizenz <p>Erlaubnis wird erteilt, um vorübergehend eine Kopie der Materialien auf der iob.vc-Website herunterzuladen, und zwar nur für persönliche, nicht kommerzielle, vorübergehende Zwecke. Dies ist die Gewährung einer Lizenz, nicht eine Übertragung des Eigentums, und unter dieser Lizenz dürfen Sie das nicht:  <p>Ändern oder kopieren Sie die Materialien;</p> <p>verwenden Sie die Materialien für kommerzielle Zwecke oder für öffentliche Zwecke;</p> <p> <p>versuchen Sie, jede auf iob enthaltene Software zurückzuentwickeln.vc's Website;</p> <p> <p> Entfernen von Urheberrechten oder anderen geschützten Bezeichnungen aus den Materialien; oder</p> <p> <p>Übertragung der Materialien an eine andere Person oder </p> <p> <p> <p>Dieses wird iob.vc erlauben, bei Verstößen gegen eine dieser Beschränkungen zu kündigen. Mit der Kündigung erlischt auch Ihr Ansichtsrecht und Sie sollten alle in Ihrem Besitz befindlichen heruntergeladenen Materialien vernichten, unabhängig davon, ob es sich um gedrucktes oder elektronisches Format handelt.</p> <p> <p> <p> <p>Alle Materialien auf der iob.vc-Website werden wie besehen zur Verfügung gestellt. iob.vc gibt keine Garantien, weder ausdrücklich noch stillschweigend, und schließt daher alle anderen Garantien aus. Darüber hinaus gibt iob.vc keine Zusicherungen bezüglich der Genauigkeit oder Zuverlässigkeit der Nutzung der Materialien auf ihrer Website oder anderweitig in Bezug auf diese Materialien oder mit dieser Website verknüpfte Websites ab.</p> <p> <p>4. Beschränkungen</p> <p> <p>iob.vc oder seine Lieferanten haften nicht für Schäden, die durch die Nutzung oder Unmöglichkeit der Nutzung der Materialien auf der iob.vc-Website entstehen, selbst wenn iob.vc oder ein autorisierter Vertreter dieser Website mündlich oder schriftlich über die Möglichkeit eines solchen Schadens informiert wurde. Einige Gerichtsbarkeiten erlauben keine Einschränkungen der stillschweigenden Garantien oder Haftungsbeschränkungen für zufällige Schäden, diese Einschränkungen gelten möglicherweise nicht für Sie.</p> <p> <p>5. Überarbeitungen und Errata</p> <p> Die auf der iob.vc-Website erscheinenden Materialien können technische, typografische oder fotografische Fehler enthalten. iob.vc garantiert nicht, dass die Materialien auf dieser Website korrekt, vollständig oder aktuell sind. iob.vc kann die auf seiner Website enthaltenen Materialien jederzeit und ohne Vorankündigung ändern. iob.vc übernimmt keine Verpflichtung zur Aktualisierung der Materialien.</p> <p> <p> <p> <p> <p> <p>iob.vc hat nicht alle mit seiner Website verlinkten Websites überprüft und ist nicht verantwortlich für den Inhalt einer solchen verlinkten Website. Das Vorhandensein eines Links bedeutet nicht, dass iob.vc die Website billigt. Die Nutzung einer verlinkten Website erfolgt auf eigene Gefahr des Nutzers.</p> <p> <p>7. Änderungen der Nutzungsbedingungen der Website</p> <p>iob.vc kann diese Nutzungsbedingungen für ihre Website jederzeit und ohne vorherige Ankündigung ändern. Mit der Nutzung dieser Website erklären Sie sich damit einverstanden, an die aktuelle Version dieser Allgemeinen Geschäftsbedingungen gebunden zu sein.</p> <p> <p> <p> <p> <p>Jede Forderung im Zusammenhang mit der iob.vc-Website unterliegt den Gesetzen von uns in Bezug auf ihre Kollisionsnormen.</p>"},"feed":{"feedText":"Feed"},"userSearch":{"label":"Username/E-mail","noDataText":"Benutzer nicht gefunden"},"wallet":{"wallet":"Wallet","transactionRecord":"Transaction Record","investmentRecord":"Investment Record","walletAddress":"Wallet Address","balance":"Balance","decimals":"Dezimalen","walletSetMessage":"Bitte geben Sie die Wallet-Adresse für Ihre IOB-Token ein. Die Wallet wird an Ihr SIP-Konto gebunden. Wenn Sie die Wallet-Adresse nach der Bindung ändern müssen, kontaktieren Sie uns bitte.","confirmWalletHint":"Sind Sie sicher, dass Sie die folgende Adresse auf Ihre Wallet-Adresse setzen möchten?","setWalletMessage":"Bitte geben Sie zuerst Ihre Wallet-Adresse an.","txHash":"TxHash","noInvestmentMessage":"No records","investmentStatementBefore":"Sie haben","investmentStatementAfter":"investment record.","investmentStatementAfters":"investment records.","errorCallback":{"wallet":{"empty":"Bitte geben Sie Ihre Wallet-Adresse ein","wrong":"Falsche Wallet-Adresse"}}},"transaction":{"txHash":"TxHash","date":"Datum","from":"Von","to":"Bis","quantity":"Menge"},"transactionData":{"transaction":"Transaction","contract":"Contract","txHash":"TxHash","blockHeight":"Block Height","time":"Time","from":"From","to":"To","tokensTransfered":"Übertragene Token","gasLimit":"Gas Limit","gasUsedByTransaction":"Gas pro Transaktion","gasPrice":"Gas Preise","nonceAndPosition":"Nonce & {Position}"},"investment":{"no":"No.","name":"Name","email":"Email","wallet":"Wallet","transaction":"Transaction ID","sendingAddress":"Absenderadresse","purchasingAmount":"Einkaufsbetrag","paymentType":"Art der Zahlung","sentTime":"Zeitpunkt Gesendet ","recordTime":"Aufzeichnungszeit","timestamp1":"Zeitstempel1","timestamp1Price":"Zeit1 Preise","timestamp2":"Zeitstempel2","timestamp2Price":"Zeit2 Preise","averagePrice":"Durchschnittspreis","purchasingAmountInUSD":"Einkaufsbetrag in USD","bonusRate":"Bonus Rate","bonus":"Bonus","totalIOB":"Total IOB"},"closeGoogleAuthentication":{"hint":"Du schließt deine 2-FA ab."},"lostGoogleAuthentication":{"lostAccessApp":"Haben Sie den Zugriff auf Ihre Google Authenticator App verloren?","lostSecretkey":"1. Ich habe den 16-stelligen Geheimschlüssel für mein SIP-Konto verloren.","sendEmailMessage":"senden Sie bitte eine E-Mail an service@iob.vc","emailAddressHint":"E-Mail-Adresse: Bitte verwenden Sie die E-Mail-Adresse, die Sie bei SIP registriert haben.","subjectHint":"Betreff: Beschreiben Sie Ihr Problem kurz im Feld Subject.","descriptionHint":"Beschreibung: Bitte geben Sie die Details Ihrer Anfrage ein. Ein Mitarbeiter unseres Supports wird so schnell wie möglich antworten.","submitRequestMessageBefore":"Sie müssen eine Anfrage stellen, um sich mit unserer Firma in Verbindung zu setzen.","customerService":" Kundenservice ","submitRequestMessageAfter":", werden wir das Problem so schnell wie möglich für Sie lösen.","haveSecretkey":"2. Ich habe den 16-stelligen Geheimschlüssel für mein SIP-Konto.","email":"E-mail","secretKey":"Geheimschlüssel","emailNotEmpty":"E-Mail ist erforderlich","emailNotValid":"E-Mail muss gültig sein","secretKeyNotEmpty":"Ein Geheimschlüssel ist erforderlich","secretKeyNotValid":"Der geheime Schlüssel muss 16 Zeichen lang sein.","accepteEmail":"Setzen Sie 2-FA zurück, indem Sie eine E-Mail annehmen.","sendEmailSuccess":"Mail erfolgreich versendet","emailAddressNotExist":"E-Mail-Adresse existiert nicht","secretKeyError":"Incorret Geheimschlüssel"},"userRequest":{"submitRequest":"Eine Anfrage senden","issue":"Ausgabe","email":"E-mail","emailHint":"Bitte geben Sie die E-Mail-Adresse an, die Sie bei SIP registriert haben.","subject":"Betreff","subjectHint":"Beschreiben Sie Ihr Problem kurz im Feld Thema.","description":"Beschreibung","descriptionHint":"Bitte geben Sie die Details Ihrer Anfrage ein.","issueSelect":{"account":"Account","password":"Password","googleAuth":"Google Auth(2FA)","wallet":"Wallet","other":"Andere"},"rules":{"issue":{"required":"Bitte wählen Sie ein Thema aus"},"regEmail":{"required":"E-Mail ist erforderlich","valid":"E-Mail muss gültig sein"},"subject":{"required":"Betreff ist erforderlich","valid":"Zeichenlänge überschreitet Grenze"},"description":{"required":"Beschreibung ist erforderlich","valid":"Zeichenlänge überschreitet Grenze"}},"submitSuccessTitle":"Erfolgreich eingereicht","submitSuccessDesc":"Ihre Anfrage wurde erfolgreich eingereicht und wir werden das Problem so schnell wie möglich lösen."},"menu":{"profile":"Profile","signOut":"Sign Out","posts":"Posts","comments":"Commentare","replies":"Replies","language":"Sprache: ","locale":"Deutsch","darkTheme":"Dark Theme","dark":"Dark","light":"Light","setting":"Einstellungen","style":"Style","selectStyle":"Style auswählen","home":"Home","microArticle":"Mikroartikel","searchUser":"User Search","tokenTracker":"Token Tracker","IOBPowerRanking":"IOB Power Ranking","GDPR":"GDPR Statement","privacy":"Datenschutzerklärung","AML":"AML-Richtlinie","support":"Support","sendFeedback":"Send Feedback","tags":"Tags"},"uploadMaterial":{"selfie":"ID Selfie","attachMessage":"Bitte fügen Sie JPG, JPEG oder PNG unter 2M bei.","uploadHint":"Klicken oder ziehen Sie Dateien hier, um sie hochzuladen.","uploadFile":"Datei hochladen","upload":"Hochladen ","message":{"tooLarge":"Die Datei ist zu groß, nicht mehr als 2M.","formatIncorrect":"Das Dateiformat ist falsch, bitte hängen Sie JPG, JPEG oder PNG unter 2M an.","uploadSuccessTitle":"Erfolgreicher Upload!","uploadSuccessDesc":"Deine Materialien wurden auf unseren Server hochgeladen, unsere Mitarbeiter werden sich so schnell wie möglich darum kümmern, bitte habe Geduld."}},"microArticles":{"publishMessage":"Was ist passiert?","publish":"Veröffentlichen","hot":"Hot","new":"Neue","noMore":"Keine Daten mehr","noResults":"Keine Ergebnisse","contentLimit":"Inhalt nicht mehr als 1000 Wörter"},"microArticle":{"no":"Nein","comments":"Kommentare","yet":"dennoch ","commentLimit":"Inhalt nicht mehr als 500 Wörter"},"foot":{"title":"Social Investment Platform<br><span class='Slogan'>Finanzmarkt Cheats berichtet</span>>","aboutUs":"Über uns","contact":"Kontaktieren Sie uns","gdpr":"GDPR Statement","privacy":"Datenschutzerklärung","policy":"AML-Richtlinie","contentpolicy":"Content Policy","kyc":"KYC","IOBToken":"IOB Token","aLLRightsReserved":"Alle Rechte vorbehalten"},"kyc":{"rules":{"required":{"required":"Dieses Feld ist Pflichtfeld","identity":"Bitte wählen Sie eine Identität aus","country":"Bitte wählen Sie ein Land aus","proof":"Bitte wählen Sie einen Proof aus"}},"identity":"Identität","identitySelect":{"passport":"Passport","idCard":"Identifikationskarte","driverLicence":"Führerschein"},"documentIssuingCountry":"Dokument ausstellendes Land","country":"Land","proofOfPermanentAddress":"Nachweis der ständigen Anschrift","proofOfPermanentAddressSelect":{"telephoneBill":"Telefonrechnung","bankAccountStatement":"Bankkontoauszug","utilityBill":"Versorgungsrechnung"},"basicInformation":"Basisinformationen","username":"Username","email":"Email","firstName":"Vorname","middleName":"Zusätzlicher Name","lastName":"Nachname","documentNumber":"Dokumentnummer","birthday":"Geburtstag","gender":{"gender":"Gender","male":"Male","female":"Female"},"documentFront":"Document Front","documentBack":"Document Back","proofOfBill":"Nachweis der Rechnung","selfieWithPhotoIDAndNote":"Selfie mit Foto-ID und Notiz","selfieMessage":"Bitte stellen Sie ein Foto von Ihnen mit Ihrem Reisepass oder Lichtbildausweis zur Verfügung. Im gleichen Bild haben Sie einen Verweis auf die IOB und das heutige Datum angezeigt - eine Notiz mit dem Wort \"IOB SIP\", dem heutigen Datum, und Ihre Unterschrift genügt. Achte darauf, dass dein Gesicht gut sichtbar ist und dass alle Passdaten gut lesbar sind.","selfieList1":"Gesicht deutlich sichtbar","selfieList2":"Photo ID deutlich sichtbar","selfieList3":"Notiz mit Wort \"IOB SIP\"","selfieList4":"Hinweis mit dem heutigen Datum","selfieList5":"Notiz mit Unterschrift"},"userRanking":{"avatar":"Avatar","userName":"Username","nickname":"Nickname"},"notification":{"notifications":"Benachrichtigungen","markAllAsRead":"Markieren, als gelesen","postUpvote":"Den Beitrag hochstimmen","postDownvote":"Den Beitrag herunterstufen","postComment":"Kommentar","commentUpvote":"Den Kommentar hochstimmen","commentDownvote":"Den Kommentar herunterstufen","commentReply":"Antwort auf Kommentar","userFollow":"Folgen Sie","userUnfollow":"Abmelden","adminPostUpdate":"Der Admin hat deinen Beitrag aktualisiert","adminPostDelete":"Der Admin hat deinen Beitrag gelöscht","adminCommentUpdate":"Der Admin hat deinen Kommentar aktualisiert","adminCommentDelete":"Der Admin hat deinen Kommentar gelöscht","nothingMessage":"Hier gibt es noch nichts zu sehen","mentionsMessage":"Wenn dich jemand bei SIP erwähnt, wirst du es hier sehen."},"faq":{"faq1":"What is iobots.pro?","faqTxt1":"<a href='https://iobots.pro' target='_blank'>iobots.pro </a>is IOB LLC's internal proprietary trading portal. Currently, it is set up only for our own proprietary cryptocurrency trading on some of the top 10 crypto spot and derivative exchanges.<br><br>We have noticed that some of the IOB Tokenholders are new trading enthusiasts. As an educator, we decide to share some of our own trading resources with the community by providing a collection of market data and trading tools online in order to offer some basic trading lessons that we wish someone would have taught us when we first started trading.","faq2":"What are the Signals? ","faqTxt2":"A Signal is a result derived from quantifiable reasons to take a trade based on price actions and other analytical market data.<br><br>Offering no investment advice or asset management services, the website simulates a realtime <a href='https://docs.google.com/spreadsheets/d/1PjQM0X7fy2iyZB5Q56V9NU5PAudHgnBQDUuJ9ig-UY8/edit?usp=sharing' target='_blank'>Model Portfolio</a> and updates its buy (Long) or sell (Short) Signals once a day. <br><br>Currently, the Signals are delayed and are covering six trading pairs: BTCUSD, ETHUSD, BCHUSD, LTCUSD, XRPUSD, and EOSUSD. ","faq3":"Are they updated in realtime? ","faqTxt3":"No.","faq4":"Can I copy the Signals on iobots.pro for my own trading? ","faqTxt4":"No. It is not recommended. <br><br> At IOB LLC, we are committed to giving our community some sound trading advice through our own trading success and failures. The website offers no investment advice or asset management services to retail traders. The signals are for informational and educational purposes only. <br><br> You should not simply follow the signals with your own trading, because it will not achieve the desired results. Everyone's trading situation, risk tolerance, and objectives are different. A one-size-fits-all approach will never yield any good result.","faq5":"How do you predict the market directions? ","faqTxt5":"We do not predict the market directions. Neither should you. <br><br> Our quantitative trading derives trading decisions from hundreds of data points. Long or Short Signals are just a relatively small part of the trading process. Money management, risk management and exits (rather than entries) are far more important considerations than market direction predictions. ","faq6":"Trading success without predicting the market directions? ","faqTxt6":"Absolutely.<br><br> In our trading experience, not trying to predict the market is one of the top reasons for trading success.<br><br>Most new traders make trading decisions based on their feelings, opinions, and predictions that often turn into hopes and wishes. Rather than disciplines, hopes and wishes often lead to holding onto the losers for too long and cutting the winners too soon. <br><br>We have a set of rules for entries and exits. When the conditions are met, we enter or exit accordingly, without emotions, without predictions, and without regrets.","faq7":"When can I use ioBots for trading? ","faqTxt7":"We believe that education and nurturing an understanding of the right trading discipline is critical to trading success. We hope novice traders learn and build some solid foundation on trading methods, systems, plans, risk/reward ratios, and win rates on our websites, both <a href='https://iobots.pro' target='_blank'>iobots.pro </a> and <a href='https://iob.community/#/' target='_blank'>iob.community </a>, before starting to risk money. <br><br> While managing our own money and for our high-net-worth limited partners (LPs) in the future, we may offer a commercial trading technical platform as a premium feature for individual traders around the world. <br><br> IOB Tokenholders will have priority access to new products and services.We currently do not have a timetable for the new product offering. We will continue to update the Signals daily as needed and will make the product roadmap available to you when they are ready."},"tag":{"no":"No","tagName":"Tag Name","numberOfPosts":"Number Of Posts"}}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = {"common":{"follow":"Follow","unfollow":"Following","confirm":"Confirm","cancel":"Cancel","clear":"Clear","submit":"Submit","verify":"Verify","apply":"Apply","save":"Save","action":"Action","yes":"Yes","no":"No","at":"at","by":"by","success":"Success","fail":"Fail","warning":"Warning","loading":"Loading...","begin":"Begin","nomore":"No more data","serverError":"Sorry, server error","details":"Details","search":"Search","edit":"Edit","copy":"Copy","copySuccess":"Copy success","copyFailure":"The browser does not support automatic replication","serialNumber":"No.","punctuation":{"period":"."}},"header":{"searchPlaceholder":"Search","posts":"Posts","microArticles":"Microarticles","login":"Log in","signUp":"Sign up","search":"Enter text...","feed":"My Feed","profile":"Profile","settings":"Settings","logout":"Logout","usernameHint":"Username/E-mail","passwordHint":"Password","usernameHintEmpty":"Please enter your username or email","passwordHintEmpty":"Please enter the password","passwordHintLength":"The password must be equal to or more than 8 characters","codeHint":"Code","rememberMe":"Remember me","forgotPassword":"Forgot password","loginButton":"LOGIN","loginButtonLoad":"LOGIN...","accountHint":"Don't have an account","googleModalTitle":"Enter 2-Factor Authentication Code","googleModalEnterHint":"Enter the code generated by your Google Authenticator app.","googleModalContactHintBefore":"Please contact us ","googleModalContactHintMiddle":"customer service","googleModalContactHintAfter":" If you've lost access to your Google Authenticator app.","verifyCodeWrongMessage":"Incorret verification code","loginSuccessMessage":"Login successful","userNotExistMessage":"The user does not exist","passwordWrongMessage":"Incorrect password","accountDisableMessage":"Your account is not verified, please activate your account","verificationCodeErrorMessage":"Incorrect code, please try again.","errorCallback":{"authenticationSecret":"Please enter the password","randomCodeBeEmpty":"Please enter the code","randomCodeValue":"Please enter a numeric value","randomCodeDigits":"Must be 6 digits"},"requiredMessage":{"userName":"Please enter your username or email","passWord":"Please enter the password","passWordMin":"The password length cannot be less than 8 characters"},"resolution":"Recommended resolution","scaling":"Recommended scaling","cookieStatementMessage":"We use cookies to understand how you use our site, to personalize content, and to improve your experience. By continuing to use our site, you accept our use of cookies and revised ","privacyPolicy":"Privacy Policy","dismiss":"Dismiss","analyst":"You are the analyst","paidTitle":"Get paid for your content. Post and upvote articles on SiP to get your share of the daily rewards pool.","hot":"Hot","new":"New","edit":"Create Post","notifications":"Notifications","menu":"Menu","announcement":{"total":"Total ","usersAwardMsg":" IOB Power awarded to users","postsAwardMsg":" IOB Power awarded to posts"}},"left":{"tags":"Tags","showall":"More","Upward":"Less"},"right":{"myWallet":"My wallet","signUp":"Sign up","login":"Log in","iobannouncements":"IOB Announcements","links":"Links","myFeed":"My feed","myBlog":"My blog","sort":"Sort","hot":"Hot","new":"New","industryNews":"Industry News","IOBOfficialTelegram":"IOB Official Telegram","allTags":"All tags","hotTopics":"Hot topics","about":"About","poet":"PoET","team":"Team","iobots":"ioBots","contact":"Contact","faq":"FAQ","investorRelations":"Investor Relations","jobs":"Jobs","eventsMedia":"Events & Media","advertise":"Advertise","title":"Latest Comments","submitRequestMessage":"If you would like to submit a request, please contact our ","customerService":"customer service","feedbackMessage":"If you have comments or suggestions, please send an email to service@iob.vc"},"posting":{"home":"Home","hot":"Hot","new":"New","bonus":"Bonus","comment":"Respond","upvote":"Upvote","tread":"Downvote","retweet":"Repost","save":"Save","evaluation":"You have voted already.","forwardplacholder":"Enter text...","forwardMessage":"Success","collectionsuccess":"Success","collectionCancel":"Cancel Collection","noMore":"No more data","noResults":"No results"},"postingsel":{"category":"Category","tags":"Tags","original":"Original","source":"Source","DISCUSSION":"Comments","follow":"Follow","unfollow":"Following","comment":"Respond","edit":"Edit","upvote":"Upvote","tread":"Downvote","UporDown":"Collapse/Expand","profile":"Personal profile","evaluation":"You have voted already.","Tocomment":"Enter text...","twitter":"Share to Twitter","google":"Share to Google","facebook":"Share to Facebook","linkedin":"Share to Linkedin","TocommentLength":"Input no less than 20 words","TocommentMaxLength":"Input no more than 200 words","success":"Success"},"postingcreate":{"Post":"Post","Reset":"Reset","preview":{"preview":"Preview","hint":{"title":"<Enter title here>","content":"<Enter content here>"}},"original":"Original","repost":"Repost","close":"Close","Title":"Please enter a title","chooseTopic":"Choose Topic","enterUrl":"please enter a url","postingTitle":{"message":"The title cannot be empty"},"postingContent":{"message":"The content cannot be empty","messageless":"Input no less than 20 words"},"market":{"message":"Please choose a topic"},"tagName":"Tags (up to 5), separated by commas, use only letters and digits","message":{"rule":"Use only letters and digits","length":"No more than 5 tags","tagNameLength":"Maximum tag length is 24 characters","updatePost":"Tip: You are updating your post. If you want to post a new post, please reset it and continue.","resetPost":"Are you sure you want to clear the edited content?"},"agree":"I agree to the","contentPolicy":"Content Policy","rules":{"originalLink":{"label":"Please enter the Source link","incorrect":"Incorrect URL format"}},"notification":"Notification","cannotPostMessage":"Sorry, ordinary users cannot post at this time, please stay tuned!"},"userData":{"posting":"Posts","microArticle":"Microarticles","comment":"Comment","comments":"Comments","reply":"Replies","forward":"Shares","forwarded":"Forwarded","favorites":"Favorites","upvotes":"Upvotes","downvotes":"Downvotes","referees":"Referees","rewardRecords":"Reward Records","bonusRecordTableHeaders":{"actionTimestamp":"Action time","timestamp":"Reward time","record":"Record"}},"follow":{"following":"Following","followers":"Followers","referrals":"Referrals","collections":"Favorite","followingTableMsg":"You're not following anyone yet.","followerTableMsg":"Nobody is following you yet.","canNotFollow":"Can't follow myself"},"userSetting":{"changeCoverImage":"change cover image","uploadImgTitle":"Click on the avatar or drag the image file to the avatar area to change it. Your picture cannot be bigger than 1M.","uploading":"Uploading...","account":"Account","password":"Password","wallet":"Wallet","walletAddress":"Wallet Address","privacyAndSafety":"Privacy and safety","kyc":{"kyc":"KYC","begin":"Begin","beginMsg":"You have not completed real-name certification.","underReviewMsg":"Your data is under review.","underReview":"Under Review","rejected":"Rejected","rejectedMsg":"Sorry, you have not passed the real-name certification review, please re-certify.","passed":"Passed","passedMsg":"You have passed the real-name certification audit."},"googleAuthentication":"Google Authentication","nickName":"Nickname","nickNameMsg":"Please enter your nickname","username":"Username","email":"Email","emailAddressMsg":"Email Address","invitationCode":"Invitation Code","copyInvitationLink":"Copy invitation link","token":"Token","edit":"Edit","refresh":"Refresh","language":"Language","avatar":"Profile picture url","coverImage":"Cover image url","timeZone":"Time zone","passwordMsg":"Change your password or recover your current one.","currentPassword":"Current password","newPassword":"New password","verifyPassword":"Verify password","forgotPassword":"Forgot your password","saveChanges":"Save Changes","walletSetMessage":"Please enter your wallet address, it cannot be changed after confirmation.","confirmWalletHint":"Are you sure to set the following address to your wallet address?","balance":"Balance","privacyStatement":"<p>IOB LLC is committed to protecting the privacy and accuracy of confidential information to the extent possible, subject to provisions of state and federal law per country and worldwide. If you make use of our services, you state that you have read, understand understood and agreed with our privacy policy.</p> <h1><b>We care about your privacy</b></h1><br/><p><b>Cookies</b></p> <p>If you leave a comment on our site you may opt-in to save your name, email address and website in cookies. These are for your convenience so that you do not have to fill in your details again when you leave another comment. These cookies will last for one year.</p> <p>If you have an account and you log in to this site, we will set a temporary cookie to determine if your browser accepts cookies. This cookie contains no personal data and is discarded when you close your browser.</p> When you log in, we will also set up several cookies to save your login information and your screen display choices. Login cookies last for two days, and screen options cookies last for a year. If you select “Remember Me”, your login will persist for two weeks. If you log out of your account, the login cookies will be removed.</p> <p>If you edit or publish an article, an additional cookie will be saved in your browser. This cookie includes no personal data and simply indicates the post ID of the article you just edited. It expires after 1 day.</p> <p>IOB makes use of Google Analytics which is a third party cookie that tracks certain information to improve our services.</p> <p><b>Comments</b></p> <p>When visitors leave comments on the site we collect the data shown in the comments form, and also the visitor’s IP address and browser user agent string to help spam detection.</p> An anonymized string created from your email address (also called a hash) may be provided to the Gravatar service to see if you are using it. The Gravatar service privacy policy is available here: https://automattic.com/privacy/. After approval of your comment, your profile picture is visible to the public in the context of your comment.</p> <p><b>Media</b></p> <p>If you upload images to the website, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website.</p> <h1><b>The use of data</b></h1> <p>We do not sell, lease, rent or otherwise disclose your personal data to any third parties. Visitor comments may be checked through an automated spam detection service.</p> <p>We do use your data for the following reasons:</p> <ul><li>To comply with the law and governmental requests</li> <li>To prevent fraud</li> <li>To optimize your experience on our website</li> <li>To record and retain your account on the IOB platform</li></ul> <p>The information can be collected automatic through cookies or filled in by yourself when creating an account. There is information we do not collect such as private keys or wallet seed. Do not trust anyone or any message you receive that are asking for this kind of private information. If something like this occurs on our website please notify us immediately.</p> <p>If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can recognize and approve any follow-up comments automatically instead of holding them in a moderation queue.</p> <p>For users that register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit, or delete their personal information at any time (except they cannot change their username). Website administrators can also see and edit that information.</p> <p>If you have an account on this site or have left comments, you can request to receive an exported file of the personal data we hold about you, including any data you have provided to us. You can also request that we erase any personal data we hold about you. This does not include any data we are obliged to keep for administrative, legal, or security purposes.</p> <h1><b>What happens if the privacy statement changes</b></h1> <p>This Privacy Statement was last revised on 30-07-2018 July 30th, 2018. We may change this Privacy Statement at any time and for any reason. We encourage you to review this Privacy Statement each time you visit the website.</p> <p>If we decide to make a significant change to our Privacy Statement, we will post a notice on the homepage of our website for a period of time after the change is made.</p> <h1><b>Privacy of third parties</b></h1> <p>IOB may contain links to other websites. Some of those websites may be operated by third parties. We provide the links for your convenience, but we do not review, control, or monitor the privacy practices of websites operated by others. We are not responsible for the performance of websites operated by third parties or for your business dealings with them. Therefore, whenever you leave this website we recommend that you review each websites’ privacy practices and make your own conclusions regarding the adequacy of these practices.</p> <p>Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website. These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.</p> <h1><b>Contact</b></h1> <p>If you have questions or comments about this Privacy Statement, please use the Contact Form on this website to reach us.</p>","emailNotifications":"Email notifications","receiveAuthEmail":"Receive authentication email","receiveAuthEmailHint":"Can't be changed, we will send an email to authenticate your information.","receivePushEmail":"News about SiP product and feature updates","receivePushEmailHint":"If selected, we will notify you by email about SiP products and feature updates.","dataProtections":"Data protections","hideSipToken":"Hide SiP Token","hideSipTokenHint":"If selected, your SiP token will be hidden and cannot be copied for security. Cancel this option when you want to copy.","disable":"Disable","enable":"Enable","enabledMsg":"Your 2-Factor authentication is enabled.","disabledMsg":"Your 2-Factor authentication is disabled.","disableModalTitle":"Disable 2-Factor Authentication","disableModalMsg":"Enter the code generated by your Google Authenticator app.","disableModalContact":"Please contact our customer service if you've lost access to your Google Authenticator app.","clickToCopy":"Click to copy","accountBinding":"Social Account","viewOrCopyHint":"If you want to view or copy the SiP Token, please unhide this option in Privacy and Safety.","errorCallback":{"passWord":{"empty":"The Current password cannot be empty","error":"Current password error"},"newPassWord":{"empty":"The new password cannot be empty","value":"Minimum 8 characters, must contain lower case letters (a-z), upper case letters (A-Z), numbers (0-9) and symbols (e.g. @, #, $, %)"},"confirmNewPassWord":{"again":"Please enter your password again","match":"The two passwords do not match"},"id":"Please enter the ID","secret":"Please enter the authentication password","code":{"empty":"Please enter the code","value":"Please enter a numeric value","digits":"Must be 6 digits"},"image":{"empty":"The URL cannot be empty","invalid":"Invalid URL"}},"requiredMessage":{"regEmailBeEmpty":"Please enter your email address","regEmailFormat":"Incorrect email format"},"notice":{"updateEmail":{"title":"Email successfully sent","desc":"The verification link was sent to your new email, please confirm to activate your account"},"updatePassword":{"title":"Changed successfully","desc":"The password has been changed successfully"}},"message":{"emailAnomaly":"Sorry, wrong email","registered":"The email has been registered"}},"allPage":{"hintLost":"The page you visited does not exhist.","hintGo":"Go to the ","homepage":"homepage","hintEnd":""},"page404":{"pageNotFound":"PAGE NOT FOUND","hintMessage":"It seems we couldn't find the page you are looking for. Please check to make sure you've typed the URL correctly.","homepageButton":"BACK TO HOMEPAGE"},"page500":{"serverError":"SORRY, SERVER ERROR","hintMessage":"The server may have a problem, our engineers are working hard to repair, please try later.","homepageButton":"BACK TO HOMEPAGE"},"enableAuthentication":{"title":"Enable 2-Factor Authentication","step1":"Step 1.","step2":"Step 2.","step3":"Step 3.","step4":"Step 4.","step1Msg":"Install the Google Authenticator app on your phone.","step2Msg":"Scan the QR code below with the authenticator app.","step3Msg":"Write down this secret key and keep it in a safe place:","step4Msg":"Enter the 6-digit code displayed on your authenticator app below:","restoreMsg":"It may take up to 7 business days if you try to restore 2FA without this key (e.g. your phone got lost or erased).","download":"Download","userGuide":"User Guide","dangerousMsg":"Suspicious operation, please log in again","verificationCodeError":"Verification code error","errorCallback":{"idBeEmpty":"Please enter the ID","secretBeEmpty":"Please enter the password","codeBeEmpty":"Please enter the code","codeValue":"Please enter a numeric value","codeDigits":"Must be 6 digits"}},"password":{"title":"Reset Password","emailAddress":"E-mail Address","agreeMsg":"I acknowledge that my account will be locked for a minimum of 24 hours.","agreeHint":"Please confirm the message first","resetButton":"Reset Password","sendMessage":"Send successfully, please check","notRegisteredMessage":"The email is not registered","failMessage":"Sorry, email sending failed","requiredMessage":{"regEmail":"Please enter your registered email","type":"Incorrect email format"}},"resetPassword":{"successMessage":"Password reset successfully","errorCallback":{"passWord":{"empty":"Please enter your new password","value":"Minimum 8 characters, must contain lower case letters (a-z), upper case letters (A-Z), numbers (0-9) and symbols (e.g. @, #, $, %)"},"confirmPassWord":{"again":"Please enter your password again","match":"The passwords do not match"}}},"updateEmail":{"updateMsg":"You are updating your email, please click the link.","sureMsg":"Confirm the email","noValidMsg":"The link is no longer valid.","noRegisterNotice":"The email is not registered or has been updated.","activatedNotice":"The email has been activated.","timeOutNotice":"The link has timed out.","successNotice":"Email updated successfully"},"register":{"alreadyAccount":"Already have an account?","create":"Sign Up","email":"Email","username":"Username","password":"Password","confirmationPassword":"Verify password","invitationCode":"Invitation Code(Optional)","agree":"I agree to the","terms":"Terms of Service","signUp":"Sign Up","reset":"Reset","noActivatedMessage":"Your email has been registered but not activated.","sendEmailMessage":"Do you want to send an activation link to your email?","invitationNotempty":"Please agree to continue","registerSuccess":"In order to complete your registration, please click the confirmation link in the email that we have sent to you.","errorCallback":{"userName":{"empty":"The username cannot be empty","value":"User names are 4-16 bits (letters, Numbers, underscore, minus)","exist":"The username has been taken"},"passWord":{"empty":"The password cannot be empty","value":"Minimum 8 characters, must contain lower case letters (a-z), upper case letters (A-Z), numbers (0-9) and symbols (e.g. @, #, $, %)"},"repassWord":{"empty":"Please enter your password again","value":"The two passwords do not match"},"regEmail":{"empty":"Please enter email address","format":"Incorrect email format","exist":"The current email has been registered, please change the account"}}},"registerSuccess":{"title":"EMAIL VERIFICATION SUCCESSFUL","message":"Your email has been confirmed and your account is now verified."},"activation":{"hint":"You are currently verifying the e-mail, please click the button below.","link":"activation","valid":"The link is no longer valid."},"serviceTerms":{"title":"SiP Terms of Service","message":"<p>Website Terms and Conditions of Use <p>1. Terms <p>By accessing this Website, accessible from https://sip.iob.llc you are agreeing to be bound by these Website Terms and Conditions of Use and agree that you are responsible for the agreement with any applicable local laws. If you disagree with any of these terms, you are prohibited from accessing this site. The materials contained in this Website are protected by copyright and trademark law.  <p>2. Use License <p>Permission is granted to temporarily download one copy of the materials on sip.iob.llc website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:  <p>modify or copy the materials;</p> <p>use the materials for any commercial purpose or for any public display;</p> <p>attempt to reverse engineer any software contained on sip.iob.llc's Website;</p> <p>remove any copyright or other proprietary notations from the materials; or</p> <p>transferring the materials to another person or 'mirror' the materials on any other server.</p> <p>This will let sip.iob.llc to terminate upon violations of any of these restrictions. Upon termination, your viewing right will also be terminated and you should destroy any downloaded materials in your possession whether it is printed or electronic format.</p>  <p>3. Disclaimer</p> <p>All the materials on sip.iob.llc website are provided 'as is'. sip.iob.llc makes no warranties, may it be expressed or implied, therefore negates all other warranties. Furthermore, sip.iob.llc does not make any representations concerning the accuracy or reliability of the use of the materials on its Website or otherwise relating to such materials or any sites linked to this Website.</p>  <p>4. Limitations</p> <p>sip.iob.llc or its suppliers will not be held accountable for any damages that will arise with the use or inability to use the materials on sip.iob.llc website, even if sip.iob.llc or an authorized representative of this website has been notified, orally or written, of the possibility of such damage. Some jurisdiction does not allow limitations on implied warranties or limitations of liability for incidental damages, these limitations may not apply to you.</p>  <p>5. Revisions and Errata</p> <p>The materials appearing on sip.iob.llc website may include technical, typographical, or photographic errors. sip.iob.llc will not promise that any of the materials in this Website are accurate, complete, or current. sip.iob.llc may change the materials contained on its Website at any time without notice. sip.iob.llc does not make any commitment to update the materials.</p>  <p>6. Links</p> <p>sip.iob.llc has not reviewed all of the sites linked to its Website and is not responsible for the contents of any such linked site. The presence of any link does not imply endorsement by sip.iob.llc of the site. The use of any linked website is at the user’s own risk.</p>  <p>7. Site Terms of Use Modifications</p> <p>sip.iob.llc may revise these Terms of Use for its Website at any time without prior notice. By using this Website, you are agreeing to be bound by the current version of these Terms and Conditions of Use.</p>  <p>8. Governing Law</p> <p>Any claim related to sip.iob.llc website shall be governed by the laws of us without regards to its conflict of law provisions.</p>"},"feed":{"feedText":"Feed"},"userSearch":{"label":"Username/E-mail","noDataText":"User not found"},"wallet":{"wallet":"Wallet","transactionRecord":"Transaction Record","investmentRecord":"Investment Record","walletAddress":"Wallet Address","balance":"Balance","decimals":"Decimals","walletSetMessage":"Please key in the wallet address for your IOB tokens. The wallet will be bound to your SiP account. If you need to change the wallet address after binding, please contact us.","confirmWalletHint":"Are you sure to set the following address to your wallet address?","setWalletMessage":"Please set your wallet address first.","txHash":"TxHash","noInvestmentMessage":"No records","investmentStatementBefore":"You have","investmentStatementAfter":"investment record.","investmentStatementAfters":"investment records.","errorCallback":{"wallet":{"empty":"Please enter your wallet address","wrong":"Incorrect wallet address"}}},"transaction":{"txHash":"TxHash","date":"Date","from":"From","to":"To","quantity":"Quantity"},"transactionData":{"transaction":"Transaction","contract":"Contract","txHash":"TxHash","blockHeight":"Block Height","time":"Time","from":"From","to":"To","tokensTransfered":"Tokens Transfered","gasLimit":"Gas Limit","gasUsedByTransaction":"Gas Used By Transaction","gasPrice":"Gas Price","nonceAndPosition":"Nonce & {Position}"},"investment":{"no":"No.","name":"Name","email":"Email","wallet":"Wallet","transaction":"Transaction ID","sendingAddress":"Sending Address","purchasingAmount":"Purchasing Amount","paymentType":"Type of Payment","sentTime":"Time Sent","recordTime":"Time on Record","timestamp1":"Timestamp1","timestamp1Price":"Time1 Price","timestamp2":"Timestamp2","timestamp2Price":"Time2 Price","averagePrice":"Average Price","purchasingAmountInUSD":"Purchasing Amount In USD","bonusRate":"Bonus Rate","bonus":"Bonus","totalIOB":"Total IOB"},"closeGoogleAuthentication":{"hint":"You are closing your 2-FA."},"lostGoogleAuthentication":{"lostAccessApp":"Lost access to your Google Authenticator app?","lostSecretkey":"1. I lost the 16-digit secret key for my SiP account.","sendEmailMessage":"please send an email to service@iob.vc","emailAddressHint":"Email address: Please use the email address you registered with SiP.","subjectHint":"Subject: Briefly describe your problem in the Subject field.","descriptionHint":"Description: Please enter the details of your request. A member of our support staff will respond as soon as possible.","submitRequestMessageBefore":"You need to submit a request to contact our","customerService":" customer service ","submitRequestMessageAfter":", we will solve the problem for you as soon as possible.","haveSecretkey":"2. I have the 16-digit secret key for my SiP account.","email":"E-mail","secretKey":"Secret Key","emailNotEmpty":"E-mail is required","emailNotValid":"E-mail must be valid","secretKeyNotEmpty":"Secret key is required","secretKeyNotValid":"Secret key must be 16 characters","accepteEmail":"Reset 2-FA by accepting an email.","sendEmailSuccess":"Mail sent successfully","emailAddressNotExist":"Email address does not exist","secretKeyError":"Incorret secret key"},"userRequest":{"submitRequest":"Submit a request","issue":"Issue","email":"E-mail","emailHint":"Please provide the email address you registered with SiP.","subject":"Subject","subjectHint":"Briefly describe your problem in the Subject field.","description":"Description","descriptionHint":"Please enter the details of your request.","issueSelect":{"account":"Account","password":"Password","googleAuth":"Google Auth(2FA)","wallet":"Wallet","other":"Other"},"rules":{"issue":{"required":"Please select a issue"},"regEmail":{"required":"E-mail is required","valid":"E-mail must be valid"},"subject":{"required":"Subject is required","valid":"Character length exceeds limit"},"description":{"required":"Description is required","valid":"Character length exceeds limit"}},"submitSuccessTitle":"Submitted successfully","submitSuccessDesc":"Your request has been submitted successfully and we will resolve the issue as soon as possible."},"menu":{"profile":"Profile","signOut":"Sign Out","posts":"Posts","comments":"Comments","replies":"Replies","language":"Language: ","locale":"English","darkTheme":"Dark Theme","dark":"Dark","light":"Light","setting":"Setting","style":"Style","selectStyle":"Select Style","home":"Home","microArticle":"Microarticles","searchUser":"User Search","tokenTracker":"Token Tracker","IOBPowerRanking":"IOB Power Ranking","GDPR":"GDPR Statement","privacy":"Privacy Statement","AML":"AML Policy","support":"Support","sendFeedback":"Send Feedback","tags":"Tags"},"uploadMaterial":{"selfie":"ID Selfie","attachMessage":"Please attach JPG, JPEG or PNG less than 2M.","uploadHint":"Click or drag files here to upload","uploadFile":"Upload file","upload":"Upload","message":{"tooLarge":"File is too large, no more than 2M.","formatIncorrect":"File format is incorrect,Please attach JPG, JPEG or PNG less than 2M.","uploadSuccessTitle":"Successful upload!","uploadSuccessDesc":"Your materials have been uploaded to our server, our staff will handle it as soon as possible, please be patient."}},"microArticles":{"publishMessage":"What's happening?","publish":"Publish","hot":"Hot","new":"New","noMore":"No more data","noResults":"No results","contentLimit":"Content no more than 1000 words"},"microArticle":{"no":"No","comments":"Comments","yet":"yet","commentLimit":"Content no more than 500 words"},"foot":{"title":"Social Investment Platform<br><span class='Slogan'>Financial market cheats reported</span>","aboutUs":"About us","contact":"Contact us","gdpr":"GDPR Statement","privacy":"Privacy Statement","policy":"AML Policy","contentpolicy":"Content Policy","kyc":"KYC","IOBToken":"IOB Token","aLLRightsReserved":"ALL rights reserved"},"kyc":{"rules":{"required":{"required":"This field is required","identity":"Please select a identity","country":"Please select a country","proof":"Please select a proof"}},"identity":"Identity","identitySelect":{"passport":"Passport","idCard":"Identification Card","driverLicence":"Driver's Licence"},"documentIssuingCountry":"Document Issuing Country","country":"Country","proofOfPermanentAddress":"Proof Of Permanent Address","proofOfPermanentAddressSelect":{"telephoneBill":"Telephone Bill","bankAccountStatement":"Bank Account Statement","utilityBill":"Utility Bill"},"basicInformation":"Basic Information","username":"Username","email":"Email","firstName":"First Name","middleName":"Middle Name","lastName":"Last Name","documentNumber":"Document Number","birthday":"Birthday","gender":{"gender":"Gender","male":"Male","female":"Female"},"documentFront":"Document Front","documentBack":"Document Back","proofOfBill":"Proof Of Bill","selfieWithPhotoIDAndNote":"Selfie With Photo ID And Note","selfieMessage":"Please provide a photo of you holding your passport or photo ID. In the same picture have a reference to IOB and today's date displayed — a note with the word 'IOB SiP', today's date, and your signature will do. Make sure your face will be clearly visible and that all passport details are clearly readable.","selfieList1":"Face clearly visible","selfieList2":"Photo ID clearly visible","selfieList3":"Note with word \"IOB SiP\"","selfieList4":"Note with today's date","selfieList5":"Note with signature"},"userRanking":{"avatar":"Avatar","userName":"Username","nickname":"Nickname"},"notification":{"notifications":"Notifications","markAllAsRead":"Mark as read","postUpvote":"Upvote the post","postDownvote":"Downvote the post","postComment":"Comment","commentUpvote":"Upvote the comment","commentDownvote":"Downvote the comment","commentReply":"Reply","userFollow":"Follow","userUnfollow":"Unfollow","adminPostUpdate":"The admin updated your post","adminPostDelete":"The admin deleted your post","adminCommentUpdate":"The admin updated your comment","adminCommentDelete":"The admin deleted your comment","nothingMessage":"Nothing to see here yet","mentionsMessage":"When someone mentions you on SiP, you’ll see it here."},"faq":{"faq1":"1. What is iobots.pro?","faqTxt1":"<a href='https://iobots.pro' target='_blank'>iobots.pro </a>is IOB LLC's internal proprietary trading portal. Currently, it is set up only for our own proprietary cryptocurrency trading on some of the top 10 crypto spot and derivative exchanges.<br><br>We have noticed that some of the IOB Tokenholders are new trading enthusiasts. As an educator, we decide to share some of our own trading resources with the community by providing a collection of market data and trading tools online in order to offer some basic trading lessons that we wish someone would have taught us when we first started trading.","faq2":"2. What are the Signals? ","faqTxt2":"A Signal is a result derived from quantifiable reasons to take a trade based on price actions and other analytical market data.<br><br>Offering no investment advice or asset management services, the website simulates a realtime <a href='https://docs.google.com/spreadsheets/d/1PjQM0X7fy2iyZB5Q56V9NU5PAudHgnBQDUuJ9ig-UY8/edit?usp=sharing' target='_blank'>Model Portfolio</a> and updates its buy (Long) or sell (Short) Signals once a day. <br><br>Currently, the Signals are delayed and are covering six trading pairs: BTCUSD, ETHUSD, BCHUSD, LTCUSD, XRPUSD, and EOSUSD. ","faq3":"3. Are they updated in realtime? ","faqTxt3":"No.","faq4":"4. Can I copy the Signals on iobots.pro for my own trading? ","faqTxt4":"No. It is not recommended. <br><br> At IOB LLC, we are committed to giving our community some sound trading advice through our own trading success and failures. The website offers no investment advice or asset management services to retail traders. The signals are for informational and educational purposes only. <br><br> You should not simply follow the signals with your own trading, because it will not achieve the desired results. Everyone's trading situation, risk tolerance, and objectives are different. A one-size-fits-all approach will never yield any good result.","faq5":"5. How do you predict the market directions? ","faqTxt5":"We do not predict the market directions. Neither should you. <br><br> Our quantitative trading derives trading decisions from hundreds of data points. Long or Short Signals are just a relatively small part of the trading process. Money management, risk management and exits (rather than entries) are far more important considerations than market direction predictions. ","faq6":"6. Trading success without predicting the market directions? ","faqTxt6":"Absolutely.<br><br> In our trading experience, not trying to predict the market is one of the top reasons for trading success.<br><br>Most new traders make trading decisions based on their feelings, opinions, and predictions that often turn into hopes and wishes. Rather than disciplines, hopes and wishes often lead to holding onto the losers for too long and cutting the winners too soon. <br><br>We have a set of rules for entries and exits. When the conditions are met, we enter or exit accordingly, without emotions, without predictions, and without regrets.","faq7":"7. When can I use ioBots for trading? ","faqTxt7":"We believe that education and nurturing an understanding of the right trading discipline is critical to trading success. We hope novice traders learn and build some solid foundation on trading methods, systems, plans, risk/reward ratios, and win rates on our websites, both <a href='https://iobots.pro' target='_blank'>iobots.pro </a> and <a href='https://iob.community/#/' target='_blank'>iob.community </a>, before starting to risk money. <br><br> While managing our own money and for our high-net-worth limited partners (LPs) in the future, we may offer a commercial trading technical platform as a premium feature for individual traders around the world. <br><br> IOB Tokenholders will have priority access to new products and services.We currently do not have a timetable for the new product offering. We will continue to update the Signals daily as needed and will make the product roadmap available to you when they are ready."},"tag":{"no":"No","tagName":"Tag Name","numberOfPosts":"Number Of Posts"}}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = {"common":{"follow":"Подписаться","unfollow":"Отписаться","confirm":"Подтвердить","cancel":"Отмена","clear":"Очистить","submit":"Отправить","verify":"Подтвердить","apply":"Применить","save":"Сохранить","action":"Действие","yes":"Да","no":"Нет","at":"в","by":"по","success":"Успех","fail":"Ошибка","warning":"Предупреждение","loading":"Загрузка...","begin":"Начать","nomore":"Нет больше информации","serverError":"Извините, ошибка сервера","details":"Подробность","search":"Поиск","edit":"Редактировать","copy":"Копировать","copySuccess":"Успешное копирование","copyFailure":"Браузер не поддерживает автоматическую репликацию","serialNumber":"Нет.","punctuation":{"period":"."}},"header":{"searchPlaceholder":"Поиск","posts":"Записи","microArticles":"Микростатьи","login":"Войти","signUp":"Зарегистрироваться","search":"Поиск...","feed":"Моя лента","profile":"Профиль","settings":"Настройки","logout":"Выход","usernameHint":"Имя пользователя / Электронная почта","passwordHint":"Пароль","usernameHintEmpty":"Пожалуйста, введите ваше имя пользователя или адрес электронной почты","passwordHintEmpty":"Пожалуйста, введите пароль","passwordHintLength":"Пароль должен быть не более 8 символов","codeHint":"Код","rememberMe":"Запомнить меня","forgotPassword":"Забыли пароль?","loginButton":"Войти","loginButtonLoad":"Вход...","accountHint":"Нет аккаунта","googleModalTitle":"Введите Двухфакторный Код Аутентификации","googleModalEnterHint":"Введите код, созданный вашим приложением Google Authenticator","googleModalContactHintBefore":"Пожалуйста, свяжитесь с ","googleModalContactHintMiddle":"нашей службой поддержки","googleModalContactHintAfter":" если вы потеряли доступ к своему приложению Google Authenticator","verifyCodeWrongMessage":"Неверный код подтверждения","loginSuccessMessage":"Успешный вход","userNotExistMessage":"Пользователь не существует","passwordWrongMessage":"Неверный пароль","accountDisableMessage":"Ваша учетная запись не подтверждена, пожалуйста, активируйте свою учетную запись","verificationCodeErrorMessage":"Неверный код, пожалуйста, попробуйте снова.","errorCallback":{"authenticationSecret":"Пожалуйста, введите пароль","randomCodeBeEmpty":"Пожалуйста, введите код","randomCodeValue":"Пожалуйста, введите числовое значение","randomCodeDigits":"Должно быть 6 цифр"},"requiredMessage":{"userName":"Пожалуйста, введите ваше имя пользователя или адрес электронной почты","passWord":"Пожалуйста, введите пароль","passWordMin":"Длина пароля не может быть меньше 8 символов"},"resolution":"Рекомендуемое разрешение","scaling":"Рекомендуемое масштабирование","cookieStatementMessage":"Мы используем файлы cookie, чтобы понять, как Вы используете наш сайт, персонализировать контент и улучшить Ваш опыт. Продолжая использовать наш сайт, Вы соглашаетесь с использованием файлов cookie и пересмотрели","privacyPolicy":"Политику конфиденциальности","dismiss":"Отклонить","analyst":"Вы - аналист","paidTitle":"Получайте оплату за Ваш контент. Размещайте статьи, голосуйте и получайте вознаграждение.","hot":"Интересное","new":"Новое","edit":"Создать Статью","notifications":"Уведомления","menu":"Меню","announcement":{"total":"Общая сумма ","usersAwardMsg":" IOB Power награждается пользователям","postsAwardMsg":" IOB Power награждается постам"}},"left":{"tags":"Теги","showall":"Больше","Upward":"Меньше"},"right":{"myWallet":"Мой кошелек","signUp":"Зарегистрироваться","login":"Войти","iobannouncements":"Объявления IOB","links":"Ссылки","myFeed":"Моя лента","myBlog":"Мой блог","sort":"Сортировка","hot":"Интересное","new":"Новое","industryNews":"Новости отрасли","IOBOfficialTelegram":"IOB Официальная Телеграмма","allTags":"Все теги","hotTopics":"Интересные темы","about":"О нас","poet":"PoET","team":"Team","iobots":"ioBots","faq":"ЧЗВ","investorRelations":"Отношения с инвесторами","jobs":"Карьера","contact":"Свяжитесь с нами","eventsMedia":"Мероприятия и СМИ","advertise":"Реклама","title":"Последние комментарии","submitRequestMessage":"Если вы хотите отправить запрос,пожалуйста, свяжитесь с","customerService":"нашей службой поддержки","feedbackMessage":"Если у вас есть комментарии или предложения, отправьте электронное письмо на адрес service@iob.vc"},"posting":{"home":"Главная","hot":"Интересное","new":"Новое","bonus":"Бонус","comment":"Комментировать","upvote":"Проголосовать за","tread":"Проголосовать против","retweet":"Поделиться","save":"Сохранить","evaluation":"Вы уже проголосовали.","forwardplacholder":"Введите текст...","forwardMessage":"Успех","collectionsuccess":"Успех","collectionCancel":"Отменить","noMore":"Нет больше информации","noResults":"Нет результата"},"postingsel":{"category":"Категория","tags":"Теги","original":"Оригинал","source":"Источник","DISCUSSION":"Комментарии","follow":"Подписаться","unfollow":"Отписаться","comment":"Комментировать","edit":"Редактировать","upvote":"Проголосовать за","tread":"Проголосовать против","UporDown":"Свернуть / развернуть","profile":"Личный профиль","evaluation":"Вы уже проголосовали.","Tocomment":"Введите текст...","twitter":"Подельться в Twitter","google":"Подельться в Google","facebook":"Подельться в Facebook","linkedin":"Подельться в Linkedin","TocommentLength":"Введите не менее 20 слов","TocommentMaxLength":"Введите не более 200 слов","success":"Успех"},"postingcreate":{"Post":"Опубликовать","Reset":"Сброс","preview":{"preview":"Предварительный просмотр","hint":{"title":"<Введите заглавие здесь>","content":"<Введите содержание здесь>"}},"original":"Оригинал","repost":"Репост","close":"Закрыть","Title":"Пожалуйста, введите заглавие","chooseTopic":"Выберете тему","enterUrl":"Пожалуйста, введите url","postingTitle":{"message":"Заглавие не может быть пустым"},"postingContent":{"message":"Содержание не может быть пустым","messageless":"Введите не менее 20 слов"},"market":{"message":"Пожалуйста, выберете тему"},"tagName":"Теги (до 5), разделенные запятыми, используйте только буквы и цифры","message":{"rule":"Используйте только буквы и цифры","length":"Не более 5 тегов","tagNameLength":"Максимальная длина тега 24 символа","updatePost":"Совет: Вы обновляете свой пост. Если Вы хотите опубликовать новое сообщение, сбросьте его и продолжите.","resetPost":"Вы уверены, что хотите удалить отредактированный контент?"},"agree":"Я соглашаюсь с","contentPolicy":"политикой содержимого","rules":{"originalLink":{"label":"Пожалуйста, введите ссылку на источник","incorrect":"Неверный формат URL"}},"notification":"Notification","cannotPostMessage":"Sorry, ordinary users cannot post at this time, please stay tuned!"},"userData":{"posting":"Посты","microArticle":"Микростатьи","comment":"Комментированное","comments":"Комментарии","reply":"Ответы","forward":"Репосты","forwarded":"Поделились","favorites":"Понравилось","upvotes":"Проголосовать за","downvotes":"Проголосовать против","referees":"Рекоммендации","rewardRecords":"Отчеты наград","bonusRecordTableHeaders":{"actionTimestamp":"Время действия","timestamp":"Время вознаграждения","record":"Запись"}},"follow":{"following":"Подписаны","followers":"Подписчики","referrals":"Рекоммендации","collections":"Понравилось","followingTableMsg":"Вы еще ни на кого не подписаны.","followerTableMsg":"На Вас еще никто не подписан.","canNotFollow":"Нельзя подписаться на себя"},"userSetting":{"changeCoverImage":"изменить изображение обложки","uploadImgTitle":"Нажмите на аватар или перетащите файл изображения в область аватара, чтобы изменить его. Ваша фотография не может быть больше 1М.","uploading":"Загрузка...","account":"Учетная запись","password":"Пароль","wallet":"Кошелек","walletAddress":"Адрес кошелька","privacyAndSafety":"Конфиденциальность и безопасность","kyc":{"kyc":"ЗСК","begin":"Начать","beginMsg":"Вы не завершили сертификацию по имени.","underReviewMsg":"Ваши данные проверяются.","underReview":"На рассмотрении","rejected":"Отклонено","rejectedMsg":"Извините, Вы не прошли проверку подлинности имени, пожалуйста, повторите сертификацию.","passed":"Пройдено","passedMsg":"Вы прошли проверку подлинности имени."},"googleAuthentication":"Google Authentication","nickName":"Никнейм","nickNameMsg":"Пожалуйста, введите ваш никнейм","username":"Имя пользователя","email":"Адрес электронной почты","emailAddressMsg":"Адрес электронной почты","invitationCode":"Код приглашения","copyInvitationLink":"Скопировать ссылку приглашения ","token":"Токен","edit":"Редактировать","refresh":"Обновить","language":"Язык","avatar":"URL аватара","coverImage":"URL обложки","timeZone":"Часовой пояс","passwordMsg":"Измените свой пароль или восстановите текущий.","currentPassword":"Текущий пароль","newPassword":"Новый пароль","verifyPassword":"Подтвердите пароль","forgotPassword":"Забыли пароль","saveChanges":"Сохранить изменения","walletSetMessage":"Пожалуйста, введите адрес своего кошелька, его нельзя изменить после подтверждения.","confirmWalletHint":"Вы уверены, что хотите установить этот адрес как своего кошелька?","balance":"Баланс","privacyStatement":"<p>IOB LLC обязуется защищать конфиденциальность и точность конфиденциальной информации в максимально возможной степени в соответствии с положениями законодательства штата и федерального законодательства в каждой стране и во всем мире. Если вы пользуетесь нашими услугами, вы заявляете, что прочитали, поняли и согласились с нашей политикой конфиденциальности.</p> <h1><b> Мы заботимся о вашей конфиденциальности</b></h1><br/><p><b>Cookies</b></p> <p> Если вы оставите комментарий на нашем сайте, вы можете отказаться от него, чтобы сохранить ваше имя, адрес электронной почты и веб-сайт в cookie. Это сделано для вашего удобства, чтобы вам не приходилось заполнять свои данные снова, когда вы оставляете другой комментарий. Срок действия этих файлов cookie составляет один год.</p> <p> Если у вас есть учетная запись и вы заходите на этот сайт, мы установим временный файл cookie, чтобы определить, принимает ли ваш браузер файлы cookie. Этот файл cookie не содержит персональных данных и удаляется при закрытии браузера.</p> Когда вы входите в систему, мы также настроим несколько файлов cookie, чтобы сохранить ваши данные для входа в систему и настройки экрана. Файлы cookie для входа сохраняются в течение двух дней, а файлы cookie для параметров экрана сохраняются в течение года. Если вы выберете «Запомнить меня», ваш логин будет сохраняться в течение двух недель. Если вы выйдете из своей учетной записи, файлы cookie для входа будут удалены.</p> <p> Если вы редактируете или публикуете статью, в вашем браузере будет сохранен дополнительный файл cookie. Этот файл cookie не содержит личных данных и просто указывает идентификатор публикации только что отредактированной статьи. Срок истекает через 1 день.</p> <p>SIP использует Google Analytics, который является сторонним файлом cookie и отслеживает определенную информацию для улучшения наших услуг.</p> <p><b>Комментарии</b></p> <p>Когда посетители оставляют комментарии на сайте, мы собираем данные, показанные в форме комментариев, а также IP-адрес посетителя и строку агента пользователя браузера, чтобы обнаружить спама.</p> Анонимная строка, созданная из вашего адреса электронной почты (также называемая хешем), может предоставляться Gravatar Сервис, чтобы увидеть, если вы используете его.  Политика конфиденциальности службы Gravatar доступна здесь: https://automattic.com/privacy/. После одобрения вашего комментария ваша фотография профиля опубликуется рядом с  комментарием.</p> <p><b>Медиа</b></p> <p>Если вы загружаете изображения на веб-сайт, вы должны избегать загрузки изображений со встроенными данными о местоположении (EXIF GPS). Посетители веб-сайта могут загружать и извлекать любые данные о местоположении из изображений на веб-сайте.</p> <h1><b>Использование данных</b></h1> <p>Мы не продаем, не сдаем в аренду, или иным образом передаем ваши личные данные третьим лицам. Комментарии посетителей могут быть проверены с помощью автоматической службы обнаружения спама.</p> <p>Мы используем ваши данные по следующим причинам:</p> <ul><li>Соблюдение требований законодательства и правительственных запросов</li> <li>Предотвращение мошенничества</li> <li>Оптимизация работы на нашем сайте</li> <li> Запись и сохранение вашей учетной записи на платформе SIP</li></ul> <p>Информация может быть собрана автоматически с помощью файлов cookie или заполнена вами самостоятельно при создании учетной записи. Мы не собираем информацию, такую как закрытые ключи или кошелек. Не доверяйте никому или любому полученному вами сообщению, в котором запрашивается такая частная информация. Если что-то подобное происходит на нашем веб-сайте, пожалуйста, немедленно сообщите нам об этом.</p> <p> Если вы оставите комментарий, комментарий и его метаданные будут сохранены на неопределенный срок. Это делается для того, чтобы мы могли автоматически распознавать и утверждать любые последующие комментарии, а не хранить их в очереди на модерацию.</p> <p> Для пользователей, которые регистрируются на нашем веб-сайте, мы также храним предоставленную ими личную информацию в их профиле пользователя. Все пользователи могут просматривать, редактировать или удалять свои личные данные в любое время (кроме изменения имени пользователя). Администраторы веб-сайта также могут просматривать и редактировать эту информацию.</p> <p>Если у вас есть учетная запись на этом сайте или вы оставили комментарии, вы можете запросить получение экспортированного файла личных данных о вас, которые мы храним, включая любые данные, которые вы предоставили нам. Вы также можете потребовать, чтобы мы удалили все ваши личные данные о вас. Это не включает в себя какие-либо данные, которые мы обязаны хранить по административным и юридическим причинам или в целях безопасности.</p> <h1><b> Что произойдет, если заявление о конфиденциальности изменится</b></h1> <p> Данное Заявление о Конфиденциальности в последний раз пересматривалось 23-04-2019, 23-го апреля 2019. Мы можем изменить это Заявление о Конфиденциальности в любое время и по любой причине. Мы рекомендуем вам просматривать это Заявление о Конфиденциальности при каждом посещении веб-сайта.</p> <p> Если мы решим внести существенные изменения в наше Заявление о Конфиденциальности, мы разместим уведомление на главной странице нашего веб-сайта на период время после внесения изменений.</p> <h1><b> Конфиденциальность третьих лиц</b></h1> <p> SIP может содержать ссылки на другие веб-сайты. Некоторые из этих веб-сайтов могут управляться третьими лицами. Мы предоставляем ссылки для вашего удобства, но мы не проверяем и не контролируем политику конфиденциальности веб-сайтов, которыми управляют другие. Мы не несем ответственности за работу веб-сайтов, управляемых третьими сторонами, или за ваши деловые отношения с ними. Поэтому всякий раз, когда вы покидаете этот веб-сайт, мы рекомендуем вам ознакомиться с правилами конфиденциальности каждого веб-сайта и сделать собственные выводы относительно достоверности этих методов.</p> <p> Статьи на этом сайте могут включать встроенный контент (например, видео, изображения и т. д.). Встроенный контент с других веб-сайтов ведет себя точно так же, как если бы посетитель посетил другой веб-сайт. Эти веб-сайты могут собирать данные о вас, использовать файлы cookie, встраивать дополнительное стороннее отслеживание и следить за вашим взаимодействием со встроенным контентом, включая отслеживание вашего взаимодействия со встроенным контентом, если у вас есть учетная запись и вы вошли на этот веб-сайт.</p> <h1><b>Связаться с нами</b></h1> <p> Если у вас есть вопросы или комментарии по поводу этого Заявления о Конфиденциальности, пожалуйста, используйте контактную форму на этом сайте, чтобы связаться с нами.</p>","emailNotifications":"Уведомления по электронной почте","receiveAuthEmail":"Получить аутентификацию по электронной почте","receiveAuthEmailHint":"Не может быть изменено, мы отправим письмо для проверки подлинности вашей информации.","receivePushEmail":"Новости об обновлениях продуктов и функций SIP","receivePushEmailHint":"Выберите, чтобы получать уведомления по электронной почте о продуктах SIP и обновлениях функций.","dataProtections":"Защита данных","hideSipToken":"Скрыть токен SIP","hideSipTokenHint":"Если этот флажок установлен, ваш SIP-токен будет скрыт и не может быть скопирован для безопасности. Отмените эту опцию, если хотите скопировать.","disable":"Отключить","enable":"Включить","enabledMsg":"Ваша двухфакторная аутентификация включена.","disabledMsg":"Ваша двухфакторная аутентификация отключена.","disableModalTitle":"Отключить двухфакторную аутентификацию","disableModalMsg":"Введите код, созданный вашим приложением Google Authenticator.","disableModalContact":"Пожалуйста, свяжитесь с нашей службой поддержки, если Вы потеряли доступ к своему приложению Google Authenticator.","clickToCopy":"Нажмите, чтобы скопировать","accountBinding":"Социальная учетная запись","viewOrCopyHint":"Если вы хотите просмотреть или скопировать SIP-токен, откройте этот параметр в разделе «Конфиденциальность и безопасность».","errorCallback":{"passWord":{"empty":"Пароль не может быть пустым","error":"Ошибка пароля"},"newPassWord":{"empty":"Новый пароль не может быть пустым","value":"Минимум 8 символов, должны содержать буквы нижнего регистра (a-z), буквы верхнего регистра (A-Z), цифры (0-9) и символы (например, @, #, $,%)"},"confirmNewPassWord":{"again":"Пожалуйста, введите Ваш пароль снова","match":"Два пароля не совпадают"},"id":"Пожалуйста, введите ID","secret":"Пожалуйста, введите пароль для аутентификации","code":{"empty":"Пожалуйста, введите код","value":"Пожалуйста, введите числовое значение","digits":"Должно быть 6 цифр"},"image":{"empty":"URL не может быть пустым","invalid":"Неверный URL"}},"requiredMessage":{"regEmailBeEmpty":"Пожалуйста, введите адрес электронной почты","regEmailFormat":"Неверный формат электронной почты"},"notice":{"updateEmail":{"title":"Письмо успешно отправлено","desc":"Ссылка для подтверждения была отправлена на Ваш новый адрес электронной почты. Подтвердите активацию своего аккаунта"},"updatePassword":{"title":"Изменено успешно","desc":"Пароль был успешно изменен"}},"message":{"emailAnomaly":"Извините, неправильный адрес электронной почты","registered":"электронная почта была зарегистрирована"}},"allPage":{"hintLost":"Страница, которую вы посетили, не существует.","hintGo":"Перейти к ","homepage":"Главная страница","hintEnd":""},"page404":{"pageNotFound":"СТРАНИЦА НЕ НАЙДЕНА","hintMessage":"Кажется, мы не смогли найти страницу, которую Вы ищете. Пожалуйста, убедитесь, что Вы правильно ввели URL.","homepageButton":"НАЗАД НА ГЛАВНУЮ СТРАНИЦУ"},"page500":{"serverError":"ИЗВИНИТЕ, ОШИБКА СЕРВЕРА","hintMessage":"Возможно проблема с сервером, наша команда прилагает все усилия, чтобы исправить, пожалуйста, попробуйте позже.","homepageButton":"НАЗАД НА ГЛАВНУЮ СТРАНИЦУ"},"enableAuthentication":{"title":"Включить двухфакторную аутентификацию","step1":"Шаг 1.","step2":"Шаг 2.","step3":"Шаг 3.","step4":"Шаг 4.","step1Msg":"Установите приложение Google Authenticator на свой телефон.","step2Msg":"Сканируйте приведенный ниже QR-код с помощью приложения для аутентификации.","step3Msg":"Запишите этот секретный ключ и храните его в надежном месте:","step4Msg":"Введите 6-значный код, отображаемый в вашем приложении для аутентификации:","restoreMsg":"Может потребоваться до 7 рабочих дней, если вы попытаетесь восстановить 2FA без этого ключа (например, ваш телефон был потерян).","download":"Скачать","userGuide":"Руководство пользователя","dangerousMsg":"Подозрительное действие, пожалуйста, войдите снова","verificationCodeError":"Ошибка кода подтверждения","errorCallback":{"idBeEmpty":"Пожалуйста, введите идентификатор","secretBeEmpty":"Пожалуйста, введите пароль","codeBeEmpty":"Пожалуйста, введите код","codeValue":"Пожалуйста, введите числовое значение","codeDigits":"Должно быть 6 цифр"}},"password":{"title":"Сброс пароля","emailAddress":"Адрес электронной почты","agreeMsg":"Я подтверждаю, что моя учетная запись будет заблокирована как минимум на 24 часа.","agreeHint":"Пожалуйста, сначала подтвердите сообщение","resetButton":"Сбросить пароль","sendMessage":"Отправлено успешно, пожалуйста, проверьте","notRegisteredMessage":"Электронная почта не зарегистрирована","failMessage":"Извините, отправка электронной почты не удалась","requiredMessage":{"regEmail":"Пожалуйста, введите ваш зарегистрированный адрес электронной почты","type":"Неверный формат электронной почты"}},"resetPassword":{"successMessage":"Пароль успешно сброшен","errorCallback":{"passWord":{"empty":"Пожалуйста, введите новый пароль","value":"Минимум 8 символов, должны содержать буквы нижнего регистра (a-z), буквы верхнего регистра (A-Z), цифры (0-9) и символы (например, @, #, $,%)"},"confirmPassWord":{"again":"ППожалуйста, введите Ваш пароль снова","match":"пароли не совпадают"}}},"updateEmail":{"updateMsg":"Вы обновляете свою электронную почту, пожалуйста, нажмите на ссылку.","sureMsg":"Подтвердите адрес электронной почты","noValidMsg":"Ссылка больше не действительна.","noRegisterNotice":"Электронная почта не зарегистрирована или была обновлена.","activatedNotice":"Электронная почта была активирована.","timeOutNotice":"Срок действия ссылки истек.","successNotice":"Электронная почта успешно обновлена"},"register":{"alreadyAccount":"Уже есть аккаунт?","create":"Создать учетную запись","email":"Электронная почта","username":"Имя пользователя","password":"Пароль","confirmationPassword":"Подтвердить пароль","invitationCode":"Код приглашения (необязательно)","agree":"Я согласен с","terms":"Условиями предоставления услуг","signUp":"Зарегистрироваться","reset":"Сброс","noActivatedMessage":"Ваш электронный адрес был зарегистрирован, но не активирован.","sendEmailMessage":"Вы хотите отправить ссылку активации на свою электронную почту?","invitationNotempty":"Пожалуйста, согласитесь, чтобы продолжить","registerSuccess":"Чтобы завершить регистрацию, нажмите ссылку для подтверждения в электронном письме, которое мы отправили вам.","errorCallback":{"userName":{"empty":"Имя пользователя не может быть пустым","value":"Имена пользователей - 4-16 бит (буквы, цифры, подчеркивание, минус)","exist":"Текущее имя пользователя уже занято"},"passWord":{"empty":"Пароль не может быть пустым","value":"Минимум 8 символов, должны содержать буквы нижнего регистра (a-z), буквы верхнего регистра (A-Z), цифры (0-9) и символы (например, @, #, $,%)"},"repassWord":{"empty":"Пожалуйста, введите ваш пароль снова","value":"Два пароля не совпадают"},"regEmail":{"empty":"Пожалуйста, введите адрес электронной почты","format":"Неверный формат электронной почты","exist":"Этот адрес электронной почты был зарегистрирован, пожалуйста, измените учетную запись"}}},"registerSuccess":{"title":"ПРОВЕРКА ЭЛЕКТРОННОЙ ПОЧТЫ УСПЕШНА","message":"Ваш адрес электронной почты был подтвержден и Ваша учетная запись зарегестрирована."},"activation":{"hint":"Вы проверяете электронную почту, пожалуйста, нажмите кнопку ниже.","link":"активация","valid":"Ссылка больше не действительна."},"serviceTerms":{"title":"Условия предоставления услуг SIP","message":"<p>Условия Использования Сайта<p>1. Условия<p>Заходя на этот сайт, доступный по адресу http://iob.community, вы соглашаетесь с этими Условиями Использования Сайта и согласны с тем, что вы несете ответственность за соглашение с любыми действующими местными законами. Если вы не согласны с каким-либо из этих условий, вам запрещается доступ к этому сайту. Материалы, содержащиеся на этом сайте, защищены законом об авторском праве и законом о товарных знаках.<p>2. Лицензия на использование<p>Разрешается временно загружать одну копию материалов на веб-сайте sip.iob.llc только для личного, некоммерческого, временного просмотра. Это предоставление лицензии, а не передача прав собственности, и в соответствии с этой лицензией вы не можете: <p>изменять или копировать материалы;</p> <p>использовать материалы в коммерческих целях или для публичного показа;</p> <p>попытаться выполнить реинжиниринг любого программного обеспечения, содержащегося на веб-сайте sip.iob.llc Website;</p> <p>удалять из материалов любые авторские права или другие права собственности; или</p> <p>передавать материалы другому лицу или «зеркальное отображать» материалы на любом другом сервере.</p> <p> sip.iob.llc прекратит активность пользователя при нарушении любого из этих ограничений. После прекращения действие вашего права на просмотр также будет прекращено, и вы должны будете уничтожить любые загруженные материалы, находящиеся в вашем распоряжении, будь то печатные или электронные форматы.</p>  <p>3. Отказ от ответственности</p> <p>Все материалы на сайте sip.iob.llc предоставляются «как есть». sip.iob.llc не дает никаких гарантий, будь то явных или подразумеваемых, поэтому отменяет все остальные гарантии. Кроме того, sip.iob.llc не делает никаких заявлений относительно точности или надежности использования материалов на своем Веб-сайте или иным образом связанных с такими материалами или любыми сайтами, связанными с этим Веб-сайтом.</p>  <p>4. Ограничения</p> <p>sip.iob.llc или его поставщики не будут нести ответственность за любые убытки, возникшие в результате использования или невозможности использования материалов на веб-сайте sip.iob.llc, даже если sip.iob.llc или уполномоченный представитель был в устной или письменной форме уведомлен о возможности такого повреждения. В некоторых юрисдикциях не допускаются ограничения подразумеваемых гарантий или ограничения ответственности за случайный ущерб, эти ограничения могут не распространяться на вас.</p>  <p>5. Редакции и исправления</p> <p>Материалы, размещенные на сайте sip.iob.llc, могут содержать технические, типографские или фотографические ошибки. sip.iob.llc не обещает, что какие-либо материалы на этом сайте являются точными, полными или актуальными. sip.iob.llc может изменить материалы, содержащиеся на его веб-сайте, в любое время без предварительного уведомления. sip.iob.llc не дает никаких обязательств по обновлению материалов.</p>  <p>6. Ссылки</p> <p>sip.iob.llc не проверяет все сайты, на которые есть ссылки на этот Веб-сайт, и не несет ответственности за содержание таких сайтов, на которые имеются ссылки. Наличие какой-либо ссылки не означает одобрение сайтом sip.iob.llc Пользователь может использовать любой связанный веб-сайт на свой риск.</p>  <p>7. Изменения условий использования сайта</p> <p>sip.iob.llc может пересмотреть настоящие Условия использования своего Сайта в любое время без предварительного уведомления. Используя этот сайт, вы соглашаетесь с текущей версией условий использования.</p>  <p>8. Применимое право </p> <p>Любые претензии, связанные с веб-сайтом sip.iob.llc, регулируются нашими законами независимо от возможного конфликта.</p>"},"feed":{"feedText":"Лента"},"userSearch":{"label":"Имя пользователя / Электронная почта","noDataText":"Пользователь не найден"},"wallet":{"wallet":"Кошелек","transactionRecord":"Запись транзакций","investmentRecord":"Запись инвестиций","walletAddress":"Адрес кошелька","balance":"Баланс","decimals":"Десятичные","walletSetMessage":"Пожалуйста, введите адрес кошелька для Ваших токенов IOB. Кошелек будет привязан к Вашей учетной записи SIP. Если Вам нужно изменить адрес кошелька после связывания, свяжитесь с нами.","confirmWalletHint":"Вы уверены, что установите следующий адрес, как адрес своего кошелька?","setWalletMessage":"Пожалуйста, сначала установите адрес своего кошелька.","txHash":"TxHash","noInvestmentMessage":"Нет записей","investmentStatementBefore":"У Вас есть","investmentStatementAfter":"инвестиционная запись.","investmentStatementAfters":"инвестиционная записи.","errorCallback":{"wallet":{"empty":"Пожалуйста, введите адрес своего кошелька","wrong":"Неверный адрес кошелька"}}},"transaction":{"txHash":"TxHash","date":"Дата","from":"От","to":"Кому","quantity":"Количество"},"transactionData":{"transaction":"Транзакция","contract":"Контракт","txHash":"TxHash","blockHeight":"Высота блока","time":"Время","from":"От","to":"Кому","tokensTransfered":"Токенов переведено","gasLimit":"Лимит газа","gasUsedByTransaction":"Использовано газа","gasPrice":"Цена на газ","nonceAndPosition":"Nonce & {Position}"},"investment":{"no":"Нет.","name":"Имя","email":"Электронная почта","wallet":"Кошелек","transaction":"Идентификатор транзакции","sendingAddress":"Адрес для отправки","purchasingAmount":"Сумма покупки","paymentType":"Тип оплаты","sentTime":"Время отправлено","recordTime":"Время записи","timestamp1":"Временная метка1","timestamp1Price":"Время1 Цена","timestamp2":"Временная метка2","timestamp2Price":"Время2 Цена","averagePrice":"Средняя цена","purchasingAmountInUSD":"Сумма покупки в долларах США","bonusRate":"Бонус-ставка","bonus":"Бонус","totalIOB":"Всего IOB"},"closeGoogleAuthentication":{"hint":"Вы закрываете двухфакторную аутентификацию."},"lostGoogleAuthentication":{"lostAccessApp":"Потерян доступ к Вашему приложению Google Authenticator?","lostSecretkey":"1. Я потерял(а) 16-значный секретный ключ для своей учетной записи SIP.","sendEmailMessage":"Пожалуйста, отправьте электронное письмо на service@iob.vc","emailAddressHint":"Адрес электронной почты: пожалуйста, используйте адрес электронной почты, который вы зарегистрировали в SIP.","subjectHint":"Тема: кратко опишите Вашу проблему в поле.","descriptionHint":"Описание: Пожалуйста, введите детали вашего запроса.","submitRequestMessageBefore":"Вам необходимо отправить запрос, чтобы связаться с нашим","customerService":" центром обслуживания клиентов ","submitRequestMessageAfter":"мы решим это как можно быстрее.","haveSecretkey":"2. У меня есть 16-значный секретный ключ для моей учетной записи SIP.","email":"Электронная почта","secretKey":"Секретный ключ","emailNotEmpty":"Требуется электронная почта","emailNotValid":"Адрем электронной почты должен быть действительным","secretKeyNotEmpty":"Требуется секретный ключ","secretKeyNotValid":"Секретный ключ должен состоять из 16 символов","accepteEmail":"Для сброса 2-FА, примите электронную почту.","sendEmailSuccess":"Почта успешно отправлена","emailAddressNotExist":"Адрес электронной почты не существует","secretKeyError":"Неправильный секретный ключ"},"userRequest":{"submitRequest":"Отправить запрос","issue":"Проблема","email":"Электронная почта","emailHint":"Пожалуйста, укажите адрес электронной почты, который Вы зарегистрировали в SIP.","subject":"Тема","subjectHint":"Кратко опишите Вашу проблему в поле Тема.","description":"Описание","descriptionHint":"Пожалуйста, введите детали Вашего запроса.","issueSelect":{"account":"Учетная запись","password":"Пароль","googleAuth":"Google Authenticator(2FA)","wallet":"Кошелек","other":"Другое"},"rules":{"issue":{"required":"Пожалуйста, выберите проблему"},"regEmail":{"required":"Требуется электронная почта","valid":"Электронная почта должна быть действительной"},"subject":{"required":"Тема обязательна","valid":"Длина символов превышает лимит"},"description":{"required":"Описание обязательно","valid":"Длина символов превышает лимит"}},"submitSuccessTitle":"Отправлено успешно","submitSuccessDesc":"Ваш запрос был успешно отправлен, и мы решим проблему как можно скорее."},"menu":{"profile":"Профиль","signOut":"Выйти","posts":"Посты","comments":"Комментарии","replies":"Ответы","language":"Язык: ","locale":"Английский язык","darkTheme":"Темный режим","dark":"Темный","light":"Светлый","setting":"Настройка","style":"Стиль","selectStyle":"Выбрать стиль","home":"Главная","microArticle":"Микростатьи","searchUser":"Поиск пользователя","tokenTracker":"Token Tracker","IOBPowerRanking":"Рейтинг IOB Power","GDPR":"GDPR","privacy":"Заявление о конфиденциальности","AML":"AML","support":"Поддержка","sendFeedback":"Отправить отзыв","tags":"Tags"},"uploadMaterial":{"selfie":"ID Selfie","attachMessage":"Пожалуйста, приложите JPG, JPEG или PNG менее 2M","uploadHint":"Нажмите или перетащите файлы сюда, чтобы загрузить","uploadFile":"Загрузить файл","upload":"Загрузить","message":{"tooLarge":"Файл слишком большой, загрузите файл не более 2M.","formatIncorrect":"Неверный формат файла. Пожалуйста, загрузите файл JPG, JPEG или PNG не более 2M.","uploadSuccessTitle":"Успешная загрузка","uploadSuccessDesc":"Ваши материалы были загружены на наш сервер, наша команда обработает это как можно скорее."}},"microArticles":{"publishMessage":"Что происходит?","publish":"Опубликовать","hot":"Интерсное","new":"Новое","noMore":"Нет больше данных","noResults":"Нет результатов","contentLimit":"Содержание не более 1000 слов"},"microArticle":{"no":"Нет","comments":"Комментарии","yet":"Пока что","commentLimit":"Содержание не более 500 слов"},"foot":{"title":"Платформа социальных инвестиций<br><span class='Slogan'>Разоблачение обманов финансового рынка</span>","aboutUs":"О нас","contact":"Свяжитесь с нами","gdpr":"GDPR","privacy":"Заявление о конфиденциальности","policy":"AML","contentpolicy":"Политика содержимого","kyc":"ЗСК","IOBToken":"IOB Токен","aLLRightsReserved":"Все права защищены"},"kyc":{"rules":{"required":{"required":"Это поле должно быть обязательно заполнено","identity":"Пожалуйста, выберите способ идентификации","country":"Пожалуйста, выберите страну","proof":"Пожалуйста, выберите способ доказательства"}},"identity":"Идентификация","identitySelect":{"passport":"Паспорт","idCard":"Достоверение личности","driverLicence":"Водительские права"},"documentIssuingCountry":"Страна выдачи документа","country":"Страна","proofOfPermanentAddress":"Подтверждение постоянного адреса проживания","proofOfPermanentAddressSelect":{"telephoneBill":"Telephone Bill","bankAccountStatement":"Bank Account Statement","utilityBill":"Utility Bill"},"basicInformation":"Basic Information","username":"Username","email":"Email","firstName":"First Name","middleName":"Middle Name","lastName":"Last Name","documentNumber":"Document Number","birthday":"Birthday","gender":{"gender":"Gender","male":"Male","female":"Female"},"documentFront":"Document Front","documentBack":"Document Back","proofOfBill":"Proof Of Bill","selfieWithPhotoIDAndNote":"Selfie With Photo ID And Note","selfieMessage":"Please provide a photo of you holding your passport or photo ID. In the same picture have a reference to IOB and today's date displayed — a note with the word 'IOB SIP', today's date, and your signature will do. Make sure your face will be clearly visible and that all passport details are clearly readable.","selfieList1":"Face clearly visible","selfieList2":"Photo ID clearly visible","selfieList3":"Note with word \"IOB SIP\"","selfieList4":"Note with today's date","selfieList5":"Note with signature"},"userRanking":{"avatar":"Avatar","userName":"Username","nickname":"Nickname"},"notification":{"notifications":"Уведомления","markAllAsRead":"Отметить, как прочитанное","postUpvote":"Пост понравился","postDownvote":"Пост не понравился","postComment":"Комментарии","commentUpvote":"Комментарий понравился","commentDownvote":"Комментарий не понравился","commentReply":"Ответ комментарию","userFollow":"Подписаться","userUnfollow":"отписаться","adminPostUpdate":"Администратор обновил ваш пост","adminPostDelete":"Администратор удалил ваш пост","adminCommentUpdate":"Администратор обновил ваш комментарий","adminCommentDelete":"Администратор удалил ваш комментарий","nothingMessage":"Здесь пока ничего нет","mentionsMessage":"Когда кто-то отметит Вас в SIP, вы увидите это здесь."},"faq":{"faq1":"What is iobots.pro?","faqTxt1":"<a href='https://iobots.pro' target='_blank'>iobots.pro </a>is IOB LLC's internal proprietary trading portal. Currently, it is set up only for our own proprietary cryptocurrency trading on some of the top 10 crypto spot and derivative exchanges.<br><br>We have noticed that some of the IOB Tokenholders are new trading enthusiasts. As an educator, we decide to share some of our own trading resources with the community by providing a collection of market data and trading tools online in order to offer some basic trading lessons that we wish someone would have taught us when we first started trading.","faq2":"What are the Signals? ","faqTxt2":"A Signal is a result derived from quantifiable reasons to take a trade based on price actions and other analytical market data.<br><br>Offering no investment advice or asset management services, the website simulates a realtime <a href='https://docs.google.com/spreadsheets/d/1PjQM0X7fy2iyZB5Q56V9NU5PAudHgnBQDUuJ9ig-UY8/edit?usp=sharing' target='_blank'>Model Portfolio</a> and updates its buy (Long) or sell (Short) Signals once a day. <br><br>Currently, the Signals are delayed and are covering six trading pairs: BTCUSD, ETHUSD, BCHUSD, LTCUSD, XRPUSD, and EOSUSD. ","faq3":"Are they updated in realtime? ","faqTxt3":"No.","faq4":"Can I copy the Signals on iobots.pro for my own trading? ","faqTxt4":"No. It is not recommended. <br><br> At IOB LLC, we are committed to giving our community some sound trading advice through our own trading success and failures. The website offers no investment advice or asset management services to retail traders. The signals are for informational and educational purposes only. <br><br> You should not simply follow the signals with your own trading, because it will not achieve the desired results. Everyone's trading situation, risk tolerance, and objectives are different. A one-size-fits-all approach will never yield any good result.","faq5":"How do you predict the market directions? ","faqTxt5":"We do not predict the market directions. Neither should you. <br><br> Our quantitative trading derives trading decisions from hundreds of data points. Long or Short Signals are just a relatively small part of the trading process. Money management, risk management and exits (rather than entries) are far more important considerations than market direction predictions. ","faq6":"Trading success without predicting the market directions? ","faqTxt6":"Absolutely.<br><br> In our trading experience, not trying to predict the market is one of the top reasons for trading success.<br><br>Most new traders make trading decisions based on their feelings, opinions, and predictions that often turn into hopes and wishes. Rather than disciplines, hopes and wishes often lead to holding onto the losers for too long and cutting the winners too soon. <br><br>We have a set of rules for entries and exits. When the conditions are met, we enter or exit accordingly, without emotions, without predictions, and without regrets.","faq7":"When can I use ioBots for trading? ","faqTxt7":"We believe that education and nurturing an understanding of the right trading discipline is critical to trading success. We hope novice traders learn and build some solid foundation on trading methods, systems, plans, risk/reward ratios, and win rates on our websites, both <a href='https://iobots.pro' target='_blank'>iobots.pro </a> and <a href='https://iob.community/#/' target='_blank'>iob.community </a>, before starting to risk money. <br><br> While managing our own money and for our high-net-worth limited partners (LPs) in the future, we may offer a commercial trading technical platform as a premium feature for individual traders around the world. <br><br> IOB Tokenholders will have priority access to new products and services.We currently do not have a timetable for the new product offering. We will continue to update the Signals daily as needed and will make the product roadmap available to you when they are ready."},"tag":{"no":"No","tagName":"Tag Name","numberOfPosts":"Number Of Posts"}}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = {"common":{"follow":"关注","unfollow":"正在关注","confirm":"确认","cancel":"取消","clear":"清除","submit":"提交","verify":"验证","apply":"应用","save":"保存","action":"操作","yes":"是","no":"否","at":"在","by":"于","success":"成功","fail":"失败","warning":"警告","loading":"加载中...","begin":"开始","nomore":"数据到底了","serverError":"对不起，服务器错误","details":"详情","search":"搜索","edit":"编辑","copy":"复制","copySuccess":"复制成功","copyFailure":"该浏览器不支持自动复制","serialNumber":"序号","punctuation":{"period":"。"}},"header":{"searchPlaceholder":"搜索","posts":"帖子","microArticles":"微文","login":"登录","signUp":"注册","search":"请输入要搜索的标题","feed":"我的动态","profile":"个人资料","settings":"设置","logout":"退出","usernameHint":"用户名/邮箱","passwordHint":"密码","usernameHintEmpty":"请输入您的用户名或邮箱","passwordHintEmpty":"请输入密码","passwordHintLength":"密码必须等于或超过8个字符","codeHint":"验证码","rememberMe":"记住我","forgotPassword":"忘记密码","loginButton":"登录","loginButtonLoad":"登录中...","accountHint":"还没有账户","googleModalTitle":"输入两步验证码","googleModalEnterHint":"请输入由谷歌身份验证器生成的两步验证码。","googleModalContactHintBefore":"如果您遗失了您的谷歌身份验证器，请","googleModalContactHintMiddle":"联系客服","googleModalContactHintAfter":"。","verifyCodeWrongMessage":"验证码错误","loginSuccessMessage":"登录成功","userNotExistMessage":"用户不存在","passwordWrongMessage":"密码错误","accountDisableMessage":"您的账户不允许登录，请激活","verificationCodeErrorMessage":"验证码错误,请重试","errorCallback":{"authenticationSecret":"秘钥不能为空","randomCodeBeEmpty":"验证码不能为空","randomCodeValue":"请输入数字","randomCodeDigits":"必须是6位数"},"requiredMessage":{"userName":"请输入您的用户名或邮箱","passWord":"请输入您的密码","passWordMin":"密码至少是8位"},"resolution":"推荐分辨率","scaling":"推荐缩放比例","cookieStatementMessage":"我们使用cookies来了解您如何使用我们的网站，个性化内容以及改善您的体验。继续使用我们的网站，即表示您接受我们使用cookies和修订的","privacyPolicy":"隐私政策","dismiss":"知道了","analyst":"你是分析师","paidTitle":"以优质内容赚取高额报酬：在SiP上发布文章或为其他文章投票，即可参与瓜分每日奖励池，赢取高额奖励。","hot":"热门","new":"最新","edit":"编辑","notifications":"通知","menu":"菜单","announcement":{"total":"总共 ","usersAwardMsg":" IOB Power 奖励给用户","postsAwardMsg":" IOB Power 奖励给帖子"}},"left":{"tags":"标签","showall":"更多","Upward":"更少"},"right":{"myWallet":"我的钱包","signUp":"注册","login":"登录","links":"链接","iobannouncements":"IOB 公告栏","myFeed":"我的关注","myBlog":"我的博客","sort":"分类","hot":"热门","new":"最新","industryNews":"行业新闻","IOBOfficialTelegram":"IOB 官方电报群","allTags":"所有标签","hotTopics":"热门话题","about":"关于","poet":"PoET","team":"团队","iobots":"ioBots","faq":"FAQ","investorRelations":"投资者关系","jobs":"工作","eventsMedia":"活动与媒体","advertise":"广告","contact":"联系我们","title":"最新评论","submitRequestMessage":"如果您想提交请求，请联系我们的","customerService":"客户服务","feedbackMessage":"如果你有意见或者建议，请发送邮件到service@iob.vc"},"posting":{"home":"主页","hot":"热门","new":"最新","comment":"评论","bonus":"奖金","upvote":"点赞","tread":"踩","retweet":"转发","save":"收藏","evaluation":"您已经投过票了.","forwardplacholder":"请输入转发内容","forwardMessage":"转发成功","collectionsuccess":"收藏成功","collectionCancel":"取消收藏","noMore":"没有更多数据了","noResults":"没有数据"},"postingsel":{"category":"类别","tags":"标签","original":"原创","source":"阅读原文","DISCUSSION":"评论","follow":"关注","unfollow":"正在关注","comment":"评论","edit":"编辑","upvote":"点赞","tread":"踩","UporDown":"折叠/展开","profile":"个人简介","evaluation":"您已经投过票了","Tocomment":"请输入内容","twitter":"分享到推特","google":"分享到谷歌","facebook":"分享到脸书","linkedin":"分享到Linkedin","TocommentLength":"内容不得少于20个字符","TocommentMaxLength":"内容不得超过200个字符","success":"成功！"},"postingcreate":{"Post":"发布","Reset":"重置","preview":{"preview":"预览","hint":{"title":"<在此处输入标题>","content":"<在此处输入内容>"}},"original":"原创","repost":"转载","close":"关闭","Title":"请输入标题","chooseTopic":"选择话题","enterUrl":"请输入一个网址","postingTitle":{"message":"标题不能为空"},"postingContent":{"message":"内容不能为空","messageless":"内容不能少于二十字"},"market":{"message":"请选择一个话题"},"tagName":"标签(最多5个)以逗号分隔，只使用字母和数字","message":{"rule":"只使用字母和数字","length":"最多5个标签","tagNameLength":"最大标签长度为24个字符","updatePost":"提示：你正在更新帖子，如果你想要发布一个新的帖子，请重置后继续。","resetPost":"是否确认要清除已编辑的内容？"},"agree":"我已阅读并同意","contentPolicy":"内容政策","rules":{"originalLink":{"label":"原文链接","incorrect":"网址格式错误"}},"notification":"通知","cannotPostMessage":"抱歉，目前普通用户无法发帖，敬请期待！"},"userData":{"posting":"帖子","microArticle":"微文","comment":"评论","comments":"评论","reply":"回复","forward":"转发","forwarded":"已转发的","favorites":"喜欢","upvotes":"投票","downvotes":"反对","referees":"推荐人","rewardRecords":"奖励记录","bonusRecordTableHeaders":{"actionTimestamp":"操作时间","timestamp":"奖励时间","record":"记录"}},"follow":{"following":"正在关注","followers":"关注者","referrals":"推荐人","collections":"喜欢","followingTableMsg":"你还没有关注任何人.","followerTableMsg":"还没有人关注你.","canNotFollow":"不能关注自己"},"userSetting":{"changeCoverImage":"更改封面图片","uploadImgTitle":"单击头像或将图像文件拖到头像区域以更改头像,你的图片不能大于1M.","uploading":"上传中...","account":"账户","password":"密码","wallet":"钱包","walletAddress":"钱包地址","privacyAndSafety":"隐私和安全","kyc":{"kyc":"实名认证","begin":"开始","beginMsg":"您尚未完成实名认证。","underReview":"正在审核中","underReviewMsg":"您的资料正在审核中。","rejected":"被拒绝","rejectedMsg":"对不起，您尚未通过实名认证审核，请重新认证。","passed":"已通过","passedMsg":"您已通过实名认证审核。"},"googleAuthentication":"二级认证","nickName":"昵称","nickNameMsg":"请设置昵称","username":"用户名","email":"邮箱","emailAddressMsg":"邮箱名","invitationCode":"邀请码","copyInvitationLink":"复制邀请链接","token":"令牌","edit":"编辑","refresh":"刷新","language":"语言","avatar":"个人头像网址","coverImage":"封面图片网址","timeZone":"时区","passwordMsg":"更改密码或恢复当前密码.","currentPassword":"当前密码","newPassword":"新密码","verifyPassword":"确认密码","forgotPassword":"忘记当前密码","saveChanges":"保存","walletSetMessage":"请输入您的钱包地址，确认后无法更改.","confirmWalletHint":"你是否确认将下面的地址设置为你的钱包地址？","balance":"余额","privacyStatement":"<p>IOB LLC is committed to protecting the privacy and accuracy of confidential information to the extent possible, subject to provisions of state and federal law per country and worldwide. If you make use of our services, you state that you have read, understand understood and agreed with our privacy policy.</p> <h1><b>We care about your privacy</b></h1><br/><p><b>Cookies</b></p> <p>If you leave a comment on our site you may opt-in to save your name, email address and website in cookies. These are for your convenience so that you do not have to fill in your details again when you leave another comment. These cookies will last for one year.</p> <p>If you have an account and you log in to this site, we will set a temporary cookie to determine if your browser accepts cookies. This cookie contains no personal data and is discarded when you close your browser.</p> When you log in, we will also set up several cookies to save your login information and your screen display choices. Login cookies last for two days, and screen options cookies last for a year. If you select “Remember Me”, your login will persist for two weeks. If you log out of your account, the login cookies will be removed.</p> <p>If you edit or publish an article, an additional cookie will be saved in your browser. This cookie includes no personal data and simply indicates the post ID of the article you just edited. It expires after 1 day.</p> <p>IOB makes use of Google Analytics which is a third party cookie that tracks certain information to improve our services.</p> <p><b>Comments</b></p> <p>When visitors leave comments on the site we collect the data shown in the comments form, and also the visitor’s IP address and browser user agent string to help spam detection.</p> An anonymized string created from your email address (also called a hash) may be provided to the Gravatar service to see if you are using it. The Gravatar service privacy policy is available here: https://automattic.com/privacy/. After approval of your comment, your profile picture is visible to the public in the context of your comment.</p> <p><b>Media</b></p> <p>If you upload images to the website, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website.</p> <h1><b>The use of data</b></h1> <p>We do not sell, lease, rent or otherwise disclose your personal data to any third parties. Visitor comments may be checked through an automated spam detection service.</p> <p>We do use your data for the following reasons:</p> <ul><li>To comply with the law and governmental requests</li> <li>To prevent fraud</li> <li>To optimize your experience on our website</li> <li>To record and retain your account on the IOB platform</li></ul> <p>The information can be collected automatic through cookies or filled in by yourself when creating an account. There is information we do not collect such as private keys or wallet seed. Do not trust anyone or any message you receive that are asking for this kind of private information. If something like this occurs on our website please notify us immediately.</p> <p>If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can recognize and approve any follow-up comments automatically instead of holding them in a moderation queue.</p> <p>For users that register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit, or delete their personal information at any time (except they cannot change their username). Website administrators can also see and edit that information.</p> <p>If you have an account on this site or have left comments, you can request to receive an exported file of the personal data we hold about you, including any data you have provided to us. You can also request that we erase any personal data we hold about you. This does not include any data we are obliged to keep for administrative, legal, or security purposes.</p> <h1><b>What happens if the privacy statement changes</b></h1> <p>This Privacy Statement was last revised on 30-07-2018 July 30th, 2018. We may change this Privacy Statement at any time and for any reason. We encourage you to review this Privacy Statement each time you visit the website.</p> <p>If we decide to make a significant change to our Privacy Statement, we will post a notice on the homepage of our website for a period of time after the change is made.</p> <h1><b>Privacy of third parties</b></h1> <p>IOB may contain links to other websites. Some of those websites may be operated by third parties. We provide the links for your convenience, but we do not review, control, or monitor the privacy practices of websites operated by others. We are not responsible for the performance of websites operated by third parties or for your business dealings with them. Therefore, whenever you leave this website we recommend that you review each websites’ privacy practices and make your own conclusions regarding the adequacy of these practices.</p> <p>Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website. These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.</p> <h1><b>Contact</b></h1> <p>If you have questions or comments about this Privacy Statement, please use the Contact Form on this website to reach us.</p>","emailNotifications":"邮件通知","receiveAuthEmail":"接受认证邮件","receiveAuthEmailHint":"无法更改，当我们想通过电子邮件验证您的信息时会向您发送电子邮件。","receivePushEmail":"有关SiP产品和功能更新的新闻","receivePushEmailHint":"如果选中，我们将通过电子邮件通知您有关SiP产品和功能更新的信息。","dataProtections":"数据保护","hideSiPToken":"隐藏SiP令牌","hideSiPTokenHint":"如果选中，您的SiP令牌将被隐藏，并且无法复制以确保安全性，当你想要复制时请取消此选项。","disable":"禁用","enable":"启用","enabledMsg":"你的二级认证已启用.","disabledMsg":"你的二级认证已禁用.","disableModalTitle":"禁用二级认证","disableModalMsg":"输入您的谷歌验证器的验证码","disableModalContact":"如果您无法使用谷歌认证器，请联系我们的客户服务。","clickToCopy":"点击复制","accountBinding":"社交账户","viewOrCopyHint":"如果要查看或复制SiP令牌，请在隐私和安全中取消隐藏此选项。","errorCallback":{"passWord":{"empty":"当前密码不能为空","error":"当前密码错误"},"newPassWord":{"empty":"新密码不能为空","value":"密码至少8位，应包含：小写字母（a-z）大写字母（A-Z）数字（即0-9）特殊字符"},"confirmNewPassWord":{"again":"请再次输入密码","match":"两次密码输入不一致"},"id":"主键不能为空","secret":"秘钥不能为空","code":{"empty":"验证码不能为空","value":"请输入数字","digits":"必须是6位数"},"image":{"empty":"链接地址不能为空","invalid":"无效的链接"}},"requiredMessage":{"regEmailBeEmpty":"请输入您的邮箱","regEmailFormat":"错误的邮箱格式"},"notice":{"updateEmail":{"title":"邮件发送成功","desc":"验证链接已发送到您的新邮箱，请在新邮箱中完成更新验证"},"updatePassword":{"title":"修改成功","desc":"密码修改成功，请牢记您的密码"}},"message":{"emailAnomaly":"对不起,邮件发生异常","registered":"该邮箱已被注册过"}},"allPage":{"hintLost":"您访问的页面似乎丢失了.","hintGo":"去","homepage":"主页","hintEnd":"逛逛吧."},"page404":{"pageNotFound":"页面没有找到","hintMessage":"我们好像找不到您要查找的页面，请检查以确保您已正确输入网址。","homepageButton":"回到主页"},"page500":{"serverError":"对不起,服务器错误","hintMessage":"服务器可能出了一点问题，我们的工程师正在全力抢修，请稍后尝试。","homepageButton":"回到主页"},"enableAuthentication":{"title":"启用二级认证","step1":"第一步：","step2":"第二步：","step3":"第三步：","step4":"第四步：","step1Msg":"在你的手机上安装谷歌身份认证器APP.","step2Msg":"用谷歌身份认证器扫描下面的二维码.","step3Msg":"把下面的秘钥记下来，放在安全的地方:","step4Msg":"输入您的身份验证器生成的6位数验证码:","restoreMsg":"如果您试图在没有这个密钥的情况下恢复二级认证，可能需要7个工作日(例如您的手机丢失或被恢复).","download":"下载","userGuide":"用户指南","dangerousMsg":"危险操作，请重新登录","verificationCodeError":"验证码错误","errorCallback":{"idBeEmpty":"主键不能为空","secretBeEmpty":"秘钥不能为空","codeBeEmpty":"验证码不能为空","codeValue":"请输入数字","codeDigits":"必须是6位数"}},"password":{"title":"重置密码","emailAddress":"邮箱名","agreeMsg":"我确认我的帐户将被锁定至少24小时.","agreeHint":"请先确认信息","resetButton":"重置","sendMessage":"发送成功,请查收","notRegisteredMessage":"该邮箱未注册","failMessage":"对不起，邮件发送失败","requiredMessage":{"regEmail":"请输入您的注册邮箱","type":"错误的邮箱格式"}},"resetPassword":{"successMessage":"密码重置成功","errorCallback":{"passWord":{"empty":"请输入您的新密码","value":"密码至少8位，应包含：小写字母（a-z）大写字母（A-Z）数字（即0-9）特殊字符"},"confirmPassWord":{"again":"请再次输入密码","match":"两次密码输入不一致"}}},"updateEmail":{"updateMsg":"您正在更新您的邮箱，请点击链接.","sureMsg":"确认使用当前邮箱","noValidMsg":"链接已失效.","noRegisterNotice":"该邮箱未注册或已被更改.","activatedNotice":"该邮箱已被激活.","timeOutNotice":"该链接已超时.","successNotice":"邮箱更新成功"},"register":{"alreadyAccount":"已有账号?","create":"注册","email":"请输入您的邮箱","username":"请输入您的用户名","password":"请输入您的密码","confirmationPassword":"请再次输入您的密码","invitationCode":"邀请码(选填)","agree":"我已阅读并同意","terms":"用户协议与隐私条款","signUp":"注册","reset":"重置","noActivatedMessage":"您的邮箱已经注册过但是没有激活。","sendEmailMessage":"你想要发送激活链接到你的邮箱吗？","invitationNotempty":"请阅读并同意","registerSuccess":"要完成注册，请单击我们发送给您的电子邮件中的确认链接。","errorCallback":{"userName":{"empty":"用户名不能为空","value":"用户名是4-16位（字母，数字，下划线，减号）","exist":"用户名已被使用"},"passWord":{"empty":"密码不能为空","value":"密码至少8位，应包含：小写字母（a-z）大写字母（A-Z）数字（即0-9）特殊字符"},"repassWord":{"empty":"请再次输入密码","value":"两次密码输入不一致"},"regEmail":{"empty":"请输入邮箱名","format":"错误的邮箱格式","exist":"该邮箱已存在，请换个邮箱"}}},"registerSuccess":{"title":"邮箱验证成功","message":"您的邮箱已被确认，您的账户已被验证."},"activation":{"hint":"您正在激活电子邮件，请点击下面的按钮.","link":"激活","valid":"链接已失效."},"serviceTerms":{"title":"SiP 服务条款","message":"<p>欢迎您来到IOB Social Investment Platform。<p>请您仔细阅读以下条款，如果您对本协议的任何条款表示异议，您可以选择不进入IOB SiP。当您注册成功，无论是进入IOB SiP，还是在IOB SiP上发布任何内容（即“内容”），以及直接或通过各类方式（如站外API引用等）间接使用IOB SiP 服务和数据的行为，均意味着您（即“用户”）完全接受本协议项下的全部条款。</p>          <p>若您对本声明的任何条款有异议，请停止使用IOB SiP 所提供的全部服务。</p>          <p>一、总则</p>         <p>1. IOB SiP社区http://iob.community的所有权和运营权归上海链策信息科技有限公司所有。</p>          <p>2. 用户在使用本社区的服务之前，应当仔细阅读本协议，并同意遵守本协议及所有社区规则后方可注册成为SiP用户，一旦用户注册成功，则用户与本社区之间自动形成协议关系，用户应当受本协议及所有社区规则的约束。用户在使用特殊的服务或产品时，应当同意接受相关协议后方能使用。</p>          <p>3. 本协议、社区规则可由本社区随时更新，用户在接收SiP服务时应当及时关注，用户同意本社区不承担通知义务。本社区已发布仍有效的和将来发布的通知、公告、声明或其它类似内容是本协议及社区规则的一部分。</p>          <p>二、用户帐号</p>         <p>1. 本社区不接受无民事行为能力和限制民事行为能力人注册本社区账号，任何冒用无、限制民事行为能力人名义注册账号的，IOB SiP有权立即注销该账号，相关法律责任由冒用人承担。</p>          <p>2. 无民事行为能力人和限制民事行为能力人确因特殊情况需要注册账号的，应和站方联系并提交相关证明进行申请，但站方有权不予同意。</p>          <p>3. 用户可通过以下方式注册成为IOB SiP社区的正式用户：</p>          <p>3.1 经本社区会员系统完成注册程序并通过实名认证的用户。</p>          <p>3.2 经社区批准的第三方合作网站登录并通过实名认证的用户。</p>          <p>4. 成为IOB SiP正式用户即获得本社区规定用户所应享有的一切权限，未经实名认证仅享有本社区规定的部分会员权限，IOB SiP社区有权对会员的权限设计进行变更。</p>          <p>5. 使用本社区会员系统注册的用户，只能使用汉字、英文字母、数字、下划线及它们的组合，否则IOB SiP有权不予注册或强制更改。</p>          <p>6. 如发现用户帐号中含有不雅文字或不恰当名称的，本社区保留取消其用户资格的权利。</p>          <p>7. 用户帐号的所有权归本社区，用户仅享有使用权以及账号中有商业价值的虚拟财产所有权。连续一年未使用的用户帐号，本社区保留收回的权利。</p>          <p>三、服务内容</p>         <p>1. IOB SiP服务的具体内容由IOB SiP社区根据实际情况提供，包括但不限于授权用户通过其帐号使用IOB SiP服务发布文章、观点、评论、图片、视频、转发链接等。</p>          <p>2. 用户理解，IOB SiP 社区仅提供与IOB SiP 服务相关的技术服务等，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。</p>          <p>3. 除非本协议另有其它明示规定，增加或强化目前本服务的任何新功能，包括所推出的新产品，均受到本协议之规范。您了解并同意，本服务仅依其当前所呈现的状况提供，对于任何用户信息或个人化设定之时效、删除、传递错误、未予储存或其它任何问题，IOB SiP均不承担任何责任。</p>          <p>四、服务变更、中断或终止</p>         <p>1. 鉴于网络服务的特殊性（包括但不限于服务器的稳定性问题、恶意的网络攻击等行为的存在及其他IOB SiP社区无法控制的情形），用户同意IOB SiP社区有权随时中断或终止部分或全部的IOB SiP服务，若发生该等中断或中止IOB SiP服务的情形，IOB SiP社区将尽可能及时通过网页公告、系统通知、私信、短信提醒或其他合理方式通知受到影响的用户。</p>          <p>2. 用户理解，IOB SiP社区需要定期或不定期地对提供IOB SiP服务的社区（如互联网网站、应用程序等）或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，IOB SiP社区无需为此承担任何责任，但IOB SiP社区应尽可能事先进行通告。</p>          <p>3. 如发生下列任何一种情形，IOB SiP社区有权随时中断或终止向用户提供本协议项下的IOB SiP服务而无需对用户或任何第三方承担任何责任，由此造成的损失由用户自行独立承担：</p>          <p>3.1 用户提供的个人资料不真实。</p>          <p>3.2 用户违反法律法规国家政策或本协议中规定的使用规则。</p>          <p>3.3 用户侵犯自然人和单位合法权益的，包括但不限于侮辱、诽谤、谩骂公民个人，诋毁单位商誉或信誉等。</p>          <p>3.4 用户损害监管部门、国家机关及政府形象。</p>          <p>3.5 用户以任何方式损害IOB SiP 社区及其关联公司的商誉或信誉等合法权益。</p>          <p>3.6 其他IOB SiP 社区认为需要中断或终止向用户提供IOB SiP 服务的。</p>          <p>4. 如用户在申请开通IOB SiP 服务后在任何连续1年内未实际使用，则IOB SiP 社区有权选择采取以下任何一种方式进行处理：</p>          <p>4.1 回收用户昵称。</p>          <p>4.2 回收用户帐号，或停止为该用户提供IOB SiP 服务。</p>          <p>5 用户选择将IOB SiP 帐号与IOB SiP 合作的第三方帐号进行绑定的，除用户自行解除绑定关系外，如发生下列任何一种情形，用户已绑定的第三方帐号也有可能被解除绑定，IOB SiP 社区无需对用户或任何第三方承担任何责任：</p>          <p>5.1 用户违反法律法规国家政策、本协议的。</p>          <p>5.2 用户违反第三方用户服务协议或其相关规定的。</p>          <p>5.3 第三方账户所属的站方要求解除绑定的。</p>          <p>5.4 第三方账户所述社区或业务已关停的。</p>          <p>5.5 依据法律法规、政策规定、或主管部门要求的。</p>          <p>5.6 IOB SiP 社区认为需要解除绑定的。</p>          <p>五、使用规则</p>         <p>1. 用户注册成功后，IOB SiP 将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管。用户应当对以其用户帐号进行的所有活动和事件负法律责任。</p>          <p>2. 用户可自行编辑注册信息中的帐号名称、昵称、头像、简介等（以下简称“帐号信息”），但应遵守“七条底线”以及相关管理规定，不得含有违法和不良信息。同时，</p>          <p>2.1 请勿以党和国家领导人或其他名人的真实姓名、字、号、艺名、笔名、头衔等注册和使用昵称（如确为本人，需要提交相关证据并通过审核方可允许使用）。</p>          <p>2.2 请勿以国家组织机构或其他组织机构的名称等注册和使用昵称（如确为该机构，需要提交相关证据并通过审核方可允许使用）。</p>          <p>2.3 请勿注册和使用与其他网友相同、相仿的名字或昵称。</p>          <p>2.4 请勿注册和使用不文明、不健康的ID和昵称，包括但不限于歧视、侮辱、猥亵类词语的。</p>          <p>2.5 请勿注册和使用易产生歧义、引起他人误解或带有各种奇形怪状符号的ID和昵称。</p>          <p>2.6 用户以虚假信息骗取账号名称注册，或账号头像、简介等注册信息存在违法和不良信息的，IOB SiP 将暂停或注销。</p>          <p>3. 未经相关权利人授权，用户不得以他人或其他组织机构名义注册IOB SiP 帐号，亦不得使用引人误解的帐号信息注册IOB SiP 帐号，包括但不限于让人误认为该帐号与某社会名人或机构组织存在关联关系的名称、头像或简介等。用户须对在IOB SiP 的注册信息的真实性、合法性、有效性承担全部责任，用户不得冒充他人。不得利用他人的名义发布任何信息。不得恶意使用注册帐号导致其他用户误认。否则IOB SiP 有权立即停止提供服务，收回其帐号并由用户独自承担由此而产生的一切法律责任。</p>          <p>4. 用户直接或通过各类方式（如 RSS 源和站外 API 引用等）间接使用IOB SiP 服务和数据的行为，都将被视作已无条件接受本协议全部内容。若用户对本协议的任何条款存在异议，请停止使用IOB SiP 所提供的全部服务。</p>          <p>5. IOB SiP是一个内容发布、分享及获取的社区，用户通过IOB SiP 发表的信息为公开的信息，其他第三方均可以通过IOB SiP 获取用户发表的信息，用户对任何信息的发表即认可该信息为公开的信息，并单独对此行为承担法律责任。任何用户不愿被其他第三人获知的信息都不应该在IOB SiP 上进行发表。</p>          <p>6. 用户不得利用IOB SiP 服务制作、上载、复制、发布、传播或者转载如下内容：</p>          <p>6.1 反对宪法所确定的基本原则的。</p>          <p>6.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。</p>          <p>6.3 损害国家荣誉和利益的。</p>          <p>6.4 煽动民族仇恨、民族歧视，破坏民族团结的。</p>          <p>6.5 破坏国家宗教政策，宣扬邪教和封建迷信的。</p>          <p>6.6 散布谣言，扰乱社会秩序，破坏社会稳定的。</p>          <p>6.7 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的。</p>          <p>6.8 侮辱或者诽谤他人，侵害他人合法权益的。</p>          <p>6.9 含有法律、行政法规禁止的其他内容的信息。</p>          <p>7. IOB SiP 有权对用户使用IOB SiP 的情况进行审查和监督，如用户在使用IOB SiP时违反任何上述规定，IOB SiP或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容、暂停或终止用户使用IOB SiP的权利）以减轻用户不当行为造成的影响。</p>          <p>8. 用户同意IOB SiP 社区在提供IOB SiP服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息（包括但不限于在IOB SiP社区网站的任何页面上投放广告），并且，用户同意接受IOB SiP社区通过电子邮件、私信或其他方式向用户发送商品促销或其他相关商业信息。</p>          <p>六、知识产权</p>         <p>1. IOB SiP是一个内容发布、分享及获取的社区，我们尊重和鼓励IOB SiP用户创作的内容，认识到保护知识产权对IOB SiP 生存与发展的重要性，承诺将保护知识产权作为IOB SiP运营的基本原则之一。</p>          <p>2. 用户在IOB SiP上发表的全部原创内容（包括但不仅限于文章和评论），著作权均归用户本人所有。用户可授权第三方以任何方式使用，不需要得到IOB SiP的同意。</p>          <p>3. IOB SiP 提供的网络服务中包含的标识、版面设计、排版方式、文本、图片、图形等均受著作权、商标权及其它法律保护，未经相关权利人（含IOB SiP 及其他原始权利人）同意，上述内容均不得在任何社区被直接或间接发布、使用、出于发布或使用目的的改写或再发行，或被用于其他任何商业目的。</p>          <p>4. 为了促进信息的创作和分享，用户将其在IOB SiP上发表的全部内容，授予IOB SiP免费的、不可撤销的、非独家使用许可，IOB SiP有权将该内容用于IOB SiP各种形态的产品和服务上，包括但不限于网站以及发表的应用或其他互联网产品。</p>          <p>5. 第三方若出于非商业目的，将用户在IOB SiP上发表的内容转载在IOB SiP之外的地方，应当在作品的正文开头的显著位置注明原作者姓名（或原作者在IOB SiP上使用的帐号名称），给出原始链接，注明“发表于IOB SiP”，并不得对作品进行修改演绎。若需要对作品进行修改，或用于商业目的，第三方应当联系用户获得单独授权，按照用户规定的方式使用该内容。</p>          <p>6. IOB SiP为用户提供“保留所有权利，禁止转载”的选项。除非获得原作者的单独授权，任何第三方不得转载标注了“禁止转载”的内容，否则均视为侵权。</p>          <p>7. 在IOB SiP上传或发表的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，IOB SiP有权根据实际情况删除相关的内容，且有权追究用户的法律责任。给IOB SiP或任何第三方造成损失的，用户应负责全额赔偿。</p>          <p>8. 如果任何第三方侵犯了IOB SiP用户相关的权利，用户同意授权IOB SiP或其指定的代理人代表IOB SiP自身或用户对该第三方提出警告、投诉、发起行政执法、诉讼、进行上诉，或谈判和解，并且用户同意在IOB SiP认为必要的情况下参与共同维权。</p>          <p>9. IOB SiP有权但无义务对用户发布的内容进行审核，有权根据相关证据结合《侵权责任法》、《信息网络传播权保护条例》等法律法规及IOB SiP社区指导原则对侵权信息进行处理。</p>          <p>七、个人隐私</p>         <p>1. 尊重用户个人隐私信息的私有性是IOB SiP的一贯原则，IOB SiP将通过技术手段、强化内部管理等办法充分保护用户的个人隐私信息，除法律或有法律赋予权限的政府部门要求或事先得到用户明确授权等原因外，IOB SiP保证不对外公开或向第三方透露用户个人隐私信息，或用户在使用服务时存储的非公开内容。</p>          <p>2. 本社区可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与本社区同等的保护用户隐私的责任，则本社区有权将用户的注册资料等提供给该第三方。</p>          <p>3. 在不透露单个用户隐私资料的前提下，本社区有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</p>          <p>八、侵权举报</p>         <p>1. 处理原则</p>          <p>IOB SiP作为信息发布、分享及获取社区，高度重视自由表达和个人、企业正当权利的平衡。依照法律规定删除违法信息是IOB SiP社区的法定义务，IOB SiP社区亦未与任何中介机构合作开展此项业务。</p>          <p>2. 受理范围</p>          <p>2.1 受理IOB SiP社区内侵犯企业或个人合法权益的侵权举报，包括但不限于涉及个人隐私、造谣与诽谤、商业侵权。</p>          <p>2.2 涉及个人隐私：发布内容中直接涉及身份信息，如个人姓名、家庭住址、身份证号码、工作单位、私人电话等详细个人隐私。</p>          <p>2.3 造谣、诽谤：发布内容中指名道姓或含沙射影地对他人（包括自然人和单位）的谩骂、侮辱、虚构中伤、恶意诽谤等。</p>          <p>2.4 商业侵权：泄露企业商业机密及其他根据保密协议不能公开的内容。</p>          <p>3. 举报条件</p>          <p>3.1 用户在IOB SiP发表的内容仅表明其个人的立场和观点，并不代表IOB SiP的立场或观点。如果个人或企业发现IOB SiP上存在侵犯自身合法权益的内容，可以先尝试与作者取得联系，通过沟通协商解决问题。如您无法联系到作者，或无法通过与作者沟通解决问题，请与IOB SiP取得联系（邮箱：service@iob.vc）。为了保证问题能够及时有效地处理，请务必提交真实有效、完整清晰的材料，否则投诉将无法受理。您需要向IOB SiP提供的投诉材料包括：</p>          <p>3.1.1 权利人对涉嫌侵权内容拥有商标权、著作权和/或其他依法可以行使权利的权属证明，权属证明通常是营业执照或组织机构代码证。</p>          <p>3.1.2 举报人的身份证明，身份证明可以是身份证或护照。</p>          <p>3.1.3 如果举报人非权利人，请举报人提供代表权利人进行举报的书面授权证明。</p>          <p>3.2 为确保投诉材料的真实性，在侵权举报中，您还需要签署以下法律声明：</p>          <p>3.2.1 我本人为所举报内容的合法权利人。</p>          <p>3.2.2 我举报的发布在IOB SiP社区中的内容侵犯了本人相应的合法权益。</p>          <p>3.2.3 如果本侵权举报内容不完全属实，本人将承担由此产生的一切法律责任，并承担和赔偿IOB SiP因根据投诉人的通知书对相关帐号的处理而造成的任何损失，包括但不限于IOB SiP因向被投诉方赔偿而产生的损失及IOB SiP名誉、商誉损害等。</p>          <p>4. 处理流程</p>          <p>4.1 出于网络社区的监督属性，并非所有申请都必须受理。IOB SiP自收到举报的七个工作日内处理完毕并给出回复。处理期间，不提供任何电话、邮件及其他方式的查询服务。</p>          <p>4.2 出现IOB SiP已经删除或处理的内容，但是百度、谷歌等搜索引擎依然可以搜索到的现象，是因为百度、谷歌等搜索引擎自带缓存，此类问题IOB SiP无权也无法处理，因此相关申请不予受理。您可以自行联系搜索引擎服务商进行处理。</p>          <p>4.3 此为IOB SiP社区唯一的官方侵权投诉渠道，暂不提供其他方式处理此业务。</p>          <p>4.4 用户在IOB SiP中的商业行为引发的法律纠纷，由交易双方自行处理，与IOB SiP无关。</p>          <p>九、免责声明</p>         <p>1. IOB SiP不能对用户发表的内容或评论的正确性进行保证。</p>          <p>2. 用户在IOB SiP发表的内容仅表明其个人的立场和观点，并不代表IOB SiP的立场或观点。作为内容的发表者，需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。IOB SiP不承担任何法律及连带责任。</p>          <p>3. IOB SiP不保证网络服务一定能满足用户的要求，也不保证网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作保证。</p>          <p>4. 对于因不可抗力或IOB SiP不能控制的原因造成的网络服务中断或其它缺陷，IOB SiP不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</p>          <p>5. 用户因个人问题造成的任何操作失误和财产损失，IOB SiP均不承担任何责任，包括但不限于账户密码被盗、转错钱包地址、遗失、被盗窃等情况。</p>          <p>6. 本社区不保证为方便用户而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由本社区实际控制的任何网页上的内容，本社区不承担任何责任。</p>          <p>7. 对于本社区向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，本社区无需承担任何责任：</p>          <p>7.1 本社区向用户免费提供的各项网络服务。</p>          <p>7.2 本社区向用户赠送的任何产品或者服务。</p>          <p>7.3 本社区向收费网络服务用户附赠的各种产品或者服务。</p>          <p>十、协议修改</p>         <p>1. 根据互联网的发展和有关法律、法规及规范性文件的变化，或者因业务发展需要，IOB SiP有权对本协议的条款作出修改或变更，一旦本协议的内容发生变动，IOB SiP将会直接在IOB SiP网站上公布修改之后的协议内容，该公布行为视为IOB SiP已经通知用户修改内容。IOB SIP也可采用电子邮件或私信的传送方式，提示《IOB SiP用户服务协议》条款的修改、服务变更、或其它重要事项。</p>          <p>2. 如果不同意IOB SiP对本协议相关条款所做的修改，用户有权并应当停止使用IOB SiP。如果用户继续使用IOB SiP，则视为用户接受IOB SiP对本协议相关条款所做的修改。</p>          <p>十一、附则</p>         <p>1. 本协议自用户注册成功时对用户生效，协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律，有关诉讼由上海链策信息科技有限公司所在地的法院管辖。</p>          <p>2. 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>          <p>3. 本协议解释权及修订权归上海链策信息科技有限公司所有。</p>"},"feed":{"feedText":"动态"},"userSearch":{"label":"请输入用户名或邮箱","noDataText":"用户没有找到"},"wallet":{"wallet":"钱包","transactionRecord":"交易记录","investmentRecord":"投资记录","walletAddress":"钱包地址","balance":"余额","decimals":"小数点","walletSetMessage":"请输入您的IOB代币的钱包地址，钱包会被绑定到你的SiP账户上，绑定后如需更改钱包地址，请与我们联系.","confirmWalletHint":"你是否确认将下面的地址设置为你的钱包地址？","setWalletMessage":"请先设置你的钱包地址.","txHash":"交易哈希值","noInvestmentMessage":"暂无记录","investmentStatementBefore":"您有","investmentStatementAfter":"投资记录。","investmentStatementAfters":"投资记录。","errorCallback":{"wallet":{"empty":"请输入您的钱包地址","wrong":"钱包地址不正确"}}},"transaction":{"txHash":"交易哈希值","date":"日期","from":"发送方","to":"接收方","quantity":"数量"},"transactionData":{"transaction":"交易哈希值","contract":"合约地址","txHash":"交易哈希值","blockHeight":"区块高度","time":"时间","from":"发送方","to":"接收方","tokensTransfered":"代币 已转移","gasLimit":"燃料限制","gasUsedByTransaction":"交易燃料费用","gasPrice":"燃料价格","nonceAndPosition":"随机数 & {位置}"},"investment":{"no":"序号","name":"姓名","email":"邮箱","wallet":"钱包","transaction":"交易ID","sendingAddress":"发送地址","purchasingAmount":"采购金额","paymentType":"付款方式","sentTime":"发送时间","recordTime":"记录时间","timestamp1":"前一个时间点","timestamp1Price":"价格","timestamp2":"后一个时间点","timestamp2Price":"价格","averagePrice":"平均价格","purchasingAmountInUSD":"采购金额以美元计算","bonusRate":"奖金率","bonus":"奖金","totalIOB":"总IOB"},"closeGoogleAuthentication":{"hint":"你正在关闭你的2-FA。"},"lostGoogleAuthentication":{"lostAccessApp":"无法访问您的Google身份验证器应用？","lostSecretkey":"1. 我丢失了SiP帐号的16位密钥。","sendEmailMessage":"请发送电子邮件至service@iob.vc","emailAddressHint":"电子邮件地址：请使用您在SiP注册的电子邮件地址。","subjectHint":"主题：在“主题”字段中简要描述您的问题。","descriptionHint":"描述：请输入您请求的详细信息，我们的工作人员将尽快回复。","submitRequestMessageBefore":"您需要提交一个请求来联系我们的","customerService":"客服","submitRequestMessageAfter":"，我们将尽快为您解决问题。","haveSecretkey":"2. 我有SiP帐户的16位密钥。","email":"邮箱","secretKey":"秘钥","emailNotEmpty":"电子邮件必填","emailNotValid":"电子邮件必须是有效的","secretKeyNotEmpty":"秘钥必填","secretKeyNotValid":"秘钥必须是16位字符","accepteEmail":"通过接收电子邮件重置2-FA。","sendEmailSuccess":"邮件发送成功","emailAddressNotExist":"邮箱不存在","secretKeyError":"秘钥错误"},"userRequest":{"submitRequest":"提交请求","issue":"问题类型","email":"邮箱地址","emailHint":"邮件地址请务必填写您在SiP的注册邮箱。","subject":"主题","subjectHint":"标题请简单描述问题。","description":"描述","descriptionHint":"请输入您请求的详情。","issueSelect":{"account":"账户","password":"密码","googleAuth":"两步验证","wallet":"钱包","other":"其他"},"rules":{"issue":{"required":"请选择一个问题类型"},"regEmail":{"required":"邮箱地址是必填的","valid":"邮箱地址必须是有效的"},"subject":{"required":"主题是必填的","valid":"字符长度超出限制"},"description":{"required":"描述是必填的","valid":"字符长度超出限制"}},"submitSuccessTitle":"提交成功","submitSuccessDesc":"您的请求已成功提交，我们将尽快解决此问题。"},"menu":{"profile":"个人资料","signOut":"退出","posts":"帖子","comments":"评论","replies":"回复","language":"语言：","locale":"中文（简体）","darkTheme":"黑暗模式","dark":"黑暗","light":"明亮","setting":"设置","style":"风格","selectStyle":"选择风格","home":"主页","microArticle":"微文","searchUser":"搜索用户","tokenTracker":"令牌跟踪","IOBPowerRanking":"IOB Power 排行","GDPR":"GDPR 声明","privacy":"隐私声明","AML":"反洗钱政策","support":"服务支持","sendFeedback":"发送反馈","tags":"标签"},"uploadMaterial":{"selfie":"ID自拍","attachMessage":"请附上小于2M的JPG、JPEG或PNG。","uploadHint":"点击或拖拽文件上传","uploadFile":"上传文件","upload":"上传","message":{"tooLarge":"文件太大，不能超过2M","formatIncorrect":"文件格式错误,请附上小于2M的JPG、JPEG或PNG。","uploadSuccessTitle":"上传成功","uploadSuccessDesc":"您的材料已经上传到我们的服务器，我们的工作人员将为您尽快处理，请耐心等待。"}},"microArticles":{"publishMessage":"说点什么吧?","publish":"发布","hot":"热门","new":"最新","noMore":"没有更多数据了","noResults":"没有数据","contentLimit":"内容不超过1000个字符"},"microArticle":{"no":"至今还没有","comments":"评论","yet":"","commentLimit":"内容不超过500个字符"},"foot":{"title":"社会投资平台金融市场作弊报告","aboutUs":"关于我们","contact":"联系我们","gdpr":"GDPR声明","privacy":"隐私声明","policy":"AML政策","contentpolicy":"内容协议","kyc":"KYC","IOBToken":"IOB Token","aLLRightsReserved":"版权所有"},"kyc":{"rules":{"required":{"required":"该项为必填","identity":"请选择一种身份","country":"请选择一个国家","proof":"请选择一种证明"}},"identity":"身份","identitySelect":{"passport":"护照","idCard":"中国居民身份证","driverLicence":"驾驶证"},"documentIssuingCountry":"证件签发国","country":"国家","proofOfPermanentAddress":"永久地址证明","proofOfPermanentAddressSelect":{"telephoneBill":"电话账单","bankAccountStatement":"银行账户报表","utilityBill":"电费单"},"basicInformation":"基本信息","username":"用户名","email":"邮箱","firstName":"名","middleName":"中间名","lastName":"姓","documentNumber":"证件号","birthday":"生日","gender":{"gender":"性别","male":"男性","female":"女性"},"documentFront":"证件正面照","documentBack":"证件反面照","proofOfBill":"账单证明","selfieWithPhotoIDAndNote":"与照片ID和笔记的自拍照","selfieMessage":"请提供持有护照或带照片的身份证件的照片。 在同一张图片中有一个参考IOB和今天显示的日期 - 一个带有'IOB SiP'字样的注释，今天的日期，你的签名就可以了。 确保您的面部清晰可见，并且所有护照详细信息都清晰可读。","selfieList1":"脸清晰可见","selfieList2":"照片ID清晰可见","selfieList3":"注意单词“IOB SiP”","selfieList4":"注意今天的日期","selfieList5":"请注意签名"},"userRanking":{"avatar":"头像","userName":"用户名","nickName":"昵称"},"notification":{"notifications":"通知","markAllAsRead":"全部标记为已读","postUpvote":"赞了你的帖子","postDownvote":"踩了你的帖子","postComment":"评论了你的帖子","commentUpvote":"赞了你的评论","commentDownvote":"踩了你的评论","commentReply":"回复了你的评论","userFollow":"关注了你","userUnfollow":"取消关注了你","adminPostUpdate":"管理员更新了你的帖子","adminPostDelete":"管理员删除了你的帖子","adminCommentUpdate":"管理员更新了你的评论","adminCommentDelete":"管理员删除了你的评论","nothingMessage":"这里没什么可看的 - 但是","mentionsMessage":"当有人在SiP中提到你时，你会在这里看到它。"},"faq":{"faq1":"什么是iobots.pro？","faqTxt1":"<a href='https://iobots.pro' target='_blank'>iobots.pro </a>是iob llc的内部自营交易门户。目前，它只为我们自己在前十大加密现货和衍生产品交易所中的一些专有加密货币交易而设立。<br><br>我们注意到，IOB 持有者是新式交易爱好者。作为市场布道者，我们决定通过在线提供市场数据和交易工具的集合，与社区共享我们自己的交易资源，以及提供基本的交易课程，我们非常希望在我们刚接触交易时有人教会我们这些课程。","faq2":"信号是什么？","faqTxt2":"信号是基于价格行为和其他分析性市场数据，从可量化的交易原因中得出的结果。该网站不提供投资建议或资产管理服务，它模拟实时<a href='https://docs.google.com/spreadsheets/d/1PjQM0X7fy2iyZB5Q56V9NU5PAudHgnBQDUuJ9ig-UY8/edit?usp=sharing' target='_blank'>模型投资组合</a>，每天更新一次买入（多头）或卖出（空头）信号。 <br><br>目前信号延迟，涵盖6对交易：BTCUSD, ETHUSD, BCHUSD, LTCUSD, XRPUSD, and EOSUSD。 ","faq3":"它们是实时更新的吗？ ","faqTxt3":"不是。","faq4":"我可以复制 iobots.pro 上的信号进行自己的交易吗？","faqTxt4":"我们不建议您这样做。<br><br> 在 IOB LLC，我们致力于通过我们自己成功和失败交易案例为我们的社区提供一些合理的交易建议。该网站不向散户提供投资建议或资产管理服务。这些信号仅供参考之用。 <br><br> 您不应简单跟随信号进行你自己的交易，因为它不会达到您预期的结果。每个人的交易策略、风险承受能力和目标都是不同的。一刀切的方法不会产生任何好的结果。","faq5":"你如何预测市场走向？ ","faqTxt5":"我们无法预测市场走向，也不建议您自行去预测。 <br><br> 我们的量化交易是从数百个数据点中提取出交易决策。长或短信号只是交易过程中相对较小的一部分。资金管理、风险管理和退出（而不是进入）远比市场方向预测重要得多。 ","faq6":"可否通过不预测市场走向而成功交易？ ","faqTxt6":"当然可以。根据我们的交易经验，不去预测市场是交易成功的主要原因之一。<br><br> 大多数新的交易者根据他们的感觉、观点和预测做出交易决定，这些往往会变成希望和愿望。与其说是纪律，不如说是希望和愿望，往往会让失败者坚持得太久，而让赢家过早落败。<br><br>我们有一套进入和推出的规则。当条件满足时，我们就相应地进入或退出，不带情绪，没有预测，也不留下遗憾。","faq7":"我什么时候可以用iobots进行交易？ ","faqTxt7":"我们相信，培养对正确交易规则的理解，对交易成功至关重要。我们希望新手交易者学习并建立一些交易方法、系统、计划、风险/回报率、以及在我们的产品 <a href='https://iobots.pro' target='_blank'>iobots.pro </a> 和 <a href='https://iob.community/#/' target='_blank'>iob.community </a>, 上获得交易盈利的理论基础，然后开始在进入市场开启冒险之旅。<br><br> 未来，在管理我们自己的资金和为高净值有限合伙人（LPs）提供服务的同时，我们可能会提供一个商业化交易技术平台，作为给全世界交易员提供的一项额外功能。IOB 通证持有者将优先获得新产品和服务。 <br><br> 我们目前还没有确定新产品上市的时间表。我们将根据市场需要继续每天更新信号，并在产品路线图准备就绪后实时更新。"},"tag":{"no":"序号","tagName":"标签","numberOfPosts":"帖子数量"}}

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Logo_vue__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Logo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Header_vue__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Left_vue__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Left_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Left_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Right_vue__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Right_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Right_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Tags_vue__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Tags_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Tags_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Terms_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Terms_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Terms_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Menu_vue__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_UserSearch_vue__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_UserSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_UserSearch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_LinkInvalid_vue__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_LinkInvalid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_LinkInvalid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_VerificationSlider_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_VerificationSlider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_VerificationSlider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_VerificationCode_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_VerificationCode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_VerificationCode_vue__);

















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AppLogo', __WEBPACK_IMPORTED_MODULE_4__components_Logo_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AppHeader', __WEBPACK_IMPORTED_MODULE_5__components_Header_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AppLeft', __WEBPACK_IMPORTED_MODULE_6__components_Left_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AppRight', __WEBPACK_IMPORTED_MODULE_7__components_Right_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AppTags', __WEBPACK_IMPORTED_MODULE_8__components_Tags_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AppTerms', __WEBPACK_IMPORTED_MODULE_9__components_Terms_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AppMenu', __WEBPACK_IMPORTED_MODULE_10__components_Menu_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AppUserSearch', __WEBPACK_IMPORTED_MODULE_11__components_UserSearch_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AppLinkInvalid', __WEBPACK_IMPORTED_MODULE_12__components_LinkInvalid_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AppVerificationSlider', __WEBPACK_IMPORTED_MODULE_13__components_VerificationSlider_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('AppVerificationCode', __WEBPACK_IMPORTED_MODULE_14__components_VerificationCode_vue___default.a);
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	data: function data() {
		return {};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["user", "darkMode"])),
	mounted: function mounted() {
		this.getUserDetail();
		this.refreshLogin();
		this.addVisitVolume();
		this.getNewNotificationNum();
		this.getMarkets();
		this.isOldPassword();
		if (this.$store.state.user.token) {
			this.getIp();
		}
	},

	methods: {
		postingcreate: function postingcreate() {
			if (localStorage.getItem('token')) {
				this.$router.push({ name: 'createPost' });
			} else {
				this.$store.state.loginModal = true;
			}
		},
		refreshLogin: function refreshLogin() {
			var _this = this;

			if (this.$store.state.user.token) {
				this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "userDetail/refreshLogin").then(function (response) {
					var data = response.data;
					if (data.resCode == 0) {
						var token = data.result;
						_this.$store.state.user.token = token;
						localStorage.setItem("token", token);
					}
				});
			}
		},
		getUserDetail: function getUserDetail() {
			var _this2 = this;

			if (this.$store.state.user.token) {
				this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "userDetail/getMe").then(function (successData) {
					var data = successData.data;
					if (data.resCode == 0) {
						var user = data.result;
						_this2.getRole(user.roleId);
						_this2.$store.dispatch("userHandler", user);
						_this2.$store.dispatch("localeHandler", user.i18nCode);
						_this2.$store.dispatch("darkModeHandler", user.darkMode);
						_this2.$store.dispatch("changeColorStyleHandler", user.colorStyle);

						_this2.$vuetify.theme = _this2.$store.getters.selectedTheme.theme;
					}
				});
			} else {
				var darkMode = localStorage.getItem("SIP-darkMode");
				if (darkMode == true) {
					this.$store.dispatch("darkModeHandler", true);
				} else if (darkMode == false) {
					this.$store.dispatch("darkModeHandler", false);
				}
				var colorStyle = localStorage.getItem("SIP-colorStyle");
				if (colorStyle) {
					this.$store.dispatch("changeColorStyleHandler", colorStyle);
					this.$vuetify.theme = this.$store.getters.selectedTheme.theme;
				}
			}
		},
		getRole: function getRole(roleId) {
			var _this3 = this;

			this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "role/open/getRole?roleId=" + roleId).then(function (successData) {
				var data = successData.data;
				if (data.resCode == 0) {
					_this3.$store.dispatch("roleHandler", data.result);
				}
			});
		},
		addVisitVolume: function addVisitVolume() {
			this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "visit/open/visit");
		},
		getNewNotificationNum: function getNewNotificationNum() {
			var _this4 = this;

			if (this.$store.state.user.token) {
				this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + 'notification/query/getNewNotificationNum').then(function (response) {
					var data = response.data;
					if (data.resCode == 0) {
						_this4.$store.dispatch('notificationNumHandler', data.result);
					}
				});
			}
		},
		getMarkets: function getMarkets() {
			var _this5 = this;

			this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "market/open/getMarkets").then(function (response) {
				var data = response.data;
				if (data.resCode == 0) {
					_this5.$store.dispatch("marketsListHandler", data.result);
				}
			});
		},
		getIp: function getIp() {
			var _this6 = this;

			var url = "https://pv.sohu.com/cityjson?ie=utf-8";
			this.$http.get(url).then(function (response) {
				var data = response.data;
				data = JSON.parse(data.substr(18, data.legth).replace(";", ""));
				var ip = data.cip;
				_this6.getAdd(ip);
			});
		},
		getAdd: function getAdd(ip) {
			var _this7 = this;

			var api = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "visit/open/getCountryCode?ip=" + ip;
			this.$http.get(api).then(function (response) {
				var data = response.data;
				if (0 == data.resCode) {
					var countryCode = data.resMsg;
					_this7.updateUserTimeZones(countryCode, ip);
				}
			});
		},
		updateUserTimeZones: function updateUserTimeZones(countryCode, ip) {
			var _this8 = this;

			var param = { countryCode: countryCode, ip: ip };
			var api = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + 'userDetail/update/updateUserTimeZone';
			this.$http.post(api, param).then(function (response) {
				var data = response.data;
				if (data.resCode == 0) {
					_this8.$router.go();
				}
			});
		},
		isOldPassword: function isOldPassword() {
			var _this9 = this;

			if (this.$store.state.user.token) {
				var api = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + 'user/isOldPassword';
				this.$http.get(api).then(function (response) {
					var data = response.data;
					if (data.resCode == 0) {
						if (data.result) {
							_this9.logout();
						}
					}
				});
			}
		},
		logout: function logout() {
			localStorage.removeItem("SIP-user");
			localStorage.removeItem("SIP-role");
			localStorage.removeItem("userName");
			localStorage.removeItem("id");
			localStorage.removeItem("token");
			localStorage.removeItem("image");
			localStorage.removeItem("invitationCode");
			this.$store.state.user.id = null;
			this.$store.state.user.name = null;
			this.$store.state.user.token = null;
			this.$store.state.user.image = null;
			this.$router.push({ name: 'home' });
			this.$router.go();
		}
	}
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_md5__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_eventBus_js__ = __webpack_require__(16);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this,
        _ref;

    var validateAuthenticationSecret = function validateAuthenticationSecret(rule, value, callback) {
      if (value === "") {
        callback(new Error("The Authentication Secret Key cannot be empty"));
      } else {
        callback();
      }
    };
    var validateRandomCode = function validateRandomCode(rule, value, callback) {
      if (!value) {
        callback(new Error("The Random Code cannot be empty"));
      } else if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(+value)) {
        callback(new Error("Please enter a numeric value"));
      } else if ((value + "").length !== 6) {
        callback(new Error("Must be 6 digits"));
      } else {
        callback();
      }
    };
    return _ref = {
      texts: [{ name: "foot.aboutUs", code: "aboutus" }, { name: "foot.contact", code: "contact" }, { name: "foot.gdpr", code: "gdpr" }, { name: "foot.privacy", code: "privacy" }, { name: "foot.policy", code: "policy" }, { name: "foot.contentpolicy", code: "contentpolicy" }, { name: "foot.kyc", code: "kyc" }],
      isShowMenuSidebar: false,
      languageName: "",
      languageModel: "",
      language: true,
      showOrderMenu: false,
      isTCSLogin: false,
      isOrderLogin: false,

      languages: [{
        code: "en-US",
        name: "English(United States)",
        img: "../../public/static/image/flag-icons/zh.png"
      }, {
        code: "zh-CN",
        name: "简体中文",
        img: "../../public/static/image/flag-icons/en.png"
      }],
      domainName: __WEBPACK_IMPORTED_MODULE_6__config_js__["a" /* default */].ip,
      chatSidebar: false,
      isShowSearchInput: false,
      searchText: null,
      isShowUserControl: false,
      isSaveUser: false,
      loading: false,
      loginAuthenticationModal: false,
      authLoading: true }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "isShowMenuSidebar", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "isShowUserSearchSidebar", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "isShowPassword", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "isShowMobileSearchModal", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "isShowCookieStatement", localStorage.getItem("SIP-isShowCookieStatement") == null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "userId", {
      id: ""
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "formInline", {
      userName: "",
      passWord: ""
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "userNameRules", [function (v) {
      return !!v || _this.$t("header.usernameHintEmpty");
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "passWordRules", [function (v) {
      return !!v || _this.$t("header.passwordHintEmpty");
    }, function (v) {
      return v && v.length >= 8 || _this.$t("header.passwordHintLength");
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "randomCodeRules", [function (v) {
      return !!v || "";
    }, function (v) {
      return v && v.length == 6 || "";
    }, function (v) {
      return (/^\d{6}$/.test(v) || ""
      );
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "formAuthentication", {
      authenticationSecret: "",
      randomCode: ""
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "ruleAuthentication", {
      authenticationSecret: [{ validator: validateAuthenticationSecret, trigger: "blur" }],
      randomCode: [{ validator: validateRandomCode, trigger: "blur" }]
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "bulletinBoardData", [{
      before: "header.announcement.total",
      data: 0,
      after: "header.announcement.usersAwardMsg"
    }, {
      before: "header.announcement.total",
      data: 0,
      after: "header.announcement.postsAwardMsg"
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "searchHistories", []), _ref;
  },

  props: {
    source: String
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(["user", "marketsList", "notificationNum"]), {
    isLogin: function isLogin() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != "") {
        return true;
      } else {
        return false;
      }
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this2 = this;

    if (JSON.parse(localStorage.getItem("SIP-searchHistories"))) {
      this.searchHistories = JSON.parse(localStorage.getItem("SIP-searchHistories"));
    }

    this.getLoginFromData();

    __WEBPACK_IMPORTED_MODULE_8__assets_js_eventBus_js__["a" /* eventBus */].$on("isShowUserSearchSidebar", function (data) {
      _this2.isShowUserSearchSidebar = data;
    });

    $(document).on("keypress", ".enter-login", function (event) {
      if (event.keyCode == 13) {
        _this2.loginAuth_v2();
      }
    });

    $(document).on("keypress", ".enter-search", function (event) {
      if (event.keyCode == 13) {
        _this2.search();
      }
    });

    $(document).on("keypress", ".enter-code-login", function (event) {
      if (event.keyCode == 13) {
        _this2.verityRandomCode("formAuthentication");
      }
    });
  },

  watch: {},
  methods: {
    goPrivacy: function goPrivacy() {
      this.$router.push({ name: "privacy" });
    },
    dissmissCookieStatement: function dissmissCookieStatement() {
      this.isShowCookieStatement = false;
      localStorage.setItem("SIP-isShowCookieStatement", 0);
    },
    routerPage: function routerPage(code) {
      switch (code) {
        case "aboutus":
          this.$router.push({ name: "about" });
          break;

        case "contact":
          this.$router.push({ name: "contact" });
          break;
        case "gdpr":
          this.$router.push({ name: "GDPR" });
          break;
        case "privacy":
          this.$router.push({ name: "privacy" });
          break;
        case "policy":
          this.$router.push({ name: "AML" });
          break;
        case "kyc":
          this.$router.push({ name: "KYC" });
          break;
        case "contentpolicy":
          this.$router.push({ name: "ContentPolicy" });
          break;
        case "iobots":
          window.open("https://iobots.pro/signals", "_blank");

        default:
          break;
      }
    },
    findByTelegramList: function findByTelegramList() {
      if (this.$store.state.user.token == null) {
        this.$store.state.loginModal = true;
      } else {
        this.$router.push({ name: "telegramusermessages" });
      }
    },
    gotoNotification: function gotoNotification() {
      if (this.$store.state.user.token) {
        this.$router.push({ name: "notification" });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    fingByHot: function fingByHot() {
      this.$router.push({ name: "posts" });
      this.$store.dispatch("pageTitleHandler", "hot");
    },
    fingByNew: function fingByNew() {
      this.$router.push({ name: "posts" });
      this.$store.dispatch("pageTitleHandler", "new");
    },
    findByMarkets: function findByMarkets(market) {
      localStorage.setItem("SIP-marketsCode", market.code);
      localStorage.setItem("SIP-marketsTitle", market.name);
      this.$store.dispatch("marketsDescHandler", market.description);
      this.$router.push({
        name: "marketPosts",
        params: {
          marketsName: market.name
        }
      });
    },
    postingcreate: function postingcreate() {
      if (localStorage.getItem("token")) {
        this.$router.push({ name: "createPost" });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    search: function search() {
      if (this.searchText != null && this.searchText.trim() != "") {
        var searchHistoryArray = JSON.parse(localStorage.getItem("SIP-searchHistories"));
        if (searchHistoryArray) {
          this.searchHistories = searchHistoryArray;
        }
        this.searchHistories.unshift(this.searchText);
        this.searchHistories = this.uniquel(this.searchHistories);
        if (this.searchHistories.length > 10) {
          this.searchHistories = this.searchHistories.slice(0, 10);
        }
        localStorage.setItem("SIP-searchHistories", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchHistories));
        this.$store.dispatch("searchTextHandler", this.searchText.trim());
        this.$router.push({
          name: "searchPosts",
          params: { searchText: this.searchText }
        });
      }
      this.searchText = null;
    },
    searchHistoryBtn: function searchHistoryBtn(searchHistory) {
      this.searchText = searchHistory;
      this.search();
    },
    showMenuSidebar: function showMenuSidebar() {
      this.isShowMenuSidebar = !this.isShowMenuSidebar;
    },
    isshowOrderMenu: function isshowOrderMenu() {
      if (this.showOrderMenu == false) {
        this.showOrderMenu = true;
      } else {
        this.showOrderMenu = false;
      }
    },
    showLoginModal: function showLoginModal() {
      this.$store.state.loginModal = true;
    },
    hideLoginModal: function hideLoginModal() {
      var _this3 = this;

      this.$store.state.loginModal = false;
      setTimeout(function () {
        localStorage.removeItem("SIP-user");
        localStorage.removeItem("SIP-role");
        localStorage.removeItem("userName");
        localStorage.removeItem("id");
        localStorage.removeItem("token");
        localStorage.removeItem("image");
        localStorage.removeItem("invitationCode");
        _this3.$store.state.user.id = null;
        _this3.$store.state.user.name = null;
        _this3.$store.state.user.token = null;
        _this3.$store.state.user.image = null;
      }, 100);
    },
    modalCancel: function modalCancel() {
      this.loginAuthenticationModal = false;
    },
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "user") {
            this.formInline.userName = arr2[1];
            if (arr2[1] !== null && "" !== arr2[1]) {
              this.isSaveUser = true;
            }
          }
          if (arr2[0] == "password") {
            this.formInline.passWord = arr2[1];
            if (arr2[1] !== null && "" !== arr2[1]) {
              this.isSaveUser = true;
            }
          }
        }
      }
    },
    getLoginFromData: function getLoginFromData() {
      var isSaveUser = localStorage.getItem("SIP-loginIsSaveUser");
      if (isSaveUser == 1) {
        this.isSaveUser = true;
        this.formInline.userName = localStorage.getItem("SIP-loginUsername");
        this.formInline.passWord = localStorage.getItem("SIP-loginPassword");
      }
    },
    gotoHome: function gotoHome() {
      this.$router.push({ name: "posts" });
      this.$router.go();
    },
    goIobots: function goIobots() {
      window.open("https://iobots.pro/", "_blank");
    },
    goIobfi: function goIobfi() {
      window.open("https://iob.fi/", "_blank");
    },
    gotoIOBLLC: function gotoIOBLLC() {},
    gotoNewsTopic: function gotoNewsTopic() {
      this.$router.push({
        name: "marketPosts",
        params: {
          marketsName: "Industry News"
        }
      });
    },
    goPassword: function goPassword() {
      this.$store.state.loginModal = false;
      this.$router.push({ name: "password" });
    },
    gotoRegister: function gotoRegister() {
      this.$store.state.loginModal = false;
      this.$router.push({ name: "register" });
    },
    goLostGoogleAuthentication: function goLostGoogleAuthentication() {
      this.loginAuthenticationModal = false;
      this.$router.push({ name: "lostGoogleAuthentication" });
    },
    goUserRequest: function goUserRequest() {
      this.loginAuthenticationModal = false;
      this.$router.push({ name: "userRequest" });
    },
    showMobileSearchModal: function showMobileSearchModal() {
      this.isShowMobileSearchModal = true;
    },
    mobileSearch: function mobileSearch() {
      this.isShowMobileSearchModal = false;
      this.search();
    },
    uniquel: function uniquel(arr) {
      var hash = [];
      for (var i = 0; i < arr.length; i++) {
        if (hash.indexOf(arr[i]) == -1) {
          hash.push(arr[i]);
        }
      }
      return hash;
    },
    setCookieUser: function setCookieUser(c_user, severalDays) {
      var currentDate = new Date();
      currentDate.setHours(currentDate.getHours() + 24 * severalDays);

      window.document.cookie = "user" + "=" + c_user + ";path=/;expires=" + currentDate.toGMTString();
    },
    setCookiePassword: function setCookiePassword(c_password, severalDays) {
      var currentDate = new Date();

      currentDate.setHours(currentDate.getHours() + 24 * severalDays);

      window.document.cookie = "password" + "=" + c_password + ";path=/;expires=" + currentDate.toGMTString();
    },
    loginAuth: function loginAuth() {
      if (this.$refs.formInline.validate()) {
        this.loading = true;
        var url = __WEBPACK_IMPORTED_MODULE_6__config_js__["a" /* default */].baseUrl + "user/open/loginPost";

        var flag = true;
        if (document.cookie.length > 0) {
          var arr = document.cookie.split("; ");
          for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split("=");
            if (arr2[0] == "password") {
              var cookiePassword = arr2[1];
              if (this.formInline.passWord == cookiePassword) {
                this.formInline.passWord = __WEBPACK_IMPORTED_MODULE_5_js_md5___default()(cookiePassword);
                flag = false;
              }
            }
          }
        }
        if (flag) {
          var password = __WEBPACK_IMPORTED_MODULE_5_js_md5___default()(this.formInline.passWord);
          var password = password.split("").reverse().join("");
          this.formInline.passWord = __WEBPACK_IMPORTED_MODULE_5_js_md5___default()(password);
        }
        this.$http.post(url, this.formInline).then(function (successData) {
          var data = successData.data;
          if (data.resCode == 0) {
            if (this.isSaveUser) {
              this.setCookieUser(this.formInline.userName, 3650);

              if (flag) {
                this.setCookiePassword(password, 3650);
              } else {
                this.setCookiePassword(cookiePassword, 3650);
              }
            } else {
              this.setCookieUser("", -1);
              this.setCookiePassword("", -1);
            }
            var userDto = data.result;
            this.$store.state.user.name = userDto.userName;
            this.$store.state.user.token = userDto.token;
            this.$store.state.user.id = userDto.id;
            this.$store.state.user.image = userDto.image;
            localStorage.setItem("userName", userDto.userName);
            localStorage.setItem("id", userDto.id);
            localStorage.setItem("token", userDto.token);
            localStorage.setItem("image", userDto.image);
            localStorage.setItem("invitationCode", userDto.invitationCode);
            this.$store.dispatch("localeHandler", userDto.i18n.code);
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.interceptors.push(function (request, next) {
              request.credentials = true;

              request.headers.set("Authorization", "Bearer " + data.result.token);
              next();
            });
            this.$refs.formInline.reset();
            this.loading = false;
            this.$store.state.loginModal = false;
          } else if (data.resCode == -1000) {
            this.$Message.error(this.$t("header.userNotExistMessage"));
            this.loading = false;
          } else if (data.resCode == -1001) {
            this.$Message.error(this.$t("header.passwordWrongMessage"));
            this.loading = false;
          } else if (data.resCode == -1004) {
            this.$Message.error(this.$t("header.accountDisableMessage"));
            this.loading = false;
          } else if (data.resCode == -1005) {
            if (this.isSaveUser) {
              this.setCookieUser(this.formInline.userName, 3650);

              if (flag) {
                this.setCookiePassword(password, 3650);
              } else {
                this.setCookiePassword(cookiePassword, 3650);
              }
            } else {
              this.setCookieUser("", -1);
              this.setCookiePassword("", -1);
            }
            this.userId.id = data.result.id;
            this.formAuthentication.authenticationSecret = data.result.authenticationSecret;
            this.loading = false;
            this.$store.state.loginModal = false;
            this.loginAuthenticationModal = true;
          }
        }, function (errorData) {
          this.loading = false;
        });
      }
    },
    loginAuth_v2: function loginAuth_v2() {
      if (this.$refs.formInline.validate()) {
        this.loading = true;
        var url = __WEBPACK_IMPORTED_MODULE_6__config_js__["a" /* default */].baseUrl + "user/open/loginPost";

        var passWord = __WEBPACK_IMPORTED_MODULE_5_js_md5___default()(this.formInline.passWord);
        passWord = passWord.split("").reverse().join("");

        passWord = __WEBPACK_IMPORTED_MODULE_5_js_md5___default()(passWord);
        var sha256 = __webpack_require__(40).sha256;

        var possWord_v2 = sha256(this.formInline.passWord);
        var userFormData = {
          userName: this.formInline.userName,
          passWord: passWord,
          passWord_v2: possWord_v2
        };
        this.$http.post(url, userFormData).then(function (successData) {
          var data = successData.data;
          if (data.resCode == 0) {
            if (this.isSaveUser) {
              localStorage.setItem("SIP-loginIsSaveUser", 1);
              localStorage.setItem("SIP-loginUsername", this.formInline.userName);
              localStorage.setItem("SIP-loginPassword", this.formInline.passWord);
            } else {
              localStorage.removeItem("SIP-loginIsSaveUser");
              localStorage.removeItem("SIP-loginUsername");
              localStorage.removeItem("SIP-loginPassword");
            }
            var userDto = data.result;
            this.$store.state.user.name = userDto.userName;
            this.$store.state.user.token = userDto.token;
            this.$store.state.user.id = userDto.id;
            this.$store.state.user.image = userDto.image;
            localStorage.setItem("userName", userDto.userName);
            localStorage.setItem("id", userDto.id);
            localStorage.setItem("token", userDto.token);
            localStorage.setItem("image", userDto.image);
            localStorage.setItem("invitationCode", userDto.invitationCode);
            this.$store.dispatch("localeHandler", userDto.i18n.code);
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.interceptors.push(function (request, next) {
              request.credentials = true;

              request.headers.set("Authorization", "Bearer " + data.result.token);
              next();
            });
            this.$refs.formInline.reset();
            this.loading = false;
            this.$store.state.loginModal = false;
            this.$router.go();
          } else if (data.resCode == -1000) {
            this.$Message.error(this.$t("header.userNotExistMessage"));
            this.loading = false;
          } else if (data.resCode == -1001) {
            this.$Message.error(this.$t("header.passwordWrongMessage"));
            this.loading = false;
          } else if (data.resCode == -1004) {
            this.$Message.error(this.$t("header.accountDisableMessage"));
            this.loading = false;
          } else if (data.resCode == -1005) {
            if (this.isSaveUser) {
              localStorage.setItem("SIP-loginIsSaveUser", 1);
              localStorage.setItem("SIP-loginUsername", this.formInline.userName);
              localStorage.setItem("SIP-loginPassword", this.formInline.passWord);
            } else {
              localStorage.removeItem("SIP-loginIsSaveUser");
              localStorage.removeItem("SIP-loginUsername");
              localStorage.removeItem("SIP-loginPassword");
            }
            this.userId.id = data.result.id;
            this.formAuthentication.authenticationSecret = data.result.authenticationSecret;
            this.loading = false;
            this.$store.state.loginModal = false;
            this.loginAuthenticationModal = true;
          }
        }, function (errorData) {
          this.loading = false;
        });
      }
    },
    verityRandomCode: function verityRandomCode(name) {
      var _this4 = this;

      if (this.$refs[name].validate()) {
        var url = __WEBPACK_IMPORTED_MODULE_6__config_js__["a" /* default */].baseUrl + "user/open/authenticationRandomCode";
        this.$http.post(url, this.formAuthentication).then(function (successData) {
          var data = successData.data;
          if (data.result) {
            var userUrl = __WEBPACK_IMPORTED_MODULE_6__config_js__["a" /* default */].baseUrl + "user/open/userDto";
            _this4.$http.post(userUrl, _this4.userId).then(function (successData) {
              var data = successData.data;
              if (data.resCode == 0) {
                _this4.$store.state.user.name = data.result.userName;
                _this4.$store.state.user.token = data.result.token;
                _this4.$store.state.user.id = data.result.id;
                _this4.$store.state.user.image = data.result.image;
                localStorage.setItem("userName", data.result.userName);
                localStorage.setItem("id", data.result.id);
                localStorage.setItem("token", data.result.token);
                localStorage.setItem("image", data.result.image);
                localStorage.setItem("invitationCode", data.result.invitationCode);
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.interceptors.push(function (request, next) {
                  request.credentials = true;

                  request.headers.set("Authorization", "Bearer " + data.result.token);
                  next();
                });
                _this4.authLoading = false;
                _this4.$nextTick(function () {
                  _this4.authLoading = true;
                });
                _this4.loginAuthenticationModal = false;
                _this4.$router.go();
              }
            }, function (errorData) {
              _this4.authLoading = false;
              _this4.$nextTick(function () {
                _this4.authLoading = true;
              });
            });
          } else {
            _this4.$Message.error(_this4.$t("header.verificationCodeErrorMessage"));
            _this4.formAuthentication.randomCode = "";
            _this4.authLoading = false;
            _this4.$nextTick(function () {
              _this4.authLoading = true;
            });
          }
        }, function (errorData) {
          _this4.authLoading = false;
          _this4.$nextTick(function () {
            _this4.authLoading = true;
          });
        });
      } else {
        this.$Message.error(this.$t("header.verificationCodeErrorMessage"));
        this.formAuthentication.randomCode = "";
        this.authLoading = false;
        this.$nextTick(function () {
          _this4.authLoading = true;
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cropperjs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cropperjs__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            uploadUrl: 'http://118.126.113.35/user/uploadHeadPortrait',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            headerImage: '',
            picValue: '',
            cropper: '',
            croppable: false,
            panel: false,
            url: ''
        };
    },

    computed: {},
    created: function created() {},
    mounted: function mounted() {
        this.initCropper();
    },

    watch: {},
    methods: {
        initCropper: function initCropper() {
            var self = this;
            var image = document.getElementById('image');
            this.cropper = new __WEBPACK_IMPORTED_MODULE_0_cropperjs___default.a(image, {
                aspectRatio: 1, viewMode: 1, background: false, zoomable: false,
                ready: function ready() {
                    self.croppable = true;
                }
            });
        },
        cancel: function cancel() {
            this.panel = false;
        },
        getObjectURL: function getObjectURL(file) {
            var url = null;
            if (window.createObjectURL != undefined) {
                url = window.createObjectURL(file);
            } else if (window.URL != undefined) {
                url = window.URL.createObjectURL(file);
            } else if (window.webkitURL != undefined) {
                url = window.webkitURL.createObjectURL(file);
            }return url;
        },
        crop: function crop() {
            this.panel = false;
            var croppedCanvas;
            var roundedCanvas;
            if (!this.croppable) {
                return;
            }
            croppedCanvas = this.cropper.getCroppedCanvas();
            console.log(this.cropper);
            roundedCanvas = this.getRoundedCanvas(croppedCanvas);
            this.headerImage = roundedCanvas.toDataURL();
            this.postImg();
        },
        getRoundedCanvas: function getRoundedCanvas(sourceCanvas) {
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            var width = sourceCanvas.width;
            var height = sourceCanvas.height;
            canvas.width = width;
            canvas.height = height;
            context.imageSmoothingEnabled = true;
            context.drawImage(sourceCanvas, 0, 0, width, height);
            context.globalCompositeOperation = 'destination-in';
            context.beginPath();
            context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
            context.fill();
            return canvas;
        },
        postImg: function postImg() {
            this.$http.post("http://127.0.0.1:7979/userDetail/uploadAvatar/" + this.$store.state.user.id, this.headerImage).then(function (res) {
                alert(1);
            }, function (err) {
                alert("err");
            });
        },
        beforeUpload: function beforeUpload(files) {
            console.log(files);
            this.panel = true;
            this.picValue = files;
            this.url = this.getObjectURL(this.picValue);
            if (this.cropper) {
                this.cropper.replace(this.url);
            }
            return false;
        },

        uploadSuccess: function uploadSuccess(response, file, fileList) {
            this.userDetail.image = response.result;
            this.$store.state.user.image = response.result;
            localStorage.setItem("image", response.result);
        }
    }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isShowAll: false,
            isShowUpward: false,
            tagList: [],
            allTagList: [] };
    },

    computed: {},
    created: function created() {},

    mounted: function mounted() {
        this.getAllTag();
    },
    watch: {},
    methods: {
        findtagposting: function findtagposting(tagId, tagName) {
            if (tagId != null && tagId.trim() != '') {
                this.$router.push({ name: 'posting', query: { "tagId": tagId, "tagName": tagName } });
            }
        },
        getAllTag: function getAllTag() {
            this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "tag/open/getTagByCondition/hot").then(function (successData) {
                var data = successData.data.result;
                this.allTagList = data;
                if (data.length > 20) {
                    for (var i = 0; i < 20; i++) {
                        this.tagList = this.tagList.concat(data[i]);
                    }
                    this.isShowAll = true;
                } else {
                    this.tagList = data;
                }
            });
        },
        showAllTag: function showAllTag() {
            this.tagList = this.allTagList;
            this.isShowAll = false;
            this.isShowUpward = true;
        },
        upwardTag: function upwardTag() {
            this.tagList = [];
            for (var i = 0; i < 20; i++) {
                this.tagList = this.tagList.concat(this.allTagList[i]);
            }
            this.isShowAll = true;
            this.isShowUpward = false;
        }
    }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },
    created: function created() {},
    mounted: function mounted() {},

    watch: {},
    methods: {
        goHome: function goHome() {
            this.$router.push({ name: "home" });
        }
    }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
        data: function data() {
                return {};
        },
        created: function created() {},

        computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(["selectedTheme", "darkMode"])),
        mounted: function mounted() {},

        watch: {},
        methods: {}
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_eventBus_js__ = __webpack_require__(16);







/* harmony default export */ __webpack_exports__["default"] = ({
				data: function data() {
								return {
												token: this.$store.state.user.token,
												drawer: null,
												languageModel: this.$store.getters.locale,
												darkModeModel: this.$store.getters.darkMode,
												mainMenuItems: [{ title: this.$t('menu.searchUser'), name: 'userSearch', icon: 'fa fa-user-plus' }, { title: this.$t('menu.IOBPowerRanking'), name: 'userRanking', icon: 'fa fa-chart-bar' }],
												viceMenuItems: [{ title: this.$t('menu.GDPR'), name: 'GDPR', icon: 'mdi-star-circle' }, { title: this.$t('menu.privacy'), name: 'privacy', icon: 'fa fa-user-lock' }, { title: this.$t('menu.AML'), name: 'AML', icon: 'fas fa-user-shield' }, { title: this.$t('menu.support'), name: 'userRequest', icon: 'far fa-question-circle' }]
								};
				},

				computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["darkMode", "themes", "selectedTheme", "user"]), {
								isLogin: function isLogin() {
												if (this.$store.state.user.token != null && this.$store.state.user.token != '') {
																return true;
												} else {
																return false;
												}
								}
				}),
				created: function created() {
								__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('NumFormat', function (value) {
												if (!value) return '0.00';
												var intPart = Number(value).toFixed(0);
												intPart = intPart > value ? intPart - 1 : intPart;
												var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
												var floatPart = ".00";
												var value2Array = value.split(".");

												if (value2Array.length == 2) {
																floatPart = value2Array[1].toString();
																if (floatPart.length == 1) {
																				return intPartFormat + "." + floatPart + '0';
																} else {
																				return intPartFormat + "." + floatPart;
																}
												} else {
																return intPartFormat + floatPart;
												}
								});
				},
				mounted: function mounted() {},

				watch: {
								darkModeModel: function darkModeModel(newVal, oldVal) {
												this.emitDarkMode(newVal);
								},
								languageModel: function languageModel(newVal, oldVal) {
												this.changeLanguage(newVal);
								}
				},
				methods: {
								goUserData: function goUserData() {
												this.$router.push({ name: 'userData', params: { username: '@' + this.$store.state.user.name } });
								},
								showLoginModal: function showLoginModal() {
												this.$store.state.loginModal = true;
								},
								logout: function logout() {
												localStorage.removeItem("SIP-user");
												localStorage.removeItem("SIP-role");
												localStorage.removeItem("userName");
												localStorage.removeItem("id");
												localStorage.removeItem("token");
												localStorage.removeItem("image");
												localStorage.removeItem("invitationCode");
												this.$store.state.user.id = null;
												this.$store.state.user.name = null;
												this.$store.state.user.token = null;
												this.$store.state.user.image = null;
												this.$router.push({ name: 'home' });
												this.$router.go();
								},
								routerPage: function routerPage(name) {
												switch (name) {
																case "myFeed":
																				this.goMyFeed();
																				break;
																case "profile":
																				this.goUserData();
																				break;
																case "userData":
																				this.goUserData();
																				break;
																case "follow":
																				this.goFollow();
																				break;
																case "wallet":
																				this.goWallet();
																				break;
																case "userSetting":
																				this.goUserSetting();
																				break;
																case "language":
																				this.changeLanguage();
																				break;
																case "signOut":
																				this.logout();
																				break;
																case "dark":
																				this.emitDarkMode();
																				break;
																case "home":
																				this.$router.push({ name: 'home' });
																				break;
																case "microArticles":
																				this.$router.push({ name: 'microArticles' });
																				break;
																case "searchUser":
																				__WEBPACK_IMPORTED_MODULE_4__assets_js_eventBus_js__["a" /* eventBus */].$emit('isShowUserSearchSidebar', true);
																				break;
																case "transaction":
																				this.$router.push({ name: 'transaction' });
																				break;
																case "userRequest":
																				this.$router.push({ name: 'userRequest' });
																				break;
																case "userRanking":
																				this.$router.push({ name: 'userRanking' });
																				break;
																case "GDPR":
																				this.$router.push({ name: 'GDPR' });
																				break;
																case "privacy":
																				this.$router.push({ name: 'privacy' });
																				break;
																case "AML":
																				this.$router.push({ name: 'AML' });
																				break;
																case "tags":
																				this.$router.push({ name: 'tags' });
																				break;
																default:
																				break;
												}
								},
								goMyFeed: function goMyFeed() {
												if (this.$store.state.user.token != null && this.$store.state.user.token != '') {
																this.$router.push({ name: 'feed', params: { username: '@' + this.$store.state.user.name } });
												} else {
																this.$store.state.loginModal = true;
												}
								},
								goWallet: function goWallet() {
												this.$router.push({ name: 'wallet' });
								},
								goUserSetting: function goUserSetting() {
												this.$router.push({ name: 'userSetting' });
								},
								goFollow: function goFollow() {
												this.$router.push({ name: 'follow', params: { username: '@' + this.$store.state.user.name } });
								},
								changeLanguage: function changeLanguage(locale) {
												var _this = this;

												if (this.$store.state.user.token) {
																var userInfo = { 'userId': this.$store.getters.user.userId, 'i18nCode': locale };
																var api = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + 'userDetail/updateI18n';
																this.$http.post(api, userInfo).then(function (response) {
																				var data = response.data;
																				if (data.resCode == 0) {
																								_this.$store.dispatch("localeHandler", data.result.code);
																								_this.$router.go();
																				}
																});
												} else {
																this.$store.dispatch("localeHandler", locale);
																this.$router.go();
												}
								},
								emitDarkMode: function emitDarkMode(darkMode) {
												if (this.$store.state.user.token) {
																var api = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + 'userRight/updateDarkMode?userId=' + this.$store.getters.user.userId + '&darkMode=' + darkMode;
																this.$http.get(api).then(function (response) {});
												}
												this.$store.dispatch("darkModeHandler", darkMode);
												localStorage.setItem('SIP-darkMode', darkMode ? 1 : 0);
								},
								changeTheme: function changeTheme(theme) {
												if (this.$store.state.user.token) {
																var api = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + 'userRight/updateColorStyle?userId=' + this.$store.getters.user.userId + '&colorStyle=' + theme.bgColor;
																this.$http.get(api).then(function (response) {});
												}
												this.$store.dispatch("changeThemeHandler", theme);
												this.$vuetify.theme = theme.theme;
												localStorage.setItem('SIP-colorStyle', theme.bgColor);
								}
				}
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tabname'],
  data: function data() {
    return {
      isShowAll: false,
      isShowUpward: false,
      tagList: [],
      allTagList: [],
      isShowAffixDiv: false,

      postingnewcommentsList: [],

      usernewcommentsList: [],

      priceMarketList: [],
      priceList: [],
      marketColumns: [{
        title: 'Name',
        key: 'symbol'
      }, {
        title: 'Price',
        key: 'price'
      }],
      bulletinBoardData: [{
        before: 'header.announcement.total',
        data: 0,
        after: 'header.announcement.usersAwardMsg'
      }, {
        before: 'header.announcement.total',
        data: 0,
        after: 'header.announcement.postsAwardMsg'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["pageTitle", "user", "marketsDesc", "marketsList"]), {
    isLogin: function isLogin() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != '') {
        return true;
      } else {
        return false;
      }
    }
  }),
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('NumFormat', function (value) {
      if (!value) return '0.00';
      var intPart = Number(value).toFixed(0);
      intPart = intPart > value ? intPart - 1 : intPart;
      var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      var floatPart = ".00";
      var value2Array = value.split(".");

      if (value2Array.length == 2) {
        floatPart = value2Array[1].toString();
        if (floatPart.length == 1) {
          return intPartFormat + "." + floatPart + '0';
        } else {
          return intPartFormat + "." + floatPart;
        }
      } else {
        return intPartFormat + floatPart;
      }
    });
  },
  mounted: function mounted() {
    this.getBulletinBoardData();

    this.getTags(20);
  },

  watch: {},
  methods: {
    findByTelegramList: function findByTelegramList() {
      this.$router.push({ name: 'telegramusermessages' });
    },
    gotoNewsTopic: function gotoNewsTopic() {
      this.$router.push({
        name: 'marketPosts',
        params: {
          marketsName: 'Industry News'
        }
      });
    },
    gotoRegister: function gotoRegister() {
      this.$store.state.loginModal = false;
      this.$router.push({ name: 'register' });
    },
    login: function login() {
      if (this.$store.state.user.token == null) {
        this.$store.state.loginModal = true;
      }
    },
    gotoHot: function gotoHot() {
      this.$router.push({ name: 'posts' });
      this.$store.dispatch("pageTitleHandler", 'hot');
    },
    gotoNew: function gotoNew() {
      this.$router.push({ name: 'posts' });
      this.$store.dispatch("pageTitleHandler", 'new');
    },
    getBulletinBoardData: function getBulletinBoardData() {
      var _this = this;

      var userApi = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + 'userDetail/open/count/totalAwardedIOBPower';
      this.$http.get(userApi).then(function (response) {
        _this.bulletinBoardData[0].data = response.data.result.toFixed(2);
      });
      var postApi = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + 'posting/open/count/totalAwardedIOBPower';
      this.$http.get(postApi).then(function (response) {
        _this.bulletinBoardData[1].data = response.data.result.toFixed(2);
      });
    },
    findByMarkets: function findByMarkets(market) {
      localStorage.setItem('SIP-marketsCode', market.code);
      localStorage.setItem('SIP-marketsTitle', market.name);
      this.$store.dispatch("marketsDescHandler", market.description);
      this.$router.push({
        name: 'marketPosts',
        params: {
          marketsName: market.name
        }
      });
    },
    goMyFeed: function goMyFeed() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != '') {
        this.$router.push({ name: 'feed', params: { username: '@' + this.$store.state.user.name } });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    findtagposting: function findtagposting(tagName) {
      if (tagName != null && tagName.trim() != '') {
        this.$router.push({ name: 'tagPosts', params: { "tagName": tagName } });
      }
    },
    getAllTagByHot: function getAllTagByHot() {
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "tag/open/getTags/hot").then(function (successData) {
        var data = successData.data.result;
        this.allTagList = data;
        if (data.length > 20) {
          for (var i = 0; i < 20; i++) {
            this.tagList = this.tagList.concat(data[i]);
          }
          this.isShowAll = true;
        } else {
          this.tagList = data;
        }
      });
    },
    getTags: function getTags(num) {
      var _this2 = this;

      var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + 'tag/open/getTagList/' + num;
      this.$http.get(url).then(function (res) {
        var data = res.data.result;
        _this2.tagList = data;
      });
    },
    goToTags: function goToTags() {
      this.$router.push({ name: 'tags' });
    },
    showAllTag: function showAllTag() {
      this.tagList = this.allTagList;
      this.isShowAll = false;
      this.isShowUpward = true;
    },
    upwardTag: function upwardTag() {
      this.tagList = [];
      for (var i = 0; i < 20; i++) {
        this.tagList = this.tagList.concat(this.allTagList[i]);
      }
      this.isShowAll = true;
      this.isShowUpward = false;
    },
    getNewComments: function getNewComments() {
      var _this3 = this;

      var userUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "comments/open/getNewComments";
      this.$http.get(userUrl).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this3.postingnewcommentsList = data.result.postingnewcommentsList;
          _this3.usernewcommentsList = data.result.usernewcommentsList;
        } else {
          _this3.postingnewcommentsList = [];
          _this3.usernewcommentsList = [];
        }
      });
    },
    goPrivacy: function goPrivacy() {
      this.$router.push({ name: 'privacy' });
    },
    goGDPR: function goGDPR() {
      this.$router.push({ name: 'GDPR' });
    },
    goAML: function goAML() {
      this.$router.push({ name: 'AML' });
    },
    goUserRequest: function goUserRequest() {
      this.$router.push({ name: 'userRequest' });
    },
    goAbout: function goAbout() {
      this.$router.push({ name: 'about' });
    },
    goPoet: function goPoet() {
      this.$router.push({ name: 'poet' });
    },
    goIr: function goIr() {
      this.$router.push({ name: 'investorrelations' });
    },
    goContact: function goContact() {
      this.$router.push({ name: 'contact' });
    },
    goFaq: function goFaq() {
      this.$router.push({ name: 'frequently-asked-questions' });
    },
    findsel: function findsel(commentsPostingId, commentsUserName) {
      this.$router.push({
        name: 'postingsel',
        params: {
          username: commentsUserName,
          postingId: commentsPostingId
        }
      });
    },
    goUserData: function goUserData() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != '') {
        this.$router.push({
          name: 'userData',
          params: { username: '@' + this.$store.state.user.name }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    goIobots: function goIobots() {
      window.open('https://iobots.pro/', '_blank');
    }
  }

});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isShowAll: false,
            isShowUpward: false,
            tagList: [],
            allTagList: [] };
    },
    created: function created() {},
    mounted: function mounted() {
        this.getAllTagByHot();
    },

    watch: {},
    methods: {
        getAllTagByHot: function getAllTagByHot() {
            this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "tag/open/getTags/hot").then(function (successData) {
                var data = successData.data.result;
                this.allTagList = data;
                if (data.length > 20) {
                    for (var i = 0; i < 20; i++) {
                        this.tagList = this.tagList.concat(data[i]);
                    }
                    this.isShowAll = true;
                } else {
                    this.tagList = data;
                }
            });
        },
        showAllTag: function showAllTag() {
            this.tagList = this.allTagList;
            this.isShowAll = false;
            this.isShowUpward = true;
        },
        upwardTag: function upwardTag() {
            this.tagList = [];
            for (var i = 0; i < 20; i++) {
                this.tagList = this.tagList.concat(this.allTagList[i]);
            }
            this.isShowAll = true;
            this.isShowUpward = false;
        },
        getPostsByTagName: function getPostsByTagName(tagName) {
            if (tagName != null && tagName.trim() != '') {
                this.$router.push({ name: 'marketPosts', params: { "tagName": tagName } });
            }
        }
    }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_eventBus_js__ = __webpack_require__(16);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			searchText: '',
			userDtoList: [],
			isNoData: false };
	},
	mounted: function mounted() {},

	methods: {
		goUserData: function goUserData(username) {
			this.$router.push({ name: 'userData', params: { username: '@' + username } });
		},
		searchUser: function searchUser() {
			var _this = this;

			if (this.searchText != null && this.searchText.trim() != '') {
				var url = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].baseUrl + "user/open/searchUserContaining/" + this.searchText;
				this.$http.get(url).then(function (response) {
					var data = response.data;
					if (data.resCode == 0) {
						_this.isNoData = false;
						_this.userDtoList = data.result;
					} else {
						_this.isNoData = true;
						_this.userDtoList = [];
					}
				}, function (error) {
					_this.isNoData = true;
					_this.userDtoList = [];
				});
			} else {
				this.isNoData = true;
				this.userDtoList = [];
			}
		}
	}
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VerificationCode',
    props: {
        identifyCode: {
            type: String,
            default: 'love'
        },
        fontSizeMin: {
            type: Number,
            default: 28
        },
        fontSizeMax: {
            type: Number,
            default: 36
        },
        backgroundColorMin: {
            type: Number,
            default: 200
        },
        backgroundColorMax: {
            type: Number,
            default: 255
        },
        colorMin: {
            type: Number,
            default: 0
        },
        colorMax: {
            type: Number,
            default: 0
        },
        lineColorMin: {
            type: Number,
            default: 0
        },
        lineColorMax: {
            type: Number,
            default: 50
        },
        dotColorMin: {
            type: Number,
            default: 0
        },
        dotColorMax: {
            type: Number,
            default: 255
        },
        contentWidth: {
            type: Number,
            default: 80
        },
        contentHeight: {
            type: Number,
            default: 40
        }
    },
    data: function data() {
        return {};
    },

    computed: {},
    created: function created() {},
    mounted: function mounted() {
        this.drawPic();
    },

    watch: {
        identifyCode: function identifyCode() {
            this.drawPic();
        }
    },
    methods: {
        randomNum: function randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        randomColor: function randomColor(min, max) {
            var r = this.randomNum(min, max);
            var g = this.randomNum(min, max);
            var b = this.randomNum(min, max);
            return 'rgb(' + r + ',' + g + ',' + b + ')';
        },
        drawPic: function drawPic() {
            var canvas = document.getElementById('s-canvas');
            var ctx = canvas.getContext('2d');
            ctx.textBaseline = 'bottom';

            ctx.fillStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax);
            ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);

            for (var i = 0; i < this.identifyCode.length; i++) {
                this.drawText(ctx, this.identifyCode[i], i);
            }
            this.drawLine(ctx);
            this.drawDot(ctx);
        },
        drawText: function drawText(ctx, txt, i) {
            ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax);
            ctx.font = this.randomNum(this.fontSizeMin, this.fontSizeMax) + 'px SimHei';
            var x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1));
            var y = this.randomNum(this.fontSizeMax, this.contentHeight - 5);
            var deg = this.randomNum(-15, 15);

            ctx.translate(x, y);
            ctx.rotate(deg * Math.PI / 180);
            ctx.fillText(txt, 0, 0);

            ctx.rotate(-deg * Math.PI / 180);
            ctx.translate(-x, -y);
        },
        drawLine: function drawLine(ctx) {
            for (var i = 0; i < 8; i++) {
                ctx.strokeStyle = this.randomColor(this.lineColorMin, this.lineColorMax);
                ctx.beginPath();
                ctx.moveTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight));
                ctx.lineTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight));
                ctx.stroke();
            }
        },
        drawDot: function drawDot(ctx) {
            for (var i = 0; i < 50; i++) {
                ctx.fillStyle = this.randomColor(0, 255);
                ctx.beginPath();
                ctx.arc(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight), 1, 0, 2 * Math.PI);
                ctx.fill();
            }
        }
    }

});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {

/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    components: {},
    props: {},
    data: function data() {
        return {
            beginClientX: 0,
            mouseMoveStata: false,
            maxwidth: 170,
            confirmWords: 'Drag slider validation' };
    },

    computed: {},
    created: function created() {},

    mounted: function mounted() {
        this.mouse();
    },
    watch: {},
    methods: {
        mousedownFn: function mousedownFn(e) {
            this.mouseMoveStata = true;
            this.beginClientX = e.clientX;
        },
        mouse: function mouse() {
            var _this = this;

            $('body').on('mousemove', function (e) {
                if (_this.mouseMoveStata) {
                    var width = e.clientX - _this.beginClientX;
                    if (width > 0 && width <= _this.maxwidth) {
                        $(".handler").css({ 'left': width });
                        $(".drag_bg").css({ 'width': width });
                    } else if (width > _this.maxwidth) {
                        _this.successFunction();
                    }
                }
            });

            $('body').on('mouseup', function (e) {
                _this.mouseMoveStata = false;
                var width = e.clientX - _this.beginClientX;
                if (width < _this.maxwidth) {
                    $(".handler").css({ 'left': 0 });
                    $(".drag_bg").css({ 'width': 0 });
                }
            });
        },
        successFunction: function successFunction() {
            $(".handler").removeClass('handler_bg').addClass('handler_ok_bg');
            this.confirmWords = 'Success';
            $(".drag").css({ 'color': '#fff' });
            $(".handler").css({ 'left': this.maxwidth });
            $(".drag_bg").css({ 'width': this.maxwidth });
            $('body').unbind('mousemove');
            $('body').unbind('mouseup');

            this.$store.state.verificationSuccess = true;
        },
        history: function history() {
            $(".handler").removeClass('handler_ok_bg').addClass('handler_bg');
            this.mouseMoveStata = true;
            this.beginClientX = 0;
            $(".handler").css({ 'left': 0 });
            $(".drag_bg").css({ 'width': 0 });
            this.confirmWords = 'Drag slider validation';
            $(".drag").css({ 'color': '#272727' });
            $(".drag").css({ 'background-color': '#e8e8e8' });
            this.mouse();
        }
    }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },
    created: function created() {},
    mounted: function mounted() {},

    watch: {},
    computed: {},
    methods: {}
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            domainName: __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].ip

        };
    },
    created: function created() {},
    mounted: function mounted() {},

    watch: {},
    methods: {}
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            domainName: __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].ip
        };
    },
    created: function created() {},
    mounted: function mounted() {},

    watch: {},
    methods: {}
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },
    created: function created() {},
    mounted: function mounted() {},

    watch: {},
    methods: {}
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            domainName: __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].ip
        };
    },
    created: function created() {},
    mounted: function mounted() {},

    watch: {},
    methods: {}
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            domainName: __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].ip

        };
    },
    created: function created() {},
    mounted: function mounted() {},

    watch: {},
    methods: {
        goUserRequest: function goUserRequest() {
            this.$router.push({ name: 'userRequest' });
        }
    }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {
    isLogin: function isLogin() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != "") {
        return true;
      } else {
        return false;
      }
    }
  },

  created: function created() {},

  mounted: function mounted() {},
  watch: {},
  methods: {}
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);


var _data$computed$comput;



/* harmony default export */ __webpack_exports__["default"] = (_data$computed$comput = {
  data: function data() {
    return {};
  },

  computed: {}
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$computed$comput, "computed", {
  isLogin: function isLogin() {
    if (this.$store.state.user.token != null && this.$store.state.user.token != "") {
      return true;
    } else {
      return false;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$computed$comput, "created", function created() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$computed$comput, "mounted", function mounted() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$computed$comput, "watch", {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$computed$comput, "methods", {}), _data$computed$comput);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);


var _data$computed$comput;



/* harmony default export */ __webpack_exports__["default"] = (_data$computed$comput = {
  data: function data() {
    return {};
  },

  computed: {}
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$computed$comput, "computed", {
  isLogin: function isLogin() {
    if (this.$store.state.user.token != null && this.$store.state.user.token != "") {
      return true;
    } else {
      return false;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$computed$comput, "created", function created() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$computed$comput, "mounted", function mounted() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$computed$comput, "watch", {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$computed$comput, "methods", {}), _data$computed$comput);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {
    isLogin: function isLogin() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != "") {
        return true;
      } else {
        return false;
      }
    }
  },
  created: function created() {},

  mounted: function mounted() {},
  watch: {},
  methods: {}
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    goHome: function goHome() {
      this.$router.push({ name: "home" });
      this.$router.go();
    }
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    goHome: function goHome() {
      this.$router.push({ name: "home" });
      this.$router.go();
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {
    isLogin: function isLogin() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != "") {
        return true;
      } else {
        return false;
      }
    }
  },
  created: function created() {},

  mounted: function mounted() {},
  watch: {},
  methods: {}
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            isShowLostHintMessage: true,
            isShowSendEmailForm: true,
            sendEmailValid: true,
            sendEmailForm: {
                regEmail: null,
                authenticationSecret: null
            },
            emailRules: [function (v) {
                return !!v || _this.$t("lostGoogleAuthentication.emailNotEmpty");
            }, function (v) {
                return (/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(v) || _this.$t("lostGoogleAuthentication.emailNotValid")
                );
            }],
            secretRules: [function (v) {
                return !!v || _this.$t("lostGoogleAuthentication.secretKeyNotEmpty");
            }, function (v) {
                return v && v.length == 16 || _this.$t("lostGoogleAuthentication.secretKeyNotValid");
            }]
        };
    },

    computed: {},
    created: function created() {},
    mounted: function mounted() {},

    watch: {},
    methods: {
        showLostHintMessage: function showLostHintMessage() {
            this.isShowLostHintMessage = !this.isShowLostHintMessage;
        },
        showSendEmailDiv: function showSendEmailDiv() {
            this.$refs.sendEmailForm.reset();
            this.isShowSendEmailForm = !this.isShowSendEmailForm;
        },
        sendEmail: function sendEmail() {
            var _this2 = this;

            if (this.$refs.sendEmailForm.validate()) {
                var sendEmailUrl = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "sendEmail/open/sendLostGoogleCodeEmail";
                this.$http.post(sendEmailUrl, this.sendEmailForm).then(function (response) {
                    var data = response.data;
                    if (data.resCode == 0) {
                        _this2.sendEmailValid = true;
                        _this2.$refs.sendEmailForm.reset();

                        _this2.$Message.success({
                            content: _this2.$t("lostGoogleAuthentication.sendEmailSuccess"),
                            duration: 3
                        });
                    } else if (data.resCode == -1) {
                        _this2.$Message.error({
                            content: _this2.$t("lostGoogleAuthentication.emailAddressNotExist"),
                            duration: 3
                        });
                    } else if (data.resCode == -2) {
                        _this2.$Message.error({
                            content: _this2.$t("lostGoogleAuthentication.secretKeyError"),
                            duration: 3
                        });
                    } else if (data.resCode == -10001) {}
                });
            }
        },
        goUserRequest: function goUserRequest() {
            this.$router.push({ name: 'userRequest' });
        }
    }

});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_infinite_loading__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: this.$route.params.username.substring(1),
      tabName: "posts",
      postsTabName: +new Date(),
      microArticlesTabName: +new Date(),
      isLoadingPostList: false,
      isLoadingMicroArticleList: false,
      postListPageNo: 0,
      microArticleListPageNo: 0,
      pageSize: 10,
      postList: [],
      postUserDetailList: [],
      postCommentList: [],
      postCommentUserList: [],
      microArticleInfoList: [],
      postingIds: [],
      microArticleIds: [],
      forwardModal: false,
      postUserImage: "",
      postTitle: "",
      postDate: "",
      postNickName: "",
      postUserName: "",
      formValidatezf: {
        postingUserforwardId: this.$store.state.user.id,
        postingId: "",
        postingForwardContext: ""
      },
      formCollection: {
        userId: "",
        postingId: ""
      },
      voteForm: {
        microArticleId: null,
        userId: null,
        status: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(["user"])),
  created: function created() {},
  mounted: function mounted() {},

  watch: {
    $route: function $route() {
      if (this.$route.params.username) {
        if (this.$route.params.username.indexOf("@") == 0) {
          this.username = this.$route.params.username.substring(1);
        } else {
          this.username = this.$route.params.username;
        }
      }
    },
    username: function username() {
      if (this.username) {
        this.changeUser();
      }
    }
  },
  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_6_vue_infinite_loading___default.a
  },
  methods: {
    changeUser: function changeUser() {
      this.postListPageNo = 0;
      this.microArticleListPageNo = 0;
      this.postList = [];
      this.postUserDetailList = [];
      this.postCommentList = [];
      this.postCommentUserList = [];
      this.microArticleInfoList = [];
      this.refreshPosts();
    },
    refreshData: function refreshData() {
      if ("posts" == this.tabName) {
        this.postList = [];
        this.postUserDetailList = [];
        this.postCommentList = [];
        this.postCommentUserList = [];
        this.postListPageNo = 0;
        this.refreshPosts();
      }
      if ("microArticles" == this.tabName) {
        this.microArticleInfoList = [];
        this.microArticleListPageNo = 0;
        this.refreshMicroArticles();
      }
    },
    refreshPosts: function refreshPosts() {
      this.tabName = "posts";
      this.postsTabName += 1;
    },
    refreshMicroArticles: function refreshMicroArticles() {
      this.tabName = "microArticles";
      this.microArticlesTabName += 1;
    },
    getPostList: function getPostList($state) {
      var _this = this;

      if (this.isLoadingPostList) {
        return;
      }
      this.isLoadingPostList = true;
      var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "posting/open/getPosts/userFeed/" + this.postListPageNo + "/" + this.pageSize + "/" + this.username;
      this.$http.get(url).then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          _this.postListPageNo += 1;
          _this.postList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.postList), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data.result.postingList));
          _this.postCommentList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.postCommentList), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data.result.postCommentsList));
          if (localStorage.getItem("token")) {
            _this.getUserActions(data.result.postingList);
          }
          var udList = data.result.userDetailList;
          var upList = data.result.commentsUserList;

          for (var i = 0; i < _this.postUserDetailList.length; i++) {
            for (var j = 0; j < udList.length; j++) {
              if (_this.postUserDetailList[i].userId == udList[j].userId) {
                udList.splice(j, 1);
              }
            }
          }
          for (var _i = 0; _i < _this.postCommentUserList.length; _i++) {
            for (var _j = 0; _j < upList.length; _j++) {
              if (_this.postCommentUserList[_i].userId == upList[_j].userId) {
                upList.splice(_j, 1);
              }
            }
          }
          _this.postUserDetailList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.postUserDetailList), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(udList));
          _this.postCommentUserList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.postCommentUserList), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(upList));
          _this.isLoadingPostList = false;
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    getMicroArticleInfoList: function getMicroArticleInfoList($state) {
      var _this2 = this;

      if (this.isLoadingMicroArticleList) {
        return;
      }
      this.isLoadingMicroArticleList = true;
      var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "microArticle/open/getFeedMicroArticleInfosByUser/" + this.microArticleListPageNo + "/" + this.pageSize + "/" + this.username;
      this.$http.get(url).then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          _this2.microArticleListPageNo += 1;
          _this2.microArticleInfoList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this2.microArticleInfoList), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data.result));
          $state.loaded();
          _this2.isLoadingMicroArticleList = false;
          if (localStorage.getItem("token")) {
            _this2.getVoteList(data.result);
          }
        } else {
          $state.complete();
        }
      });
    },
    getUserActions: function getUserActions(postList) {
      if (!localStorage.getItem("token")) {
        return;
      }
      for (var i = 0; i < postList.length; i++) {
        this.postingIds[i] = postList[i].postingId;
      }

      var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "posting/UserEvalutiongood/" + this.$store.state.user.id;
      this.$http.post(url, this.postingIds).then(function (successData) {
        var voteList = successData.data.result;
        for (var _i2 = 0; _i2 < postList.length; _i2++) {
          for (var j = 0; j < voteList.length; j++) {
            if (postList[_i2].postingId == voteList[j].postingId) {
              if (voteList[j].eStatus == "0") {
                postList[_i2].postingStatus = 0;
              }
              if (voteList[j].eStatus == "1") {
                postList[_i2].postingStatus = 1;
              }
            }
          }
        }
      });

      var collectionUrl = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "collection/getCollectionByUserIdAndPostingIds/" + this.$store.state.user.id;
      this.$http.post(collectionUrl, this.postingIds).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          var collectionList = data.result;

          for (var _i3 = 0; _i3 < postList.length; _i3++) {
            for (var j = 0; j < collectionList.length; j++) {
              if (postList[_i3].postingId == collectionList[j].postingId) {
                postList[_i3].postingCollection = 0;
              }
            }
          }
        }
      });
    },
    getVoteList: function getVoteList(microArticleList) {
      var _this3 = this;

      for (var i = 0; i < microArticleList.length; i++) {
        this.microArticleIds[i] = microArticleList[i].microArticleId;
      }
      var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "microArticle/getVoteList/" + this.$store.state.user.id;
      this.$http.post(url, this.microArticleIds).then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          var voteList = data.result;
          for (var _i4 = 0; _i4 < voteList.length; _i4++) {
            for (var j = 0; j < microArticleList.length; j++) {
              if (voteList[_i4].microArticleId == microArticleList[j].microArticleId) {
                if ("0" == voteList[_i4].status) {
                  microArticleList[j].isUpvote = true;
                }
              }
            }
          }
        }

        _this3.$forceUpdate();
      });
    },
    goUserData: function goUserData(username) {
      this.$router.push({
        name: "userData",
        params: {
          username: "@" + username
        }
      });
    },
    changesup: function changesup(obj) {
      if (localStorage.getItem("token")) {
        var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "posting/evaluationgood/" + obj.postingId;
        this.$http.get(url).then(function (successData) {
          var that = this;
          var data = successData.data;
          if (data.resCode == 0) {
            obj.postingGoodnums = data.result;
            obj.postingStatus = 0;
          } else if (data.resCode == -11) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 2
            });
          } else if (data.resCode == -1) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 2
            });
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    changesdown: function changesdown(obj) {
      if (localStorage.getItem("token")) {
        var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "posting/evaluationstep/" + obj.postingId;
        this.$http.get(url).then(function (successData) {
          var that = this;
          var data = successData.data;
          if (data.resCode == 0) {
            obj.postingStepnums = data.result;
            obj.postingStatus = 1;
          } else if (data.resCode == -1) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 1
            });
          } else if (data.resCode == -11) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 1
            });
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    postingforward: function postingforward() {
      var _this4 = this;

      var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "posting/forward";
      this.$http.post(url, this.formValidatezf).then(function (successData) {
        var data = successData.data;
        _this4.forwardModal = false;
        if (data.resCode == 0) {
          _this4.$Message.success({
            content: _this4.$t("posting.forwardMessage"),
            duration: 2
          });
          for (var i = 0; i < _this4.postList.length; i++) {
            if (_this4.postList[i].postingId == _this4.formValidatezf.postingId) {
              _this4.postList[i].postingCountForword = data.result;
              break;
            }
          }
          _this4.formValidatezf.postingId = "";
          _this4.formValidatezf.postingForwardContext = "";
        } else if (data.resCode == -1) {
          _this4.$Message.error({
            content: _this4.$t("common.fail"),
            duration: 2
          });
        }
      }, function (error) {
        _this4.forwardModal = false;
      });
    },
    modalzf: function modalzf(obj, user) {
      if (localStorage.getItem("token")) {
        this.formValidatezf.postingId = obj.postingId;
        this.formValidatezf.postingForwardContext = "";
        this.postUserImage = user.image;
        this.postTitle = obj.postingTitle;
        this.postDate = obj.postingTime;
        this.postUserName = user.userName;
        this.postNickName = user.nickName;
        this.forwardModal = true;
      } else {
        this.$store.state.loginModal = true;
      }
    },
    postingforwardCancel: function postingforwardCancel() {
      this.forwardModal = false;
    },
    collectionPosting: function collectionPosting(posting) {
      if (!localStorage.getItem("token")) {
        this.$store.state.loginModal = true;
        return;
      }
      this.formCollection.userId = this.$store.state.user.id;
      this.formCollection.postingId = posting.postingId;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "collection/saveCollectionPosting", this.formCollection).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          posting.postingCollection = 0;
        } else if (data.resCode == 1) {
          posting.postingCollection = -1;
        }
      });
    },
    findsel: function findsel(posting) {
      this.$router.push({
        name: "postingsel",
        params: {
          postingId: posting.postingId,
          username: posting.postingUserName
        }
      });
    },
    gotoMicroArticle: function gotoMicroArticle(microArticle) {
      sessionStorage.setItem("microArticle", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(microArticle));
      this.$router.push({
        name: "microArticle",
        params: {
          userName: "@" + microArticle.userName,
          microArticleId: microArticle.microArticleId
        }
      });
    },
    voteMicroArticle: function voteMicroArticle(microArticle, status) {
      var _this5 = this;

      if (!localStorage.getItem("token")) {
        this.$store.state.loginModal = true;
        return;
      }
      this.voteForm.microArticleId = microArticle.microArticleId;
      this.voteForm.userId = this.$store.state.user.id;
      this.voteForm.status = status;
      var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "microArticle/voteMicroArticle";
      this.$http.post(url, this.voteForm).then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          microArticle.isUpvote = true;
          microArticle.upvoteCount += 1;
        } else {
          _this5.$Message.warning(_this5.$t("posting.evaluation"));
        }
      }, function (error) {
        _this5.$Message.warning(_this5.$t("common.fail"));
      });
    },
    dateFormat: function dateFormat(time) {
      var timeOffset = -28800000;
      if (this.user) {
        timeOffset = this.user.timeOffset;
      }
      return formatDate(time, timeOffset, this.$i18n.locale);
    }
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            userName: this.$route.params.userName,
            microArticleId: this.$route.params.microArticleId,
            microArticle: {},
            loginUserName: this.$store.state.user.name,
            loginImage: this.$store.state.user.image,
            commentVaild: true,
            commentForm: {
                microArticleId: null,
                userId: this.$store.state.user.id,
                parentCommentId: null,
                content: ''
            },
            commentContentRules: [function (v) {
                return !!v || '';
            }, function (v) {
                return v && v.length <= 500 || _this.$t("microArticle.commentLimit");
            }],
            voteForm: {
                microArticleId: null,
                userId: null,
                status: null
            },
            commentVoteForm: {
                commentId: null,
                userId: null,
                status: null
            },
            isShowCommentForm: false,
            isShowMicroArticleLoading: true,
            isShowCommentLoading: true,
            submitBtnLoading: false,
            commentList: [],
            commentIds: [],
            microArticleIds: [],
            isUpvote: false,
            commentContent: '' };
    },
    created: function created() {},
    mounted: function mounted() {
        this.getMicroArticle();
    },

    watch: {
        $route: function $route() {
            if (this.$route.params.userName) {
                if (this.$route.params.userName.indexOf('@') == 0) {
                    this.userName = this.$route.params.userName.substring(1);
                } else {
                    this.userName = this.$route.params.userName;
                }
            }
            if (this.$route.params.microArticleId) {
                this.microArticleId = this.$route.params.microArticleId;
            }
        },
        microArticleId: function microArticleId() {
            if (this.microArticleId) {
                this.commentList = [];
                this.isShowCommentLoading = true;
                this.getMicroArticle();
            }
        }
    },
    methods: {
        getMicroArticle: function getMicroArticle() {
            var _this2 = this;

            if (this.microArticleId == null || this.microArticleId == '') {
                return;
            }
            this.isShowMicroArticleLoading = true;
            var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "microArticle/open/getMicroArticleInfo?microArticleId=" + this.microArticleId;
            this.$http.get(url).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this2.microArticle = data.result;
                    _this2.isShowMicroArticleLoading = false;
                    if (localStorage.getItem('token')) {
                        _this2.getVoteList();
                    }
                } else {
                    _this2.microArticle = {};
                    _this2.isShowMicroArticleLoading = false;
                    _this2.$router.push({ name: 'page404' });
                }
            }, function (error) {
                _this2.microArticle = {};
                _this2.isShowMicroArticleLoading = false;
                _this2.$router.push({ name: 'page500' });
            });
            this.getCommentsByMicroArticleId();
        },
        getCommentsByMicroArticleId: function getCommentsByMicroArticleId() {
            var _this3 = this;

            var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "microArticleComment/open/getCommentsByMicroArticleId?microArticleId=" + this.microArticleId;
            this.$http.get(url).then(function (response) {
                _this3.isShowCommentLoading = false;
                var data = response.data;
                if (data.resCode == 0) {
                    _this3.commentList = data.result;

                    if (localStorage.getItem('token')) {
                        _this3.getCommentVoteList();
                    }
                } else {
                    _this3.commentList = [];
                }
            }, function (error) {
                _this3.isShowCommentLoading = false;
            });
        },
        goUserData: function goUserData(username) {
            this.$router.push({
                name: 'userData',
                params: {
                    username: '@' + username
                }
            });
        },
        showLoginModal: function showLoginModal() {
            this.$store.state.loginModal = true;
        },
        dateFormat: function dateFormat(time) {
            return formatDate(time, this.$i18n.locale);
        },
        showCommentForm: function showCommentForm() {
            if (!localStorage.getItem('token')) {
                this.showLoginModal();
                return;
            }
            this.isShowCommentForm = !this.isShowCommentForm;
        },
        commentMicroArticle: function commentMicroArticle() {
            var _this4 = this;

            if (!localStorage.getItem('token')) {
                this.showLoginModal();
                return;
            }
            if (this.$refs.commentForm.validate()) {
                this.submitBtnLoading = true;
                this.commentForm.microArticleId = this.microArticleId;
                this.commentForm.userId = this.$store.state.user.id;
                var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "microArticleComment/saveComment";
                this.$http.post(url, this.commentForm).then(function (response) {
                    _this4.submitBtnLoading = false;
                    var data = response.data;
                    if (data.resCode == 0) {
                        _this4.microArticle.commentCount += 1;
                        _this4.isShowCommentForm = false;
                        _this4.commentForm.content = '';
                        _this4.commentList.unshift(data.result);
                    } else {
                        _this4.submitBtnLoading = false;
                        _this4.$Message.error(_this4.$t('common.fail'));
                    }
                }, function (error) {
                    _this4.submitBtnLoading = false;
                    _this4.$Message.error(_this4.$t('common.fail'));
                });
            }
        },
        voteMicroArticle: function voteMicroArticle(microArticle, status) {
            var _this5 = this;

            if (!localStorage.getItem('token')) {
                this.showLoginModal();
                return;
            }
            this.voteForm.microArticleId = microArticle.microArticleId;
            this.voteForm.userId = this.$store.state.user.id;
            this.voteForm.status = status;
            var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "microArticle/voteMicroArticle";
            this.$http.post(url, this.voteForm).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this5.isUpvote = true;
                    microArticle.upvoteCount += 1;
                } else {
                    _this5.$Message.warning(_this5.$t('posting.evaluation'));
                }
            }, function (error) {
                _this5.$Message.error(_this5.$t('common.fail'));
            });
        },
        voteMicroArticleComment: function voteMicroArticleComment(comment, status) {
            var _this6 = this;

            if (!localStorage.getItem('token')) {
                this.showLoginModal();
                return;
            }
            this.commentVoteForm.commentId = comment.commentId;
            this.commentVoteForm.userId = this.$store.state.user.id;
            this.commentVoteForm.status = status;
            var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "microArticleComment/voteMicroArticleComment";
            this.$http.post(url, this.commentVoteForm).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    comment.isUpvote = true;
                    comment.upvoteCount += 1;
                } else {
                    _this6.$Message.warning(_this6.$t('posting.evaluation'));
                }
            }, function (error) {
                _this6.$Message.error(_this6.$t('common.fail'));
            });
        },
        getVoteList: function getVoteList() {
            var _this7 = this;

            this.microArticleIds[0] = this.microArticleId;
            var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "microArticle/getVoteList/" + this.$store.state.user.id;
            this.$http.post(url, this.microArticleIds).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    if ('0' == data.result[0].status) {
                        _this7.isUpvote = true;
                    }
                } else {
                    _this7.isUpvote = false;
                }
            });
        },
        getCommentVoteList: function getCommentVoteList() {
            var _this8 = this;

            if (this.commentList.length <= 0) {
                return;
            }
            var count = 0;
            for (var i = 0; i < this.commentList.length; i++) {
                this.commentIds[count] = this.commentList[i].commentId;
                count++;
                if (this.commentList[i].secondCommentInfoList) {
                    var secondList = this.commentList[i].secondCommentInfoList;
                    for (var j = 0; j < secondList.length; j++) {
                        this.commentIds[count] = secondList[j].commentId;
                        count++;
                    }
                }
            }
            var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "microArticleComment/getCommentVoteList/" + this.$store.state.user.id;
            this.$http.post(url, this.commentIds).then(function (response) {
                var data = response.data;

                if (data.resCode == 0) {
                    for (var _i = 0; _i < data.result.length; _i++) {
                        for (var _j = 0; _j < _this8.commentList.length; _j++) {
                            if (data.result[_i].commentId == _this8.commentList[_j].commentId) {
                                if ('0' == data.result[_i].status) {
                                    _this8.commentList[_j].isUpvote = true;
                                }
                            } else if (_this8.commentList[_j].secondCommentInfoList != null) {
                                for (var k = 0; k < _this8.commentList[_j].secondCommentInfoList.length; k++) {
                                    if (data.result[_i].commentId == _this8.commentList[_j].secondCommentInfoList[k].commentId) {
                                        if ('0' == data.result[_i].status) {
                                            _this8.commentList[_j].secondCommentInfoList[k].isUpvote = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                _this8.$forceUpdate();
            });
        },
        showCommentField: function showCommentField(comment) {
            if (!localStorage.getItem('token')) {
                this.showLoginModal();
                return;
            }
            if (comment.isShowCommentField) {
                comment.isShowCommentField = false;
            } else {
                comment.isShowCommentField = true;
            }

            this.$forceUpdate();
        },
        commentRootComment: function commentRootComment(comment) {
            var _this9 = this;

            if (!localStorage.getItem('token')) {
                this.showLoginModal();
                return;
            }
            if (this.commentContent.trim() != '') {
                this.submitBtnLoading = true;
                this.commentForm.content = this.commentContent.trim();
                this.commentForm.microArticleId = this.microArticleId;
                this.commentForm.userId = this.$store.state.user.id;
                this.commentForm.parentCommentId = comment.commentId;
                var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "microArticleComment/saveComment";
                this.$http.post(url, this.commentForm).then(function (response) {
                    _this9.submitBtnLoading = false;
                    var data = response.data;
                    if (data.resCode == 0) {
                        _this9.commentForm.content = '';
                        _this9.commentContent = '';
                        comment.isShowCommentField = false;
                        if (comment.secondCommentInfoList) {
                            comment.secondCommentInfoList.unshift(data.result);
                        } else {
                            comment.secondCommentInfoList = new Array(data.result);
                        }
                    } else {
                        _this9.submitBtnLoading = false;
                        _this9.$Message.error(_this9.$t('common.fail'));
                    }
                }, function (error) {
                    _this9.submitBtnLoading = false;
                    _this9.$Message.error(_this9.$t('common.fail'));
                });
            } else {
                this.commentContent = '';
            }
        },
        commentSecondComment: function commentSecondComment(comment, secondComment) {
            var _this10 = this;

            if (!localStorage.getItem('token')) {
                this.showLoginModal();
                return;
            }
            if (this.commentContent.trim() != '') {
                this.submitBtnLoading = true;
                var userName = "<a href='" + __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].ip + "#/profile/@" + secondComment.userName + "'  style='color: #41B8BC;'>" + "@" + secondComment.userName + "</a>";
                this.commentForm.content = userName + " : " + this.commentContent.trim();
                this.commentForm.microArticleId = this.microArticleId;
                this.commentForm.userId = this.$store.state.user.id;
                this.commentForm.parentCommentId = comment.commentId;
                var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "microArticleComment/saveComment";
                this.$http.post(url, this.commentForm).then(function (response) {
                    _this10.submitBtnLoading = false;
                    var data = response.data;
                    if (data.resCode == 0) {
                        _this10.commentForm.content = '';
                        _this10.commentContent = '';
                        secondComment.isShowCommentField = false;
                        if (comment.secondCommentInfoList) {
                            comment.secondCommentInfoList.unshift(data.result);
                        } else {
                            comment.secondCommentInfoList = new Array(data.result);
                        }
                    } else {
                        _this10.submitBtnLoading = false;
                        _this10.$Message.error(_this10.$t('common.fail'));
                    }
                }, function (error) {
                    _this10.submitBtnLoading = false;
                    _this10.$Message.error(_this10.$t('common.fail'));
                });
            } else {
                this.commentContent = '';
            }
        }
    }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            tabName: 'hot',
            microArticleNewList: [],
            microArticleHotList: [],
            microArticleSearchList: [],
            microArticleVaild: true,
            microArticleForm: {
                userId: this.$store.state.user.id,
                content: '',
                isNewCreate: true
            },
            microArticleContentRules: [function (v) {
                return !!v || '';
            }, function (v) {
                return v && v.length <= 1000 || _this.$t('microArticles.contentLimit');
            }],
            voteForm: {
                microArticleId: null,
                userId: null,
                status: null
            },
            publishBtnLoading: false,
            availableContentLength: 1000,
            contentPercentage: 0,
            newListPageNo: 0,
            hotListPageNo: 0,
            searchPageNo: 0,
            searchText: '',
            isLoadingNewList: false,
            isLoadingHotList: false,
            isLoadingSearchList: false,
            isShowSearchField: false,
            microArticleIds: [] };
    },
    created: function created() {},
    mounted: function mounted() {},

    watch: {},
    components: {
        InfiniteLoading: __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default.a
    },
    methods: {
        getMicroArticleNewList: function getMicroArticleNewList($state) {
            var _this2 = this;

            if (this.isLoadingNewList) {
                return;
            }
            this.isLoadingNewList = true;
            var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "microArticle/open/getMicroArticle/" + this.newListPageNo + "/5/new";
            this.$http.get(url).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this2.newListPageNo += 1;
                    _this2.microArticleNewList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.microArticleNewList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result));
                    $state.loaded();
                    _this2.isLoadingNewList = false;
                    if (localStorage.getItem('token')) {
                        _this2.getVoteList(data.result);
                    }
                } else {
                    $state.complete();
                }
            });
        },
        getMicroArticleHotList: function getMicroArticleHotList($state) {
            var _this3 = this;

            if (this.isLoadingHotList) {
                return;
            }
            this.isLoadingHotList = true;
            var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "microArticle/open/getMicroArticle/" + this.hotListPageNo + "/5/hot";
            this.$http.get(url).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this3.hotListPageNo += 1;
                    _this3.microArticleHotList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this3.microArticleHotList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result));
                    $state.loaded();
                    _this3.isLoadingHotList = false;
                    if (localStorage.getItem('token')) {
                        _this3.getVoteList(data.result);
                    }
                } else {
                    $state.complete();
                }
            });
        },
        getMicroArticleSearchList: function getMicroArticleSearchList($state) {
            var _this4 = this;

            if (this.searchText == null || this.searchText.trim() == 0) {
                return;
            }
            this.isLoadingsearchList = true;
            var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "microArticle/open/searchMicroArticle/" + this.searchPageNo + "/5/" + this.searchText;
            this.$http.get(url).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this4.searchPageNo += 1;
                    _this4.microArticleSearchList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this4.microArticleSearchList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result));
                    $state.loaded();
                    _this4.isLoadingsearchList = false;
                } else {
                    $state.complete();
                }
            }, function (error) {});
        },
        createMicroArticle: function createMicroArticle() {
            var _this5 = this;

            if (!localStorage.getItem('token')) {
                this.$store.state.loginModal = true;
                return;
            }
            if (this.$refs.microArticleForm.validate()) {
                var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "microArticle/saveMicroArticle";
                this.publishBtnLoading = true;
                this.microArticleForm.userId = this.$store.state.user.id;
                this.microArticleForm.isNewCreate = true;
                this.$http.post(url, this.microArticleForm).then(function (response) {
                    var data = response.data;
                    _this5.publishBtnLoading = false;
                    if (data.resCode == 0) {
                        _this5.microArticleForm.content = '';
                        _this5.availableContentLength = 1000;
                        _this5.contentPercentage = 0;
                        _this5.gotoMicroArticle(data.result);
                    }
                }, function (error) {
                    _this5.publishBtnLoading = false;
                    _this5.$Message.error(_this5.$t('common.fail'));
                });
            }
        },
        goUserData: function goUserData(username) {
            this.$router.push({
                name: 'userData',
                params: {
                    username: '@' + username
                }
            });
        },
        gotoMicroArticle: function gotoMicroArticle(microArticle) {
            this.$router.push({
                name: 'microArticle',
                params: {
                    userName: '@' + microArticle.userName,
                    microArticleId: microArticle.microArticleId
                }
            });
        },
        changeContent: function changeContent() {
            var contectLength = this.microArticleForm.content.length;
            this.availableContentLength = 1000 - contectLength;
            this.contentPercentage = contectLength / 10;
        },
        voteMicroArticle: function voteMicroArticle(microArticle, status) {
            var _this6 = this;

            if (!localStorage.getItem('token')) {
                this.$store.state.loginModal = true;
                return;
            }
            this.voteForm.microArticleId = microArticle.microArticleId;
            this.voteForm.userId = this.$store.state.user.id;
            this.voteForm.status = status;
            var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "microArticle/voteMicroArticle";
            this.$http.post(url, this.voteForm).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    microArticle.isUpvote = true;
                    microArticle.upvoteCount += 1;
                } else {
                    _this6.$Message.warning(_this6.$t('posting.evaluation'));
                }
            }, function (error) {
                _this6.$Message.warning(_this6.$t('common.fail'));
            });
        },
        getVoteList: function getVoteList(microArticleList) {
            var _this7 = this;

            for (var i = 0; i < microArticleList.length; i++) {
                this.microArticleIds[i] = microArticleList[i].microArticleId;
            }
            var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "microArticle/getVoteList/" + this.$store.state.user.id;
            this.$http.post(url, this.microArticleIds).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    var voteList = data.result;
                    for (var _i = 0; _i < voteList.length; _i++) {
                        for (var j = 0; j < microArticleList.length; j++) {
                            if (voteList[_i].microArticleId == microArticleList[j].microArticleId) {
                                if ('0' == voteList[_i].status) {
                                    microArticleList[j].isUpvote = true;
                                }
                            }
                        }
                    }
                }

                _this7.$forceUpdate();
            });
        },
        dateFormat: function dateFormat(time) {
            return formatDate(time, this.$i18n.locale);
        }
    }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_quill_editor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_js_quill_config_js__ = __webpack_require__(178);















/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      tagNameArray: [],
      postLoading: false,
      tagName: "",
      marketList: [],
      selectedMarket: {},
      userFollowList: [],
      atUserDialog: false,
      imageLinkDialog: false,
      imageLink: null,
      uploadFileLoading: null,
      uploadUrl: __WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].baseUrl + "posting/uploadHeadPortrait",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token")
      },
      quillEditorScrollHeight: 0,
      quillEditorScrollTop: 0,
      editorOption: __WEBPACK_IMPORTED_MODULE_12__assets_js_quill_config_js__["a" /* default */],
      credentials: true,
      imgurl: "",
      file: null,
      videoUrl: null,
      isShowResetDialog: false,
      isShowMarketListDialog: false,
      isShowInsertVideoDialog: false,
      previewPostDialog: false,
      titleRules: [function (v) {
        return !!v || _this.$t("postingcreate.Title");
      }],
      originalLinkRules: [function (v) {
        return !!v || _this.$t("postingcreate.rules.originalLink.label");
      }, function (v) {
        return (/^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/.test(v) || _this.$t("postingcreate.rules.originalLink.incorrect")
        );
      }],
      formValidate: {
        postingId: null,
        postingTitle: "",
        postingContent: "",
        postingImg: "",
        postingUserId: this.$store.state.user.id,
        postingUserName: this.$store.state.user.name,
        marketId: null,
        isOriginal: false,
        originalLink: null,
        postingStatus: -1 },
      isDisabledOriginalBtn: false,
      isAgreeOriginalTerms: true,
      uploadImageApi: '',
      uploadFileApi: __WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].baseUrl + 'upload/file',
      ruleValidate: {
        postingTitle: [{
          required: true,
          message: this.$t("postingcreate.postingTitle.message"),
          trigger: "blur"
        }],
        postingContent: [{
          required: true,
          message: this.$t("postingcreate.postingContent.message"),
          trigger: "blur"
        }, {
          type: "string",
          min: 20,
          message: this.$t("postingcreate.postingContent.messageless"),
          trigger: "blur"
        }],
        marketId: [{
          required: true,
          message: this.$t("postingcreate.market.message"),
          trigger: "click"
        }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapGetters */])(["user", "darkMode", "marketsList"]), {
    editor: function editor() {
      return this.$refs.myQuillEditor.quill;
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_12__assets_js_quill_config_js__["a" /* default */].initAtButton();
    __WEBPACK_IMPORTED_MODULE_12__assets_js_quill_config_js__["a" /* default */].initImageLinkButton();
    __WEBPACK_IMPORTED_MODULE_12__assets_js_quill_config_js__["a" /* default */].initUploadFileButton();
    this.getMarkets();
    this.loadPostCache();
    this.customizeLinkBlot();

    $(".ql-at").click(function (data) {
      _this2.userfollowShow();
    });

    $(".ql-image-link").click(function (data) {
      _this2.imageLinkDialog = true;
    });
  },

  watch: {
    $route: function $route(to, from) {
      if ("/post/create" == to.path) {
        this.loadPostCache();
      } else if ("/post/create" == from.path) {
        this.savePostCache();
      }
    },

    selectedMarket: {
      handler: function handler(newVal, oldVal) {
        if ('industrynews' == newVal.code) {
          this.formValidate.isOriginal = false;
          this.isDisabledOriginalBtn = true;
        } else {
          this.isDisabledOriginalBtn = false;
        }
      },

      deep: true
    }

  },
  methods: {
    onEditorReady: function onEditorReady(editor) {},
    onEditorBlur: function onEditorBlur(editor) {
      this.savePostCache();
    },
    onEditorFocus: function onEditorFocus(editor) {
      this.savePostCache();
    },
    onEditorChange: function onEditorChange(_ref) {
      var editor = _ref.editor,
          html = _ref.html,
          text = _ref.text;

      this.savePostCache();
    },
    getMarkets: function getMarkets() {
      var _this3 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].baseUrl + "market/open/getMarkets").then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          for (var i = 0; i < data.result.length; i++) {
            if ("industrynews" == data.result[i].code) {
              _this3.selectedMarket = data.result[i];
              _this3.formValidate.marketId = _this3.selectedMarket.marketId;
              break;
            }
          }
          var flag = true;
          var role = _this3.$store.getters.role;
          if (role != null && role.roleCode != null && role.roleCode != "USER") {
            flag = false;
          }
          if (flag) {
            for (var _i = 0; _i < data.result.length; _i++) {
              if ("cheatalerts" == data.result[_i].code) {
                data.result.splice(_i, 1);
                break;
              }
            }
          }
          _this3.marketList = data.result;
        } else {
          _this3.marketList = [];
        }
      });
    },
    uploadImageBefore: function uploadImageBefore(file) {
      var loading = this.$Message.loading({
        content: this.$t("userSetting.uploading"),
        duration: 0
      });
      var fileData = new FormData();
      var url = __WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].baseUrl + 'posting/image/upload';
      var that = this;
      photoCompress(file, { quality: 0.5 }, function (base64Codes) {
        var blob = convertBase64UrlToBlob(base64Codes);

        fileData.append('upfile', blob, file.name);
        that.$http.post(url, fileData).then(function (response) {
          var data = response.data;
          if (data.resCode == 0) {
            var quill = that.$refs.myQuillEditor.quill;

            var length = quill.getSelection().index;

            quill.insertEmbed(length, 'image', data.result);

            quill.setSelection(length + 1);
          }
          setTimeout(loading, 500);
        }, function (error) {
          setTimeout(loading, 0);
          that.$Message.error(that.$t("common.fail"));
        });
      });
      return false;
    },
    customizeLinkBlot: function customizeLinkBlot() {
      var Quill = __webpack_require__(85);
      var Link = Quill.import('formats/link');

      var FileBlot = function (_Link) {
        __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(FileBlot, _Link);

        function FileBlot() {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FileBlot);

          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FileBlot.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(FileBlot)).apply(this, arguments));
        }

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(FileBlot, null, [{
          key: "create",
          value: function create(value) {
            var node = undefined;
            if (value && !value.href) {
              node = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(FileBlot.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(FileBlot), "create", this).call(this, value);
            } else {
              node = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(FileBlot.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(FileBlot), "create", this).call(this, value.href);

              node.innerText = value.innerText;
            }
            return node;
          }
        }]);

        return FileBlot;
      }(Link);

      FileBlot.blotName = 'link';
      FileBlot.tagName = 'A';
      Quill.register(FileBlot);
    },
    uploadFileBefore: function uploadFileBefore() {
      var uploadFileLoading = this.$Message.loading({
        content: this.$t("userSetting.uploading"),
        duration: 0
      });
      this.uploadFileLoading = uploadFileLoading;
    },
    uploadFileSuccess: function uploadFileSuccess(data) {
      if (data.resCode == 0) {
        var fileUrl = data.result;
        var fileName = fileUrl.substring(fileUrl.lastIndexOf("/") + 1, fileUrl.length);

        var quill = this.$refs.myQuillEditor.quill;

        var length = quill.selection.savedRange.index;
        var text = ' [Source: ' + fileUrl + '] ';

        quill.insertEmbed(length, 'text', text);
        quill.insertEmbed(length, 'link', { href: fileUrl, innerText: fileName }, "api");

        quill.setSelection(length + text.length + fileName.length);
      } else {
        this.$Message.error(this.$t("common.fail"));
      }
      setTimeout(this.uploadFileLoading, 0);
    },
    insertImageLink: function insertImageLink() {
      var quill = this.$refs.myQuillEditor.quill;

      var length = quill.selection.savedRange.index;

      quill.insertEmbed(length, 'image', this.imageLink);
      this.imageLink = null;

      quill.setSelection(length + 1);
      this.imageLinkDialog = false;
    },
    selectMarket: function selectMarket(market) {
      this.formValidate.marketId = market.marketId;
      this.selectedMarket = market;
      this.isShowMarketListDialog = !this.isShowMarketListDialog;
    },
    userfollowShow: function userfollowShow() {
      var _this5 = this;

      this.atUserDialog = true;
      var url = __WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].baseUrl + "follow/open/getFollowingUserDtoByUserId/" + this.user.userId;
      this.$http.get(url).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this5.userFollowList = data.result;
        } else {
          _this5.userFollowList = [];
        }
      });
    },
    userfollowing: function userfollowing(userfollow) {
      var userName = "&nbsp; <a href='" + __WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].ip + "#/user/profile/@" + userfollow.userName + "'  class='primary--text'>" + "@" + userfollow.userName + "</a>&nbsp; ";
      this.formValidate.postingContent = this.formValidate.postingContent + userName;
      var quill = this.$refs.myQuillEditor.quill;
      var length = quill.selection.savedRange.index;
      quill.insertEmbed(length, 'text', ' ');
      quill.insertEmbed(length, 'link', { href: __WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].ip + "#/user/profile/@" + userfollow.userName, innerText: "@" + userfollow.userName }, "api");
      quill.setSelection(length + userfollow.userName.length + 1);
      this.atUserDialog = false;
    },
    tagchange: function tagchange() {
      var rule = /^[a-zA-Z0-9, ]*$/;

      if (!rule.test(this.tagName)) {
        document.getElementById("tagruleValidate").innerText = this.$t("postingcreate.message.rule");
        return false;
      }

      if (this.tagName.indexOf(",") != -1) {
        this.tagNameArray = this.tagName.split(",");
        for (var i = 0; i < this.tagNameArray.length; i++) {
          if (this.tagNameArray[i].indexOf("，") != -1) {
            var array = this.tagNameArray[i].split("，");
            this.tagNameArray.splice(i, 1);
            for (var j = 0; j < array.length; j++) {
              this.tagNameArray.splice(i, 0, array[j]);
            }
          }
        }
      } else if (this.tagName.indexOf("，") != -1) {
        this.tagNameArray = this.tagName.split("，");
      } else {
        this.tagNameArray = [];
        if (this.tagName != "") {
          this.tagNameArray[0] = this.tagName;
        }
      }

      for (var index in this.tagNameArray) {
        if (this.tagNameArray[index].length > 24) {
          document.getElementById("tagruleValidate").innerText = this.$t("postingcreate.message.tagNameLength");
          return false;
        }
      }

      if (this.tagNameArray.length > 5) {
        document.getElementById("tagruleValidate").innerText = this.$t("postingcreate.message.length");
        this.tagNameArray = this.tagNameArray.slice(0, 5);
        return false;
      } else {
        document.getElementById("tagruleValidate").innerText = "";
        localStorage.setItem("SIP-tagName", this.tagName);
        return true;
      }
    },
    handleSubmit: function handleSubmit() {
      var _this6 = this;

      if (localStorage.getItem("token")) {
        if (this.user.userName != 'iob_official' && this.user.userName != 'longnshort' && this.user.userName != 'louis' && this.user.userName != 'shirley' && this.user.userName != 'Fred' && this.user.userName != 'KateL' && this.user.userName != 'renlywen') {
          this.$Notice.error({
            title: this.$t('postingcreate.notification'),
            desc: this.$t('postingcreate.cannotPostMessage'),
            duration: 5
          });
          return;
        }
        if (this.$refs["formValidate"].validate()) {
          if (this.formValidate.postingContent == "") {
            return;
          }
          if (this.formValidate.marketId == null) {
            return;
          }
          var flag = this.tagchange();
          if (!flag) {
            return;
          }
          if (this.formValidate.isOriginal) {
            if (this.isAgreeOriginalTerms) {
              this.formValidate.originalLink = null;
            } else {
              return;
            }
          }
          this.postLoading = true;
          var url = __WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].baseUrl + "posting/create?tagName=" + this.tagNameArray;
          this.$http.post(url, this.formValidate, this.tagName).then(function (successData) {
            var data = successData.data;
            if (data.resCode == 0) {
              _this6.postLoading = false;
              _this6.handleReset();
              _this6.previewPostDialog = false;
              _this6.goPostingsel(data.result.postingId, data.result.postingUserName);
            } else {
              _this6.postLoading = false;
              _this6.$Message.error(_this6.$t("common.fail"));
            }
          }, function (errorData) {
            _this6.postLoading = false;
          });
        } else {
          this.postLoading = false;
        }
      } else {
        this.postLoading = false;
        this.$store.state.loginModal = true;
      }
    },
    handleReset: function handleReset() {
      this.formValidate.postingTitle = "";
      this.formValidate.postingContent = "";
      this.formValidate.postingStatus = -1;
      this.formValidate.postingId = null;
      this.formValidate.marketId = null;
      this.formValidate.isOriginal = false;
      this.formValidate.originalLink = null;
      this.isAgreeOriginalTerms = false;
      this.selectedMarket = {};
      this.tagNameArray = [];
      this.tagName = "";
      this.postLoading = false;
      this.isShowResetDialog = false;
    },
    goPostingsel: function goPostingsel(postingId, username) {
      this.$router.push({
        name: "postingsel",
        params: {
          username: username,
          postingId: postingId
        }
      });
    },
    savePostCache: function savePostCache() {
      localStorage.setItem("SIP-editPost", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formValidate));
      localStorage.setItem("SIP-tagName", this.tagName);
    },
    loadPostCache: function loadPostCache() {
      var editPost = JSON.parse(localStorage.getItem("SIP-editPost"));
      if (editPost) {
        this.formValidate.postingId = editPost.postingId;
        this.formValidate.postingTitle = editPost.postingTitle;
        this.formValidate.postingContent = editPost.postingContent;
        this.formValidate.isOriginal = editPost.isOriginal;
        this.formValidate.originalLink = editPost.originalLink;
        this.formValidate.postingStatus = -1;
        if (this.formValidate.postingId) {
          this.formValidate.postingStatus = 0;
        }
        this.formValidate.marketId = editPost.marketId;
        if (this.formValidate.marketId) {
          for (var j = 0; j < this.marketsList.length; j++) {
            if (this.marketsList[j].marketId == this.formValidate.marketId) {
              this.selectedMarket = this.marketsList[j];
              break;
            } else {
              this.selectedMarket = {};
            }
          }
        }
        var tagName = localStorage.getItem("SIP-tagName");
        if (!tagName) {
          tagName = "";
          var tagList = editPost.tagList;
          if (tagList != null && tagList != "") {
            for (var i = 0; i < tagList.length; i++) {
              if (i == 0) {
                tagName += tagList[i].tagName;
              } else {
                tagName += "," + tagList[i].tagName;
              }
            }
          }
        }
        this.tagName = tagName;
        this.tagchange();
      }
    },
    dateFormat: function dateFormat(time) {
      var timeOffset = -28800000;
      if (this.user) {
        timeOffset = this.user.timeOffset;
      }
      return formatDate(time, timeOffset, this.$i18n.locale);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      marketsName: this.$route.params.marketsName,
      tabs: null,
      marketCode: null,
      timestamp: +new Date(),
      tagName: null,
      isShowSelectTag: true,
      isLoadingList: false,
      loadTimes: 0,
      pageNo: 0,
      pageSize: 10,
      postList: [],
      userDetailList: [],
      commentList: [],
      commentUserDetailList: [],
      postingIds: [],
      forwardModal: false,
      postUserImage: "",
      postTitle: "",
      postDate: "",
      postNickName: "",
      postUserName: "",
      formValidatezf: {
        postingUserforwardId: this.$store.state.user.id,
        postingId: "",
        postingForwardContext: ""
      },
      formCollection: {
        userId: "",
        postingId: ""
      },
      marketList: [],
      isShowAll: false,
      isShowUpward: false,
      tagList: [],
      allTagList: [] };
  },
  created: function created() {},

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(["user"]), {
    isLogin: function isLogin() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != "") {
        return true;
      } else {
        return false;
      }
    }
  }),
  mounted: function mounted() {
    this.getAllTagByHot();
    this.getMarkets();
  },

  watch: {
    $route: function $route() {
      if (this.$route.params.marketsName) {
        this.marketsName = this.$route.params.marketsName;
      }
    },
    marketsName: function marketsName() {
      if (this.marketsName != null) {
        this.refreshPosts();
      }
    },
    tagName: function tagName() {
      this.refreshPosts();
    }
  },
  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
  },
  methods: {
    getPostList: function getPostList($state) {
      var _this = this;

      this.marketCode = this.marketsName.replace(" ", "").toLowerCase();
      if (this.isLoadingList) {
        return;
      }
      if (!this.marketCode) {
        return;
      }
      this.isLoadingList = true;
      var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "posting/open/getPosts/market/" + this.pageNo + "/" + this.pageSize + "/" + this.marketCode;
      if (this.tagName) {
        url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "posting/open/getPosts/market/tag/" + this.pageNo + "/" + this.pageSize + "/" + this.marketCode + "/" + this.tagName;
      }
      this.$http.get(url).then(function (response) {
        var data = response.data;
        _this.loadTimes += 1;
        _this.isLoadingList = false;
        if (data.resCode == 0) {
          var result = data.result;
          _this.pageNo += 1;
          _this.postList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.postList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(result.postList));
          _this.commentList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.commentList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(result.commentList));
          if (localStorage.getItem("token")) {
            _this.getUserActions(result.postList);
          }
          var udList = result.userDetailList;
          var cudList = result.commentUserDetailList;

          for (var i = 0; i < _this.userDetailList.length; i++) {
            for (var j = 0; j < udList.length; j++) {
              if (_this.userDetailList[i].userId == udList[j].userId) {
                udList.splice(j, 1);
              }
            }
          }
          for (var _i = 0; _i < _this.commentUserDetailList.length; _i++) {
            for (var _j = 0; _j < cudList.length; _j++) {
              if (_this.commentUserDetailList[_i].userId == cudList[_j].userId) {
                cudList.splice(_j, 1);
              }
            }
          }
          _this.userDetailList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.userDetailList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(udList));
          _this.commentUserDetailList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.commentUserDetailList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(cudList));
          $state.loaded();
        } else {
          $state.complete();
        }
        if (_this.loadTimes == 1) {
          _this.timestamp = +new Date();
        }
      });
    },
    refreshPosts: function refreshPosts() {
      this.postList = [];
      this.userDetailList = [];
      this.commentList = [];
      this.commentUserDetailList = [];
      this.pageNo = 0;
      this.loadTimes = 0;
      this.timestamp = +new Date();
    },
    getMarkets: function getMarkets() {
      var _this2 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "market/open/getMarkets").then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          _this2.marketList = data.result;
        } else {
          _this2.marketList = [];
        }
      });
    },
    getUserActions: function getUserActions(postList) {
      if (!localStorage.getItem("token")) {
        return;
      }
      for (var i = 0; i < postList.length; i++) {
        this.postingIds[i] = postList[i].postingId;
      }

      var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "posting/UserEvalutiongood/" + this.$store.state.user.id;
      this.$http.post(url, this.postingIds).then(function (successData) {
        var voteList = successData.data.result;
        for (var _i2 = 0; _i2 < postList.length; _i2++) {
          for (var j = 0; j < voteList.length; j++) {
            if (postList[_i2].postingId == voteList[j].postingId) {
              if (voteList[j].eStatus == "0") {
                postList[_i2].postingStatus = 0;
              }
              if (voteList[j].eStatus == "1") {
                postList[_i2].postingStatus = 1;
              }
            }
          }
        }
      });

      var collectionUrl = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "collection/getCollectionByUserIdAndPostingIds/" + this.$store.state.user.id;
      this.$http.post(collectionUrl, this.postingIds).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          var collectionList = data.result;

          for (var _i3 = 0; _i3 < postList.length; _i3++) {
            for (var j = 0; j < collectionList.length; j++) {
              if (postList[_i3].postingId == collectionList[j].postingId) {
                postList[_i3].postingCollection = 0;
              }
            }
          }
        }
      });
    },
    goUserData: function goUserData(username) {
      this.$router.push({
        name: "userData",
        params: {
          username: "@" + username
        }
      });
    },
    changesup: function changesup(obj) {
      if (localStorage.getItem("token")) {
        var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "posting/evaluationgood/" + obj.postingId;
        this.$http.get(url).then(function (successData) {
          var that = this;
          var data = successData.data;
          if (data.resCode == 0) {
            obj.postingGoodnums = data.result;
            obj.postingStatus = 0;
          } else if (data.resCode == -11) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 2
            });
          } else if (data.resCode == -1) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 2
            });
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    changesdown: function changesdown(obj) {
      if (localStorage.getItem("token")) {
        var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "posting/evaluationstep/" + obj.postingId;
        this.$http.get(url).then(function (successData) {
          var that = this;
          var data = successData.data;
          if (data.resCode == 0) {
            obj.postingStepnums = data.result;
            obj.postingStatus = 1;
          } else if (data.resCode == -1) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 1
            });
          } else if (data.resCode == -11) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 1
            });
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    postingforward: function postingforward() {
      var _this3 = this;

      var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "posting/forward";
      this.$http.post(url, this.formValidatezf).then(function (successData) {
        var data = successData.data;
        _this3.forwardModal = false;
        if (data.resCode == 0) {
          _this3.$Message.success({
            content: _this3.$t("posting.forwardMessage"),
            duration: 2
          });
          for (var i = 0; i < _this3.posting.length; i++) {
            if (_this3.posting[i].postingId == _this3.formValidatezf.postingId) {
              _this3.posting[i].postingCountForword = data.result;
              break;
            }
          }
          _this3.formValidatezf.postingId = "";
          _this3.formValidatezf.postingForwardContext = "";
        } else if (data.resCode == -1) {
          _this3.$Message.error({
            content: _this3.$t("common.fail"),
            duration: 2
          });
        }
      }, function (error) {
        _this3.forwardModal = false;
      });
    },
    modalzf: function modalzf(obj, user) {
      if (localStorage.getItem("token")) {
        this.formValidatezf.postingId = obj.postingId;
        this.formValidatezf.postingForwardContext = "";
        this.postUserImage = user.image;
        this.postTitle = obj.postingTitle;
        this.postDate = obj.postingTime;
        this.postUserName = user.userName;
        this.postNickName = user.nickName;
        this.forwardModal = true;
      } else {
        this.$store.state.loginModal = true;
      }
    },
    postingforwardCancel: function postingforwardCancel() {
      this.forwardModal = false;
    },
    collectionPosting: function collectionPosting(posting) {
      if (!localStorage.getItem("token")) {
        this.$store.state.loginModal = true;
        return;
      }
      this.formCollection.userId = this.$store.state.user.id;
      this.formCollection.postingId = posting.postingId;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "collection/saveCollectionPosting", this.formCollection).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          posting.postingCollection = 0;
        } else if (data.resCode == 1) {
          posting.postingCollection = -1;
        }
      });
    },
    findsel: function findsel(posting) {
      this.$router.push({
        name: "postingsel",
        params: {
          postingId: posting.postingId,
          username: posting.postingUserName
        }
      });
    },
    getAllTagByHot: function getAllTagByHot() {
      var _this4 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "tag/open/getTags/hot").then(function (successData) {
        var data = successData.data.result;
        _this4.allTagList = data;
        if (data.length > 20) {
          for (var i = 0; i < 20; i++) {
            _this4.tagList = _this4.tagList.concat(data[i]);
          }
          _this4.isShowAll = true;
        } else {
          _this4.tagList = data;
        }
      });
    },
    showAllTag: function showAllTag() {
      this.tagList = this.allTagList;
      this.isShowAll = false;
      this.isShowUpward = true;
    },
    upwardTag: function upwardTag() {
      this.tagList = [];
      for (var i = 0; i < 20; i++) {
        this.tagList = this.tagList.concat(this.allTagList[i]);
      }
      this.isShowAll = true;
      this.isShowUpward = false;
    },
    getPostsByTagName: function getPostsByTagName(tagName) {
      if (tagName != null && tagName.trim() != "") {
        this.tagName = tagName;
      }
    },
    dateFormat: function dateFormat(time) {
      var timeOffset = -28800000;
      if (this.user) {
        timeOffset = this.user.timeOffset;
      }
      return formatDate(time, timeOffset, this.$i18n.locale);
    }
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_quill_editor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_quill_editor__);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      editorOption: {},
      username: this.$route.params.username,
      postingId: this.$route.params.postingId,
      postingTitle: this.$route.params.postingTitle,
      isLoading: true,
      forwardModal: false,
      isShowViewImageModal: false,
      postingForwardIdDetail: "",
      fab: false,
      colorGoodnum: "",
      colorStepnum: "",
      divIndex: -1,
      posting: {},
      userDetail: {},
      usercommentsList: [],
      postingCommentList: [],
      postingCommentsEvaluationgoods: [],
      postingCommentsEvaluationsteps: [],
      collectionPostingList: [],
      isShowUpvoteUserDiv: false,
      isShowDownvoteUserDiv: false,
      upvoteUserList: [],
      downvoteUserList: [],
      s: localStorage.getItem("token"),
      isuserinfoShow: false,
      isuserinfoShow1: false,
      isShowcomments: false,
      replyShow: true,
      replysubmit: true,
      modal2: false,
      isFollow: false,
      formFollow: {
        userId: "",
        followerId: ""
      },
      formValidate: {
        commentsContext: ""
      },
      formCollection: {
        userId: "",
        postingId: ""
      },
      formEvaluation: {
        userId: "",
        postingId: ""
      },
      ruleValidate: {
        commentsContext: [{
          required: true,
          message: this.$t("postingsel.Tocomment"),
          trigger: "blur"
        }, {
          type: "string",
          min: 20,
          message: this.$t("postingsel.TocommentLength"),
          trigger: "blur"
        }]
      },
      formValidatezf: {
        postingUserforwardId: this.$store.state.user.id,
        postingId: this.$route.params.postingId,
        postingForwardContext: ""
      },
      ruleValidatezf: {
        postingForwardContext: [{
          required: false,
          message: this.$t("postingsel.Tocomment"),
          trigger: "blur"
        }, {
          type: "string",
          min: 20,
          message: this.$t("postingsel.TocommentLength"),
          trigger: "blur"
        }]
      },
      formValidatereply: {
        commentsContext: "",
        commentsId: ""
      },
      ruleValidatereply: {
        commentsContext: [{
          required: true,
          message: this.$t("postingsel.Tocomment"),
          trigger: "blur"
        }, {
          type: "string",
          max: 200,
          message: this.$t("postingsel.TocommentMaxLength"),
          trigger: "blur"
        }]
      },
      formValidatereplytoreply: {
        commentsContext: "",
        commentsId: ""
      },
      commentsEvaluation: {
        userId: this.$store.state.user.id,
        commentsId: "",
        eStatus: ""
      },
      postingCommentsEvaluationList: null,
      editCommentsContext: null };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(["user", "marketsList"]), {
    isLogin: function isLogin() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != "") {
        return true;
      } else {
        return false;
      }
    },
    editor: function editor() {
      return this.$refs.myQuillEditor.quill;
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    this.postingbyid();
  },

  watch: {
    $route: function $route() {
      this.postingId = this.$route.params.postingId;
    },
    postingId: function postingId() {
      if (this.postingId != null) {
        this.postingbyid();

        this.postingCommentList = [];
      }
    }
  },
  methods: {
    onEditorReady: function onEditorReady(editor) {},
    onEditorBlur: function onEditorBlur(editor) {},
    onEditorFocus: function onEditorFocus(editor) {},
    onEditorChange: function onEditorChange(_ref) {
      var editor = _ref.editor,
          html = _ref.html,
          text = _ref.text;
    },
    findtagposting: function findtagposting(tagName) {
      if (tagName != null && tagName.trim() != "") {
        this.$router.push({ name: "tagPosts", params: { tagName: tagName } });
      }
    },
    hideBlock: function hideBlock(event) {
      var upvoteUserDiv = document.getElementById("upvoteUserDiv");
      if (upvoteUserDiv) {
        if (!upvoteUserDiv.contains(event.target)) {
          var faSortDownIcon = document.getElementsByClassName("fa-fort-down-icon");
          var flag = false;
          for (var i = 0; i < faSortDownIcon.length; i++) {
            if (faSortDownIcon[i].contains(event.target)) {
              flag = true;
            }
          }
          if (!flag) {
            this.isShowUpvoteUserDiv = false;
            this.isShowDownvoteUserDiv = false;
            document.getElementById("comments").setAttribute("style", "margin-bottom: 0px");
          }
        }
      }
    },
    goUserData: function goUserData(username) {
      this.$router.push({
        name: "userData",
        params: {
          username: "@" + username
        }
      });
    },
    follow: function follow() {
      var _this = this;

      this.formFollow.userId = this.$store.state.user.id;
      this.formFollow.followerId = this.posting.postingUserId;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "follow/saveFollow", this.formFollow).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this.isFollow = true;
        } else if (data.resCode == 1) {
          _this.isFollow = false;
        } else if (data.resCode == -3) {
          _this.$Message.error("Can not follow yourself!");
        }
      });
    },
    commentsUporDown: function commentsUporDown(event, com) {
      if (com.cupordown == true) {
        com.cupordown = false;
        event.target.className = "ivu-icon ivu-icon-chevron-up";
      } else {
        com.cupordown = true;
        event.target.className = "ivu-icon ivu-icon-chevron-down";
      }
    },
    changeData: function changeData(com) {
      if (localStorage.getItem("token")) {
        if (com.cshow == true) {
          this.formValidate.commentsContext = "";
          this.formValidatereply.commentsContext = "";
          this.formValidatereplytoreply.commentsContext = "";
          com.cshow = false;
        } else {
          com.cshow = true;
        }
      } else {
        this.$store.state.loginModal = true;
      }
    },
    changereplytoreply: function changereplytoreply(reptorep, commentuser2) {
      if (localStorage.getItem("token")) {
        this.replyShow = true;
        this.replysubmit = true;
        if (reptorep.cshow == true) {
          reptorep.cshow = false;
        } else {
          reptorep.cshow = true;
          this.formValidatereplytoreply.commentsContext = "@" + commentuser2.userName + ":";
        }
      } else {
        this.$store.state.loginModal = true;
      }
    },
    toggletext: function toggletext(com) {
      if (com.cupordown == false) {
        com.cupordown = true;
      } else {
        com.cupordown = false;
      }
    },
    toggleuserinfocomments: function toggleuserinfocomments(com) {
      if (com.commentsUserDetalinfo == true) {
        com.commentsUserDetalinfo = false;
      } else {
        com.commentsUserDetalinfo = true;
      }
    },
    postingbyid: function postingbyid() {
      var _this2 = this;

      var postingId = this.$route.params.postingId;
      if (postingId == null || postingId == "") {
        return;
      }
      this.isLoading = true;

      var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "posting/open/sel/" + postingId;
      this.$http.get(url).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this2.posting = data.result;

          document.title = _this2.posting.postingTitle;
          _this2.isLoading = false;

          _this2.getCommentsByPostingId();

          _this2.getUserDetailByUserId();

          if (localStorage.getItem("token")) {
            _this2.getOperationStatus(postingId);
          }

          if (data.result.postingUserForwardId != null) {
            var forwordUserUrl = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "user/open/userDetail/" + data.result.postingUserForwardId;
            _this2.$http.get(forwordUserUrl).then(function (successData) {
              _this2.postingForwardIdDetail = successData.data.result;
            });
          }
        } else {
          _this2.posting = {};
          _this2.isLoading = false;
          _this2.$router.push({ name: "page404" });
        }
      });
    },
    getCommentsByPostingId: function getCommentsByPostingId() {
      var _this3 = this;

      var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "comments/open/selbypostingid/" + this.postingId;
      this.$http.get(url).then(function (successData) {
        var data = successData.data;
        _this3.usercommentsList = data.result.usercommentsList;
        _this3.postingCommentList = data.result.postingCommentList;
      });
    },
    getUserDetailByUserId: function getUserDetailByUserId() {
      var _this4 = this;

      var userUrl = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "userDetail/open/getSimpleUserDetailByUserId/" + this.posting.postingUserId;
      this.$http.get(userUrl).then(function (successData) {
        _this4.userDetail = successData.data.result;
      });
    },
    getOperationStatus: function getOperationStatus(postingId) {
      var _this5 = this;

      var evaluationUrl = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "posting/getPostingEvaluation";
      this.formEvaluation.userId = this.$store.state.user.id;
      this.formEvaluation.postingId = postingId;
      this.$http.post(evaluationUrl, this.formEvaluation).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this5.posting.postingStatus = data.result.eStatus;
        }
      });

      var collectionUrl = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "collection/isCollection";
      this.formCollection.userId = this.$store.state.user.id;
      this.formCollection.postingId = this.posting.postingId;
      this.$http.post(collectionUrl, this.formCollection).then(function (successData) {
        var data = successData.data;
        if (data.result == true) {
          _this5.posting.postingCollection = 0;
        } else {
          _this5.posting.postingCollection = -1;
        }
      });

      this.formFollow.userId = this.$store.state.user.id;
      this.formFollow.followerId = this.posting.postingUserName;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "follow/isFollow", this.formFollow).then(function (successData) {
        _this5.isFollow = successData.data.result;
      });

      var commentEvaluationUrl = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "comments/getPostingCommentsEvaluationList/" + postingId + "/" + this.$store.state.user.id;
      this.$http.get(commentEvaluationUrl).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this5.postingCommentsEvaluationList = data.result;
        } else {
          _this5.postingCommentsEvaluationList = null;
        }
      });
    },
    commentsshow: function commentsshow() {
      if (localStorage.getItem("token")) {
        this.isShowcomments = !this.isShowcomments;
      } else {
        this.$store.state.loginModal = true;
      }
    },
    postingforward: function postingforward() {
      var _this6 = this;

      var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "posting/forward";
      this.$http.post(url, this.formValidatezf).then(function (successData) {
        var data = successData.data;
        _this6.forwardModal = false;
        if (data.resCode == 0) {
          _this6.$Message.success({
            content: _this6.$t("posting.forwardMessage"),
            duration: 2
          });
          _this6.posting.postingCountForword = data.result;
          _this6.formValidatezf.postingForwardContext = "";
        } else if (data.resCode == -1) {
          _this6.$Message.error({
            content: _this6.$t("common.fail"),
            duration: 2
          });
        }
      }, function (error) {
        _this6.forwardModal = false;
      });
    },
    modalzf: function modalzf(obj) {
      if (localStorage.getItem("token")) {
        this.formValidatezf.postingId = obj.postingId;
        this.forwardModal = true;
      } else {
        this.$store.state.loginModal = true;
      }
    },
    collectionPosting: function collectionPosting() {
      var _this7 = this;

      if (!localStorage.getItem("token")) {
        this.$store.state.loginModal = true;
        return;
      }
      this.formCollection.userId = this.$store.state.user.id;
      this.formCollection.postingId = this.posting.postingId;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "collection/saveCollectionPosting", this.formCollection).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this7.posting.postingCollection = 0;
        } else if (data.resCode == 1) {
          _this7.posting.postingCollection = -1;
        }
      });
    },
    postingcomments: function postingcomments(name) {
      var _this8 = this;

      if (this.$refs["formValidate"].validate()) {
        var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "comments/create/" + this.$route.params.postingId;
        this.$http.post(url, this.formValidate).then(function (successData) {
          var data = successData.data;
          if (data.resCode == 0) {
            _this8.formValidate.commentsContext = "";
            _this8.postingcommentsclose();
            _this8.getCommentsByPostingId();
          } else if (data.resCode == -1003) {
            _this8.$Message.error({
              content: _this8.$t("postingsel.Tocomment"),
              duration: 2
            });
          }
        });
      } else {
        this.$Message.error(this.$t("common.fail"));
      }
    },
    postingreplys: function postingreplys(name, com) {
      var _this9 = this;

      var postingId = this.$route.params.postingId;
      var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "comments/createreply/" + postingId + "/" + com.commentsId;
      this.$http.post(url, this.formValidatereply).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this9.formValidatereply.commentsContext = "";
          _this9.postingreplyclose(com);
          _this9.getCommentsByPostingId();
        } else if (data.resCode == -1003) {
          _this9.$Message.error({
            content: _this9.$t("postingsel.Tocomment"),
            duration: 2
          });
        }
      });
    },
    postingreplytoreplys: function postingreplytoreplys(name, com) {
      var _this10 = this;

      var postingId = this.$route.params.postingId;
      var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "comments/createreply/" + postingId + "/" + com.commentsId;
      if (this.formValidatereplytoreply.commentsContext.substring(this.formValidatereplytoreply.commentsContext.indexOf(":") + 1) == "") {
        this.$Message.error({
          content: this.$t("postingsel.Tocomment"),
          duration: 2
        });
      } else {
        var username = this.formValidatereplytoreply.commentsContext.substring(this.formValidatereplytoreply.commentsContext.indexOf("@") + 1, this.formValidatereplytoreply.commentsContext.indexOf(":"));
        var context = this.formValidatereplytoreply.commentsContext.substring(this.formValidatereplytoreply.commentsContext.indexOf(":"));
        username = "<a href='" + __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].ip + "#/user/profile/@" + username + "'  style='color: #41B8BC;'>" + "@" + username + "</a>";
        this.replyShow = false;
        this.replysubmit = false;
        this.formValidatereplytoreply.commentsContext = username + context;
        this.$http.post(url, this.formValidatereplytoreply).then(function (successData) {
          var data = successData.data;
          if (data.resCode == 0) {
            _this10.formValidatereplytoreply.commentsContext = "";
            _this10.postingreplyclose(com);
            _this10.getCommentsByPostingId();
          } else if (data.resCode == -1003) {
            _this10.$Message.error({
              content: _this10.$t("postingsel.Tocomment"),
              duration: 2
            });
          }
        });
      }
    },
    postingcommentsclose: function postingcommentsclose() {
      this.isShowcomments = false;
    },
    postingreplyclose: function postingreplyclose(com) {
      com.cshow = false;
      this.formValidatereply.commentsContext = "";
      this.formValidatereplytoreply.commentsContext = "";
    },
    toggleuserinfo: function toggleuserinfo() {
      this.isuserinfoShow = !this.isuserinfoShow;
    },
    toggleuserinfo1: function toggleuserinfo1() {
      this.isuserinfoShow1 = !this.isuserinfoShow1;
    },
    changesup: function changesup() {
      var _this11 = this;

      if (localStorage.getItem("token")) {
        var postingId = this.$route.params.postingId;
        var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "posting/evaluationgood/" + postingId;
        this.$http.get(url).then(function (successData) {
          var data = successData.data;
          if (data.resCode == 0) {
            _this11.posting.postingGoodnums = data.result;
            _this11.posting.postingStatus = 0;
          } else if (data.resCode == -11) {
            _this11.$Message.warning(_this11.$t("posting.evaluation"));
          } else if (data.resCode == -1) {
            _this11.$Message.warning(_this11.$t("posting.evaluation"));
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    changesdown: function changesdown() {
      var _this12 = this;

      if (localStorage.getItem("token")) {
        var postingId = this.$route.params.postingId;
        var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "posting/evaluationstep/" + postingId;
        this.$http.get(url).then(function (successData) {
          var data = successData.data;
          if (data.resCode == 0) {
            _this12.posting.postingStepnums = data.result;
            _this12.posting.postingStatus = 1;
          } else if (data.resCode == -1) {
            _this12.$Message.warning(_this12.$t("posting.evaluation"));
          } else if (data.resCode == -11) {
            _this12.$Message.warning(_this12.$t("posting.evaluation"));
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    evaluateComment: function evaluateComment(commentId, status) {
      var _this13 = this;

      if (localStorage.getItem("token")) {
        this.commentsEvaluation.userId = this.$store.state.user.id;
        this.commentsEvaluation.commentsId = commentId;
        this.commentsEvaluation.eStatus = status;
        var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "comments/evaluateComment";
        this.$http.post(url, this.commentsEvaluation).then(function (successData) {
          var data = successData.data;
          if (data.resCode == 0) {
            for (var i = 0; i < _this13.postingCommentsEvaluationList.length; i++) {
              if (_this13.postingCommentsEvaluationList[i].commentsId == commentId) {
                _this13.postingCommentsEvaluationList[i].eStatus = "0";
                break;
              }
            }
            for (var i = 0; i < _this13.postingCommentList.length; i++) {
              if (_this13.postingCommentList[i].commentsId == commentId) {
                _this13.postingCommentList[i].postingCommentsGoodnums += 1;
                break;
              }
            }
            _this13.$forceUpdate();
          } else if (data.resCode == 1) {
            for (var i = 0; i < _this13.postingCommentsEvaluationList.length; i++) {
              if (_this13.postingCommentsEvaluationList[i].commentsId == commentId) {
                _this13.postingCommentsEvaluationList[i].eStatus = "1";
                break;
              }
            }
            for (var i = 0; i < _this13.postingCommentList.length; i++) {
              if (_this13.postingCommentList[i].commentsId == commentId) {
                _this13.postingCommentList[i].postingCommentsStepnums += 1;
                break;
              }
            }
            _this13.$forceUpdate();
          } else if (data.resCode == 1000) {
            _this13.$Message.warning(_this13.$t("posting.evaluation"));
          } else if (data.resCode == 1001) {
            _this13.$Message.warning(_this13.$t("posting.evaluation"));
          } else if (data.resCode == -1) {
            _this13.$Message.error(_this13.$t("common.fail"));
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    postingforwardCancel: function postingforwardCancel() {
      this.modal2 = false;
    },
    commentsupanddowm: function commentsupanddowm(event) {
      event.target.iscommentsContext = false;
      if (event.target.className == "ivu-icon ivu-icon-chevron-up") {
        event.target.className = "ivu-icon ivu-icon-chevron-down";
      } else {
        event.target.className = "ivu-icon ivu-icon-chevron-up";
      }
    },
    editPosting: function editPosting(post) {
      localStorage.setItem("SIP-editPost", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(post));
      localStorage.removeItem("SIP-tagName");
      this.$router.push({ name: "createPost" });
    },
    editComment: function editComment(comment) {
      comment.editCommentsFlag = !comment.editCommentsFlag;
      this.editCommentsContext = comment.commentsContext;
    },
    updateComment: function updateComment(comment) {
      var api = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "comments/updateComment";
      var obj = new Object();
      obj.commentsId = comment.commentsId;
      obj.commentsContext = this.editCommentsContext;
      this.$http.post(api, obj).then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          comment.commentsContext = data.result;
        }
        comment.editCommentsFlag = true;
      }, function (error) {
        comment.editCommentsFlag = true;
      });
    },
    getUpvoteUser: function getUpvoteUser() {
      var _this14 = this;

      this.isShowUpvoteUserDiv = !this.isShowUpvoteUserDiv;
      if (!this.isShowUpvoteUserDiv) {
        document.getElementById("comments").setAttribute("style", "margin-bottom: 0px");
        return;
      }
      this.upvoteUserList = [];
      this.isShowDownvoteUserDiv = false;
      document.getElementById("comments").setAttribute("style", "margin-bottom: 450px");
      var upvoteUrl = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "postingEvaluation/open/getUpvoteUserByPostingId?postingId=" + this.postingId;
      this.$http.get(upvoteUrl).then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          _this14.upvoteUserList = data.result;
        } else {
          _this14.upvoteUserList = [];
        }
      });
    },
    getDownvoteUser: function getDownvoteUser() {
      var _this15 = this;

      this.isShowDownvoteUserDiv = !this.isShowDownvoteUserDiv;
      if (!this.isShowDownvoteUserDiv) {
        document.getElementById("comments").setAttribute("style", "margin-bottom: 0px");
        return;
      }
      this.downvoteUserList = [];
      this.isShowUpvoteUserDiv = false;
      document.getElementById("comments").setAttribute("style", "margin-bottom: 450px");
      var downvoteUrl = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "postingEvaluation/open/getDownvoteUserByPostingId?postingId=" + this.postingId;
      this.$http.get(downvoteUrl).then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          _this15.downvoteUserList = data.result;
        } else {
          _this15.downvoteUserList = [];
        }
      });
    },
    findByMarkets: function findByMarkets(market) {
      localStorage.setItem('SIP-marketsCode', market.code);
      localStorage.setItem('SIP-marketsTitle', market.name);
      this.$store.dispatch("marketsDescHandler", market.description);
      this.$router.push({
        name: 'marketPosts',
        params: {
          marketsName: market.name
        }
      });
    },
    dateFormat: function dateFormat(time) {
      var timeOffset = -28800000;
      if (this.user) {
        timeOffset = this.user.timeOffset;
      }
      return formatDate(time, timeOffset, this.$i18n.locale);
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tabName: 'hot',
      isLoadingNewList: false,
      isLoadingHotList: false,
      hotListPageNo: 0,
      newListPageNo: 0,
      pageSize: 10,
      postHotList: [],
      userDetailHotList: [],
      commentHotList: [],
      commentUserHotList: [],
      postNewList: [],
      userDetailNewList: [],
      commentNewList: [],
      commentUserNewList: [],
      postingIds: [],
      forwardModal: false,
      postUserImage: '',
      postTitle: '',
      postDate: '',
      postNickName: '',
      postUserName: '',
      formValidatezf: {
        postingUserforwardId: this.$store.state.user.id,
        postingId: '',
        postingForwardContext: ''
      },
      formCollection: {
        userId: '',
        postingId: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['user']), {
    isLogin: function isLogin() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != '') {
        return true;
      } else {
        return false;
      }
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    this.$store.dispatch('pageTitleHandler', 'new');
  },

  watch: {},
  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default.a
  },
  methods: {
    getPostHotList: function getPostHotList($state) {
      var _this = this;

      if (this.isLoadingHotList) {
        return;
      }
      this.isLoadingHotList = true;
      var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'posting/open/findallspopular/' + this.hotListPageNo + '/' + this.pageSize;
      this.$http.get(url).then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          _this.hotListPageNo += 1;
          _this.postHotList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.postHotList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result.postingList));
          _this.commentHotList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.commentHotList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result.postCommentsList));
          if (localStorage.getItem('token')) {
            _this.getUserActions(data.result.postingList);
          }
          var udList = data.result.userDetailList;
          var upList = data.result.userpopularsList;

          for (var i = 0; i < _this.userDetailHotList.length; i++) {
            for (var j = 0; j < udList.length; j++) {
              if (_this.userDetailHotList[i].userId == udList[j].userId) {
                udList.splice(j, 1);
              }
            }
          }
          for (var _i = 0; _i < _this.commentUserHotList.length; _i++) {
            for (var _j = 0; _j < upList.length; _j++) {
              if (_this.commentUserHotList[_i].userId == upList[_j].userId) {
                upList.splice(_j, 1);
              }
            }
          }
          _this.userDetailHotList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.userDetailHotList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(udList));
          _this.commentUserHotList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.commentUserHotList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(upList));
          _this.isLoadingHotList = false;
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    getPostNewList: function getPostNewList($state) {
      var _this2 = this;

      if (this.isLoadingNewList) {
        return;
      }
      this.isLoadingNewList = true;
      var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'posting/open/findallsnewest/' + this.newListPageNo + '/' + this.pageSize;
      this.$http.get(url).then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          _this2.newListPageNo += 1;
          _this2.postNewList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.postNewList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result.postingList));
          _this2.commentNewList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.commentNewList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result.postCommentsList));
          if (localStorage.getItem('token')) {
            _this2.getUserActions(data.result.postingList);
          }
          var udList = data.result.userDetailList;
          var upList = data.result.userpopularsList;

          for (var i = 0; i < _this2.userDetailNewList.length; i++) {
            for (var j = 0; j < udList.length; j++) {
              if (_this2.userDetailNewList[i].userId == udList[j].userId) {
                udList.splice(j, 1);
              }
            }
          }
          for (var _i2 = 0; _i2 < _this2.commentUserNewList.length; _i2++) {
            for (var _j2 = 0; _j2 < upList.length; _j2++) {
              if (_this2.commentUserNewList[_i2].userId == upList[_j2].userId) {
                upList.splice(_j2, 1);
              }
            }
          }
          _this2.userDetailNewList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.userDetailNewList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(udList));
          _this2.commentUserNewList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.commentUserNewList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(upList));
          _this2.isLoadingNewList = false;
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    getUserActions: function getUserActions(postList) {
      if (!localStorage.getItem('token')) {
        return;
      }
      for (var i = 0; i < postList.length; i++) {
        this.postingIds[i] = postList[i].postingId;
      }

      var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'posting/UserEvalutiongood/' + this.$store.state.user.id;
      this.$http.post(url, this.postingIds).then(function (successData) {
        var voteList = successData.data.result;
        for (var _i3 = 0; _i3 < postList.length; _i3++) {
          for (var j = 0; j < voteList.length; j++) {
            if (postList[_i3].postingId == voteList[j].postingId) {
              if (voteList[j].eStatus == '0') {
                postList[_i3].postingStatus = 0;
              }
              if (voteList[j].eStatus == '1') {
                postList[_i3].postingStatus = 1;
              }
            }
          }
        }
      });

      var collectionUrl = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'collection/getCollectionByUserIdAndPostingIds/' + this.$store.state.user.id;
      this.$http.post(collectionUrl, this.postingIds).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          var collectionList = data.result;

          for (var _i4 = 0; _i4 < postList.length; _i4++) {
            for (var j = 0; j < collectionList.length; j++) {
              if (postList[_i4].postingId == collectionList[j].postingId) {
                postList[_i4].postingCollection = 0;
              }
            }
          }
        }
      });
    },
    goUserData: function goUserData(username) {
      this.$router.push({
        name: 'userData',
        params: {
          username: '@' + username
        }
      });
    },
    changesup: function changesup(obj) {
      if (localStorage.getItem('token')) {
        var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'posting/evaluationgood/' + obj.postingId;
        this.$http.get(url).then(function (successData) {
          var that = this;
          var data = successData.data;
          if (data.resCode == 0) {
            obj.postingGoodnums = data.result;
            obj.postingStatus = 0;
          } else if (data.resCode == -11) {
            this.$Message.warning({
              content: this.$t('posting.evaluation'),
              duration: 2
            });
          } else if (data.resCode == -1) {
            this.$Message.warning({
              content: this.$t('posting.evaluation'),
              duration: 2
            });
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    changesdown: function changesdown(obj) {
      if (localStorage.getItem('token')) {
        var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'posting/evaluationstep/' + obj.postingId;
        this.$http.get(url).then(function (successData) {
          var that = this;
          var data = successData.data;
          if (data.resCode == 0) {
            obj.postingStepnums = data.result;
            obj.postingStatus = 1;
          } else if (data.resCode == -1) {
            this.$Message.warning({
              content: this.$t('posting.evaluation'),
              duration: 1
            });
          } else if (data.resCode == -11) {
            this.$Message.warning({
              content: this.$t('posting.evaluation'),
              duration: 1
            });
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    postingforward: function postingforward() {
      var _this3 = this;

      var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'posting/forward';
      this.$http.post(url, this.formValidatezf).then(function (successData) {
        var data = successData.data;
        _this3.forwardModal = false;
        if (data.resCode == 0) {
          _this3.$Message.success({
            content: _this3.$t('posting.forwardMessage'),
            duration: 2
          });
          _this3.formValidatezf.postingForwardContext = '';
          _this3.formValidatezf.postingId = '';
          for (var i = 0; i < _this3.postingList.length; i++) {
            if (_this3.postingList[i].postingId == _this3.formValidatezf.postingId) {
              _this3.postingList[i].postingCountForword = data.result;
              break;
            }
          }
        } else if (data.resCode == -1) {
          _this3.$Message.error({
            content: _this3.$t('common.fail'),
            duration: 2
          });
        }
      }, function (error) {
        _this3.forwardModal = false;
      });
    },
    modalzf: function modalzf(obj, user) {
      if (localStorage.getItem('token')) {
        this.formValidatezf.postingId = obj.postingId;
        this.formValidatezf.postingForwardContext = '';
        this.postUserImage = user.image;
        this.postTitle = obj.postingTitle;
        this.postDate = obj.postingTime;
        this.postUserName = user.userName;
        this.postNickName = user.nickName;
        this.forwardModal = true;
      } else {
        this.$store.state.loginModal = true;
      }
    },
    postingforwardCancel: function postingforwardCancel() {
      this.forwardModal = false;
    },
    collectionPosting: function collectionPosting(posting) {
      if (!localStorage.getItem('token')) {
        this.$store.state.loginModal = true;
        return;
      }
      this.formCollection.userId = this.$store.state.user.id;
      this.formCollection.postingId = posting.postingId;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'collection/saveCollectionPosting', this.formCollection).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          posting.postingCollection = 0;
        } else if (data.resCode == 1) {
          posting.postingCollection = -1;
        }
      });
    },
    findsel: function findsel(posting) {
      this.$router.push({
        name: 'postingsel',
        params: {
          postingId: posting.postingId,
          username: posting.postingUserName
        }
      });
    },
    dateFormat: function dateFormat(time) {
      var timeOffset = -28800000;
      if (this.user) {
        timeOffset = this.user.timeOffset;
      }
      return formatDate(time, timeOffset, this.$i18n.locale);
    }
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      infiniteId: +new Date(),
      isLoadingSearchList: false,
      searchListPageNo: 0,
      pageSize: 10,
      postSearchList: [],
      userDetailSearchList: [],
      postingIds: [],
      forwardModal: false,
      postUserImage: '',
      postTitle: '',
      postDate: '',
      postNickName: '',
      postUserName: '',
      formValidatezf: {
        postingUserforwardId: this.$store.state.user.id,
        postingId: '',
        postingForwardContext: ''
      },
      formCollection: {
        userId: '',
        postingId: ''
      }
    };
  },
  created: function created() {},

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["user"]), {
    searchText: function searchText() {
      return this.$store.getters.searchText;
    },
    isLogin: function isLogin() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != '') {
        return true;
      } else {
        return false;
      }
    }
  }),
  mounted: function mounted() {
    this.$store.dispatch('searchTextHandler', this.$route.params.searchText);
    this.reloadData();
  },

  watch: {
    searchText: function searchText(newVal, oldVal) {
      if (newVal != null && newVal.trim() != '') {
        this.searchListPageNo = 0;
        this.postSearchList = [];
        this.userDetailSearchList = [];
        this.infiniteId += 1;
      }
    }
  },
  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default.a
  },
  methods: {
    reloadData: function reloadData() {
      this.searchListPageNo = 0;
      this.postSearchList = [];
      this.userDetailSearchList = [];
      this.infiniteId += 1;
    },
    getPostSearchList: function getPostSearchList($state) {
      var _this = this;

      if (this.isLoadingSearchList) {
        return;
      }
      var url = null;
      if (this.searchText != null && this.searchText.trim() != '') {
        url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + "es/open/searchPost/" + this.searchListPageNo + "/" + this.pageSize + "/" + this.searchText;
      } else {
        return;
      }
      this.isLoadingSearchList = true;
      this.$http.get(url).then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          _this.searchListPageNo += 1;
          _this.postSearchList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.postSearchList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result.postList));
          if (localStorage.getItem('token')) {
            _this.getUserActions(data.result.postList);
          }
          var udList = data.result.userDetailList;
          var upList = data.result.userpopularsList;

          for (var i = 0; i < _this.userDetailSearchList.length; i++) {
            for (var j = 0; j < udList.length; j++) {
              if (_this.userDetailSearchList[i].userId == udList[j].userId) {
                udList.splice(j, 1);
              }
            }
          }
          _this.userDetailSearchList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.userDetailSearchList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(udList));
          _this.isLoadingSearchList = false;
          $state.loaded();
        } else {
          _this.isLoadingSearchList = false;
          $state.complete();
        }
      });
    },
    getUserActions: function getUserActions(postList) {
      if (!localStorage.getItem('token')) {
        return;
      }
      for (var i = 0; i < postList.length; i++) {
        this.postingIds[i] = postList[i].postingId;
      }

      var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + "posting/UserEvalutiongood/" + this.$store.state.user.id;
      this.$http.post(url, this.postingIds).then(function (successData) {
        var voteList = successData.data.result;
        for (var _i = 0; _i < postList.length; _i++) {
          for (var j = 0; j < voteList.length; j++) {
            if (postList[_i].postingId == voteList[j].postingId) {
              if (voteList[j].eStatus == '0') {
                postList[_i].postingStatus = 0;
              }
              if (voteList[j].eStatus == '1') {
                postList[_i].postingStatus = 1;
              }
            }
          }
        }
      });

      var collectionUrl = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + "collection/getCollectionByUserIdAndPostingIds/" + this.$store.state.user.id;
      this.$http.post(collectionUrl, this.postingIds).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          var collectionList = data.result;

          for (var _i2 = 0; _i2 < postList.length; _i2++) {
            for (var j = 0; j < collectionList.length; j++) {
              if (postList[_i2].postingId == collectionList[j].postingId) {
                postList[_i2].postingCollection = 0;
              }
            }
          }
        }
      });
    },
    goUserData: function goUserData(username) {
      this.$router.push({
        name: 'userData',
        params: {
          username: '@' + username
        }
      });
    },
    changesup: function changesup(obj) {
      if (localStorage.getItem('token')) {
        var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + "posting/evaluationgood/" + obj.postingId;
        this.$http.get(url).then(function (successData) {
          var that = this;
          var data = successData.data;
          if (data.resCode == 0) {
            obj.postingGoodnums = data.result;
            obj.postingStatus = 0;
          } else if (data.resCode == -11) {
            this.$Message.warning({
              content: this.$t('posting.evaluation'),
              duration: 2
            });
          } else if (data.resCode == -1) {
            this.$Message.warning({
              content: this.$t('posting.evaluation'),
              duration: 2
            });
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    changesdown: function changesdown(obj) {
      if (localStorage.getItem('token')) {
        var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + "posting/evaluationstep/" + obj.postingId;
        this.$http.get(url).then(function (successData) {
          var that = this;
          var data = successData.data;
          if (data.resCode == 0) {
            obj.postingStepnums = data.result;
            obj.postingStatus = 1;
          } else if (data.resCode == -1) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 1
            });
          } else if (data.resCode == -11) {
            this.$Message.warning({
              content: this.$t("posting.evaluation"),
              duration: 1
            });
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    postingforward: function postingforward() {
      var _this2 = this;

      var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + "posting/forward";
      this.$http.post(url, this.formValidatezf).then(function (successData) {
        var data = successData.data;
        _this2.forwardModal = false;
        if (data.resCode == 0) {
          _this2.$Message.success({
            content: _this2.$t('posting.forwardMessage'),
            duration: 2
          });
          _this2.formValidatezf.postingForwardContext = '';
          _this2.formValidatezf.postingId = '';
          for (var i = 0; i < _this2.postList.length; i++) {
            if (_this2.postList[i].postingId == _this2.formValidatezf.postingId) {
              _this2.postList[i].postingCountForword = data.result;
              break;
            }
          }
        } else if (data.resCode == -1) {
          _this2.$Message.error({
            content: _this2.$t('common.fail'),
            duration: 2
          });
        }
      }, function (error) {
        _this2.forwardModal = false;
      });
    },
    modalzf: function modalzf(obj, user) {
      if (localStorage.getItem('token')) {
        this.formValidatezf.postingId = obj.postingId;
        this.formValidatezf.postingForwardContext = '';
        this.postUserImage = user.image;
        this.postTitle = obj.postingTitle;
        this.postDate = obj.postingTime;
        this.postUserName = user.userName;
        this.postNickName = user.nickName;
        this.forwardModal = true;
      } else {
        this.$store.state.loginModal = true;
      }
    },
    postingforwardCancel: function postingforwardCancel() {
      this.forwardModal = false;
    },
    collectionPosting: function collectionPosting(posting) {
      if (!localStorage.getItem('token')) {
        this.$store.state.loginModal = true;
        return;
      }
      this.formCollection.userId = this.$store.state.user.id;
      this.formCollection.postingId = posting.postingId;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + "collection/saveCollectionPosting", this.formCollection).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          posting.postingCollection = 0;
        } else if (data.resCode == 1) {
          posting.postingCollection = -1;
        }
      });
    },
    findsel: function findsel(posting) {
      this.$router.push({
        name: 'postingsel',
        params: {
          postingId: posting.postingId,
          username: posting.postingUserName

        }
      });
    },
    dateFormat: function dateFormat(time) {
      var timeOffset = -28800000;
      if (this.user) {
        timeOffset = this.user.timeOffset;
      }
      return formatDate(time, timeOffset, this.$i18n.locale);
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__);








/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			tagName: this.$route.params.tagName,
			postsTabName: +new Date(),
			isLoadingPostList: false,
			pageNo: 0,
			pageSize: 10,
			postList: [],
			commentList: [],
			userDetailList: [],
			commentUserDetailList: [],
			forwardModal: false,
			postUserImage: '',
			postTitle: '',
			postDate: '',
			postNickName: '',
			postUserName: '',
			formValidatezf: {
				postingUserforwardId: this.$store.state.user.id,
				postingId: '',
				postingForwardContext: ''
			},
			formCollection: {
				userId: '',
				postingId: ''
			}
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['user']), {
		isLogin: function isLogin() {
			if (this.$store.state.user.token != null && this.$store.state.user.token != '') {
				return true;
			} else {
				return false;
			}
		}
	}),
	created: function created() {},
	mounted: function mounted() {},

	watch: {
		$route: function $route() {
			if (this.$route.params.tagName) {
				this.tagName = this.$route.params.tagName;
			}
		},
		tagName: function tagName() {
			if (this.tagName) {
				this.refreshPosts();
			}
		}
	},
	components: {
		InfiniteLoading: __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default.a
	},
	methods: {
		getPostsByTagName: function getPostsByTagName($state) {
			var _this = this;

			if (this.isLoadingPostList) {
				return;
			}
			this.isLoadingPostList = true;
			var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'posting/open/getPosts/tag/' + this.pageNo + '/' + this.pageSize + '/' + this.tagName;
			this.$http.get(url).then(function (response) {
				var data = response.data;
				_this.isLoadingPostList = false;
				if (data.resCode == 0) {
					_this.pageNo += 1;
					_this.postList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.postList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result.postList));
					_this.commentList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.commentList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result.commentList));
					if (localStorage.getItem('token')) {
						_this.getUserActions(data.result.postList);
					}
					var udList = data.result.userDetailList;
					var cudList = data.result.commentUserDetailList;

					for (var i = 0; i < _this.userDetailList.length; i++) {
						for (var j = 0; j < udList.length; j++) {
							if (_this.userDetailList[i].userId == udList[j].userId) {
								udList.splice(j, 1);
							}
						}
					}
					for (var _i = 0; _i < _this.commentUserDetailList.length; _i++) {
						for (var _j = 0; _j < cudList.length; _j++) {
							if (_this.commentUserDetailList[_i].userId == cudList[_j].userId) {
								cudList.splice(_j, 1);
							}
						}
					}
					_this.userDetailList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.userDetailList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(udList));
					_this.commentUserDetailList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.commentUserDetailList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(cudList));
					$state.loaded();
				} else {
					$state.complete();
				}
			});
		},
		getUserActions: function getUserActions(postList) {
			if (!localStorage.getItem('token')) {
				return;
			}
			var postIds = new Array();
			for (var i = 0; i < postList.length; i++) {
				postIds[i] = postList[i].postingId;
			}

			var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'posting/UserEvalutiongood/' + this.$store.state.user.id;
			this.$http.post(url, postIds).then(function (successData) {
				var voteList = successData.data.result;
				for (var _i2 = 0; _i2 < postList.length; _i2++) {
					for (var j = 0; j < voteList.length; j++) {
						if (postList[_i2].postingId == voteList[j].postingId) {
							if (voteList[j].eStatus == '0') {
								postList[_i2].postingStatus = 0;
							}
							if (voteList[j].eStatus == '1') {
								postList[_i2].postingStatus = 1;
							}
						}
					}
				}
			});

			var collectionUrl = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'collection/getCollectionByUserIdAndPostingIds/' + this.$store.state.user.id;
			this.$http.post(collectionUrl, postIds).then(function (successData) {
				var data = successData.data;
				if (data.resCode == 0) {
					var collectionList = data.result;

					for (var _i3 = 0; _i3 < postList.length; _i3++) {
						for (var j = 0; j < collectionList.length; j++) {
							if (postList[_i3].postingId == collectionList[j].postingId) {
								postList[_i3].postingCollection = 0;
							}
						}
					}
				}
			});
		},
		refreshPosts: function refreshPosts() {
			this.postList = [];
			this.userDetailList = [];
			this.commentList = [];
			this.commentUserDetailList = [];
			this.pageNo = 0;
			this.postsTabName += 1;
		},
		goUserData: function goUserData(username) {
			this.$router.push({
				name: 'userData',
				params: {
					username: '@' + username
				}
			});
		},
		findsel: function findsel(posting) {
			this.$router.push({
				name: 'postingsel',
				params: {
					postingId: posting.postingId,
					username: posting.postingUserName
				}
			});
		},
		changesup: function changesup(obj) {
			if (localStorage.getItem('token')) {
				var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'posting/evaluationgood/' + obj.postingId;
				this.$http.get(url).then(function (successData) {
					var that = this;
					var data = successData.data;
					if (data.resCode == 0) {
						obj.postingGoodnums = data.result;
						obj.postingStatus = 0;
					} else if (data.resCode == -11) {
						this.$Message.warning({
							content: this.$t('posting.evaluation'),
							duration: 2
						});
					} else if (data.resCode == -1) {
						this.$Message.warning({
							content: this.$t('posting.evaluation'),
							duration: 2
						});
					}
				});
			} else {
				this.$store.state.loginModal = true;
			}
		},
		changesdown: function changesdown(obj) {
			if (localStorage.getItem('token')) {
				var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'posting/evaluationstep/' + obj.postingId;
				this.$http.get(url).then(function (successData) {
					var that = this;
					var data = successData.data;
					if (data.resCode == 0) {
						obj.postingStepnums = data.result;
						obj.postingStatus = 1;
					} else if (data.resCode == -1) {
						this.$Message.warning({
							content: this.$t('posting.evaluation'),
							duration: 1
						});
					} else if (data.resCode == -11) {
						this.$Message.warning({
							content: this.$t('posting.evaluation'),
							duration: 1
						});
					}
				});
			} else {
				this.$store.state.loginModal = true;
			}
		},
		postingforward: function postingforward() {
			var _this2 = this;

			var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'posting/forward';
			this.$http.post(url, this.formValidatezf).then(function (successData) {
				var data = successData.data;
				_this2.forwardModal = false;
				if (data.resCode == 0) {
					_this2.$Message.success({
						content: _this2.$t('posting.forwardMessage'),
						duration: 2
					});
					for (var i = 0; i < _this2.postList.length; i++) {
						if (_this2.postList[i].postingId == _this2.formValidatezf.postingId) {
							_this2.postList[i].postingCountForword = data.result;
							break;
						}
					}
					_this2.formValidatezf.postingId = '';
					_this2.formValidatezf.postingForwardContext = '';
				} else if (data.resCode == -1) {
					_this2.$Message.error({
						content: _this2.$t('common.fail'),
						duration: 2
					});
				}
			}, function (error) {
				_this2.forwardModal = false;
			});
		},
		modalzf: function modalzf(obj, user) {
			if (localStorage.getItem('token')) {
				this.formValidatezf.postingId = obj.postingId;
				this.formValidatezf.postingForwardContext = '';
				this.postUserImage = user.image;
				this.postTitle = obj.postingTitle;
				this.postDate = obj.postingTime;
				this.postUserName = user.userName;
				this.postNickName = user.nickName;
				this.forwardModal = true;
			} else {
				this.$store.state.loginModal = true;
			}
		},
		postingforwardCancel: function postingforwardCancel() {
			this.forwardModal = false;
		},
		collectionPosting: function collectionPosting(posting) {
			if (!localStorage.getItem('token')) {
				this.$store.state.loginModal = true;
				return;
			}
			this.formCollection.userId = this.$store.state.user.id;
			this.formCollection.postingId = posting.postingId;
			this.$http.post(__WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'collection/saveCollectionPosting', this.formCollection).then(function (successData) {
				var data = successData.data;
				if (data.resCode == 0) {
					posting.postingCollection = 0;
				} else if (data.resCode == 1) {
					posting.postingCollection = -1;
				}
			});
		},
		dateFormat: function dateFormat(time) {
			var timeOffset = -28800000;
			if (this.user) {
				timeOffset = this.user.timeOffset;
			}
			return formatDate(time, timeOffset, this.$i18n.locale);
		}
	}
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    computed: {},
    created: function created() {},

    mounted: function mounted() {},
    watch: {},
    methods: {}

});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tagList: '',
            formValidate: {
                projectName: '',
                financingTarget: '',
                contacts: '',
                contactEmail: '',
                whitePaper: '',
                telegram: '',
                twitter: '',
                tag: [],
                projectDesc: ''
            },
            ruleValidate: {
                projectName: [{ required: true, message: 'The project name cannot be empty', trigger: 'blur' }],
                contacts: [{ required: true, message: 'The contacts cannot be empty', trigger: 'blur' }],
                whitePaper: [{ required: true, message: 'The whitePaper link cannot be empty', trigger: 'blur' }],
                telegram: [{ required: true, message: 'The telegram link cannot be empty', trigger: 'blur' }],
                twitter: [{ required: true, message: 'The twitter account cannot be empty', trigger: 'blur' }],
                contactEmail: [{ required: true, message: 'Mailbox cannot be empty', trigger: 'blur' }, { type: 'email', message: 'Incorrect email format', trigger: 'blur' }],
                tag: [{ required: false, type: 'array', min: 1, message: 'Choose at least one tag', trigger: 'change' }, { type: 'array', max: 3, message: 'Choose three tags at best', trigger: 'change' }],
                projectDesc: [{ required: true, message: 'Please enter a project description', trigger: 'blur' }, { type: 'string', min: 20, message: 'Description no less than 20 words', trigger: 'blur' }]
            }
        };
    },
    created: function created() {},

    mounted: function mounted() {
        this.getAllTag();
    },
    watch: {},
    computed: {},
    methods: {

        getAllTag: function getAllTag() {
            var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "tag/getAllTag";
            this.$http.get(url).then(function (successData) {
                var that = this;
                var data = successData.data;
                that.tagList = data;
            }, function (errorData) {
                this.$Message.error("Load Fail!");
            });
        },
        handleSubmit: function handleSubmit(name) {
            var _this = this;

            this.$refs[name].validate(function (valid) {
                if (valid) {
                    var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + 'project/creation';
                    _this.$http.post(url, _this.formValidate).then(function (successData) {
                        var data = successData.data;

                        if (data.resCode == 0) {
                            this.$refs[name].resetFields();
                            this.$Notice.info({
                                title: 'check pending',
                                desc: "Your project has been successfully created. Please wait for the administrator's approval.",
                                duration: 0
                            });
                            this.$router.push({ name: 'project' });
                            this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + 'project/noticeEmail/' + data.result).then(function (successData) {
                                var data = successData.data;

                                if (data.resCode == 0) {
                                    this.$Notice.info({
                                        title: 'Notification email was sent successfully',
                                        desc: "We have sent a notification email to the administrator, please wait for review."
                                    });
                                }
                            });
                        }
                    }, function (errorData) {
                        this.$Message.error('Sorry,server exception!');
                    });
                } else {
                    _this.$Message.error('Fail!');
                }
            });
        },
        handleReset: function handleReset(name) {
            this.$refs[name].resetFields();
        }
    }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            list: [],
            list1: [],
            userDetailList: [],
            value1: '2',
            isLogin: false
        };
    },

    created: function created() {},
    mounted: function mounted() {
        this.findProject();
    },
    methods: {
        findProject: function findProject() {
            var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "project/projectList";
            this.$http.get(url).then(function (successData) {
                var that = this;
                var data = successData.data;
                var length = 3;
                that.list = data.result.projectList;
                that.userDetailList = data.result.userDetailList;
                for (var i = 0; i < length; i++) {
                    that.list1.push(that.list[i]);
                }
            }, function (errorData) {
                this.$Message.error('Error!');
            });
        },
        handleReachBottom: function handleReachBottom() {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                setTimeout(function () {
                    var listLength = _this.list.length;
                    var listLength1 = _this.list1.length;
                    if (listLength - listLength1 != listLength % 3) {
                        for (var i = 1; i < 4; i++) {
                            _this.list1.push(_this.list[listLength1 - 1 + i]);
                        }
                    } else {
                        for (var _i = 1; _i < listLength % 3 + 1; _i++) {
                            _this.list1.push(_this.list[listLength1 - 1 + _i]);
                        }
                        _this.text = '数据已经到底了';
                    }
                    resolve();
                }, 1000);
            });
        },
        dateFormat: function dateFormat(time) {
            return formatDate(time);
        },

        iob: function iob() {
            this.$router.push({ name: 'home' });
        },
        project: function project() {
            this.$router.go(0);
        },
        posting: function posting() {
            this.$router.push({ name: 'posting' });
        },

        userInformation: function userInformation(userId) {
            this.$router.push({ name: 'userInformation', params: { userId: userId } });
        },
        getAllTag: function getAllTag() {
            var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "tag/getAllTag";
            this.$http.get(url).then(function (successData) {
                var that = this;
                var data = successData.data;
                that.tagList = data;
            }, function (errorData) {
                this.$Message.error("Load Fail!");
            });
        },
        gotoRegister: function gotoRegister() {
            this.$router.push({ name: 'register' });
        },
        gotoLogin: function gotoLogin() {
            this.$router.push({ name: 'login' });
        },
        projectDetail: function projectDetail(projectId, userId) {
            this.$router.push({ name: 'projectDetail', params: { projectId: projectId, userId: userId } });
        },
        createProject: function createProject() {
            this.$router.push({ name: 'createProject' });
        }
    }

});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var commentText = function commentText(rule, value, callback) {
			if (value == 0) {
				callback(new Error('Please enter a personal introduction'));
			} else if (value < 10) {
				callback(new Error('Introduce no less than 10 words'));
			} else {
				callback();
			}
		};
		return {
			project: [],
			userDetail: [],
			projectCommentList: [],
			isShowUserDetail: false,
			isShowCommentText: true,
			isShowcomments: false,
			formValidate: {
				commentProjectId: '',
				commentText: ''
			},
			ruleValidate: {
				commentText: [{ required: true, validator: commentText, trigger: 'blur' }]
			}
		};
	},

	watch: {
		'$route': 'projectDetail'
	},

	mounted: function mounted() {
		this.projectDetail();
	},
	methods: {
		projectDetail: function projectDetail() {
			var projectId = this.$route.params.projectId;
			var userId = this.$route.params.userId;
			var projectUrl = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].baseUrl + "project/projectDetail/" + projectId;
			var that = this;
			that.formValidate.commentProjectId = projectId;
			this.$http.get(projectUrl).then(function (successData) {
				var data = successData.data;
				that.project = data.result;
			}, function (errorData) {
				this.$Message.error("Sorry, server error!");
			});
			var userUrl = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].baseUrl + "user/userDetail/" + userId;
			this.$http.get(userUrl).then(function (successData) {
				var data = successData.data;
				that.userDetail = data.result;
			}, function (errorData) {
				this.$Message.error("Sorry, server error!");
			});
			var commentUrl = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].baseUrl + "projectComment/getProjectComment/" + projectId;
			this.$http.get(commentUrl).then(function (successData) {
				var data = successData.data;
				that.projectCommentList = data.result;
			}, function (errorData) {
				this.$Message.error("Sorry, server error!");
			});
		},

		commentsshow: function commentsshow() {
			this.isShowcomments = !this.isShowcomments;
		},
		submitComment: function submitComment(name) {
			var _this = this;

			this.$refs[name].validate(function (valid) {
				if (valid) {
					var url = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].baseUrl + "projectComment/addProjectComment";
					var that = _this;
					_this.$http.post(url, _this.formInline, _this.ruleInline).then(function (successData) {
						var data = successData.data;
						if (data.resCode == 0) {
							this.$Message.success('Success!');
						} else if (data.resCode == -1) {
							this.$Message.error('Fail!');
						}
					}, function (errorData) {
						this.$Message.error('Fail!');
					});
				} else {
					_this.$Message.error('Fail!');
				}
			});
		},
		closeComment: function closeComment(name) {
			this.isShowcomments = false;
			this.$refs[name].resetFields();
		},

		showUserDetail: function showUserDetail() {
			this.isShowUserDetail = !this.isShowUserDetail;
		},

		hideUserDetail: function hideUserDetail() {
			var that = this;
			setTimeout(function () {
				that.isShowUserDetail = !that.isShowUserDetail;
			}, 1000);
		},

		toggletext: function toggletext(index) {
			this.isShowCommentText = !this.isShowCommentText;
		},

		supportProject: function supportProject(event) {
			var projectId = this.$route.params.projectId;
			var url = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].baseUrl + "project/support/" + projectId;
			this.$http.get(url).then(function (successData) {
				var that = this;
				var data = successData.data;
				if (event.target.style.color == 'red') {
					event.target.style.color = 'gray';
				} else {
					event.target.style.color = 'red';
				}
				if (data.resCode == 0) {
					that.project.supportNumber = data.result;
				} else if (data.resCode == 1) {
					that.project.supportNumber = data.result;
				}
			}, function (errorData) {
				this.$Message.error("Fail!");
			});
		},

		opposeProject: function opposeProject(event) {
			var projectId = this.$route.params.projectId;
			var url = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].baseUrl + "project/oppose/" + projectId;
			this.$http.get(url).then(function (successData) {
				var that = this;
				var data = successData.data;
				if (event.target.style.color == 'red') {
					event.target.style.color = 'gray';
				} else {
					event.target.style.color = 'red';
				}
				if (data.resCode == 0) {
					that.project.opposeNumber = data.result;
				} else if (data.resCode == 1) {
					that.project.opposeNumber = data.result;
				}
			}, function (errorData) {
				this.$Message.error("Fail!");
			});
		},
		dateFormat: function dateFormat(time) {
			return formatDate(time);
		}
	}
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            pageNo: 0,

            pageSize: 5,
            isLoading: false,
            isNoMoreData: false,

            isSendRequest: true,
            projectList: [],
            userDetailList: []
        };
    },
    mounted: function mounted() {
        this.findProject();
    },
    create: function create() {},

    directives: {
        scroll: {
            bind: function bind(el, binding) {
                el.addEventListener('scroll', function () {
                    var containerHeight = el.clientHeight;
                    var scrollTop = el.scrollTop;
                    var contentHeight = el.scrollHeight;
                    if (scrollTop + containerHeight >= contentHeight) {
                        binding.value();
                    }
                });
            }
        }
    },

    methods: {
        findProject: function findProject() {
            if (this.isSendRequest) {
                var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "project/projectList/" + this.pageNo + "/" + this.pageSize;
                this.$http.get(url).then(function (successData) {
                    var data = successData.data;
                    this.projectList = data.result.projectList;
                    this.userDetailList = data.result.userDetailList;
                    this.pageNo = this.pageNo + 1;
                }, function (errorData) {
                    this.$Message.error('Error!');
                });
            }
        },
        loadMore: function loadMore() {
            var _this = this;

            if (this.isLoading) {
                return;
            }
            if (this.isSendRequest) {
                this.isLoading = true;
                var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "project/projectList/" + this.pageNo + "/" + this.pageSize;
                this.$http.get(url).then(function (successData) {
                    var data = successData.data;
                    if (data.resCode == 0) {
                        _this.projectList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.projectList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result.projectList));
                        var udList = data.result.userDetailList;

                        for (var i = 0; i < _this.userDetailList.length; i++) {
                            for (var j = 0; j < udList.length; j++) {
                                if (_this.userDetailList[i].id == udList[j].id) {
                                    udList.splice(j, 1);
                                }
                            }
                        }

                        _this.userDetailList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.userDetailList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(udList));
                        _this.pageNo = _this.pageNo + 1;
                    }
                    _this.isLoading = false;
                    if (data.resCode == -1) {
                        _this.isSendRequest = false;
                        _this.isNoMoreData = true;
                        setTimeout(function () {
                            _this.isNoMoreData = false;
                        }, 3000);
                    }
                });
            }
        },

        userInformation: function userInformation(userId) {
            this.$router.push({ name: 'userInformation', params: { userId: userId } });
        },
        projectDetail: function projectDetail(projectId, userId) {
            this.$router.push({ name: 'projectDetail', params: { projectId: projectId, userId: userId } });
        },
        createProject: function createProject() {
            this.$router.push({ name: 'createProject' });
        },
        dateFormat: function dateFormat(time) {
            return formatDate(time);
        }
    }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            userRequest: {},
            file: null,
            uploadLoading: false,
            isShowUploadDiv: true };
    },
    created: function created() {},
    mounted: function mounted() {
        this.verifyLink();
    },

    watch: {
        '$router': 'verifyLink'
    },
    methods: {
        verifyLink: function verifyLink() {
            var _this = this;

            var currentUrl = window.location.href;
            var requestId = currentUrl.substring(currentUrl.lastIndexOf("/") + 1, currentUrl.length);
            var verifyUrl = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + 'request/open/verifyRequest?requestId=' + requestId;
            this.$http.get(verifyUrl).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this.userRequest = data.result;
                    _this.isShowUploadDiv = true;
                } else {
                    _this.userRequest = {};
                    _this.isShowUploadDiv = false;
                }
            });
        },
        beforeUpload: function beforeUpload(file) {
            var fileName = file.name;
            var suffix = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length).toLowerCase();
            if (suffix == "jpg" || suffix == "jpeg" || suffix == "png") {
                var fileSize = file.size;
                if (fileSize > 1024 * 1024) {
                    this.file = null;
                    this.$Message.error({
                        content: this.$t('uploadMaterial.message.tooLarge'),
                        duration: 5,
                        closable: true
                    });
                } else {
                    this.file = file;
                }
            } else {
                this.file = null;

                this.$Message.error({
                    content: this.$t('uploadMaterial.message.formatIncorrect'),
                    duration: 5,
                    closable: true
                });
            }

            return false;
        },
        clearFile: function clearFile() {
            this.file = null;
        },
        uploadFile: function uploadFile() {
            var _this2 = this;

            this.uploadLoading = true;
            var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "request/open/uploadFile/" + this.userRequest.userRequestId;

            var fileData = new FormData();
            fileData.append('upfile', this.file);
            this.$http.post(url, fileData).then(function (successData) {
                _this2.uploadLoading = false;
                _this2.clearFile();
                var data = successData.data;
                if (data.resCode == 0) {
                    _this2.sendNoticeEmail();
                    _this2.$Notice.success({
                        title: _this2.$t('uploadMaterial.message.uploadSuccessTitle'),
                        duration: 10,
                        desc: _this2.$t('uploadMaterial.message.uploadSuccessDesc')
                    });
                    _this2.$router.push({ name: "home" });
                } else {
                    _this2.$Message.error(_this2.$t("common.fail"));
                }
            }, function (error) {
                _this2.$Message.error(_this2.$t("common.fail"));
                _this2.uploadLoading = false;
            });
        },
        sendNoticeEmail: function sendNoticeEmail() {
            var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "sendEmail/open/sendUploadMaterialNoticeEmail?userRequestId=" + this.userRequest.userRequestId;
            this.$http.get(url).then(function (response) {});
        }
    }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            issueSelect: [{ label: this.$t('userRequest.issueSelect.account'), value: 'ACCOUNT' }, { label: this.$t('userRequest.issueSelect.password'), value: 'PASSWORD' }, { label: this.$t('userRequest.issueSelect.googleAuth'), value: '2FA' }, { label: this.$t('userRequest.issueSelect.wallet'), value: 'WAllET' }, { label: this.$t('userRequest.issueSelect.other'), value: 'OTHER' }],

            userRequestVaild: true,

            userRequestBtnLoading: false,

            userRequestForm: {
                issue: '',
                regEmail: '',
                subject: '',
                description: ''
            },

            issueRules: [function (v) {
                return !!v || _this.$t('userRequest.rules.issue.required');
            }],

            regEmailRules: [function (v) {
                return !!v || _this.$t('userRequest.rules.regEmail.required');
            }, function (v) {
                return (/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(v) || _this.$t('userRequest.rules.regEmail.valid')
                );
            }],

            subjectRules: [function (v) {
                return !!v || _this.$t('userRequest.rules.subject.required');
            }, function (v) {
                return v && v.length <= 50 || _this.$t('userRequest.rules.subject.valid');
            }],

            descriptionRules: [function (v) {
                return !!v || _this.$t('userRequest.rules.description.required');
            }, function (v) {
                return v && v.length <= 1000 || _this.$t('userRequest.rules.description.valid');
            }]
        };
    },
    created: function created() {},
    mounted: function mounted() {
        this.loadRegEmail();
    },

    watch: {},
    methods: {
        loadRegEmail: function loadRegEmail() {
            var _this2 = this;

            if (localStorage.getItem('token')) {
                var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "user/open/getRegEmailById?userId=" + this.$store.state.user.id;
                this.$http.get(url).then(function (response) {
                    var data = response.data;
                    if (data.resCode == 0) {
                        _this2.userRequestForm.regEmail = data.result;
                    }
                });
            }
        },
        submitRequest: function submitRequest() {
            var _this3 = this;

            if (this.$refs.userRequestForm.validate()) {
                var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "request/open/submitRequest";
                this.userRequestBtnLoading = true;
                this.$http.post(url, this.userRequestForm).then(function (response) {
                    var data = response.data;
                    _this3.userRequestBtnLoading = false;
                    if (data.resCode == 0) {
                        _this3.sendNoticeEmail(data.result.userRequestId);

                        _this3.clearUserRequestForm();

                        _this3.$Notice.success({
                            title: _this3.$t('userRequest.submitSuccessTitle'),
                            duration: 10,
                            desc: _this3.$t('userRequest.submitSuccessDesc')
                        });

                        _this3.$router.push({ name: 'home' });
                    } else if (data.resCode == -1) {
                        _this3.$Message.error({
                            content: _this3.$t("lostGoogleAuthentication.emailAddressNotExist"),
                            duration: 3
                        });
                    }
                }, function (error) {
                    _this3.userRequestBtnLoading = false;
                });
            }
        },
        clearUserRequestForm: function clearUserRequestForm() {
            this.$refs.userRequestForm.reset();
        },
        sendNoticeEmail: function sendNoticeEmail(userRequestId) {
            var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "sendEmail/open/sendSubmitRequestNoticeEmail?userRequestId=" + userRequestId;
            this.$http.get(url).then(function (response) {});
        }
    }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            list: []
        };
    },
    created: function created() {},
    mounted: function mounted() {},

    watch: {},
    methods: {
        infiniteHandler: function infiniteHandler($state) {
            var _this = this;

            console.log(1);
            setTimeout(function () {
                var temp = [];
                for (var i = _this.list.length + 1; i <= _this.list.length + 20; i++) {
                    temp.push(i);
                }
                _this.list = _this.list.concat(temp);
                $state.loaded();
            }, 1000);
        }
    },
    components: {
        InfiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a
    }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



var easings = {
  linear: '',
  easeInQuad: '',
  easeOutQuad: '',
  easeInOutQuad: '',
  easeInCubic: '',
  easeOutCubic: '',
  easeInOutCubic: '',
  easeInQuart: '',
  easeOutQuart: '',
  easeInOutQuart: '',
  easeInQuint: '',
  easeOutQuint: '',
  easeInOutQuint: ''
};
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      type: 'number',
      number: 9999,
      selector: '#first',
      selected: 'Button',
      elements: ['Button', 'Radio group'],
      duration: 300,
      offset: 0,
      easing: 'easeInOutCubic',
      easings: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(easings),
      sendTime: null,
      sendTime1: null,
      sendTime2: null
    };
  },

  computed: {
    target: function target() {
      var value = this[this.type];
      if (!isNaN(value)) return Number(value);else return value;
    },
    options: function options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing
      };
    },
    element: function element() {
      if (this.selected === 'Button') return this.$refs.button;else if (this.selected === 'Radio group') return this.$refs.radio;
    }
  },
  methods: {
    getTimeAndPrice: function getTimeAndPrice() {
      var _this = this;

      var sendTimeStamp = this.sendTime.valueOf();

      var timeStamp1 = sendTimeStamp - 5 * 60 * 1000;
      var timeStamp2 = sendTimeStamp + 5 * 60 * 1000;
      this.$http.get("https://graphs2.coinmarketcap.com/currencies/bitcoin/" + timeStamp1 + "/" + timeStamp2 + "/").then(function (response) {
        var data = response.data;
        var price_usd = data.price_usd;
        var array1 = price_usd[0];
        var array2 = price_usd[1];
        var timeStamp1 = array1[0];
        var timeStamp2 = array2[0];
        _this.sendTime1 = new Date(timeStamp1);
        _this.sendTime2 = new Date(timeStamp2);
      });
    }
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            userId: this.$store.state.user.id,
            investmentList: [],
            investmentPeople: {} };
    },

    computed: {},
    created: function created() {},
    mounted: function mounted() {
        this.getInvestment();
    },

    watch: {},
    methods: {
        getInvestment: function getInvestment() {
            var _this = this;

            var investmentUrl = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + 'investment/getInvestmentByUserId/' + this.userId;
            this.$http.get(investmentUrl).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this.investmentList = data.result;
                    _this.investmentPeople = _this.investmentList[0];
                    console.log(_this.investmentPeople);
                } else {
                    _this.investmentList = [];
                }
            });
        }
    }

});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            investmentId: this.$route.params.investmentId,
            investment: {} };
    },

    computed: {},
    created: function created() {
        this.getInvestmentById();
    },
    mounted: function mounted() {},

    watch: {
        $route: function $route() {
            this.investmentId = this.$route.params.investmentId;
        },
        investmentId: function investmentId() {
            this.getInvestmentById();
        }
    },
    methods: {
        getInvestmentById: function getInvestmentById() {
            this.investment = JSON.parse(sessionStorage.getItem('investment'));
        }
    }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isLoading: true,
            headers: [{ text: this.$t('transaction.txHash'), align: 'left', value: 'txHash', sortable: false }, { text: this.$t('transaction.date'), align: 'left', value: 'date', sortable: false }, { text: this.$t('transaction.from'), align: 'left', value: 'from', sortable: false }, { text: this.$t('transaction.to'), align: 'left', value: 'to', sortable: false }, { text: this.$t('transaction.quantity'), align: 'left', value: 'quantity', sortable: false }],
            transactionList: [],
            totalTransactionNumber: 0,
            pageNo: 1,
            pageSize: 20,
            totalPage: 1,
            params: ["0xaf29be288274e907f948e148b1e757e29c046cbd", "latest"],
            params2: ['0x7f64eae019f8058449d2131d99f1c47e4f153a4897faa6a83f4bc9c2f7b8e865']
        };
    },

    computed: {},
    created: function created() {},

    mounted: function mounted() {
        this.getTransactionList();
    },
    watch: {},
    methods: {
        getTransactionList: function getTransactionList() {
            var _this = this;

            var transactionCountUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "token/open/getTransactionCount";
            this.$http.get(transactionCountUrl).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this.totalTransactionNumber = data.result;
                    _this.totalPage = Math.ceil(_this.totalTransactionNumber / _this.pageSize);
                }
            });
            var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "token/open/getTransactionList/" + this.pageNo + "/" + this.pageSize;
            this.$http.get(url).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this.transactionList = data.result;
                    _this.isLoading = false;
                    _this.pageNo = _this.pageNo + 1;
                }
            });
        },
        timeStampToTime: function (_timeStampToTime) {
            function timeStampToTime(_x) {
                return _timeStampToTime.apply(this, arguments);
            }

            timeStampToTime.toString = function () {
                return _timeStampToTime.toString();
            };

            return timeStampToTime;
        }(function (timeStamp) {
            return timeStampToTime(timeStamp);
        }),
        subToHash: function subToHash(input) {
            var to = '0x' + input.substring(34, 74);
            return to.length > 18 ? to.substring(0, 18) + '...' : to;
        },
        getTransactionByPage: function getTransactionByPage(pageNo) {
            var _this2 = this;

            var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "token/open/getTransactionList/" + pageNo + "/" + this.pageSize;
            this.$http.get(url).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this2.transactionList = data.result;
                    _this2.pageNo = _this2.pageNo + 1;
                }
            });
        },
        goTransactionData: function goTransactionData(transaction) {
            sessionStorage.setItem('transaction', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(transaction));
            this.$router.push({ name: 'transactionData', params: { txHash: transaction.hash } });
        },
        getQuantity: function getQuantity(input) {
            var sixteen = input.substring(74, 138);
            var ten = parseInt(sixteen, 16);
            return ten / 1E18;
        }
    }

});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qrcode__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qrcode__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            txHash: this.$route.params.txHash,
            transaction: {},
            isShowQRCode: false };
    },

    computed: {},
    created: function created() {
        this.getTransactionByTxHash();
    },
    mounted: function mounted() {},

    watch: {
        $route: function $route() {
            this.txHash = this.$route.params.txHash;
        },
        txHash: function txHash() {
            this.getTransactionByTxHash();
        }
    },
    methods: {
        getTransactionByTxHash: function getTransactionByTxHash() {
            this.transaction = JSON.parse(sessionStorage.getItem('transaction'));
        },
        timeStampToTime: function (_timeStampToTime) {
            function timeStampToTime(_x) {
                return _timeStampToTime.apply(this, arguments);
            }

            timeStampToTime.toString = function () {
                return _timeStampToTime.toString();
            };

            return timeStampToTime;
        }(function (timeStamp) {
            return timeStampToTime(timeStamp);
        }),
        subToHash: function subToHash(input) {
            var to = '0x' + input.substring(34, 74);
            return to;
        },
        numberToString: function numberToString(number) {
            var num = number / 1E18;

            return num;
        },
        getQuantity: function getQuantity(input) {
            var sixteen = input.substring(74, 138);
            var ten = parseInt(sixteen, 16);
            return ten / 1E18;
        },
        copyTxHash: function copyTxHash() {
            var _this = this;

            var clipboard = new __WEBPACK_IMPORTED_MODULE_2_clipboard___default.a('.txHash');
            clipboard.on('success', function (e) {
                _this.$Message.success(_this.$t("common.copySuccess"));

                clipboard.destroy();
            });
            clipboard.on('error', function (e) {
                _this.$Message.error(_this.$t("common.copyFailure"));

                clipboard.destroy();
            });
        },
        copyContract: function copyContract() {
            var _this2 = this;

            var clipboard = new __WEBPACK_IMPORTED_MODULE_2_clipboard___default.a('.contract');
            clipboard.on('success', function (e) {
                _this2.$Message.success(_this2.$t("common.copySuccess"));

                clipboard.destroy();
            });
            clipboard.on('error', function (e) {
                _this2.$Message.error(_this2.$t("common.copyFailure"));

                clipboard.destroy();
            });
        },
        generateQRCode: function generateQRCode(event) {
            var canvas = document.getElementById('canvas');
            canvas.style.position = 'fixed';
            canvas.style.top = event.clientY + 20;
            canvas.style.left = event.clientX + 20;
            this.isShowQRCode = !this.isShowQRCode;
            __WEBPACK_IMPORTED_MODULE_3_qrcode___default.a.toCanvas(canvas, this.transaction.contractAddress, function (error) {});
        },
        hideQRCode: function hideQRCode() {
            this.isShowQRCode = false;
        }
    }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isShowLink: false,
      isShowMessage: false
    };
  },

  mounted: function mounted() {
    this.verifyLink();
    this.background();
  },
  methods: {
    background: function background() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()("[data-bg-image]").each(function () {
        var img = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data("bg-image");
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).css({
          backgroundImage: "url(" + img + ")"
        });
      });
    },
    autodivheight: function autodivheight() {
      var winHeight = 0;
      if (window.innerHeight) {
        winHeight = window.innerHeight;
      } else if (document.body && document.body.clientHeight) {
        winHeight = document.body.clientHeight;
      }
      if (document.documentElement && document.documentElement.clientHeight) {
        winHeight = document.documentElement.clientHeight;
      }

      document.getElementById("content").style.height = winHeight + "px";
    },
    verifyLink: function verifyLink() {
      var _this = this;

      var currentUrl = window.location.href;
      var email = currentUrl.substring(currentUrl.indexOf("=", 1) + 1, currentUrl.indexOf("#", 1));
      this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].baseUrl + "emailLink/open/verifyLink?regEmail=" + email).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this.isShowLink = true;
          _this.isShowMessage = false;
        } else if (data.resCode == -1) {
          _this.isShowLink = false;
          _this.isShowMessage = true;
          _this.$Notice.warning({
            title: "Warning",
            desc: "The email is not registered or has been updated. "
          });
        } else if (data.resCode == -2) {
          _this.isShowLink = false;
          _this.isShowMessage = true;
          _this.$Notice.warning({
            title: "Warning",
            desc: "The email has been activated. "
          });
        } else if (data.resCode == -3) {
          _this.isShowLink = false;
          _this.isShowMessage = true;
          _this.$Notice.warning({
            title: "Warning",
            desc: "The link has timed out. "
          });
        }
      }, function (errorData) {
        _this.$Message.error(_this.$t("common.error"));
      });
    },
    gotoresgistersuccess: function gotoresgistersuccess() {
      this.$router.push({ name: "resgistersuccess" });
    },
    goHome: function goHome() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].ip;
    },
    register: function register() {
      var _this2 = this;

      var url = window.location.href;
      var email = url.substring(url.indexOf("=", 1) + 1, url.indexOf("#", 1));
      var url1 = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].baseUrl + "user/open/register/activateEmail?regEmail=" + email;
      var that = this;
      this.$http.get(url1, this.formInline).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this2.$Message.success("success");
          _this2.$router.push({ name: "registersuccess" });
        } else if (data.resCode == -1) {
          _this2.$Message.error("The account does not exist!");
        } else if (data.resCode == -2) {
          _this2.$Message.error("The account has been activated!");
        } else if (data.resCode == -3) {
          _this2.$Message.error(_this2.$t("common.error"));
        } else {
          _this2.$router.push({ name: "activation" });
        }
      }, function (errorData) {
        _this2.$Message.error(_this2.$t("common.error"));
      });
    }
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      isShowLinkDiv: false,
      closeAuthenticationValid: true,
      passWord: "",
      closeAuthenticationForm: {
        id: null,
        regEmail: null,
        authenticationSecret: null,
        passWord: null },
      passWordRules: [function (v) {
        return !!v || _this.$t("header.passwordHintEmpty");
      }, function (v) {
        return v && v.length >= 8 || _this.$t("header.passwordHintLength");
      }]
    };
  },

  computed: {},
  created: function created() {
    this.verifyLink();
  },
  mounted: function mounted() {},

  watch: {
    $route: "verifyLink"
  },
  methods: {
    verifyLink: function verifyLink() {
      var _this2 = this;

      var currentUrl = window.location.href;
      var emailLinkId = currentUrl.substring(currentUrl.lastIndexOf("/") + 1, currentUrl.length);
      var verifyUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "emailLink/open/verifyGoogleCodeLink?emailLinkId=" + emailLinkId;
      this.$http.get(verifyUrl).then(function (response) {
        var data = response.data;
        if (data.resCode == 0) {
          _this2.isShowLinkDiv = true;
          _this2.closeAuthenticationForm.id = data.result.userId;
          _this2.closeAuthenticationForm.regEmail = data.result.regEmail;
          _this2.closeAuthenticationForm.authenticationSecret = data.result.authenticationSecret;
        } else if (data.resCode == -1) {} else if (data.resCode == -2) {}
      });
    },
    closeAuthentication: function closeAuthentication() {
      var _this3 = this;

      if (this.$refs.closeAuthenticationForm.validate()) {
        var closeAuthenticationUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "user/open/closeAuthenticationBySecret";
        var password = __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(this.passWord);
        password = password.split("").reverse().join("");
        this.closeAuthenticationForm.passWord = __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(password);
        this.$http.post(closeAuthenticationUrl, this.closeAuthenticationForm).then(function (response) {
          var data = response.data;
          if (data.resCode == 0) {
            _this3.sendCloseAuthenticationNoticeEmail();
            _this3.$refs.closeAuthenticationForm.reset();
            _this3.passWord = "";
            _this3.goHomePage();
          } else if (data.resCode == -4) {
            _this3.$Message.error(_this3.$t("header.passwordWrongMessage"));
          }
        });
      }
    },
    sendCloseAuthenticationNoticeEmail: function sendCloseAuthenticationNoticeEmail() {
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "sendEmail/open/sendCloseAuthenticationNoticeEmail?email=" + this.closeAuthenticationForm.regEmail);
    },
    goHomePage: function goHomePage() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].ip;
    }
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qrcode__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qrcode__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        var validateId = function validateId(rule, value, callback) {
            if (value === '') {
                callback(new Error(_this.$t("enableAuthentication.errorCallback.idBeEmpty")));
            } else {
                callback();
            }
        };
        var validateAuthenticationSecret = function validateAuthenticationSecret(rule, value, callback) {
            if (value === '') {
                callback(new Error(_this.$t("enableAuthentication.errorCallback.secretBeEmpty")));
            } else {
                callback();
            }
        };
        var validateRandomCode = function validateRandomCode(rule, value, callback) {
            if (!value) {
                callback(new Error(_this.$t("enableAuthentication.errorCallback.codeBeEmpty")));
            } else if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
                callback(new Error(_this.$t("enableAuthentication.errorCallback.codeValue")));
            } else if ((value + '').length !== 6) {
                callback(new Error(_this.$t("enableAuthentication.errorCallback.codeDigits")));
            } else {
                callback();
            }
        };
        return {
            qrcode: '#',
            formCustom: {
                id: '',
                authenticationSecret: '',
                randomCode: ''
            },
            ruleCustom: {
                id: [{ validator: validateId, trigger: 'blur' }],
                authenticationSecret: [{ validator: validateAuthenticationSecret, trigger: 'blur' }],
                randomCode: [{ validator: validateRandomCode, trigger: 'blur' }]
            },
            randomCodeRules: [function (v) {
                return !!v || '';
            }, function (v) {
                return v && v.length == 6 || '';
            }, function (v) {
                return (/^\d{6}$/.test(v) || ''
                );
            }]
        };
    },

    computed: {},
    created: function created() {},

    mounted: function mounted() {
        var _this2 = this;

        this.getUser();

        $(document).on('keypress', '#enter-verify-code', function (event) {
            if (event.keyCode == 13) {
                _this2.verityRandomCode('formCustom');
            }
        });
    },
    watch: {
        '$route': 'getUser'
    },
    methods: {
        getUser: function getUser() {
            var _this3 = this;

            var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "userDetail/getMe";
            this.$http.get(url).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    var userDetail = data.result;
                    _this3.formCustom.id = userDetail.userId;
                    _this3.formCustom.authenticationSecret = data.result.authenticationSecret;

                    var canvas = document.getElementById('canvas');
                    __WEBPACK_IMPORTED_MODULE_4_qrcode___default.a.toCanvas(canvas, userDetail.qrcode, function (error) {});
                } else {
                    _this3.$Message.error(_this3.$t("common.serverError"));
                }
            }, function (errorData) {
                _this3.$Message.error(_this3.$t("common.serverError"));
            });
        },
        copySecretKey: function copySecretKey() {
            var _this4 = this;

            var clipboard = new __WEBPACK_IMPORTED_MODULE_2_clipboard___default.a('.secretKey');
            clipboard.on('success', function (e) {
                _this4.$Message.success(_this4.$t("common.copySuccess"));

                clipboard.destroy();
            });
            clipboard.on('error', function (e) {
                _this4.$Message.error(_this4.$t("common.copyFailure"));

                clipboard.destroy();
            });
        },
        verityRandomCode: function verityRandomCode(name) {
            var _this5 = this;

            if (this.$refs[name].validate()) {
                var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "user/updateAuthenticationStatus";
                this.$http.post(url, this.formCustom).then(function (successData) {
                    var data = successData.data;
                    _this5.formCustom.randomCode = '';
                    if (data.resCode == 0) {
                        _this5.$Message.success(_this5.$t("common.success"));
                        sessionStorage.setItem('authentication', true);
                        _this5.$router.push({ name: 'userSetting' });
                        location.reload();
                    } else if (data.resCode == -1) {
                        _this5.$Message.error(_this5.$t("enableAuthentication.dangerousMsg"));
                    } else if (data.resCode == -2) {
                        _this5.$Message.error(_this5.$t("enableAuthentication.verificationCodeError"));
                    } else if (data.resCode == -3) {
                        _this5.$Message.error(_this5.$t("common.serverError"));
                    }
                }, function (errorData) {
                    _this5.$Message.error(_this5.$t("common.fail"));
                    _this5.formCustom.randomCode = '';
                });
            } else {
                this.$Message.error(this.$t("common.fail"));
                this.formCustom.randomCode = '';
            }
        },
        handleSubmit: function handleSubmit(name) {
            var _this6 = this;

            alert(this.formCustom.randomCode);
            this.$refs[name].validate(function (valid) {
                if (valid) {
                    var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "user/updateAuthenticationStatus";
                    _this6.$http.post(url, _this6.formCustom).then(function (successData) {
                        var data = successData.data;
                        _this6.formCustom.randomCode = '';
                        if (data.resCode == 0) {
                            _this6.$Message.success(_this6.$t("common.success"));
                            sessionStorage.setItem('authentication', true);
                            _this6.$router.push({ name: 'userSetting' });
                            location.reload();
                        } else if (data.resCode == -1) {
                            _this6.$Message.error(_this6.$t("enableAuthentication.dangerousMsg"));
                        } else if (data.resCode == -2) {
                            _this6.$Message.error(_this6.$t("enableAuthentication.verificationCodeError"));
                        } else if (data.resCode == -3) {
                            _this6.$Message.error(_this6.$t("common.serverError"));
                        }
                    }, function (errorData) {
                        _this6.$Message.error(_this6.$t("common.fail"));
                        _this6.formCustom.randomCode = '';
                    });
                } else {
                    _this6.$Message.error(_this6.$t("common.fail"));
                    _this6.formCustom.randomCode = '';
                }
            });
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var validateAuthenticationSecret = function validateAuthenticationSecret(rule, value, callback) {
            if (value === '') {
                callback(new Error('The authenticationSecret cannot be empty'));
            } else {
                callback();
            }
        };
        var validateRandomCode = function validateRandomCode(rule, value, callback) {
            if (!value) {
                callback(new Error('The randomCode cannot be empty'));
            } else if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(+value)) {
                callback(new Error('Please enter a numeric value'));
            } else if ((value + '').length !== 6) {
                callback(new Error('Must be 6 digits'));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            authLoading: true,
            loginAuthenticationModal: false,
            isSaveUser: false,
            formInline: {
                userName: '',
                passWord: ''
            },
            formAuthentication: {
                authenticationSecret: '',
                randomCode: ''
            },
            userId: {
                id: ''
            },
            ruleAuthentication: {
                authenticationSecret: [{ validator: validateAuthenticationSecret, trigger: 'blur' }],
                randomCode: [{ validator: validateRandomCode, trigger: 'blur' }]
            },
            ruleInline: {
                userName: [{ required: true, message: 'Please enter your username or email', trigger: 'blur' }],
                passWord: [{ required: true, message: 'Please enter the password', trigger: 'blur' }, { type: 'string', min: 8, message: 'The password length cannot be less than 8 bits', trigger: 'blur' }]
            }
        };
    },
    mounted: function mounted() {
        window.onresize = this.autodivheight();

        this.getCookie();
    },

    methods: {
        autodivheight: function autodivheight() {
            var winHeight = 0;
            if (window.innerHeight) {
                winHeight = window.innerHeight;
            } else if (document.body && document.body.clientHeight) {
                winHeight = document.body.clientHeight;
            }
            if (document.documentElement && document.documentElement.clientHeight) {
                winHeight = document.documentElement.clientHeight;
            }

            document.getElementById("content").style.height = winHeight + "px";
        },

        gotoRegister: function gotoRegister() {
            this.$router.push({ name: 'register' });
        },
        findPassword: function findPassword() {
            this.$router.push({ name: 'password' });
        },
        handleSubmit: function handleSubmit(name) {
            var _this = this;

            this.$refs[name].validate(function (valid) {
                if (valid) {
                    _this.loading = true;
                    var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "user/open/loginPost";

                    if (_this.isSaveUser) {
                        _this.setCookieUser(_this.formInline.userName, 3650);

                        _this.setCookiePassword(_this.formInline.passWord, 3650);
                    } else {
                        _this.setCookieUser("", -1);
                        _this.setCookiePassword("", -1);
                    }
                    var that = _this;
                    _this.$http.post(url, _this.formInline).then(function (successData) {
                        var data = successData.data;
                        if (data.resCode == 0) {
                            that.$store.state.user.name = data.result.userName;
                            that.$store.state.user.token = data.result.token;
                            that.$store.state.user.id = data.result.id;
                            that.$Message.success('Login successful!');
                            localStorage.setItem("userName", data.result.userName);
                            localStorage.setItem("id", data.result.id);
                            localStorage.setItem("token", data.result.token);
                            localStorage.setItem("image", data.result.image);
                            localStorage.setItem("invitationCode", data.result.invitationCode);
                            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.interceptors.push(function (request, next) {
                                request.credentials = true;

                                request.headers.set('Authorization', 'Bearer ' + data.result.token);
                                next();
                            });
                            that.formInline.userName = '';
                            that.formInline.passWord = '';
                            that.$router.push({ name: 'posting' });
                        } else if (data.resCode == -1000) {
                            this.$Message.error('The user does not exist!');
                            this.loading = false;
                        } else if (data.resCode == -1001) {
                            this.$Message.error('Wrong password!');
                            this.loading = false;
                        } else if (data.resCode == -1004) {
                            this.$Message.error('Your account is not allowed to login,Please activate!');
                            this.loading = false;
                        } else if (data.resCode == -1005) {
                            this.userId.id = data.result.id;
                            this.formAuthentication.authenticationSecret = data.result.authenticationSecret;
                            this.loading = false;
                            this.loginAuthenticationModal = true;
                        }
                    }, function (errorData) {
                        this.$Message.error('Fail!');
                        this.loading = false;
                    });
                } else {
                    _this.$Message.error('Fail!');
                    _this.loading = false;
                }
            });
        },
        setCookieUser: function setCookieUser(c_user, severalDays) {
            var currentDate = new Date();
            currentDate.setHours(currentDate.getHours() + 24 * severalDays);

            window.document.cookie = "user" + "=" + c_user + ";path=/;expires=" + currentDate.toGMTString();
        },
        setCookiePassword: function setCookiePassword(c_password, severalDays) {
            var currentDate = new Date();
            currentDate.setHours(currentDate.getHours() + 24 * severalDays);

            window.document.cookie = "password" + "=" + c_password + ";path=/;expires=" + currentDate.toGMTString();
        },

        getCookie: function getCookie() {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; ');
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('=');
                    if (arr2[0] == 'user') {
                        this.formInline.userName = arr2[1];
                        if (arr2[1] !== null && '' !== arr2[1]) {
                            this.isSaveUser = true;
                        }
                    }
                    if (arr2[0] == 'password') {
                        this.formInline.passWord = arr2[1];
                        if (arr2[1] !== null && '' !== arr2[1]) {
                            this.isSavePassword = true;
                        }
                    }
                }
            }
        },
        submitRandomCode: function submitRandomCode(name) {
            var _this2 = this;

            this.$refs[name].validate(function (valid) {
                if (valid) {
                    var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "user/open/authenticationRandomCode";
                    _this2.$http.post(url, _this2.formAuthentication).then(function (successData) {
                        var _this4 = this;

                        var data = successData.data;
                        if (data.result) {
                            var userUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "user/open/userDto";
                            var that = this;
                            this.$http.post(userUrl, this.userId).then(function (successData) {
                                var data = successData.data;
                                if (data.resCode == 0) {
                                    that.$store.state.user.name = data.result.userName;
                                    that.$store.state.user.token = data.result.token;
                                    that.$store.state.user.id = data.result.id;
                                    that.$Message.success('Login successful!');
                                    localStorage.setItem("userName", data.result.userName);
                                    localStorage.setItem("id", data.result.id);
                                    localStorage.setItem("token", data.result.token);
                                    localStorage.setItem("image", data.result.image);
                                    localStorage.setItem("invitationCode", data.result.invitationCode);
                                    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.interceptors.push(function (request, next) {
                                        request.credentials = true;

                                        request.headers.set('Authorization', 'Bearer ' + data.result.token);
                                        next();
                                    });
                                    that.formInline.userName = '';
                                    that.formInline.passWord = '';
                                    that.formAuthentication.randomCode = '';
                                    that.authLoading = false;
                                    that.$nextTick(function () {
                                        that.authLoading = true;
                                    });
                                    that.loginAuthenticationModal = false;
                                    that.$router.push({ name: 'posting' });
                                } else {
                                    this.$Message.error('Fail!');
                                }
                            }, function (errorData) {
                                var _this3 = this;

                                this.$Message.error('Fail!');
                                this.authLoading = false;
                                this.$nextTick(function () {
                                    _this3.authLoading = true;
                                });
                            });
                        } else {
                            this.$Message.error('Verification code error!');
                            this.formAuthentication.randomCode = '';
                            this.authLoading = false;
                            this.$nextTick(function () {
                                _this4.authLoading = true;
                            });
                        }
                    }, function (errorData) {
                        var _this5 = this;

                        this.$Message.error('Fail!');
                        this.authLoading = false;
                        this.$nextTick(function () {
                            _this5.authLoading = true;
                        });
                    });
                } else {
                    _this2.formAuthentication.randomCode = '';
                    _this2.authLoading = false;
                    _this2.$nextTick(function () {
                        _this2.authLoading = true;
                    });
                }
            });
        },

        modalCancel: function modalCancel() {
            this.loginAuthenticationModal = false;
        }
    }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isLoadingNotificationList: false,
            isShowNothingMessage: false,
            notificationList: [],
            pageNo: 0,
            pageSize: 10,
            relatedUserInfoList: [],
            formFollow: {
                userId: '',
                followerId: ''
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["user", "notificationNum"])),
    created: function created() {},
    mounted: function mounted() {
        this.getRelatedUserInfoList();
    },

    components: {
        InfiniteLoading: __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default.a
    },
    watch: {},
    methods: {
        getNotificationList: function getNotificationList($state) {
            var _this = this;

            if (this.isLoadingNotificationList) {
                return;
            }
            this.isLoadingNotificationList = true;
            var api = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'notification/query/getNotificationList?pageNo=' + this.pageNo + '&pageSize=' + this.pageSize;
            this.$http.get(api).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this.pageNo += 1;

                    _this.notificationList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.notificationList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result));
                    _this.isLoadingNotificationList = false;
                    $state.loaded();
                } else {
                    $state.complete();
                }
                if (_this.notificationList.length > 0) {
                    _this.isShowNothingMessage = false;
                } else {
                    _this.isShowNothingMessage = true;
                }
            });
        },
        updateReadIndex: function updateReadIndex(readIndex) {
            var _this2 = this;

            if (readIndex > this.user.readIndex) {
                this.$http.get(__WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'userDetail/update/updateReadIndex?readIndex=' + readIndex).then(function (response) {
                    var data = response.data;
                    if (data.resCode == 0) {
                        _this2.$store.dispatch('readIndexHandler', data.result);
                    }
                });
            }
        },
        readNotification: function readNotification(notification) {
            notification.isNotRead = false;
            this.$store.dispatch('notificationNumHandler', this.notificationNum - 1);
            this.updateReadIndex(notification.autoIndex);
        },
        markAllAsRead: function markAllAsRead() {
            this.$store.dispatch('notificationNumHandler', 0);
            this.updateReadIndex(this.notificationList[0].autoIndex);
            for (var i = 0; i < this.notificationList.length; i++) {
                this.notificationList[i].isNotRead = false;
            }
        },
        goUserData: function goUserData(username) {
            this.$router.push({
                name: "userData",
                params: {
                    username: "@" + username
                }
            });
        },
        gotoPost: function gotoPost(notification) {
            if (notification.isNotRead) {
                this.readNotification(notification);
            }
            var postId = "";
            switch (notification.type) {
                case "POST_UPVOTE":
                    postId = notification.post.postingId;
                    break;
                case "POST_DOWNVOTE":
                    postId = notification.post.postingId;
                    break;
                case "POST_COMMENT":
                    postId = notification.postComment.commentsPostingId;
                    break;
                case "COMMENT_UPVOTE":
                    postId = notification.postComment.commentsPostingId;
                    break;
                case "COMMENT_DOWNVOTE":
                    postId = notification.postComment.commentsPostingId;
                    break;
                case "COMMENT_REPLY":
                    postId = notification.postComment.commentsPostingId;
                    break;
                case "ADMIN_POST_UPDATE":
                    postId = notification.post.postingId;
                    break;
                case "ADMIN_COMMENT_UPDATE":
                    postId = notification.postComment.commentsPostingId;
                    break;
                case "ADMIN_COMMENT_DELETE":
                    postId = notification.post.postingId;
                    break;
                default:
                    break;
            }
            this.$router.push({
                name: 'postingsel',
                params: {
                    postingId: postId,
                    username: ''
                }
            });
        },
        getRelatedUserInfoList: function getRelatedUserInfoList() {
            for (var i = 0; i < 4; i++) {
                var user = {
                    userId: 1,
                    userName: 'test',
                    nickName: 'Test',
                    reputationScore: 30
                };
                this.relatedUserInfoList[i] = user;
            }
        },
        follow: function follow(userInfo) {
            var _this3 = this;

            if (localStorage.getItem('token')) {
                this.formFollow.userId = this.$store.state.user.id;
                this.formFollow.followerId = userInfo.userId;
                this.$http.post(__WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + "follow/saveFollow", this.formFollow).then(function (successData) {
                    var data = successData.data;
                    if (data.resCode == 0) {
                        _this3.isFollow = true;
                    } else if (data.resCode == 1) {
                        _this3.isFollow = false;
                    } else if (data.resCode == -3) {
                        _this3.$Message.error("Can not follow yourself!");
                    }
                });
            } else {
                this.$store.state.loginModal = true;
            }
        },
        dateFormat: function dateFormat(time) {
            var timeOffset = -28800000;
            if (this.user) {
                timeOffset = this.user.timeOffset;
            }
            return formatDate(time, timeOffset, this.$i18n.locale);
        }
    }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_md5__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isDisabled: false,
      isAgree: false,
      isShowAgreeMessage: false,
      domainName: __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].ip,
      formInline: {
        regEmail: ""
      },
      ruleInline: {
        regEmail: [{
          required: true,
          message: this.$t("password.requiredMessage.regEmail"),
          trigger: "change"
        }, {
          type: "email",
          message: this.$t("password.requiredMessage.type"),
          trigger: "change"
        }]
      }
    };
  },
  mounted: function mounted() {
    this.background();
  },

  methods: {
    background: function background() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()("[data-bg-image]").each(function () {
        var img = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).data("bg-image");
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).css({
          backgroundImage: "url(" + img + ")"
        });
      });
    },

    gotoRegister: function gotoRegister() {
      this.$router.push({ name: "register" });
    },

    showButton: function showButton() {
      this.isDisabled = false;
    },
    handleSubmit: function handleSubmit(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (_this.isAgree) {
          _this.isShowAgreeMessage = false;
        }
        if (valid) {
          if (_this.isAgree) {
            _this.isShowAgreeMessage = false;

            _this.isDisabled = true;

            var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "user/open/sendEmailEditPwd";
            _this.$http.post(url, _this.formInline).then(function (successData) {
              var data = successData.data;
              if (data.resCode == 0) {
                this.$Message.success(this.$t("password.sendMessage"));
              } else if (data.resCode == -1) {
                this.$Message.error(this.$t("password.notRegisteredMessage"));
              } else if (data.resCode == -10001) {
                this.$Message.error(this.$t("password.failMessage"));
              }
            }, function (errorData) {
              this.$Message.error(this.$t("common.fail"));
            });
          } else {
            _this.isShowAgreeMessage = true;
          }
        }
      });
    }
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_md5__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var userName = function userName(rule, value, callback) {
      var uPattern = /^[a-zA-Z0-9_-]{4,16}$/;
      if (value == 0) {
        callback(new Error(_this.$t("register.errorCallback.userName.empty")));
      } else if (!uPattern.test(value)) {
        callback(new Error(_this.$t("register.errorCallback.userName.value")));
      } else {
        _this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "user/open/register/validationName", _this.formInline).then(function (successData) {
          var data = successData.data;
          if (data.resCode == 1) {
            callback(new Error(_this.$t("register.errorCallback.userName.exist")));
          } else {
            callback();
          }
        });
      }
    };

    var passWord = function passWord(rule, value, callback) {
      var passreg = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;
      if (value == 0) {
        callback(new Error(_this.$t("register.errorCallback.passWord.empty")));
      } else if (!passreg.test(value)) {
        callback(new Error(_this.$t("register.errorCallback.passWord.value")));
      } else {
        callback();
      }
    };

    var repassWord = function repassWord(rule, value, callback) {
      if (value == 0) {
        callback(new Error(_this.$t("register.errorCallback.repassWord.empty")));
      } else if (value !== _this.formInline.passWord) {
        callback(new Error(_this.$t("register.errorCallback.repassWord.value")));
      } else {
        callback();
      }
    };

    var regEmail = function regEmail(rule, value, callback) {
      var Emailyz = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (value == 0) {
        callback(new Error(_this.$t("register.errorCallback.regEmail.empty")));
      } else if (!Emailyz.test(value)) {
        callback(new Error(_this.$t("register.errorCallback.regEmail.format")));
      } else {
        _this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "user/open/register/validationEmail", _this.formInline).then(function (successData) {
          var data = successData.data;
          if (data.resCode == 1) {
            callback(new Error(_this.$t("register.errorCallback.regEmail.exist")));
          } else {
            callback();
          }
        });
      }
    };

    var agreed = function agreed(rule, value, callback) {
      if (value == false) {
        callback(new Error(_this.$t("register.invitationNotempty")));
      } else {
        callback();
      }
    };
    return {
      valid: true,
      domainName: __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].ip,
      passwordForm: {
        passWord: "",
        repassWord: ""
      },
      registrationForm: {
        userName: "",
        passWord: "",
        repassWord: "",
        regEmail: "",
        status: -1,
        agreed: false,
        fillInvitationCode: ""
      },
      regEmailRules: [function (v) {
        return !!v || _this.$t("register.errorCallback.regEmail.empty");
      }, function (v) {
        return (/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(v) || _this.$t("register.errorCallback.regEmail.format")
        );
      }],
      userNameRules: [function (v) {
        return !!v || _this.$t("register.errorCallback.userName.empty");
      }, function (v) {
        return (/^[a-zA-Z0-9_-]{4,16}$/.test(v) || _this.$t("register.errorCallback.userName.value")
        );
      }],
      passWordRules: [function (v) {
        return !!v || _this.$t("register.errorCallback.passWord.empty");
      }, function (v) {
        return (/^(?=.*\d)(?=.*[A-Za-z]).{8,20}$/.test(v) || _this.$t("register.errorCallback.passWord.value")
        );
      }],
      repassWordRules: [function (v) {
        return !!v || _this.$t("register.errorCallback.repassWord.empty");
      }, function (v) {
        return v == _this.passwordForm.passWord || _this.$t("register.errorCallback.repassWord.value");
      }],
      agreedRules: [function (v) {
        return !!v || _this.$t("register.invitationNotempty");
      }],


      isShowNoticeModal: true,
      loading: false,
      formInline: {
        userName: "",
        passWord: "",
        repassWord: "",
        regEmail: "",
        status: -1,
        agreed: "",
        fillInvitationCode: ""
      },
      ruleInline: {
        userName: [{ required: true, validator: userName, trigger: "change" }],
        passWord: [{ required: true, validator: passWord, trigger: "blur" }],
        repassWord: [{ required: true, validator: repassWord, trigger: "blur" }],
        regEmail: [{ required: true, validator: regEmail, trigger: "blur" }],
        agreed: [{ required: true, validator: agreed, trigger: "blur" }]
      },
      termsModal: false,
      sendEmailModal: false };
  },
  mounted: function mounted() {
    this.getInvitationCode();
    this.background();
  },

  methods: {
    autodivheight: function autodivheight() {},
    background: function background() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()("[data-bg-image]").each(function () {
        var img = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data("bg-image");
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).css({
          backgroundImage: "url(" + img + ")"
        });
      });
    },
    closeNoticeModal: function closeNoticeModal() {
      this.isShowNoticeModal = false;
      this.$router.push({ name: "home" });
    },
    getInvitationCode: function getInvitationCode() {
      var url = window.location.href;
      var invitationCode = url.substring(url.lastIndexOf("=") + 1);
      if (invitationCode.match("://") === null) {
        this.registrationForm.fillInvitationCode = invitationCode;
      }
    },
    agreeTerms: function agreeTerms() {
      this.registrationForm.agreed = true;
    },
    goHome: function goHome() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].ip;
    },
    gotoLogin: function gotoLogin() {
      this.$router.push({ name: "posts" });
      this.$store.state.loginModal = true;
    },
    closeSendEmailModal: function closeSendEmailModal() {
      this.sendEmailModal = false;
    },
    sendActivationEmail: function sendActivationEmail() {
      var _this2 = this;

      var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "user/open/register/sendEmail";
      this.$http.post(url, this.registrationForm).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          if (data.resCode == 0) {
            _this2.sendEmailModal = false;
            _this2.$Message.success({
              content: _this2.$t("register.registerSuccess"),
              duration: 10,
              closable: true
            });
            _this2.$refs.registrationForm.reset();
            _this2.$router.push({ name: "home" });
          }
        }
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;

      if (this.$refs.registrationForm.validate()) {
        this.loading = true;

        var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "user/open/register/validationEmail";
        var sha256 = __webpack_require__(40).sha256;
        var passWord = sha256(this.passwordForm.passWord);
        var repassWord = sha256(this.passwordForm.repassWord);
        this.registrationForm.passWord = passWord;
        this.registrationForm.repassWord = repassWord;
        this.$http.post(url, this.registrationForm).then(function (successData) {
          var data = successData.data;
          if (data.resCode == 1) {
            _this3.registrationForm.passWord = "";
            _this3.registrationForm.repassWord = "";
            _this3.$Message.error({
              content: _this3.$t("register.errorCallback.regEmail.exist"),
              duration: 10,
              closable: true
            });
            _this3.loading = false;
          } else if (data.resCode == -1) {
            _this3.sendEmailModal = true;
            _this3.loading = false;
          } else {
            var _url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "user/open/register/validationName";
            _this3.$http.post(_url, _this3.registrationForm).then(function (successData) {
              var data = successData.data;
              if (data.resCode == 1) {
                _this3.registrationForm.passWord = "";
                _this3.registrationForm.repassWord = "";
                _this3.$Message.error({
                  content: _this3.$t("register.errorCallback.userName.exist"),
                  duration: 10,
                  closable: true
                });
                _this3.loading = false;
              } else {
                if (_this3.registrationForm.passWord == null && _this3.registrationForm.passWord == "") {
                  _this3.$Message.error(_this3.$t("common.fail"));
                  _this3.loading = false;
                  return;
                }

                var _url2 = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "user/open/register/editInfo";
                _this3.registrationForm.passWord = passWord;
                _this3.registrationForm.repassWord = repassWord;
                _this3.$http.post(_url2, _this3.registrationForm).then(function (successData) {
                  var data = successData.data;
                  if (data.resCode == 0) {
                    var _url3 = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "user/open/register/sendEmail";
                    _this3.$http.post(_url3, _this3.registrationForm).then(function (successData) {
                      var data = successData.data;
                      if (data.resCode == 0) {
                        _this3.$Notice.success({
                          title: _this3.$t("common.success"),
                          desc: _this3.$t("register.registerSuccess"),
                          duration: 0
                        });
                        _this3.loading = false;
                        _this3.$refs.registrationForm.reset();
                        _this3.$router.push({ name: "home" });
                      }
                    }, function (errorData) {
                      _this3.$Message.error(_this3.$t("common.fail"));
                      _this3.loading = false;
                    });
                  }
                }, function (errorData) {
                  _this3.$Message.error(_this3.$t("common.fail"));
                  _this3.loading = false;
                });
              }
            }, function (errorData) {
              _this3.$Message.error(_this3.$t("common.fail"));
              _this3.loading = false;
            });
          }
        }, function (errorData) {
          _this3.$Message.error(_this3.$t("common.fail"));
          _this3.loading = false;
        });
      } else {
        this.$Message.error(this.$t("common.fail"));
        this.loading = false;
      }
    },
    clearForm: function clearForm() {
      this.$refs.registrationForm.reset();
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      domainName: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].ip
    };
  },
  mounted: function mounted() {
    window.onresize = this.autodivheight();
    this.background();
  },

  methods: {
    background: function background() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()("[data-bg-image]").each(function () {
        var img = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data("bg-image");
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).css({
          backgroundImage: "url(" + img + ")"
        });
      });
    },
    autodivheight: function autodivheight() {
      var winHeight = 0;
      if (window.innerHeight) {
        winHeight = window.innerHeight;
      } else if (document.body && document.body.clientHeight) {
        winHeight = document.body.clientHeight;
      }
      if (document.documentElement && document.documentElement.clientHeight) {
        winHeight = document.documentElement.clientHeight;
      }
    },
    goHome: function goHome() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].ip;
    }
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var validateId = function validateId(rule, value, callback) {
            if (value === '') {
                callback(new Error('  '));
            } else {
                callback();
            }
        };
        var validateAuthenticationSecret = function validateAuthenticationSecret(rule, value, callback) {
            if (value === '') {
                callback(new Error(' '));
            } else {
                callback();
            }
        };
        var validateRandomCode = function validateRandomCode(rule, value, callback) {
            if (!value) {
                callback(new Error('The randomCode cannot be empty'));
            } else if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(+value)) {
                callback(new Error('Please enter a numeric value'));
            } else if ((value + '').length !== 6) {
                callback(new Error('Must be 6 digits'));
            } else {
                callback();
            }
        };
        return {
            qrcode: '#',
            formCustom: {
                id: '',
                authenticationSecret: '',
                qrcode: '#',
                randomCode: ''
            },
            ruleCustom: {
                id: [{ validator: validateId, trigger: 'blur' }],
                authenticationSecret: [{ validator: validateAuthenticationSecret, trigger: 'blur' }],
                randomCode: [{ validator: validateRandomCode, trigger: 'blur' }]
            },
            formAuthentication: {
                id: ''
            }
        };
    },

    computed: {},
    created: function created() {},

    mounted: function mounted() {
        this.getUser();
    },
    watch: {
        '$route': 'getUser'
    },
    methods: {
        getUser: function getUser() {
            var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "user/getAuthentication";
            this.formAuthentication.id = this.$route.params.userId;
            var that = this;
            this.$http.post(url, this.formAuthentication).then(function (successData) {
                var data = successData.data;
                that.formCustom.id = data.result.id;
                that.formCustom.authenticationSecret = data.result.authenticationSecret;
                that.qrcode = data.result.qrcode;
            }, function (errorData) {
                this.$Message.error("Sorry, server error!");
            });
        },
        copySecretKey: function copySecretKey() {
            var _this = this;

            var clipboard = new __WEBPACK_IMPORTED_MODULE_2_clipboard___default.a('.secretKey');
            clipboard.on('success', function (e) {
                _this.$Message.success("Copy success!");

                clipboard.destroy();
            });
            clipboard.on('error', function (e) {
                _this.$Message.error("The browser does not support automatic replication!");

                clipboard.destroy();
            });
        },
        handleSubmit: function handleSubmit(name) {
            var _this2 = this;

            this.$refs[name].validate(function (valid) {
                if (valid) {
                    _this2.formCustom.qrcode = _this2.qrcode;
                    var url = __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].baseUrl + "user/resetAuthentication";
                    _this2.$http.post(url, _this2.formCustom).then(function (successData) {
                        var data = successData.data;
                        this.formCustom.randomCode = '';
                        if (data.resCode == 0) {
                            this.$Message.success("Success");
                            this.$router.push({ name: 'userSetting' });
                        } else if (data.resCode == -1) {
                            this.$Message.error('Dangerous operation, please log in again!');
                        } else if (data.resCode == -2) {
                            this.$Message.error('Verification code error!');
                        } else if (data.resCode == -3) {
                            this.$Message.error("Sorry, server error!");
                        }
                    }, function (errorData) {
                        this.$Message.error('Fail!');
                        this.formCustom.randomCode = '';
                    });
                } else {
                    _this2.formCustom.randomCode = '';
                }
            });
        }
    }

});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_md5__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var passWord = function passWord(rule, value, callback) {
      var passreg = /^(?=.*\d)(?=.*[A-Za-z]).{8,20}$/;
      if (value == 0) {
        callback(new Error(_this.$t("resetPassword.errorCallback.passWord.empty")));
      } else if (!passreg.test(value)) {
        callback(new Error(_this.$t("resetPassword.errorCallback.passWord.value")));
      } else {
        callback();
      }
    };
    var confirmPassWord = function confirmPassWord(rule, value, callback) {
      if (value == 0) {
        callback(new Error(_this.$t("resetPassword.errorCallback.confirmPassWord.again")));
      } else if (value !== _this.formInline.passWord) {
        callback(new Error(_this.$t("resetPassword.errorCallback.confirmPassWord.match")));
      } else {
        callback();
      }
    };
    return {
      formInline: {
        regEmail: "",
        passWord: "",
        confirmPassWord: ""
      },
      domainName: __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].ip,
      ruleInline: {
        passWord: [{ required: true, validator: passWord, trigger: "blur" }],
        confirmPassWord: [{ required: true, validator: confirmPassWord, trigger: "blur" }]
      }
    };
  },

  mounted: function mounted() {
    this.getRegEmail();
    this.background();
  },
  methods: {
    background: function background() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()("[data-bg-image]").each(function () {
        var img = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data("bg-image");
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).css({
          backgroundImage: "url(" + img + ")"
        });
      });
    },

    getRegEmail: function getRegEmail() {
      var url = window.location.href;
      var email = url.substring(url.indexOf("=", 1) + 1, url.indexOf("#", 1));
      this.formInline.regEmail = email;
    },
    gotoLogin: function gotoLogin() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].ip + "#/login";
    },
    gotoRegister: function gotoRegister() {
      this.$router.push({ name: "register" });
    },
    findPassword: function findPassword() {
      this.$router.push({ name: "password" });
    },
    handleSubmit: function handleSubmit(name) {
      var _this2 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          var api = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "user/open/updatePasswordByRegEmail";
          var passWord = __WEBPACK_IMPORTED_MODULE_0_js_md5___default()(_this2.formInline.passWord);
          passWord = passWord.split("").reverse().join("");
          passWord = __WEBPACK_IMPORTED_MODULE_0_js_md5___default()(passWord);

          var sha256 = __webpack_require__(40).sha256;
          var possWord_v2 = sha256(_this2.formInline.passWord);
          var userFormData = {
            regEmail: _this2.formInline.regEmail,
            passWord: passWord,
            passWord_v2: possWord_v2
          };
          _this2.$http.post(api, userFormData).then(function (successData) {
            var data = successData.data;
            if (data.resCode == 0) {
              this.$refs[name].resetFields();
              window.location.href = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].ip;
              this.$Message.success(this.$t("resetPassword.successMessage"));
            } else if (data.resCode == -1) {
              this.$Message.error(this.$t("common.fail"));
            }
          }, function (errorData) {
            this.$Message.error(this.$t("common.fail"));
          });
        } else {
          _this2.$Message.error(_this2.$t("common.fail"));
        }
      });
    }
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);







/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			telegramName: 'IOB Telegram',
			changeDate: +new Date(),
			telegramGroupList: [],
			PageNo: 0,
			pageSize: 30 };
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["user"])),
	components: {
		InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
	},
	mounted: function mounted() {},
	watch: {
		$route: function $route() {
			this.chatId = this.$route.params.chatId;
		},
		chatId: function chatId() {
			if (this.chatId != null) {
				this.telegramGroupList = [];
				this.PageNo = 0;
				this.changeDate = this.changeDate + 1;
			}
		}
	},
	methods: {
		findTelegramUserMsg: function findTelegramUserMsg($state) {
			var _this = this;

			var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "/telegramUser/open/telegramChat?pageNo=" + this.PageNo + '&pageSize=' + this.pageSize;
			this.$http.get(url).then(function (response) {
				if (response.data.resCode == 0) {
					_this.PageNo += 1;
					_this.telegramGroupList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.telegramGroupList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.data.result.telegramGroupList));
					$state.loaded();
				} else {
					$state.complete();
				}
			});
		},
		viewUserTelegramInfo: function viewUserTelegramInfo(username) {
			if (username) {
				window.open('https://telegram.me/' + username, '_blank');
			} else {
				alert("The user did not set a username.");
			}
		},
		dateFormat: function dateFormat(time) {
			var timeOffset = -28800000;
			if (this.user) {
				timeOffset = this.user.timeOffset;
			}
			return formatDate(time, timeOffset, this.$i18n.locale);
		}
	}
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isShowLink: false,
      domainName: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].ip,
      isShowMessage: false
    };
  },

  mounted: function mounted() {
    window.onresize = this.autodivheight();
    this.verifyLink();
    this.background();
  },
  methods: {
    background: function background() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()("[data-bg-image]").each(function () {
        var img = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data("bg-image");
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).css({
          backgroundImage: "url(" + img + ")"
        });
      });
    },
    autodivheight: function autodivheight() {
      var winHeight = 0;
      if (window.innerHeight) {
        winHeight = window.innerHeight;
      } else if (document.body && document.body.clientHeight) {
        winHeight = document.body.clientHeight;
      }
      if (document.documentElement && document.documentElement.clientHeight) {
        winHeight = document.documentElement.clientHeight;
      }
    },
    verifyLink: function verifyLink() {
      var currentUrl = window.location.href;
      var email = currentUrl.substring(currentUrl.indexOf("=", 1) + 1, currentUrl.indexOf("#", 1));
      this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].baseUrl + "emailLink/open/verifyLink?regEmail=" + email).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          this.isShowLink = true;
          this.isShowMessage = false;
        } else if (data.resCode == -1) {
          this.isShowLink = false;
          this.isShowMessage = true;
          this.$Notice.warning({
            title: this.$t("common.warning"),
            desc: this.$t("updateEmail.noRegisterNotice")
          });
        } else if (data.resCode == -2) {
          this.isShowLink = false;
          this.isShowMessage = true;
          this.$Notice.warning({
            title: this.$t("common.warning"),
            desc: this.$t("updateEmail.activatedNotice")
          });
        } else if (data.resCode == -3) {
          this.isShowLink = false;
          this.isShowMessage = true;
          this.$Notice.warning({
            title: this.$t("common.warning"),
            desc: this.$t("updateEmail.timeOutNotice")
          });
        }
      }, function (errorData) {
        this.$Message.error(this.$t("common.fail"));
      });
    },

    gotoresgistersuccess: function gotoresgistersuccess() {
      this.$router.push({ name: "resgistersuccess" });
    },
    goHome: function goHome() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].ip;
    },
    updateEmail: function updateEmail() {
      var url = window.location.href;
      var email = url.substring(url.indexOf("=", 1) + 1, url.indexOf("#", 1));
      var url1 = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].baseUrl + "user/updateEmail?regEmail=" + email;
      var that = this;
      this.$http.get(url1, this.formInline).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          this.$Notice.success({
            title: this.$t("common.success"),
            desc: this.$t("updateEmail.successNotice")
          });
          this.goHome();
        } else if (data.resCode == -1) {
          this.$Message.error(this.$t("common.serverError"));
        }
      }, function (errorData) {
        this.$Message.error(this.$t("common.fail"));
      });
    }
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_eventBus_js__ = __webpack_require__(16);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      userId: this.$store.getters.user != null ? this.$store.getters.user.userId : null,
      username: this.$route.params.username,
      isShowPosting: true,
      isShowMicroArticle: false,
      isShowComments: false,
      isShowReply: false,
      isShowForward: false,
      isShowUpvotes: false,
      isShowDownvotes: false,
      isShowCollections: false,
      isShowRewardRecords: false,
      isShowReferrals: false,
      postingList: [],
      microArticleList: [],
      totalPostingNum: 0,
      totalMicroArticleNum: 0,
      totalCommentsNum: 0,
      totalReplyNum: 0,
      totalForwardNum: 0,
      userDetail: {},
      postingCommentsList: [],
      commentsPostingList: [],
      postingReplyList: [],
      postingForwardList: [],
      parentCommentList: [],
      collectionPostList: [],
      totalCollectionPostNum: 0,
      upvotePostList: [],
      totalUpvoteNum: 0,
      downvotePostList: [],
      totalDownvoteNum: 0,
      referralList: [],
      totalRewardRecordsNum: 0,
      bonusRecordTableHeaders: [{ text: this.$t('userData.bonusRecordTableHeaders.actionTimestamp'), align: 'left', sortable: false }, { text: this.$t('userData.bonusRecordTableHeaders.timestamp'), align: 'left', sortable: false }, { text: this.$t('userData.bonusRecordTableHeaders.record'), align: 'left', sortable: false }],
      bonusRecordList: [],
      isShowViewImageModal: false,
      formFollow: {
        userId: '',
        followerId: ''
      },
      isFollow: false,
      followingNum: 0,
      followerNum: 0 };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["user"])),
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('NumFormat', function (value) {
      if (!value) return '0.00';
      var intPart = Number(value).toFixed(0);
      intPart = intPart > value ? intPart - 1 : intPart;
      var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      var floatPart = ".00";
      var value2Array = value.split(".");

      if (value2Array.length == 2) {
        floatPart = value2Array[1].toString();
        if (floatPart.length == 1) {
          return intPartFormat + "." + floatPart + '0';
        } else {
          return intPartFormat + "." + floatPart;
        }
      } else {
        return intPartFormat + floatPart;
      }
    });
  },

  mounted: function mounted() {
    if (this.$route.params.username) {
      if (this.$route.params.username.indexOf('@') == 0) {
        this.username = this.$route.params.username.substring(1);
      }

      this.getBaseData();

      this.getMenuData("posting");
    }
  },
  watch: {
    $route: function $route() {
      if (this.$route.params.username) {
        if (this.$route.params.username.indexOf('@') == 0) {
          this.username = this.$route.params.username.substring(1);
        } else {
          this.username = this.$route.params.username;
        }
      }
    },
    username: function username() {
      if (this.username) {
        this.getBaseData();

        this.getMenuData("posting");
      }
    }
  },
  methods: {
    getBaseData: function getBaseData() {
      var _this = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "userDetail/open/getUserInfo/" + this.username).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this.userDetail = data.result;
          document.title = _this.userDetail.nickName + "(@" + _this.userDetail.userName + ")——SiP";
        } else {
          _this.$router.push({ name: 'page404' });
        }
      });

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "microArticle/open/countMicroArticlesByUsername/" + this.username).then(function (successData) {
        _this.totalMicroArticleNum = successData.data.result;
      });

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "comments/open/countCommentsByUsername/" + this.username).then(function (successData) {
        _this.totalCommentsNum = successData.data.result;
      });

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "comments/open/countReplyByUsername/" + this.username).then(function (successData) {
        _this.totalReplyNum = successData.data.result;
      });

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "posting/open/countForwardsByUsername/" + this.username).then(function (successData) {
        _this.totalForwardNum = successData.data.result;
      });

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "posting/open/countPosts/upvote/" + this.username).then(function (successData) {
        _this.totalUpvoteNum = successData.data.result;
      });

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "posting/open/countPosts/downvote/" + this.username).then(function (successData) {
        _this.totalDownvoteNum = successData.data.result;
      });

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "collection/open/countPostingByUsername/" + this.username).then(function (successData) {
        _this.totalCollectionPostNum = successData.data.result;
      });

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "bonusRecord/open/countBonusRecordByUsername/" + this.username).then(function (successData) {
        _this.totalRewardRecordsNum = successData.data.result;
      });

      if (localStorage.getItem('token')) {
        this.formFollow.userId = this.$store.state.user.id;
        this.formFollow.followerId = this.username;
        this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "follow/isFollow", this.formFollow).then(function (successData) {
          _this.isFollow = successData.data.result;
        });
      }

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "follow/open/countFollowingByUsername/" + this.username).then(function (successData) {
        _this.followingNum = successData.data.result;
      });

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "follow/open/countFollowerByUsername/" + this.username).then(function (successData) {
        _this.followerNum = successData.data.result;
      });
    },
    getMenuData: function getMenuData(name) {
      switch (name) {
        case "posting":
          this.isShowPosting = true;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getPostingList();
          break;

        case "microArticle":
          this.isShowPosting = false;
          this.isShowMicroArticle = true;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getMicroArticleList();
          break;

        case "comments":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = true;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getCommentList();
          break;

        case "reply":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = true;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getReplyList();
          break;

        case "forward":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = true;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getForwardList();
          break;

        case "upvotes":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = true;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getUpvotePostListByPage(1);
          break;

        case "downvotes":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = true;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getDownvotePostListByPage(1);
          break;

        case "collections":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = true;
          this.isShowReferrals = false;
          this.isShowRewardRecords = false;
          this.getCollectionPostingList();
          break;

        case "referees":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = true;
          this.isShowRewardRecords = false;
          this.getReferralList();
          break;

        case "rewardRecords":
          this.isShowPosting = false;
          this.isShowMicroArticle = false;
          this.isShowComments = false;
          this.isShowReply = false;
          this.isShowForward = false;
          this.isShowUpvotes = false;
          this.isShowDownvotes = false;
          this.isShowCollections = false;
          this.isShowReferrals = false;
          this.isShowRewardRecords = true;
          this.getBonusRecordsListByPage(1);
          break;
        default:
          break;
      }
    },
    getPostingList: function getPostingList() {
      var _this2 = this;

      var postingUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "posting/open/selByUsername/" + this.username + "/0/5";
      this.$http.get(postingUrl).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this2.postingList = data.result.postingList;
          _this2.totalPostingNum = data.result.totalElements;
        } else {
          _this2.postingList = [];
          _this2.totalPostingNum = 0;
        }
      });
    },
    getMicroArticleList: function getMicroArticleList() {
      var _this3 = this;

      var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "microArticle/open/getMicroArticleByUsername/" + this.username + "/0/5";
      this.$http.get(url).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this3.microArticleList = data.result;
        } else {
          _this3.microArticleList = [];
        }
      });
    },
    getCommentList: function getCommentList() {
      var _this4 = this;

      var commentsUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "comments/open/selCommentsByUsername/" + this.username + "/0/5";
      this.$http.get(commentsUrl).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this4.postingCommentsList = data.result.postingCommentsList;
          _this4.commentsPostingList = data.result.commentsPostingList;
          _this4.totalCommentsNum = data.result.totalElements;
        } else {
          _this4.postingCommentsList = [];
          _this4.commentsPostingList = [];
          _this4.totalCommentsNum = 0;
        }
      });
    },
    getReplyList: function getReplyList() {
      var _this5 = this;

      var replyUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "comments/open/selReplyByUsername/" + this.username + "/0/5";
      this.$http.get(replyUrl).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this5.postingReplyList = data.result.postingReplyList;
          _this5.parentCommentList = data.result.parentCommentList;
          _this5.totalReplyNum = data.result.totalElements;
        } else {
          _this5.postingReplyList = [];
          _this5.parentCommentList = [];
          _this5.totalReplyNum = 0;
        }
      });
    },
    getForwardList: function getForwardList() {
      var _this6 = this;

      var forwardUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "posting/open/forwardByUsername/" + this.username + "/0/5";
      this.$http.get(forwardUrl).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this6.postingForwardList = data.result.postingForwardList;
          _this6.totalForwardNum = data.result.totalElements;
        } else {
          _this6.postingForwardList = [];
          _this6.totalForwardNum = 0;
        }
      });
    },
    getCollectionPostingList: function getCollectionPostingList() {
      var _this7 = this;

      var postingUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "collection/open/getPostingByUsername/" + this.username + "/0/5";
      this.$http.get(postingUrl).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this7.collectionPostList = data.result.postingList;
          _this7.totalCollectionPostNum = data.result.totalElements;
        } else if (data.resCode == -1) {
          _this7.collectionPostList = [];
          _this7.totalCollectionPostNum = 0;
        }
      });
    },
    getCollectionPostByPage: function getCollectionPostByPage(pageNo) {
      var _this8 = this;

      var postingUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "collection/open/getPostingByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
      this.$http.get(postingUrl).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this8.collectionPostList = data.result.postingList;
          _this8.totalCollectionPostNum = data.result.totalElements;
        } else if (data.resCode == -1) {
          _this8.collectionPostList = [];
          _this8.totalCollectionPostNum = 0;
          _this8.$Notice.info({
            title: "You don't have any collections yet."
          });
        }
      });
    },
    getUpvotePostListByPage: function getUpvotePostListByPage(pageNo) {
      var _this9 = this;

      var api = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "posting/open/getPosts/upvote/" + (pageNo - 1) + "/5/" + this.username;
      this.$http.get(api).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this9.upvotePostList = data.result;
        } else if (data.resCode == -1) {
          _this9.upvotePostList = [];
        }
      });
    },
    getDownvotePostListByPage: function getDownvotePostListByPage(pageNo) {
      var _this10 = this;

      var api = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "posting/open/getPosts/downvote/" + (pageNo - 1) + "/5/" + this.username;
      this.$http.get(api).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this10.downvotePostList = data.result;
        } else if (data.resCode == -1) {
          _this10.downvotePostList = [];
        }
      });
    },
    getReferralList: function getReferralList() {
      var _this11 = this;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "follow/open/getReferralsByUsername/" + this.username).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this11.referralList = data.result;
          _this11.userDetail.invitationNumber = data.result.length;
        } else {
          _this11.referralList = [];
          _this11.userDetail.invitationNumber = 0;
        }
      });
    },
    getBonusRecordsListByPage: function getBonusRecordsListByPage(pageNo) {
      var _this12 = this;

      var api = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "bonusRecord/open/getBonusRecords/" + (pageNo - 1) + "/10/" + this.username;
      this.$http.get(api).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this12.bonusRecordList = data.result;
        } else if (data.resCode == -1) {
          _this12.bonusRecordList = [];
        }
      });
    },
    referralFollow: function referralFollow(followerId) {
      var _this13 = this;

      if (localStorage.getItem("token")) {
        this.formFollow.userId = this.$store.state.user.id;
        this.formFollow.followerId = followerId;
        this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "follow/saveFollow", this.formFollow).then(function (successData) {
          var data = successData.data;
          if (data.resCode == 0) {
            for (var i = 0; i < _this13.referralList.length; i++) {
              if (_this13.referralList[i].userId == followerId) {
                _this13.referralList[i].status = "1";
              }
            }
            _this13.followingNum += 1;
          } else if (data.resCode == 1) {
            for (var i = 0; i < _this13.referralList.length; i++) {
              if (_this13.referralList[i].userId == followerId) {
                _this13.referralList[i].status = "0";
              }
            }
            _this13.followingNum -= 1;
          } else if (data.resCode == -3) {
            _this13.$Message.error("Can not follow yourself!");
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    viewBigImage: function viewBigImage() {
      this.isShowViewImageModal = true;
    },
    goUserData: function goUserData(username) {
      this.$router.push({
        name: 'userData',
        params: {
          username: '@' + username
        }
      });
    },
    goFollow: function goFollow(followOption) {
      sessionStorage.setItem("followOption", followOption);
      this.$router.push({ name: 'follow', params: { username: '@' + this.username } });
    },
    follow: function follow() {
      var _this14 = this;

      if (localStorage.getItem('token')) {
        this.formFollow.userId = this.$store.state.user.id;
        this.formFollow.followerId = this.userDetail.userId;
        this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "follow/saveFollow", this.formFollow).then(function (successData) {
          var data = successData.data;
          if (data.resCode == 0) {
            _this14.isFollow = true;
          } else if (data.resCode == 1) {
            _this14.isFollow = false;
          } else if (data.resCode == -3) {
            _this14.$Message.error("Can not follow yourself!");
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    getPostingById: function getPostingById(postingId) {
      this.$router.push({
        name: 'postingsel',
        params: {
          username: this.username,
          postingId: postingId
        }
      });
    },
    gotoMicroArticle: function gotoMicroArticle(microArticle) {
      this.$router.push({
        name: 'microArticle',
        params: {
          userName: '@' + this.username,
          microArticleId: microArticle.microArticleId
        }
      });
    },
    getPostingByPage: function getPostingByPage(pageNo) {
      var _this15 = this;

      var postingUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "posting/open/selByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
      this.$http.get(postingUrl).then(function (successData) {
        var data = successData.data;
        _this15.postingList = data.result.postingList;
        _this15.totalPostingNum = data.result.totalElements;
      });
    },
    getMicroArticleByPage: function getMicroArticleByPage(pageNo) {
      var _this16 = this;

      var url = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "microArticle/open/getMicroArticleByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
      this.$http.get(url).then(function (successData) {
        var data = successData.data;
        if (data.resCode == 0) {
          _this16.microArticleList = data.result;
        } else {
          _this16.microArticleList = [];
        }
      });
    },
    getForwardByPage: function getForwardByPage(pageNo) {
      var _this17 = this;

      var postingUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "posting/open/forwardByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
      this.$http.get(postingUrl).then(function (successData) {
        var data = successData.data;
        _this17.postingForwardList = data.result.postingForwardList;
        _this17.totalForwardNum = data.result.totalElements;
      });
    },
    getCommentsByPage: function getCommentsByPage(pageNo) {
      var _this18 = this;

      var commentsUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "comments/open/selCommentsByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
      this.$http.get(commentsUrl).then(function (successData) {
        var data = successData.data;
        _this18.postingCommentsList = data.result.postingCommentsList;
        _this18.commentsPostingList = data.result.commentsPostingList;
        _this18.totalCommentsNum = data.result.totalElements;
      });
    },
    getReplyByPage: function getReplyByPage(pageNo) {
      var _this19 = this;

      var replyUrl = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + "comments/open/selReplyByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
      this.$http.get(replyUrl).then(function (successData) {
        var data = successData.data;
        _this19.postingReplyList = data.result.postingReplyList;
        _this19.parentCommentList = data.result.parentCommentList;
        _this19.totalReplyNum = data.result.totalElements;
      });
    },
    openNewWindowViewImage: function openNewWindowViewImage(imageUrl) {
      if (imageUrl) {
        window.open(imageUrl);
      }
    },
    hideBlock: function hideBlock(event) {},
    regTimeFormat: function regTimeFormat(time) {
      return formatTime(time, this.$i18n.locale);
    },
    dateFormat: function dateFormat(time) {
      var timeOffset = -28800000;
      if (this.user) {
        timeOffset = this.user.timeOffset;
      }
      return formatDate(time, timeOffset, this.$i18n.locale);
    }
  }

});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_eventBus_js__ = __webpack_require__(16);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            userId: this.$store.state.user.id,
            username: this.$route.params.username,
            userDetail: {},
            isShowViewImageModal: false,
            isShowFollowing: true,
            isShowFollowers: false,
            isShowReferrals: false,
            isShowCollections: false,
            followingList: [],
            followerList: [],
            referralList: [],
            postingList: [],
            followingNum: 0,
            followerNum: 0,
            totalPostingNum: 0,
            userIdArray: [],
            formCollection: {
                userId: '',
                postingId: ''
            },
            formFollow: {
                userId: '',
                followerId: ''
            },
            followingColumns: [{
                type: 'index',
                width: 100
            }, {
                render: function render(h, params) {
                    return h('div', [h('strong', {
                        style: {
                            cursor: 'pointer',
                            color: '#41B8BC'
                        },
                        on: {
                            click: function click() {
                                var routeData = _this.$router.resolve({
                                    name: 'userData',
                                    params: {
                                        username: params.row.userName
                                    }
                                });
                                window.open(routeData.href, '_blank');
                            }
                        }
                    }, params.row.userName)]);
                }
            }, {
                width: 200,
                align: 'center',
                render: function render(h, params) {
                    return h('div', [h('Button', {
                        style: {
                            background: '#41B8BC',
                            color: '#FFFFFF'
                        },
                        on: {
                            click: function click() {
                                _this.following(params.row.id, params.index);
                            }
                        }
                    }, _this.$t("common.unfollow"))]);
                }
            }],
            followerColumns: [{
                type: 'index',
                width: 100
            }, {
                render: function render(h, params) {
                    return h('div', [h('strong', {
                        style: {
                            cursor: 'pointer',
                            color: '#41B8BC'
                        },
                        on: {
                            click: function click() {
                                var routeData = _this.$router.resolve({
                                    name: 'userData',
                                    params: {
                                        username: params.row.userName
                                    }
                                });
                                window.open(routeData.href, '_blank');
                            }
                        }
                    }, params.row.userName)]);
                }
            }, {
                width: 200,
                align: 'center',
                render: function render(h, params) {
                    return h('div', [h('Button', {
                        style: {
                            marginRight: '5px',
                            background: '#41B8BC',
                            color: '#FFFFFF'
                        },
                        on: {
                            click: function click() {
                                _this.follower(params.row.userId);
                            }
                        }
                    }, _this.isFollow(params.row.userId) ? _this.$t("common.unfollow") : _this.$t("common.follow"))]);
                }
            }]
        };
    },

    computed: {},
    created: function created() {},

    mounted: function mounted() {
        if (this.$route.params.username) {
            if (this.$route.params.username.indexOf('@') == 0) {
                this.username = this.$route.params.username.substring(1);
            }
            this.getUserDetail();
            this.initCount();
            this.getMenuData('following');
        }
    },
    watch: {
        $route: function $route() {
            if (this.$route.params.username) {
                if (this.$route.params.username.indexOf('@') == 0) {
                    this.username = this.$route.params.username.substring(1);
                } else {
                    this.username = this.$route.params.username;
                }
            }
        },
        username: function username() {
            if (this.username) {
                this.initCount();

                this.getUserDetail();

                this.getMenuData("following");
            }
        }
    },
    methods: {
        getMenuData: function getMenuData(name) {
            var followOption = sessionStorage.getItem("followOption");
            if (followOption) {
                name = followOption;
                sessionStorage.removeItem("followOption");
            }
            switch (name) {
                case "following":
                    this.isShowFollowing = true;
                    this.isShowFollowers = false;
                    this.isShowReferrals = false;
                    this.isShowCollections = false;
                    this.getFollowingList();
                    break;
                case "followers":
                    this.isShowFollowing = false;
                    this.isShowFollowers = true;
                    this.isShowReferrals = false;
                    this.isShowCollections = false;
                    this.getFollowerList();
                    break;
                case "referrals":
                    this.isShowFollowing = false;
                    this.isShowFollowers = false;
                    this.isShowReferrals = true;
                    this.isShowCollections = false;
                    this.getReferralList();
                    break;
                case "collections":
                    this.isShowFollowing = false;
                    this.isShowFollowers = false;
                    this.isShowReferrals = false;
                    this.isShowCollections = true;
                    this.getCollectionPostingList();
                    break;
                default:
                    this.isShowFollowing = true;
                    this.isShowFollowers = false;
                    this.isShowReferrals = false;
                    this.isShowCollections = false;
                    this.getFollowingList();
                    break;
            }
        },
        isFollow: function isFollow(followerId) {
            if (this.followingList != null && this.followingList.length > 0) {
                for (var i = 0; i < this.followingList.length; i++) {
                    if (this.followingList[i].userId == followerId) {
                        return true;
                    }
                }
            }
            return false;
        },
        initCount: function initCount() {
            var _this2 = this;

            this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "follow/open/countFollowingByUsername/" + this.username).then(function (successData) {
                _this2.followingNum = successData.data.result;
            });
            this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "follow/open/countFollowerByUsername/" + this.username).then(function (successData) {
                _this2.followerNum = successData.data.result;
            });
            this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "collection/open/countPostingByUsername/" + this.username).then(function (successData) {
                _this2.totalPostingNum = successData.data.result;
            });
        },
        getUserDetail: function getUserDetail() {
            var _this3 = this;

            this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "userDetail/open/getUserInfo/" + this.username).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this3.userDetail = data.result;
                    document.title = _this3.userDetail.nickName + "(@" + _this3.userDetail.userName + ")——SiP";
                } else {
                    _this3.$router.push({ name: 'page404' });
                }
            });
        },
        viewBigImage: function viewBigImage() {
            this.isShowViewImageModal = true;
        },
        getFollowingList: function getFollowingList() {
            var _this4 = this;

            this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "follow/open/getFollowingByUsername/" + this.username).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this4.followingList = data.result;
                    _this4.followingNum = data.result.length;
                } else {
                    _this4.followingList = [];
                    _this4.followingNum = 0;
                }
            });
        },
        getFollowerList: function getFollowerList() {
            var _this5 = this;

            this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "follow/open/getFollowerByFollowername/" + this.username).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this5.followerList = data.result;
                    _this5.followerNum = data.result.length;
                } else {
                    _this5.followerList = [];
                    _this5.followerNum = 0;
                }
            });
        },
        getReferralList: function getReferralList() {
            var _this6 = this;

            this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "follow/open/getReferralsByUsername/" + this.username).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this6.referralList = data.result;
                    _this6.userDetail.invitationNumber = data.result.length;
                } else {
                    _this6.referralList = [];
                    _this6.userDetail.invitationNumber = 0;
                }
            });
        },
        following: function following(followerId) {
            var _this7 = this;

            if (localStorage.getItem("token")) {
                this.formFollow.userId = this.$store.state.user.id;
                this.formFollow.followerId = followerId;
                this.$http.post(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "follow/saveFollow", this.formFollow).then(function (successData) {
                    var data = successData.data;
                    if (data.resCode == 0) {
                        for (var i = 0; i < _this7.followingList.length; i++) {
                            if (_this7.followingList[i].userId == followerId) {
                                _this7.followingList[i].status = "1";
                            }
                        }
                        if (_this7.username == _this7.$store.state.user.name) {
                            _this7.followingNum += 1;
                        }
                    } else if (data.resCode == 1) {
                        for (var i = 0; i < _this7.followingList.length; i++) {
                            if (_this7.followingList[i].userId == followerId) {
                                _this7.followingList[i].status = "0";
                            }
                        }
                        if (_this7.username == _this7.$store.state.user.name) {
                            _this7.followingNum -= 1;
                        }
                    } else if (data.resCode == -3) {
                        _this7.$Message.error("Can not follow yourself!");
                    }
                });
            } else {
                this.$store.state.loginModal = true;
            }
        },
        follower: function follower(followerId) {
            var _this8 = this;

            if (localStorage.getItem("token")) {
                this.formFollow.userId = this.$store.state.user.id;
                this.formFollow.followerId = followerId;
                this.$http.post(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "follow/saveFollow", this.formFollow).then(function (successData) {
                    var data = successData.data;
                    if (data.resCode == 0) {
                        for (var i = 0; i < _this8.followerList.length; i++) {
                            if (_this8.followerList[i].userId == followerId) {
                                _this8.followerList[i].status = "1";
                            }
                        }
                        if (_this8.username == _this8.$store.state.user.name) {
                            _this8.followingNum += 1;
                        }
                    } else if (data.resCode == 1) {
                        for (var i = 0; i < _this8.followerList.length; i++) {
                            if (_this8.followerList[i].userId == followerId) {
                                _this8.followerList[i].status = "0";
                            }
                        }
                        if (_this8.username == _this8.$store.state.user.name) {
                            _this8.followingNum -= 1;
                        }
                    } else if (data.resCode == -3) {
                        _this8.$Message.error(_this8.$t('follow.canNotFollow'));
                    }
                });
            } else {
                this.$store.state.loginModal = true;
            }
        },
        referralFollow: function referralFollow(followerId) {
            var _this9 = this;

            if (localStorage.getItem("token")) {
                this.formFollow.userId = this.$store.state.user.id;
                this.formFollow.followerId = followerId;
                this.$http.post(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "follow/saveFollow", this.formFollow).then(function (successData) {
                    var data = successData.data;
                    if (data.resCode == 0) {
                        for (var i = 0; i < _this9.referralList.length; i++) {
                            if (_this9.referralList[i].userId == followerId) {
                                _this9.referralList[i].status = "1";
                            }
                        }
                        _this9.followingNum += 1;
                    } else if (data.resCode == 1) {
                        for (var i = 0; i < _this9.referralList.length; i++) {
                            if (_this9.referralList[i].userId == followerId) {
                                _this9.referralList[i].status = "0";
                            }
                        }
                        _this9.followingNum -= 1;
                    } else if (data.resCode == -3) {
                        _this9.$Message.error("Can not follow yourself!");
                    }
                });
            } else {
                this.$store.state.loginModal = true;
            }
        },
        getIsFollowByUserId: function getIsFollowByUserId(name) {
            var _this10 = this;

            this.userIdArray = [];
            switch (name) {
                case 'following':
                    for (var i = 0; i < this.followingList.length; i++) {
                        this.userIdArray[i] = this.followingList[i].userId;
                    }
                    break;
                case 'followers':
                    for (var i = 0; i < this.followerList.length; i++) {
                        this.userIdArray[i] = this.followerList[i].userId;
                    }
                    break;
                case 'referrals':
                    for (var i = 0; i < this.referralList.length; i++) {
                        this.userIdArray[i] = this.referralList[i].userId;
                    }
                    break;
                default:
                    break;
            }
            if (this.userIdArray.length == 0) {
                return;
            }
            var url = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "follow/getIsFollowByUserId/" + this.userId;
            this.$http.post(url, this.userIdArray).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    switch (name) {
                        case 'following':
                            for (var i = 0; i < _this10.followingList.length; i++) {
                                for (var j = 0; j < data.result.length; j++) {
                                    if (_this10.followingList[i].userId == data.result[j].followerId) {
                                        _this10.followingList[i].status = "1";
                                    }
                                }
                            }
                            break;
                        case 'followers':
                            for (var i = 0; i < _this10.followerList.length; i++) {
                                for (var j = 0; j < data.result.length; j++) {
                                    if (_this10.followerList[i].userId == data.result[j].followerId) {
                                        _this10.followerList[i].status = "1";
                                    }
                                }
                            }
                            break;
                        case 'referrals':
                            for (var i = 0; i < _this10.referralList.length; i++) {
                                for (var j = 0; j < data.result.length; j++) {
                                    if (_this10.referralList[i].userId == data.result[j].followerId) {
                                        _this10.referralList[i].status = "1";
                                    }
                                }
                            }
                            break;
                        default:
                            break;
                    }
                }
            });
        },
        getPostingById: function getPostingById(postingId, userId) {
            this.$router.push({
                name: 'postingsel',
                params: {
                    postingId: postingId,
                    userId: userId
                }
            });
        },
        getCollectionPostingList: function getCollectionPostingList() {
            var _this11 = this;

            var postingUrl = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "collection/open/getPostingByUsername/" + this.username + "/0/5";
            this.$http.get(postingUrl).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this11.postingList = data.result.postingList;
                    _this11.totalPostingNum = data.result.totalElements;
                } else if (data.resCode == -1) {
                    _this11.postingList = [];
                    _this11.totalPostingNum = 0;
                }
            });
        },
        getPostingByPage: function getPostingByPage(pageNo) {
            var _this12 = this;

            var postingUrl = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "collection/open/getPostingByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
            this.$http.get(postingUrl).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this12.postingList = data.result.postingList;
                    _this12.totalPostingNum = data.result.totalElements;
                } else if (data.resCode == -1) {
                    _this12.postingList = [];
                    _this12.totalPostingNum = 0;
                    _this12.$Notice.info({
                        title: "You don't have any collections yet."
                    });
                }
            });
        },

        collectionPosting: function collectionPosting(postingId) {
            var _this13 = this;

            this.formCollection.userId = this.$store.state.user.id;
            this.formCollection.postingId = postingId;
            this.$http.post(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "collection/saveCollectionPosting", this.formCollection).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {} else if (data.resCode == 1) {
                    _this13.getPostingByPage(1);
                }
            });
        },

        goUserData: function goUserData(username) {
            this.$router.push({
                name: 'userData',
                params: {
                    username: '@' + username
                }
            });
        },
        openNewWindowViewImage: function openNewWindowViewImage(imageUrl) {
            if (imageUrl) {
                window.open(imageUrl);
            }
        },
        hideBlock: function hideBlock(event) {},
        regTimeFormat: function regTimeFormat(time) {
            return formatTime(time, this.$i18n.locale);
        }
    }

});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js__ = __webpack_require__(1);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            file: null,
            uploadLoading: false,
            submitLoading: false,
            kycFormValid: true,
            birthdayModal: false,
            uploadUrl: '',

            documentImageFrontFile: null,
            documentImageFrontUrl: null,
            isShowDocumentImageFrontUploading: false,

            documentImageBackFile: null,
            documentImageBackUrl: null,
            isShowDocumentImageBackUploading: false,

            proofImageFile: null,
            proofImageUrl: null,
            isShowProofImageUploading: false,

            selfieImageFile: null,
            selfieImageUrl: null,
            isShowSelfieImageUploading: false,

            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            firstNameRules: [function (v) {
                return !!v || _this.$t('kyc.rules.required.required');
            }],
            lastNameRules: [function (v) {
                return !!v || _this.$t('kyc.rules.required.required');
            }],
            numberRules: [function (v) {
                return !!v || _this.$t('kyc.rules.required.required');
            }],
            birthdayRules: [function (v) {
                return !!v || _this.$t('kyc.rules.required.required');
            }],
            birthdayFormatted: null,
            kycForm: {
                userId: this.$store.getters.user.userId,
                identity: null,
                firstName: null,
                middleName: null,
                lastName: null,
                number: null,
                birthday: this.formatBirthday(this.birthdayFormatted),
                gender: 'M',
                documentImageFrontUrl: null,
                documentImageBackUrl: null,
                proofImageUrl: null,
                selfieImageUrl: null
            },
            identitySelect: [{ label: this.$t('kyc.identitySelect.passport'), value: 'PASSPORT' }, { label: this.$t('kyc.identitySelect.idCard'), value: 'IDCARD' }, { label: this.$t('kyc.identitySelect.driverLicence'), value: 'DRIVERLICENCE' }],
            genderSelect: [{ label: this.$t('kyc.gender.male'), value: 'M' }, { label: this.$t('kyc.gender.female'), value: 'F' }],
            countrySelect: [{ label: 'Albania', value: 'Albania' }, { label: 'Algeria', value: 'Algeria' }, { label: 'American Samoa', value: 'American Samoa' }, { label: 'Andorre', value: 'Andorre' }, { label: 'Angola', value: 'Angola' }, { label: 'Anguilla', value: 'Anguilla' }, { label: 'Antarctica', value: 'Antarctica' }, { label: 'Antigua and Barbuda', value: 'Antigua and Barbuda' }, { label: 'Argentina', value: 'Argentina' }, { label: 'Armenia', value: 'Armenia' }, { label: 'Aruba', value: 'Aruba' }, { label: 'Australia', value: 'Australia' }, { label: 'Austria', value: 'Austria' }, { label: 'Azerbaijan', value: 'Azerbaijan' }, { label: 'Bahamas', value: 'Bahamas' }, { label: 'Bahrain', value: 'Bahrain' }, { label: 'Bangladesh', value: 'Bangladesh' }, { label: 'Barbados', value: 'Barbados' }, { label: 'Belarus', value: 'Belarus' }, { label: 'Belgium', value: 'Belgium' }, { label: 'Belize', value: 'Belize' }, { label: 'Benin', value: 'Benin' }, { label: 'Bermuda', value: 'Bermuda' }, { label: 'Bhutan', value: 'Bhutan' }, { label: 'Bolivia', value: 'Bolivia' }, { label: 'Bonaire, Sint Eustatius and Saba', value: 'Bonaire, Sint Eustatius and Saba' }, { label: 'Botswana', value: 'Botswana' }, { label: 'Bouvet Island', value: 'Bouvet Island' }, { label: 'Brazil', value: 'Brazil' }, { label: 'British Indian Ocean Territory', value: 'British Indian Ocean Territory' }, { label: 'British Virgin Islands', value: 'British Virgin Islands' }, { label: 'Brunei', value: 'Brunei' }, { label: 'Bulgaria', value: 'Bulgaria' }, { label: 'Burkina Faso', value: 'Burkina Faso' }, { label: 'Burundi', value: 'Burundi' }, { label: 'Cambodia', value: 'Cambodia' }, { label: 'Cameroon', value: 'Cameroon' }, { label: 'Canada', value: 'Canada' }, { label: 'Cape Verde', value: 'Cape Verde' }, { label: 'Cayman Islands', value: 'Cayman Islands' }, { label: 'Central African Republic', value: 'Central African Republic' }, { label: 'Chad', value: 'Chad' }, { label: 'Chile', value: 'Chile' }, { label: 'China', value: 'China' }, { label: 'Christmas Island', value: 'Christmas Island' }, { label: 'Cocos (Keeling) Islands', value: 'Cocos (Keeling) Islands' }, { label: 'Colombia', value: 'Colombia' }, { label: 'Comoros', value: 'Comoros' }, { label: 'Congo', value: 'Congo' }, { label: 'Congo (Dem. Rep.)', value: 'Congo (Dem. Rep.)' }, { label: 'Cook Islands', value: 'Cook Islands' }, { label: 'Costa Rica', value: 'Costa Rica' }, { label: 'Croatia', value: 'Croatia' }, { label: 'Cuba', value: 'Cuba' }, { label: 'Curaçao', value: 'Curaçao' }, { label: 'Cyprus', value: 'Cyprus' }, { label: 'Czech Republic', value: 'Czech Republic' }, { label: "Côte D'Ivoire", value: "Côte D'Ivoire" }, { label: 'Denmark', value: 'Denmark' }, { label: 'Djibouti', value: 'Djibouti' }, { label: 'Dominica', value: 'Dominica' }, { label: 'Dominican Republic', value: 'Dominican Republic' }, { label: 'East Timor', value: 'East Timor' }, { label: 'Ecuador', value: 'Ecuador' }, { label: 'Egypt', value: 'Egypt' }, { label: 'El Salvador', value: 'El Salvador' }, { label: 'Equatorial Guinea', value: 'Equatorial Guinea' }, { label: 'Eritrea', value: 'Eritrea' }, { label: 'Estonia', value: 'Estonia' }, { label: 'Ethiopia', value: 'Ethiopia' }, { label: 'Falkland Islands', value: 'Falkland Islands' }, { label: 'Faroe Islands', value: 'Faroe Islands' }, { label: 'Fiji', value: 'Fiji' }, { label: 'Finland', value: 'Finland' }, { label: 'France', value: 'France' }, { label: 'French Guiana', value: 'French Guiana' }, { label: 'French Polynesia', value: 'French Polynesia' }, { label: 'French Southern Territories', value: 'French Southern Territories' }, { label: 'Gabon', value: 'Gabon' }, { label: 'Gambia', value: 'Gambia' }, { label: 'Georgia', value: 'Georgia' }, { label: 'Germany', value: 'Germany' }, { label: 'Ghana', value: 'Ghana' }, { label: 'Gibraltar', value: 'Gibraltar' }, { label: 'Greece', value: 'Greece' }, { label: 'Greenland', value: 'Greenland' }, { label: 'Grenada', value: 'Grenada' }, { label: 'Guadeloupe', value: 'Guadeloupe' }, { label: 'Guam', value: 'Guam' }, { label: 'Guatemala', value: 'Guatemala' }, { label: 'Guernsey and Alderney', value: 'Guernsey and Alderney' }, { label: 'Guinea', value: 'Guinea' }, { label: 'Guinea-Bissau', value: 'Guinea-Bissau' }, { label: 'Haiti', value: 'Haiti' }, { label: 'Heard and McDonald Islands', value: 'Heard and McDonald Islands' }, { label: 'Honduras', value: 'Honduras' }, { label: 'Hong Kong', value: 'Hong Kong' }, { label: 'Hungary', value: 'Hungary' }, { label: 'Iceland', value: 'Iceland' }, { label: 'India', value: 'India' }, { label: 'Indonesia', value: 'Indonesia' }, { label: 'Ireland', value: 'Ireland' }, { label: 'Isle of Man', value: 'Isle of Man' }, { label: 'Israel', value: 'Israel' }, { label: 'Italy', value: 'Italy' }, { label: 'Jamaica', value: 'Jamaica' }, { label: 'Japan', value: 'Japan' }, { label: 'Jersey', value: 'Jersey' }, { label: 'Jordan', value: 'Jordan' }, { label: 'Kazakhstan', value: 'Kazakhstan' }, { label: 'Kenya', value: 'Kenya' }, { label: 'Kiribati', value: 'Kiribati' }, { label: 'Korea (South)', value: 'Korea (South)' }, { label: 'Kosovo', value: 'Kosovo' }, { label: 'Kuwait', value: 'Kuwait' }, { label: 'Kyrgyzstan', value: 'Kyrgyzstan' }, { label: 'Laos', value: 'Laos' }, { label: 'Latvia', value: 'Latvia' }, { label: 'Lebanon', value: 'Lebanon' }, { label: 'Lesotho', value: 'Lesotho' }, { label: 'Liberia', value: 'Liberia' }, { label: 'Libya', value: 'Libya' }, { label: 'Liechtenstein', value: 'Liechtenstein' }, { label: 'Lithuania', value: 'Lithuania' }, { label: 'Luxembourg', value: 'Luxembourg' }, { label: 'Macao', value: 'Macao' }, { label: 'Macedonia', value: 'Macedonia' }, { label: 'Madagascar', value: 'Madagascar' }, { label: 'Malawi', value: 'Malawi' }, { label: 'Malaysia', value: 'Malaysia' }, { label: 'Maldives', value: 'Maldives' }, { label: 'Mali', value: 'Mali' }, { label: 'Malta', value: 'Malta' }, { label: 'Marshall Islands', value: 'Marshall Islands' }, { label: 'Martinique', value: 'Martinique' }, { label: 'Mauritania', value: 'Mauritania' }, { label: 'Mauritius', value: 'Mauritius' }, { label: 'Mayotte', value: 'Mayotte' }, { label: 'Mexico', value: 'Mexico' }, { label: 'Micronesia', value: 'Micronesia' }, { label: 'Moldova', value: 'Moldova' }, { label: 'Monaco', value: 'Monaco' }, { label: 'Mongolia', value: 'Mongolia' }, { label: 'Montenegro', value: 'Montenegro' }, { label: 'Montserrat', value: 'Montserrat' }, { label: 'Morocco', value: 'Morocco' }, { label: 'Mozambique', value: 'Mozambique' }, { label: 'Myanmar', value: 'Myanmar' }, { label: 'Namibia', value: 'Namibia' }, { label: 'Nauru', value: 'Nauru' }, { label: 'Nepal', value: 'Nepal' }, { label: 'Netherlands', value: 'Netherlands' }, { label: 'Netherlands Antilles', value: 'Netherlands Antilles' }, { label: 'New Caledonia', value: 'New Caledonia' }, { label: 'New Zealand', value: 'New Zealand' }, { label: 'Nicaragua', value: 'Nicaragua' }, { label: 'Niger', value: 'Niger' }, { label: 'Nigeria', value: 'Nigeria' }, { label: 'Niue', value: 'Niue' }, { label: 'Norfolk Island', value: 'Norfolk Island' }, { label: 'Northern Mariana Islands', value: 'Northern Mariana Islands' }, { label: 'Norway', value: 'Norway' }, { label: 'Oman', value: 'Oman' }, { label: 'Pakistan', value: 'Pakistan' }, { label: 'Palau', value: 'Palau' }, { label: 'Palestine', value: 'Palestine' }, { label: 'Panama', value: 'Panama' }, { label: 'Paraguay', value: 'Paraguay' }, { label: 'Peru', value: 'Peru' }, { label: 'Philippines', value: 'Philippines' }, { label: 'Pitcairn', value: 'Pitcairn' }, { label: 'Poland', value: 'Poland' }, { label: 'Portugal', value: 'Portugal' }, { label: 'Puerto Rico', value: 'Puerto Rico' }, { label: 'Qatar', value: 'Qatar' }, { label: 'Romania', value: 'Romania' }, { label: 'Russia', value: 'Russia' }, { label: 'Rwanda', value: 'Rwanda' }, { label: 'Réunion', value: 'Réunion' }, { label: 'Saint Barthélemy', value: 'Saint Barthélemy' }, { label: 'Saint Helena', value: 'Saint Helena' }, { label: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' }, { label: 'Saint Lucia', value: 'Saint Lucia' }, { label: 'Saint Martin', value: 'Saint Martin' }, { label: 'Saint Pierre and Miquelon', value: 'Saint Pierre and Miquelon' }, { label: 'Saint Vincent and the Grenadines', value: 'Saint Vincent and the Grenadines' }, { label: 'Samoa', value: 'Samoa' }, { label: 'San Marino', value: 'San Marino' }, { label: 'Saudi Arabia', value: 'Saudi Arabia' }, { label: 'Senegal', value: 'Senegal' }, { label: 'Serbia', value: 'Serbia' }, { label: 'Seychelles', value: 'Seychelles' }, { label: 'Sierra Leone', value: 'Sierra Leone' }, { label: 'Singapore', value: 'Singapore' }, { label: 'Sint Maarten', value: 'Sint Maarten' }, { label: 'Slovakia', value: 'Slovakia' }, { label: 'Slovenia', value: 'Slovenia' }, { label: 'Solomon Islands', value: 'Solomon Islands' }, { label: 'Somalia', value: 'Somalia' }, { label: 'South Africa', value: 'South Africa' }, { label: 'South Georgia and the South Sandwich Islands', value: 'South Georgia and the South Sandwich Islands' }, { label: 'South Sudan', value: 'South Sudan' }, { label: 'Spain', value: 'Spain' }, { label: 'Sri Lanka', value: 'Sri Lanka' }, { label: 'Sudan', value: 'Sudan' }, { label: 'Suriname', value: 'Suriname' }, { label: 'Svalbard and Jan Mayen', value: 'Svalbard and Jan Mayen' }, { label: 'Swaziland', value: 'Swaziland' }, { label: 'Sweden', value: 'Sweden' }, { label: 'Switzerland', value: 'Switzerland' }, { label: 'São Tomé and Príncipe', value: 'São Tomé and Príncipe' }, { label: 'Taiwan', value: 'Taiwan' }, { label: 'Tajikistan', value: 'Tajikistan' }, { label: 'Tanzania', value: 'Tanzania' }, { label: 'Thailand', value: 'Thailand' }, { label: 'Togo', value: 'Togo' }, { label: 'Tokelau', value: 'Tokelau' }, { label: 'Tonga', value: 'Tonga' }, { label: 'Trinidad and Tobago', value: 'Trinidad and Tobago' }, { label: 'Tunisia', value: 'Tunisia' }, { label: 'Turkey', value: 'Turkey' }, { label: 'Turkmenistan', value: 'Turkmenistan' }, { label: 'Turks and Caicos Islands', value: 'Turks and Caicos Islands' }, { label: 'Tuvalu', value: 'Tuvalu' }, { label: 'Ukraine', value: 'Ukraine' }, { label: 'United Arab Emirates', value: 'United Arab Emirates' }, { label: 'United Kingdom', value: 'United Kingdom' }, { label: 'United States Minor Outlying Islands', value: 'United States Minor Outlying Islands' }, { label: 'United States of America', value: 'United States of America' }, { label: 'Uruguay', value: 'Uruguay' }, { label: 'Uzbekistan', value: 'Uzbekistan' }, { label: 'Vatican City', value: 'Vatican City' }, { label: 'Venezuela', value: 'Venezuela' }, { label: 'Vietnam', value: 'Vietnam' }, { label: 'Virgin Islands of the United States', value: 'Virgin Islands of the United States' }, { label: 'Wallis and Futuna', value: 'Wallis and Futuna' }, { label: 'Western Sahara', value: 'Western Sahara' }, { label: 'Zambia', value: 'Zambia' }, { label: 'Zimbabwe', value: 'Zimbabwe' }, { label: 'Åland Islands', value: 'Åland Islands' }],
            proofOfPermanentAddressSelect: [{ label: this.$t('kyc.proofOfPermanentAddressSelect.telephoneBill'), value: 'TELEPHONEBILL' }, { label: this.$t('kyc.proofOfPermanentAddressSelect.bankAccountStatement'), value: 'BANKACCOUNTSTATEMENT' }, { label: this.$t('kyc.proofOfPermanentAddressSelect.utilityBill'), value: "UTILITYBILL" }],

            identityRules: [function (v) {
                return !!v || _this.$t('kyc.rules.required.identity');
            }],
            countryRules: [function (v) {
                return !!v || _this.$t('kyc.rules.required.country');
            }],
            proofOfPermanentAddressRules: [function (v) {
                return !!v || _this.$t('kyc.rules.required.proof');
            }]
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["user"])),
    created: function created() {},
    mounted: function mounted() {},

    watch: {
        birthdayFormatted: function birthdayFormatted(newVal, oldVal) {
            this.kycForm.birthday = this.formatBirthday(newVal);
        }
    },
    methods: {
        documentImageFrontBeforeUpload: function documentImageFrontBeforeUpload(file) {
            var _this2 = this;

            this.isShowDocumentImageFrontUploading = true;
            this.documentImageFrontFile = file;
            var uploadKycFileApi = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'userKyc/uploadKycFile?type=document-image-front';
            var fileData = new FormData();
            fileData.append('upfile', file);
            this.$http.post(uploadKycFileApi, fileData).then(function (response) {
                var data = response.data;
                _this2.isShowDocumentImageFrontUploading = false;
                if (data.resCode == 0) {
                    _this2.documentImageFrontUrl = data.result;
                    _this2.kycForm.documentImageFrontUrl = data.result;
                } else {
                    _this2.$Message.error(_this2.$t("common.fail"));
                }
            }, function (error) {
                _this2.$Message.error(_this2.$t("common.serverError"));
                _this2.isShowDocumentImageFrontUploading = false;
            });
        },
        documentImageBackBeforeUpload: function documentImageBackBeforeUpload(file) {
            var _this3 = this;

            this.isShowDocumentImageBackUploading = true;
            this.documentImageBackFile = file;
            var uploadKycFileApi = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'userKyc/uploadKycFile?type=document-image-back';
            var fileData = new FormData();
            fileData.append('upfile', file);
            this.$http.post(uploadKycFileApi, fileData).then(function (response) {
                var data = response.data;
                _this3.isShowDocumentImageBackUploading = false;
                if (data.resCode == 0) {
                    _this3.documentImageBackUrl = data.result;
                    _this3.kycForm.documentImageBackUrl = data.result;
                } else {
                    _this3.$Message.error(_this3.$t("common.fail"));
                }
            }, function (error) {
                _this3.$Message.error(_this3.$t("common.serverError"));
                _this3.isShowDocumentImageBackUploading = false;
            });
        },
        proofImageBeforeUpload: function proofImageBeforeUpload(file) {
            var _this4 = this;

            this.isShowProofImageUploading = true;
            this.proofImageFile = file;
            var uploadKycFileApi = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'userKyc/uploadKycFile?type=proof-image';
            var fileData = new FormData();
            fileData.append('upfile', file);
            this.$http.post(uploadKycFileApi, fileData).then(function (response) {
                var data = response.data;
                _this4.isShowProofImageUploading = false;
                if (data.resCode == 0) {
                    _this4.proofImageUrl = data.result;
                    _this4.kycForm.proofImageUrl = data.result;
                } else {
                    _this4.$Message.error(_this4.$t("common.fail"));
                }
            }, function (error) {
                _this4.$Message.error(_this4.$t("common.serverError"));
                _this4.isShowProofImageUploading = false;
            });
        },
        selfieImageBeforeUpload: function selfieImageBeforeUpload(file) {
            var _this5 = this;

            this.isSelfieImageUploading = true;
            this.selfieImageFile = file;
            var uploadKycFileApi = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + 'userKyc/uploadKycFile?type=selfie-image';
            var fileData = new FormData();
            fileData.append('upfile', file);
            this.$http.post(uploadKycFileApi, fileData).then(function (response) {
                var data = response.data;
                _this5.isSelfieImageUploading = false;
                if (data.resCode == 0) {
                    _this5.selfieImageUrl = data.result;
                    _this5.kycForm.selfieImageUrl = data.result;
                } else {
                    _this5.$Message.error(_this5.$t("common.fail"));
                }
            }, function (error) {
                _this5.$Message.error(_this5.$t("common.serverError"));
                _this5.isSelfieImageUploading = false;
            });
        },
        clearDocumentImageFrontFile: function clearDocumentImageFrontFile() {
            this.documentImageFrontFile = null;
            this.documentImageFrontUrl = null;
            this.kycForm.documentImageFrontUrl = null;
        },
        clearDocumentImageBackFile: function clearDocumentImageBackFile() {
            this.documentImageBackFile = null;
            this.documentImageBackUrl = null;
            this.kycForm.documentImageBackUrl = null;
        },
        clearProofImageFile: function clearProofImageFile() {
            this.proofImageFile = null;
            this.proofImageUrl = null;
            this.kycForm.proofImageUrl = null;
        },
        clearSelfieImageFile: function clearSelfieImageFile() {
            this.selfieImageFile = null;
            this.selfieImageUrl = null;
            this.kycForm.selfieImageUrl = null;
        },
        beforeUpload: function beforeUpload(file) {
            var fileName = file.name;
            var suffix = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length).toLowerCase();
            if (suffix == "jpg" || suffix == "jpeg" || suffix == "png") {
                var fileSize = file.size;
                if (fileSize > 1024 * 1024 * 2) {
                    this.file = null;
                    this.$Message.error({
                        content: this.$t('uploadMaterial.message.tooLarge'),
                        duration: 5,
                        closable: true
                    });
                } else {
                    this.file = file;
                }
            } else {
                this.file = null;

                this.$Message.error({
                    content: this.$t('uploadMaterial.message.formatIncorrect'),
                    duration: 5,
                    closable: true
                });
            }

            return false;
        },
        clearFile: function clearFile() {
            this.clearDocumentImageFrontFile();
            this.clearDocumentImageBackFile();
            this.clearProofImageFile();
            this.clearSelfieImageFile();
        },
        uploadFile: function uploadFile() {
            var _this6 = this;

            alert("正在开发中...");
            return;
            this.uploadLoading = true;
            var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + "request/open/uploadFile/" + this.userRequest.userRequestId;

            var fileData = new FormData();
            fileData.append('upfile', this.file);
            this.$http.post(url, fileData).then(function (successData) {
                _this6.uploadLoading = false;
                _this6.clearFile();
                var data = successData.data;
                if (data.resCode == 0) {
                    _this6.sendNoticeEmail();
                    _this6.$Notice.success({
                        title: _this6.$t('uploadMaterial.message.uploadSuccessTitle'),
                        duration: 10,
                        desc: _this6.$t('uploadMaterial.message.uploadSuccessDesc')
                    });
                    _this6.$router.push({ name: "home" });
                } else {
                    _this6.$Message.error(_this6.$t("common.fail"));
                }
            }, function (error) {
                _this6.$Message.error(_this6.$t("common.fail"));
                _this6.uploadLoading = false;
            });
        },
        sendNoticeEmail: function sendNoticeEmail() {
            var url = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + "sendEmail/open/sendUploadMaterialNoticeEmail?userRequestId=" + this.userRequest.userRequestId;
            this.$http.get(url).then(function (response) {});
        },
        formatBirthday: function formatBirthday(date) {
            if (!date) return null;

            var _date$split = date.split('-'),
                _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
                year = _date$split2[0],
                month = _date$split2[1],
                day = _date$split2[2];

            return '' + year + month + day;
        },
        submitUserKycHandle: function submitUserKycHandle() {
            var _this7 = this;

            this.submitLoading = true;
            if (this.$refs.kycForm.validate()) {
                if (this.kycForm.birthday == null || this.kycForm.documentImageFrontUrl == null || this.kycForm.documentImageBackUrl == null || this.kycForm.proofImageUrl == null || this.kycForm.selfieImageUrl == null) {
                    this.$Message.error(this.$t("common.fail"));
                    this.submitLoading = false;
                    return;
                }
                var api = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].baseUrl + "userKyc/saveUserKyc";
                this.$http.post(api, this.kycForm).then(function (response) {
                    _this7.submitLoading = false;
                    var data = response.data;
                    if (data.resCode == 0) {
                        _this7.$refs.kycForm.reset();
                        _this7.clearFile();
                        _this7.$Notice.success({
                            title: _this7.$t('common.success'),
                            duration: 5
                        });
                        _this7.$router.push({ name: 'userSetting' });
                    } else {
                        _this7.$Message.error(_this7.$t("common.fail"));
                    }
                }, function (error) {
                    _this7.$Message.error(_this7.$t("common.serverError"));
                    _this7.submitLoading = false;
                });
            } else {
                this.$Message.error(this.$t("common.fail"));
                this.submitLoading = false;
            }
        }
    }

});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            userInfoList: [],
            pageNo: 0,
            infiniteId: +new Date(),
            isLoadingUserInfoList: false
        };
    },

    components: {
        InfiniteLoading: __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default.a
    },
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('NumFormat', function (value) {
            if (!value) return '0.00';
            var intPart = Number(value).toFixed(0);
            intPart = intPart > value ? intPart - 1 : intPart;
            var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
            var floatPart = ".00";
            var value2Array = value.split(".");

            if (value2Array.length == 2) {
                floatPart = value2Array[1].toString();
                if (floatPart.length == 1) {
                    return intPartFormat + "." + floatPart + '0';
                } else {
                    return intPartFormat + "." + floatPart;
                }
            } else {
                return intPartFormat + floatPart;
            }
        });
    },
    mounted: function mounted() {},

    watch: {},
    methods: {
        getUserRanking: function getUserRanking($state) {
            var _this = this;

            if (this.isLoadingUserInfoList) {
                return;
            }
            this.isLoadingUserInfoList = true;
            var api = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].baseUrl + 'userDetail/open/getUserRanking?sortField=iobPower&pageNo=' + this.pageNo + '&pageSize=10';
            this.$http.get(api).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this.userInfoList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.userInfoList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.result));
                    _this.pageNo += 1;
                    _this.isLoadingUserInfoList = false;
                    $state.loaded();
                } else {
                    _this.isLoadingUserInfoList = false;
                    $state.complete();
                }
            });
        },
        gotoUserData: function gotoUserData(username) {
            this.$router.push({ name: 'userData', params: { username: '@' + username } });
        }
    }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clipboard__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_cropperjs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_cropperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_md5__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_js_eventBus_js__ = __webpack_require__(16);












/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        var passWord = function passWord(rule, value, callback) {
            var passreg = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;
            if (value == 0) {
                callback(new Error(_this.$t("userSetting.errorCallback.passWord.empty")));
            } else {
                callback();
            }
        };
        var newPassWord = function newPassWord(rule, value, callback) {
            var passreg = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;
            if (value == 0) {
                callback(new Error(_this.$t("userSetting.errorCallback.newPassWord.empty")));
            } else if (!passreg.test(value)) {
                callback(new Error(_this.$t("userSetting.errorCallback.newPassWord.value")));
            } else {
                callback();
            }
        };
        var confirmNewPassWord = function confirmNewPassWord(rule, value, callback) {
            if (value == 0) {
                callback(new Error(_this.$t("userSetting.errorCallback.confirmNewPassWord.again")));
            } else if (value !== _this.formPassword.newPassWord) {
                callback(new Error(_this.$t("userSetting.errorCallback.confirmNewPassWord.match")));
            } else {
                callback();
            }
        };
        var validateId = function validateId(rule, value, callback) {
            if (value === '') {
                callback(new Error(_this.$t("userSetting.errorCallback.id")));
            } else {
                callback();
            }
        };
        var validateAuthenticationSecret = function validateAuthenticationSecret(rule, value, callback) {
            if (value === '') {
                callback(new Error(_this.$t("userSetting.errorCallback.secret")));
            } else {
                callback();
            }
        };
        var validateRandomCode = function validateRandomCode(rule, value, callback) {
            if (!value) {
                callback(new Error(_this.$t("userSetting.errorCallback.code.empty")));
            } else if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(+value)) {
                callback(new Error(_this.$t("userSetting.errorCallback.code.value")));
            } else if ((value + '').length !== 6) {
                callback(new Error(_this.$t("userSetting.errorCallback.code.digits")));
            } else {
                callback();
            }
        };
        var validateImage = function validateImage(rule, value, callback) {
            if (value === '') {
                callback(new Error(_this.$t("userSetting.errorCallback.image.empty")));
            } else if (value.substring(0, 7) === 'http://') {
                callback();
            } else if (value.substring(0, 8) === 'https://') {
                callback();
            } else {
                callback(new Error(_this.$t("userSetting.errorCallback.image.invalid")));
            }
        };
        var validateCoverImage = function validateCoverImage(rule, value, callback) {
            if (value === '') {
                callback(new Error(_this.$t("userSetting.errorCallback.image.empty")));
            } else if (value.substring(0, 7) === 'http://') {
                callback();
            } else if (value.substring(0, 8) === 'https://') {
                callback();
            } else {
                callback(new Error(_this.$t("userSetting.errorCallback.image.invalid")));
            }
        };
        return {
            image_url: '',
            username: this.$store.state.user.name,
            uploadUrl: '',
            uploadCoverImageUrl: '',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            headerImage: '',
            picValue: '',
            cropper: '',
            croppable: false,
            panel: false,
            panelImageUrl: '',
            credentials: true,
            isShowNickName: true,
            isShowNickNameInput: false,
            isShowRegEmailInput: false,
            isShowImageInput: false,
            isShowCoverImageInput: false,
            isShowTimeZoneInput: false,
            isShowAccount: true,
            isShowPassword: false,
            isShowKyc: false,
            isShowPrivacyAndSafety: false,
            isShowGoogleAuthentication: false,
            isShowAccountBinding: false,
            isShowConfirmWalletModal: false,
            isShowDisableModal: false,
            enableLoading: false,
            invitationLink: __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].ip + '#/register?invitationCode=' + localStorage.getItem("invitationCode"),
            userDetail: {},
            level: {},
            formNickName: { nickName: '' },
            formRegEmail: {
                id: '',
                regEmail: ''
            },
            formImage: {
                userId: '',
                image: ''
            },
            formCoverImage: {
                userId: '',
                coverImage: ''
            },
            formPasswordValid: false,
            formPassword: {
                id: '',
                passWord: '',
                newPassWord: '',
                confirmNewPassWord: ''
            },
            formAuthentication: {
                id: ''
            },
            formDisableAuthentication: {
                id: '',
                authenticationSecret: '',
                randomCode: ''
            },
            ruleRegEmail: {
                regEmail: [{ required: true, message: this.$t("userSetting.requiredMessage.regEmailBeEmpty"), trigger: 'change' }, { type: 'email', message: this.$t("userSetting.requiredMessage.regEmailFormat"), trigger: 'change' }]
            },
            ruleImage: {
                image: [{ required: true, validator: validateImage, trigger: 'blur' }]
            },
            ruleCoverImage: {
                image: [{ required: true, validator: validateCoverImage, trigger: 'blur' }]
            },
            rulePassword: {
                passWord: [{ validator: passWord, trigger: 'blur' }],
                newPassWord: [{ validator: newPassWord, trigger: 'blur' }],
                confirmNewPassWord: [{ validator: confirmNewPassWord, trigger: 'blur' }]
            },
            currentPasswordRules: [function (v) {
                return !!v || _this.$t('register.errorCallback.passWord.empty');
            }],
            newPasswordRules: [function (v) {
                return !!v || _this.$t('register.errorCallback.passWord.empty');
            }, function (v) {
                return (/^(?=.*\d)(?=.*[A-Za-z]).{8,20}$/.test(v) || _this.$t('register.errorCallback.passWord.value')
                );
            }],
            confirmNewPasswordRules: [function (v) {
                return !!v || _this.$t('register.errorCallback.repassWord.empty');
            }, function (v) {
                return v == _this.formPassword.newPassWord || _this.$t('register.errorCallback.repassWord.value');
            }],
            ruleDisableAuthentication: {
                id: [{ validator: validateId, trigger: 'blur' }],
                authenticationSecret: [{ validator: validateAuthenticationSecret, trigger: 'blur' }],
                randomCode: [{ validator: validateRandomCode, trigger: 'blur' }]
            },
            randomCodeRules: [function (v) {
                return !!v || '';
            }, function (v) {
                return v && v.length == 6 || '';
            }, function (v) {
                return (/^\d{6}$/.test(v) || ''
                );
            }],
            i18nList: [],
            timeZoneList: [],
            receiveAuthenticationEmail: true,
            userRight: {},
            userRightCheck: {},
            userRightVaild: true,
            telegramUser: {},
            telegramUserUrl: "https://telegram.me/"
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(["user"])),
    created: function created() {
        this.authenticationSuccess();
        this.getUserDetail();

        this.getTimeZoneList();
    },
    mounted: function mounted() {
        var _this2 = this;

        this.initCropper();

        $(document).on('keypress', '#enter-verify-code', function (event) {
            if (event.keyCode == 13) {
                _this2.verityRandomCode('formDisableAuthentication');
            }
        });
    },

    watch: {
        '$route': 'authenticationSuccess',
        userRight: {
            handler: function handler() {
                var flag = isObjectValueEqual(this.userRight, this.userRightCheck);
                if (flag) {
                    this.userRightVaild = true;
                } else {
                    this.userRightVaild = false;
                }
            },

            deep: true
        }
    },
    methods: {
        getMenuData: function getMenuData(name) {
            switch (name) {
                case "account":
                    this.isShowAccount = true;
                    this.isShowPassword = false;
                    this.isShowKyc = false;
                    this.isShowPrivacyAndSafety = false;
                    this.isShowGoogleAuthentication = false;
                    this.isShowAccountBinding = false;
                    break;
                case "password":
                    this.isShowAccount = false;
                    this.isShowPassword = true;
                    this.isShowKyc = false;
                    this.isShowPrivacyAndSafety = false;
                    this.isShowGoogleAuthentication = false;
                    this.isShowAccountBinding = false;
                    break;
                case "kyc":
                    this.isShowAccount = false;
                    this.isShowPassword = false;
                    this.isShowKyc = true;
                    this.isShowPrivacyAndSafety = false;
                    this.isShowGoogleAuthentication = false;
                    this.isShowAccountBinding = false;
                    break;
                case "privacyAndSafety":
                    this.isShowAccount = false;
                    this.isShowPassword = false;
                    this.isShowKyc = false;
                    this.isShowPrivacyAndSafety = true;
                    this.isShowGoogleAuthentication = false;
                    this.isShowAccountBinding = false;
                    break;
                case "googleAuthentication":
                    this.isShowAccount = false;
                    this.isShowPassword = false;
                    this.isShowKyc = false;
                    this.isShowPrivacyAndSafety = false;
                    this.isShowGoogleAuthentication = true;
                    this.isShowAccountBinding = false;
                    break;
                case "accountBinding":
                    this.getTelegramUserByUserId();
                    this.isShowAccount = false;
                    this.isShowPassword = false;
                    this.isShowKyc = false;
                    this.isShowPrivacyAndSafety = false;
                    this.isShowGoogleAuthentication = false;
                    this.isShowAccountBinding = true;
                    break;
                default:
                    break;
            }
        },
        getUserDetail: function getUserDetail() {
            var _this3 = this;

            this.$http.get(__WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "userDetail/getMe").then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this3.userDetail = data.result;
                    document.title = _this3.userDetail.nickName + "(@" + _this3.userDetail.userName + ")——SiP";
                } else {
                    _this3.$router.push({ name: 'page404' });
                }
            });
            this.$http.get(__WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "userRight/getUserRight?userId=" + this.$store.state.user.id).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this3.userRight = data.result;
                    _this3.userRightCheck = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data.result);
                }
            });
        },
        getLevelById: function getLevelById() {
            var _this4 = this;

            this.$http.get(__WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + 'level/getLevel/' + this.userDetail.levelId).then(function (successData) {
                var data = successData.data;
                _this4.level = data.result;
            });
        },
        getI18nList: function getI18nList() {
            var _this5 = this;

            var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + 'i18n/getI18nAllList';
            this.$http.get(url).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this5.i18nList = data.result;
                } else {
                    _this5.i18nList = [];
                }
            });
        },
        getTimeZoneList: function getTimeZoneList() {
            var _this6 = this;

            var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + 'timeZone/getTimeZoneList';
            this.$http.get(url).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this6.timeZoneList = data.result;
                } else {
                    _this6.timeZoneList = [];
                }
            });
        },
        initCropper: function initCropper() {
            var self = this;
            var image = document.getElementById('image');
            this.cropper = new __WEBPACK_IMPORTED_MODULE_7_cropperjs___default.a(image, { aspectRatio: 1, viewMode: 1, background: false, zoomable: false,
                ready: function ready() {
                    self.croppable = true;
                }
            });
        },
        beforeUpload: function beforeUpload(files) {
            this.panel = true;
            this.picValue = files;

            this.panelImageUrl = this.getObjectURL(this.picValue);
            if (this.cropper) {
                this.cropper.replace(this.panelImageUrl);
            }

            return false;
        },
        getObjectURL: function getObjectURL(file) {
            var url = null;
            if (window.createObjectURL != undefined) {
                url = window.createObjectURL(file);
            } else if (window.URL != undefined) {
                url = window.URL.createObjectURL(file);
            } else if (window.webkitURL != undefined) {
                url = window.webkitURL.createObjectURL(file);
            }
            return url;
        },
        getRoundedCanvas: function getRoundedCanvas(sourceCanvas) {
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            var width = sourceCanvas.width;
            var height = sourceCanvas.height;
            canvas.width = width;
            canvas.height = height;
            context.imageSmoothingEnabled = true;
            context.drawImage(sourceCanvas, 0, 0, width, height);
            context.globalCompositeOperation = 'destination-in';
            context.beginPath();
            context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
            context.fill();
            return canvas;
        },
        cancelPanel: function cancelPanel() {
            this.panel = false;
        },
        cropperImage: function cropperImage() {
            this.panel = false;
            var croppedCanvas;
            var roundedCanvas;
            if (!this.croppable) {
                return;
            }
            croppedCanvas = this.cropper.getCroppedCanvas();
            roundedCanvas = this.getRoundedCanvas(croppedCanvas);
            this.headerImage = roundedCanvas.toDataURL();
            this.uploadAvatar();
        },
        uploadAvatar: function uploadAvatar() {
            var loading = this.$Message.loading({
                content: this.$t("userSetting.uploading"),
                duration: 0
            });
            var fileData = new FormData();
            var that = this;
            var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "userDetail/uploadAvatar/file/" + this.$store.state.user.id;

            canvasDataURL(that.headerImage, { width: 150, height: 150 }, function (base64Codes) {
                var blob = convertBase64UrlToBlob(base64Codes);

                fileData.append('upfile', blob, Date.parse(new Date()) + ".png");
                that.$http.post(url, fileData).then(function (successData) {
                    var data = successData.data;
                    setTimeout(loading, 500);
                    if (data.resCode == 0) {
                        that.userDetail.image = data.result;
                        that.$store.dispatch('imageHandler', data.result);
                        that.$store.state.user.image = data.result;
                        localStorage.setItem("image", data.result);
                    } else {
                        that.$Message.error(that.$t("common.fail"));
                    }
                }, function (error) {
                    setTimeout(loading, 500);
                    that.$Message.error(that.$t("common.fail"));
                });
            });
        },
        uploadSuccess: function uploadSuccess(response, file, fileList) {
            this.userDetail.image = response.result;
            this.$store.state.user.image = response.result;
            localStorage.setItem("image", response.result);
        },
        uploadProgress: function uploadProgress(event, file, fileList) {
            this.$Message.loading(this.$t("common.loading"));
        },
        uploadCoverImageBefore: function uploadCoverImageBefore(file) {
            var loading = this.$Message.loading({
                content: this.$t("userSetting.uploading"),
                duration: 0
            });
            var fileData = new FormData();
            var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + 'userDetail/uploadCoverImage?userId=' + this.$store.state.user.id;
            var that = this;
            photoCompress(file, { quality: 0.2 }, function (base64Codes) {
                var blob = convertBase64UrlToBlob(base64Codes);

                fileData.append('coverImage', blob, file.name);
                that.$http.post(url, fileData).then(function (response) {
                    var data = response.data;
                    if (data.resCode == 0) {
                        that.userDetail.coverImage = data.result;
                    }
                    setTimeout(loading, 500);
                }, function (error) {
                    setTimeout(loading, 0);
                    that.$Message.error(that.$t("common.fail"));
                });
            });
            return false;
        },
        uploadCoverImageProgress: function uploadCoverImageProgress(event, file, fileList) {
            this.$Message.loading(this.$t("common.loading"));
        },
        uploadCoverImageSuccess: function uploadCoverImageSuccess(response, file, fileList) {
            this.userDetail.coverImage = response.result;
        },
        uploadError: function uploadError() {
            this.$Message.error(this.$t("common.fail"));
        },
        showNickNameInput: function showNickNameInput() {
            this.userDetail.nickName = this.user.nickName;
            this.isShowNickName = !this.isShowNickName;
            this.isShowNickNameInput = !this.isShowNickNameInput;
        },
        updateNickName: function updateNickName() {
            var _this7 = this;

            this.formNickName.nickName = this.userDetail.nickName;
            this.isShowNickName = !this.isShowNickName;
            this.isShowNickNameInput = !this.isShowNickNameInput;
            this.$http.post(__WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "user/updateNickName", this.formNickName).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this7.userDetail.nickName = data.result;
                }
            }, function (errorData) {
                _this7.$Message.error(_this7.$t("common.serverError"));
            });
        },
        showRegEmailInput: function showRegEmailInput() {
            this.userDetail.regEmail = this.user.regEmail;
            this.isShowRegEmailInput = !this.isShowRegEmailInput;
        },
        sendUpdateRegEmail: function sendUpdateRegEmail() {
            var _this8 = this;

            this.formRegEmail.id = this.userDetail.userId;
            this.formRegEmail.regEmail = this.userDetail.regEmail;
            var validationEmailUrl = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "user/open/register/validationEmail";
            this.$http.post(validationEmailUrl, this.formRegEmail).then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    var sendEmailUrl = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + 'user/sendUpdateRegEmail';
                    _this8.isShowRegEmailInput = !_this8.isShowRegEmailInput;
                    _this8.$http.post(sendEmailUrl, _this8.formRegEmail).then(function (successData) {
                        var data = successData.data;
                        if (data.resCode == 0) {
                            _this8.userDetail.regEmail = _this8.user.regEmail;
                            _this8.$Notice.success({
                                title: _this8.$t("userSetting.notice.updateEmail.title"),
                                desc: _this8.$t("userSetting.notice.updateEmail.desc"),
                                duration: 0
                            });
                        } else if (data.resCode == -10001) {
                            _this8.isShowRegEmailInput = !_this8.isShowRegEmailInput;
                            _this8.$Message.error(_this8.$t("userSetting.message.emailAnomaly"));
                        }
                    });
                } else if (data.resCode == 1) {
                    _this8.isShowRegEmailInput = !_this8.isShowRegEmailInput;
                    _this8.$Message.error(_this8.$t("userSetting.message.registered"));
                }
            });
        },
        copyInvitationLink: function copyInvitationLink() {
            var _this9 = this;

            var clipboard = new __WEBPACK_IMPORTED_MODULE_6_clipboard___default.a('#invitationLink');
            clipboard.on('success', function (e) {
                _this9.$Message.success(_this9.$t("common.copySuccess"));

                clipboard.destroy();
            });
            clipboard.on('error', function (e) {
                _this9.$Message.error(_this9.$t("common.copyFailure"));

                clipboard.destroy();
            });
        },
        shareInvitationLink: function shareInvitationLink() {
            this.$Message.info("敬请期待分享邀请码!");
        },
        updateI18n: function updateI18n(i18nId) {
            var _this10 = this;

            var userInfo = { 'userId': this.userDetail.userId, 'i18nId': i18nId };
            var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + 'userDetail/updateI18n';
            this.$http.post(url, userInfo).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this10.$i18n.locale = data.result.code;
                    localStorage.setItem("locale", data.result.code);
                    _this10.$Message.success(_this10.$t("common.success"));
                }
            });
        },
        updateTimeZone: function updateTimeZone() {
            var _this11 = this;

            var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + 'userDetail/updateTimeZone?timeZoneId=' + this.userDetail.timeZoneId + '&userId=' + this.userDetail.userId;
            this.$http.get(url).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this11.$store.dispatch("timeZoneHandler", data.result);
                }
            });
        },
        subImageLink: function subImageLink(image) {
            if ((image + '').length > 20) {
                return image.substring(0, 20) + "...";
            } else {
                return image;
            }
        },
        showImageInput: function showImageInput() {
            this.userDetail.image = this.user.image;
            this.isShowImageInput = !this.isShowImageInput;
        },
        updateImage: function updateImage() {
            var _this12 = this;

            this.formImage.image = this.userDetail.image;
            this.formImage.userId = this.userDetail.userId;
            this.$http.post(__WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + 'userDetail/updateImage', this.formImage).then(function (successData) {
                var data = successData.data;
                _this12.isShowImageInput = !_this12.isShowImageInput;
                if (data.resCode == 0) {
                    _this12.userDetail.image = data.result;
                    _this12.$store.state.user.image = data.result;
                    localStorage.setItem("image", data.result);
                }
            });
        },
        showCoverImageInput: function showCoverImageInput() {
            this.userDetail.coverImage = this.user.coverImage;
            this.isShowCoverImageInput = !this.isShowCoverImageInput;
        },
        updateCoverImage: function updateCoverImage() {
            var _this13 = this;

            this.formCoverImage.coverImage = this.userDetail.coverImage;
            this.formCoverImage.userId = this.userDetail.userId;
            this.$http.post(__WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + 'userDetail/updateCoverImage', this.formCoverImage).then(function (successData) {
                var data = successData.data;
                _this13.isShowCoverImageInput = !_this13.isShowCoverImageInput;
                if (data.resCode == 0) {
                    _this13.userDetail.coverImage = data.result;
                }
            });
        },
        goPassword: function goPassword() {
            this.$router.push({ name: 'password' });
        },
        updatePassword: function updatePassword() {
            var _this14 = this;

            if (this.$refs.formPassword.validate()) {
                this.formPassword.id = this.userDetail.userId;
                var passWord = __WEBPACK_IMPORTED_MODULE_8_js_md5___default()(this.formPassword.passWord);
                passWord = passWord.split('').reverse().join('');
                passWord = __WEBPACK_IMPORTED_MODULE_8_js_md5___default()(passWord);
                var sha256 = __webpack_require__(40).sha256;
                var passWord_v2 = sha256(this.formPassword.passWord);
                var newPassWord = sha256(this.formPassword.newPassWord);
                var confirmNewPassWord = sha256(this.formPassword.confirmNewPassWord);
                var userPasswordFormData = {
                    id: this.formPassword.id,
                    passWord: passWord,
                    passWord_v2: passWord_v2,
                    newPassWord: newPassWord,
                    confirmNewPassWord: confirmNewPassWord
                };

                var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "user/updatePasswordByPassword";
                this.$http.post(url, userPasswordFormData).then(function (successData) {
                    var data = successData.data;
                    if (data.resCode == 0) {
                        this.$refs.formPassword.reset();
                        this.$Notice.success({
                            title: this.$t("userSetting.notice.updatePassword.title"),
                            desc: this.$t("userSetting.notice.updatePassword.desc"),
                            duration: 0
                        });
                    } else if (data.resCode == -3) {
                        this.$refs.formPassword.reset();
                        this.$Notice.error({
                            title: this.$t("userSetting.errorCallback.confirmNewPassWord.match"),
                            duration: 0
                        });
                    } else if (data.resCode == -5) {
                        this.$refs.formPassword.reset();
                        this.$Notice.error({
                            title: this.$t("userSetting.errorCallback.passWord.error"),
                            duration: 0
                        });
                    } else if (data.resCode == -1) {
                        this.$refs.formPassword.reset();
                        this.$Notice.error({
                            title: this.$t("enableAuthentication.dangerousMsg"),
                            duration: 0
                        });
                    }
                }, function (errorData) {
                    _this14.$Message.error(_this14.$t("common.serverError"));
                    _this14.$refs.formPassword.reset();
                });
            }
        },
        gotoAuthentication: function gotoAuthentication() {
            var _this15 = this;

            var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "user/openAuthentication";
            this.formAuthentication.id = this.userDetail.userId;
            this.enableLoading = !this.enableLoading;
            this.$http.post(url, this.formAuthentication).then(function (successData) {
                _this15.enableLoading = !_this15.enableLoading;
                _this15.$router.push({ name: 'enableAuthentication' });
            }, function (errorData) {
                _this15.enableLoading = !_this15.enableLoading;
                _this15.$Message.error(_this15.$t("common.serverError"));
            });
        },
        authenticationSuccess: function authenticationSuccess() {
            if (sessionStorage.getItem('authentication') == true) {
                this.getUserDetail();
                sessionStorage.setItem('authentication', false);
            }
        },
        resetAuthentication: function resetAuthentication() {
            this.$router.push({ name: 'resetAuthentication', params: { userId: this.userDetail.userId } });
        },
        showDisableModal: function showDisableModal() {
            this.isShowDisableModal = !this.isShowDisableModal;
        },
        disableModalCancel: function disableModalCancel() {
            this.isShowDisableModal = !this.isShowDisableModal;
        },
        verityRandomCode: function verityRandomCode(name) {
            var _this16 = this;

            this.formDisableAuthentication.id = this.userDetail.userId;
            this.formDisableAuthentication.authenticationSecret = this.userDetail.authenticationSecret;
            if (this.$refs[name].validate()) {
                var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "user/updateAuthenticationStatus";
                this.$http.post(url, this.formDisableAuthentication).then(function (successData) {
                    var data = successData.data;
                    _this16.formDisableAuthentication.randomCode = '';
                    if (data.resCode == 0) {
                        _this16.$Message.success(_this16.$t("common.success"));
                        _this16.isShowDisableModal = !_this16.isShowDisableModal;
                        _this16.userDetail.openAuthentication = false;
                    } else if (data.resCode == -1) {
                        _this16.$Message.error(_this16.$t("enableAuthentication.dangerousMsg"));
                    } else if (data.resCode == -2) {
                        _this16.$Message.error(_this16.$t("enableAuthentication.verificationCodeError"));
                    } else if (data.resCode == -3) {
                        _this16.$Message.error(_this16.$t("common.serverError"));
                    }
                }, function (errorData) {
                    _this16.$Message.error(_this16.$t("common.serverError"));
                });
            } else {
                this.$Message.error(this.$t("common.fail"));
                this.formDisableAuthentication.randomCode = '';
            }
        },
        disableAuthentication: function disableAuthentication(name) {
            var _this17 = this;

            this.formDisableAuthentication.id = this.userDetail.userId;
            this.formDisableAuthentication.authenticationSecret = this.userDetail.authenticationSecret;
            this.$refs[name].validate(function (valid) {
                if (valid) {
                    var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "user/updateAuthenticationStatus";
                    _this17.$http.post(url, _this17.formDisableAuthentication).then(function (successData) {
                        var data = successData.data;
                        _this17.formDisableAuthentication.randomCode = '';
                        if (data.resCode == 0) {
                            _this17.$Message.success(_this17.$t("common.success"));
                            _this17.isShowDisableModal = !_this17.isShowDisableModal;
                            _this17.userDetail.openAuthentication = false;
                        } else if (data.resCode == -1) {
                            _this17.$Message.error(_this17.$t("enableAuthentication.dangerousMsg"));
                        } else if (data.resCode == -2) {
                            _this17.$Message.error(_this17.$t("enableAuthentication.verificationCodeError"));
                        } else if (data.resCode == -3) {
                            _this17.$Message.error(_this17.$t("common.serverError"));
                        }
                    }, function (errorData) {
                        _this17.$Message.error(_this17.$t("common.serverError"));
                    });
                }
            });
        },
        updateSipToken: function updateSipToken() {
            var _this18 = this;

            var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "userDetail/updateSipToken?userId=" + this.userDetail.userId;
            this.$http.get(url).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this18.userDetail.sipToken = data.result;

                    _this18.$forceUpdate();
                }
            });
        },
        copySipToken: function copySipToken() {
            var _this19 = this;

            var clipboard = new __WEBPACK_IMPORTED_MODULE_6_clipboard___default.a('#sipToken');
            clipboard.on('success', function (e) {
                _this19.$Message.success(_this19.$t("common.copySuccess"));

                clipboard.destroy();
            });
            clipboard.on('error', function (e) {
                _this19.$Message.error(_this19.$t("common.copyFailure"));

                clipboard.destroy();
            });
        },
        updateUserRight: function updateUserRight() {
            var _this20 = this;

            var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + 'userRight/updateUserRight';
            this.$http.post(url, this.userRight).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this20.userRight = data.result;
                    _this20.userRightCheck = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data.result);
                }
            });
        },
        getTelegramUserByUserId: function getTelegramUserByUserId() {
            var _this21 = this;

            var url = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].baseUrl + "telegramUser/getTelegramUser?userId=" + this.$store.state.user.id;
            this.$http.get(url).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this21.telegramUser = data.result;
                    _this21.telegramUserUrl = "https://telegram.me/" + _this21.telegramUser.userName;
                } else {
                    _this21.telegramUserUrl = "https://telegram.me/sip_test_bot";
                }
            });
        },
        gotoKyc: function gotoKyc() {
            this.$router.push({ name: 'userKyc' });
        },
        hideBlock: function hideBlock(event) {},
        regTimeFormat: function regTimeFormat(time) {
            return formatTime(time, this.$i18n.locale);
        }
    }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_eventBus_js__ = __webpack_require__(16);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        var validateWallet = function validateWallet(rule, value, callback) {
            var addressRule = /^0x[a-zA-Z0-9]{40}$/;
            if (value == '') {
                callback(new Error(_this.$t("wallet.errorCallback.wallet.empty")));
            } else if (!addressRule.test(value)) {
                callback(new Error(_this.$t("wallet.errorCallback.wallet.wrong")));
            } else {
                callback();
            }
        };
        return {
            userId: this.$store.state.user.id,
            username: this.$store.state.user.name,
            userDetail: {},
            isShowWallet: true,
            isShowTransactionRecord: false,
            isShowInvestmentRecord: false,
            isShowConfirmWalletModal: false,
            balance: 0,
            queryField: 'email',
            queryFieldSelect: [{ label: 'email', value: 'email' }, { label: 'wallet', value: 'wallet' }],
            transactionList: [],
            investmentNumber: 0,
            investmentList: [],
            transactionTableHeaders: [{ text: this.$t('common.serialNumber'), align: 'left', sortable: false }, { text: this.$t('transaction.txHash'), align: 'left', sortable: false }, { text: this.$t('transaction.quantity'), align: 'left', sortable: false }],
            investmentTableHeaders: [{ text: this.$t('common.serialNumber'), align: 'left', sortable: false }, { text: this.$t('investment.sentTime'), align: 'left', sortable: false }, { text: this.$t('investment.purchasingAmount'), align: 'left', sortable: false }, { text: this.$t('investment.paymentType'), align: 'left', sortable: false }, { text: this.$t('investment.totalIOB'), align: 'left', sortable: false }],
            formWallet: {
                userId: '',
                walletAddress: ''
            },
            ruleWallet: {
                walletAddress: [{ required: true, validator: validateWallet, trigger: 'blur' }]
            }
        };
    },

    computed: {},
    created: function created() {},
    mounted: function mounted() {
        this.getBaseData();
    },

    watch: {
        '$router': 'getBaseData'
    },
    methods: {
        getBaseData: function getBaseData() {
            var _this2 = this;

            this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + "userDetail/getMe").then(function (successData) {
                var data = successData.data;
                if (data.resCode == 0) {
                    _this2.userDetail = data.result;
                    document.title = _this2.userDetail.nickName + "(@" + _this2.userDetail.userName + ")——SiP";

                    if (_this2.userDetail.walletAddress != null && _this2.userDetail.walletAddress != '') {
                        _this2.getBalance();
                    }
                } else {
                    _this2.$router.push({ name: 'page404' });
                }
            });
        },
        getMenuData: function getMenuData(name) {
            switch (name) {
                case 'wallet':
                    this.isShowWallet = true;
                    this.isShowTransactionRecord = false;
                    this.isShowInvestmentRecord = false;
                    break;
                case 'transactionRecord':
                    this.isShowWallet = false;
                    this.isShowTransactionRecord = true;
                    this.isShowInvestmentRecord = false;
                    this.getTransaction();
                    break;
                case 'investmentRecord':
                    this.isShowWallet = false;
                    this.isShowTransactionRecord = false;
                    this.isShowInvestmentRecord = true;
                    this.getInvestment();
                    break;
                default:
                    break;
            }
        },
        showConfirmWalletModal: function showConfirmWalletModal(name) {
            var _this3 = this;

            this.$refs[name].validate(function (valid) {
                if (valid) {
                    _this3.isShowConfirmWalletModal = !_this3.isShowConfirmWalletModal;
                }
            });
        },
        updateWallet: function updateWallet(name) {
            var _this4 = this;

            this.$refs[name].validate(function (valid) {
                _this4.formWallet.userId = _this4.userDetail.userId;
                if (valid) {
                    _this4.$http.post(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + 'userDetail/updateWalletAddress', _this4.formWallet).then(function (successData) {
                        var data = successData.data;
                        _this4.isShowConfirmWalletModal = !_this4.isShowConfirmWalletModal;
                        if (data.resCode == 0) {
                            _this4.userDetail.walletAddress = data.result;
                            _this4.getBalance();
                        } else {
                            _this4.$Message.error(_this4.$t("common.fail"));
                        }
                    });
                }
            });
        },
        getBalance: function getBalance() {
            var _this5 = this;

            if (this.userDetail.walletAddress != null && this.userDetail.walletAddress != '') {
                var tokenUrl = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + 'token/open/getBalanceByAddressAndContractAddress/' + this.userDetail.walletAddress;
                this.$http.get(tokenUrl).then(function (response) {
                    _this5.balance = response.data.result;
                });
            }
        },
        getTransaction: function getTransaction() {
            var _this6 = this;

            if (this.userDetail.walletAddress != null && this.userDetail.walletAddress != '') {
                var transactionUrl = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + 'token/open/getTransactionByAddressAndContractAddress/' + this.userDetail.walletAddress;
                this.$http.get(transactionUrl).then(function (response) {
                    var data = response.data;
                    if (data.resCode == 0) {
                        _this6.transactionList = response.data.result;
                    } else {
                        _this6.transactionList = [];
                    }
                });
            }
        },
        getQuantity: function getQuantity(input) {
            var sixteen = input.substring(74, 138);
            var ten = parseInt(sixteen, 16);
            return ten / 1E18;
        },
        goTransactionData: function goTransactionData(transaction) {
            sessionStorage.setItem('transaction', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(transaction));
            this.$router.push({ name: 'transactionData', params: { txHash: transaction.hash } });
        },
        countInvestment: function countInvestment() {
            var _this7 = this;

            var investmentUrl = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + 'investment/countInvestmentByUserId/' + this.userId;
            this.$http.get(investmentUrl).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this7.investmentNumber = response.data.result;
                } else {
                    _this7.investmentNumber = 0;
                }
            });
        },
        getInvestment: function getInvestment() {
            var _this8 = this;

            var investmentUrl = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseUrl + 'investment/getInvestmentByUserId/' + this.queryField + '/' + this.userId;
            this.$http.get(investmentUrl).then(function (response) {
                var data = response.data;
                if (data.resCode == 0) {
                    _this8.investmentList = data.result;
                } else {
                    _this8.investmentList = [];
                }
            });
        },
        goInvestment: function goInvestment() {
            this.$router.push({ name: 'investment' });
        },
        goInvestmentData: function goInvestmentData(investment) {
            sessionStorage.setItem('investment', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(investment));
            this.$router.push({ name: 'investmentData', params: { investmentId: investment.investmentId } });
        },
        openNewWindowViewImage: function openNewWindowViewImage(imageUrl) {
            if (imageUrl) {
                window.open(imageUrl);
            }
        },
        hideBlock: function hideBlock(event) {},
        regTimeFormat: function regTimeFormat(time) {
            return formatTime(time, this.$i18n.locale);
        }
    }

});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

var toolOptions = [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'direction': 'rtl' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'font': [] }], [{ 'align': [] }], [{ 'clean': '源码编辑' }], ['link', 'image', 'image-link', 'video', 'upload-file', 'at']];
var handlers = {
  shadeBox: null,
  'image': function image(value) {
    if (value) {
      document.querySelector('.upload-image .ivu-upload .ivu-btn').click();
    } else {
      _this.quill.format('image', false);
    }
  },

  'image-link': function imageLink(value) {},

  'upload-file': function uploadFile(value) {
    if (value) {
      document.querySelector('.upload-file .ivu-upload .ivu-btn').click();
    }
  },

  'at': function at(value) {}
};

/* harmony default export */ __webpack_exports__["a"] = ({
  placeholder: '',
  theme: 'snow',
  modules: {
    toolbar: {
      container: toolOptions,
      handlers: handlers }
  },

  initImageLinkButton: function initImageLinkButton() {
    var imageLinkButton = document.querySelector('.ql-image-link');
    imageLinkButton.innerHTML = '<?xml version="1.0" encoding="iso-8859-1"?><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 485 485" style="enable-background:new 0 0 419.2 419.2;" xml:space="preserve"><g><g><g><circle cx="158" cy="144.4" r="28.8"/><path d="M394.4,250.4c-13.6-12.8-30.8-21.2-49.6-23.6V80.4c0-15.6-6.4-29.6-16.4-40C318,30,304,24,288.4,24h-232c-15.6,0-29.6,6.4-40,16.4C6,50.8,0,64.8,0,80.4v184.4V282v37.2c0,15.6,6.4,29.6,16.4,40c10.4,10.4,24.4,16.4,40,16.4h224.4c14.8,12,33.2,19.6,53.6,19.6c23.6,0,44.8-9.6,60-24.8c15.2-15.2,24.8-36.4,24.8-60C419.2,286.8,409.6,265.6,394.4,250.4zM21.2,80.4c0-9.6,4-18.4,10.4-24.8c6.4-6.4,15.2-10.4,24.8-10.4h232c9.6,0,18.4,4,24.8,10.4c6.4,6.4,10.4,15.2,10.4,24.8v124.8l-59.2-58.8c-4-4-10.8-4.4-15.2,0L160,236l-60.4-60.8c-4-4-10.8-4.4-15.2,0l-63.2,64V80.4z M56,354.8v-0.4c-9.6,0-18.4-4-24.8-10.4c-6-6.4-10-15.2-10-24.8V282v-12.8L92.4,198l60.4,60.4c4,4,10.8,4,15.2,0l89.2-89.6l58.4,58.8c-1.2,0.4-2.4,0.8-3.6,1.2c-1.6,0.4-3.2,0.8-5.2,1.6c-1.6,0.4-3.2,1.2-4.8,1.6c-1.2,0.4-2,0.8-3.2,1.6c-1.6,0.8-2.8,1.2-4,2c-2,1.2-4,2.4-6,3.6c-1.2,0.8-2,1.2-3.2,2c-0.8,0.4-1.2,0.8-2,1.2c-3.6,2.4-6.8,5.2-9.6,8.4c-15.2,15.2-24.8,36.4-24.8,60c0,6,0.8,11.6,2,17.6c0.4,1.6,0.8,2.8,1.2,4.4c1.2,4,2.4,8,4,12v0.4c1.6,3.2,3.2,6.8,5.2,9.6H56z M378.8,355.2c-11.6,11.6-27.2,18.4-44.8,18.4c-16.8,0-32.4-6.8-43.6-17.6c-1.6-1.6-3.2-3.6-4.8-5.2c-1.2-1.2-2.4-2.8-3.6-4c-1.6-2-2.8-4.4-4-6.8c-0.8-1.6-1.6-2.8-2.4-4.4c-0.8-2-1.6-4.4-2-6.8c-0.4-1.6-1.2-3.6-1.6-5.2c-0.8-4-1.2-8.4-1.2-12.8c0-17.6,7.2-33.2,18.4-44.8c11.6-11.6,27.2-18.4,44.8-18.4c17.6,0,33.2,7.2,44.8,18.4c11.6,11.2,18.4,27.2,18.4,44.8C397.2,328,390,343.6,378.8,355.2z"/><path d="M368.8,299.6h-24.4v-24.4c0-6-4.8-10.8-10.8-10.8s-10.8,4.8-10.8,10.8v24.4h-24.4c-6,0-10.8,4.8-10.8,10.8s4.8,10.8,10.8,10.8h24.4v24.4c0,6,4.8,10.8,10.8,10.8s10.8-4.8,10.8-10.8v-24.4h24.4c6,0,10.8-4.8,10.8-10.8S374.8,299.6,368.8,299.6z"/></g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>';
    imageLinkButton.title = 'image link';
  },

  initUploadFileButton: function initUploadFileButton() {
    var atButton = document.querySelector('.ql-upload-file');
    atButton.innerHTML = '<?xml version="1.0" encoding="iso-8859-1"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 548.176 548.176" style="enable-background:new 0 0 548.176 548.176;" xml:space="preserve"><g><path d="M524.326,297.352c-15.896-19.89-36.21-32.782-60.959-38.684c7.81-11.8,11.704-24.934,11.704-39.399c0-20.177-7.139-37.401-21.409-51.678c-14.273-14.272-31.498-21.411-51.675-21.411c-18.083,0-33.879,5.901-47.39,17.703c-11.225-27.41-29.171-49.393-53.817-65.95c-24.646-16.562-51.818-24.842-81.514-24.842c-40.349,0-74.802,14.279-103.353,42.83c-28.553,28.544-42.825,62.999-42.825,103.351c0,2.474,0.191,6.567,0.571,12.275c-22.459,10.469-40.349,26.171-53.676,47.106C6.661,299.594,0,322.43,0,347.179c0,35.214,12.517,65.329,37.544,90.358c25.028,25.037,55.15,37.548,90.362,37.548h310.636c30.259,0,56.096-10.711,77.512-32.12c21.413-21.409,32.121-47.246,32.121-77.516C548.172,339.944,540.223,317.248,524.326,297.352z M362.729,289.648c-1.813,1.804-3.949,2.707-6.42,2.707h-63.953v100.502c0,2.471-0.903,4.613-2.711,6.42c-1.813,1.813-3.949,2.711-6.42,2.711h-54.826c-2.474,0-4.615-0.897-6.423-2.711c-1.804-1.807-2.712-3.949-2.712-6.42V292.355H155.31c-2.662,0-4.853-0.855-6.563-2.563c-1.713-1.714-2.568-3.904-2.568-6.566c0-2.286,0.95-4.572,2.852-6.855l100.213-100.21c1.713-1.714,3.903-2.57,6.567-2.57c2.666,0,4.856,0.856,6.567,2.57l100.499,100.495c1.714,1.712,2.562,3.901,2.562,6.571C365.438,285.696,364.535,287.845,362.729,289.648z"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>';
    atButton.title = 'upload file';
  },

  initAtButton: function initAtButton() {
    var atButton = document.querySelector('.ql-at');
    atButton.innerHTML = '<?xml version="1.0" encoding="iso-8859-1"?><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 550 550" style="enable-background:new 0 0 490.2 490.2;" xml:space="preserve"><g><path d="M420.95,61.8C376.25,20.6,320.65,0,254.25,0c-69.8,0-129.3,23.4-178.4,70.3s-73.7,105.2-73.7,175 c0,66.9,23.4,124.4,70.1,172.6c46.9,48.2,109.9,72.3,189.2,72.3c47.8,0,94.7-9.8,140.7-29.5c15-6.4,22.3-23.6,16.2-38.7l0,0c-6.3-15.6-24.1-22.8-39.6-16.2c-40,17.2-79.2,25.8-117.4,25.8c-60.8,0-107.9-18.5-141.3-55.6c-33.3-37-50-80.5-50-130.4 c0-54.2,17.9-99.4,53.6-135.7c35.6-36.2,79.5-54.4,131.5-54.4c47.9,0,88.4,14.9,121.4,44.7s49.5,67.3,49.5,112.5 c0,30.9-7.6,56.7-22.7,77.2c-15.1,20.6-30.8,30.8-47.1,30.8c-8.8,0-13.2-4.7-13.2-14.2c0-7.7,0.6-16.7,1.7-27.1l18.6-152.1h-64 l-4.1,14.9c-16.3-13.3-34.2-20-53.6-20c-30.8,0-57.2,12.3-79.1,36.8c-22,24.5-32.9,56.1-32.9,94.7c0,37.7,9.7,68.2,29.2,91.3 c19.5,23.2,42.9,34.7,70.3,34.7c24.5,0,45.4-10.3,62.8-30.8c13.1,19.7,32.4,29.5,57.9,29.5c37.5,0,69.9-16.3,97.2-49 c27.3-32.6,41-72,41-118.1C488.05,152.9,465.75,103,420.95,61.8z M273.55,291.9c-11.3,15.2-24.8,22.9-40.5,22.9 c-10.7,0-19.3-5.6-25.8-16.8c-6.6-11.2-9.9-25.1-9.9-41.8c0-20.6,4.6-37.2,13.8-49.8s20.6-19,34.2-19c11.8,0,22.3,4.7,31.5,14.2 s13.8,22.1,13.8,37.9C290.55,259.2,284.85,276.6,273.55,291.9z"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>';
    atButton.title = 'at';
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iview__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_quill_editor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_store__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_iview_dist_styles_iview_css__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_css_global_css__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_css_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__static_css_global_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__font_awesome_4_7_0_css_font_awesome_min_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__font_awesome_4_7_0_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__font_awesome_4_7_0_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fortawesome_fontawesome_free_css_all_css__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fortawesome_fontawesome_free_css_all_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__fortawesome_fontawesome_free_css_all_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_dist_vuetify_min_css__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_quill_dist_quill_core_css__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_quill_dist_quill_snow_css__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_quill_dist_quill_bubble_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_quill_dist_quill_bubble_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mdi_font_css_materialdesignicons_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__mdi_font_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__static_css_animate_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__static_css_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__static_css_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_infinite_loading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_i18n__ = __webpack_require__(103);
var _this2 = this;


































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_iview___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_quill_editor___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vuetify___default.a, {
	theme: __WEBPACK_IMPORTED_MODULE_10__store_store__["a" /* store */].getters.selectedTheme.theme,
	iconfont: 'fa',
	icons: {
		'cancel': 'fas fa-ban',
		'menu': 'fas fa-ellipsis-v'
	}
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_vue_i18n__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('title', {
	inserted: function inserted(el, binding) {
		document.title = binding.value;
	}
});


function getLanguage() {
	var locale = localStorage.getItem("SIP-locale");
	if (locale) {
		return locale;
	} else {
		return 'en-US';
	}
}

var language = getLanguage();

var i18n = new __WEBPACK_IMPORTED_MODULE_23_vue_i18n__["a" /* default */]({
	locale: language,
	messages: {
		'de-DE': __webpack_require__(107),
		'en-US': __webpack_require__(108),
		'ru-RU': __webpack_require__(109),
		'zh-CN': __webpack_require__(110)
	}
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	el: '#app',
	i18n: i18n,
	router: __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_10__store_store__["a" /* store */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a, InfiniteLoading: __WEBPACK_IMPORTED_MODULE_22_vue_infinite_loading___default.a },
	created: function created() {
		var _this = this;

		var tokenObject = localStorage.getItem("token");
		var usernameObject = localStorage.getItem("userName");
		var idObject = localStorage.getItem("id");
		var imageObject = localStorage.getItem("image");
		this.$store.commit('setToken', { name: tokenObject });
		this.$store.commit('setUserName', { name: usernameObject });
		this.$store.commit('setUserId', { name: idObject });
		this.$store.commit('setImage', { name: imageObject });
		if (usernameObject) {
			this.$store.state.user.name = usernameObject;
		}
		if (idObject) {
			this.$store.state.user.id = idObject;
		}
		if (imageObject) {
			this.$store.state.user.image = imageObject;
		}
		if (tokenObject) {
			this.$store.state.user.token = tokenObject;
			__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
				request.credentials = false;

				request.headers.set('Authorization', 'Bearer ' + tokenObject);
				next(function (response) {
					if (response.headers.get('isLogin') === 'false') {
						localStorage.removeItem("SIP-user");
						localStorage.removeItem("SIP-role");
						localStorage.removeItem("userName");
						localStorage.removeItem("id");
						localStorage.removeItem("token");
						localStorage.removeItem("image");
						localStorage.removeItem("invitationCode");
						_this.$store.state.loginModal = true;
						_this.$router.go();
					}
					if (response.data.resCode == 8000) {
						_this.$router.push({ name: 'page500' });
					}
					return response;
				});
			});
		} else {
			__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
				next(function (response) {
					if (response.headers.get('isLogin') === 'false') {
						localStorage.removeItem("SIP-user");
						localStorage.removeItem("SIP-role");
						localStorage.removeItem("userName");
						localStorage.removeItem("id");
						localStorage.removeItem("token");
						localStorage.removeItem("image");
						localStorage.removeItem("invitationCode");
						_this.$router.push({ name: 'home' });
						_this.$router.go();
					}
					if (response.data.resCode == 8000) {
						_this.$router.push({ name: 'page500' });
					}
					return response;
				});
			});
		}
	},
	methods: {}
});

__WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */].beforeEach(function (to, from, next) {
	if (to.meta.requireAuth) {
		if (localStorage.getItem('token')) {
			next();
		} else {
			_this2.$store.state.loginModal = true;
			next({
				path: '/'
			});
		}
	} else {
		next();
	}

	if (to.fullPath == "/login") {
		if (localStorage.getItem('token')) {
			next({
				path: from.fullPath
			});
		} else {
			next();
		}
	}
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	marketsTitle: '',
	marketsCode: '',
	marketsDesc: '',
	marketsList: []
};

var getters = {
	marketsTitle: function marketsTitle(state) {
		var marketsTitle = localStorage.getItem("SIP-marketsTitle");
		if (marketsTitle) {
			state.marketsTitle = marketsTitle;
		}
		return state.marketsTitle;
	},
	marketsCode: function marketsCode(state) {
		var marketsCode = localStorage.getItem("SIP-marketsCode");
		if (marketsCode) {
			state.marketsCode = marketsCode;
		}
		return state.marketsCode;
	},
	marketsDesc: function marketsDesc(state) {
		var marketsDesc = localStorage.getItem("SIP-marketsDesc");
		if (marketsDesc) {
			state.marketsDesc = marketsDesc;
		}
		return state.marketsDesc;
	},
	marketsList: function marketsList(state) {
		return state.marketsList;
	}
};

var actions = {
	marketsTitleHandler: function marketsTitleHandler(context, payload) {
		context.commit('marketsTitleHandler', payload);
	},
	marketsCodeHandler: function marketsCodeHandler(context, payload) {
		context.commit('marketsCodeHandler', payload);
	},
	marketsDescHandler: function marketsDescHandler(context, payload) {
		context.commit('marketsDescHandler', payload);
	},
	marketsListHandler: function marketsListHandler(context, payload) {
		context.commit('marketsListHandler', payload);
	}
};

var mutations = {
	marketsTitleHandler: function marketsTitleHandler(state, marketsTitle) {
		localStorage.setItem("SIP-marketsTitle", marketsTitle);
		state.marketsTitle = marketsTitle;
	},
	marketsCodeHandler: function marketsCodeHandler(state, marketsCode) {
		localStorage.setItem("SIP-marketsCode", marketsCode);
		state.marketsCode = marketsCode;
	},
	marketsDescHandler: function marketsDescHandler(state, marketsDesc) {
		localStorage.setItem("SIP-marketsDesc", marketsDesc);
		state.marketsDesc = marketsDesc;
	},
	marketsListHandler: function marketsListHandler(state, marketsList) {
		state.marketsList = marketsList;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	pageTitle: '',
	pageHrefName: ''
};

var getters = {
	pageTitle: function pageTitle(state) {
		return state.pageTitle;
	},
	pageHrefName: function pageHrefName(state) {
		var pageHrefName = localStorage.getItem("SIP-pageHrefName");
		if (pageHrefName) {
			state.pageHrefName = pageHrefName;
		}
		return state.pageHrefName;
	}
};

var actions = {
	pageTitleHandler: function pageTitleHandler(context, payload) {
		context.commit('pageTitleHandler', payload);
	},
	pageHrefNameHandler: function pageHrefNameHandler(context, payload) {
		context.commit('pageHrefNameHandler', payload);
	}
};

var mutations = {
	pageTitleHandler: function pageTitleHandler(state, pageTitle) {
		state.pageTitle = pageTitle;
	},
	pageHrefNameHandler: function pageHrefNameHandler(state, pageHrefName) {
		localStorage.setItem("SIP-pageHrefName", pageHrefName);
		state.pageHrefName = pageHrefName;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	searchText: null
};

var getters = {
	searchText: function searchText(state) {
		return state.searchText;
	}
};

var actions = {
	searchTextHandler: function searchTextHandler(context, payload) {
		context.commit('searchTextHandler', payload);
	}
};

var mutations = {
	searchTextHandler: function searchTextHandler(state, searchText) {
		state.searchText = searchText;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes_lightredTheme__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_limegreenTheme__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes_moderatecyanTheme__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__themes_pureredTheme__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes_strongblueTheme__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themes_vividyellowTheme__ = __webpack_require__(191);







var themes = [{
   id: 1,
   bgColor: "lightred",
   theme: __WEBPACK_IMPORTED_MODULE_0__themes_lightredTheme__["a" /* default */]
}, {
   id: 2,
   bgColor: "limegreen",
   theme: __WEBPACK_IMPORTED_MODULE_1__themes_limegreenTheme__["a" /* default */]
}, {
   id: 3,
   bgColor: "moderatecyan",
   theme: __WEBPACK_IMPORTED_MODULE_2__themes_moderatecyanTheme__["a" /* default */]
}, {
   id: 4,
   bgColor: "purered",
   theme: __WEBPACK_IMPORTED_MODULE_3__themes_pureredTheme__["a" /* default */]
}, {
   id: 5,
   bgColor: "strongblue",
   theme: __WEBPACK_IMPORTED_MODULE_4__themes_strongblueTheme__["a" /* default */]
}, {
   id: 6,
   bgColor: "vividyellow",
   theme: __WEBPACK_IMPORTED_MODULE_5__themes_vividyellowTheme__["a" /* default */]
}];

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(183);


var state = {
	darkMode: false,
	themes: __WEBPACK_IMPORTED_MODULE_0__data__["a" /* themes */],
	selectedTheme: __WEBPACK_IMPORTED_MODULE_0__data__["a" /* themes */][0]
};

var getters = {
	darkMode: function darkMode(state) {
		var darkMode = localStorage.getItem('SIP-darkMode');
		if (darkMode == 0) {
			state.darkMode = false;
		} else if (darkMode == 1) {
			state.darkMode = true;
		}
		return state.darkMode;
	},
	themes: function themes(state) {
		return state.themes;
	},
	selectedTheme: function selectedTheme(state) {
		return state.selectedTheme;
	}
};

var actions = {
	darkModeHandler: function darkModeHandler(context, payload) {
		context.commit('darkModeHandler', payload);
	},
	changeThemeHandler: function changeThemeHandler(context, payload) {
		context.commit('changeThemeHandler', payload);
	},
	changeColorStyleHandler: function changeColorStyleHandler(context, payload) {
		context.commit('changeColorStyleHandler', payload);
	}
};

var mutations = {
	darkModeHandler: function darkModeHandler(state, darkMode) {
		state.darkMode = darkMode;
		localStorage.setItem('SIP-darkMode', darkMode ? 1 : 0);
	},
	changeThemeHandler: function changeThemeHandler(state, theme) {
		state.selectedTheme = theme;
	},
	changeColorStyleHandler: function changeColorStyleHandler(state, colorStyle) {
		for (var i = 0; i < state.themes.length; i++) {
			if (colorStyle == state.themes[i].bgColor) {
				state.selectedTheme = state.themes[i];
				localStorage.setItem('SIP-colorStyle', state.themes[i].bgColor);
				return;
			}
		}
		state.selectedTheme = state.themes[0];
		localStorage.setItem('SIP-colorStyle', state.themes[0].bgColor);
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var state = {
	user: null,
	role: null,
	locale: 'en-US',
	notificationNum: 0 };

var getters = {
	user: function user(state) {
		var user = JSON.parse(localStorage.getItem('SIP-user'));
		if (user) {
			state.user = user;
		}
		return state.user;
	},
	role: function role(state) {
		var role = JSON.parse(localStorage.getItem('SIP-role'));
		if (role) {
			state.role = role;
		}
		return state.role;
	},
	locale: function locale(state) {
		var locale = localStorage.getItem("SIP-locale");
		if (locale) {
			state.locale = locale;
		}
		return state.locale;
	},
	notificationNum: function notificationNum(state) {
		return state.notificationNum;
	}
};

var actions = {
	userHandler: function userHandler(context, payload) {
		context.commit('userHandler', payload);
	},
	roleHandler: function roleHandler(context, payload) {
		context.commit('roleHandler', payload);
	},
	localeHandler: function localeHandler(context, payload) {
		context.commit('localeHandler', payload);
	},
	timeZoneHandler: function timeZoneHandler(context, payload) {
		context.commit('timeZoneHandler', payload);
	},
	imageHandler: function imageHandler(context, payload) {
		context.commit('imageHandler', payload);
	},
	notificationNumHandler: function notificationNumHandler(context, payload) {
		context.commit('notificationNumHandler', payload);
	},
	readIndexHandler: function readIndexHandler(context, payload) {
		context.commit('readIndexHandler', payload);
	}
};

var mutations = {
	userHandler: function userHandler(state, user) {
		localStorage.setItem('SIP-user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
		state.user = user;
	},
	roleHandler: function roleHandler(state, role) {
		localStorage.setItem('SIP-role', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(role));
		state.role = role;
	},
	localeHandler: function localeHandler(state, locale) {
		localStorage.setItem("SIP-locale", locale);
		state.locale = locale;
	},
	timeZoneHandler: function timeZoneHandler(state, timeZone) {
		state.user.timeZoneId = timeZone.timeZoneId;
		state.user.timeOffset = timeZone.timeOffset;
	},
	imageHandler: function imageHandler(state, image) {
		state.user.image = image;
	},
	notificationNumHandler: function notificationNumHandler(state, notificationNum) {
		state.notificationNum = notificationNum;
	},
	readIndexHandler: function readIndexHandler(state, readIndex) {
		state.user.readIndex = readIndex;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	primary: '#ff6f61'
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	primary: '#00cc00'
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	primary: '#3ab8bd'
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	primary: '#ff3300'
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	primary: '#0233cc'
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	primary: '#ffcc01'
});

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(290)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(441),
  /* scopeId */
  "data-v-596f911f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(314)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(469),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(293)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(444),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(292)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(443),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(303)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(456),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(440),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(313)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(468),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(299)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(305)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(459),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(438),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(274)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(420),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(311)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(466),
  /* scopeId */
  "data-v-ae55fa24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(267)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(411),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(301)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(454),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(308)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(462),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(297)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(448),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(470),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(288)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(437),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(465),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(473),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(425),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(296)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(447),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(304)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(457),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(312)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(467),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(294)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(445),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(289)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(306)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(460),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(291)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(442),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(276)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(422),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(266)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(410),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(310)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(464),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(309)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(463),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(320)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(476),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(271)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(415),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(474),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(307)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(461),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(272)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(416),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(268)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(412),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(273)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(419),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(281)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(428),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(319)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(475),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(300)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(453),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(302)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(455),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(435),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(269)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(413),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(278)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(424),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(458),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(417),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(283)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(430),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(279)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(426),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(282)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(429),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(280)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(427),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(275)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(421),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(418),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(452),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(433),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(471),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(449),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(317)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(472),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(277)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(423),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(270)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(414),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(285)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(432),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(284)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(431),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(286)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(434),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(298)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(450),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(287)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(436),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "warp": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "lg10": "",
      "sm12": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-5 pa-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    ref: "formValidate"
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('postingcreate.Title'),
      "rules": _vm.titleRules,
      "single-line": "",
      "outline": ""
    },
    model: {
      value: (_vm.formValidate.postingTitle),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "postingTitle", $$v)
      },
      expression: "formValidate.postingTitle"
    }
  }), _vm._v(" "), _c('Upload', {
    ref: "upload",
    staticClass: "d-none upload-image",
    attrs: {
      "name": "upfile",
      "format": ['jpg', 'jpeg', 'png', 'gif'],
      "max-size": 4096,
      "headers": _vm.headers,
      "action": _vm.uploadImageApi,
      "with-credentials": true,
      "show-upload-list": false,
      "before-upload": _vm.uploadImageBefore
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-cloud-upload-outline"
    }
  })], 1), _vm._v(" "), _c('Upload', {
    ref: "upload",
    staticClass: "d-none upload-file",
    attrs: {
      "name": "upfile",
      "max-size": 10240,
      "headers": _vm.headers,
      "action": _vm.uploadFileApi,
      "with-credentials": true,
      "show-upload-list": false,
      "on-success": _vm.uploadFileSuccess,
      "before-upload": _vm.uploadFileBefore
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-cloud-upload-outline"
    }
  })], 1), _vm._v(" "), _c('quill-editor', {
    ref: "myQuillEditor",
    staticClass: "mt-3",
    attrs: {
      "id": "quillEditor",
      "options": _vm.editorOption
    },
    on: {
      "blur": function($event) {
        return _vm.onEditorBlur($event)
      },
      "focus": function($event) {
        return _vm.onEditorFocus($event)
      },
      "ready": function($event) {
        return _vm.onEditorReady($event)
      },
      "change": function($event) {
        return _vm.onEditorChange($event)
      }
    },
    model: {
      value: (_vm.formValidate.postingContent),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "postingContent", $$v)
      },
      expression: "formValidate.postingContent"
    }
  }), _vm._v(" "), _c('div', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMarket.marketId == null),
      expression: "selectedMarket.marketId == null"
    }],
    staticClass: "mt-5 ml-0",
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isShowMarketListDialog = !_vm.isShowMarketListDialog
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.chooseTopic")))]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMarket.marketId != null),
      expression: "selectedMarket.marketId != null"
    }],
    staticClass: "white--text mt-5 ml-0",
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isShowMarketListDialog = !_vm.isShowMarketListDialog
      }
    }
  }, [_vm._v(_vm._s(_vm.selectedMarket.name))]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "persistent": "",
      "hide-overlay": ""
    },
    model: {
      value: (_vm.isShowMarketListDialog),
      callback: function($$v) {
        _vm.isShowMarketListDialog = $$v
      },
      expression: "isShowMarketListDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pb-0",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("postingcreate.chooseTopic")))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "right": "",
      "color": "pink"
    },
    on: {
      "click": function($event) {
        _vm.isShowMarketListDialog = !_vm.isShowMarketListDialog
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [(_vm.user.userName == 'iob_official' || _vm.user.userName == 'longnshort' || _vm.user.userName == 'Fred' || _vm.user.userName == 'louis' || _vm.user.userName == 'shirley' || _vm.user.userName == 'KateL' || _vm.user.userName == 'renlywen') ? _c('div', _vm._l((_vm.marketList), function(market) {
    return _c('v-btn', {
      key: market.marketId,
      staticClass: "white--text",
      attrs: {
        "depressed": "",
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.selectMarket(market)
        }
      }
    }, [_vm._v(_vm._s(market.name))])
  }), 1) : _c('div', _vm._l((_vm.marketList), function(market) {
    return ('industrynews' == market.code) ? _c('v-btn', {
      key: market.marketId,
      staticClass: "white--text",
      attrs: {
        "depressed": "",
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.selectMarket(market)
        }
      }
    }, [_vm._v(_vm._s(market.name))]) : _vm._e()
  }), 1)])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "persistent": "",
      "hide-overlay": ""
    },
    model: {
      value: (_vm.imageLinkDialog),
      callback: function($$v) {
        _vm.imageLinkDialog = $$v
      },
      expression: "imageLinkDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-5"
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "placeholder": "Image Link",
      "outline": ""
    },
    model: {
      value: (_vm.imageLink),
      callback: function($$v) {
        _vm.imageLink = $$v
      },
      expression: "imageLink"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.insertImageLink.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.confirm")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.imageLinkDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    staticClass: "ShapeUser",
    attrs: {
      "max-width": "320px",
      "persistent": "",
      "hide-overlay": ""
    },
    model: {
      value: (_vm.atUserDialog),
      callback: function($$v) {
        _vm.atUserDialog = $$v
      },
      expression: "atUserDialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "right": "",
      "color": "pink"
    },
    on: {
      "click": function($event) {
        _vm.atUserDialog = !_vm.atUserDialog
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userFollowList.length == 0),
      expression: "userFollowList.length == 0"
    }],
    staticClass: "text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userFollowList.length != 0),
      expression: "userFollowList.length != 0"
    }],
    staticClass: "mt-5 mb-3"
  }, [_c('v-divider'), _vm._v(" "), _vm._l((_vm.userFollowList), function(userfollow, index) {
    return _c('div', {
      staticClass: "userFollow-li pointer mt-3 ml-5",
      on: {
        "click": function($event) {
          return _vm.userfollowing(userfollow)
        }
      }
    }, [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "40"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (userfollow.image != null),
        expression: "userfollow.image != null"
      }],
      attrs: {
        "src": userfollow.image,
        "alt": userfollow.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (userfollow.image == null),
        expression: "userfollow.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v("\n                                    " + _vm._s(userfollow.userName != null ? userfollow.userName.trim().substring(0, 1).toLocaleUpperCase() : ''))])]), _vm._v(" "), _c('span', {
      attrs: {
        "id": "followUserName"
      }
    }, [_vm._v(_vm._s(userfollow.nickName))]), _vm._v(" \n                                    "), _c('span', {
      staticClass: "primary--text font-12 ml-2"
    }, [_vm._v("@" + _vm._s(userfollow.userName))])], 1)
  })], 2)])], 1)], 1)], 1), _vm._v(" "), _c('div', _vm._l((_vm.tagNameArray), function(tagName, index) {
    return _c('v-btn', {
      key: index,
      staticClass: "mt-3 ml-0",
      attrs: {
        "outline": "",
        "small": "",
        "color": "primary darken-1"
      }
    }, [_vm._v(_vm._s(tagName))])
  }), 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": _vm.$t('postingcreate.tagName'),
      "single-line": "",
      "outline": ""
    },
    on: {
      "input": _vm.tagchange
    },
    model: {
      value: (_vm.tagName),
      callback: function($$v) {
        _vm.tagName = $$v
      },
      expression: "tagName"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "height": "10px",
      "display": "inline-block",
      "color": "red",
      "margin-top": "-15px",
      "margin-left": "10px"
    },
    attrs: {
      "id": "tagruleValidate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    class: _vm.formValidate.isOriginal ? 'primary' : '',
    attrs: {
      "small": "",
      "type": "ghost",
      "disabled": _vm.isDisabledOriginalBtn
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.formValidate.isOriginal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('postingcreate.original')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    class: _vm.formValidate.isOriginal ? '' : 'primary',
    attrs: {
      "small": "",
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.formValidate.isOriginal = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('postingcreate.repost')))]), _vm._v(" "), (_vm.formValidate.isOriginal) ? _c('div', [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "required": ""
    },
    model: {
      value: (_vm.isAgreeOriginalTerms),
      callback: function($$v) {
        _vm.isAgreeOriginalTerms = $$v
      },
      expression: "isAgreeOriginalTerms"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    on: {
      "click": function($event) {}
    },
    slot: "label"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("postingcreate.agree")) + "\n                      "), _c('span', {
    staticClass: "primary--text pointer"
  }, [_c('a', {
    attrs: {
      "href": "/#/about/ContentPolicy",
      "target": "_black"
    }
  }, [_vm._v("<<" + _vm._s(_vm.$t("postingcreate.contentPolicy")) + ">>")])])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.formValidate.isOriginal) ? _c('div', [_c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": _vm.$t('postingcreate.rules.originalLink.label'),
      "rules": _vm.originalLinkRules,
      "single-line": "",
      "outline": "",
      "required": ""
    },
    model: {
      value: (_vm.formValidate.originalLink),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "originalLink", $$v)
      },
      expression: "formValidate.originalLink"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "font-16 primary--text mt-3"
  }, [_vm._v(_vm._s(_vm.formValidate.postingId != null ? _vm.$t('postingcreate.message.updatePost') : ""))]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isShowResetDialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.Reset")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previewPostDialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.preview.preview")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "type": "ghost",
      "loading": _vm.postLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.Post")))])], 1), _vm._v(" "), _c('div', [_c('v-dialog', {
    attrs: {
      "width": "40%",
      "persistent": "",
      "hide-overlay": ""
    },
    model: {
      value: (_vm.isShowResetDialog),
      callback: function($$v) {
        _vm.isShowResetDialog = $$v
      },
      expression: "isShowResetDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.message.resetPost")))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "right": "",
      "color": "pink"
    },
    on: {
      "click": function($event) {
        _vm.isShowResetDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleReset.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.confirm")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isShowResetDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.previewPostDialog),
      callback: function($$v) {
        _vm.previewPostDialog = $$v
      },
      expression: "previewPostDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('postingcreate.preview.preview')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.previewPostDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "sm12": "",
      "lg10": ""
    }
  }, [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formValidate.postingTitle != ''),
      expression: "formValidate.postingTitle != ''"
    }],
    staticClass: "fw-bold mb-3 display-1"
  }, [_vm._v(_vm._s(_vm.formValidate.postingTitle))]), _vm._v(" "), _c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formValidate.postingTitle == ''),
      expression: "formValidate.postingTitle == ''"
    }],
    staticClass: "fw-bold mb-3 display-1"
  }, [_vm._v(_vm._s(_vm.$t('postingcreate.preview.hint.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled mb-5"
  }, [_c('li', {
    staticClass: "userDetail"
  }, [_c('div', {
    staticClass: "imgleft"
  }, [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "40"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user != null && _vm.user.image != null),
      expression: "user != null && user.image != null"
    }],
    attrs: {
      "src": _vm.user.image,
      "alt": _vm.user.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user == null || _vm.user.image == null),
      expression: "user == null || user.image == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v(_vm._s(_vm.user.userName != null ? _vm.user.userName.trim().substring(0, 1).toLocaleUpperCase() : ''))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-side ml-2"
  }, [_c('span', {
    staticClass: "title-1 font-md pointer primary--text"
  }, [_vm._v("\n                            " + _vm._s(_vm.user.nickName) + "\n                            "), _c('span', [_vm._v("(" + _vm._s(_vm.user.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
    staticClass: "ml-2 font-md"
  }, [_vm._v(_vm._s(_vm.$t("common.at")) + " " + _vm._s(_vm.dateFormat(+new Date())))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formValidate.postingContent != ''),
      expression: "formValidate.postingContent != ''"
    }],
    staticClass: "mb-5 font-18 fw-400 ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.formValidate.postingContent)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formValidate.postingContent == ''),
      expression: "formValidate.postingContent == ''"
    }],
    staticClass: "mb-5 font-18 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('postingcreate.preview.hint.content')))]), _vm._v(" "), _c('div', _vm._l((_vm.tagNameArray), function(tagName, index) {
    return _c('v-btn', {
      key: index,
      attrs: {
        "outline": "",
        "small": "",
        "color": "primary darken-1"
      }
    }, [_vm._v(_vm._s(tagName))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "userDetail mt-4"
  }, [_c('span', {
    staticClass: "font-md fw-semi-bold"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("timer")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(+new Date())) + " " + _vm._s(_vm.$t("common.by")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgleft ml-3"
  }, [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.image != null),
      expression: "user.image != null"
    }],
    attrs: {
      "src": _vm.user.image,
      "alt": _vm.user.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.image == null),
      expression: "user.image == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v(_vm._s(_vm.user.userName != null ? _vm.user.userName.trim().substring(0, 1).toLocaleUpperCase() : ''))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-side ml-2 primary--text"
  }, [_c('span', {
    staticClass: "Author"
  }, [_c('span', {
    staticClass: "font-md fw-semi-bold"
  }, [_vm._v("\n                            " + _vm._s(_vm.user.nickName) + "\n                            "), _c('span', [_vm._v("(" + _vm._s(_vm.user.reputationScore) + ")")])])])])]), _vm._v(" "), _c('div', {}, [(_vm.formValidate.isOriginal) ? _c('span', {
    staticClass: "primary--text ml-2 font-14 fw-700"
  }, [_vm._v(_vm._s(_vm.$t('postingsel.original')))]) : _vm._e(), _vm._v(" "), (!_vm.formValidate.isOriginal) ? _c('span', {
    staticClass: "pointer primary--text ml-2 font-14 fw-700"
  }, [_c('a', {
    attrs: {
      "href": _vm.formValidate.originalLink,
      "target": "_black"
    }
  }, [_vm._v(_vm._s(_vm.$t('postingsel.source')))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "social-list clearfix right"
  }, [_c('ul', {
    staticClass: "list-inline d-inline-block right"
  }, [_c('li', [_c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.bonus')
    }
  }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', [_vm._v("0.00")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.upvote')
    }
  }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
    staticClass: "icon-title"
  }, [_vm._v("0")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('postingsel.tread')
    }
  }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
    staticClass: "icon-title"
  }, [_vm._v("0")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.comment')
    }
  }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
    staticClass: "icon-title"
  }, [_vm._v("0")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.retweet')
    }
  }, [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
    staticClass: "icon-title"
  }, [_vm._v("0")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.save')
    }
  }, [_vm._v("fa fa-star")])], 1)])])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "right",
    attrs: {
      "color": "primary",
      "loading": _vm.postLoading
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formValidate', _vm.file)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.Post")))]), _vm._v(" "), _c('v-btn', {
    staticClass: "right",
    attrs: {
      "color": "primary",
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previewPostDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("postingcreate.close")))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout"
  }, [_c('app-header')], 1)
},staticRenderFns: []}

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v("\n             \n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('app-left')], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px auto"
    }
  }, [_c('div', [_c('Scroll', {
    staticClass: "scrollWrap",
    attrs: {
      "on-reach-bottom": _vm.handleReachBottom,
      "height": 700
    }
  }, _vm._l((_vm.list1), function(project, index) {
    return _c('Card', {
      key: project.projectId,
      staticStyle: {
        "margin": "100px 0"
      }
    }, [_vm._l((_vm.userDetailList), function(userDetail, index) {
      return (project.creatorId == userDetail.userId) ? _c('p', [_c('Row', [_c('Col', {
        attrs: {
          "span": "4"
        }
      }, [_c('span', {
        on: {
          "click": function($event) {
            return _vm.userInformation(userDetail.userId)
          }
        }
      }, [_c('a', [_vm._v(_vm._s(userDetail.nickName))])])]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "6"
        }
      }, [_c('span', {
        on: {
          "click": function($event) {
            return _vm.projectDetail(project.projectId, userDetail.userId)
          }
        }
      }, [_c('a', [_vm._v(_vm._s(project.projectName))])])]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "2"
        }
      }, [_vm._v("\n                                        " + _vm._s(_vm.dateFormat(project.creationTime)) + "\n                                    ")])], 1)], 1) : _vm._e()
    }), _vm._v(" "), _c('Row', [_c('Col', {
      attrs: {
        "span": "4"
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "10"
      }
    }, [_vm._v(_vm._s(project.projectDesc))])], 1), _vm._v(" "), _c('Row', [_c('br'), _c('br')])], 2)
  }), 1)], 1)])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('div', {
    staticClass: "postmiddle-right",
    staticStyle: {
      "height": "700px",
      "background-color": "white",
      "margin": "0px auto",
      "text-align": "center"
    }
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none",
      "font-size": "16px"
    }
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.createProject
    }
  }, [_vm._v("创建项目")])])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "mt-7 ml-7 mr-7 pl-7 pr-7"
  }, [_c('div', {
    staticClass: "ml-4 mr-4"
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "ml-4 h3"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.name")) + ":"), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.investmentPeople.name))]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t("investment.wallet")) + ":"), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.investmentPeople.walletAddress))])])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "app-card": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('v-expansion-panel', _vm._l((_vm.investmentList), function(investment, index) {
    return _c('v-expansion-panel-content', {
      key: index
    }, [_c('div', {
      staticClass: "primary--text h4 ml-5",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v(_vm._s(index + 1) + ". " + _vm._s(investment.investmentId))]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "h5": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs1": "",
        "lg1": ""
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "lg3": "",
        "fw-bold": ""
      }
    }, [_c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.transaction")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.sendingAddress")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.purchasingAmount")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.paymentType")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.sentTime")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.recordTime")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.timestamp1")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.timestamp1Price")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.timestamp2")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.timestamp2Price")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.averagePrice")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.purchasingAmountInUSD")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.bonusRate")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.bonus")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.totalIOB")))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "lg8": ""
      }
    }, [_c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.transaction))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.sendingAddress))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.purchasingAmount))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.paymentType))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.sentTime))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.recordTime))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.timestamp1))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.timestamp1Price))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.timestamp2))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.timestamp2Price))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.averagePrice))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.purchasingAmountInUSD))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.bonusRate))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.bonus))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.totalIOB))])])], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.hideBlock
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "profile-head"
  }, [_c('div', {
    staticClass: "profile-top",
    style: ({
      backgroundImage: 'url(' + _vm.userDetail.coverImage + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-bottom"
  }, [_c('div', {
    staticClass: "user-image text-xs-center mb-3"
  }, [_c('v-avatar', {
    attrs: {
      "color": "primary pointer",
      "size": "100"
    },
    on: {
      "click": function($event) {
        return _vm.openNewWindowViewImage(_vm.userDetail.image)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image != null),
      expression: "userDetail.image != null"
    }],
    attrs: {
      "src": _vm.userDetail.image,
      "alt": _vm.userDetail.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image == null),
      expression: "userDetail.image == null"
    }],
    staticClass: "font-50 white--text"
  }, [_vm._v("\n                        " + _vm._s(_vm.userDetail.userName != null ? _vm.userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                      ")])]), _vm._v(" "), _c('Modal', {
    model: {
      value: (_vm.isShowViewImageModal),
      callback: function($$v) {
        _vm.isShowViewImageModal = $$v
      },
      expression: "isShowViewImageModal"
    }
  }, [_c('p', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.userDetail.image
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-list-content mb-5"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('h1', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.userDetail.nickName) + " (" + _vm._s(_vm.userDetail.reputationScore) + ")")]), _vm._v(" "), _c('h3', [_vm._v("IOB Power: "), _c('span', {
    staticClass: "font-26 primary--text"
  }, [_vm._v(_vm._s(_vm._f("NumFormat")(((_vm.userDetail.iobPower != null ? _vm.userDetail.iobPower : 0).toFixed(2)))))])]), _vm._v(" "), _c('div', {
    staticClass: "font-16 fw-500 mt-3"
  }, [_c('span', {
    staticClass: "mx-3"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-at")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.userDetail.userName))])], 1), _vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-calendar-alt")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.regTimeFormat(_vm.userDetail.regTime)))])], 1)]), _vm._v(" "), (_vm.username != this.$store.state.user.name) ? _c('div', {
    staticClass: "social-list clearfix mb-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": _vm.follow
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFollow),
      expression: "!isFollow"
    }]
  }, [_c('Icon', {
    attrs: {
      "type": "plus-round",
      "color": "#FFFFFF"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("common.follow")))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFollow),
      expression: "isFollow"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("common.unfollow")))])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "h4 mt-3"
  }, [_c('span', {
    staticClass: "primary--text pointer mr-2",
    on: {
      "click": function($event) {
        return _vm.goFollow('following')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.followingNum) + " " + _vm._s(_vm.$t("follow.following")) + "\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "primary--text pointer ml-2",
    on: {
      "click": function($event) {
        return _vm.goFollow('followers')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.followerNum) + " " + _vm._s(_vm.$t("follow.followers")) + "\n                      ")])])])])])])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-5": "",
      "mb-5": "",
      "pb-5": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "lg3": ""
    }
  }, [_c('div', {
    staticClass: "inbox-head"
  }, [_c('div', {
    staticClass: "mailbox-items-warp"
  }, [_c('div', {
    staticClass: "app-card"
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.posting') + '(' + _vm.totalPostingNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('posting')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa fa-file-alt")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.posting")) + "(" + _vm._s(_vm.totalPostingNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.comments') + '(' + _vm.totalRewardRecordsNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('comments')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa fa-comment")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.comments")) + "(" + _vm._s(_vm.totalCommentsNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.reply') + '(' + _vm.totalReplyNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('reply')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa fa-reply")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.reply")) + "(" + _vm._s(_vm.totalReplyNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.forward') + '(' + _vm.totalForwardNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('forward')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa fa-share")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.forward")) + "(" + _vm._s(_vm.totalForwardNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.upvotes') + '(' + _vm.totalUpvoteNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('upvotes')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("thumb_up")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.upvotes")) + "(" + _vm._s(_vm.totalUpvoteNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.downvotes') + '(' + _vm.totalDownvoteNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('downvotes')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("thumb_down")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.downvotes")) + "(" + _vm._s(_vm.totalDownvoteNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.favorites') + '(' + _vm.totalCollectionPostNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('collections')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa fa-star")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.favorites")) + "(" + _vm._s(_vm.totalCollectionPostNum) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.referees') + '(' + _vm.userDetail.invitationNumber + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('referees')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("accessibility")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.referees")) + "(" + _vm._s(_vm.userDetail.invitationNumber) + ")\n                        ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userData.rewardRecords') + '(' + _vm.totalRewardRecordsNum + ')'
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('rewardRecords')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fas fa-clipboard")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(_vm.$t("userData.rewardRecords")) + "(" + _vm._s(_vm.totalRewardRecordsNum) + ")\n                        ")])], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "inbox-content",
    attrs: {
      "xs12": "",
      "md7": "",
      "lg9": ""
    }
  }, [_c('div', {
    staticClass: "inbox-content-wrap"
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPosting),
      expression: "isShowPosting"
    }]
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.posting")))]), _vm._v(" "), _vm._l((_vm.postingList), function(posting, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [(posting.postingImg != '') ? _c('span', {
      staticClass: "rounded-circle mr-4 img-responsive posting-image pointer",
      domProps: {
        "innerHTML": _vm._s(posting.postingImg)
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h2', {
      staticClass: "fw-700",
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(posting.postingTitle) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [(posting.postingContent.length = 0) ? _c('span') : _vm._e(), _vm._v(" "), (posting.postingContent.length < 30) ? _c('span', [_vm._v("\n                              " + _vm._s(posting.postingContent) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(posting.postingContent) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix mb-4"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v("\n                                      " + _vm._s(posting.postingGoodnums) + "\n                                  ")])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v("\n                                      " + _vm._s(posting.postingStepnums) + "\n                                  ")])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v("\n                                    " + _vm._s(posting.postingCountComments) + "\n                              ")])], 1)])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postingList.length > 0),
      expression: "postingList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalPostingNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getPostingByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMicroArticle),
      expression: "isShowMicroArticle"
    }]
  }, [_c('h2', {
    staticClass: "fw-bold mt-5 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.microArticle")))]), _vm._v(" "), _vm._l((_vm.microArticleList), function(microArticle, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('div', {
      staticClass: "mt-3 mb-3 ml-3 mr-3"
    }, [_c('div', {
      staticClass: "mt-3 font-md pointer hover-color",
      on: {
        "click": function($event) {
          return _vm.gotoMicroArticle(microArticle)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(microArticle.content) + "\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "mr-5 right"
    }, [_c('v-icon', {
      class: {
        'primary--text': microArticle.isUpvote
      },
      attrs: {
        "small": "",
        "title": _vm.$t('posting.upvote')
      },
      on: {
        "click": function($event) {
          return _vm.voteMicroArticle(microArticle, '0')
        }
      }
    }, [_vm._v("thumb_up")]), _vm._v("\n                      " + _vm._s(microArticle.upvoteCount) + "\n                      "), _c('v-icon', {
      staticClass: "ml-3",
      attrs: {
        "small": "",
        "title": _vm.$t('posting.comment')
      },
      on: {
        "click": function($event) {
          return _vm.gotoMicroArticle(microArticle)
        }
      }
    }, [_vm._v("fa fa-comment")]), _vm._v("\n                      " + _vm._s(microArticle.commentCount) + "\n                    ")], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "mt-5"
    })], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.microArticleList.length > 0),
      expression: "microArticleList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalMicroArticleNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getMicroArticleByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowComments),
      expression: "isShowComments"
    }]
  }, [_c('h3', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.comments")))]), _vm._v(" "), _vm._l((_vm.postingCommentsList), function(comments, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [_c('div', {
      staticClass: "media-body"
    }, [_vm._l((_vm.commentsPostingList), function(posting, index) {
      return _c('div', [(comments.commentsPostingId == posting.postingId) ? _c('p', {
        staticClass: "font-16 fw-500",
        on: {
          "click": function($event) {
            return _vm.getPostingById(posting.postingId)
          }
        }
      }, [_c('span', {
        staticClass: "fw-700"
      }, [_vm._v(_vm._s(_vm.$t("userData.posting")) + ":")]), _vm._v("\n                               " + _vm._s(posting.postingTitle) + "\n                            ")]) : _vm._e()])
    }), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [_c('span', {
      staticClass: "fw-700"
    }, [_vm._v(_vm._s(_vm.$t("userData.comment")) + ":")]), _vm._v(" "), (comments.commentsContext.length = 0) ? _c('span', {
      staticClass: "small"
    }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (comments.commentsContext.length < 30) ? _c('span', {
      staticClass: "small"
    }, [_vm._v("\n                              " + _vm._s(comments.commentsContext) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(comments.commentsContext) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(" " + _vm._s(comments.postingCommentsGoodnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(comments.postingCommentsStepnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(" " + _vm._s(comments.postingCommentList.length))])], 1)])])], 2)])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postingCommentsList.length > 0),
      expression: "postingCommentsList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalCommentsNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getCommentsByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReply),
      expression: "isShowReply"
    }]
  }, [_c('h3', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.reply")))]), _vm._v(" "), _vm._l((_vm.postingReplyList), function(reply, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [_c('div', {
      staticClass: "media-body"
    }, [_vm._l((_vm.parentCommentList), function(comments, index) {
      return _c('div', [(comments.commentsId == reply.parentCommentId) ? _c('p', {
        staticClass: "font-16 fw-500 word-break",
        on: {
          "click": function($event) {
            return _vm.getPostingById(comments.commentsPostingId)
          }
        }
      }, [_c('span', {
        staticClass: "fw-700"
      }, [_vm._v(_vm._s(_vm.$t("userData.comment")) + "：")]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(comments.commentsContext)
        }
      })]) : _vm._e()])
    }), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [_c('span', {
      staticClass: "fw-700"
    }, [_vm._v(_vm._s(_vm.$t("userData.reply")) + "：")]), _vm._v(" "), (reply.commentsContext.length = 0) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (reply.commentsContext.length < 30) ? _c('span', [_vm._v("\n                              " + _vm._s(reply.commentsContext) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(reply.commentsContext) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {}
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(" " + _vm._s(reply.postingCommentsGoodnums))])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {}
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(" " + _vm._s(reply.postingCommentsStepnums))])], 1)])])], 2)])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postingReplyList.length > 0),
      expression: "postingReplyList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalReplyNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getReplyByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowForward),
      expression: "isShowForward"
    }]
  }, [_c('h3', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.forward")))]), _vm._v(" "), _vm._l((_vm.postingForwardList), function(posting, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('div', {
      staticClass: "font-md mt-3"
    }, [_c('v-icon', [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700 mr-1"
    }, [_vm._v(_vm._s(_vm.$t("userData.forwarded")))])], 1), _vm._v(" "), _c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [(posting.postingImg != '') ? _c('span', {
      staticClass: "rounded-circle mr-4 img-responsive posting-image",
      domProps: {
        "innerHTML": _vm._s(posting.postingImg)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h2', {
      staticClass: "fw-700",
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(posting.postingTitle) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [(posting.postingContent.length = 0) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (posting.postingContent.length < 30) ? _c('span', [_vm._v("\n                              " + _vm._s(posting.postingContent) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(posting.postingContent) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingGoodnums))])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingStepnums))])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingCountComments))])], 1)])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postingForwardList.length > 0),
      expression: "postingForwardList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalForwardNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getForwardByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUpvotes),
      expression: "isShowUpvotes"
    }]
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.upvotes")))]), _vm._v(" "), _vm._l((_vm.upvotePostList), function(posting, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [(posting.postingImg != '') ? _c('span', {
      staticClass: "rounded-circle mr-4 img-responsive posting-image",
      domProps: {
        "innerHTML": _vm._s(posting.postingImg)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h2', {
      staticClass: "fw-700",
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(posting.postingTitle) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [(posting.postingContent.length = 0) ? _c('span') : _vm._e(), _vm._v(" "), (posting.postingContent.length < 30) ? _c('span', [_vm._v("\n                              " + _vm._s(posting.postingContent) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(posting.postingContent) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix mb-4"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingGoodnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingStepnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingCountComments))])], 1)])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upvotePostList.length > 0),
      expression: "upvotePostList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalUpvoteNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getUpvotePostListByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDownvotes),
      expression: "isShowDownvotes"
    }]
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.downvotes")))]), _vm._v(" "), _vm._l((_vm.downvotePostList), function(posting, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [(posting.postingImg != '') ? _c('span', {
      staticClass: "rounded-circle mr-4 img-responsive posting-image",
      domProps: {
        "innerHTML": _vm._s(posting.postingImg)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h2', {
      staticClass: "fw-700",
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(posting.postingTitle) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [(posting.postingContent.length = 0) ? _c('span') : _vm._e(), _vm._v(" "), (posting.postingContent.length < 30) ? _c('span', [_vm._v("\n                              " + _vm._s(posting.postingContent) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(posting.postingContent) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix mb-4"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingGoodnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingStepnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingCountComments))])], 1)])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downvotePostList.length > 0),
      expression: "downvotePostList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalDownvoteNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getDownvotePostListByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCollections),
      expression: "isShowCollections"
    }]
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.favorites")))]), _vm._v(" "), _vm._l((_vm.collectionPostList), function(posting, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [(posting.postingImg != '') ? _c('span', {
      staticClass: "rounded-circle mr-4 img-responsive posting-image",
      domProps: {
        "innerHTML": _vm._s(posting.postingImg)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h2', {
      staticClass: "fw-700",
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(posting.postingTitle) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-0 font-14 fw-400"
    }, [(posting.postingContent.length = 0) ? _c('span') : _vm._e(), _vm._v(" "), (posting.postingContent.length < 30) ? _c('span', [_vm._v("\n                              " + _vm._s(posting.postingContent) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(posting.postingContent) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix mb-4"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingGoodnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingStepnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-400 ml-1"
    }, [_vm._v(_vm._s(posting.postingCountComments))])], 1)])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collectionPostList.length > 0),
      expression: "collectionPostList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalCollectionPostNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getCollectionPostByPage
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReferrals),
      expression: "isShowReferrals"
    }]
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.referees")))]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "pt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.referralList), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "mr-3 mb-3 app-card"
    }, [_c('div', {
      staticClass: "text-xs-center follow-w mb-3 mt-2 profile-card-bg",
      style: ({
        backgroundImage: 'url(' + user.coverImage + ')'
      })
    }, [_c('v-avatar', {
      staticClass: "pointer mt-4",
      attrs: {
        "color": "primary",
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image != null),
        expression: "user.image != null"
      }],
      attrs: {
        "src": user.image,
        "alt": user.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image == null),
        expression: "user.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v("\n                              " + _vm._s(user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                            ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "user-list-content"
    }, [_c('div', {
      staticClass: "text-xs-center pt-2"
    }, [_c('h4', {
      staticClass: "fw-bold pointer",
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_vm._v(_vm._s(user.nickName))]), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(user.userName))])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs-center mb-2"
    }, [(user.userId != _vm.userId) ? _c('div', [_c('v-btn', {
      staticClass: "primary",
      attrs: {
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.referralFollow(user.userId)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? true : false),
        expression: "user.status == '1' ? true : false"
      }]
    }, [_vm._v("\n                                  " + _vm._s(_vm.$t("common.unfollow")) + "\n                                ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? false : true),
        expression: "user.status == '1' ? false : true"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "plus-round",
        "color": "white--text"
      }
    }), _vm._v("\n                                  " + _vm._s(_vm.$t("common.follow")) + "\n                                ")], 1)])], 1) : _vm._e()])])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowRewardRecords),
      expression: "isShowRewardRecords"
    }]
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userData.rewardRecords")))]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 mb-5",
    attrs: {
      "headers": _vm.bonusRecordTableHeaders,
      "items": _vm.bonusRecordList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(_vm.dateFormat(props.item.actionTimestamp)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateFormat(props.item.timestamp)))]), _vm._v(" "), _c('td', {
          staticClass: "primary--text pointer",
          on: {
            "click": function($event) {}
          }
        }, [_c('router-link', {
          attrs: {
            "to": '/post/' + props.item.postId
          }
        }, [_vm._v("\n                            " + _vm._s(props.item.bonus != null ? props.item.bonus.toFixed(4) : 0.0000) + " IOB Power for " + _vm._s(props.item.type) + "\n                          ")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bonusRecordList.length > 0),
      expression: "bonusRecordList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalRewardRecordsNum,
      "pageSize": 10,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getBonusRecordsListByPage
    }
  })], 1)], 1)])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    class: _vm.isLogin ? 'mt-70' : ''
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('div', [_vm._l((_vm.postSearchList), function(post, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-4"
    }, [_c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media"
    }, _vm._l((_vm.userDetailSearchList), function(user, index) {
      return (post.postingUserId == user.userId) ? _c('div', {
        key: index,
        staticClass: "ml-2 mr-2 pt-3"
      }, [_c('div', {
        staticClass: "mb-3"
      }, [_c('v-avatar', {
        staticClass: "pointer",
        attrs: {
          "color": "primary",
          "size": "32"
        },
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image != null),
          expression: "user.image != null"
        }],
        attrs: {
          "src": user.image,
          "alt": user.userName
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image == null),
          expression: "user.image == null"
        }],
        staticClass: "headline white--text"
      }, [_vm._v("\n                            " + _vm._s(user.userName
        .trim()
        .substring(0, 1)
        .toLocaleUpperCase()) + "\n                          ")])]), _vm._v(" "), _c('span', {
        staticClass: "pl-2 pointer hover-color font-16 fw-700",
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_vm._v("\n                          " + _vm._s(user.nickName) + "\n                          "), _c('span', [_vm._v("(" + _vm._s(user.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
        staticClass: "px-2 fw-500 font-14"
      }, [_c('v-icon', {
        attrs: {
          "size": "18"
        }
      }, [_vm._v("schedule")]), _vm._v("\n                          " + _vm._s(_vm.dateFormat(post.postingTime)) + "\n                        ")], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_vm._l((_vm.userDetailSearchList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('div', {
          key: index,
          staticClass: "px-0"
        }, [(post.postingImg != '') ? _c('span', {
          staticClass: "rounded-circle mr-4 img-responsive posts-image pointer",
          domProps: {
            "innerHTML": _vm._s(post.postingImg)
          },
          on: {
            "click": function($event) {
              return _vm.findsel(post)
            }
          }
        }) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), _c('div', {
        staticClass: "media-body"
      }, [_c('h3', {
        staticClass: "fw-700 pointer break-word",
        domProps: {
          "innerHTML": _vm._s(post.postingTitle)
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }), _vm._v(" "), _c('h5', {
        staticClass: "mb-3 py-2",
        domProps: {
          "innerHTML": _vm._s(post.postingContent)
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "mt-1 justify-space-between"
      }, [_c('div', {
        staticClass: "social"
      }, [_c('span', {
        staticClass: "pointer"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.bonus')
        }
      }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
        staticClass: "font-1x fw-400 ml-1"
      }, [_vm._v(_vm._s(post.bonus.toFixed(2)))])], 1), _vm._v(" "), (post.postingStatus == 0) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == 1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == -1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.comment')
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingCountComments))])], 1), _vm._v(" "), _vm._l((_vm.userDetailSearchList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('span', {
          staticClass: "ml-2"
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.retweet')
          },
          on: {
            "click": function($event) {
              return _vm.modalzf(post, user)
            }
          }
        }, [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 fw-400 ml-1"
        }, [_vm._v(_vm._s(post.postingCountForword))])], 1) : _vm._e()
      }), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [(post.postingCollection == 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("\n                                  fa fa-star\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('span', [(post.postingCollection != 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("fa fa-star")]) : _vm._e()], 1)], 2)])])], 2)]) : _vm._e()
    }), 0)])])])
  }), _vm._v(" "), _c('infinite-loading', {
    staticClass: "mb-3",
    attrs: {
      "identifier": _vm.infiniteId
    },
    on: {
      "infinite": _vm.getPostSearchList
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t("posting.noMore")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t("posting.noResults")))])])], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.forwardModal),
      callback: function($$v) {
        _vm.forwardModal = $$v
      },
      expression: "forwardModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "font-30 fw-500"
  }, [_vm._v(_vm._s(_vm.$t('posting.retweet')))])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "32"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage != null),
      expression: "postUserImage != null"
    }],
    attrs: {
      "src": _vm.postUserImage,
      "alt": _vm.postUserName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage == null),
      expression: "postUserImage == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v("\n                          " + _vm._s(_vm.postUserName
    .trim()
    .substring(0, 1)
    .toLocaleUpperCase()) + "\n                        ")])])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
    staticClass: "pointer font-18 fw-700",
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_vm._v(_vm._s(_vm.postNickName))]), _vm._v(" "), _c('span', {
    staticClass: "px-2 font-16 fw-700"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('common.at')) + "\n                          "), _c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("schedule")]), _vm._v("\n                          " + _vm._s(_vm.dateFormat(_vm.postDate)) + "\n                        ")], 1)]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', {
    staticClass: "font-14 fw-700"
  }, [_vm._v(_vm._s(_vm.postTitle))])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-form', {
    ref: "formValidatezf"
  }, [_c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "input-7-4"
    },
    model: {
      value: (_vm.formValidatezf.postingForwardContext),
      callback: function($$v) {
        _vm.$set(_vm.formValidatezf, "postingForwardContext", $$v)
      },
      expression: "formValidatezf.postingForwardContext"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.forwardModal = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.postingforward
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_vm._v("\n            \n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "font-family": "inherit",
      "font-size": "large"
    }
  }, [_vm._v("Create A New Project")])]), _vm._v(" "), _c('Form', {
    ref: "formValidate",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "model": _vm.formValidate,
      "label-position": "left",
      "rules": _vm.ruleValidate,
      "label-width": 100
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "Name",
      "prop": "projectName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Enter project name",
      "clearable": ""
    },
    model: {
      value: (_vm.formValidate.projectName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "projectName", $$v)
      },
      expression: "formValidate.projectName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Description",
      "prop": "projectDesc"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formValidate.projectDesc),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "projectDesc", $$v)
      },
      expression: "formValidate.projectDesc"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "contacts",
      "prop": "contacts"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Enter contacts",
      "clearable": ""
    },
    model: {
      value: (_vm.formValidate.contacts),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "contacts", $$v)
      },
      expression: "formValidate.contacts"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "E-mail",
      "prop": "contactEmail"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Enter your e-mail",
      "clearable": ""
    },
    model: {
      value: (_vm.formValidate.contactEmail),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "contactEmail", $$v)
      },
      expression: "formValidate.contactEmail"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Financing",
      "prop": "financingTarget"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "max": 100000000,
      "min": 0
    },
    model: {
      value: (_vm.financingTarget),
      callback: function($$v) {
        _vm.financingTarget = $$v
      },
      expression: "financingTarget"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "White Paper",
      "prop": "whitePaper"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Enter the white paper link",
      "clearable": ""
    },
    model: {
      value: (_vm.formValidate.whitePaper),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "whitePaper", $$v)
      },
      expression: "formValidate.whitePaper"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Telegram",
      "prop": "telegram"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Enter telegram link",
      "clearable": ""
    },
    model: {
      value: (_vm.formValidate.telegram),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "telegram", $$v)
      },
      expression: "formValidate.telegram"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Twitter",
      "prop": "twitter"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Enter Twitter account",
      "clearable": ""
    },
    model: {
      value: (_vm.formValidate.twitter),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "twitter", $$v)
      },
      expression: "formValidate.twitter"
    }
  })], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formValidate')
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function($event) {
        return _vm.handleReset('formValidate')
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', [_vm._v("\n                 \n            ")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 mt-5"
  }, [_c('div', {
    staticClass: "alert primary"
  }, [_c('div', {
    staticClass: "alert-text"
  }, [_c('div', {
    staticClass: "font-md"
  }, [_c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("transactionData.transaction")) + ":")]), _vm._v(" " + _vm._s(_vm.txHash) + "\n                                "), _c('Icon', {
    staticClass: "txHash pointer",
    attrs: {
      "type": "ios-copy-outline",
      "title": _vm.$t('common.copy'),
      "data-clipboard-text": _vm.txHash,
      "color": "primary--text"
    },
    on: {
      "click": _vm.copyTxHash
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "font-md"
  }, [_c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("transactionData.contract")) + ":")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transaction.contractAddress != ''),
      expression: "transaction.contractAddress != ''"
    }]
  }, [_vm._v("\n                                    " + _vm._s(_vm.transaction.contractAddress) + "\n                                    "), _c('Icon', {
    staticClass: "contract pointer",
    attrs: {
      "type": "ios-copy-outline",
      "title": _vm.$t('common.copy'),
      "data-clipboard-text": _vm.transaction.contractAddress,
      "color": "primary--text"
    },
    on: {
      "click": _vm.copyContract
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transaction.contractAddress == ''),
      expression: "transaction.contractAddress == ''"
    }]
  }, [_vm._v("\n                                    " + _vm._s(_vm.transaction.to) + "\n                                    "), _c('Icon', {
    staticClass: "contract pointer",
    attrs: {
      "type": "ios-copy-outline",
      "title": _vm.$t('common.copy'),
      "data-clipboard-text": _vm.transaction.to,
      "color": "primary--text"
    },
    on: {
      "click": _vm.copyContract
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowQRCode),
      expression: "isShowQRCode"
    }],
    staticClass: "qrcode",
    attrs: {
      "id": "qrcode"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "canvas",
      "width": "200px",
      "height": "200px;"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "container mt-4 row"
  }, [_c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.txHash")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.txHash) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.blockHeight")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.transaction.blockNumber) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.time")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.timeStampToTime(_vm.transaction.timeStamp)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.from")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3 primary--text"
  }, [_vm._v("\n                        " + _vm._s(_vm.transaction.from) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.to")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.contract")) + "\n                        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transaction.contractAddress != ''),
      expression: "transaction.contractAddress != ''"
    }],
    staticClass: "primary--text"
  }, [_vm._v("\n                            " + _vm._s(_vm.transaction.contractAddress) + "\n                        ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transaction.contractAddress == ''),
      expression: "transaction.contractAddress == ''"
    }],
    staticClass: "primary--text"
  }, [_vm._v("\n                            " + _vm._s(_vm.transaction.to) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.tokensTransfered")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("transactionData.from")) + " \n                        "), _c('span', {
    staticClass: "primary--text"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n                                    " + _vm._s(_vm.transaction.from > 18 ? _vm.transaction.from.substring(0, 18) + '...' : _vm.transaction.from) + "\n                                ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.transaction.from))])])], 1), _vm._v(" " + _vm._s(_vm.$t("transactionData.to")) + " \n                        "), _c('span', {
    staticClass: "primary--text"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n                                    " + _vm._s(_vm.subToHash(_vm.transaction.input) > 18 ? _vm.subToHash(_vm.transaction.input).substring(0, 18) + '...' : _vm.subToHash(_vm.transaction.input)) + "\n                                ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subToHash(_vm.transaction.input)))])])], 1), _vm._v(" for\n                        " + _vm._s(_vm.getQuantity(_vm.transaction.input)) + " ERC-20(IOB Token)\n                         ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.gasLimit")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.transaction.gas) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.gasUsedByTransaction")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.transaction.gasUsed) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.gasPrice")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.numberToString(_vm.transaction.gasPrice)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("transactionData.nonceAndPosition")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.transaction.nonce) + "|"), _c('span', [_vm._v("{")]), _vm._v(_vm._s(_vm.transaction.transactionIndex)), _c('span', [_vm._v("}")])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "fxt-template-layout10"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-12 fxt-bg-img flex-b",
    attrs: {
      "md6": "",
      "data-bg-image": "../../../static/img/bg14-l.jpg"
    }
  }, [_c('div', {
    staticClass: "fxt-header"
  }, [_c('div', [_c('h1', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.analyst')) + " ")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.paidTitle')))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "col-12 fxt-bg-color",
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "fxt-content"
  }, [_c('div', {
    staticClass: "fxt-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("password.title")))]), _vm._v(" "), _c('Form', {
    ref: "formInline",
    attrs: {
      "model": _vm.formInline,
      "rules": _vm.ruleInline
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "regEmail"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "E-mail Address"
    },
    on: {
      "input": _vm.showButton
    },
    model: {
      value: (_vm.formInline.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "regEmail", $$v)
      },
      expression: "formInline.regEmail"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    model: {
      value: (_vm.isAgree),
      callback: function($$v) {
        _vm.isAgree = $$v
      },
      expression: "isAgree"
    }
  }, [_c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.$t("password.agreeMsg")))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAgreeMessage),
      expression: "isShowAgreeMessage"
    }]
  }, [_vm._v(_vm._s(_vm.$t("password.agreeHint")))]), _vm._v(" "), _c('FormItem', {
    staticClass: "mt-3"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisabled),
      expression: "isDisabled"
    }]
  }, [_c('v-btn', {
    attrs: {
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formInline')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("password.resetButton")))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDisabled),
      expression: "!isDisabled"
    }],
    staticClass: "mt-3 mb-3"
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formInline')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("password.resetButton")))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "font-14"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("header.accountHint")) + "?")]), _vm._v(" "), _c('span', {
    staticClass: "primary--text pointer mr-2",
    on: {
      "click": _vm.gotoRegister
    }
  }, [_vm._v(_vm._s(_vm.$t("header.signUp")))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "fxt-footer"
  }, [_c('ul', {
    staticClass: "fxt-socials"
  }, [_c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBots_",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBotsPro",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-linkedin fxt-transformY-50 fxt-transition-delay-9"
  }, [_c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "title": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fab fa-telegram-plane"
  })])])])])])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', [_c('app-header'), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px auto",
      "margin-top": "80px"
    }
  }, [_c('div', {
    staticClass: "postingtitle",
    staticStyle: {
      "text-align": "center",
      "border-bottom": "1px solid rgb(238,238,238)",
      "height": "120px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.project.projectName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('Avatar', {
    staticStyle: {
      "background-color": "#87d068"
    },
    attrs: {
      "icon": "person"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("创建时间：" + _vm._s(_vm.dateFormat(_vm.project.creationTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "cursor": "pointer"
    },
    on: {
      "mouseenter": _vm.showUserDetail,
      "mouseleave": _vm.hideUserDetail
    }
  }, [_vm._v(_vm._s(_vm.userDetail.nickName))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUserDetail),
      expression: "isShowUserDetail"
    }],
    staticStyle: {
      "width": "300px",
      "height": "160px",
      "background-color": "rgb(254,254,254)",
      "box-shadow": "1px 1px 5px 0px rgba(50, 50, 50, 0.75)",
      "border": "1px solid #cacaca",
      "border-radius": "3px",
      "position": "relative",
      "top": "10px",
      "left": "350px"
    }
  }, [_c('dl', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('dt', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_c('Avatar', {
    staticStyle: {
      "background-color": "#87d068"
    },
    attrs: {
      "icon": "person",
      "size": "large"
    }
  })], 1), _vm._v(" "), _c('dd', {
    staticStyle: {
      "margin": "12px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.userDetail.nickName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "20px",
      "color": "rgb(120,145,150)"
    }
  }, [_vm._v("@" + _vm._s(_vm.userDetail.nickName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("关注")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("个人简介")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "projecrDesc"
  }, [_vm._v("项目描述：\n\t\t\t\t" + _vm._s(_vm.project.projectDesc) + " \n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "postingbottom",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('p', [_c('span', {
    staticStyle: {
      "margin-left": "50px"
    }
  }, [_c('Icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "转发",
      "type": "forward",
      "size": "20"
    }
  })], 1), _vm._v("    \n\t\t\t\t\t"), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#A9A9A9",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.commentsshow
    }
  }, [_vm._v("评论   |")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('Icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "thumbsup",
      "size": "20"
    },
    on: {
      "click": _vm.supportProject
    }
  }), _vm._v(_vm._s(_vm.project.supportNumber) + "\n\t\t\t\t\t\t \n\t\t\t\t\t\t"), _c('Icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "thumbsdown",
      "size": "20"
    },
    on: {
      "click": _vm.opposeProject
    }
  }), _vm._v(_vm._s(_vm.project.opposeNumber) + "\n\t\t\t\t\t")], 1), _vm._v(" "), _c('span', {
    staticClass: "posting_shape",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('Icon', {
    staticClass: "shape_twitter",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "分享到推特",
      "type": "social-twitter",
      "size": "20"
    }
  }), _vm._v("  \n\t\t\t\t\t\t"), _c('Icon', {
    staticClass: "shape_facebook",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "分享到脸书",
      "type": "social-facebook",
      "size": "20"
    }
  }), _vm._v("  \n\t\t\t\t\t\t"), _c('Icon', {
    staticClass: "shape_google",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "分享到谷歌",
      "type": "social-google",
      "size": "20"
    }
  }), _vm._v("  \n\t\t\t\t\t\t"), _c('Icon', {
    staticClass: "shape_reddit",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "shape on reddit",
      "type": "social-reddit",
      "size": "20"
    }
  }), _vm._v("  \n\t\t\t\t\t\t"), _c('Icon', {
    staticClass: "shape_linkedin",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "分享到linkedin",
      "type": "social-linkedin",
      "size": "20"
    }
  }), _vm._v("  \n\t\t\t\t\t")], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowcomments),
      expression: "isShowcomments"
    }],
    staticClass: "projectComment"
  }, [_c('Form', {
    ref: "formValidate",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "commentProjectId"
    }
  }, [_c('Input', {
    attrs: {
      "type": "hidden"
    },
    model: {
      value: (_vm.formValidate.commentProjectId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "commentProjectId", $$v)
      },
      expression: "formValidate.commentProjectId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "commentText"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formValidate.commentText),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "commentText", $$v)
      },
      expression: "formValidate.commentText"
    }
  })], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitComment('formValidate')
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        return _vm.closeComment('formValidate')
      }
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px",
      "border-bottom": "1px solid rgb(238,238,238)",
      "border-top": "1px solid rgb(238,238,238)",
      "margin-top": "20px",
      "background-color": "#A9A9A9"
    }
  }), _vm._v(" "), _vm._l((_vm.projectCommentList), function(comment, index) {
    return _c('div', {
      staticClass: "comments",
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('dl', {
      staticStyle: {
        "display": "flex",
        "font-family": "inherit",
        "font-size": "14px"
      }
    }, [_c('dt', [_c('Avatar', {
      staticStyle: {
        "background-color": "#87d068"
      },
      attrs: {
        "icon": "person",
        "size": "large"
      }
    })], 1), _vm._v(" "), _c('dd', [_c('span', [_c('a', [_vm._v(_vm._s(_vm.userDetail.nickName))]), _vm._v(" 发表于")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(comment.commentTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Icon', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "thumbsup",
        "size": "20"
      },
      on: {
        "click": function($event) {}
      }
    }), _vm._v(_vm._s(comment.supportNumber) + "\n\t\t\t\t\t\t \n\t\t\t\t\t\t"), _c('Icon', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "thumbsdown",
        "size": "20"
      },
      on: {
        "click": function($event) {}
      }
    }), _vm._v(_vm._s(comment.opposeNumber) + "\n\t\t\t\t\t\t"), _c('span', {
      staticClass: "toggletext",
      staticStyle: {
        "margin-left": "400px",
        "color": "rgb(224,224,224)",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.toggletext(index)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "chevron-down"
      },
      on: {
        "click": _vm.q
      }
    })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isShowCommentText),
        expression: "isShowCommentText"
      }],
      staticClass: "commentText"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(comment.commentText) + "\n\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _vm._l((comment.projectCommentList), function(childComment) {
      return _c('div', {
        staticStyle: {
          "margin-left": "40px"
        }
      }, [_c('br'), _vm._v(" "), _c('dl', {
        staticStyle: {
          "display": "flex",
          "font-family": "inherit",
          "font-size": "14px"
        }
      }, [_c('dt', [_c('Avatar', {
        staticStyle: {
          "background-color": "#87d068"
        },
        attrs: {
          "icon": "person",
          "size": "large"
        }
      })], 1), _vm._v(" "), _c('dd', [_c('span', [_c('a', [_vm._v(_vm._s(_vm.userDetail.nickName))]), _vm._v(" 发表于")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(childComment.commentTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Icon', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "type": "thumbsup",
          "size": "20"
        },
        on: {
          "click": function($event) {}
        }
      }), _vm._v(_vm._s(childComment.supportNumber) + "\n\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t"), _c('Icon', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "type": "thumbsdown",
          "size": "20"
        },
        on: {
          "click": function($event) {}
        }
      }), _vm._v(_vm._s(childComment.opposeNumber) + "\n\t\t\t\t\t\t\t"), _c('span', {
        staticClass: "toggletext",
        staticStyle: {
          "margin-left": "300px",
          "color": "rgb(224,224,224)",
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            return _vm.toggletext(index)
          }
        }
      }, [_c('Icon', {
        attrs: {
          "type": "chevron-down"
        },
        on: {
          "click": _vm.q
        }
      })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.isShowCommentText),
          expression: "isShowCommentText"
        }],
        staticClass: "commentText"
      }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(childComment.commentText) + "\n\t\t\t\t\t\t\t")])], 1)])])
    })], 2)
  })], 2)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v(" ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "s-canvas"
  }, [_c('canvas', {
    attrs: {
      "id": "s-canvas",
      "width": _vm.contentWidth,
      "height": _vm.contentHeight
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "mt-70"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "mb-4 font-14"
  }, [_c('div', {
    staticClass: "ma-2"
  }, [_c('span', {
    staticClass: "font-18"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("notification.notifications")) + "\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "pointer hover-color right",
    on: {
      "click": _vm.markAllAsRead
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("notification.markAllAsRead")) + "\n                                ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNothingMessage),
      expression: "isShowNothingMessage"
    }]
  }, [_c('div', {
    staticClass: "font-20 text-center"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("notification.nothingMessage")) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-12 text-center"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("notification.mentionsMessage")) + "\n                            ")])]), _vm._v(" "), _c('div', [_vm._l((_vm.notificationList), function(notification, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-2 px-3 py-3"
    }, [(notification.type == 'POST_UPVOTE') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.postUpvote")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.post.postingTitle) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'POST_DOWNVOTE') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.postDownvote")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.post.postingTitle) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'POST_COMMENT') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.postComment")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.postComment.commentsContext) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'COMMENT_UPVOTE') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.commentUpvote")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.postComment.commentsContext) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'COMMENT_DOWNVOTE') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.commentDownvote")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.postComment.commentsContext) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'COMMENT_REPLY') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.commentReply")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.postComment.commentsContext) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'USER_FOLLOW') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.userFollow")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (notification.type == 'USER_UNFOLLOW') ? _c('div', [_c('div', [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "30"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image != null),
        expression: "notification.senderUserDetail.image != null"
      }],
      attrs: {
        "src": notification.senderUserDetail.image,
        "alt": notification.senderUserDetail.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.senderUserDetail.image == null),
        expression: "notification.senderUserDetail.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(notification.senderUserDetail.userName.trim().substring(0, 1).toLocaleUpperCase()))])]), _vm._v(" "), _c('span', {
      staticClass: "pl-2 pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(notification.senderUserDetail.userName)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(notification.senderUserDetail.nickName) + "\n                                            "), _c('span', [_vm._v("(" + _vm._s(notification.senderUserDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.userUnfollow")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (notification.type == 'ADMIN_POST_UPDATE') ? _c('div', [_c('div', [_c('v-avatar', {
      attrs: {
        "color": "primary",
        "size": "30"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/icons/iob-sip-admin.jpg",
        "alt": "SIP"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.adminPostUpdate")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.post.postingTitle) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'ADMIN_POST_DELETE') ? _c('div', [_c('div', [_c('v-avatar', {
      attrs: {
        "color": "primary",
        "size": "30"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/icons/iob-sip-admin.jpg",
        "alt": "SIP"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.adminPostDelete")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (notification.type == 'ADMIN_COMMENT_UPDATE') ? _c('div', [_c('div', [_c('v-avatar', {
      attrs: {
        "color": "primary",
        "size": "30"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/icons/iob-sip-admin.jpg",
        "alt": "SIP"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.adminCommentUpdate")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.postComment.commentsContext) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (notification.type == 'ADMIN_COMMENT_DELETE') ? _c('div', [_c('div', [_c('v-avatar', {
      attrs: {
        "color": "primary",
        "size": "30"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/icons/iob-sip-admin.jpg",
        "alt": "SIP"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "ml-2 fw-600"
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("notification.adminCommentDelete")) + "\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "fw-700"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', {
      staticClass: "fw-600"
    }, [_vm._v(_vm._s(_vm.dateFormat(notification.timestamp)))]), _vm._v(" "), (notification.isNotRead) ? _c('span', {
      staticClass: "right fw-700 pointer",
      on: {
        "click": function($event) {
          return _vm.readNotification(notification)
        }
      }
    }, [_c('v-icon', {
      staticClass: "primary--text",
      attrs: {
        "size": "12"
      }
    }, [_vm._v("fas fa-circle")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "font-14 mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.gotoPost(notification)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(notification.post.postingTitle) + "\n                                    ")])]) : _vm._e()])
  }), _vm._v(" "), _c('infinite-loading', {
    staticClass: "mb-3",
    on: {
      "infinite": _vm.getNotificationList
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t("posting.noMore")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t("posting.noResults")))])])], 2)], 1), _vm._v(" "), (false) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": "",
      "fill-height": ""
    }
  }, [_c('v-card', _vm._l((_vm.relatedUserInfoList), function(userInfo, index) {
    return _c('div', {
      key: index,
      staticClass: "ma-3 userDetail"
    }, [_c('div', {
      staticClass: "imgleft"
    }, [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "52"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(userInfo.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (userInfo.image != null),
        expression: "userInfo.image != null"
      }],
      attrs: {
        "src": userInfo.image,
        "alt": userInfo.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (userInfo.image == null),
        expression: "userInfo.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v(_vm._s(userInfo.userName.trim().substring(0, 1).toLocaleUpperCase()))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "right-side Author"
    }, [_c('div', {
      staticClass: "ml-3"
    }, [_c('span', {
      staticClass: "pointer hover-color font-14 fw-700",
      on: {
        "click": function($event) {
          return _vm.goUserData(userInfo.userName)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(userInfo.nickName))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(userInfo.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-500"
    }, [_vm._v("@" + _vm._s(userInfo.userName))])]), _vm._v(" "), _c('div', {
      staticClass: "ml-3"
    }, [_c('v-btn', {
      attrs: {
        "color": "primary",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.follow(userInfo)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (userInfo.status == '0'),
        expression: "userInfo.status == '0'"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "plus-round",
        "color": "#FFFFFF"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("common.follow")))])], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (userInfo.status == '1'),
        expression: "userInfo.status == '1'"
      }]
    }, [_c('span', [_vm._v(_vm._s(_vm.$t("common.unfollow")))])])])], 1)])])
  }), 0)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "mb-150"
  }), _vm._v(" "), _c('div', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg10": "",
      "mt-6": ""
    }
  }, [_c('v-card', [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    staticClass: "font-md",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t("microArticles.publishMessage")) + "\n                                    ")]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "microArticleForm",
    model: {
      value: (_vm.microArticleVaild),
      callback: function($$v) {
        _vm.microArticleVaild = $$v
      },
      expression: "microArticleVaild"
    }
  }, [_c('v-textarea', {
    attrs: {
      "color": "aquamarine",
      "rules": _vm.microArticleContentRules,
      "auto-grow": "",
      "required": "",
      "outline": ""
    },
    on: {
      "input": _vm.changeContent
    },
    model: {
      value: (_vm.microArticleForm.content),
      callback: function($$v) {
        _vm.$set(_vm.microArticleForm, "content", $$v)
      },
      expression: "microArticleForm.content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-progress-circular', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contentPercentage <= 100),
      expression: "contentPercentage <= 100"
    }],
    attrs: {
      "rotate": -90,
      "size": 30,
      "width": 1,
      "value": _vm.contentPercentage,
      "color": "aquamarine"
    }
  }, [_vm._v(" \n                                                    " + _vm._s(_vm.availableContentLength) + " \n                                                ")]), _vm._v(" "), _c('v-progress-circular', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contentPercentage > 100),
      expression: "contentPercentage > 100"
    }],
    attrs: {
      "rotate": -90,
      "size": 30,
      "width": 1,
      "value": _vm.contentPercentage,
      "color": "error"
    }
  }, [_vm._v(" \n                                                    " + _vm._s(_vm.availableContentLength) + " \n                                                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "round": "",
      "color": "aquamarine",
      "disabled": !_vm.microArticleVaild,
      "loading": _vm.publishBtnLoading
    },
    on: {
      "click": _vm.createMicroArticle
    }
  }, [_vm._v("\n                                                    " + _vm._s(_vm.$t("microArticles.publish")) + "\n                                                ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tabs', {
    staticClass: "aquamarine--text",
    attrs: {
      "right": "",
      "slider-color": "aquamarine",
      "show-arrows": ""
    }
  }, [_c('v-tab', {
    on: {
      "click": function($event) {
        _vm.tabName = 'hot'
      }
    }
  }, [_c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("microArticles.hot")))])]), _vm._v(" "), _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.tabName = 'new'
      }
    }
  }, [_c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("microArticles.new")))])]), _vm._v(" "), _c('v-tab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.microArticleSearchList.length > 0),
      expression: "microArticleSearchList.length > 0"
    }],
    on: {
      "click": function($event) {
        _vm.tabName = _vm.searchText
      }
    }
  }, [_c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.searchText))])]), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-divider'), _vm._v(" "), _vm._l((_vm.microArticleHotList), function(microArticle, index) {
    return [_c('div', {
      staticClass: "mt-3 mb-3 ml-3 mr-3"
    }, [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(microArticle.userName)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": microArticle.image
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "ml-3 font-lg pointer hover-color",
      on: {
        "click": function($event) {
          return _vm.goUserData(microArticle.userName)
        }
      }
    }, [_vm._v(_vm._s(microArticle.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "ml-3 font-lg"
    }, [_vm._v(_vm._s(_vm.dateFormat(microArticle.time)))]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 font-md pointer hover-color",
      on: {
        "click": function($event) {
          return _vm.gotoMicroArticle(microArticle)
        }
      }
    }, [_vm._v("\n                                                        " + _vm._s(microArticle.content) + "\n                                                    ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "mr-5 right"
    }, [_c('v-icon', {
      class: {
        'aquamarine--text': microArticle.isUpvote
      },
      attrs: {
        "small": "",
        "title": _vm.$t('posting.upvote')
      },
      on: {
        "click": function($event) {
          return _vm.voteMicroArticle(microArticle, '0')
        }
      }
    }, [_vm._v("thumb_up")]), _vm._v("\n                                                    " + _vm._s(microArticle.upvoteCount) + "\n                                                    "), _vm._v(" "), _c('v-icon', {
      staticClass: "ml-3",
      attrs: {
        "small": "",
        "title": _vm.$t('posting.comment')
      },
      on: {
        "click": function($event) {
          return _vm.gotoMicroArticle(microArticle)
        }
      }
    }, [_vm._v("fa fa-comment")]), _vm._v("\n                                                    " + _vm._s(microArticle.commentCount) + "\n                                                ")], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "mt-5"
    })]
  })], 2), _vm._v(" "), _c('infinite-loading', {
    staticClass: "mb-3",
    attrs: {
      "identifier": _vm.tabName
    },
    on: {
      "infinite": _vm.getMicroArticleHotList
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "aquamarine"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t("microArticles.noMore")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t("microArticles.noResults")))])])], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-divider'), _vm._v(" "), _vm._l((_vm.microArticleNewList), function(microArticle, index) {
    return [_c('div', {
      staticClass: "mt-3 mb-3 ml-3 mr-3"
    }, [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(microArticle.userName)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": microArticle.image
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "ml-3 font-lg pointer hover-color",
      on: {
        "click": function($event) {
          return _vm.goUserData(microArticle.userName)
        }
      }
    }, [_vm._v(_vm._s(microArticle.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "ml-3 font-lg"
    }, [_vm._v(_vm._s(_vm.dateFormat(microArticle.time)))]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 font-md pointer hover-color",
      on: {
        "click": function($event) {
          return _vm.gotoMicroArticle(microArticle)
        }
      }
    }, [_vm._v("\n                                                        " + _vm._s(microArticle.content) + "\n                                                    ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "mr-5 right"
    }, [_c('v-icon', {
      class: {
        'aquamarine--text': microArticle.isUpvote
      },
      attrs: {
        "small": "",
        "title": _vm.$t('posting.upvote')
      },
      on: {
        "click": function($event) {
          return _vm.voteMicroArticle(microArticle, '0')
        }
      }
    }, [_vm._v("thumb_up")]), _vm._v("\n                                                    " + _vm._s(microArticle.upvoteCount) + "\n                                                    "), _vm._v(" "), _c('v-icon', {
      staticClass: "ml-3",
      attrs: {
        "small": "",
        "title": _vm.$t('posting.comment')
      },
      on: {
        "click": function($event) {
          return _vm.gotoMicroArticle(microArticle)
        }
      }
    }, [_vm._v("fa fa-comment")]), _vm._v("\n                                                    " + _vm._s(microArticle.commentCount) + "\n                                                ")], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "mt-5"
    })]
  })], 2), _vm._v(" "), _c('keep-alive', [_c('infinite-loading', {
    staticClass: "mb-3",
    attrs: {
      "identifier": _vm.tabName
    },
    on: {
      "infinite": _vm.getMicroArticleNewList
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "aquamarine"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t("microArticles.noMore")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t("microArticles.noResults")))])])], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-divider'), _vm._v(" "), _vm._l((_vm.microArticleSearchList), function(microArticle, index) {
    return [_c('div', {
      staticClass: "mt-3 mb-3 ml-3 mr-3"
    }, [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(microArticle.userName)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": microArticle.image
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "ml-3 font-lg pointer hover-color",
      on: {
        "click": function($event) {
          return _vm.goUserData(microArticle.userName)
        }
      }
    }, [_vm._v(_vm._s(microArticle.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "ml-3 font-lg"
    }, [_vm._v(_vm._s(_vm.dateFormat(microArticle.time)))]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 font-md pointer hover-color",
      on: {
        "click": function($event) {
          return _vm.gotoMicroArticle(microArticle)
        }
      }
    }, [_vm._v("\n                                                        " + _vm._s(microArticle.content) + "\n                                                    ")])], 1), _vm._v(" "), _c('v-divider')]
  })], 2), _vm._v(" "), _c('keep-alive', [_c('infinite-loading', {
    staticClass: "mb-3",
    attrs: {
      "identifier": _vm.tabName
    },
    on: {
      "infinite": _vm.getMicroArticleSearchList
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "aquamarine"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t("microArticles.noMore")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t("microArticles.noResults")))])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "fxt-template-layout10"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-12 fxt-bg-img",
    attrs: {
      "md6": "",
      "data-bg-image": "../../../static/img/bg14-l.jpg"
    }
  }, [_c('div', {
    staticClass: "fxt-header"
  }, [_c('div', [_c('h1', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.analyst')) + " ")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.paidTitle')))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "col-12 fxt-bg-color",
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "fxt-content"
  }, [_c('div', {
    staticClass: "fxt-form fxt-footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLink),
      expression: "isShowLink"
    }],
    staticClass: "mb-3"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("updateEmail.updateMsg")) + "\n                    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "medium": "",
      "color": "primary"
    },
    on: {
      "click": _vm.updateEmail
    }
  }, [_vm._v(_vm._s(_vm.$t("updateEmail.sureMsg")))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMessage),
      expression: "isShowMessage"
    }],
    staticClass: "mt-5"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t("updateEmail.noValidMsg")))]), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "flat": "",
      "medium": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(_vm._s(_vm.$t("allPage.homepage")))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "fxt-footer"
  }, [_c('ul', {
    staticClass: "fxt-socials"
  }, [_c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBots_",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBotsPro",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-linkedin fxt-transformY-50 fxt-transition-delay-9"
  }, [_c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "title": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fab fa-telegram-plane"
  })])])])])])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 mt-5"
  }, [_c('div', {
    staticClass: "alert primary"
  }, [_c('div', {
    staticClass: "alert-text"
  }, [_c('div', {
    staticClass: "font-md"
  }, [_c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("investment.name")) + ":")]), _vm._v(" " + _vm._s(_vm.investment.name) + "\n                           ")]), _vm._v(" "), _c('div', {
    staticClass: "font-md"
  }, [_c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("investment.email")) + ": ")]), _vm._v(_vm._s(_vm.investment.email) + "\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container mt-4 row"
  }, [_c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.wallet")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.walletAddress) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                         " + _vm._s(_vm.$t("investment.transaction")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.transaction) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.sendingAddress")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.sendingAddress) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.purchasingAmount")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.investment.purchasingAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.paymentType")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.investment.paymentType))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.sentTime")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.sentTime) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.recordTime")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.recordTime) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.averagePrice")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.averagePrice) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.purchasingAmountInUSD")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.purchasingAmountInUSD) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.bonusRate")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.bonusRate) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.bonus")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.bonus) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.totalIOB")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.investment.totalIOB))])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "h-100"
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    class: _vm.isLogin ? 'mt-70' : ''
  }), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md7": "",
      "lg10": ""
    }
  }, [_c('div', {
    staticClass: "font-30 fw-700 mb-5 text-center"
  }, [_vm._v("Corporate GDPR Statement")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 fw-400"
  }, [_c('p', [_vm._v("\n            In May 2018, the EU\n            "), _c('a', {
    staticClass: "primary--text",
    attrs: {
      "href": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32016R0679",
      "target": "_blank"
    }
  }, [_vm._v("General Data Protection Regulation (GDPR)")]), _vm._v("\n            replaces the existing 1995 EU Data Protection Directive (European Directive 95/46/EC).\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            IOB LLC currently complies with applicable data protection regulations and is committed to GDPR compliance across its relevant services when the GDPR\n            takes effect May 25, 2018. IOB LLC has a dedicated internal team made up of cross-functional stakeholders overseeing IOB LLC’s GDPR readiness. IOB LLC’s\n            ongoing compliance efforts include:\n          ")]), _vm._v(" "), _c('h4', [_c('strong', [_vm._v("Assessment")])]), _vm._v(" "), _c('p', [_vm._v("\n            IOB LLC has reviewed where and how our relevant services collect, use, store and dispose of personal data and has updated policies, standards,\n            governance and documentation where needed. IOB LLC is dedicated to keeping such due diligence current and carrying out re-assessments periodically\n            and/or as required by changed circumstances.\n          ")]), _vm._v(" "), _c('h4', [_c('strong', [_vm._v("Contractual Commitments")])]), _vm._v(" "), _c('p', [_vm._v("\n            Working in conjunction with our partners and customers, IOB LLC is reviewing our contractual commitments and updating as needed to directly address GDPR\n            requirements. IOB LLC has released a Data Processing Addendum (DPA) with provisions to assist our partners and customers with their GDPR compliance.\n          ")]), _vm._v(" "), _c('h4', [_c('strong', [_vm._v("Cross-border Data Transfer")])]), _vm._v(" "), _c('p', [_vm._v("\n            In addition to ensuring IOB LLC’s contractual commitments meet the requirements to legally transfer data from the EU to the rest of the world under\n            applicable law, IOB LLC plans to certify under the EU-US Privacy Shield Framework.\n          ")]), _vm._v(" "), _c('h4', [_c('strong', [_vm._v("Employee Training And Awareness")])]), _vm._v(" "), _c('p', [_vm._v("\n            All IOB LLC employees must complete data privacy and security training. IOB LLC will supplement existing training modules with GDPR-specific content. In\n            addition to these training requirements, IOB LLC conducts ongoing awareness initiatives on a variety of topics, including data protection, security\n          ")]), _vm._v(" "), _c('h4', [_c('strong', [_vm._v("IOB LLC Investors, Partners, and Customers")])]), _vm._v(" "), _c('p', [_vm._v("\n            Compliance with the GDPR requires a partnership between IOB LLC and our partners and customers in their use of applicable IOB LLC services. In this\n            context, IOB LLC generally will act as a data processor and our partners and customers generally will act as data controllers. Working together, we hope\n            to explore opportunities within our relevant service offerings to assist our partners and customers meet their GDPR obligations. In the meantime, IOB\n            LLC encourages partners and customers to independently familiarize themselves with the GDPR.\n          ")])])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "fxt-template-layout10"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-12 fxt-bg-img flex-b",
    attrs: {
      "md6": "",
      "data-bg-image": "../../../static/img/bg14-l.jpg"
    }
  }, [_c('div', {
    staticClass: "fxt-header"
  }, [_c('div', [_c('h1', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.analyst')) + " ")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.paidTitle')))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "col-12 fxt-bg-color",
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "fxt-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLinkDiv),
      expression: "isShowLinkDiv"
    }],
    staticClass: "fxt-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("closeGoogleAuthentication.hint")))]), _vm._v(" "), _c('v-form', {
    ref: "closeAuthenticationForm",
    model: {
      value: (_vm.closeAuthenticationValid),
      callback: function($$v) {
        _vm.closeAuthenticationValid = $$v
      },
      expression: "closeAuthenticationValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "E-mail",
      "required": ""
    },
    model: {
      value: (_vm.closeAuthenticationForm.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.closeAuthenticationForm, "regEmail", $$v)
      },
      expression: "closeAuthenticationForm.regEmail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Secret Key",
      "required": ""
    },
    model: {
      value: (_vm.closeAuthenticationForm.authenticationSecret),
      callback: function($$v) {
        _vm.$set(_vm.closeAuthenticationForm, "authenticationSecret", $$v)
      },
      expression: "closeAuthenticationForm.authenticationSecret"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('header.passwordHint'),
      "rules": _vm.passWordRules,
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.passWord),
      callback: function($$v) {
        _vm.passWord = $$v
      },
      expression: "passWord"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary white--text",
      "disabled": !_vm.closeAuthenticationValid
    },
    on: {
      "click": _vm.closeAuthentication
    }
  }, [_vm._v(_vm._s(_vm.$t("common.submit")))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowLinkDiv),
      expression: "!isShowLinkDiv"
    }],
    staticClass: "mt-5 mb-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("activation.valid")))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-5 fw-bold primary--text",
    attrs: {
      "round": "",
      "flat": "",
      "outline": ""
    },
    on: {
      "click": _vm.goHomePage
    }
  }, [_vm._v(_vm._s(_vm.$t("page404.homepageButton")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fxt-footer"
  }, [_c('ul', {
    staticClass: "fxt-socials"
  }, [_c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBots_",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBotsPro",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-linkedin fxt-transformY-50 fxt-transition-delay-9"
  }, [_c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "title": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fab fa-telegram-plane"
  })])])])])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "primary",
    attrs: {
      "id": "content"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "xs": 4,
      "lg": 4
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 6,
      "lg": 8
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "src": ""
    }
  })]), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 6,
      "lg": 3
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 6,
      "lg": 6
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin": "auto",
      "background-color": "#FFFFFF",
      "text-align": "center",
      "border-radius": "6px",
      "box-shadow": "0 3px 4px 0 rgba(0,0,0,0.15)"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "45%",
      "padding": "30px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "Helvetica-Bold",
      "color": "#333333",
      "font-size": "24px",
      "letter-spacing": "0",
      "line-height": "30px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("Log in.")]), _vm._v(" "), _c('Form', {
    ref: "formInline",
    attrs: {
      "model": _vm.formInline,
      "rules": _vm.ruleInline,
      "inline": ""
    }
  }, [_c('FormItem', {
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "prop": "userName"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "size": "large",
      "placeholder": "Username/E-mail"
    },
    on: {
      "on-enter": function($event) {
        return _vm.handleSubmit('formInline')
      }
    },
    model: {
      value: (_vm.formInline.userName),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "userName", $$v)
      },
      expression: "formInline.userName"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "ios-person-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "prop": "passWord"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "password",
      "size": "large",
      "placeholder": "Password"
    },
    on: {
      "on-enter": function($event) {
        return _vm.handleSubmit('formInline')
      }
    },
    model: {
      value: (_vm.formInline.passWord),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "passWord", $$v)
      },
      expression: "formInline.passWord"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "ios-locked-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "font-family": "Helvetica",
      "font-size": "12px",
      "color": "#747D82",
      "letter-spacing": "0",
      "line-height": "18px"
    },
    model: {
      value: (_vm.isSaveUser),
      callback: function($$v) {
        _vm.isSaveUser = $$v
      },
      expression: "isSaveUser"
    }
  }, [_vm._v("Remember me")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Helvetica",
      "font-size": "12px",
      "color": "#41B8BC",
      "letter-spacing": "0",
      "line-height": "18px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.findPassword
    }
  }, [_vm._v("Forgot password?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('FormItem', [_c('Button', {
    staticStyle: {
      "width": "200px",
      "background": "#41B8BC",
      "margin-top": "6px"
    },
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formInline')
      }
    }
  }, [(!_vm.loading) ? _c('span', {
    staticStyle: {
      "font-family": "Helvetica",
      "font-size": "12px",
      "color": "#FFFFFF",
      "line-height": "12px"
    }
  }, [_vm._v("LOGIN")]) : _c('span', {
    staticStyle: {
      "font-family": "Helvetica",
      "font-size": "12px",
      "color": "#FFFFFF",
      "line-height": "12px"
    }
  }, [_vm._v("LOGIN...")])])], 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Helvetica",
      "font-size": "12px",
      "color": "#747D82",
      "letter-spacing": "0",
      "line-height": "18px"
    }
  }, [_vm._v("Don’t have an account?")]), _vm._v("     \n                            "), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Helvetica",
      "font-size": "12px",
      "color": "#41B8BC",
      "letter-spacing": "0",
      "line-height": "18px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.gotoRegister
    }
  }, [_vm._v("Sign up")])], 1)])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 2,
      "lg": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('Modal', {
    attrs: {
      "title": "Enter Two-factor Authentication Code",
      "align": "center",
      "loading": _vm.authLoading
    },
    model: {
      value: (_vm.loginAuthenticationModal),
      callback: function($$v) {
        _vm.loginAuthenticationModal = $$v
      },
      expression: "loginAuthenticationModal"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Enter the code generated by your Google Authenticator app.")]), _vm._v(" "), _c('Form', {
    ref: "formAuthentication",
    attrs: {
      "model": _vm.formAuthentication,
      "rules": _vm.ruleAuthentication,
      "inline": ""
    }
  }, [_c('FormItem', {
    staticStyle: {
      "margin-top": "6px",
      "width": "200px"
    },
    attrs: {
      "prop": "randomCode"
    }
  }, [_c('Input', {
    staticClass: "juzhong",
    staticStyle: {
      "width": "100px",
      "height": "30px",
      "text-align": "center",
      "margin-top": "20PX"
    },
    attrs: {
      "type": "text",
      "placeholder": "000000",
      "size": "large",
      "maxlength": 6
    },
    model: {
      value: (_vm.formAuthentication.randomCode),
      callback: function($$v) {
        _vm.$set(_vm.formAuthentication, "randomCode", $$v)
      },
      expression: "formAuthentication.randomCode"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "authenticationSecret"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formAuthentication.authenticationSecret),
      expression: "formAuthentication.authenticationSecret"
    }],
    attrs: {
      "type": "hidden",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formAuthentication.authenticationSecret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formAuthentication, "authenticationSecret", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Please contact our "), _c('a', {
    attrs: {
      "href": "####"
    }
  }, [_vm._v("customer service")]), _vm._v(" if you've lost access to your Google Authenticator app.")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.modalCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.submitRandomCode('formAuthentication')
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticStyle: {
      "height": "680px",
      "overflow": "auto"
    }
  }, [_c('Row', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('app-left')], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none"
    }
  }, [_vm._l((_vm.projectList), function(project, index) {
    return _c('li', {
      staticClass: "project"
    }, [_vm._l((_vm.userDetailList), function(userDetail, index) {
      return (project.creatorId == userDetail.userId) ? _c('p', [_c('Row', [_c('Col', {
        attrs: {
          "span": "4"
        }
      }, [_c('span', {
        on: {
          "click": function($event) {
            return _vm.userInformation(userDetail.userId)
          }
        }
      }, [_c('a', [_vm._v(_vm._s(userDetail.nickName))])])]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "6"
        }
      }, [_c('span', {
        on: {
          "click": function($event) {
            return _vm.projectDetail(project.projectId, userDetail.userId)
          }
        }
      }, [_c('a', [_vm._v(_vm._s(project.projectName))])])]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "2"
        }
      }, [_vm._v("\n                                        " + _vm._s(_vm.dateFormat(project.creationTime)) + "\n                                    ")])], 1)], 1) : _vm._e()
    }), _vm._v(" "), _c('Row', [_c('Col', {
      attrs: {
        "span": "4"
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "10"
      }
    }, [_vm._v(_vm._s(project.projectDesc))])], 1)], 2)
  }), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.isLoading) ? _c('Button', {
    attrs: {
      "type": "text",
      "loading": ""
    }
  }, [_vm._v("loading...")]) : _vm._e(), _vm._v(" "), (_vm.isNoMoreData) ? _c('Button', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v("no more data")]) : _vm._e()], 1)], 2)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('div', {
    staticClass: "postmiddle-right",
    staticStyle: {
      "background-color": "white",
      "margin": "0px auto",
      "text-align": "center"
    }
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none",
      "font-size": "16px"
    }
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.createProject
    }
  }, [_vm._v("创建项目")])])])])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-5": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "xs12": "",
      "md12": "",
      "lg8": "",
      "pa-0": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-center font-24 fw-700",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_vm._v("\r\n                                " + _vm._s(_vm.$t("enableAuthentication.title")) + "\r\n                            ")])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "font-16",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('span', {
    staticClass: "fw-400 primary--text"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.step1")) + "\r\n                                ")]), _vm._v(" "), _c('span', [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.step1Msg")) + "\r\n                                ")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "ml-5",
    attrs: {
      "xs4": "",
      "lg2": ""
    }
  }, [_c('div', {
    staticClass: "google-authentication-icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(87)
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "lg10": ""
    }
  }, [_c('div', {
    staticClass: "links"
  }, [_c('p', [_vm._v("\r\n                                        IOS "), _c('a', {
    staticClass: "primary--text",
    attrs: {
      "href": "https://itunes.apple.com/cn/app/google-authenticator/id388497605",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("enableAuthentication.download")))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                                        Android "), _c('a', {
    staticClass: "primary--text",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("enableAuthentication.download")))])])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "font-16",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('span', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("\r\n                                   " + _vm._s(_vm.$t("enableAuthentication.step2")) + " \r\n                                ")]), _vm._v(" "), _c('span', [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.step2Msg")) + "\r\n                                ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-5",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('canvas', {
    attrs: {
      "id": "canvas",
      "width": "160px",
      "height": "160px;"
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "font-16",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('span', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("\r\n                                   " + _vm._s(_vm.$t("enableAuthentication.step3")) + " \r\n                                ")]), _vm._v(" "), _c('span', [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.step3Msg")) + "\r\n                                ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "authentication-secret-key primary--text ml-5"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.formCustom.authenticationSecret) + "   \r\n                                    "), _c('Icon', {
    staticClass: "secretKey",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "ios-copy-outline",
      "size": "20",
      "title": "Copy",
      "data-clipboard-text": this.formCustom.authenticationSecret,
      "color": "#41B8BC"
    },
    on: {
      "click": _vm.copySecretKey
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "font-14 mt-3"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.restoreMsg")) + "\r\n                                ")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "font-16",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('span', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.step4")) + "\r\n                                ")]), _vm._v(" "), _c('span', [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.step4Msg")) + "\r\n                                ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('v-form', {
    ref: "formCustom",
    staticClass: "ml-5"
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "enter-verify-code",
      "counter": 6,
      "rules": _vm.randomCodeRules,
      "single-line": "",
      "outline": ""
    },
    model: {
      value: (_vm.formCustom.randomCode),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "randomCode", $$v)
      },
      expression: "formCustom.randomCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "medium": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.verityRandomCode('formCustom')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.verify")))])], 1), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.formCustom.id),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "id", $$v)
      },
      expression: "formCustom.id"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.formCustom.authenticationSecret),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "authenticationSecret", $$v)
      },
      expression: "formCustom.authenticationSecret"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "fxt-template-layout10"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-12 fxt-bg-img",
    attrs: {
      "md6": "",
      "data-bg-image": "../../../static/img/bg14-l.jpg"
    }
  }, [_c('div', {
    staticClass: "fxt-header"
  }, [_c('div', [_c('h1', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.analyst')) + " ")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.paidTitle')))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "col-12 fxt-bg-color",
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "fxt-content"
  }, [_c('div', {
    staticClass: "fxt-form fxt-footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLink),
      expression: "isShowLink"
    }]
  }, [_c('h2', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("activation.hint")))]), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "flat": "",
      "medium": "",
      "color": "primary"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.$t("activation.link")))])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMessage),
      expression: "isShowMessage"
    }]
  }, [_c('div', {
    staticClass: "mb-3 font-14"
  }, [_vm._v(_vm._s(_vm.$t("activation.valid")))]), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "medium": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(_vm._s(_vm.$t("allPage.homepage")))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "fxt-footer"
  }, [_c('ul', {
    staticClass: "fxt-socials"
  }, [_c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBots_",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBotsPro",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-linkedin fxt-transformY-50 fxt-transition-delay-9"
  }, [_c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "title": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fab fa-telegram-plane"
  })])])])])])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "mt-5": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg7": ""
    }
  }, [_c('v-form', {
    ref: "kycForm",
    model: {
      value: (_vm.kycFormValid),
      callback: function($$v) {
        _vm.kycFormValid = $$v
      },
      expression: "kycFormValid"
    }
  }, [_c('v-card', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.identity')))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('kyc.identity'),
      "items": _vm.identitySelect,
      "rules": _vm.identityRules,
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: (_vm.kycForm.identity),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "identity", $$v)
      },
      expression: "kycForm.identity"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.documentIssuingCountry')))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('kyc.country'),
      "items": _vm.countrySelect,
      "rules": _vm.countryRules,
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: (_vm.kycForm.country),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "country", $$v)
      },
      expression: "kycForm.country"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.proofOfPermanentAddress')))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('kyc.proofOfPermanentAddress'),
      "items": _vm.proofOfPermanentAddressSelect,
      "rules": _vm.proofOfPermanentAddressRules,
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: (_vm.kycForm.proofOfPermanentAddress),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "proofOfPermanentAddress", $$v)
      },
      expression: "kycForm.proofOfPermanentAddress"
    }
  })], 1)]), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.basicInformation')))]), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('kyc.username'),
      "readonly": "",
      "disabled": ""
    },
    model: {
      value: (_vm.user.userName),
      callback: function($$v) {
        _vm.$set(_vm.user, "userName", $$v)
      },
      expression: "user.userName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "readonly": "",
      "disabled": ""
    },
    model: {
      value: (_vm.user.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.user, "regEmail", $$v)
      },
      expression: "user.regEmail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.firstNameRules,
      "label": _vm.$t('kyc.firstName'),
      "required": ""
    },
    model: {
      value: (_vm.kycForm.firstName),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "firstName", $$v)
      },
      expression: "kycForm.firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('kyc.middleName')
    },
    model: {
      value: (_vm.kycForm.middleName),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "middleName", $$v)
      },
      expression: "kycForm.middleName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.lastNameRules,
      "label": _vm.$t('kyc.lastName'),
      "required": ""
    },
    model: {
      value: (_vm.kycForm.lastName),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "lastName", $$v)
      },
      expression: "kycForm.lastName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.numberRules,
      "label": _vm.$t('kyc.documentNumber'),
      "required": ""
    },
    model: {
      value: (_vm.kycForm.number),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "number", $$v)
      },
      expression: "kycForm.number"
    }
  }), _vm._v(" "), _c('v-dialog', {
    ref: "birthdayDialog",
    attrs: {
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.birthdayModal),
      callback: function($$v) {
        _vm.birthdayModal = $$v
      },
      expression: "birthdayModal"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "rules": _vm.birthdayRules,
      "label": _vm.$t('kyc.birthday'),
      "readonly": "",
      "clearable": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.kycForm.birthday),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "birthday", $$v)
      },
      expression: "kycForm.birthday"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "header-color": "primary",
      "color": "primary",
      "max": new Date().toISOString().substr(0, 10)
    },
    on: {
      "input": function($event) {
        _vm.birthdayModal = false
      }
    },
    model: {
      value: (_vm.birthdayFormatted),
      callback: function($$v) {
        _vm.birthdayFormatted = $$v
      },
      expression: "birthdayFormatted"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('kyc.gender.gender'),
      "items": _vm.genderSelect,
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: (_vm.kycForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "gender", $$v)
      },
      expression: "kycForm.gender"
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-layout', {
    staticClass: "pa-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.documentFront')))])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.documentImageFrontUrl == null),
      expression: "documentImageFrontUrl == null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('Upload', {
    staticClass: "black--text",
    attrs: {
      "type": "drag",
      "enctype": "multipart/form-data",
      "name": "upfile",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "before-upload": _vm.documentImageFrontBeforeUpload
    }
  }, [_c('Icon', {
    staticClass: "primary--text",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "50"
    }
  }), _vm._v(" "), (_vm.documentImageFrontFile != null) ? _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadFile")) + ": " + _vm._s(_vm.documentImageFrontFile.name))]) : _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadHint")))])], 1), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDocumentImageFrontUploading),
      expression: "isShowDocumentImageFrontUploading"
    }],
    attrs: {
      "color": "primary",
      "indeterminate": true
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.documentImageFrontUrl != null),
      expression: "documentImageFrontUrl != null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.documentImageFrontUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    staticClass: "right primary--text mt-3",
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.clearDocumentImageFrontFile
    }
  }, [_vm._v("\n\t\t\t\t                            " + _vm._s(_vm.$t("common.clear")) + "\n\t\t\t\t                        ")])], 1)])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-layout', {
    staticClass: "pa-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.documentBack')))])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.documentImageBackUrl == null),
      expression: "documentImageBackUrl == null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('Upload', {
    staticClass: "black--text",
    attrs: {
      "type": "drag",
      "enctype": "multipart/form-data",
      "name": "upfile",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "before-upload": _vm.documentImageBackBeforeUpload
    }
  }, [_c('Icon', {
    staticClass: "primary--text",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "50"
    }
  }), _vm._v(" "), (_vm.documentImageBackFile != null) ? _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadFile")) + ": " + _vm._s(_vm.documentImageBackFile.name))]) : _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadHint")))])], 1), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDocumentImageBackUploading),
      expression: "isShowDocumentImageBackUploading"
    }],
    attrs: {
      "color": "primary",
      "indeterminate": true
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.documentImageBackUrl != null),
      expression: "documentImageBackUrl != null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.documentImageBackUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    staticClass: "right primary--text mt-3",
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.clearDocumentImageBackFile
    }
  }, [_vm._v("\n\t\t\t\t                            " + _vm._s(_vm.$t("common.clear")) + "\n\t\t\t\t                        ")])], 1)])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-layout', {
    staticClass: "pa-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.proofOfBill')))])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.proofImageUrl == null),
      expression: "proofImageUrl == null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('Upload', {
    staticClass: "black--text",
    attrs: {
      "type": "drag",
      "enctype": "multipart/form-data",
      "name": "upfile",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "before-upload": _vm.proofImageBeforeUpload
    }
  }, [_c('Icon', {
    staticClass: "primary--text",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "50"
    }
  }), _vm._v(" "), (_vm.proofImageFile != null) ? _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadFile")) + ": " + _vm._s(_vm.proofImageFile.name))]) : _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadHint")))])], 1), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowProofImageUploading),
      expression: "isShowProofImageUploading"
    }],
    attrs: {
      "color": "primary",
      "indeterminate": true
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.proofImageUrl != null),
      expression: "proofImageUrl != null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.proofImageUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    staticClass: "right primary--text mt-3",
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.clearProofImageFile
    }
  }, [_vm._v("\n\t\t\t\t                            " + _vm._s(_vm.$t("common.clear")) + "\n\t\t\t\t                        ")])], 1)])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.selfieWithPhotoIDAndNote')))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "src": "https://images.iob.community/SIP-test/material/KYC/resource/selfie-example.jpg"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_c('p', {
    staticClass: "font-14 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.selfieMessage')))]), _vm._v(" "), _c('ul', {
    staticClass: "font-14 fw-400"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('kyc.selfieList1')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('kyc.selfieList2')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('kyc.selfieList3')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('kyc.selfieList4')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('kyc.selfieList5')))])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selfieImageUrl == null),
      expression: "selfieImageUrl == null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('Upload', {
    staticClass: "black--text",
    attrs: {
      "type": "drag",
      "enctype": "multipart/form-data",
      "name": "upfile",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "before-upload": _vm.selfieImageBeforeUpload
    }
  }, [_c('Icon', {
    staticClass: "primary--text",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "50"
    }
  }), _vm._v(" "), (_vm.selfieImageFile != null) ? _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadFile")) + ": " + _vm._s(_vm.selfieImageFile.name))]) : _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadHint")))])], 1), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowSelfieImageUploading),
      expression: "isShowSelfieImageUploading"
    }],
    attrs: {
      "color": "primary",
      "indeterminate": true
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selfieImageUrl != null),
      expression: "selfieImageUrl != null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.selfieImageUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    staticClass: "right primary--text mt-3",
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.clearSelfieImageFile
    }
  }, [_vm._v("\n\t\t\t\t\t                            " + _vm._s(_vm.$t("common.clear")) + "\n\t\t\t\t\t                        ")])], 1)])], 1)], 1)]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text right mt-5 mb-5",
    attrs: {
      "outline": "",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submitUserKycHandle
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("common.submit")) + "\n                        ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.hideBlock
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "profile-head"
  }, [_c('div', {
    staticClass: "profile-top",
    style: ({
      backgroundImage: 'url(' + _vm.userDetail.coverImage + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-bottom"
  }, [_c('div', {
    staticClass: "user-image text-xs-center mb-3"
  }, [_c('Tooltip', {
    attrs: {
      "content": '@' + _vm.userDetail.userName,
      "placement": "right-end"
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "primary pointer",
      "size": "100"
    },
    on: {
      "click": function($event) {
        return _vm.openNewWindowViewImage(_vm.userDetail.image)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image != null),
      expression: "userDetail.image != null"
    }],
    attrs: {
      "src": _vm.userDetail.image,
      "alt": _vm.userDetail.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image == null),
      expression: "userDetail.image == null"
    }],
    staticClass: "font-50 white--text"
  }, [_vm._v("\n                                                " + _vm._s(_vm.userDetail.userName != null ? _vm.userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                            ")])])], 1), _vm._v(" "), _c('Modal', {
    model: {
      value: (_vm.isShowViewImageModal),
      callback: function($$v) {
        _vm.isShowViewImageModal = $$v
      },
      expression: "isShowViewImageModal"
    }
  }, [_c('p', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.userDetail.image
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-list-content mb-5"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('h3', {
    staticClass: "fw-700"
  }, [_vm._v(_vm._s(_vm.userDetail.nickName) + " (" + _vm._s(_vm.userDetail.reputationScore) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 fw-500 mt-3"
  }, [_c('span', {
    staticClass: "mx-3"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-at")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.userDetail.userName))])], 1), _vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-calendar-alt")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.regTimeFormat(_vm.userDetail.regTime)))])], 1)])])])])])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mb-5": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "inbox-sidebar",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": "",
      "lg3": "",
      "xl2": ""
    }
  }, [_c('div', {
    staticClass: "inbox-head"
  }, [_c('div', {
    staticClass: "mailbox-items-warp"
  }, [_c('div', {
    staticClass: "app-card"
  }, [_c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.getMenuData('following')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("group_add")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("follow.following")) + "(" + _vm._s(_vm.followingNum) + ")\n                                                    ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.getMenuData('followers')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("group")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("follow.followers")) + "(" + _vm._s(_vm.followerNum) + ")\n                                                    ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "d-none",
    on: {
      "click": function($event) {
        return _vm.getMenuData('referrals')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("accessibility")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("follow.referrals")) + "(" + _vm._s(_vm.userDetail.invitationNumber) + ")\n                                                    ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "d-none",
    on: {
      "click": function($event) {
        return _vm.getMenuData('collections')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa fa-star")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("follow.collections")) + "(" + _vm._s(_vm.totalPostingNum) + ")\n                                                    ")])], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "inbox-content",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('div', {
    staticClass: "inbox-content-wrap"
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowFollowing),
      expression: "isShowFollowing"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "pt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.followingList), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "mr-3 mb-3 app-card"
    }, [_c('div', {
      staticClass: "text-xs-center follow-w mb-3 mt-2 profile-card-bg",
      style: ({
        backgroundImage: 'url(' + user.coverImage + ')'
      })
    }, [_c('v-avatar', {
      staticClass: "pointer mt-4",
      attrs: {
        "color": "primary",
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image != null),
        expression: "user.image != null"
      }],
      attrs: {
        "src": user.image,
        "alt": user.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image == null),
        expression: "user.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v("\n                                                          " + _vm._s(user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                                        ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "user-list-content"
    }, [_c('div', {
      staticClass: "text-xs-center pt-2"
    }, [_c('h4', {
      staticClass: "fw-bold pointer",
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_vm._v(_vm._s(user.nickName))]), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(user.userName))])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs-center mb-2"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.userId != _vm.userId),
        expression: "user.userId != userId"
      }]
    }, [_c('v-btn', {
      staticClass: "primary",
      attrs: {
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.following(user.userId)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? true : false),
        expression: "user.status == '1' ? true : false"
      }]
    }, [_vm._v("\n                                                                    " + _vm._s(_vm.$t("common.unfollow")) + "\n                                                                ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? false : true),
        expression: "user.status == '1' ? false : true"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "plus-round",
        "color": "#FFFFFF"
      }
    }), _vm._v("\n                                                                    " + _vm._s(_vm.$t("common.follow")) + "\n                                                                ")], 1)])], 1)])])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowFollowers),
      expression: "isShowFollowers"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "pt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.followerList), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "mr-3 mb-3 app-card"
    }, [_c('div', {
      staticClass: "text-xs-center follow-w mb-3 mt-2 profile-card-bg",
      style: ({
        backgroundImage: 'url(' + user.coverImage + ')'
      })
    }, [_c('v-avatar', {
      staticClass: "pointer mt-4",
      attrs: {
        "color": "primary",
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image != null),
        expression: "user.image != null"
      }],
      attrs: {
        "src": user.image,
        "alt": user.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image == null),
        expression: "user.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v("\n                                                          " + _vm._s(user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                                        ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "user-list-content"
    }, [_c('div', {
      staticClass: "text-xs-center pt-2"
    }, [_c('h4', {
      staticClass: "fw-bold pointer",
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_vm._v(_vm._s(user.nickName))]), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(user.userName))])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs-center mb-2"
    }, [(user.userId != _vm.userId) ? _c('div', [_c('v-btn', {
      staticClass: "primary",
      attrs: {
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.follower(user.userId)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? true : false),
        expression: "user.status == '1' ? true : false"
      }]
    }, [_vm._v("\n                                                                    " + _vm._s(_vm.$t("common.unfollow")) + "\n                                                                ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? false : true),
        expression: "user.status == '1' ? false : true"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "plus-round",
        "color": "#FFFFFF"
      }
    }), _vm._v("\n                                                                    " + _vm._s(_vm.$t("common.follow")) + "\n                                                                ")], 1)])], 1) : _vm._e()])])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReferrals),
      expression: "isShowReferrals"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "pt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.referralList), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "mr-3 mb-3 app-card"
    }, [_c('div', {
      staticClass: "text-xs-center follow-w mb-3 mt-2 profile-card-bg",
      style: ({
        backgroundImage: 'url(' + user.coverImage + ')'
      })
    }, [_c('v-avatar', {
      staticClass: "pointer mt-4",
      attrs: {
        "color": "primary",
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image != null),
        expression: "user.image != null"
      }],
      attrs: {
        "src": user.image,
        "alt": user.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image == null),
        expression: "user.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v("\n                                                          " + _vm._s(user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                                        ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "user-list-content"
    }, [_c('div', {
      staticClass: "text-xs-center pt-2"
    }, [_c('h4', {
      staticClass: "fw-bold pointer",
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_vm._v(_vm._s(user.nickName))]), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(user.userName))])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs-center mb-2"
    }, [(user.userId != _vm.userId) ? _c('div', [_c('v-btn', {
      staticClass: "primary",
      attrs: {
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.referralFollow(user.userId)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? true : false),
        expression: "user.status == '1' ? true : false"
      }]
    }, [_vm._v("\n                                                                    " + _vm._s(_vm.$t("common.unfollow")) + "\n                                                                ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? false : true),
        expression: "user.status == '1' ? false : true"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "plus-round",
        "color": "#FFFFFF"
      }
    }), _vm._v("\n                                                                    " + _vm._s(_vm.$t("common.follow")) + "\n                                                                ")], 1)])], 1) : _vm._e()])])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCollections),
      expression: "isShowCollections"
    }]
  }, [_vm._l((_vm.postingList), function(posting, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [(posting.postingImg != '') ? _c('span', {
      staticClass: "rounded-circle mr-4 img-responsive posting-image",
      domProps: {
        "innerHTML": _vm._s(posting.postingImg)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h3', {
      staticClass: "fw-bold",
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(posting.postingTitle))])]), _vm._v(" "), _c('p', {
      staticClass: "mb-0"
    }, [(posting.postingContent.length = 0) ? _c('span') : _vm._e(), _vm._v(" "), (posting.postingContent.length < 30) ? _c('span', [_vm._v("\n                                                        " + _vm._s(posting.postingContent) + "\n                                                    ")]) : _c('span', [_vm._v(_vm._s(posting.postingContent) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix mb-4"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_up_alt")]), _c('span', [_vm._v(_vm._s(posting.postingGoodnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_down_alt")]), _c('span', [_vm._v(_vm._s(posting.postingStepnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("fa fa-comment")]), _c('span', [_vm._v(_vm._s(posting.postingCountComments))])], 1)])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postingList.length > 0),
      expression: "postingList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalPostingNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getPostingByPage
    }
  })], 1)], 2)])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "fxt-template-layout10"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-12 fxt-bg-img",
    attrs: {
      "md6": "",
      "data-bg-image": "../../../static/img/bg14-l.jpg"
    }
  }, [_c('div', {
    staticClass: "fxt-header"
  }, [_c('div', [_c('h1', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.analyst')) + " ")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.paidTitle')))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "col-12 fxt-bg-color",
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "fxt-content"
  }, [_c('div', {
    staticClass: "fxt-form fxt-footer"
  }, [_c('h3', {
    staticClass: "fw-bold f-700 mb-3"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("registerSuccess.title")) + "\n                ")]), _vm._v(" "), _c('div', [_vm._v("\n                  " + _vm._s(_vm.$t("registerSuccess.message")) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-btn', {
    attrs: {
      "medium": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(_vm._s(_vm.$t("allPage.homepage")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fxt-footer"
  }, [_c('ul', {
    staticClass: "fxt-socials"
  }, [_c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBots_",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBotsPro",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-linkedin fxt-transformY-50 fxt-transition-delay-9"
  }, [_c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "title": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fab fa-telegram-plane"
  })])])])])])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-5": "",
      "pt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": "",
      "lg9": ""
    }
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "ml-2 mt-2 font-14 fw-400 primary--text",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "lg2": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('userRanking.avatar')) + "\n                                ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "lg3": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('userRanking.nickname')) + "\n                                ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "lg2": ""
    }
  }, [_vm._v("\n                                    IOB Power\n                                ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "lg2": ""
    }
  }, [_vm._v("\n                                    IOB Tokens\n                                ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "lg2": ""
    }
  }, [_vm._v("\n                                    RS\n                                ")])], 1), _vm._v(" "), _vm._l((_vm.userInfoList), function(user, index) {
    return [_c('v-divider'), _vm._v(" "), _c('v-layout', {
      staticClass: "ml-2 font-14 fw-400 pointer",
      attrs: {
        "row": "",
        "align-center": ""
      },
      on: {
        "click": function($event) {
          return _vm.gotoUserData(user.userName)
        }
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "lg2": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "color": "primary pointer",
        "size": "36"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image != null),
        expression: "user.image != null"
      }],
      attrs: {
        "src": user.image,
        "alt": user.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image == null),
        expression: "user.image == null"
      }],
      staticClass: "font-24 white--text"
    }, [_vm._v("\n                                                " + _vm._s(user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                            ")])])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "lg3": ""
      }
    }, [_vm._v("\n                                        " + _vm._s(user.nickName) + "\n                                    ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "lg2": ""
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm._f("NumFormat")(user.iobPower.toFixed(2))) + "\n                                    ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "lg2": ""
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm._f("NumFormat")(user.iobTokens.toFixed(2))) + "\n                                    ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "lg2": ""
      }
    }, [_vm._v("\n                                        " + _vm._s(user.reputationScore) + "\n                                    ")])], 1), _vm._v(" "), _c('v-divider', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    })]
  })], 2), _vm._v(" "), _c('infinite-loading', {
    staticClass: "mt-5 mb-5 fw-400",
    attrs: {
      "identifier": _vm.infiniteId
    },
    on: {
      "infinite": _vm.getUserRanking
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t("posting.noMore")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t("posting.noResults")))])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "1900px"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', [_c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "Select date and time"
    },
    model: {
      value: (_vm.sendTime),
      callback: function($$v) {
        _vm.sendTime = $$v
      },
      expression: "sendTime"
    }
  }), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "disabled": "",
      "placeholder": "Select date and time"
    },
    model: {
      value: (_vm.sendTime1),
      callback: function($$v) {
        _vm.sendTime1 = $$v
      },
      expression: "sendTime1"
    }
  }), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "disabled": "",
      "placeholder": "Select date and time"
    },
    model: {
      value: (_vm.sendTime2),
      callback: function($$v) {
        _vm.sendTime2 = $$v
      },
      expression: "sendTime2"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.getTimeAndPrice
    }
  }, [_vm._v("send")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1800px"
    }
  }, [_c('v-flex', [_c('v-btn', {
    ref: "button",
    attrs: {
      "color": "primary",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.$vuetify.goTo(0)
      }
    }
  }, [_vm._v("scroll")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.hideBlock
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "profile-head"
  }, [_c('div', {
    staticClass: "profile-top",
    style: ({
      backgroundImage: 'url(' + _vm.userDetail.coverImage + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-bottom"
  }, [_c('div', {
    staticClass: "user-image text-xs-center mb-3"
  }, [_c('Tooltip', {
    attrs: {
      "content": '@' + _vm.userDetail.userName,
      "placement": "right-end"
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "primary pointer",
      "size": "100"
    },
    on: {
      "click": function($event) {
        return _vm.openNewWindowViewImage(_vm.userDetail.image)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image != null),
      expression: "userDetail.image != null"
    }],
    attrs: {
      "src": _vm.userDetail.image,
      "alt": _vm.userDetail.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image == null),
      expression: "userDetail.image == null"
    }],
    staticClass: "font-50 white--text"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.userDetail.userName != null ? _vm.userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                                ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "user-list-content mb-5"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('h3', {
    staticClass: "fw-700"
  }, [_vm._v(_vm._s(_vm.userDetail.nickName) + " (" + _vm._s(_vm.userDetail.reputationScore) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 fw-500 mt-3"
  }, [_c('span', {
    staticClass: "mx-3"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-at")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.userDetail.userName))])], 1), _vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-calendar-alt")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.regTimeFormat(_vm.userDetail.regTime)))])], 1)]), _vm._v(" "), (_vm.username != this.$store.state.user.name) ? _c('div', {
    staticClass: "social-list clearfix mb-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": _vm.follow
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFollow),
      expression: "!isFollow"
    }]
  }, [_c('Icon', {
    attrs: {
      "type": "plus-round",
      "color": "#FFFFFF"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("common.follow")))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFollow),
      expression: "isFollow"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("common.unfollow")))])])])], 1) : _vm._e()])])])])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-5": "",
      "mb-5": "",
      "pb-5": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": "",
      "lg3": "",
      "xl2": ""
    }
  }, [_c('div', {
    staticClass: "inbox-head"
  }, [_c('div', {
    staticClass: "mailbox-items-warp"
  }, [_c('div', {
    staticClass: "app-card"
  }, [_c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.getMenuData('wallet')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fas fa-wallet")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("wallet.wallet")) + "\n                                                    ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.getMenuData('transactionRecord')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fas fa-list-alt")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("wallet.transactionRecord")) + "\n                                                    ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.getMenuData('investmentRecord')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fas fa-th-list")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("wallet.investmentRecord")) + "\n                                                    ")])], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "inbox-content",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('div', {
    staticClass: "inbox-content-wrap"
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowWallet),
      expression: "isShowWallet"
    }],
    staticClass: "ml-3 mr-3 mb-5"
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("wallet.wallet")))]), _vm._v(" "), (_vm.userDetail.walletAddress != null && _vm.userDetail.walletAddress != '') ? _c('div', [_c('Row', [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t("wallet.walletAddress")))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_vm._v("\n                                                    " + _vm._s(_vm.userDetail.walletAddress) + "\n                                                ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t("wallet.balance")))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_vm._v("\n                                                    " + _vm._s(_vm.balance / 1000000000000000000) + " IOB (" + _vm._s(_vm.$t("wallet.decimals")) + ": 18)\n                                                ")])], 1)], 1) : _c('div', [_vm._v("\n                                            " + _vm._s(_vm.$t("wallet.walletSetMessage")) + "\n                                            "), _c('br'), _c('br'), _vm._v(" "), _c('Form', {
    ref: "formWallet",
    attrs: {
      "model": _vm.formWallet,
      "rules": _vm.ruleWallet
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "walletAddress"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.formWallet.walletAddress),
      callback: function($$v) {
        _vm.$set(_vm.formWallet, "walletAddress", $$v)
      },
      expression: "formWallet.walletAddress"
    }
  }), _vm._v("   \n                                                "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#41B8BC",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showConfirmWalletModal('formWallet')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.confirm")))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', [_c('Modal', {
    model: {
      value: (_vm.isShowConfirmWalletModal),
      callback: function($$v) {
        _vm.isShowConfirmWalletModal = $$v
      },
      expression: "isShowConfirmWalletModal"
    }
  }, [_c('div', {
    staticClass: "body-2 text-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("wallet.confirmWalletHint")))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.formWallet.walletAddress))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('Button', {
    staticClass: "text-white primary",
    on: {
      "click": function($event) {
        return _vm.showConfirmWalletModal('formWallet')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('Button', {
    staticClass: "text-white primary",
    on: {
      "click": function($event) {
        return _vm.updateWallet('formWallet')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.submit")))])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTransactionRecord),
      expression: "isShowTransactionRecord"
    }]
  }, [_c('h2', {
    staticClass: "fw-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t("wallet.transactionRecord")))]), _vm._v(" "), (_vm.userDetail.walletAddress != null && _vm.userDetail.walletAddress != '') ? _c('div', [_c('v-data-table', {
    staticClass: "elevation-1 mb-5",
    attrs: {
      "headers": _vm.transactionTableHeaders,
      "items": _vm.transactionList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goTransactionData(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goTransactionData(props.item)
            }
          }
        }, [_vm._v(_vm._s((props.item.hash.length) > 18 ? (props.item.hash).substring(0, 18) + '...' : (props.item.hash)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getQuantity(props.item.input)))])]
      }
    }], null, false, 1815811248)
  })], 1) : _c('div', [_vm._v("\n                                            " + _vm._s(_vm.$t("wallet.setWalletMessage")) + "\n                                        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowInvestmentRecord),
      expression: "isShowInvestmentRecord"
    }]
  }, [_c('h2', {
    staticClass: "fw-bold mb-3"
  }, [_vm._v(_vm._s(_vm.$t("wallet.investmentRecord")))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.queryFieldSelect,
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    on: {
      "input": _vm.getInvestment
    },
    model: {
      value: (_vm.queryField),
      callback: function($$v) {
        _vm.queryField = $$v
      },
      expression: "queryField"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investmentList.length <= 0),
      expression: "investmentList.length <= 0"
    }]
  }, [_c('v-flex', [_vm._v(_vm._s(_vm.$t("wallet.noInvestmentMessage")))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investmentList.length > 0),
      expression: "investmentList.length > 0"
    }]
  }, [_c('v-data-table', {
    staticClass: "elevation-1 mb-5",
    attrs: {
      "headers": _vm.investmentTableHeaders,
      "items": _vm.investmentList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goInvestmentData(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goInvestmentData(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.sentTime))]), _vm._v(" "), _c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goInvestmentData(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.purchasingAmount))]), _vm._v(" "), _c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goInvestmentData(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.paymentType))]), _vm._v(" "), _c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goInvestmentData(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.totalIOB))])]
      }
    }])
  })], 1)], 1)])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-2": "",
      "pa-5": ""
    }
  }, [_c('V-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-30"
  }, [_vm._v("Proof of Enquiries & Trades")]), _vm._v(" "), _c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("We Are Transforming The Future of Financial Markets")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-5": ""
    }
  }, [_c('v-container', {
    attrs: {
      "pa-0": "",
      "grid-list-xl": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        See\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                           The unseen\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        Trading charts only display the orders that were filled. What’s happening to the majority of the orders that were placed and canceled, the orders that ARE moving the market? Now you see them.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        True\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                           Market Intelligence\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        The prices flickering on your computer screen do not tell you the whole story of what is happening in the market. Far from it. It is just a very small tip of the iceberg. It often is what you do not see that will hurt you.\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_vm._v("\n                                        If your analysis is only based on the small available final prints of the filled trades, you have been missing 90% of the whole story of the market. Let’s look below the tip of the iceberg!\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Why bother\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                        with the canceled orders?\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        The majority of the orders were never filled or never intended to be filled. But they are the ones that truly move the market and the prices that are disclosed to the public.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Promoting\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                           An Industry-wide Fair Trading Practice\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                       Through the IOB PoET smart contracts, every order that occurred on the network is recorded automatically on the distributed public ledger, regardless whether it is filled or not.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Preventing\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                        Price Spoofing\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        Spoofing is a disruptive algorithmic trading entity employed by traders to outpace other market participants and to manipulate financial markets.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Proof of All Enquiries\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                        PoET Addresses The Spoofing Problem\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        Recording all orders sent, not only the small fraction of executed orders. Every time an order is sent, it records its wallet address, time (accurate to a nanosecond), quantity, price, instrument, account/wallet ID, exchange(s) it was sent to.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Preventing\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                        Front Running\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                       Front-running is the prohibited practice of entering into an order to capitalize on an advance, nonpublic knowledge of a large pending transaction that will influence the price of the underlying security. This is considered a form of market manipulation in many markets.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Proof of All Trades\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                        Every Trade on An Immutable Distributed Public Ledger\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                       PoET records all transactions occurred on the network on an immutable public ledger. Every time an order is executed, it records its wallet address, time (accurate to a nanosecond), quantity, price, instrument, account/wallet ID, and exchange(s).\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 pb-2",
    attrs: {
      "hover": "",
      "height": "325px"
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text d-flex"
  }, [_vm._v("\n                                        Protocol\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font-italic py-0 font-14"
  }, [_vm._v("\n                                        A market transparency protocol\n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                       The market is often manipulated by the unfilled orders.\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_vm._v("\n                                       As regulation in the traditional financial markets is tightening the control of various market manipulations, IOB proposes a DLT solution to record every price and order enquiry ever sent – whether filled or not – and every trade ever executed on an immutable distributed public ledger, the IOB Proof of Enquiries & Trades (PoET) protocol.\n                                    ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": "",
      "mt-5": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "mx-3 mb-0 mt-2"
  }, [_vm._v("\n                                        IOB LLC offers market fraud detection products and services (IOB Analytics), coupled with automated trading systems through its structured market data (PoET), a social investment platform (SiP), and trader-generated data integration.Separate products are provided to address the needs of both professional traders (TCS) and Millennial/Gen Z traders (ioBots).\n                                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-right mt-0"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": _vm.goUserRequest
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-lg-right",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": "",
      "mt-5": ""
    }
  }, [_c('div', [_c('a', {
    attrs: {
      "href": _vm.domainName
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey",
      "size": "20"
    }
  }, [_vm._v("arrow_back")])], 1)])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', [_c('v-toolbar-title', {
    staticClass: "text-xs-center"
  }, [_c('v-text-field', {
    staticClass: "mt-2 pl-2",
    attrs: {
      "label": _vm.$t('userSearch.label')
    },
    on: {
      "change": _vm.searchUser
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.searchUser
    }
  }, [_c('v-icon', [_vm._v("search")])], 1)], 1), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-tab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNoData),
      expression: "isNoData"
    }]
  }, [_vm._v(_vm._s(_vm.$t('userSearch.noDataText')))]), _vm._v(" "), _c('v-tab-item', [_c('v-list', _vm._l((_vm.userDtoList), function(userDto) {
    return _c('v-list-tile', {
      key: userDto.id,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(userDto.userName)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      staticClass: "img-responsive rounded-circle posting-img",
      attrs: {
        "src": userDto.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "aquamarine--text",
      domProps: {
        "innerHTML": _vm._s(userDto.userName)
      }
    }), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(userDto.regEmail)
      }
    })], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "mt-7": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg7": "",
      "sm12": ""
    }
  }, [_c('h1', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("lostGoogleAuthentication.lostAccessApp")))]), _vm._v(" "), _c('p', {
    staticClass: "font-lg mt-3"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("lostGoogleAuthentication.lostSecretkey")) + "\n                        ")]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLostHintMessage),
      expression: "isShowLostHintMessage"
    }],
    staticClass: "col-height-auto ml-2 font-lg",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg10": "",
      "sm12": ""
    }
  }, [_c('p', {
    staticClass: "font-1x"
  }, [_vm._v(_vm._s(_vm.$t("lostGoogleAuthentication.submitRequestMessageBefore"))), _c('a', {
    on: {
      "click": _vm.goUserRequest
    }
  }, [_vm._v(_vm._s(_vm.$t("lostGoogleAuthentication.customerService")))]), _vm._v(_vm._s(_vm.$t("lostGoogleAuthentication.submitRequestMessageAfter")))])]), _vm._v(" "), _c('p', {
    staticClass: "font-lg mt-3"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("lostGoogleAuthentication.haveSecretkey")) + "\n                        ")]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowSendEmailForm),
      expression: "isShowSendEmailForm"
    }],
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg10": "",
      "sm12": "",
      "ml-2": ""
    }
  }, [_c('p', {
    staticClass: "font-1x"
  }, [_vm._v(_vm._s(_vm.$t("lostGoogleAuthentication.accepteEmail")))]), _vm._v(" "), _c('v-form', {
    ref: "sendEmailForm",
    model: {
      value: (_vm.sendEmailValid),
      callback: function($$v) {
        _vm.sendEmailValid = $$v
      },
      expression: "sendEmailValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.emailRules,
      "label": _vm.$t('lostGoogleAuthentication.email'),
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.sendEmailForm.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.sendEmailForm, "regEmail", $$v)
      },
      expression: "sendEmailForm.regEmail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.secretRules,
      "counter": 16,
      "label": _vm.$t('lostGoogleAuthentication.secretKey'),
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.sendEmailForm.authenticationSecret),
      callback: function($$v) {
        _vm.$set(_vm.sendEmailForm, "authenticationSecret", $$v)
      },
      expression: "sendEmailForm.authenticationSecret"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "outline": "",
      "disabled": !_vm.sendEmailValid
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("common.submit")) + "\n                                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "h-100"
  }, [_c('v-list', {
    staticClass: "pa-1"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin),
      expression: "!isLogin"
    }],
    staticClass: "align-center pointer",
    attrs: {
      "mt-4": ""
    },
    on: {
      "click": _vm.showLoginModal
    }
  }, [_c('v-list-tile-avatar', [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": "",
      "large": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("fas fa-user-circle")])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('a', {
    staticClass: "font-lg"
  }, [_vm._v(_vm._s(_vm.$t('header.login')))])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    staticClass: "align-center pointer",
    attrs: {
      "mt-4": ""
    },
    on: {
      "click": _vm.goUserData
    }
  }, [_c('v-list-tile-avatar', {
    attrs: {
      "color": "primary"
    }
  }, [(_vm.user != null && _vm.user.image != null) ? _c('img', {
    attrs: {
      "src": _vm.user.image
    }
  }) : _c('span', {
    staticClass: "headline white--text"
  }, [_vm._v("\n\t\t\t                " + _vm._s(_vm.user != null ? _vm.user.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n\t\t\t            ")])]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "primary--text"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.user != null ? _vm.user.nickName : '') + "\n\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "ml-2"
  }), _vm._v("\n\t\t\t\t\t\t\t(@" + _vm._s(_vm.user != null ? _vm.user.userName : '') + ")\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    staticClass: "pt-0 Slogan"
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('wallet')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-wallet")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "font-22 primary--text fw-700"
  }, [_vm._v(_vm._s(_vm._f("NumFormat")(((_vm.user != null ? _vm.user.iobPower : 0).toFixed(2)))))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v("IOB Power")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("NumFormat")(((_vm.user != null ? _vm.user.iobTokens : 0).toFixed(2)))))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v("IOB Tokens")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("NumFormat")(((_vm.user != null ? _vm.user.iobPower + _vm.user.iobTokens : 0).toFixed(2)))))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v("USD")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('profile')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("account_box")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.profile')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('signOut')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-sign-out-alt")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.signOut')))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('myFeed')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-rss-square")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('right.myFeed')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('profile')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-comment-alt")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.posts')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('profile')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-comments")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.comments')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('profile')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fa fa-reply")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.replies')))])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0 Slogan"
  }, [_c('v-list-tile', {
    staticClass: "d-none",
    on: {
      "click": function($event) {
        return _vm.routerPage('searchUser')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fa fa-user-plus")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.searchUser')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('userRanking')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-bolt")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.IOBPowerRanking')))])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0"
  }, [_c('v-list-group', [_c('v-list-tile', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("translate")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.language') + _vm.$t('menu.locale')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "ml-5"
  }, [_c('v-radio-group', {
    staticClass: "ml-2",
    model: {
      value: (_vm.languageModel),
      callback: function($$v) {
        _vm.languageModel = $$v
      },
      expression: "languageModel"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "English",
      "value": "en-US"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "ml-5"
  }, [_c('v-radio-group', {
    staticClass: "ml-2",
    model: {
      value: (_vm.languageModel),
      callback: function($$v) {
        _vm.languageModel = $$v
      },
      expression: "languageModel"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "Deutsch",
      "value": "de-DE"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "ml-5"
  }, [_c('v-radio-group', {
    staticClass: "ml-2",
    model: {
      value: (_vm.languageModel),
      callback: function($$v) {
        _vm.languageModel = $$v
      },
      expression: "languageModel"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "Pусский",
      "value": "ru-RU"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "ml-5"
  }, [_c('v-radio-group', {
    staticClass: "ml-2",
    model: {
      value: (_vm.languageModel),
      callback: function($$v) {
        _vm.languageModel = $$v
      },
      expression: "languageModel"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "中文（简体）",
      "value": "zh-CN"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "pt-0 pointer"
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("brightness_4")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.darkTheme')))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary"
    },
    model: {
      value: (_vm.darkModeModel),
      callback: function($$v) {
        _vm.darkModeModel = $$v
      },
      expression: "darkModeModel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0 mb-5"
  }, [_c('v-list-group', [_c('v-list-tile', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-palette")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.style')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', _vm._l((_vm.themes), function(theme) {
    return _c('v-avatar', {
      key: theme.id,
      staticClass: "pointer mr-2",
      attrs: {
        "size": "24",
        "color": theme.bgColor
      },
      on: {
        "click": function($event) {
          return _vm.changeTheme(theme)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-list-tile', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    on: {
      "click": function($event) {
        return _vm.routerPage('userSetting')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fa fa-cog")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('header.settings')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('userRequest')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("message")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.sendFeedback')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "Vuely-toolbar",
    attrs: {
      "width": 250,
      "fixed": "",
      "app": ""
    }
  }, [_c('div', {
    staticClass: "d-custom-flex align-items-center navbar-left"
  }, [_c('div', {
    staticClass: "d-custom-flex ml-0 align-items-center pl-0"
  }, [_c('div', {
    staticClass: "pointer mr-4"
  }, [_c('a', {
    attrs: {
      "href": _vm.domainName
    }
  }, [_c('app-logo')], 1)]), _vm._v(" "), _c('v-menu', {
    staticClass: "quciklink-dropdown",
    attrs: {
      "offset-y": "",
      "origin": "left top",
      "z-index": "99",
      "content-class": "quciklink-dropdown",
      "transition": "slide-y-transition",
      "nudge-left": "30",
      "fixed": ""
    }
  }, [_c('div', {
    staticClass: "m-0 fw-500",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.$t("right.hotTopics")))]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "slot": "activator",
      "color": "primary"
    },
    slot: "activator"
  }, [_vm._v("keyboard_arrow_down")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('v-list', {
    staticClass: "dropdown-list"
  }, [_c('v-list-tile', {
    staticClass: "pointer"
  }, [_c('span', {
    staticClass: "fw-bold font-1x primary--text"
  }, [_vm._v(_vm._s(_vm.$t('right.sort')))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "pointer",
    on: {
      "click": _vm.fingByHot
    }
  }, [_c('span', {
    staticClass: "font-15 fw-400 pointer"
  }, [_c('v-icon', [_vm._v("whatshot")]), _vm._v(" "), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.$t('right.hot')))])], 1)]), _vm._v(" "), _c('v-list-tile', {
    staticClass: "pointer",
    on: {
      "click": _vm.fingByNew
    }
  }, [_c('span', {
    staticClass: "font-15 fw-400 pointer"
  }, [_c('v-icon', [_vm._v("fiber_new")]), _vm._v(" "), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.$t('right.new')))])], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "pointer"
  }, [_c('span', {
    staticClass: "fw-bold font-1x primary--text"
  }, [_vm._v(_vm._s(_vm.$t("right.hotTopics")))])]), _vm._v(" "), _vm._l((_vm.marketsList), function(market) {
    return _c('v-list-tile', {
      key: market.marketId,
      staticClass: "pointer",
      on: {
        "click": function($event) {
          return _vm.findByMarkets(market)
        }
      }
    }, [_c('span', {
      staticClass: "font-15 fw-400 pointer"
    }, [_c('v-icon', {
      attrs: {
        "size": "20"
      }
    }, [_vm._v(_vm._s(market.icon))]), _vm._v(" "), _c('span', {
      staticClass: "ml-3"
    }, [_vm._v(_vm._s(market.name))])], 1)])
  }), _vm._v(" "), _c('v-list-tile', {
    staticClass: "pointer",
    on: {
      "click": _vm.findByTelegramList
    }
  }, [_c('span', {
    staticClass: "font-15 fw-400 pointer"
  }, [_c('v-icon', [_vm._v("fab fa-telegram")]), _vm._v(" "), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v("IOB Telegram")])], 1)])], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "ml-4 upgrade-btn pointer",
    on: {
      "click": _vm.goIobots
    }
  }, [_vm._v("ioBots")]), _vm._v(" "), _c('div', {
    staticClass: "ml-4 upgrade-btn pointer",
    on: {
      "click": _vm.goIobfi
    }
  }, [_vm._v("iob.fi")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-right v-breadcrumbs__item"
  }, [_c('v-btn', {
    staticClass: "full-screen ma-0 mr-2 pointer",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.gotoNewsTopic
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('right.industryNews'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("fas fa-poll-h")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "full-screen ma-0 mr-2 pointer",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.fingByHot
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('header.hot'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("trending_up")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "full-screen ma-0 pointer",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.fingByNew
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('header.new'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("equalizer")])], 1)], 1), _vm._v(" "), _c('span', [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "origin": "left top",
      "z-index": "99",
      "content-class": "notification-dropdown",
      "transition": "slide-y-transition",
      "nudge-top": "-10",
      "nudge-left": "30"
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('header.menu'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("apps")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('v-list', {
    staticClass: "dropdown-list"
  }, [_c('v-list-tile', {
    staticClass: "pl-3 mb-2 mt-2 pointer",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('foot.title'))
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.texts), function(text) {
    return _c('v-list-tile', {
      key: text.name,
      staticClass: "pointer",
      on: {
        "click": function($event) {
          return _vm.routerPage(text.code)
        }
      }
    }, [_c('span', {
      staticClass: "font-16"
    }, [_vm._v(_vm._s(_vm.$t(text.name)))])])
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "mt-1"
  }, [_c('span', {
    staticClass: "font-10"
  }, [_vm._v("IOB LLC © 2019. " + _vm._s(_vm.$t('foot.aLLRightsReserved')))])])], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-badge', {
    staticClass: "notification-dropdown ma-0 pointer font-12",
    attrs: {
      "overlap": ""
    },
    scopedSlots: _vm._u([{
      key: "badge",
      fn: function() {
        return [(_vm.notificationNum > 0) ? _c('span', [_vm._v(_vm._s(_vm.notificationNum))]) : _vm._e()]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.gotoNotification
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('header.notifications'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("far fa-bell")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.showMenuSidebar
    },
    slot: "activator"
  }, [_c('v-avatar', {
    attrs: {
      "color": "primary",
      "size": "30"
    }
  }, [(_vm.user != null && _vm.user.image != null) ? _c('img', {
    attrs: {
      "src": _vm.user.image,
      "alt": _vm.user.userName
    }
  }) : _c('span', {
    staticClass: "headline white--text"
  }, [_vm._v(_vm._s(_vm.user != null ? _vm.user.userName.trim().substring(0, 1).toLocaleUpperCase() : ''))])])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin),
      expression: "!isLogin"
    }],
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.showMenuSidebar
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary",
      "title": "User"
    }
  }, [_vm._v("fas fa-user-circle")])], 1)], 1)]), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "Vuely-sidebar",
    attrs: {
      "hide-overlay": "",
      "fixed": "",
      "right": "",
      "temporary": ""
    },
    model: {
      value: (_vm.isShowMenuSidebar),
      callback: function($$v) {
        _vm.isShowMenuSidebar = $$v
      },
      expression: "isShowMenuSidebar"
    }
  }, [_c('app-menu')], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "chat-sidebar-wrap",
    attrs: {
      "hide-overlay": "",
      "fixed": "",
      "right": "",
      "temporary": ""
    },
    model: {
      value: (_vm.isShowUserSearchSidebar),
      callback: function($$v) {
        _vm.isShowUserSearchSidebar = $$v
      },
      expression: "isShowUserSearchSidebar"
    }
  }, [_c('app-user-search')], 1), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "hide-overlay": "",
      "persistent": ""
    },
    model: {
      value: (_vm.isShowCookieStatement),
      callback: function($$v) {
        _vm.isShowCookieStatement = $$v
      },
      expression: "isShowCookieStatement"
    }
  }, [_c('v-card', {
    staticClass: "text-center"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("header.cookieStatementMessage")) + "\n      "), _c('a', {
    on: {
      "click": _vm.goPrivacy
    }
  }, [_vm._v(_vm._s(_vm.$t("header.privacyPolicy")))]), _vm._v("\n      " + _vm._s(_vm.$t("common.punctuation.period")) + "\n      "), _c('v-btn', {
    attrs: {
      "outline": "",
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.dissmissCookieStatement
    }
  }, [_vm._v(_vm._s(_vm.$t("header.dismiss")))])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    model: {
      value: (this.$store.state.loginModal),
      callback: function($$v) {
        _vm.$set(this.$store.state, "loginModal", $$v)
      },
      expression: "this.$store.state.loginModal"
    }
  }, [_c('v-card', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("header.login")))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "right": "",
      "color": "pink"
    },
    on: {
      "click": _vm.hideLoginModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-form', {
    ref: "formInline",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "enter-login",
    attrs: {
      "label": _vm.$t('header.usernameHint'),
      "rules": _vm.userNameRules,
      "required": ""
    },
    on: {
      "on-enter": _vm.loginAuth_v2
    },
    model: {
      value: (_vm.formInline.userName),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "userName", $$v)
      },
      expression: "formInline.userName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "enter-login",
    attrs: {
      "label": _vm.$t('header.passwordHint'),
      "rules": _vm.passWordRules,
      "type": _vm.isShowPassword ? 'text' : 'password',
      "append-icon": _vm.isShowPassword ? 'visibility_off' : 'visibility',
      "required": ""
    },
    on: {
      "click:append": function($event) {
        _vm.isShowPassword = !_vm.isShowPassword
      }
    },
    model: {
      value: (_vm.formInline.passWord),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "passWord", $$v)
      },
      expression: "formInline.passWord"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary"
    },
    model: {
      value: (_vm.isSaveUser),
      callback: function($$v) {
        _vm.isSaveUser = $$v
      },
      expression: "isSaveUser"
    }
  }, [_c('div', {
    staticClass: "ml-2",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('header.rememberMe')) + "\n                      "), _c('span', {
    attrs: {
      "color": "primary--text",
      "right": ""
    },
    on: {
      "click": _vm.goPassword
    }
  }, [_c('span', {
    staticClass: "ml-5"
  }, [_vm._v(_vm._s(_vm.$t("header.forgotPassword")))]), _vm._v("?\n                      ")])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": "",
      "loading": _vm.loading,
      "dark": ""
    },
    on: {
      "click": _vm.loginAuth_v2
    }
  }, [_vm._v(_vm._s(_vm.$t("header.login")))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$t("header.accountHint")) + "?")]), _vm._v(" "), _c('span', {
    staticClass: "caption primary--text pointer",
    on: {
      "click": _vm.gotoRegister
    }
  }, [_vm._v(_vm._s(_vm.$t("header.signUp")))])])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('Modal', {
    attrs: {
      "align": "center",
      "loading": _vm.authLoading,
      "mask-closable": false
    },
    model: {
      value: (_vm.loginAuthenticationModal),
      callback: function($$v) {
        _vm.loginAuthenticationModal = $$v
      },
      expression: "loginAuthenticationModal"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "Helvetica-Bold",
      "color": "#333333",
      "font-size": "20px",
      "letter-spacing": "0",
      "line-height": "30px",
      "height": "40px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("header.googleModalTitle")))]), _vm._v(" "), _c('label', {
    staticClass: "font-1x"
  }, [_vm._v(_vm._s(_vm.$t("header.googleModalEnterHint")))]), _vm._v(" "), _c('v-form', {
    ref: "formAuthentication",
    staticClass: "mt-4 mb-4"
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    staticClass: "enter-code-login",
    attrs: {
      "counter": 6,
      "rules": _vm.randomCodeRules,
      "single-line": "",
      "outline": ""
    },
    model: {
      value: (_vm.formAuthentication.randomCode),
      callback: function($$v) {
        _vm.$set(_vm.formAuthentication, "randomCode", $$v)
      },
      expression: "formAuthentication.randomCode"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.formAuthentication.authenticationSecret),
      callback: function($$v) {
        _vm.$set(_vm.formAuthentication, "authenticationSecret", $$v)
      },
      expression: "formAuthentication.authenticationSecret"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "font-1x"
  }, [_vm._v(_vm._s(_vm.$t("header.googleModalContactHintBefore")))]), _vm._v(" "), _c('label', {
    staticClass: "font-1x primary--text pointer",
    on: {
      "click": _vm.goLostGoogleAuthentication
    }
  }, [_vm._v(_vm._s(_vm.$t("header.googleModalContactHintMiddle")))]), _vm._v(" "), _c('label', {
    staticClass: "font-1x"
  }, [_vm._v(_vm._s(_vm.$t("header.googleModalContactHintAfter")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('Button', {
    staticClass: "primary",
    on: {
      "click": _vm.modalCancel
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))])]), _vm._v(" "), _c('Button', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.verityRandomCode('formAuthentication')
      }
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.$t("common.verify")))])])], 1)], 1)], 1), _vm._v(" "), (!_vm.isLogin) ? _c('div', {
    staticClass: "welcomeWrapper mb-2"
  }, [_c('div', {
    staticClass: "welcomeBanner"
  }, [_c('div', {
    staticClass: "row primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "show-for-large"
  }), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 welcomePitch"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('header.analyst')))]), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('header.paidTitle'))
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "black--text pa-0",
    attrs: {
      "small": "",
      "color": "white"
    },
    on: {
      "click": _vm.gotoRegister
    }
  }, [_vm._v(_vm._s(_vm.$t('register.signUp')))])], 1), _vm._v(" "), _vm._m(1)])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center welcomeImage small-12 show-for-small-only"
  }, [_c('img', {
    staticClass: "heroImage",
    attrs: {
      "src": __webpack_require__(86)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center welcomeImage medium-6 show-for-medium"
  }, [_c('img', {
    staticClass: "heroImage",
    attrs: {
      "src": __webpack_require__(86)
    }
  })])
}]}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "mb-150"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-7 app-card w-85"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg7": "",
      "sm12": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMicroArticleLoading),
      expression: "isShowMicroArticleLoading"
    }],
    staticClass: "mt-7 text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "aquamarine"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowMicroArticleLoading),
      expression: "!isShowMicroArticleLoading"
    }],
    staticClass: "mt-7 app-card"
  }, [_c('div', {
    staticClass: "pa-5 display-1"
  }, [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "size": "60"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.microArticle.userName)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.microArticle.image
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-3 font-lg pointer hover-color",
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.microArticle.userName)
      }
    }
  }, [_vm._v(_vm._s(_vm.microArticle.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "ml-3 font-lg"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.microArticle.time)))]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 font-md"
  }, [_vm._v("\n                                " + _vm._s(_vm.microArticle.content) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 font-sm right"
  }, [_c('v-icon', {
    class: {
      'aquamarine--text': _vm.isUpvote
    },
    attrs: {
      "small": "",
      "title": _vm.$t('posting.upvote')
    },
    on: {
      "click": function($event) {
        return _vm.voteMicroArticle(_vm.microArticle, '0')
      }
    }
  }, [_vm._v("thumb_up")]), _vm._v("\n                                    " + _vm._s(_vm.microArticle.upvoteCount) + "\n                                "), _vm._v(" "), _c('v-icon', {
    staticClass: "ml-3",
    attrs: {
      "small": "",
      "title": _vm.$t('posting.comment')
    },
    on: {
      "click": _vm.showCommentForm
    }
  }, [_vm._v("fa fa-comment")]), _vm._v("\n                                    " + _vm._s(_vm.microArticle.commentCount) + "\n                            ")], 1)], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommentForm),
      expression: "isShowCommentForm"
    }],
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "md1": "",
      "lg1": "",
      "sm1": ""
    }
  }, [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "size": "38"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.loginUserName)
      }
    }
  }, [_c('img', {
    staticClass: "img-responsive rounded-circle user-img",
    attrs: {
      "alt": _vm.loginUserName,
      "src": this.$store.state.user.image
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": "",
      "lg10": "",
      "sm10": ""
    }
  }, [_c('v-form', {
    ref: "commentForm",
    model: {
      value: (_vm.commentVaild),
      callback: function($$v) {
        _vm.commentVaild = $$v
      },
      expression: "commentVaild"
    }
  }, [_c('v-textarea', {
    attrs: {
      "color": "aquamarine",
      "rules": _vm.commentContentRules,
      "auto-grow": "",
      "required": "",
      "outline": ""
    },
    model: {
      value: (_vm.commentForm.content),
      callback: function($$v) {
        _vm.$set(_vm.commentForm, "content", $$v)
      },
      expression: "commentForm.content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "dark": "",
      "color": "aquamarine",
      "disabled": !_vm.commentVaild,
      "loading": _vm.submitBtnLoading
    },
    on: {
      "click": _vm.commentMicroArticle
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t("common.submit")) + "\n                                        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "dark": "",
      "color": "aquamarine"
    },
    on: {
      "click": function($event) {
        _vm.isShowCommentForm = !_vm.isShowCommentForm
      }
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t("common.cancel")) + "\n                                        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-5 mt-5"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommentLoading),
      expression: "isShowCommentLoading"
    }],
    staticClass: "text-center"
  }, [_c('v-progress-circular', {
    staticClass: "mb-5",
    attrs: {
      "indeterminate": "",
      "color": "aquamarine"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowCommentLoading),
      expression: "!isShowCommentLoading"
    }],
    staticClass: "mb-5 ml-4 mr-4 display-1"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.commentList.length <= 0),
      expression: "commentList.length <= 0"
    }],
    staticClass: "font-1x text-center"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("microArticle.no")) + "\n                                "), _c('a', {
    on: {
      "click": _vm.showCommentForm
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("microArticle.comments")) + "\n                                ")]), _vm._v("\n                                " + _vm._s(_vm.$t("microArticle.yet")) + "\n                            ")]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.commentList.length > 0),
      expression: "commentList.length > 0"
    }]
  }, [_vm._v(_vm._s(_vm.$t("microArticle.comments")))]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_vm._l((_vm.commentList), function(comment, index) {
    return [_c('div', {
      staticClass: "font-1x"
    }, [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "size": "24"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(comment.userName)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": comment.image
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "ml-1 pointer hover-color",
      on: {
        "click": function($event) {
          return _vm.goUserData(comment.userName)
        }
      }
    }, [_vm._v(_vm._s(comment.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "fw-bold"
    }, [_vm._v("·")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(comment.time)))]), _vm._v(" "), _c('div', {
      staticClass: "ml-5",
      domProps: {
        "innerHTML": _vm._s(comment.content)
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ml-5 font-1x"
    }, [_c('v-icon', {
      class: {
        'aquamarine--text': comment.isUpvote
      },
      attrs: {
        "small": "",
        "title": _vm.$t('posting.upvote')
      },
      on: {
        "click": function($event) {
          return _vm.voteMicroArticleComment(comment, '0')
        }
      }
    }, [_vm._v("thumb_up")]), _vm._v("\n                                        " + _vm._s(comment.upvoteCount) + "\n                                        "), _c('v-icon', {
      staticClass: "ml-3",
      attrs: {
        "small": "",
        "title": _vm.$t('posting.comment')
      },
      on: {
        "click": function($event) {
          return _vm.showCommentField(comment)
        }
      }
    }, [_vm._v("fa fa-comment")])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (comment.isShowCommentField),
        expression: "comment.isShowCommentField"
      }],
      staticClass: "ml-5"
    }, [_c('v-textarea', {
      attrs: {
        "color": "aquamarine",
        "rules": _vm.commentContentRules,
        "auto-grow": "",
        "required": "",
        "outline": ""
      },
      model: {
        value: (_vm.commentContent),
        callback: function($$v) {
          _vm.commentContent = $$v
        },
        expression: "commentContent"
      }
    }), _vm._v(" "), _c('v-btn', {
      attrs: {
        "dark": "",
        "color": "aquamarine",
        "loading": _vm.submitBtnLoading
      },
      on: {
        "click": function($event) {
          return _vm.commentRootComment(comment)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("common.submit")) + "\n                                        ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "dark": "",
        "color": "aquamarine"
      },
      on: {
        "click": function($event) {
          return _vm.showCommentField(comment)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("common.cancel")) + "\n                                        ")])], 1), _vm._v(" "), _vm._l((comment.secondCommentInfoList), function(secondComment, index) {
      return [_c('div', {
        staticClass: "font-1x ml-5"
      }, [_c('v-avatar', {
        staticClass: "pointer",
        attrs: {
          "size": "24"
        },
        on: {
          "click": function($event) {
            return _vm.goUserData(secondComment.userName)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": secondComment.image
        }
      })]), _vm._v(" "), _c('span', {
        staticClass: "ml-1 pointer hover-color",
        on: {
          "click": function($event) {
            return _vm.goUserData(secondComment.userName)
          }
        }
      }, [_vm._v(_vm._s(secondComment.nickName))]), _vm._v(" "), _c('span', {
        staticClass: "fw-bold"
      }, [_vm._v("·")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(secondComment.time)))]), _vm._v(" "), _c('div', {
        staticClass: "ml-5",
        domProps: {
          "innerHTML": _vm._s(secondComment.content)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "ml-5"
      }, [_c('v-icon', {
        class: {
          'aquamarine--text': secondComment.isUpvote
        },
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.voteMicroArticleComment(secondComment, '0')
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v("\n                                                " + _vm._s(secondComment.upvoteCount) + "\n                                                "), _c('v-icon', {
        staticClass: "ml-3",
        attrs: {
          "small": "",
          "title": _vm.$t('posting.comment')
        },
        on: {
          "click": function($event) {
            return _vm.showCommentField(secondComment)
          }
        }
      }, [_vm._v("fa fa-comment")])], 1)], 1), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (secondComment.isShowCommentField),
          expression: "secondComment.isShowCommentField"
        }],
        staticClass: "ml-5 pl-5"
      }, [_c('v-textarea', {
        attrs: {
          "color": "aquamarine",
          "rules": _vm.commentContentRules,
          "auto-grow": "",
          "required": "",
          "outline": ""
        },
        model: {
          value: (_vm.commentContent),
          callback: function($$v) {
            _vm.commentContent = $$v
          },
          expression: "commentContent"
        }
      }), _vm._v(" "), _c('v-btn', {
        attrs: {
          "dark": "",
          "color": "aquamarine",
          "loading": _vm.submitBtnLoading
        },
        on: {
          "click": function($event) {
            return _vm.commentSecondComment(comment, secondComment)
          }
        }
      }, [_vm._v("\n                                                " + _vm._s(_vm.$t("common.submit")) + "\n                                            ")]), _vm._v(" "), _c('v-btn', {
        attrs: {
          "dark": "",
          "color": "aquamarine"
        },
        on: {
          "click": function($event) {
            return _vm.showCommentField(secondComment)
          }
        }
      }, [_vm._v("\n                                                " + _vm._s(_vm.$t("common.cancel")) + "\n                                            ")])], 1)]
    })]
  })], 2)])], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "session-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "session-right text-xs-center"
  }, [_c('div', {
    staticClass: "session-table-cell"
  }, [_c('div', {
    staticClass: "div-icon mb-3 pointer",
    on: {
      "click": _vm.goHome
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.jpg",
      "width": "78",
      "height": "78"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 mb-3"
  }, [_c('div', {
    staticClass: "font-lg mb-5"
  }, [_vm._v(_vm._s(_vm.$t("activation.valid")))]), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "round": "",
      "flat": "",
      "outline": "",
      "large": "",
      "color": "aquamarine"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("page404.homepageButton")))])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "session-left"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/graphic1.svg"
    }
  })])])
}]}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-card mt-5"
  }, [_c('div', {
    staticStyle: {
      "margin": "0 20px"
    }
  }, [_c('label', {
    staticClass: "mt-3",
    staticStyle: {
      "font-size": "16px",
      "border-bottom": "1px solid  #EEEEEE",
      "display": "block",
      "text-align": "center",
      "height": "30px",
      "line-height": "15px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n            \t" + _vm._s(_vm.$t("left.tags")) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 mb-3"
  }, _vm._l((_vm.tagList), function(tag, index) {
    return _c('Tag', {
      key: tag.tagId,
      staticClass: "body-2",
      attrs: {
        "type": "border",
        "color": "#41B8BC"
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.findtagposting(tag.tagId, tag.tagName)
        }
      }
    }, [_vm._v(_vm._s(tag.tagName))])])
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAll),
      expression: "isShowAll"
    }],
    staticClass: "postmiddle-right mt-3"
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none",
      "font-size": ".8rem",
      "margin-bottom": "20px",
      "text-align": "center"
    }
  }, [_c('li', [_c('span', {
    staticClass: "body-2 ml-1 pointer",
    on: {
      "click": _vm.showAllTag
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("left.showall")))]), _vm._v(" "), _c('v-icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "medium": ""
    }
  }, [_vm._v("keyboard_arrow_down")])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUpward),
      expression: "isShowUpward"
    }],
    staticClass: "postmiddle-right"
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none",
      "font-size": ".8rem",
      "margin-bottom": "20px",
      "text-align": "center"
    }
  }, [_c('li', [_c('span', {
    staticClass: "body-2 ml-1 pointer",
    on: {
      "click": _vm.upwardTag
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("left.Upward")))]), _vm._v(" "), _c('v-icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "medium": ""
    }
  }, [_vm._v("keyboard_arrow_up")])], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('app-header'), _vm._v(" "), _c('div', {
    class: _vm.isLogin ? 'mt-70' : ''
  }), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md7": "",
      "lg10": ""
    }
  }, [_c('div', {
    staticClass: "font-30 fw-700 mb-5 text-center"
  }, [_vm._v("Privacy Statement")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 fw-400"
  }, [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v("\n            IOB LLC is committed to protecting the privacy and accuracy of confidential information to the extent possible, subject to provisions of state and\n            federal law per country and worldwide. If you make use of our services, you state that you have read, understand understood and agreed with our privacy\n            policy.\n          ")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold mb-3"
  }, [_vm._v("We care about your privacy")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("Cookies")])]), _vm._v(" "), _c('p', [_vm._v("\n            If you leave a comment on our site you may opt-in to save your name, email address and website in cookies. These are for your convenience so that you do\n            not have to fill in your details again when you leave another comment. These cookies will last for one year.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            If you have an account and you log in to this site, we will set a temporary cookie to determine if your browser accepts cookies. This cookie contains no\n            personal data and is discarded when you close your browser.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            When you log in, we will also set up several cookies to save your login information and your screen display choices. Login cookies last for two days,\n            and screen options cookies last for a year. If you select “Remember Me”, your login will persist for two weeks. If you log out of your account, the\n            login cookies will be removed.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            If you edit or publish an article, an additional cookie will be saved in your browser. This cookie includes no personal data and simply indicates the\n            post ID of the article you just edited. It expires after 1 day.\n          ")]), _vm._v(" "), _c('p', [_vm._v("IOB makes use of Google Analytics which is a third party cookie that tracks certain information to improve our services.")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("Comments")])]), _vm._v(" "), _c('p', [_vm._v("\n            When visitors leave comments on the site we collect the data shown in the comments form, and also the visitor’s IP address and browser user agent string\n            to help spam detection.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            An anonymized string created from your email address (also called a hash) may be provided to the Gravatar service to see if you are using it. The\n            Gravatar service privacy policy is available here: https://automattic.com/privacy/. After approval of your comment, your profile picture is visible to\n            the public in the context of your comment.\n          ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("Media")])]), _vm._v(" "), _c('p', [_vm._v("\n            If you upload images to the website, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can\n            download and extract any location data from images on the website.\n          ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("The use of data")])]), _vm._v(" "), _c('p', [_vm._v("\n            We do not sell, lease, rent or otherwise disclose your personal data to any third parties. Visitor comments may be checked through an automated spam\n            detection service.\n          ")]), _vm._v(" "), _c('p', [_vm._v("We do use your data for the following reasons:")]), _vm._v(" "), _c('ul', {
    staticClass: "mb-2"
  }, [_c('li', [_vm._v("To comply with the law and governmental requests")]), _vm._v(" "), _c('li', [_vm._v("To prevent fraud")]), _vm._v(" "), _c('li', [_vm._v("To optimize your experience on our website")]), _vm._v(" "), _c('li', [_vm._v("To record and retain your account on the SiP platform")])]), _vm._v(" "), _c('p', [_vm._v("\n            The information can be collected automatic through cookies or filled in by yourself when creating an account. There is information we do not collect\n            such as private keys or wallet seed. Do not trust anyone or any message you receive that are asking for this kind of private information. If something\n            like this occurs on our website please notify us immediately.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can recognize and approve any follow-up comments\n            automatically instead of holding them in a moderation queue.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            For users that register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit, or\n            delete their personal information at any time (except they cannot change their username). Website administrators can also see and edit that information.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            If you have an account on this site or have left comments, you can request to receive an exported file of the personal data we hold about you, including\n            any data you have provided to us. You can also request that we erase any personal data we hold about you. This does not include any data we are obliged\n            to keep for administrative, legal, or security purposes.\n          ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("What happens if the privacy statement changes")])]), _vm._v(" "), _c('p', [_vm._v("\n            This Privacy Statement was last revised on 23-04-2019 April 23rd, 2019. We may change this Privacy Statement at any time and for any reason. We\n            encourage you to review this Privacy Statement each time you visit the website.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            If we decide to make a significant change to our Privacy Statement, we will post a notice on the homepage of our website for a period of time after the\n            change is made.\n          ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("Privacy of third parties")])]), _vm._v(" "), _c('p', [_vm._v("\n            IOB may contain links to other websites. Some of those websites may be operated by third parties. We provide the links for your convenience, but we do\n            not review, control, or monitor the privacy practices of websites operated by others. We are not responsible for the performance of websites operated by\n            third parties or for your business dealings with them. Therefore, whenever you leave this website we recommend that you review each websites’ privacy\n            practices and make your own conclusions regarding the adequacy of these practices.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same\n            way as if the visitor has visited the other website. These websites may collect data about you, use cookies, embed additional third-party tracking, and\n            monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged\n            in to that website.\n          ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("Contact")])]), _vm._v(" "), _c('p', [_vm._v("If you have questions or comments about this Privacy Statement, please use the Contact Form on this website to reach us.")])])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "dark": _vm.darkMode
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.postingcreate
    }
  }, [_c('v-icon', [_vm._v("fas fa-plus")])], 1), _vm._v(" "), _c('div', {
    staticClass: "application",
    attrs: {
      "id": "App",
      "data-app": "true"
    }
  }, [_c('div', {
    staticClass: "application--wrap"
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "h-100"
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    class: _vm.isLogin ? 'mt-70' : ''
  }), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md7": "",
      "lg10": ""
    }
  }, [_c('div', {
    staticClass: "font-30 fw-700 mb-5 text-center"
  }, [_vm._v("KYC")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 fw-400"
  }, [_c('p', [_vm._v("Depending on the functions that you seek to enable on your account and IOB’s risk determination, IOB may, in its discretion, require identity verification and other screening procedures with respect to you or transactions associated with your SiP Account.")]), _vm._v(" "), _c('p', [_vm._v("These verification and screening procedures may include, without limitation, checking the information you provide against the Specially Designated Nationals and Blocked Persons list maintained by the U.S. Office of Foreign Assets Control, the U.S. Department of Commerce Denied Persons list, and any similar list issued by any U.S. governmental authority or any other governmental authority prohibiting or limiting business activities or transactions with any persons.")]), _vm._v(" "), _c('p', [_vm._v("You may be required to provide IOB with certain personal information, including, but not limited to, your name, address, telephone number, email address, date of birth, taxpayer identification number, government identification number, photograph of your government-issued ID or other photographic proof of your identity, and information regarding your bank account.")]), _vm._v(" "), _c('p', [_vm._v("You hereby authorize IOB, directly or through a third party, to make any inquiries IOB considers necessary to verify your identity and/or protect against fraud, including but not limited to: (a) query identity information contained in public reports (e.g., your name, address, past addresses, or date of birth); (b) query account information associated with your linked bank account (e.g., name or account balance); and (c) take action IOB reasonably deems necessary based on the results of such inquiries and reports.")]), _vm._v(" "), _c('p', [_vm._v("You further authorize any and all third parties to which such inquiries or requests may be directed to fully respond to such inquiries or requests. IOB will have no liability or responsibility for any permanent or temporary inability to access or use any Services, including your inability to withdraw Tokens or execute Trades, as a result of any identity verification or other screening procedures.")])])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "pa-5": "",
      "mt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "fill-height": "",
      "mb-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "md10": ""
    }
  }, [_c('div', {
    staticClass: "font-24"
  }, [_vm._v("FAQ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md10": "",
      "mt-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-3 py-3",
    attrs: {
      "flat": ""
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "focusable": ""
    }
  }, [_c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq1')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt1'))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq2')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt2'))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq3')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt3'))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq4')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt4'))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq5')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt5'))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq6')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt6'))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t('faq.faq7')))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faqTxt7'))
    }
  })])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "fxt-template-layout10"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-12 fxt-bg-img",
    attrs: {
      "md6": "",
      "data-bg-image": "../../../static/img/bg14-l.jpg"
    }
  }, [_c('div', {
    staticClass: "fxt-header"
  }, [_c('div', [_c('h1', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.analyst')) + " ")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.paidTitle')))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "col-12 fxt-bg-color",
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "fxt-content"
  }, [_c('div', {
    staticClass: "fxt-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("password.title")))]), _vm._v(" "), _c('Form', {
    ref: "formInline",
    attrs: {
      "model": _vm.formInline,
      "rules": _vm.ruleInline
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "regEmail"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.formInline.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "regEmail", $$v)
      },
      expression: "formInline.regEmail"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "passWord"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "New Password",
      "type": "password"
    },
    model: {
      value: (_vm.formInline.passWord),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "passWord", $$v)
      },
      expression: "formInline.passWord"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "confirmPassWord"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Confirm password",
      "type": "password"
    },
    model: {
      value: (_vm.formInline.confirmPassWord),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "confirmPassWord", $$v)
      },
      expression: "formInline.confirmPassWord"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "text-lg-center"
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formInline')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("password.resetButton")))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-lg-center font-14"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("header.accountHint")) + "?")]), _vm._v(" "), _c('span', {
    staticClass: "primary--text pointer mr-2",
    on: {
      "click": _vm.gotoRegister
    }
  }, [_vm._v(_vm._s(_vm.$t("header.signUp")))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "fxt-footer"
  }, [_c('ul', {
    staticClass: "fxt-socials"
  }, [_c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBots_",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBotsPro",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-linkedin fxt-transformY-50 fxt-transition-delay-9"
  }, [_c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "title": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fab fa-telegram-plane"
  })])])])])])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-4"
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "img-upload"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel),
      expression: "panel"
    }],
    staticClass: "img-container"
  }, [_c('img', {
    attrs: {
      "id": "image",
      "src": _vm.panelImageUrl,
      "alt": "Picture"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "id": "img-button-cancel",
      "dark": ""
    },
    on: {
      "click": _vm.cancelPanel
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "id": "img-button-submit",
      "dark": ""
    },
    on: {
      "click": _vm.cropperImage
    }
  }, [_vm._v(_vm._s(_vm.$t("common.apply")))])], 1)]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.hideBlock
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "profile-head"
  }, [_c('div', {
    staticClass: "profile-top",
    style: ({
      backgroundImage: 'url(' + _vm.userDetail.coverImage + ')'
    })
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "name": "coverImage",
      "max-size": 1024,
      "format": ['jpg', 'jpeg', 'png'],
      "action": _vm.uploadCoverImageUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "show-upload-list": false,
      "before-upload": _vm.uploadCoverImageBefore
    }
  }, [_c('div', [_c('v-btn', {
    staticClass: "mt-4 mr-4 right",
    staticStyle: {
      "position": "absolute",
      "right": "0px"
    },
    attrs: {
      "small": "",
      "flat": "",
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.changeCoverImage")))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-bottom"
  }, [_c('div', {
    staticClass: "picture"
  }, [_c('div', {
    staticClass: "user-image text-xs-center mb-3"
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "name": "upfile",
      "max-size": 1024,
      "format": ['jpg', 'jpeg', 'png'],
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "before-upload": _vm.beforeUpload,
      "show-upload-list": false
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "primary pointer",
      "size": "100",
      "title": _vm.$t('userSetting.uploadImgTitle')
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image != null),
      expression: "userDetail.image != null"
    }],
    attrs: {
      "src": _vm.userDetail.image,
      "alt": _vm.userDetail.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image == null),
      expression: "userDetail.image == null"
    }],
    staticClass: "font-50 white--text"
  }, [_vm._v("\n                                                " + _vm._s(_vm.userDetail.userName != null ? _vm.userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                            ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "user-list-content mb-5"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('h3', {
    staticClass: "fw-700"
  }, [_vm._v(_vm._s(_vm.userDetail.nickName) + " (" + _vm._s(_vm.userDetail.reputationScore) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 fw-500 mt-3"
  }, [_c('span', {
    staticClass: "mx-3"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-at")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.userDetail.userName))])], 1), _vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-calendar-alt")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.regTimeFormat(_vm.userDetail.regTime)))])], 1)])])])])])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-5": "",
      "mb-5": "",
      "pb-5": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "lg3": ""
    }
  }, [_c('div', {
    staticClass: "inbox-head"
  }, [_c('div', {
    staticClass: "mailbox-items-warp"
  }, [_c('div', {
    staticClass: "app-card"
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userSetting.account')
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('account')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("account_box")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.account")) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userSetting.password')
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('password')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("lock")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.password")) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userSetting.kyc.kyc')
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('kyc')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fas fa-id-card")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.kyc.kyc")) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userSetting.privacyAndSafety')
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('privacyAndSafety')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("security")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.privacyAndSafety")) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userSetting.googleAuthentication')
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('googleAuthentication')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("phonelink_setup")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.googleAuthentication")) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userSetting.accountBinding')
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('accountBinding')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fas fa-globe-europe")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.accountBinding")) + "\n                            ")])], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "inbox-content",
    attrs: {
      "xs12": "",
      "md7": "",
      "lg9": ""
    }
  }, [_c('div', {
    staticClass: "inbox-content-wrap"
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAccount),
      expression: "isShowAccount"
    }],
    staticClass: "ml-3 mr-3 mb-5"
  }, [_c('h2', {
    staticClass: "fw-700 mb-3"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.account")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("userSetting.username")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('userSetting.username'),
      "disabled": ""
    },
    model: {
      value: (_vm.userDetail.userName),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "userName", $$v)
      },
      expression: "userDetail.userName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.nickName")))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('userSetting.nickName'),
      "disabled": !_vm.isShowNickNameInput
    },
    model: {
      value: (_vm.userDetail.nickName),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "nickName", $$v)
      },
      expression: "userDetail.nickName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.edit'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowNickNameInput),
      expression: "!isShowNickNameInput"
    }],
    on: {
      "click": function($event) {
        _vm.isShowNickNameInput = !_vm.isShowNickNameInput
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.confirm'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNickNameInput),
      expression: "isShowNickNameInput"
    }],
    on: {
      "click": _vm.updateNickName
    }
  }, [_vm._v("fas fa-check")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.cancel'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNickNameInput),
      expression: "isShowNickNameInput"
    }],
    staticClass: "ml-3",
    on: {
      "click": _vm.showNickNameInput
    }
  }, [_vm._v("fas fa-times")])], 1)], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("userSetting.email")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('userSetting.email'),
      "disabled": !_vm.isShowRegEmailInput
    },
    model: {
      value: (_vm.userDetail.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "regEmail", $$v)
      },
      expression: "userDetail.regEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.edit'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowRegEmailInput),
      expression: "!isShowRegEmailInput"
    }],
    on: {
      "click": function($event) {
        _vm.isShowRegEmailInput = !_vm.isShowRegEmailInput
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.confirm'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowRegEmailInput),
      expression: "isShowRegEmailInput"
    }],
    on: {
      "click": _vm.sendUpdateRegEmail
    }
  }, [_vm._v("fas fa-check")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.cancel'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowRegEmailInput),
      expression: "isShowRegEmailInput"
    }],
    staticClass: "ml-3",
    on: {
      "click": _vm.showRegEmailInput
    }
  }, [_vm._v("fas fa-times")])], 1)], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("userSetting.invitationCode")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pointer",
    attrs: {
      "label": _vm.$t('userSetting.invitationCode'),
      "disabled": ""
    },
    model: {
      value: (_vm.userDetail.invitationCode),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "invitationCode", $$v)
      },
      expression: "userDetail.invitationCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('userSetting.copyInvitationLink'),
      "placement": "bottom"
    }
  }, [_c('span', {
    attrs: {
      "id": "invitationLink",
      "data-clipboard-text": _vm.invitationLink
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.copyInvitationLink
    }
  }, [_vm._v("fas fa-copy")])], 1)])], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("userSetting.avatar")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('userSetting.avatar'),
      "disabled": !_vm.isShowImageInput
    },
    model: {
      value: (_vm.userDetail.image),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "image", $$v)
      },
      expression: "userDetail.image"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.edit'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowImageInput),
      expression: "!isShowImageInput"
    }],
    on: {
      "click": function($event) {
        _vm.isShowImageInput = !_vm.isShowImageInput
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.confirm'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowImageInput),
      expression: "isShowImageInput"
    }],
    on: {
      "click": _vm.updateImage
    }
  }, [_vm._v("fas fa-check")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.cancel'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowImageInput),
      expression: "isShowImageInput"
    }],
    staticClass: "ml-3",
    on: {
      "click": _vm.showImageInput
    }
  }, [_vm._v("fas fa-times")])], 1)], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("userSetting.coverImage")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('userSetting.coverImage'),
      "disabled": !_vm.isShowCoverImageInput
    },
    model: {
      value: (_vm.userDetail.coverImage),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "coverImage", $$v)
      },
      expression: "userDetail.coverImage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.edit'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowCoverImageInput),
      expression: "!isShowCoverImageInput"
    }],
    on: {
      "click": function($event) {
        _vm.isShowCoverImageInput = !_vm.isShowCoverImageInput
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.confirm'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCoverImageInput),
      expression: "isShowCoverImageInput"
    }],
    on: {
      "click": _vm.updateCoverImage
    }
  }, [_vm._v("fas fa-check")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.cancel'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCoverImageInput),
      expression: "isShowCoverImageInput"
    }],
    staticClass: "ml-3",
    on: {
      "click": _vm.showCoverImageInput
    }
  }, [_vm._v("fas fa-times")])], 1)], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("userSetting.timeZone")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.timeZoneList,
      "item-text": "name",
      "item-value": "timeZoneId",
      "label": _vm.$t('userSetting.timeZone'),
      "disabled": !_vm.isShowTimeZoneInput
    },
    on: {
      "input": _vm.updateTimeZone
    },
    model: {
      value: (_vm.userDetail.timeZoneId),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "timeZoneId", $$v)
      },
      expression: "userDetail.timeZoneId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.edit'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowTimeZoneInput),
      expression: "!isShowTimeZoneInput"
    }],
    on: {
      "click": function($event) {
        _vm.isShowTimeZoneInput = !_vm.isShowTimeZoneInput
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.confirm'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTimeZoneInput),
      expression: "isShowTimeZoneInput"
    }],
    on: {
      "click": function($event) {
        _vm.isShowTimeZoneInput = !_vm.isShowTimeZoneInput
      }
    }
  }, [_vm._v("fas fa-check")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPassword),
      expression: "isShowPassword"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.password")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "font-14 fw-500"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.passwordMsg")))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "formPassword",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.formPasswordValid),
      callback: function($$v) {
        _vm.formPasswordValid = $$v
      },
      expression: "formPasswordValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "rules": _vm.currentPasswordRules,
      "label": _vm.$t('userSetting.currentPassword'),
      "required": ""
    },
    model: {
      value: (_vm.formPassword.passWord),
      callback: function($$v) {
        _vm.$set(_vm.formPassword, "passWord", $$v)
      },
      expression: "formPassword.passWord"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pointer font-12",
    on: {
      "click": _vm.goPassword
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.forgotPassword")) + "?")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "password",
      "rules": _vm.newPasswordRules,
      "label": _vm.$t('userSetting.newPassword'),
      "required": ""
    },
    model: {
      value: (_vm.formPassword.newPassWord),
      callback: function($$v) {
        _vm.$set(_vm.formPassword, "newPassWord", $$v)
      },
      expression: "formPassword.newPassWord"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "password",
      "rules": _vm.confirmNewPasswordRules,
      "label": _vm.$t('userSetting.verifyPassword'),
      "required": ""
    },
    model: {
      value: (_vm.formPassword.confirmNewPassWord),
      callback: function($$v) {
        _vm.$set(_vm.formPassword, "confirmNewPassWord", $$v)
      },
      expression: "formPassword.confirmNewPassWord"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "primary",
      "outline": "",
      "small": ""
    },
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.saveChanges")))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowKyc),
      expression: "isShowKyc"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('h2', {
    staticClass: "fw-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.kyc.kyc")))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.realNameAuthentication == '-1'),
      expression: "userDetail.realNameAuthentication == '-1'"
    }]
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.kyc.beginMsg")))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "small": ""
    },
    on: {
      "click": _vm.gotoKyc
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t("userSetting.kyc.begin")) + "\n                                    ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.realNameAuthentication == '-2'),
      expression: "userDetail.realNameAuthentication == '-2'"
    }]
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.kyc.underReviewMsg")))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "small": "",
      "disabled": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("userSetting.kyc.underReview")) + "\n                                ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.realNameAuthentication == '1'),
      expression: "userDetail.realNameAuthentication == '1'"
    }]
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.kyc.rejectedMsg")))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "small": ""
    },
    on: {
      "click": _vm.gotoKyc
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("userSetting.kyc.rejected")) + "\n                                ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.realNameAuthentication == '0'),
      expression: "userDetail.realNameAuthentication == '0'"
    }]
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.kyc.passedMsg")))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "small": "",
      "disabled": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("userSetting.kyc.passed")) + "\n                                ")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPrivacyAndSafety),
      expression: "isShowPrivacyAndSafety"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('h2', {
    staticClass: "fw-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.privacyAndSafety")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "font-md"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t("userSetting.emailNotifications")))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "readonly": "",
      "label": _vm.$t('userSetting.receiveAuthEmail')
    },
    model: {
      value: (_vm.userRight.isReceiveAuthEmail),
      callback: function($$v) {
        _vm.$set(_vm.userRight, "isReceiveAuthEmail", $$v)
      },
      expression: "userRight.isReceiveAuthEmail"
    }
  }), _vm._v("\n                                    " + _vm._s(_vm.$t("userSetting.receiveAuthEmailHint")) + "\n                                    "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$t('userSetting.receivePushEmail')
    },
    model: {
      value: (_vm.userRight.isReceivePushEmail),
      callback: function($$v) {
        _vm.$set(_vm.userRight, "isReceivePushEmail", $$v)
      },
      expression: "userRight.isReceivePushEmail"
    }
  }), _vm._v("\n                                    " + _vm._s(_vm.$t("userSetting.receivePushEmailHint")) + "\n                                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "font-md mt-3"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t("userSetting.dataProtections")))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$t('userSetting.hideSipToken')
    },
    model: {
      value: (_vm.userRight.isHideSipToken),
      callback: function($$v) {
        _vm.$set(_vm.userRight, "isHideSipToken", $$v)
      },
      expression: "userRight.isHideSipToken"
    }
  }), _vm._v("\n                                    " + _vm._s(_vm.$t("userSetting.hideSipTokenHint")) + "\n                                ")], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userDetail.openAuthentication),
      expression: "!userDetail.openAuthentication"
    }]
  }, [_c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "primary",
      "outline": "",
      "small": "",
      "disabled": _vm.userRightVaild
    },
    on: {
      "click": _vm.updateUserRight
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.saveChanges")))])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowGoogleAuthentication),
      expression: "isShowGoogleAuthentication"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('h2', {
    staticClass: "fw-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.googleAuthentication")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.openAuthentication),
      expression: "userDetail.openAuthentication"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.enabledMsg")))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userDetail.openAuthentication),
      expression: "!userDetail.openAuthentication"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.disabledMsg")))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.openAuthentication),
      expression: "userDetail.openAuthentication"
    }]
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "small": ""
    },
    on: {
      "click": _vm.showDisableModal
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.disable")))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userDetail.openAuthentication),
      expression: "!userDetail.openAuthentication"
    }]
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "small": "",
      "loading": _vm.enableLoading
    },
    on: {
      "click": _vm.gotoAuthentication
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.enable")))])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAccountBinding),
      expression: "isShowAccountBinding"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('h2', {
    staticClass: "fw-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.accountBinding")))]), _vm._v(" "), _c('v-layout', {
    staticClass: "font-md",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "small-12 ml-3"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.viewOrCopyHint")) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "small-12 mt-5 ml-3"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("fas fa-key")]), _vm._v(" "), _c('span', {
    staticClass: "ml-2 mr-5"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.token")) + ":")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userRight.isHideSipToken),
      expression: "userRight.isHideSipToken"
    }]
  }, [_vm._v("\n                                    " + _vm._s(_vm.userDetail.sipToken) + "\n                                ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userRight.isHideSipToken),
      expression: "!userRight.isHideSipToken"
    }]
  }, [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('userSetting.clickToCopy'),
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "pointer",
    attrs: {
      "id": "sipToken",
      "data-clipboard-text": _vm.userDetail.sipToken
    },
    on: {
      "click": _vm.copySipToken
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.userDetail.sipToken) + "\n                                        ")])])], 1), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "primary pointer",
      "title": _vm.$t('userSetting.refresh')
    },
    on: {
      "click": _vm.updateSipToken
    }
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br')], 1)])], 1)])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "red"
    }
  }, [_c('Modal', {
    attrs: {
      "align": "center"
    },
    model: {
      value: (_vm.isShowDisableModal),
      callback: function($$v) {
        _vm.isShowDisableModal = $$v
      },
      expression: "isShowDisableModal"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "Helvetica-Bold",
      "color": "#333333",
      "font-size": "20px",
      "letter-spacing": "0",
      "line-height": "30px",
      "height": "40px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.disableModalTitle")))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.disableModalMsg")))]), _vm._v(" "), _c('v-form', {
    ref: "formDisableAuthentication",
    staticClass: "mt-5 mb-4"
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "enter-verify-code",
      "counter": 6,
      "rules": _vm.randomCodeRules,
      "single-line": "",
      "outline": ""
    },
    model: {
      value: (_vm.formDisableAuthentication.randomCode),
      callback: function($$v) {
        _vm.$set(_vm.formDisableAuthentication, "randomCode", $$v)
      },
      expression: "formDisableAuthentication.randomCode"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.formDisableAuthentication.id),
      callback: function($$v) {
        _vm.$set(_vm.formDisableAuthentication, "id", $$v)
      },
      expression: "formDisableAuthentication.id"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.formDisableAuthentication.authenticationSecret),
      callback: function($$v) {
        _vm.$set(_vm.formDisableAuthentication, "authenticationSecret", $$v)
      },
      expression: "formDisableAuthentication.authenticationSecret"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.disableModalContact")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.disableModalCancel
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.verityRandomCode('formDisableAuthentication')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.verify")))])], 1)], 1)], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "app-card mt-6"
  }, [_c('div', {
    staticStyle: {
      "margin": "0 20px"
    }
  }, [_c('label', {
    staticClass: "mt-3",
    staticStyle: {
      "font-size": "16px",
      "border-bottom": "1px solid  #EEEEEE",
      "display": "block",
      "text-align": "center",
      "height": "30px",
      "line-height": "15px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("left.tags")) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 mb-3"
  }, _vm._l((_vm.tagList), function(tag, index) {
    return _c('Tag', {
      key: tag.tagId,
      staticClass: "body-2",
      attrs: {
        "type": "border",
        "color": "#41B8BC"
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.getPostsByTagName(tag.tagName)
        }
      }
    }, [_vm._v(_vm._s(tag.tagName))])])
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAll),
      expression: "isShowAll"
    }],
    staticClass: "postmiddle-right mt-3"
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none",
      "font-size": ".8rem",
      "margin-bottom": "20px",
      "text-align": "center"
    }
  }, [_c('li', [_c('span', {
    staticClass: "body-2 ml-1 pointer",
    on: {
      "click": _vm.showAllTag
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("left.showall")))]), _vm._v(" "), _c('v-icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "medium": ""
    }
  }, [_vm._v("keyboard_arrow_down")])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUpward),
      expression: "isShowUpward"
    }],
    staticClass: "postmiddle-right"
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none",
      "font-size": ".8rem",
      "margin-bottom": "20px",
      "text-align": "center"
    }
  }, [_c('li', [_c('span', {
    staticClass: "body-2 ml-1 pointer",
    on: {
      "click": _vm.upwardTag
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("left.Upward")))]), _vm._v(" "), _c('v-icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "medium": ""
    }
  }, [_vm._v("keyboard_arrow_up")])], 1)])])])])])])
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "fxt-template-layout10"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-12 fxt-bg-img",
    attrs: {
      "md6": "",
      "data-bg-image": "../../../static/img/bg14-l.jpg"
    }
  }, [_c('div', {
    staticClass: "fxt-header"
  }, [_c('div', [_c('h1', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.analyst')) + " ")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.paidTitle')))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "col-12 fxt-bg-color",
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "fxt-content"
  }, [_c('div', {
    staticClass: "fxt-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("register.create")))]), _vm._v(" "), _c('v-form', {
    ref: "registrationForm",
    staticClass: "mt-5",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-3",
    attrs: {
      "rules": _vm.regEmailRules,
      "label": _vm.$t('register.email'),
      "required": ""
    },
    model: {
      value: (_vm.registrationForm.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.registrationForm, "regEmail", $$v)
      },
      expression: "registrationForm.regEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.userNameRules,
      "label": _vm.$t('register.username'),
      "required": ""
    },
    model: {
      value: (_vm.registrationForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.registrationForm, "userName", $$v)
      },
      expression: "registrationForm.userName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-3",
    attrs: {
      "type": "password",
      "rules": _vm.passWordRules,
      "label": _vm.$t('register.password'),
      "required": ""
    },
    model: {
      value: (_vm.passwordForm.passWord),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "passWord", $$v)
      },
      expression: "passwordForm.passWord"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "rules": _vm.repassWordRules,
      "label": _vm.$t('register.confirmationPassword'),
      "required": ""
    },
    model: {
      value: (_vm.passwordForm.repassWord),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "repassWord", $$v)
      },
      expression: "passwordForm.repassWord"
    }
  })], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('register.invitationCode'),
      "required": ""
    },
    model: {
      value: (_vm.registrationForm.fillInvitationCode),
      callback: function($$v) {
        _vm.$set(_vm.registrationForm, "fillInvitationCode", $$v)
      },
      expression: "registrationForm.fillInvitationCode"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "rules": _vm.agreedRules
    },
    model: {
      value: (_vm.registrationForm.agreed),
      callback: function($$v) {
        _vm.$set(_vm.registrationForm, "agreed", $$v)
      },
      expression: "registrationForm.agreed"
    }
  }, [_c('div', {
    staticClass: "font-14",
    attrs: {
      "slot": "label"
    },
    on: {
      "click": function($event) {
        _vm.termsModal = true
      }
    },
    slot: "label"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("register.agree")) + "\n                        "), _c('span', {
    staticClass: "primary--text pointer font-14"
  }, [_vm._v("\n                          <<" + _vm._s(_vm.$t("register.terms")) + ">>\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex text-xs-left mt-3"
  }, [_c('v-btn', {
    staticClass: "primary ml-0",
    attrs: {
      "medium": "",
      "dark": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.$t("register.signUp")))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "medium": "",
      "dark": ""
    },
    on: {
      "click": _vm.clearForm
    }
  }, [_vm._v(_vm._s(_vm.$t("register.reset")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-5 fxt-footer font-14"
  }, [_vm._v("\n                      Already a Account?\n                      "), _c('span', {
    staticClass: "primary--text pointer mr-2",
    on: {
      "click": _vm.gotoLogin
    }
  }, [_vm._v(_vm._s(_vm.$t("header.login")))])])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "80%",
      "title": _vm.$t('serviceTerms.title'),
      "ok-text": "OK",
      "cancel-text": "Cancel"
    },
    on: {
      "on-ok": _vm.agreeTerms
    },
    model: {
      value: (_vm.termsModal),
      callback: function($$v) {
        _vm.termsModal = $$v
      },
      expression: "termsModal"
    }
  }, [_c('app-terms')], 1), _vm._v(" "), _c('Modal', {
    model: {
      value: (_vm.sendEmailModal),
      callback: function($$v) {
        _vm.sendEmailModal = $$v
      },
      expression: "sendEmailModal"
    }
  }, [_c('div', {
    staticClass: "text-center h4 fw-bold mt-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("register.noActivatedMessage")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("register.sendEmailMessage")))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    staticClass: "text-white primary",
    on: {
      "click": _vm.closeSendEmailModal
    }
  }, [_vm._v(_vm._s(_vm.$t("common.no")))]), _vm._v(" "), _c('Button', {
    staticClass: "text-white primary",
    on: {
      "click": _vm.sendActivationEmail
    }
  }, [_vm._v(_vm._s(_vm.$t("common.yes")))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "fxt-footer"
  }, [_c('ul', {
    staticClass: "fxt-socials"
  }, [_c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBots_",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBotsPro",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-linkedin fxt-transformY-50 fxt-transition-delay-9"
  }, [_c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "title": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fab fa-telegram-plane"
  })])])])])])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "mt-150"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('p', {
    staticClass: "font-2x mt-7"
  }, [_vm._v(_vm._s(_vm.$t('userRequest.submitRequest')))]), _vm._v(" "), _c('v-form', {
    ref: "userRequestForm",
    model: {
      value: (_vm.userRequestVaild),
      callback: function($$v) {
        _vm.userRequestVaild = $$v
      },
      expression: "userRequestVaild"
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('userRequest.issue'),
      "items": _vm.issueSelect,
      "rules": _vm.issueRules,
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: (_vm.userRequestForm.issue),
      callback: function($$v) {
        _vm.$set(_vm.userRequestForm, "issue", $$v)
      },
      expression: "userRequestForm.issue"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('userRequest.email'),
      "rules": _vm.regEmailRules,
      "hint": _vm.$t('userRequest.emailHint'),
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.userRequestForm.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.userRequestForm, "regEmail", $$v)
      },
      expression: "userRequestForm.regEmail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('userRequest.subject'),
      "rules": _vm.subjectRules,
      "hint": _vm.$t('userRequest.subjectHint'),
      "counter": "50",
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.userRequestForm.subject),
      callback: function($$v) {
        _vm.$set(_vm.userRequestForm, "subject", $$v)
      },
      expression: "userRequestForm.subject"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": _vm.$t('userRequest.description'),
      "rules": _vm.descriptionRules,
      "hint": _vm.$t('userRequest.descriptionHint'),
      "counter": "1000",
      "clearable": "",
      "auto-grow": "",
      "required": ""
    },
    model: {
      value: (_vm.userRequestForm.description),
      callback: function($$v) {
        _vm.$set(_vm.userRequestForm, "description", $$v)
      },
      expression: "userRequestForm.description"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "outline": "",
      "disabled": !_vm.userRequestVaild,
      "loading": _vm.userRequestBtnLoading
    },
    on: {
      "click": _vm.submitRequest
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("common.submit")) + "\n                                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-2": "",
      "pa-5": ""
    }
  }, [_c('V-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "mb-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-24"
  }, [_vm._v("Decades of Financial Expertise")]), _vm._v(" "), _c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("Real solutions to today's real problems")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-5": "",
      "mb-5": ""
    }
  }, [_c('v-container', {
    attrs: {
      "pa-0": "",
      "grid-list-xl": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2",
    attrs: {
      "hover": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text"
  }, [_c('a', {
    staticClass: "pointer",
    attrs: {
      "href": "https://iobots.pro",
      "target": "_blank"
    }
  }, [_vm._v("ioBots")])]), _vm._v(" "), _c('v-card-text', [_vm._v("ioBots are professional-grade cryptocurrency trading systems with portfolio risk management and trading strategies aimed at the post-Millennial and Generation Z traders:")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        Commission- and fee-free; a mobile- and anywhere-platform. \n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        The most comprehensive trading system on the market that helps its users to stay in the game for a long time.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2",
    attrs: {
      "hover": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text"
  }, [_c('a', {
    staticClass: "pointer",
    attrs: {
      "href": "https://beta.poet.best",
      "target": "_blank"
    }
  }, [_vm._v("PoET")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Proof of Enquiries & Trades (PoET) is a DLT solution that records every order enquiry ever sent – whether filled or not – and every trade ever executed on a distributed ledger. It makes regulatory compliance and enforcement easy and cost-effective.")]), _vm._v(" "), _c('v-card-text', [_vm._v("Trader Credit Score (TCS) is a product that helps licensed firms and their traders streamline their compliance requirements.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2",
    attrs: {
      "hover": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text"
  }, [_c('a', {
    staticClass: "pointer",
    attrs: {
      "href": _vm.domainName
    }
  }, [_vm._v("SiP")])]), _vm._v(" "), _c('v-card-text', [_vm._v("The crowd wisdom helps identify financial market manipulations and fake news;")]), _vm._v(" "), _c('v-card-text', [_vm._v("A social network rewards good contents.")]), _vm._v(" "), _c('v-card-text', [_vm._v("Helps build a loyal and active community.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-lg-right",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": "",
      "mt-5": ""
    }
  }, [_c('div', [_c('a', {
    attrs: {
      "href": _vm.domainName
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey",
      "size": "20"
    }
  }, [_vm._v("arrow_back")])], 1)])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', [_vm._l((_vm.list), function(item) {
    return _c('p', [_vm._v("\n\t\t    Line:\n\t\t    "), _c('span', {
      domProps: {
        "textContent": _vm._s(item)
      }
    })])
  }), _vm._v(" "), _c('infinite-loading', {
    on: {
      "infinite": _vm.infiniteHandler
    }
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('lightred' == _vm.selectedTheme.bgColor),
      expression: "'lightred' == selectedTheme.bgColor"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.darkMode),
      expression: "!darkMode"
    }],
    staticClass: "site-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "130",
      "height": "30",
      "viewBox": "0 0 130 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "lightred",
      "width": "130",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.darkMode),
      expression: "!darkMode"
    }],
    staticClass: "site-mobile-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "75",
      "height": "30",
      "viewBox": "0 0 75 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "Sip_lightred_m",
      "width": "75",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.darkMode),
      expression: "darkMode"
    }],
    staticClass: "site-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "130",
      "height": "30",
      "viewBox": "0 0 130 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "IOB_Sip_logo_lightred",
      "width": "130",
      "height": "30",
      "xlink:href": "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAAAeCAYAAADgp8bFAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wMOChIvJckGMwAACdpJREFUaN7tm3twVNUdxz93c3ezCUk2m8fmwSsEBYEU0FpQKkOl1AelVcqAaEFhRFrsoNjigNW2VC1ILA7MYItAaccxjFVakYlF24JToRQqjyJIgFCCgAokQMSwSTbJ3v7xOzd7s+yGfSVhCt+ZM+fuPeeex+/8zu91zmrGTo1wKMagCpgOrCFMvRQDatLgzxOhyQ72JhKAe4G3gHqgORENdjLSgc+BgUBtm5ImH7T44eelUNgj+pa3boblpZBfKL+bm6CxAZ5aCMXXxzxgvaspFgYPqzylqwcSB9IBLe5WOgm2rh5ACAwAxnX1IK42XImM8GBXD+BqxJXGCHZgSlcP4mrElcYIk4AYLKhriBc60BfZiS0Rf6Wp2n7DAZxH47MEjWdaB8yxDvg38Kma5/XAUCCpA/pKBGxAMuDj8muiqTn54u1UB/YgFm7obgCMIOO3xQBnEdgLoOVf5Rj+7ySAADcCYyKsux/4CrASeCRMneOq7K9hymcCS4C0MOV/ASYAfgKEdiKqaxGQk4A5WzEJ+AFQArgQBj6g5vhamG+WYEt6goaGKdSeKwN+pdo5bqmjIczlBT4CfgdUBjcU2n1sBtwGZCI8qRlQDdRrso8MIMkF9u7QgkaKIV0ZcRHioSjqNqq8Nkz5cmC2eh6mCFysZrYHeFkReCXCKN8K0caXQAMwCChSC/MxsBooA/4D9ItrxgH8Hfhm0LtkYKRKPwS+waUxlRux2aCpqRf1XoAhwHUqhcLdwDzgeeBn1gIdmItIhAZA+D/PaDhS1Sv55LLpz9LizD6UfWI7U1e+hKc5F6+mgQbGPmCfGw97LuxIwlkHjuSYCZEGPBDDd6H89MXAfKAnsAlRBVaMAZ4E3lWEuQN4G/huUD1TLL+o6pl4B3FvH1ULGC9eIcAEO4CFSDDKo8Y5Cvg6wnz3BX07i8aGW8j1lNFvYHC7S4CTQDdEovVHpFky8AzC2IvNyvpq2RWtcKQZ6Ofg2edX0bT1jrlahjd7mze1YsoZz5urxy/gTK1Bs6EBBrpu8KUPjm0zGKMhbBWbVJgM5CaAqB8gTDAQ2b3t4S7gBNALuAf4RD1fDt9Wi7MJkRrpEXwTDjnA99XzQeCWoPJ31JxGIiL/18CHlvKDGMZBknSw24PbXqbmZ8VvgF3q+UlEMtYB6I8Er1w3YH8JVA7BNuAjsDdiNPZiyz9H8dYX0KKDryXwzcUW6JkOyVmINIkN0+IgphVzVL4+wvo9gHJkcX9KeF0cDNPQjH3GAg9CcRC7JxTWIowA0Be/YTLCIETflyOiPhLsRlTbDCAbGI4wdAj30Qdkn8LmrMd/qgh/rRvq8nAU1OAsBD0b7DmBlJwH/jREkMYmDUYgoi9e7Eb0/zQuVQftYSxieJYB5yOovw/YjCyOK84xf45IFYA7gT4h6qxA1kkH1lF7DgwDRbPhUc7V7NNEq6FsQ7iyAMgD8rhAHn1qUo3Zj+fmdj+S5C48T0H391J+nDuPnHpyUy+S56pvTd0zvWSm16vWYousR2Mktof3VT4xhm8nq3yX5Z05mwpFvA8Qe2EwYn+sT8CYzyO7GkTFVCC7OziWYiBbrRl/q0c5SOU7o+xzsOX5lPmgIy5KNqaL5AdqwRi3ga0jNtr7ZSfRXN48SV/aPN7vQguSIQ58rCed8dyMsFXk0QhUv5Oj+iI8KlTeP4ZvTaJWWd6ZHtVPVLLiASArQeN+AshXdEgGnlbpAPAqIhG+aK2ttS6AuaAVEfYDsACxh0Bskh3WyTrUs+Qa4pw1gX1AE6Q2oedi4yzJNieXKhMfdpoQBoguLGUSNCNBBDXPv2M5UTV1vnX05vN0xHWrQXzxvyHW9muI4VaQgLHfjyz6YkRNgRi8L6j0I8TQs2KIyg+HaXM7srnNFfMgcRATc6yVdQp4DtF19a1vM2hkb77jpVWT52Zmpbgzqk7sntOjbKXda2QDWiDQRA5eth8aBh4XuOuiJkCi1AKIuAb4DOgd5bemJOhueWcaghNp6z4+A7yBuHLjaKtO4sFGlfohgawHgRtU2cvIQi5Qhlgx4AbO0DZ4ZEVhmPd7kEBbm3HrE8t50foiJQmqnbCxbAXL379nBik+NymOvVuHFL4ydXAp1S1gKBKl+uBgJrw7GrZsQvjPQaQYDXw1QUQEuFXlmy3PkaJc5UMjrD8JsUlWIOJ1eALncRiJXC5CLuisQyTWL4BXQTtKIJC1t512HkUiiFm0jSweC1VZf2Nh0BsNKn0lbEy9FQbvw9bSgFHdmw32sWx4vFQY0ozrGYALelZBei3RGovTEkg8kF3rQIyt+UR+lnAAiS6OIiBVIsEwhBGOEzsjTEekymkkkHQyqHw9otefU79HgHEUURsgCxsO5VwaRwgLG1nQJrnBkV8NLh/UFeL3psM5DzZfrSiPc0hgtxYxYaoRXotOMxciuyqRsAFLkQjpzCi+M4+9F0XZ30GVe+IY82Dge8AsxA4JBavC1fFeBDmPAGHihMCGjRRsdMNGqpl6a6dZyjwnGTW2FGczySXbdP+Mp8HASSOp+FtTGn5iCSyboc5EYxaiu9cgu609NCCRvD3IboxGnXwIlCIMPSqO8VoDWEsI7HQTHtoadTv49AQ4kmPxGNqFDhxCRGIgmNKA8VjyWu2h+eWuzB52lmv19812e++mhqQgr8EN/JHoXcCOvIX0usr/gOjXXyK6Nh/xBKqAVcjBFKr8qRDtmDMtQ8S/D7iAeA3/UGVvxjnWXarvRciif4zEBQ4jIfeRBCz933P0cAWH9uu4XEPVu8rougsPHTljBFlUgSHqPjPnAhRBtzM4OEtOmGssaUSHsQT89o7C64i/PJ3QcQCQ3byO8JLAyghrFa1MF/Vrqo/iBIz1BWRnr0SY4WaVrCgF5rF/L5ytKaGobxJ+/38RlzYh0JHDCTei6QWm0VeniS3gRY6iL4WHwO6IFNMSMO6BiLXe3kLcr9IWxBj8BFncfsjZwpDL9HEnsmPN05xGxBjtQ3wHTaHwtkq3IYyZpfqrBN7DXHCnExyO0/j9DxPaPngOYdxKxACNGDpB59IdjGJiCwEHIwWx2iOBeaYfLVzATZ1EFxNbVQoNTQMJd68JU2MHchvrNgK3nELBvD1iWF90JqZ2cn9XI/KRGMIIAlGdPgS8knsRRjIQ2/B2wNbZf3C5xggdj55I2H4CokJ/C4xHDhUdyP9GihC1fjtyilnSmRJhAnJR9ho6Fjch0dWZiJe0DFGNpxAGOIZ4TBcRhjkDFHUmI8zqagpdJbgBWdxByA2oE8AR9e5PyH3GSuAxxI64DrjQWaqhPxJ48dM2Uvb/igzkwkl813ljQyVyB/Iu5ICsAXGfXcBZJB7cH7nIMxqRDDv/B/o+d7AYZAN5AAAAAElFTkSuQmCC"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.darkMode),
      expression: "darkMode"
    }],
    staticClass: "site-mobile-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "75",
      "height": "30",
      "viewBox": "0 0 75 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "sip_mobile_logo_lightred",
      "width": "75",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('limegreen' == _vm.selectedTheme.bgColor),
      expression: "'limegreen' == selectedTheme.bgColor"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.darkMode),
      expression: "!darkMode"
    }],
    staticClass: "site-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "130",
      "height": "30",
      "viewBox": "0 0 130 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "limegreen",
      "width": "130",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.darkMode),
      expression: "!darkMode"
    }],
    staticClass: "site-mobile-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "75",
      "height": "30",
      "viewBox": "0 0 75 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "sip_limegreen_m",
      "width": "75",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.darkMode),
      expression: "darkMode"
    }],
    staticClass: "site-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "130",
      "height": "30",
      "viewBox": "0 0 130 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "IOB_Sip_logo_limegreen",
      "width": "130",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.darkMode),
      expression: "darkMode"
    }],
    staticClass: "site-mobile-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "75",
      "height": "30",
      "viewBox": "0 0 75 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "IOB_Sip_logo_limegreen_mobile",
      "width": "75",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('moderatecyan' == _vm.selectedTheme.bgColor),
      expression: "'moderatecyan' == selectedTheme.bgColor"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.darkMode),
      expression: "!darkMode"
    }],
    staticClass: "site-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "130",
      "height": "30",
      "viewBox": "0 0 130 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "moderatecyan",
      "width": "130",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.darkMode),
      expression: "darkMode"
    }],
    staticClass: "site-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "130",
      "height": "30",
      "viewBox": "0 0 130 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "IOB_Sip_logo_light",
      "width": "130",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.darkMode),
      expression: "!darkMode"
    }],
    staticClass: "site-mobile-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "75",
      "height": "30",
      "viewBox": "0 0 75 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "moderatecyan_m",
      "width": "75",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.darkMode),
      expression: "darkMode"
    }],
    staticClass: "site-mobile-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "75",
      "height": "30",
      "viewBox": "0 0 75 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "sip_mobile_logo",
      "width": "75",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('purered' == _vm.selectedTheme.bgColor),
      expression: "'purered' == selectedTheme.bgColor"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.darkMode),
      expression: "!darkMode"
    }],
    staticClass: "site-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "130",
      "height": "30",
      "viewBox": "0 0 130 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "purered",
      "width": "130",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.darkMode),
      expression: "!darkMode"
    }],
    staticClass: "site-mobile-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "75",
      "height": "30",
      "viewBox": "0 0 75 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "sip_purered_m",
      "width": "75",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.darkMode),
      expression: "darkMode"
    }],
    staticClass: "site-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "130",
      "height": "30",
      "viewBox": "0 0 130 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "IOB_Sip_logo_purered",
      "width": "130",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.darkMode),
      expression: "darkMode"
    }],
    staticClass: "site-mobile-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "75",
      "height": "30",
      "viewBox": "0 0 75 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "sip_mobile_logo_purered",
      "width": "75",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('strongblue' == _vm.selectedTheme.bgColor),
      expression: "'strongblue' == selectedTheme.bgColor"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.darkMode),
      expression: "!darkMode"
    }],
    staticClass: "site-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "130",
      "height": "30",
      "viewBox": "0 0 130 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "svg_blue",
      "width": "130",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.darkMode),
      expression: "!darkMode"
    }],
    staticClass: "site-mobile-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "75",
      "height": "30",
      "viewBox": "0 0 75 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "sip_blue_m",
      "width": "75",
      "height": "30",
      "xlink:href": "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAeCAYAAABkDeOuAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4wMIEh4DjPqIyAAACQ1JREFUaN7lmmuQVEcVx3/dd3ZmH7Owb1ieSy0BBHatDZpQPDabUGoSxARKIEIlWTFoKZqiErXKmERL80CNX0C0eBQWVURMFDUpyyQmAkFQgQoJCASUEFzeszu7O7Pz2Jk7c9sPfWd32L0zzAwfNMWp6prb3adP9/336dPnnDtCzeYUXdTTR+HkA+YBG4AEgABYCOzPOEYoGAHbX2njtwdvZ0xlT0FTVxb3cOTyLN58fwnC3YcQCgArWYSQJis+/iK1pZ1EzNK8ZcdiMUpLS1m5ciV1dXW4uMAkHl7hZt7CwsEKA1OBKUnoPAcXnwZJiRKCAejypxHALGAiUAT4gRPA6RzGrgT6QexCYzcOGJmBVwFR4AJgZhPqwk8Pc+8dxd0rCgcLgB4Id0HNPA3WdSbOQuXA88AKoNKh/23gGeCtDOO/BGwVMoEyvXd2RWr2jh1xcX3ELF18nXkvA/uAn9u/w0gikCQTNwgUkCgBTxWo+I1IqUdrz5oMQAHcAbwJfCNDfymAEoAlY1qvlcxx7uXozXjWicHFWAS/2QhH9jmL6ARab4Wla3T9+EHYshmq7f4gsETAdI9+jl8AIQo9e28A49Pq69B2LwY0Ao8An7D71gOHgINDZGwA/MRLO6sqzv29seoMobi3P63/KPBaWl0AdcAioMZuewI4B2y5FqwaBPsOw6uHnZffCwSODYJ16gis36YtQABtDRbaosP21MUC21bkQ3cATfazAhYAe9L63wI2AQeAOXbbT4BWB1m/IummpsSP1xOiN1oxdEO+4zBmJPCnNNm/AF4EIikGSRxJtb1vTqUSGD1hUKR3pMb/FqAK+KKAZgGm0CB5CgKKtEUCHB8CVDqtS3ueL1CVHiM2VM4CZLKhL15Ov1mMIZLp/VUZ5AaAxYBl1w3gU+kMLgo9MP1o5Z0LhIDhViFfyNKNXWUWvn3A1wEEypVUhuUL14ESCEE1WvNAqIcSluucpaRttnJagw84BUy361OUUiilbLDcSK7YuDpRD+C7MFgPBaALXe4Dpii4mLYYyYB25b5GQB+PF+znccBL6JstNIQvAGwEEEIRt9z8JzAxtT8fG+Cy5D9KiyIUGSYJ05XPpg0wCyEs+1d3/L6nVTR90svkCR7noVeBu2YP1htnwkOLtZIuE/pIJhnUz4Qf+vZxSGhVmZv7Io8D24GH7foyoA3YCvwOeMdpkEDhNgaUcpr92wWcEc5ble3qnwpMSVVisdjxqqoqvF4vpmniWtKxjafWNfKD+3J8pZb5sH3+tW3lac+xs/BuI3e6EBEBKr9T3g4Uo69w0Af9Cbv80wZtG9CRYXzq+JwAVIa5rQxjW9GbpTdBiFAwGNw9Z84cKioq8Pv9SNQVGosyncECSJYAg3dwAfQA8CBwbEh7E/A94Azww+uA9X4W+cuBI0PKh2j/qgFASklnZ+fKhoYGs7W1lVAohGVZuESFZP87vYyqwNHAqKjF6HEeWqbp2OrSVcXRdyMw6wCUJYf76f0nQWr7fwOA7bDLZ4D7gXvQYQ/o0OdJdCh075BxM+3fE1lkVzPoJQ4jKaXf5/Otra6ufrW9vZ2ysjK6u7uRUuISEzxs3XGVrZsuOY++GKFt9Tj2bJ4KwGu7BI88uw1ef1S7ikPBEvbrALcWDlaK3rCLAD4HPA6kbMA9aH/pebs+BhhrP2fTrC60V5harQKiSqmOWCy23+/37xw/fnxg1apV1NbW4vP5kFJf9S6SCsoMKJHOTkTQTeUIY6BaYgDLd2lr0jEIjBMlyZmud3Eq4BW7vAws1Y3iMUMmfuwx4kmQ09P4T2WR9bKUck0gECAWiyGlRAiBYRiUl5fT1tbGggULGDly5DVAabAUSAlIZ0NsuQRGWp+Y8SHUvg3dOPlWw94wRypD+0cpiQ8C72XgfSoFFooaAWOFsDpQpNyGi3Zxfh/LkqZpMnv2bGpra4lGoxiGgdfrpb6+njFjxhCNRrVBl9e+oAspsCJJiGd4td4EoejgBRKbsVvrQSALWAb5UgRoTqs/kAWsAR9HCEXSMsyoWQLSmmE3Z7NXWJblisfjtLS00NTURG9vLynHs7+/H7/fj1JqGFAarKSiqMzAKM8gPOimwjv49sWGB7fhBrczv0JhqryzMxY67fKkXX8M+As6u5BOAvjpwOJloiOSKL3sj1aBEU9p1slsEwkhkFISDAbp7OwkGAw68jiRyzrXz9PPTeKrS+twPDhJ8JQMony/9/Ocn/XpDCuBQ6FDLDq9SGtXfoHU99HX+i1oS/hn4HW0MxoCRqND9sl6UwTlnr7vHrvSTDQ8Wgp3MGWzTuY1ax7kot9i0lgPdVW5hQTFsphiWZyxv7m0udBAOgnchnY877Tb7rbL8IVL80fheNmOw5duAyVmCmHV2LvjdBMOuApCiErLsrAsK6MGZQarSMjOnhySfzH0fl/HqJ+Pny84j4xOCN0FfAGdGr6da921S8Bfgc0umdgdjI2gO1INRf11ID5AOzJONusEtp9mmubpaDSKlHIgQM4ZLNlQXPbctsv87CVfZq6rE1GLNqNWb9CZ8CxzxFQsFYrm/4VgkHbapQQdVBejs2Ud2LGdUgJDJvG4YiTMsr3Yx3MoGYZBqCe0ti8UXVtUpP2c1tZWJk2aRDgczg8siuWXu6/E3d2RDCGTJaEzBCt2QrJjeA5gKAlSYB29AbBSFAX+nQNfxqMRiURoamqhumYUUkrq6+tpaGggkUhgmqbjrZcZrITaIssM7Zg6gmWAO4mqKtF57aKcZf/PSaEIh8M0Nzczb34bXV1dNYlEYl5fX98fEolEXkDBdS1QalYJybxyQv83ZBgGoVAIn8+H3+//bCAQaLcsKxtQbuBrTth8NBEonErQyfJN6LT1r9H5q2+iP808g443vw38DQ1cO9pe/jI/Pfzo03TgX+gY81F05uIFtE83DVgNnAX2otM2jegvSNOBdTebZtWgc2HvobMXX0FnKhrQbslZ9JfwveiArhwdXYSBnptJs1xop/ccOns0Dq01YbSbsgv4IzpIP4DOlX0LneWYDHTfTGBVAx+gvzZvRKent6I9/sfRzrAL/S1gGfo/FSfQ+bIYsOe/DTftK/d3+bYAAAAASUVORK5CYII="
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.darkMode),
      expression: "darkMode"
    }],
    staticClass: "site-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "130",
      "height": "30",
      "viewBox": "0 0 130 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "IOB_Sip_logo_strongblue",
      "width": "130",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.darkMode),
      expression: "darkMode"
    }],
    staticClass: "site-mobile-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "75",
      "height": "30",
      "viewBox": "0 0 75 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "sip_mobile_logo_strongblue",
      "width": "75",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('vividyellow' == _vm.selectedTheme.bgColor),
      expression: "'vividyellow' == selectedTheme.bgColor"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.darkMode),
      expression: "!darkMode"
    }],
    staticClass: "site-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "130",
      "height": "30",
      "viewBox": "0 0 130 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "vividyellow",
      "width": "130",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.darkMode),
      expression: "!darkMode"
    }],
    staticClass: "site-mobile-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "75",
      "height": "30",
      "viewBox": "0 0 75 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "vividyellow",
      "width": "75",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.darkMode),
      expression: "darkMode"
    }],
    staticClass: "site-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "130",
      "height": "30",
      "viewBox": "0 0 130 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "IOB_Sip_logo_vividyellow",
      "width": "130",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.darkMode),
      expression: "darkMode"
    }],
    staticClass: "site-mobile-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "75",
      "height": "30",
      "viewBox": "0 0 75 30"
    }
  }, [_c('image', {
    attrs: {
      "id": "IOB_Sip_logo_vividyellow_mobile",
      "width": "75",
      "height": "30",
      "xlink:href": "data:img/png;base64,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"
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "pa-0": "",
      "mt-5": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "sm6": "",
      "mt-5": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('div', {
    staticClass: "primary--text error-text text-xs-center"
  }, [_vm._v("404")]), _vm._v(" "), _c('div', {
    staticClass: "font-20 text-xs-center mt-4"
  }, [_vm._v(_vm._s(_vm.$t("page404.pageNotFound")))]), _vm._v(" "), _c('div', {
    staticClass: "font-18 text-xs-center mt-4 mb-4"
  }, [_vm._v(_vm._s(_vm.$t("page404.hintMessage")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "flat": "",
      "outline": "",
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("page404.homepageButton")))])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "mt-7",
    attrs: {
      "align": "center"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('v-container', {
    staticClass: "mt-7",
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "app-card"
  }, [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.transactionList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.goTransactionData(props.item)
            }
          }
        }, [_vm._v("\n                        " + _vm._s((props.item.hash.length) > 18 ? (props.item.hash).substring(0, 18) + '...' : (props.item.hash)) + "\n                      ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.timeStampToTime(props.item.timeStamp)) + "\n                      ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('a', [_vm._v("\n                        " + _vm._s((props.item.from.length) > 18 ? (props.item.from).substring(0, 18) + '...' : (props.item.from)) + "\n                      ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('a', [_vm._v("\n                        " + _vm._s(_vm.subToHash(props.item.input)) + "\n                      ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.getQuantity(props.item.input)) + "\n                      ")])])]
      }
    }])
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 mb-5 text-xs-center"
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalTransactionNumber,
      "pageSize": _vm.pageSize,
      "simple": ""
    },
    on: {
      "on-change": _vm.getTransactionByPage
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('serviceTerms.message'))
    }
  })
},staticRenderFns: []}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "mt-70"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('div', [_vm._l((_vm.postList), function(post, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-4"
    }, [_c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media"
    }, _vm._l((_vm.postUserDetailList), function(user, index) {
      return (post.postingUserId == user.userId) ? _c('div', {
        key: index,
        staticClass: "ml-2 pt-3 mr-2"
      }, [_c('div', {
        staticClass: "mb-3"
      }, [_c('v-avatar', {
        staticClass: "pointer",
        attrs: {
          "color": "primary",
          "size": "34"
        },
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image != null),
          expression: "user.image != null"
        }],
        attrs: {
          "src": user.image,
          "alt": user.userName
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image == null),
          expression: "user.image == null"
        }],
        staticClass: "headline white--text"
      }, [_vm._v("\n                            " + _vm._s(user.userName
        .trim()
        .substring(0, 1)
        .toLocaleUpperCase()) + "\n                          ")])]), _vm._v(" "), _c('span', {
        staticClass: "pl-2 pointer hover-color font-16 fw-700",
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_vm._v("\n                          " + _vm._s(user.nickName) + "\n                          "), _c('span', [_vm._v("(" + _vm._s(user.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
        staticClass: "px-2 fw-500 font-14"
      }, [_c('v-icon', {
        attrs: {
          "size": "16"
        }
      }, [_vm._v("schedule")]), _vm._v("\n                          " + _vm._s(_vm.dateFormat(post.postingTime)) + "\n                        ")], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_vm._l((_vm.postUserDetailList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('div', {
          key: index,
          staticClass: "px-0"
        }, [(post.postingImg != '') ? _c('span', {
          staticClass: "rounded-circle mr-4 img-responsive posts-image pointer",
          domProps: {
            "innerHTML": _vm._s(post.postingImg)
          },
          on: {
            "click": function($event) {
              return _vm.findsel(post)
            }
          }
        }) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), _c('div', {
        staticClass: "media-body"
      }, [_c('h2', {
        staticClass: "fw-700 pointer break-word",
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v(_vm._s(post.postingTitle))]), _vm._v(" "), _c('h4', {
        staticClass: "mb-3 py-2 line-height-16",
        domProps: {
          "innerHTML": _vm._s(post.postingContent)
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "mt-1 justify-space-between"
      }, [_c('div', {
        staticClass: "social"
      }, [_c('span', {
        staticClass: "pointer"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.bonus')
        }
      }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
        staticClass: "font-1x fw-400 ml-1"
      }, [_vm._v(_vm._s(post.bonus.toFixed(2)))])], 1), _vm._v(" "), (post.postingStatus == 0) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == 1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == -1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.comment')
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingCountComments))])], 1), _vm._v(" "), _vm._l((_vm.postUserDetailList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('span', {
          staticClass: "ml-2"
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.retweet')
          },
          on: {
            "click": function($event) {
              return _vm.modalzf(post, user)
            }
          }
        }, [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 fw-400 ml-1"
        }, [_vm._v(_vm._s(post.postingCountForword))])], 1) : _vm._e()
      }), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [(post.postingCollection == 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("\n                                  fa fa-star\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('span', [(post.postingCollection != 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("fa fa-star")]) : _vm._e()], 1)], 2)])])], 2), _vm._v(" "), _c('div', {
        staticClass: "mt-3"
      }, _vm._l((_vm.postCommentList), function(postcomments, index) {
        return (post.postingId == postcomments.commentsPostingId) ? _c('span', {
          staticClass: "flex-middle"
        }, [_vm._l((_vm.postCommentUserList), function(userpopular, index) {
          return (postcomments.commentsUserId == userpopular.userId) ? _c('span', [_c('v-avatar', {
            staticClass: "pointer",
            attrs: {
              "color": "primary",
              "size": "32"
            },
            on: {
              "click": function($event) {
                return _vm.goUserData(userpopular.userName)
              }
            }
          }, [_c('img', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (userpopular.image != null),
              expression: "userpopular.image != null"
            }],
            attrs: {
              "src": userpopular.image,
              "alt": userpopular.userName
            }
          }), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (userpopular.image == null),
              expression: "userpopular.image == null"
            }],
            staticClass: "headline white--text"
          }, [_vm._v(_vm._s(userpopular.userName.trim().substring(0, 1).toLocaleUpperCase()))])])], 1) : _vm._e()
        }), _vm._v(" "), _c('span', {
          staticClass: "font-14 fw-500 ml-2"
        }, [(post.postingContent.length > 20) ? _c('span', [_vm._v(_vm._s(postcomments.commentsContext))]) : _c('span', [_vm._v(_vm._s(postcomments.commentsContext) + "……")])])], 2) : _vm._e()
      }), 0)]) : _vm._e()
    }), 0)])])])
  }), _vm._v(" "), _c('infinite-loading', {
    staticClass: "mb-3",
    attrs: {
      "identifier": _vm.postsTabName
    },
    on: {
      "infinite": _vm.getPostList
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t("posting.noMore")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t("posting.noResults")))])])], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.forwardModal),
      callback: function($$v) {
        _vm.forwardModal = $$v
      },
      expression: "forwardModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "font-30 fw-500"
  }, [_vm._v(_vm._s(_vm.$t('posting.retweet')))])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "32"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage != null),
      expression: "postUserImage != null"
    }],
    attrs: {
      "src": _vm.postUserImage,
      "alt": _vm.postUserName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage == null),
      expression: "postUserImage == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v("\n                          " + _vm._s(_vm.postUserName
    .trim()
    .substring(0, 1)
    .toLocaleUpperCase()) + "\n                        ")])])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
    staticClass: "pointer font-18 fw-700",
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_vm._v(_vm._s(_vm.postNickName))]), _vm._v(" "), _c('span', {
    staticClass: "px-2 font-16 fw-700"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('common.at')) + "\n                          "), _c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("schedule")]), _vm._v("\n                          " + _vm._s(_vm.dateFormat(_vm.postDate)) + "\n                        ")], 1)]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', {
    staticClass: "font-14 fw-700"
  }, [_vm._v(_vm._s(_vm.postTitle))])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-form', {
    ref: "formValidatezf"
  }, [_c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "input-7-4"
    },
    model: {
      value: (_vm.formValidatezf.postingForwardContext),
      callback: function($$v) {
        _vm.$set(_vm.formValidatezf, "postingForwardContext", $$v)
      },
      expression: "formValidatezf.postingForwardContext"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.forwardModal = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.postingforward
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md1": "",
      "lg4": ""
    }
  }, [_c('app-right')], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("\n\t\t\t Test\n\t\t")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n\t\t\t \n\t\t")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("\n\t\t\t \n\t\t")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "pa-5": "",
      "mt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "fill-height": "",
      "mb-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "md10": ""
    }
  }, [_c('div', {
    staticClass: "font-24"
  }, [_vm._v("Contact us")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md10": "",
      "mt-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-3 py-3",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "f-700"
  }, [_vm._v("Existing Investors")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "mt-1 font-12"
  }, [_vm._v("Speak write to "), _c('a', {
    attrs: {
      "href": "mailto:ir@iob.vc"
    }
  }, [_vm._v("ir@iob.vc.")]), _vm._v(" You can also speak directly to our support team "), _c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "target": "_blank"
    }
  }, [_vm._v("via Telegram")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "f-700"
  }, [_vm._v("Potential Investors")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "mt-1 font-12"
  }, [_vm._v("For more information, please write to us at "), _c('a', {
    attrs: {
      "href": "mailto:ir@iob.vc"
    }
  }, [_vm._v("ir@iob.vc")]), _vm._v(". You can find more information about our upcoming TAOs at "), _c('a', {
    attrs: {
      "href": _vm.domainName + '/#/ir'
    }
  }, [_vm._v("Investor Relations")]), _vm._v(".")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "f-700"
  }, [_vm._v("Media & Press")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "mt-1 font-12"
  }, [_vm._v("For our media package, media events or to book a speaking engagement, please email us at "), _c('a', {
    attrs: {
      "href": "mailto:media@iob.vc"
    }
  }, [_vm._v("media@iob.vc")]), _vm._v(".")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-5": "",
      "mb-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md3": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/contact/usa.jpg",
      "height": "300px"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-start": "",
      "column": ""
    }
  }, [_c('div', {
    staticClass: "white--text pa-3 py-5"
  }, [_c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("\n                                            IOB LLC\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v(" \n                                            1013 Centre Road, Suite 403-A Wilmington, DE 19805, USA (HQ)\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("\n                                            +1 775 476 8588\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('a', {
    attrs: {
      "href": "mailto:usa@iob.vc"
    }
  }, [_vm._v("usa@iob.vc")])])])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md3": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/contact/shanghai.jpg",
      "height": "300px"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-start": "",
      "column": ""
    }
  }, [_c('div', {
    staticClass: "white--text pa-3 py-5"
  }, [_c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("\n                                        IOB Shanghai Ltd.\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v(" \n                                        Shanghai, China (Regional HQ)\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("\n                                        +1 775 476 8588\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('a', {
    attrs: {
      "href": "mailto:china@iob.vc"
    }
  }, [_vm._v("china@iob.vc")])])])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md3": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/contact/germany.jpg",
      "height": "300px"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-start": "",
      "column": ""
    }
  }, [_c('div', {
    staticClass: "white--text pa-3 py-5"
  }, [_c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("\n                                        IOB Mesh Technology\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v(" \n                                        Hildeboldplatz 15-17, 50672, Cologne, Germany (Regional HQ)\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("\n                                        +49 172 261 2031\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('a', {
    attrs: {
      "href": "mailto:germany@iob.vc"
    }
  }, [_vm._v("germany@iob.vc")])])])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md3": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/contact/london.jpg",
      "height": "300px"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-start": "",
      "column": ""
    }
  }, [_c('div', {
    staticClass: "white--text pa-3 py-5"
  }, [_c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("\n                                        IOB London\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v(" \n                                        Hyde House, Edgware Road, London NW9, UK (Investment Services)\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("\n                                        +44 794 110 9962\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('a', {
    attrs: {
      "href": "mailto:uk@iob.vc"
    }
  }, [_vm._v("uk@iob.vc")])])])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-5": ""
    },
    on: {
      "click": _vm.hideBlock
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md9": "",
      "mt-5": "",
      "mb-5": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "mt-7",
    attrs: {
      "align": "center"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "profile-body"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "font-30 font-weight-bold",
    attrs: {
      "id": "postingTitle"
    }
  }, [_vm._v(_vm._s(_vm.posting.postingTitle))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "userDetail"
  }, [_c('div', {
    staticClass: "imgleft"
  }, [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "40"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.userDetail.userName)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image != null),
      expression: "userDetail.image != null"
    }],
    attrs: {
      "src": _vm.userDetail.image,
      "alt": _vm.userDetail.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image == null),
      expression: "userDetail.image == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v("\n                              " + _vm._s(_vm.userDetail.userName != null ? _vm.userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                            ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-side ml-2"
  }, [_c('a', {
    staticClass: "fw-bold font-18",
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.userDetail.userName)
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.userDetail.nickName) + "\n                            "), _c('span', [_vm._v("(" + _vm._s(_vm.userDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
    staticClass: "ml-2 font-16 fw-500"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('common.at')) + " " + _vm._s(_vm.dateFormat(_vm.posting.postingTime)) + "\n                          ")])])]), _vm._v(" "), _c('li', {
    staticClass: "right mr-5"
  }, [_c('v-speed-dial', {
    attrs: {
      "left": true,
      "direction": "left",
      "open-on-hover": true,
      "transition": "slide-x-reverse-transition"
    },
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    staticClass: "share-icon",
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": "",
      "fab": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("share")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "small": "",
      "dark": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:window.open('http://www.linkedin.com/sharing/share-offsite/?title='+encodeURIComponent(document.getElementById('postingTitle').innerHTML)+'&url='+encodeURIComponent(document.location.href),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');void(0)"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": _vm.$t('postingsel.linkedin'),
      "color": "white",
      "type": "social-twitter"
    }
  }, [_vm._v("mdi-linkedin")])], 1)]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "small": "",
      "dark": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(document.location.href)+'&t='+encodeURIComponent(document.title),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');void(0)"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": _vm.$t('postingsel.facebook'),
      "color": "white",
      "type": "social-facebook"
    }
  }, [_vm._v("mdi-facebook")])], 1)]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "small": "",
      "dark": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:window.open('http://twitter.com/home?status='+encodeURIComponent(document.getElementById('postingTitle').innerHTML)+''+encodeURIComponent(document.location.href)+''+encodeURIComponent('@IOB_llc'),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');void(0)"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": _vm.$t('postingsel.twitter'),
      "color": "white",
      "type": "social-twitter"
    }
  }, [_vm._v("mdi-twitter")])], 1)])], 1)], 1)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-5": ""
    }
  }, [_c('v-card-text', {
    staticClass: "font-18",
    attrs: {
      "id": "posting-content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.posting.postingContent)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "d-custom-flex",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "font-14 mr-2 pa-2"
  }, [_vm._v(_vm._s(_vm.$t('postingsel.category')) + ": ")]), _vm._v(" "), _c('span', _vm._l((_vm.marketsList), function(market, index) {
    return (market.marketId == _vm.posting.marketId) ? _c('v-btn', {
      key: index,
      attrs: {
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.findByMarkets(market)
        }
      }
    }, [_vm._v(_vm._s(market.name))]) : _vm._e()
  }), 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "d-custom-flex",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.posting.tagList != null && _vm.posting.tagList.length > 0) ? _c('span', {
    staticClass: "font-14 mr-2 pa-2"
  }, [_vm._v(_vm._s(_vm.$t('postingsel.tags')) + ": ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._l((_vm.posting.tagList), function(postingtag, index) {
    return _c('v-btn', {
      key: index,
      attrs: {
        "outline": "",
        "small": "",
        "color": "primary darken-1"
      },
      on: {
        "click": function($event) {
          return _vm.findtagposting(postingtag.tagName)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(postingtag.tagName) + "\n                      ")])
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.getters.user != null && _vm.posting.postingUserId == this.$store.getters.user.userId),
      expression: "this.$store.getters.user != null && posting.postingUserId == this.$store.getters.user.userId"
    }],
    staticClass: "right",
    attrs: {
      "small": "",
      "color": "primary darken-1"
    },
    on: {
      "click": function($event) {
        return _vm.editPosting(_vm.posting)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('postingsel.edit')) + "\n                      ")])], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": ""
    }
  }, [_c('div', {
    staticClass: "font-14 ml-2"
  }, [_c('v-icon', {
    attrs: {
      "size": "20"
    }
  }, [_vm._v("schedule")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(_vm.posting.postingTime)) + " " + _vm._s(_vm.$t('common.by')))]), _vm._v(" "), _c('span', {
    staticClass: "Author"
  }, [_c('a', {
    staticClass: "font-16",
    attrs: {
      "id": "userinfo"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.userDetail.userName)
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.userDetail.nickName) + "\n                          "), _c('span', [_vm._v("(" + _vm._s(_vm.userDetail.reputationScore) + ")")])])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-30"
  }, [(_vm.posting.isOriginal) ? _c('span', {
    staticClass: "primary--text ml-2 font-14"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('postingsel.original')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.posting.isOriginal) ? _c('span', {
    staticClass: "pointer primary--text ml-2 font-14"
  }, [_c('a', {
    attrs: {
      "href": _vm.posting.originalLink,
      "target": "_black"
    }
  }, [_vm._v(_vm._s(_vm.$t('postingsel.source')))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "social-list clearfix right"
  }, [_c('ul', {
    staticClass: "list-inline d-inline-block"
  }, [_c('li', [(this.user != null && this.user.userName == 'Andy') ? _c('a', {
    staticClass: "font-1x mr-3",
    on: {
      "click": function($event) {
        return _vm.editPosting(_vm.posting)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('postingsel.edit')))]) : _vm._e()]), _vm._v(" "), _c('li', [_c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.bonus')
    }
  }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
    staticClass: "font-14"
  }, [_vm._v(_vm._s(_vm.posting.bonus != null ? _vm.posting.bonus.toFixed(2) : 0.0))])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingStatus == 0),
      expression: "posting.postingStatus == 0"
    }]
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "primary",
      "title": _vm.$t('posting.upvote')
    },
    on: {
      "click": _vm.changesup
    }
  }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v(" " + _vm._s(_vm.posting.postingGoodnums) + "\n                            "), _c('v-icon', {
    staticClass: "fa-fort-down-icon",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.getUpvoteUser
    }
  }, [_vm._v("fas fa-sort-down")])], 1), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('postingsel.tread')
    },
    on: {
      "click": _vm.changesdown
    }
  }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v("\n                            " + _vm._s(_vm.posting.postingStepnums) + "\n                            "), _c('v-icon', {
    staticClass: "fa-fort-down-icon",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.getDownvoteUser
    }
  }, [_vm._v("fas fa-sort-down")])], 1)], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingStatus == 1),
      expression: "posting.postingStatus == 1"
    }]
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.upvote')
    },
    on: {
      "click": _vm.changesup
    }
  }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v(_vm._s(_vm.posting.postingGoodnums) + "\n                              "), _c('v-icon', {
    staticClass: "fa-fort-down-icon",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.getUpvoteUser
    }
  }, [_vm._v("fas fa-sort-down")])], 1), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "color": "primary",
      "title": _vm.$t('postingsel.tread')
    },
    on: {
      "click": _vm.changesdown
    }
  }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v("\n                              " + _vm._s(_vm.posting.postingStepnums) + "\n                              "), _c('v-icon', {
    staticClass: "fa-fort-down-icon",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.getDownvoteUser
    }
  }, [_vm._v("fas fa-sort-down")])], 1)], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingStatus == -1),
      expression: "posting.postingStatus == -1"
    }]
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.upvote')
    },
    on: {
      "click": _vm.changesup
    }
  }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v(_vm._s(_vm.posting.postingGoodnums) + "\n                            "), _c('v-icon', {
    staticClass: "fa-fort-down-icon",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.getUpvoteUser
    }
  }, [_vm._v("fas fa-sort-down")])], 1), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('postingsel.tread')
    },
    on: {
      "click": _vm.changesdown
    }
  }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v("\n                            " + _vm._s(_vm.posting.postingStepnums) + "\n                            "), _c('v-icon', {
    staticClass: "fa-fort-down-icon",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.getDownvoteUser
    }
  }, [_vm._v("fas fa-sort-down")])], 1)], 1), _vm._v(" "), _c('li', [_c('v-icon', {
    staticClass: "poin",
    attrs: {
      "small": "",
      "title": _vm.$t('posting.comment')
    },
    on: {
      "click": _vm.commentsshow
    }
  }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v(_vm._s(_vm.posting.postingCountComments))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.retweet')
    },
    on: {
      "click": function($event) {
        return _vm.modalzf(_vm.posting)
      }
    }
  }, [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v(_vm._s(_vm.posting.postingCountForword))])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingCollection == 0),
      expression: "posting.postingCollection == 0"
    }]
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "primary",
      "title": _vm.$t('posting.save')
    },
    on: {
      "click": _vm.collectionPosting
    }
  }, [_vm._v("fa fa-star")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingCollection != 0),
      expression: "posting.postingCollection != 0"
    }]
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.save')
    },
    on: {
      "click": _vm.collectionPosting
    }
  }, [_vm._v("fa fa-star")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUpvoteUserDiv),
      expression: "isShowUpvoteUserDiv"
    }],
    staticClass: "dropdown",
    attrs: {
      "id": "upvoteUserDiv"
    }
  }, [_vm._l((_vm.upvoteUserList), function(user) {
    return _c('div', [_c('div', {
      staticClass: "pointer font-14",
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_vm._v("+ " + _vm._s(user.userName))])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingGoodnums > 20),
      expression: "posting.postingGoodnums > 20"
    }]
  }, [_c('div', {
    on: {
      "click": _vm.getUpvoteUser
    }
  }, [_vm._v("……")])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDownvoteUserDiv),
      expression: "isShowDownvoteUserDiv"
    }],
    staticClass: "dropdown ml-5"
  }, [_vm._l((_vm.downvoteUserList), function(user) {
    return _c('div', {
      staticClass: "dropdown_color"
    }, [_c('div', {
      staticClass: "pointer font-14",
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_vm._v("+ " + _vm._s(user.userName))])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingGoodnums > 20),
      expression: "posting.postingGoodnums > 20"
    }]
  }, [_c('div', {
    on: {
      "click": _vm.getDownvoteUser
    }
  }, [_vm._v("……")])])], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.forwardModal),
      callback: function($$v) {
        _vm.forwardModal = $$v
      },
      expression: "forwardModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "font-30"
  }, [_vm._v(_vm._s(_vm.$t('posting.retweet')))])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "40"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.userDetail.userName)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image != null),
      expression: "userDetail.image != null"
    }],
    attrs: {
      "src": _vm.userDetail.image,
      "alt": _vm.userDetail.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image == null),
      expression: "userDetail.image == null"
    }],
    staticClass: "white--text"
  }, [_vm._v("\n                                    " + _vm._s(_vm.userDetail.userName != null ? _vm.userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                  ")])])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
    staticClass: "pointer font-18",
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.userDetail.nickName)
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.userDetail.nickName) + "\n                                    "), _c('span', [_vm._v("(" + _vm._s(_vm.userDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
    staticClass: "px-2 font-16"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('common.at')) + "\n                                    "), _c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("schedule")]), _vm._v("\n                                    " + _vm._s(_vm.dateFormat(_vm.posting.postingTime)) + "\n                                  ")], 1)]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', {
    staticClass: "font-18"
  }, [_vm._v(_vm._s(_vm.posting.postingTitle))])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-form', {
    ref: "formValidatezf"
  }, [_c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "input-7-4"
    },
    model: {
      value: (_vm.formValidatezf.postingForwardContext),
      callback: function($$v) {
        _vm.$set(_vm.formValidatezf, "postingForwardContext", $$v)
      },
      expression: "formValidatezf.postingForwardContext"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.forwardModal = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.postingforward
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowcomments),
      expression: "isShowcomments"
    }],
    staticClass: "mt-5"
  }, [_c('v-form', {
    ref: "formValidate"
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    staticClass: "mt-3 postCommentOfEditor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "blur": function($event) {
        return _vm.onEditorBlur($event)
      },
      "focus": function($event) {
        return _vm.onEditorFocus($event)
      },
      "ready": function($event) {
        return _vm.onEditorReady($event)
      },
      "change": function($event) {
        return _vm.onEditorChange($event)
      }
    },
    model: {
      value: (_vm.formValidate.commentsContext),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "commentsContext", $$v)
      },
      expression: "formValidate.commentsContext"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.postingcomments('formValidate')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isShowcomments = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 mt-3"
  }, [_c('div', {
    staticClass: "border-bottom-light-1 pt-2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postingCommentList != null && _vm.postingCommentList.length > 0),
      expression: "postingCommentList != null && postingCommentList.length > 0"
    }],
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.$t('postingsel.DISCUSSION')))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "comments"
    }
  }, _vm._l((_vm.postingCommentList), function(com, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (com.parentCommentId == null),
        expression: "com.parentCommentId == null"
      }],
      staticClass: "my-5",
      attrs: {
        "id": com.commentsId
      }
    }, [_c('span', {
      staticClass: "right pointer",
      on: {
        "click": function($event) {
          return _vm.commentsUporDown($event, com)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "title": _vm.$t('postingsel.UporDown'),
        "size": "20",
        "type": "chevron-down"
      }
    })], 1), _vm._v(" "), _vm._l((_vm.usercommentsList), function(commentuser, index) {
      return (com.commentsUserId == commentuser.userId) ? _c('dl', {
        staticClass: "font-14 d-custom-flex"
      }, [_c('dt', [_c('v-avatar', {
        staticClass: "pointer",
        attrs: {
          "color": "primary",
          "size": "32"
        },
        on: {
          "click": function($event) {
            return _vm.goUserData(commentuser.userName)
          }
        }
      }, [_c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (commentuser.image != null),
          expression: "commentuser.image != null"
        }],
        attrs: {
          "src": commentuser.image,
          "alt": commentuser.userName
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (commentuser.image == null),
          expression: "commentuser.image == null"
        }],
        staticClass: "headline white--text"
      }, [_vm._v("\n                          " + _vm._s(commentuser.userName != null ? commentuser.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                        ")])])], 1), _vm._v(" "), _c('dd', {
        staticClass: "ml-2"
      }, [_c('span', {
        staticClass: "pointer font-16",
        on: {
          "click": function($event) {
            return _vm.goUserData(commentuser.userName)
          }
        }
      }, [_vm._v("\n                        " + _vm._s(commentuser.nickName) + "\n                        "), _c('span', [_vm._v("(" + _vm._s(commentuser.reputationScore) + ")")])]), _vm._v(" "), _c('span', [_vm._v("·")]), _vm._v(" "), _c('span', {
        staticClass: "font-14"
      }, [_vm._v(_vm._s(_vm.dateFormat(com.commentsTime)))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (com.cupordown),
          expression: "com.cupordown"
        }]
      }, [(com.editCommentsFlag) ? _c('div', [_c('div', {
        staticClass: "font-14 mt-3",
        domProps: {
          "innerHTML": _vm._s(com.commentsContext)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "social-list mt-3"
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.postingCommentsEvaluationList != null),
          expression: "postingCommentsEvaluationList != null"
        }]
      }, _vm._l((_vm.postingCommentsEvaluationList), function(pce, index) {
        return _c('ul', {
          key: index,
          staticClass: "list-inline d-inline-block"
        }, [_c('li', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (pce.commentsId == com.commentsId && pce.eStatus == 0),
            expression: "pce.commentsId == com.commentsId && pce.eStatus == 0"
          }]
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.bonus')
          }
        }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.bonus != null ? com.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "color": "primary",
            "title": _vm.$t('postingsel.upvote')
          },
          on: {
            "click": function($event) {
              return _vm.evaluateComment(com.commentsId, '0')
            }
          }
        }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('postingsel.tread')
          },
          on: {
            "click": function($event) {
              return _vm.evaluateComment(com.commentsId, '1')
            }
          }
        }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.comment')
          },
          on: {
            "click": function($event) {
              return _vm.changeData(com)
            }
          }
        }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.user != null && com.commentsUserId == _vm.user.userId),
            expression: "user != null && com.commentsUserId == user.userId"
          }],
          attrs: {
            "small": "",
            "title": _vm.$t('common.edit')
          },
          on: {
            "click": function($event) {
              return _vm.editComment(com)
            }
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('li', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (pce.commentsId == com.commentsId && pce.eStatus == 1),
            expression: "pce.commentsId == com.commentsId && pce.eStatus == 1"
          }]
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.bonus')
          }
        }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.bonus != null ? com.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('postingsel.upvote')
          },
          on: {
            "click": function($event) {
              return _vm.evaluateComment(com.commentsId, '0')
            }
          }
        }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "color": "primary",
            "title": _vm.$t('postingsel.tread')
          },
          on: {
            "click": function($event) {
              return _vm.evaluateComment(com.commentsId, '1')
            }
          }
        }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.comment')
          },
          on: {
            "click": function($event) {
              return _vm.changeData(com)
            }
          }
        }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.user != null && com.commentsUserId == _vm.user.userId),
            expression: "user != null && com.commentsUserId == user.userId"
          }],
          attrs: {
            "small": "",
            "title": _vm.$t('common.edit')
          },
          on: {
            "click": function($event) {
              return _vm.editComment(com)
            }
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('li', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (pce.commentsId == com.commentsId && pce.eStatus == -1),
            expression: "pce.commentsId == com.commentsId && pce.eStatus == -1"
          }]
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.bonus')
          }
        }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.bonus != null ? com.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('postingsel.upvote')
          },
          on: {
            "click": function($event) {
              return _vm.evaluateComment(com.commentsId, '0')
            }
          }
        }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('postingsel.tread')
          },
          on: {
            "click": function($event) {
              return _vm.evaluateComment(com.commentsId, '1')
            }
          }
        }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.comment')
          },
          on: {
            "click": function($event) {
              return _vm.changeData(com)
            }
          }
        }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.user != null && com.commentsUserId == _vm.user.userId),
            expression: "user != null && com.commentsUserId == user.userId"
          }],
          attrs: {
            "small": "",
            "title": _vm.$t('common.edit')
          },
          on: {
            "click": function($event) {
              return _vm.editComment(com)
            }
          }
        }, [_vm._v("edit")])], 1)])
      }), 0), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.postingCommentsEvaluationList == null),
          expression: "postingCommentsEvaluationList == null"
        }]
      }, [_c('ul', {
        staticClass: "list-inline d-inline-block"
      }, [_c('li', [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.bonus')
        }
      }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(com.bonus != null ? com.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.evaluateComment(com.commentsId, '0')
          }
        }
      }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(com.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.evaluateComment(com.commentsId, '1')
          }
        }
      }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(com.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.comment')
        },
        on: {
          "click": function($event) {
            return _vm.changeData(com)
          }
        }
      }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(com.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.user != null && com.commentsUserId == _vm.user.userId),
          expression: "user != null && com.commentsUserId == user.userId"
        }],
        attrs: {
          "small": "",
          "title": _vm.$t('common.edit')
        },
        on: {
          "click": function($event) {
            return _vm.editComment(com)
          }
        }
      }, [_vm._v("edit")])], 1)])])]), _vm._v(" "), (com.cshow) ? _c('div', {
        staticClass: "postingreplys"
      }, [_c('v-form', {
        ref: "formValidatereply",
        refInFor: true
      }, [_c('v-text-field', {
        staticClass: "d-none",
        model: {
          value: (com.commentsId),
          callback: function($$v) {
            _vm.$set(com, "commentsId", $$v)
          },
          expression: "com.commentsId"
        }
      }), _vm._v(" "), _c('quill-editor', {
        ref: "myQuillEditor",
        refInFor: true,
        staticClass: "mt-3 postCommentOfEditor",
        on: {
          "blur": function($event) {
            return _vm.onEditorBlur($event)
          },
          "focus": function($event) {
            return _vm.onEditorFocus($event)
          },
          "ready": function($event) {
            return _vm.onEditorReady($event)
          },
          "change": function($event) {
            return _vm.onEditorChange($event)
          }
        },
        model: {
          value: (_vm.formValidatereply.commentsContext),
          callback: function($$v) {
            _vm.$set(_vm.formValidatereply, "commentsContext", $$v)
          },
          expression: "formValidatereply.commentsContext"
        }
      }), _vm._v(" "), _c('v-btn', {
        attrs: {
          "color": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.postingreplys('formValidatereply', com)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('v-btn', {
        attrs: {
          "color": "primary",
          "type": "ghost"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.postingreplyclose(com)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1) : _vm._e()]) : _c('div', [_c('v-form', [_c('quill-editor', {
        ref: "myQuillEditor",
        refInFor: true,
        staticClass: "mt-3 postCommentOfEditor",
        on: {
          "blur": function($event) {
            return _vm.onEditorBlur($event)
          },
          "focus": function($event) {
            return _vm.onEditorFocus($event)
          },
          "ready": function($event) {
            return _vm.onEditorReady($event)
          },
          "change": function($event) {
            return _vm.onEditorChange($event)
          }
        },
        model: {
          value: (_vm.editCommentsContext),
          callback: function($$v) {
            _vm.editCommentsContext = $$v
          },
          expression: "editCommentsContext"
        }
      }), _vm._v(" "), _c('v-btn', {
        attrs: {
          "color": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.updateComment(com)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('v-btn', {
        attrs: {
          "color": "primary",
          "type": "ghost"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            com.editCommentsFlag = !com.editCommentsFlag
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1), _vm._v(" "), _vm._l((com.postingCommentList), function(rep, index) {
        return (rep.parentCommentId != null) ? _c('div', {
          staticClass: "mt-5"
        }, [_c('span', {
          staticClass: "right pointer pos-absolute ml-71",
          on: {
            "click": function($event) {
              return _vm.commentsUporDown($event, rep)
            }
          }
        }, [_c('Icon', {
          attrs: {
            "size": "20",
            "title": _vm.$t('postingsel.UporDown'),
            "type": "chevron-down"
          }
        })], 1), _vm._v(" "), _vm._l((_vm.usercommentsList), function(commentuser1, index) {
          return (rep.commentsUserId == commentuser1.userId) ? _c('div', {
            staticStyle: {
              "display": "flex"
            }
          }, [_c('dt', [_c('v-avatar', {
            staticClass: "pointer",
            attrs: {
              "color": "primary",
              "size": "32"
            },
            on: {
              "click": function($event) {
                return _vm.goUserData(commentuser1.userName)
              }
            }
          }, [_c('img', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (commentuser1.image != null),
              expression: "commentuser1.image != null"
            }],
            attrs: {
              "src": commentuser1.image,
              "alt": commentuser1.userName
            }
          }), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (commentuser1.image == null),
              expression: "commentuser1.image == null"
            }],
            staticClass: "white--text"
          }, [_vm._v("\n                                  " + _vm._s(commentuser1.userName != null ? commentuser1.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                ")])])], 1), _vm._v(" "), _c('dd', {
            staticClass: "ml-2"
          }, [_c('span', {
            staticClass: "pointer font-16",
            on: {
              "click": function($event) {
                return _vm.goUserData(commentuser1.userName)
              }
            }
          }, [_vm._v("\n                                " + _vm._s(commentuser1.nickName) + "\n                                "), _c('span', [_vm._v("(" + _vm._s(commentuser1.reputationScore) + ")")])]), _vm._v(" "), _c('span', [_vm._v("·")]), _vm._v(" "), _c('span', {
            staticClass: "font-14"
          }, [_vm._v(_vm._s(_vm.dateFormat(rep.commentsTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (rep.cupordown),
              expression: "rep.cupordown"
            }]
          }, [(rep.editCommentsFlag) ? _c('div', [_c('div', {
            staticClass: "font-14 mt-3",
            domProps: {
              "innerHTML": _vm._s(rep.commentsContext)
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "social-list mt-3"
          }, [_c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.postingCommentsEvaluationList != null),
              expression: "postingCommentsEvaluationList != null"
            }]
          }, _vm._l((_vm.postingCommentsEvaluationList), function(pce, index) {
            return _c('ul', {
              key: index,
              staticClass: "list-inline d-inline-block"
            }, [_c('li', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (pce.commentsId == rep.commentsId && pce.eStatus == 0),
                expression: "pce.commentsId == rep.commentsId && pce.eStatus == 0"
              }]
            }, [_c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('posting.bonus')
              }
            }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
              staticClass: "font-14"
            }, [_vm._v(_vm._s(rep.bonus != null ? rep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "color": "primary",
                "title": _vm.$t('postingsel.upvote')
              },
              on: {
                "click": function($event) {
                  return _vm.evaluateComment(rep.commentsId, '0')
                }
              }
            }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('postingsel.tread')
              },
              on: {
                "click": function($event) {
                  return _vm.evaluateComment(rep.commentsId, '1')
                }
              }
            }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('posting.comment')
              },
              on: {
                "click": function($event) {
                  return _vm.changeData(rep)
                }
              }
            }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (_vm.user != null && rep.commentsUserId == _vm.user.userId),
                expression: "user != null && rep.commentsUserId == user.userId"
              }],
              attrs: {
                "small": "",
                "title": _vm.$t('common.edit')
              },
              on: {
                "click": function($event) {
                  return _vm.editComment(rep)
                }
              }
            }, [_vm._v("edit")])], 1), _vm._v(" "), _c('li', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (pce.commentsId == rep.commentsId && pce.eStatus == 1),
                expression: "pce.commentsId == rep.commentsId && pce.eStatus == 1"
              }]
            }, [_c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('posting.bonus')
              }
            }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
              staticClass: "font-14"
            }, [_vm._v(_vm._s(rep.bonus != null ? rep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('postingsel.upvote')
              },
              on: {
                "click": function($event) {
                  return _vm.evaluateComment(rep.commentsId, '0')
                }
              }
            }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "color": "primary",
                "title": _vm.$t('postingsel.tread')
              },
              on: {
                "click": function($event) {
                  return _vm.evaluateComment(rep.commentsId, '1')
                }
              }
            }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('posting.comment')
              },
              on: {
                "click": function($event) {
                  return _vm.changeData(rep)
                }
              }
            }, [_vm._v("fa fa-comment")]), _vm._v("<\n                                          "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (_vm.user != null && rep.commentsUserId == _vm.user.userId),
                expression: "user != null && rep.commentsUserId == user.userId"
              }],
              attrs: {
                "small": "",
                "title": _vm.$t('common.edit')
              },
              on: {
                "click": function($event) {
                  return _vm.editComment(rep)
                }
              }
            }, [_vm._v("edit")])], 1), _vm._v(" "), _c('li', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (pce.commentsId == rep.commentsId && pce.eStatus == -1),
                expression: "pce.commentsId == rep.commentsId && pce.eStatus == -1"
              }]
            }, [_c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('posting.bonus')
              }
            }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
              staticClass: "font-14"
            }, [_vm._v(_vm._s(rep.bonus != null ? rep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('postingsel.upvote')
              },
              on: {
                "click": function($event) {
                  return _vm.evaluateComment(rep.commentsId, '0')
                }
              }
            }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('postingsel.tread')
              },
              on: {
                "click": function($event) {
                  return _vm.evaluateComment(rep.commentsId, '1')
                }
              }
            }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('posting.comment')
              },
              on: {
                "click": function($event) {
                  return _vm.changeData(rep)
                }
              }
            }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (_vm.user != null && rep.commentsUserId == _vm.user.userId),
                expression: "user != null && rep.commentsUserId == user.userId"
              }],
              attrs: {
                "small": "",
                "title": _vm.$t('common.edit')
              },
              on: {
                "click": function($event) {
                  return _vm.editComment(rep)
                }
              }
            }, [_vm._v("edit")])], 1)])
          }), 0), _vm._v(" "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.postingCommentsEvaluationList == null),
              expression: "postingCommentsEvaluationList == null"
            }]
          }, [_c('ul', {
            staticClass: "list-inline d-inline-block"
          }, [_c('li', [_c('v-icon', {
            attrs: {
              "small": "",
              "title": _vm.$t('posting.bonus')
            }
          }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
            staticClass: "font-14"
          }, [_vm._v(_vm._s(rep.bonus != null ? rep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
            attrs: {
              "small": "",
              "title": _vm.$t('postingsel.upvote')
            },
            on: {
              "click": function($event) {
                return _vm.evaluateComment(rep.commentsId, '0')
              }
            }
          }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
            staticClass: "font-14 ml-1"
          }, [_vm._v(_vm._s(rep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
            attrs: {
              "small": "",
              "title": _vm.$t('postingsel.tread')
            },
            on: {
              "click": function($event) {
                return _vm.evaluateComment(rep.commentsId, '1')
              }
            }
          }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
            staticClass: "font-14 ml-1"
          }, [_vm._v(_vm._s(rep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
            attrs: {
              "small": "",
              "title": _vm.$t('posting.comment')
            },
            on: {
              "click": function($event) {
                return _vm.changeData(rep)
              }
            }
          }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
            staticClass: "font-14 ml-1"
          }, [_vm._v(_vm._s(rep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.user != null && rep.commentsUserId == _vm.user.userId),
              expression: "user != null && rep.commentsUserId == user.userId"
            }],
            attrs: {
              "small": "",
              "title": _vm.$t('common.edit')
            },
            on: {
              "click": function($event) {
                return _vm.editComment(rep)
              }
            }
          }, [_vm._v("edit")])], 1)])])]), _vm._v(" "), (rep.cshow) ? _c('div', {
            staticClass: "postingreplys"
          }, [_c('v-form', {
            ref: "formValidatereply",
            refInFor: true
          }, [_c('v-text-field', {
            staticClass: "d-none",
            model: {
              value: (rep.commentsId),
              callback: function($$v) {
                _vm.$set(rep, "commentsId", $$v)
              },
              expression: "rep.commentsId"
            }
          }), _vm._v(" "), _c('quill-editor', {
            ref: "myQuillEditor",
            refInFor: true,
            staticClass: "mt-3 postCommentOfEditor",
            attrs: {
              "options": _vm.editorOption
            },
            on: {
              "blur": function($event) {
                return _vm.onEditorBlur($event)
              },
              "focus": function($event) {
                return _vm.onEditorFocus($event)
              },
              "ready": function($event) {
                return _vm.onEditorReady($event)
              },
              "change": function($event) {
                return _vm.onEditorChange($event)
              }
            },
            model: {
              value: (_vm.formValidatereply.commentsContext),
              callback: function($$v) {
                _vm.$set(_vm.formValidatereply, "commentsContext", $$v)
              },
              expression: "formValidatereply.commentsContext"
            }
          }), _vm._v(" "), _c('v-btn', {
            attrs: {
              "color": "primary"
            },
            on: {
              "click": function($event) {
                return _vm.postingreplys('formValidatereply', rep)
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('postingcreate.Post')))]), _vm._v(" "), _c('v-btn', {
            attrs: {
              "color": "primary",
              "type": "ghost"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.postingreplyclose(rep)
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1) : _vm._e()]) : _c('div', [_c('v-form', [_c('quill-editor', {
            ref: "myQuillEditor",
            refInFor: true,
            staticClass: "mt-3 postCommentOfEditor",
            on: {
              "blur": function($event) {
                return _vm.onEditorBlur($event)
              },
              "focus": function($event) {
                return _vm.onEditorFocus($event)
              },
              "ready": function($event) {
                return _vm.onEditorReady($event)
              },
              "change": function($event) {
                return _vm.onEditorChange($event)
              }
            },
            model: {
              value: (_vm.editCommentsContext),
              callback: function($$v) {
                _vm.editCommentsContext = $$v
              },
              expression: "editCommentsContext"
            }
          }), _vm._v(" "), _c('v-btn', {
            attrs: {
              "color": "primary"
            },
            on: {
              "click": function($event) {
                return _vm.updateComment(rep)
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('v-btn', {
            attrs: {
              "color": "primary",
              "type": "ghost"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                rep.editCommentsFlag = !rep.editCommentsFlag
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1), _vm._v(" "), _vm._l((rep.postingCommentList), function(reptorep, index) {
            return _c('div', {
              staticClass: "mt-5"
            }, [_c('span', {
              staticClass: "pointer right pos-absolute ml-68",
              on: {
                "click": function($event) {
                  return _vm.commentsUporDown($event, reptorep)
                }
              }
            }, [_c('Icon', {
              attrs: {
                "title": _vm.$t('postingsel.UporDown'),
                "size": "20",
                "type": "chevron-down"
              }
            })], 1), _vm._v(" "), _vm._l((_vm.usercommentsList), function(commentuser2, index) {
              return (reptorep.commentsUserId == commentuser2.userId) ? _c('div', {
                staticClass: "d-custom-flex font-14"
              }, [_c('dt', [_c('v-avatar', {
                staticClass: "pointer",
                attrs: {
                  "color": "primary",
                  "size": "32"
                },
                on: {
                  "click": function($event) {
                    return _vm.goUserData(commentuser2.userName)
                  }
                }
              }, [_c('img', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (commentuser2.image != null),
                  expression: "commentuser2.image != null"
                }],
                attrs: {
                  "src": commentuser2.image,
                  "alt": commentuser2.userName
                }
              }), _vm._v(" "), _c('span', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (commentuser2.image == null),
                  expression: "commentuser2.image == null"
                }],
                staticClass: "white--text"
              }, [_vm._v("\n                                          " + _vm._s(commentuser2.userName != null ? commentuser2.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                        ")])])], 1), _vm._v(" "), _c('dd', {
                staticStyle: {
                  "margin-left": "10px"
                }
              }, [_c('span', {
                staticClass: "pointer font-16",
                on: {
                  "click": function($event) {
                    return _vm.goUserData(commentuser2.userName)
                  }
                }
              }, [_vm._v("\n                                        " + _vm._s(commentuser2.nickName) + "\n                                        "), _c('span', [_vm._v("(" + _vm._s(commentuser2.reputationScore) + ")")])]), _vm._v(" "), _c('span', [_vm._v("·")]), _vm._v(" "), _c('span', {
                staticClass: "font-14"
              }, [_vm._v(_vm._s(_vm.dateFormat(reptorep.commentsTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (reptorep.cupordown),
                  expression: "reptorep.cupordown"
                }]
              }, [(reptorep.editCommentsFlag) ? _c('div', [_c('div', {
                staticClass: "font-14 mt-3",
                domProps: {
                  "innerHTML": _vm._s(reptorep.commentsContext)
                }
              }), _vm._v(" "), _c('div', {
                staticClass: "social-list mt-3 mb-4"
              }, [_c('div', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (_vm.postingCommentsEvaluationList != null),
                  expression: "postingCommentsEvaluationList != null"
                }]
              }, _vm._l((_vm.postingCommentsEvaluationList), function(pce, index) {
                return _c('ul', {
                  key: index,
                  staticClass: "list-inline d-inline-block"
                }, [_c('li', {
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (pce.commentsId == reptorep.commentsId && pce.eStatus == 0),
                    expression: "pce.commentsId == reptorep.commentsId && pce.eStatus == 0"
                  }]
                }, [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('posting.bonus')
                  }
                }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14"
                }, [_vm._v(_vm._s(reptorep.bonus != null ? reptorep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "primary",
                    "title": _vm.$t('postingsel.upvote')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.evaluateComment(reptorep.commentsId, '0')
                    }
                  }
                }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('postingsel.tread')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.evaluateComment(reptorep.commentsId, '1')
                    }
                  }
                }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('posting.comment')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.changereplytoreply(reptorep, commentuser2)
                    }
                  }
                }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (_vm.user != null && reptorep.commentsUserId == _vm.user.userId),
                    expression: "user != null && reptorep.commentsUserId == user.userId"
                  }],
                  attrs: {
                    "small": "",
                    "title": _vm.$t('common.edit')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.editComment(reptorep)
                    }
                  }
                }, [_vm._v("edit")])], 1), _vm._v(" "), _c('li', {
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (pce.commentsId == reptorep.commentsId && pce.eStatus == 1),
                    expression: "pce.commentsId == reptorep.commentsId && pce.eStatus == 1"
                  }]
                }, [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('posting.bonus')
                  }
                }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14"
                }, [_vm._v(_vm._s(reptorep.bonus != null ? reptorep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('postingsel.upvote')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.evaluateComment(reptorep.commentsId, '0')
                    }
                  }
                }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "primary",
                    "title": _vm.$t('postingsel.tread')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.evaluateComment(reptorep.commentsId, '1')
                    }
                  }
                }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('posting.comment')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.changereplytoreply(reptorep, commentuser2)
                    }
                  }
                }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (_vm.user != null && reptorep.commentsUserId == _vm.user.userId),
                    expression: "user != null && reptorep.commentsUserId == user.userId"
                  }],
                  attrs: {
                    "small": "",
                    "title": _vm.$t('common.edit')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.editComment(reptorep)
                    }
                  }
                }, [_vm._v("edit")])], 1), _vm._v(" "), _c('li', {
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (pce.commentsId == reptorep.commentsId && pce.eStatus == -1),
                    expression: "pce.commentsId == reptorep.commentsId && pce.eStatus == -1"
                  }]
                }, [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('posting.bonus')
                  }
                }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.bonus != null ? reptorep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('postingsel.upvote')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.evaluateComment(reptorep.commentsId, '0')
                    }
                  }
                }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('postingsel.tread')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.evaluateComment(reptorep.commentsId, '1')
                    }
                  }
                }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('posting.comment')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.changereplytoreply(reptorep, commentuser2)
                    }
                  }
                }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (_vm.user != null && reptorep.commentsUserId == _vm.user.userId),
                    expression: "user != null && reptorep.commentsUserId == user.userId"
                  }],
                  attrs: {
                    "small": "",
                    "title": _vm.$t('common.edit')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.editComment(reptorep)
                    }
                  }
                }, [_vm._v("edit")])], 1)])
              }), 0), _vm._v(" "), _c('div', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (_vm.postingCommentsEvaluationList == null),
                  expression: "postingCommentsEvaluationList == null"
                }]
              }, [_c('ul', {
                staticClass: "list-inline d-inline-block"
              }, [_c('li', [_c('v-icon', {
                attrs: {
                  "small": "",
                  "title": _vm.$t('posting.bonus')
                }
              }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
                staticClass: "font-14"
              }, [_vm._v(_vm._s(reptorep.bonus != null ? reptorep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
                attrs: {
                  "small": "",
                  "title": _vm.$t('postingsel.upvote')
                },
                on: {
                  "click": function($event) {
                    return _vm.evaluateComment(reptorep.commentsId, '0')
                  }
                }
              }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
                staticClass: "font-14 ml-1"
              }, [_vm._v(_vm._s(reptorep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
                attrs: {
                  "small": "",
                  "title": _vm.$t('postingsel.tread')
                },
                on: {
                  "click": function($event) {
                    return _vm.evaluateComment(reptorep.commentsId, '1')
                  }
                }
              }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
                staticClass: "font-14 ml-1"
              }, [_vm._v(_vm._s(reptorep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
                attrs: {
                  "small": "",
                  "title": _vm.$t('posting.comment')
                },
                on: {
                  "click": function($event) {
                    return _vm.changereplytoreply(reptorep, commentuser2)
                  }
                }
              }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
                staticClass: "font-14 ml-1"
              }, [_vm._v(_vm._s(reptorep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (_vm.user != null && reptorep.commentsUserId == _vm.user.userId),
                  expression: "user != null && reptorep.commentsUserId == user.userId"
                }],
                attrs: {
                  "small": "",
                  "title": _vm.$t('common.edit')
                },
                on: {
                  "click": function($event) {
                    return _vm.editComment(reptorep)
                  }
                }
              }, [_vm._v("edit")])], 1)])])]), _vm._v(" "), (reptorep.cshow) ? _c('div', {
                staticClass: "postingreplys"
              }, [_c('v-form', {
                ref: "formValidatereplytoreply",
                refInFor: true
              }, [_c('v-text-field', {
                staticClass: "d-none",
                model: {
                  value: (rep.commentsId),
                  callback: function($$v) {
                    _vm.$set(rep, "commentsId", $$v)
                  },
                  expression: "rep.commentsId"
                }
              }), _vm._v(" "), _c('quill-editor', {
                ref: "myQuillEditor",
                refInFor: true,
                staticClass: "mt-3 postCommentOfEditor",
                attrs: {
                  "options": _vm.editorOption
                },
                on: {
                  "blur": function($event) {
                    return _vm.onEditorBlur($event)
                  },
                  "focus": function($event) {
                    return _vm.onEditorFocus($event)
                  },
                  "ready": function($event) {
                    return _vm.onEditorReady($event)
                  },
                  "change": function($event) {
                    return _vm.onEditorChange($event)
                  }
                },
                model: {
                  value: (_vm.formValidatereplytoreply.commentsContext),
                  callback: function($$v) {
                    _vm.$set(_vm.formValidatereplytoreply, "commentsContext", $$v)
                  },
                  expression: "formValidatereplytoreply.commentsContext"
                }
              }), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "color": "primary"
                },
                on: {
                  "click": function($event) {
                    return _vm.postingreplytoreplys('formValidatereplytoreply', rep)
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('v-btn', {
                staticClass: "primary white--text",
                attrs: {
                  "color": "primary"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.postingreplyclose(reptorep)
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1) : _vm._e()]) : _c('div', [_c('v-form', [_c('quill-editor', {
                ref: "myQuillEditor",
                refInFor: true,
                staticClass: "mt-3 postCommentOfEditor",
                on: {
                  "blur": function($event) {
                    return _vm.onEditorBlur($event)
                  },
                  "focus": function($event) {
                    return _vm.onEditorFocus($event)
                  },
                  "ready": function($event) {
                    return _vm.onEditorReady($event)
                  },
                  "change": function($event) {
                    return _vm.onEditorChange($event)
                  }
                },
                model: {
                  value: (_vm.editCommentsContext),
                  callback: function($$v) {
                    _vm.editCommentsContext = $$v
                  },
                  expression: "editCommentsContext"
                }
              }), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "color": "primary"
                },
                on: {
                  "click": function($event) {
                    return _vm.updateComment(reptorep)
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "color": "primary",
                  "type": "ghost"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    reptorep.editCommentsFlag = !reptorep.editCommentsFlag
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1)])])]) : _vm._e()
            })], 2)
          })], 2)])]) : _vm._e()
        })], 2) : _vm._e()
      })], 2)])]) : _vm._e()
    })], 2)
  }), 0)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    class: _vm.isLogin ? 'mt-70' : ''
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_vm._l((_vm.marketList), function(market) {
    return (market.name == _vm.marketsName) ? _c('v-card', {
      key: market.marketId,
      staticClass: "mb-3"
    }, [_c('v-img', {
      attrs: {
        "height": "200",
        "src": market.image
      }
    }, [_c('v-container', {
      attrs: {
        "fill-height": "",
        "fluid": "",
        "pa-2": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "fill-height": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "font-20 fw-700 white--text ml-3",
      domProps: {
        "textContent": _vm._s(_vm.marketsName)
      }
    })])], 1)], 1)], 1)], 1) : _vm._e()
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('div', [_vm._l((_vm.postList), function(post, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-4"
    }, [_c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media"
    }, _vm._l((_vm.userDetailList), function(user, index) {
      return (post.postingUserId == user.userId) ? _c('div', {
        key: index,
        staticClass: "ml-2 pt-3 mr-2"
      }, [_c('div', {
        staticClass: "mb-3"
      }, [_c('v-avatar', {
        staticClass: "pointer",
        attrs: {
          "color": "primary",
          "size": "34"
        },
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image != null),
          expression: "user.image != null"
        }],
        attrs: {
          "src": user.image,
          "alt": user.userName
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image == null),
          expression: "user.image == null"
        }],
        staticClass: "headline white--text"
      }, [_vm._v("\n                            " + _vm._s(user.userName
        .trim()
        .substring(0, 1)
        .toLocaleUpperCase()) + "\n                          ")])]), _vm._v(" "), _c('span', {
        staticClass: "pl-2 pointer hover-color font-16 fw-700",
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_vm._v("\n                          " + _vm._s(user.nickName) + "\n                          "), _c('span', [_vm._v("(" + _vm._s(user.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
        staticClass: "px-2 fw-500 font-14"
      }, [_c('v-icon', {
        attrs: {
          "size": "16"
        }
      }, [_vm._v("schedule")]), _vm._v("\n                          " + _vm._s(_vm.dateFormat(post.postingTime)) + "\n                        ")], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_vm._l((_vm.userDetailList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('div', {
          key: index,
          staticClass: "px-0"
        }, [(post.postingImg != '') ? _c('span', {
          staticClass: "rounded-circle mr-4 img-responsive posts-image pointer",
          domProps: {
            "innerHTML": _vm._s(post.postingImg)
          },
          on: {
            "click": function($event) {
              return _vm.findsel(post)
            }
          }
        }) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), _c('div', {
        staticClass: "media-body"
      }, [_c('h2', {
        staticClass: "fw-700 pointer break-word",
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v(_vm._s(post.postingTitle))]), _vm._v(" "), _c('h4', {
        staticClass: "mb-3 py-2",
        domProps: {
          "innerHTML": _vm._s(post.postingContent)
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "mt-1 justify-space-between"
      }, [_c('div', {
        staticClass: "social"
      }, [_c('span', {
        staticClass: "pointer"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.bonus')
        }
      }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
        staticClass: "font-1x fw-400 ml-1"
      }, [_vm._v(_vm._s(post.bonus.toFixed(2)))])], 1), _vm._v(" "), (post.postingStatus == 0) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == 1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == -1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.comment')
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingCountComments))])], 1), _vm._v(" "), _vm._l((_vm.userDetailList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('span', {
          staticClass: "ml-2"
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.retweet')
          },
          on: {
            "click": function($event) {
              return _vm.modalzf(post, user)
            }
          }
        }, [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 fw-400 ml-1"
        }, [_vm._v(_vm._s(post.postingCountForword))])], 1) : _vm._e()
      }), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [(post.postingCollection == 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("\n                                  fa fa-star\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('span', [(post.postingCollection != 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("fa fa-star")]) : _vm._e()], 1)], 2)])])], 2), _vm._v(" "), _c('div', {
        staticClass: "mt-3"
      }, _vm._l((_vm.commentList), function(postcomments, index) {
        return (post.postingId == postcomments.commentsPostingId) ? _c('span', {
          key: index,
          staticClass: "flex-middle"
        }, [_vm._l((_vm.commentUserDetailList), function(userpopular, index) {
          return (postcomments.commentsUserId == userpopular.userId) ? _c('span', {
            key: index
          }, [_c('v-avatar', {
            staticClass: "pointer",
            attrs: {
              "color": "primary",
              "size": "32"
            },
            on: {
              "click": function($event) {
                return _vm.goUserData(userpopular.userName)
              }
            }
          }, [_c('img', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (userpopular.image != null),
              expression: "userpopular.image != null"
            }],
            attrs: {
              "src": userpopular.image,
              "alt": userpopular.userName
            }
          }), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (userpopular.image == null),
              expression: "userpopular.image == null"
            }],
            staticClass: "headline white--text"
          }, [_vm._v("\n                                " + _vm._s(userpopular.userName
            .trim()
            .substring(0, 1)
            .toLocaleUpperCase()) + "\n                              ")])])], 1) : _vm._e()
        }), _vm._v(" "), _c('span', {
          staticClass: "font-14 fw-500 ml-2"
        }, [(post.postingContent.length > 20) ? _c('span', [_vm._v(_vm._s(postcomments.commentsContext))]) : _c('span', [_vm._v(_vm._s(postcomments.commentsContext) + "……")])])], 2) : _vm._e()
      }), 0)]) : _vm._e()
    }), 0)])])])
  }), _vm._v(" "), _c('infinite-loading', {
    staticClass: "mb-3",
    attrs: {
      "identifier": _vm.timestamp
    },
    on: {
      "infinite": _vm.getPostList
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t("posting.noMore")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t("posting.noResults")))])])], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.forwardModal),
      callback: function($$v) {
        _vm.forwardModal = $$v
      },
      expression: "forwardModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "font-30 fw-500"
  }, [_vm._v(_vm._s(_vm.$t('posting.retweet')))])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "32"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage != null),
      expression: "postUserImage != null"
    }],
    attrs: {
      "src": _vm.postUserImage,
      "alt": _vm.postUserName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage == null),
      expression: "postUserImage == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v("\n                          " + _vm._s(_vm.postUserName
    .trim()
    .substring(0, 1)
    .toLocaleUpperCase()) + "\n                        ")])])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
    staticClass: "pointer font-18 fw-700",
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_vm._v(_vm._s(_vm.postNickName))]), _vm._v(" "), _c('span', {
    staticClass: "px-2 font-16 fw-700"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('common.at')) + "\n                          "), _c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("schedule")]), _vm._v("\n                          " + _vm._s(_vm.dateFormat(_vm.postDate)) + "\n                        ")], 1)]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', {
    staticClass: "font-14 fw-700"
  }, [_vm._v(_vm._s(_vm.postTitle))])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-form', {
    ref: "formValidatezf"
  }, [_c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "input-7-4"
    },
    model: {
      value: (_vm.formValidatezf.postingForwardContext),
      callback: function($$v) {
        _vm.$set(_vm.formValidatezf, "postingForwardContext", $$v)
      },
      expression: "formValidatezf.postingForwardContext"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.forwardModal = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.postingforward
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "lg4": ""
    }
  }, [_c('app-right')], 1)], 1)], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('app-header'), _vm._v(" "), _c('div', {
    class: _vm.isLogin ? 'mt-70' : ''
  }), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-7": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md7": "",
      "lg10": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "font-30 fw-700 mb-5 text-center"
  }, [_vm._v("AML Policy")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 fw-400"
  }, [_c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("1. Firm Policy")]), _vm._v(" "), _c('p', [_vm._v("\n              It is the policy of the firm to prohibit and actively prevent money laundering and any activity that facilitates money laundering or the funding of\n              terrorist or criminal activities by complying with all applicable requirements under the Bank Secrecy Act (BSA) and its implementing regulations.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Money laundering is generally defined as engaging in acts designed to conceal or disguise the true origins of criminally derived proceeds so that\n              the proceeds appear to have derived from legitimate origins or constitute legitimate assets. Generally, money laundering occurs in three stages.\n              Cash first enters the financial system at the “placement” stage, where the cash generated from criminal activities is converted into monetary\n              instruments, such as money orders or traveler’s checks, or deposited into accounts at financial institutions. At the “layering” stage, the funds are\n              transferred or moved into other accounts or other financial institutions to further separate the money from its criminal origin. At the\n              “integration” stage, the funds are reintroduced into the economy and used to purchase legitimate assets or to fund other criminal activities or\n              legitimate businesses.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Terrorist financing may not involve the proceeds of criminal conduct, but rather an attempt to conceal either the origin of the funds or their\n              intended use, which could be for criminal purposes. Legitimate sources of funds are a key difference between terrorist financiers and traditional\n              criminal organizations. In addition to charitable donations, legitimate sources include foreign government sponsors, business ownership and personal\n              employment. Although the motivation differs between traditional money launderers and terrorist financiers, the actual methods used to fund terrorist\n              operations can be the same as or similar to methods used by other criminals to launder funds. Funding for terrorist attacks does not always require\n              large sums of money and the associated transactions may not be complex.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Our AML policies, procedures and internal controls are designed to ensure compliance with all applicable BSA regulations and FINRA rules and will be\n              reviewed and updated on a regular basis to ensure appropriate policies, procedures and internal controls are in place to account for both changes in\n              regulations and changes in our business.\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("2. AML Compliance Person Designation and Duties")]), _vm._v(" "), _c('p', [_vm._v("\n              The firm has designated Zhenhao Fei as its Anti-Money Laundering Program Compliance Person (AML Compliance Person), with full responsibility for the\n              firm’s AML program. Zhenhao Fei has a working knowledge of the BSA and its implementing regulations and is qualified by experience, knowledge and\n              training. The duties of the AML Compliance Person will include monitoring the firm’s compliance with AML obligations, overseeing communication and\n              training for employees. The AML Compliance Person will also ensure that the firm keeps and maintains all of the required AML records and will ensure\n              that Suspicious Activity Reports (SAR-SFs) are filed with the Financial Crimes Enforcement Network (FinCEN) when appropriate. The AML Compliance\n              Person is vested with full responsibility and authority to enforce the firm’s AML program.\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("3. Giving AML Information to Federal Law Enforcement Agencies and Other Financial Institutions")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("a. FinCEN Requests Under USA PATRIOT Act Section 314(a)")])]), _vm._v(" "), _c('p', [_vm._v("\n              We will respond to a Financial Crimes Enforcement Network (FinCEN) request concerning accounts and transactions (a 314(a) Request) by immediately\n              searching our records to determine whether we maintain or have maintained any account for, or have engaged in any transaction with, each individual,\n              entity or organization named in the 314(a) Request as outlined in the Frequently Asked Questions (FAQ) located on FinCEN’s secure Web site. We\n              understand that we have 14 days (unless otherwise specified by FinCEN) from the transmission date of the request to respond to a 314(a) Request. We\n              will designate through the FINRA Contact System (FCS) one or more persons to be the point of contact (POC) for 314(a) Requests and will promptly\n              update the POC information following any change in such information. (See also Section 2 above regarding updating of contact information for the AML\n              Compliance Person.) Unless otherwise stated in the 314(a) Request or specified by FinCEN, we are required to search those documents outlined in\n              FinCEN’s FAQ. If we find a match, Zhenhao Fei will report it to FinCEN via FinCEN’s Web-based 314(a) Secure Information Sharing System within 14\n              days or within the time requested by FinCEN in the request. If the search parameters differ from those mentioned above (for example, if FinCEN\n              limits the search to a geographic location), Zhenhao Fei will structure our search accordingly.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will not disclose the fact that FinCEN has requested or obtained information from us, except to the extent necessary to comply with the\n              information request. Zhenhao Fei will review, maintain and implement procedures to protect the security and confidentiality of requests from FinCEN\n              similar to those procedures established to satisfy the requirements of Section 501 of the Gramm-Leach-Bliley Act with regard to the protection of\n              customers’ nonpublic information.\n            ")]), _vm._v(" "), _c('p', [_vm._v("We will direct any questions we have about the 314(a) Request to the requesting federal law enforcement agency as designated in the request.")]), _vm._v(" "), _c('p', [_vm._v("\n              Unless otherwise stated in the 314(a) Request, we will not be required to treat the information request as continuing in nature, and we will not be\n              required to treat the periodic 314(a) Requests as a government provided list of suspected terrorists for purposes of the customer identification and\n              verification requirements.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("b.Grand Jury Subpoenas")])]), _vm._v(" "), _c('p', [_vm._v("\n              We understand that the receipt of a grand jury subpoena concerning a customer does not in itself require that we file a Suspicious Activity Report\n              (SAR-SF). When we receive a grand jury subpoena, we will conduct a risk assessment of the customer subject to the subpoena as well as review the\n              customer’s account activity. If we uncover suspicious activity during our risk assessment and review, we will elevate that customer’s risk\n              assessment and file a SAR-SF in accordance with the SAR-SF filing requirements. We understand that none of our officers, employees or agents may\n              directly or indirectly disclose to the person who is the subject of the subpoena its existence, its contents or the information we used to respond\n              to it. To maintain the confidentiality of any grand jury subpoena we receive, we will process and maintain the subpoena. If we file a SAR-SF after\n              receiving a grand jury subpoena, the SAR-SF will not contain any reference to the receipt or existence of the subpoena. The SAR-SF will only contain\n              detailed information about the facts and circumstances of the detected suspicious activity.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("c. Voluntary Information Sharing With Other Financial Institutions Under USA PATRIOT Act Section 314(b)")])]), _vm._v(" "), _c('p', [_vm._v("\n              We will share information with other financial institutions regarding individuals, entities, organizations, and countries for purposes of\n              identifying and, where appropriate, reporting activities that we suspect may involve possible terrorist activity or money laundering. Zhenhao Fei\n              will ensure that the firm files with FinCEN an initial notice before any sharing occurs and annual notices thereafter. We will use the notice form\n              found at FinCEN’s Web site. Before we share information with another financial institution, we will take reasonable steps to verify that the other\n              financial institution has submitted the requisite notice to FinCEN, either by obtaining confirmation from the financial institution or by consulting\n              a list of such financial institutions that FinCEN will make available. We understand that this requirement applies even to financial institutions\n              with which we are affiliated and that we will obtain the requisite notices from affiliates and follow all required procedures.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will employ strict procedures both to ensure that only relevant information is shared and to protect the security and confidentiality of this\n              information, for example, by segregating it from the firm’s other books and records.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We also will employ procedures to ensure that any information received from another financial institution shall not be used for any purpose other\n              than:\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("identifying and, where appropriate, reporting on money laundering or terrorist activities;")]), _vm._v(" "), _c('li', [_vm._v("determining whether to establish or maintain an account, or to engage in a transaction;")]), _vm._v(" "), _c('li', [_vm._v("or assisting the financial institution in complying with performing such activities.")])]), _vm._v(" "), _c('h5', {
    staticClass: "mt-3"
  }, [_c('strong', [_vm._v("d. Joint Filing of SARs by Broker-Dealers and Other Financial Institutions")])]), _vm._v(" "), _c('p', [_vm._v("\n              We will file joint SARs in required circumstances. We will also share information about a particular suspicious transaction with any broker-dealer,\n              as appropriate, involved in that particular transaction for purposes of determining whether we will file jointly a SAR-SF.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will share information about particular suspicious transactions with our clearing broker for purposes of determining whether we and our clearing\n              broker will file jointly a SAR-SF. In cases in which we file a joint SAR-SF for a transaction that has been handled both by us and by the clearing\n              broker, we may share with the clearing broker a copy of the filed SAR-SF.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              If we determine it is appropriate to jointly file a SAR-SF, we understand that we cannot disclose that we have filed a SAR-SF to any financial\n              institution except the financial institution that is filing jointly. If we determine it is not appropriate to file jointly (e.g., because the SAR-SF\n              concerns the other broker-dealer or one of its employees), we understand that we cannot disclose that we have filed a SAR-SF to any other financial\n              institution or insurance company.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("f. Checking the Office of Foreign Assets Control Listings")])]), _vm._v(" "), _c('p', [_vm._v("\n              Before opening an account, and on an ongoing basis, Zhenhao Fei will check to ensure that a customer does not appear on the SDN list or is not\n              engaging in transactions that are prohibited by the economic sanctions and embargoes administered and enforced by OFAC. (See the OFAC Web site for\n              the SDN list and listings of current sanctions and embargoes). Because the SDN list and listings of economic sanctions and embargoes are updated\n              frequently, we will consult them on a regular basis and subscribe to receive any available updates when they occur. With respect to the SDN list, we\n              may also access that list through various software programs to ensure speed and accuracy. Zhenhao Fei will also review existing accounts against the\n              SDN list and listings of current sanctions and embargoes when they are updated and he will document the review.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              If we determine that a customer is on the SDN list or is engaging in transactions that are prohibited by the economic sanctions and embargoes\n              administered and enforced by OFAC, we will reject the transaction and/or block the customer’s assets and file a blocked assets and/or rejected\n              transaction form with OFAC within 10 days. We will also call the OFAC Hotline at (800) 540-6322 immediately.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Our review will include customer accounts, transactions involving customers (including activity that passes through the firm such as wires) and the\n              review of customer transactions that involve physical security certificates or application-based investments (e.g., mutual funds).\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("5. Customer Identification Program")]), _vm._v(" "), _c('p', [_vm._v("\n              In addition to the information we must collect under FINRA Rule 2010 (Standards of Commercial Honor and Principles of Trade), NASD Rules 2310\n              (Recommendations to Customers – Suitability) and 3110 (Books and Records) and Securities Exchange Act of 1934 (Exchange Act) Rules 17a-3(a)(9)\n              (Beneficial Ownership regarding Cash and Margin Accounts) and 17a-3(a)(17) (Customer Accounts), we have established, documented and maintained a\n              written Customer Identification Program (CIP). We will collect certain minimum customer identification information from each customer who opens an\n              account; utilize risk-based measures to verify the identity of each customer who opens an account; record customer identification information and\n              the verification methods and results; provide the required adequate CIP notice to customers that we will seek identification information to verify\n              their identities; and compare customer identification information with government-provided lists of suspected terrorists, once such lists have been\n              issued by the government. See Section 5.g. (Notice to Customers) for additional information.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will collect information to determine whether any entity opening an account would be excluded as a “customer,” pursuant to the exceptions\n              outlined in 31 CFR 103.122(a)(4)(ii) (e.g., documentation of a company’s listing information, licensing or registration of a financial institution\n              in the U.S, and status or verification of the authenticity of a government agency or department).\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("a. Required Customer Information")])]), _vm._v(" "), _c('p', [_vm._v("\n              Prior to opening an account, Zhenhao Fei will collect the following information for all accounts, if applicable, for any person, entity or\n              organization that is opening a new account and whose name is on the account:\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("(1) the name;")]), _vm._v(" "), _c('li', [_vm._v("(2) date of birth (for an individual);")]), _vm._v(" "), _c('li', [_vm._v("\n                (3) an address, which will be a residential or business street address (for an individual), an Army Post Office (APO) or Fleet Post Office (FPO)\n                box number, or residential or business street address of next of kin or another contact individual (for an individual who does not have a\n                residential or business street address), or a principal place of business, local office, or other physical location (for a person other than an\n                individual); and\n              ")]), _vm._v(" "), _c('li', [_vm._v("\n                (4) an identification number, which will be a taxpayer identification number (for U.S. persons), or one or more of the following: a taxpayer\n                identification number, passport number and country of issuance, alien identification card number, or number and country of issuance of any other\n                government-issued document evidencing nationality or residence and bearing a photograph or other similar safeguard (for non-U.S. persons).\n              ")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v("\n              In the event that a customer has applied for, but has not received, a taxpayer identification number, we will make arrangements to confirm that the\n              application was filed before the customer opens the account and to obtain the taxpayer identification number within a reasonable period of time\n              after the account is opened.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              When opening an account for a foreign business or enterprise that does not have an identification number, we will request alternative\n              government-issued documentation certifying the existence of the business or enterprise.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("b. Customers Who Refuse to Provide Information")])]), _vm._v(" "), _c('p', [_vm._v("\n              If a potential or existing customer either refuses to provide the information described above when requested, or appears to have intentionally\n              provided misleading information, our firm will not open a new account and, after considering the risks involved, consider closing any existing\n              account. In either case, our AML Compliance Person will be notified so that we can determine whether we should report the situation to FinCEN on a\n              SAR-SF.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("c. Verifying Information")])]), _vm._v("Based on the risk, and to the extent reasonable and practicable, we will ensure that we have a reasonable belief that we know the true identity of our\n            customers by using risk-based procedures to verify and document the accuracy of the information we get about our customers. Zhenhao Fei will analyze the\n            information we obtain to determine whether the information is sufficient to form a reasonable belief that we know the true identity of the customer\n            (e.g., whether the information is logical or contains inconsistencies).\n            "), _c('p', [_vm._v("\n              We will verify customer identity through documentary means, non-documentary means or both. We will use documents to verify customer identity when\n              appropriate documents are available. In light of the increased instances of identity fraud, we will supplement the use of documentary evidence by\n              using the non-documentary means described below whenever necessary. We may also use non-documentary means, if we are still uncertain about whether\n              we know the true identity of the customer. In verifying the information, we will consider whether the identifying information that we receive, such\n              as the customer’s name, street address, zip code, telephone number (if provided), date of birth and Social Security number, allow us to determine\n              that we have a reasonable belief that we know the true identity of the customer (e.g., whether the information is logical or contains\n              inconsistencies).\n            ")]), _vm._v(" "), _c('p', [_vm._v("Appropriate documents for verifying the identity of customers include the following:")]), _vm._v(" "), _c('p', [_vm._v("\n              For an individual, an unexpired government-issued identification evidencing nationality or residence and bearing a photograph or similar safeguard,\n              such as a driver’s license or passport; and\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              For a person other than an individual, documents showing the existence of the entity, such as certified articles of incorporation, a\n              government-issued business license, a partnership agreement or a trust instrument.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We understand that we are not required to take steps to determine whether the document that the customer has provided to us for identity\n              verification has been validly issued and that we may rely on a government-issued identification as verification of a customer’s identity. If,\n              however, we note that the document shows some obvious form of fraud, we must consider that factor in determining whether we can form a reasonable\n              belief that we know the customer’s true identity.\n            ")]), _vm._v(" "), _c('p', [_vm._v("We will use the following non-documentary methods of verifying identity:")]), _vm._v(" "), _c('p', [_vm._v("\n              Independently verifying the customer’s identity through the comparison of information provided by the customer with information obtained from a\n              consumer reporting agency, public database.\n            ")]), _vm._v(" "), _c('p', [_vm._v("Checking references with other financial institutions; or")]), _vm._v(" "), _c('p', [_vm._v("Obtaining a financial statement.")]), _vm._v(" "), _c('p', [_vm._v("We will use non-documentary methods of verification when:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("(1) the customer is unable to present an unexpired government-issued identification document with a photograph or other similar safeguard;")]), _vm._v(" "), _c('li', [_vm._v("(2) the firm is unfamiliar with the documents the customer presents for identification verification;")]), _vm._v(" "), _c('li', [_vm._v("(3) the customer and firm do not have face-to-face contact; and")]), _vm._v(" "), _c('li', [_vm._v("\n                (4) there are other circumstances that increase the risk that the firm will be unable to verify the true identity of the customer through\n                documentary means.\n              ")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v("\n              We will verify the information within a reasonable time before or after the account is opened. Depending on the nature of the account and requested\n              transactions, we may refuse to complete a transaction before we have verified the information, or in some instances when we need more time, we may,\n              pending verification, restrict the types of transactions or dollar amount of transactions. If we find suspicious information that indicates possible\n              money laundering, terrorist financing activity, or other suspicious activity, we will, after internal consultation with the firm’s AML Compliance\n              Person, file a SAR-SF in accordance with applicable laws and regulations.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We recognize that the risk that we may not know the customer’s true identity may be heightened for certain types of accounts, such as an account\n              opened in the name of a corporation, partnership or trust that is created or conducts substantial business in a jurisdiction that has been\n              designated by the U.S. as a primary money laundering jurisdiction, a terrorist concern, or has been designated as a non-cooperative country or\n              territory. We will identify customers that pose a heightened risk of not being properly identified. We will also take the following additional\n              measures that may be used to obtain information about the identity of the individuals associated with the customer when standard documentary methods\n              prove to be insufficient.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("d. Lack of Verification")])]), _vm._v(" "), _c('p', [_vm._v("\n              When we cannot form a reasonable belief that we know the true identity of a customer, we will do the following: (1) not open an account; (2) impose\n              terms under which a customer may conduct transactions while we attempt to verify the customer’s identity; (3) close an account after attempts to\n              verify customer’s identity fail; and (4) determine whether it is necessary to file a SAR-SF in accordance with applicable laws and regulations.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("e. Recordkeeping")])]), _vm._v(" "), _c('p', [_vm._v("\n              We will document our verification, including all identifying information provided by a customer, the methods used and results of verification, and\n              the resolution of any discrepancies identified in the verification process. We will keep records containing a description of any document that we\n              relied on to verify a customer’s identity, noting the type of document, any identification number contained in the document, the place of issuance,\n              and if any, the date of issuance and expiration date. With respect to non-documentary verification, we will retain documents that describe the\n              methods and the results of any measures we took to verify the identity of a customer. We will also keep records containing a description of the\n              resolution of each substantive discrepancy discovered when verifying the identifying information obtained. We will retain records of all\n              identification information for five years after the account has been closed; we will retain records made about verification of the customer’s\n              identity for five years after the record is made.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("f. Comparison with Government-Provided Lists of Terrorists")])]), _vm._v(" "), _c('p', [_vm._v("\n              At such time as we receive notice that a federal government agency has issued a list of known or suspected terrorists and identified the list as a\n              list for CIP purposes, we will, within a reasonable period of time after an account is opened (or earlier, if required by another federal law or\n              regulation or federal directive issued in connection with an applicable list), determine whether a customer appears on any such list of known or\n              suspected terrorists or terrorist organizations issued by any federal government agency and designated as such by Treasury in consultation with the\n              federal functional regulators. We will follow all federal directives issued in connection with such lists.\n            ")]), _vm._v(" "), _c('p', [_vm._v("We will continue to comply separately with OFAC rules prohibiting transactions with certain foreign countries or their nationals.")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("g. Notice to Customers")])]), _vm._v(" "), _c('p', [_vm._v("\n              FINRA has produced a Customer Identification Program Notice to assist firms in fulfilling this notification requirement. Please refer to FINRA’s AML\n              Web page for further details. We will provide notice to customers that the firm is requesting information from them to verify their identities, as\n              required by federal law. We will use the following method to provide notice to customers: telephone and online.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Important Information About Procedures for Opening a New Account\n              "), _c('br'), _vm._v("To help the government fight the funding of terrorism and money laundering activities, federal law requires all financial institutions to obtain,\n              verify, and record information that identifies each person who opens an account.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("h. Reliance on Another Financial Institution for Identity Verification")])]), _vm._v(" "), _c('p', [_vm._v("\n              We may, under the following circumstances, rely on the performance by another financial institution (including an affiliate) of some or all of the\n              elements of our CIP with respect to any customer that is opening an account or has established an account or similar business relationship with the\n              other financial institution to provide or engage in services, dealings or other financial transactions:\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              when such reliance is reasonable under the circumstances;\n              "), _c('br'), _vm._v("when the other financial institution is subject to a rule implementing the anti-money laundering compliance program requirements of 31 U.S.C. §\n              5318(h), and is regulated by a federal functional regulator; and\n              "), _c('br'), _vm._v("when the other financial institution has entered into a contract with our firm requiring it to certify annually to us that it has implemented its\n              anti-money laundering program and that it will perform (or its agent will perform) specified requirements of the customer identification program.\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("6. General Customer Due Diligence")]), _vm._v(" "), _c('p', [_vm._v("\n              It is important to our AML and SAR-SF reporting program that we obtain sufficient information about each customer to allow us to evaluate the risk\n              presented by that customer and to detect and report suspicious activity. When we open an account for a customer, the due diligence we perform may be\n              in addition to customer information obtained for purposes of our CIP.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              For each account meeting the required criteria, we will take steps to obtain sufficient customer information to comply with our suspicious activity\n              reporting requirements. Such information should include:\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("the customer’s business;")]), _vm._v(" "), _c('li', [_vm._v("the customer’s anticipated account activity (both volume and type);")]), _vm._v(" "), _c('li', [_vm._v("the source of the customer’s funds.")])]), _vm._v(" "), _c('p', [_vm._v("For accounts that we have deemed to be higher risk, we will obtain the following information:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("the purpose of the account;")]), _vm._v(" "), _c('li', [_vm._v("the source of funds and wealth;")]), _vm._v(" "), _c('li', [_vm._v("the beneficial owners of the accounts;")]), _vm._v(" "), _c('li', [_vm._v("the customer’s (or beneficial owner’s) occupation or type of business;")]), _vm._v(" "), _c('li', [_vm._v("financial statements;")]), _vm._v(" "), _c('li', [_vm._v("banking references;")]), _vm._v(" "), _c('li', [_vm._v("domicile (where the customer’s business is organized);")]), _vm._v(" "), _c('li', [_vm._v("description of customer’s primary trade area and whether international transactions are expected to be routine;")]), _vm._v(" "), _c('li', [_vm._v("description of the business operations and anticipated volume of trading;")]), _vm._v(" "), _c('li', [_vm._v("explanations for any changes in account activity.")])]), _vm._v(" "), _c('p', [_vm._v("We will also ensure that the customer information remains accurate by thorough due diligence procedures.")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("7. Correspondent Accounts for Foreign Shell Banks")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("a. Detecting and Closing Correspondent Accounts of Foreign Shell Banks")])]), _vm._v(" "), _c('p', [_vm._v("\n              We will identify foreign bank accounts and any such account that is a correspondent account (any account that is established for a foreign bank to\n              receive deposits from, or to make payments or other disbursements on behalf of, the foreign bank, or to handle other financial transactions related\n              to such foreign bank) for foreign shell banks by [describe procedure to detect such accounts]. Upon finding or suspecting such accounts, firm\n              employees will notify the AML Compliance Person, who will terminate any verified correspondent account in the United States for a foreign shell\n              bank. We will also terminate any correspondent account that we have determined is not maintained by a foreign shell bank but is being used to\n              provide services to such a shell bank. We will exercise caution regarding liquidating positions in such accounts and take reasonable steps to ensure\n              that no new positions are established in these accounts during the termination period. We will terminate any correspondent account for which we have\n              not obtained the information described in Appendix A of the regulations regarding shell banks within the time periods specified in those\n              regulations.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("b. Certifications")])]), _vm._v(" "), _c('p', [_vm._v("\n              We will require our foreign bank account holders to identify the owners of the foreign bank if it is not publicly traded, the name and street\n              address of a person who resides in the United States and is authorized and has agreed to act as agent for acceptance of legal process, and an\n              assurance that the foreign bank is not a shell bank nor is it facilitating activity of a shell bank. In lieu of this information the foreign bank\n              may submit the Certification Regarding Correspondent Accounts For Foreign Banks provided in the BSA regulations. We will re-certify when we believe\n              that the information is no longer accurate or at least once every three years.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("c. Recordkeeping for Correspondent Accounts for Foreign Banks")])]), _vm._v(" "), _c('p', [_vm._v("\n              We will keep records identifying the owners of foreign banks with U.S. correspondent accounts and the name and address of the U.S. agent for service\n              of legal process for those banks.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("d. Summons or Subpoena of Foreign Bank Records; Termination of Correspondent Relationships with Foreign Bank")])]), _vm._v(" "), _c('p', [_vm._v("\n              When we receive a written request from a federal law enforcement officer for information identifying the non-publicly traded owners of any foreign\n              bank for which we maintain a correspondent account in the United States and/or the name and address of a person residing in the United States who is\n              an agent to accept service of legal process for a foreign bank’s correspondent account, we will provide that information to the requesting officer\n              not later than seven days after receipt of the request. We will close, within 10 days, any correspondent account for a foreign bank that we learn\n              from FinCEN or the Department of Justice has failed to comply with a summons or subpoena issued by the Secretary of the Treasury or the Attorney\n              General of the United States or has failed to contest such a summons or subpoena. We will scrutinize any correspondent account activity during that\n              10-day period to ensure that any suspicious activity is appropriately reported and to ensure that no new positions are established in these\n              correspondent accounts.\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("8. Due Diligence and Enhanced Due Diligence Requirements for Correspondent Accounts of Foreign Financial Institutions")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("a. Due Diligence for Correspondent Accounts of Foreign Financial Institutions")])]), _vm._v(" "), _c('p', [_vm._v("\n              We will conduct an inquiry to determine whether a foreign financial institution has a correspondent account established, maintained, administered or\n              managed by the firm.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              If we have correspondent accounts for foreign financial institutions, we will assess the money laundering risk posed, based on a consideration of\n              relevant risk factors. We can apply all or a subset of these risk factors depending on the nature of the foreign financial institutions and the\n              relative money laundering risk posed by such institutions.\n            ")]), _vm._v(" "), _c('p', [_vm._v("The relevant risk factors can include:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("the nature of the foreign financial institution’s business and the markets it serves;")]), _vm._v(" "), _c('li', [_vm._v("the type, purpose and anticipated activity of such correspondent account;")]), _vm._v(" "), _c('li', [_vm._v("the nature and duration of the firm’s relationship with the foreign financial institution and its affiliates;")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("\n              the anti-money laundering and supervisory regime of the jurisdiction that issued the foreign financial institution’s charter or license and, to the\n              extent reasonably available, the jurisdiction in which any company that is an owner of the foreign financial institution is incorporated or\n              chartered; and information known or reasonably available to the covered financial institution about the foreign financial institution’s anti-money\n              laundering record.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              In addition, our due diligence program will consider additional factors that have not been enumerated above when assessing foreign financial\n              institutions that pose a higher risk of money laundering.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will apply our risk-based due diligence procedures and controls to each financial foreign institution correspondent account on an ongoing basis.\n              This includes periodically reviewing the activity of each foreign financial institution correspondent sufficient to ensure whether the nature and\n              volume of account activity is generally consistent with the information regarding the purpose and expected account activity and to ensure that the\n              firm can adequately identify suspicious transactions. Ordinarily, we will not conduct this periodic review by scrutinizing every transaction taking\n              place within the account. One procedure we may use instead is to use any account profiles for our correspondent accounts (to the extent we maintain\n              these) that we ordinarily use to anticipate how the account might be used and the expected volume of activity to help establish baselines for\n              detecting unusual activity.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("b. Enhanced Due Diligence")])]), _vm._v(" "), _c('p', [_vm._v("\n              We will assess any correspondent accounts for foreign financial institutions to determine whether they are correspondent accounts that have been\n              established, maintained, administered or managed for any foreign bank that operates under:\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("(1) an offshore banking license;")]), _vm._v(" "), _c('li', [_vm._v("\n                (2) a banking license issued by a foreign country that has been designated as non-cooperative with international anti-money laundering\n                principles or procedures by an intergovernmental group or organization of which the United States is a member and with which designation the\n                U.S. representative to the group or organization concurs; or\n              ")]), _vm._v(" "), _c('li', [_vm._v("\n                (3) a banking license issued by a foreign country that has been designated by the Secretary of the Treasury as warranting special measures due\n                to money laundering concerns.\n              ")])]), _vm._v(" "), _c('p', [_vm._v("\n              If we determine that we have any correspondent accounts for these specified foreign banks, we will perform enhanced due diligence on these\n              correspondent accounts. The enhanced due diligence that we will perform for each correspondent account will include, at a minimum, procedures to\n              take reasonable steps to:\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                (1) conduct enhanced scrutiny of the correspondent account to guard against money laundering and to identify and report any suspicious\n                transactions. Such scrutiny will not only reflect the risk assessment that is described in Section 8.a. above, but will also include procedures\n                to, as appropriate:\n                "), _c('ol', [_vm._v("\n                  (i) obtain (e.g., using a questionnaire) and consider information related to the foreign bank’s AML program to assess the extent to which\n                  the foreign bank’s correspondent account may expose us to any risk of money laundering;\n                ")]), _vm._v(" "), _c('ol', [_vm._v("\n                  (ii) monitor transactions to, from or through the correspondent account in a manner reasonably designed to detect money laundering and\n                  suspicious activity (this monitoring may be conducted manually or electronically and may be done on an individual account basis or by\n                  product activity); and\n                ")]), _vm._v(" "), _c('ol', [_vm._v("\n                  (iii) obtain information from the foreign bank about the identity of any person with authority to direct transactions through any\n                  correspondent account that is a payable-through account (a correspondent account maintained for a foreign bank through which the foreign\n                  bank permits its customer to engage, either directly or through a subaccount, in banking activities) and the sources and beneficial owners\n                  of funds or other assets in the payable-through account.\n                ")])]), _vm._v(" "), _c('li', [_vm._v("\n                (2) determine whether the foreign bank maintains correspondent accounts for other foreign banks that enable those other foreign banks to gain\n                access to the correspondent account under review and, if so, to take reasonable steps to obtain information to assess and mitigate the money\n                laundering risks associated with such accounts, including, as appropriate, the identity of those other foreign banks; and\n              ")]), _vm._v(" "), _c('li', [_vm._v("\n                (3) if the foreign bank’s shares are not publicly traded, determine the identity of each owner and the nature and extent of each owner’s\n                ownership interest. We understand that for purposes of determining a private foreign bank’s ownership, an “owner” is any person who directly or\n                indirectly owns, controls or has the power to vote 10 percent or more of any class of securities of a foreign bank. We also understand that\n                members of the same family shall be considered to be one person.\n              ")])]), _vm._v(" "), _c('h5', {
    staticClass: "mt-3"
  }, [_c('strong', [_vm._v("c. Special Procedures When Due Diligence or Enhanced Due Diligence Cannot Be Performed")])]), _vm._v(" "), _c('p', [_vm._v("\n              In the event there are circumstances in which we cannot perform appropriate due diligence with respect to a correspondent account, we will\n              determine, at a minimum, whether to refuse to open the account, suspend transaction activity, file a SAR-SF, close the correspondent account and/or\n              take other appropriate action.\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("9. Due Diligence and Enhanced Due Diligence Requirements for Private Banking Accounts/Senior Foreign Political Figures")]), _vm._v(" "), _c('p', [_vm._v("\n              We will review our accounts to determine whether we offer any private banking accounts and we will conduct due diligence on such accounts. This due\n              diligence will include, at least, (1) ascertaining the identity of all nominal holders and holders of any beneficial ownership interest in the\n              account (including information on those holders’ lines of business and sources of wealth); (2) ascertaining the source of funds deposited into the\n              account; (3) ascertaining whether any such holder may be a senior foreign political figure; and (4) detecting and reporting, in accordance with\n              applicable laws and regulations, any known or suspected money laundering, or use of the proceeds of foreign corruption.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will review public information, including information available in Internet databases, to determine whether any private banking account holders\n              are senior foreign political figures. If we discover information indicating that a particular private banking account holder may be a senior foreign\n              political figure, and upon taking additional reasonable steps to confirm this information, we determine that the individual is, in fact, a senior\n              foreign political figure, we will conduct additional enhanced due diligence to detect and report transactions that may involve money laundering or\n              the proceeds of foreign corruption.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              In so doing, we will consider the risks that the funds in the account may be the proceeds of foreign corruption by determining the purpose and use\n              of the private banking account, location of the account holder(s), source of funds in the account, type of transactions conducted through the\n              account and jurisdictions involved in such transactions. The degree of scrutiny we will apply will depend on various risk factors, including, but\n              not limited to, whether the jurisdiction the senior foreign political figure is from is one in which current or former political figures have been\n              implicated in corruption and the length of time that a former political figure was in office. Our enhanced due diligence might include, depending on\n              the risk factors, probing the account holder’s employment history, scrutinizing the account holder’s source(s) of funds, and monitoring transactions\n              to the extent necessary to detect and report proceeds of foreign corruption, and reviewing monies coming from government, government controlled or\n              government enterprise accounts (beyond salary amounts).\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              If we do not find information indicating that a private banking account holder is a senior foreign political figure, and the account holder states\n              that he or she is not a senior foreign political figure, then we may make an assessment if a higher risk for money laundering, nevertheless, exists\n              independent of the classification. If a higher risk is apparent, we will consider additional due diligence measures such as [describe in detail the\n              additional measures].\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              In either case, if due diligence (or the required enhanced due diligence, if the account holder is a senior foreign political figure) cannot be\n              performed adequately, we will, after consultation with the firm’s AML Compliance Person and, as appropriate, not open the account, suspend the\n              transaction activity, file a SAR-SF or close the account.\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("\n              10. Compliance with FinCEN’s Issuance of Special Measures Against Foreign Jurisdictions, Financial Institutions or International Transactions of\n              Primary Money Laundering Concern\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              If FinCEN issues a final rule imposing a special measure against one or more foreign jurisdictions or financial institutions, classes of\n              international transactions or types of accounts deeming them to be of primary money laundering concern, we understand that we must read FinCEN’s\n              final rule and follow any prescriptions or prohibitions contained in that rule. For example, if the final rule deems a certain bank and its\n              subsidiaries (Specified Bank) to be of primary money laundering concerns, a special measure may be a prohibition from opening or maintaining a\n              correspondent account in the United States for, or on behalf of, the Specified Banks. In that case, we will take the following steps:\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                (1) We will review our account records, including correspondent account records, to ensure that our accountholders and correspondent\n                accountholders maintain no accounts directly for, or on behalf of, the Specified Banks; and\n              ")]), _vm._v(" "), _c('li', [_vm._v("\n                (2) We will apply due diligence procedures to our correspondent accounts that are reasonably designed to guard against indirect use of those\n                accounts by the Specified Banks. Such due diligence may include:\n                "), _c('ol', [_vm._v("\n                  Notification to Correspondent Accountholders\n                  "), _c('br'), _vm._v("We will notify our correspondent accountholders that the account may not be used to provide the Specified Banks with access to us.\n                  "), _c('br'), _vm._v("We will transmit the notice to our correspondent accounts using the following method, and we shall retain documentation of such notice.\n                ")]), _vm._v(" "), _c('ol', [_vm._v("\n                  Identification of Indirect Use\n                  "), _c('br'), _vm._v("We will take reasonable steps in order to identify any indirect use of our correspondent accounts by the Specified Banks. We will determine\n                  if such indirect use is occurring from transactional records that we maintain in the normal course of business. We will take a risk-based\n                  approach when deciding what, if any, additional due diligence measures we should adopt to guard against the indirect use of correspondent\n                  accounts by the Specified Banks, based on risk factors such as the type of services offered by, and geographic locations of, their\n                  correspondents.\n                  "), _c('br'), _vm._v("We understand that we have an ongoing obligation to take reasonable steps to identify all correspondent account services our correspondent\n                  accountholders may directly or indirectly provide to the Specified Banks.\n                ")])])]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("11. Monitoring Accounts for Suspicious Activity")]), _vm._v(" "), _c('p', [_vm._v("\n              We will monitor account activity for unusual size, volume, pattern or type of transactions, taking into account risk factors and red flags that are\n              appropriate to our business. (Red flags are identified in Section 11.b. below.) The AML Compliance Person or his or her designee With the approval\n              of Zhenhao Fei will be responsible for this monitoring, will review any activity that our monitoring system detects, will determine whether any\n              additional steps are required, will document when and how this monitoring is carried out, and will report suspicious activities to the appropriate\n              authorities.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will conduct reviews of activity that our monitoring system detects. We will document our monitoring and reviews. The AML Compliance Person or\n              his or her designee will conduct an appropriate investigation and review relevant information from internal or third-party sources before a SAR-SF\n              is filed.\n              "), _c('br'), _vm._v("Rules: 31 C.F.R. §103.19; FINRA Rule 3310(a).\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("a. Emergency Notification to Law Enforcement by Telephone")])]), _vm._v(" "), _c('p', [_vm._v("\n              In situations involving violations that require immediate attention, such as terrorist financing or ongoing money laundering schemes, we will\n              immediately call an appropriate law enforcement authority. If a customer or company appears on OFAC’s SDN list, we will call the OFAC Hotline at\n              (800) 540-6322. Other contact numbers we will use are: FinCEN’s Financial Institutions Hotline ((866) 556-3974) (especially to report transactions\n              relating to terrorist activity), local U.S. Attorney’s office, local FBI office and local SEC office (to voluntarily report such violations to the\n              SEC in addition to contacting the appropriate law enforcement authority). If we notify the appropriate law enforcement authority of any such\n              activity, we must still file a timely SAR-SF.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Although we are not required to, in cases where we have filed a SAR-SF that may require immediate attention by the SEC, we may contact the SEC via\n              the SEC SAR Alert Message Line at (202) 551-SARS (7277) to alert the SEC about the filing. We understand that calling the SEC SAR Alert Message Line\n              does not alleviate our obligations to file a SAR-SF or notify an appropriate law enforcement authority.\n              "), _c('br'), _vm._v("Rule: 31 C.F.R. § 103.19.\n              "), _c('br'), _vm._v("Resources: FinCEN’s Web site; OFAC Web page; NTM 02-21; NTM 02-47.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("b. Red Flags")])]), _vm._v(" "), _c('p', [_vm._v("Red flags that signal possible money laundering or terrorist financing include, but are not limited to:")]), _vm._v(" "), _c('p', [_vm._v("Customers – Insufficient or Suspicious Information")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Provides unusual or suspicious identification documents that cannot be readily verified.")]), _vm._v(" "), _c('li', [_vm._v("\n                Reluctant to provide complete information about nature and purpose of business, prior banking relationships, anticipated account activity,\n                officers and directors or business location.\n              ")]), _vm._v(" "), _c('li', [_vm._v("Refuses to identify a legitimate source for funds or information is false, misleading or substantially incorrect.")]), _vm._v(" "), _c('li', [_vm._v("Background is questionable or differs from expectations based on business activities.")]), _vm._v(" "), _c('li', [_vm._v("Customer with no discernable reason for using the firm’s service.")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("Efforts to Avoid Reporting and Recordkeeping")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Reluctant to provide information needed to file reports or fails to proceed with transaction.")]), _vm._v(" "), _c('li', [_vm._v("Tries to persuade an employee not to file required reports or not to maintain required records.")]), _vm._v(" "), _c('li', [_vm._v("“Structures” deposits, withdrawals or purchase of monetary instruments below a certain amount to avoid reporting or recordkeeping requirements.")]), _vm._v(" "), _c('li', [_vm._v("Unusual concern with the firm’s compliance with government reporting requirements and firm’s AML policies.>")])]), _vm._v(" "), _c('p', [_vm._v("Certain Funds Transfer Activities")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Wire transfers to/from financial secrecy havens or high-risk geographic location without an apparent business reason.")]), _vm._v(" "), _c('li', [_vm._v("\n                Many small, incoming wire transfers or deposits made using checks and money orders. Almost immediately withdrawn or wired out in manner\n                inconsistent with customer’s business or history. May indicate a Ponzi scheme.\n              ")]), _vm._v(" "), _c('li', [_vm._v("Wire activity that is unexplained, repetitive, unusually large or shows unusual patterns or with no apparent business purpose.")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("Certain Deposits or Dispositions of Physical Certificates")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Physical certificate is titled differently than the account.")]), _vm._v(" "), _c('li', [_vm._v("\n                Physical certificate does not bear a restrictive legend, but based on history of the stock and/or volume of shares trading, it should have such\n                a legend.\n              ")]), _vm._v(" "), _c('li', [_vm._v("Customer’s explanation of how he or she acquired the certificate does not make sense or changes.")]), _vm._v(" "), _c('li', [_vm._v("\n                Customer deposits the certificate with a request to journal the shares to multiple accounts, or to sell or otherwise transfer ownership of the\n                shares.\n              ")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("Certain Securities Transactions")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Customer engages in prearranged or other non-competitive trading, including wash or cross trades of illiquid securities.")]), _vm._v(" "), _c('li', [_vm._v("Two or more accounts trade an illiquid stock suddenly and simultaneously.")]), _vm._v(" "), _c('li', [_vm._v("Customer journals securities between unrelated accounts for no apparent business reason.")]), _vm._v(" "), _c('li', [_vm._v("Customer has opened multiple accounts with the same beneficial owners or controlling parties for no apparent business reason.")]), _vm._v(" "), _c('li', [_vm._v("\n                Customer transactions include a pattern of receiving stock in physical form or the incoming transfer of shares, selling the position and wiring\n                out proceeds.\n              ")]), _vm._v(" "), _c('li', [_vm._v("Customer’s trading patterns suggest that he or she may have inside information.")]), _vm._v(" "), _c('li', [_vm._v("Transactions Involving Penny Stock Companies")]), _vm._v(" "), _c('li', [_vm._v("Company has no business, no revenues and no product.")]), _vm._v(" "), _c('li', [_vm._v("Company has experienced frequent or continuous changes in its business structure.")]), _vm._v(" "), _c('li', [_vm._v("Officers or insiders of the issuer are associated with multiple penny stock issuers.")]), _vm._v(" "), _c('li', [_vm._v("Company undergoes frequent material changes in business strategy or its line of business.")]), _vm._v(" "), _c('li', [_vm._v("Officers or insiders of the issuer have a history of securities violations.")]), _vm._v(" "), _c('li', [_vm._v("Company has not made disclosures in SEC or other regulatory filings.")]), _vm._v(" "), _c('li', [_vm._v("Company has been the subject of a prior trading suspension.")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("Transactions Involving Insurance Products")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cancels an insurance contract and directs funds to a third party.")]), _vm._v(" "), _c('li', [_vm._v("Structures withdrawals of funds following deposits of insurance annuity checks signaling an effort to avoid BSA reporting requirements.")]), _vm._v(" "), _c('li', [_vm._v("Rapidly withdraws funds shortly after a deposit of a large insurance check when the purpose of the fund withdrawal cannot be determined.")]), _vm._v(" "), _c('li', [_vm._v("\n                Cancels annuity products within the free look period which, although could be legitimate, may signal a method of laundering funds if accompanied\n                with other suspicious indicia.\n              ")]), _vm._v(" "), _c('li', [_vm._v("\n                Opens and closes accounts with one insurance company then reopens a new account shortly thereafter with the same insurance company, each time\n                with new ownership information.\n              ")]), _vm._v(" "), _c('li', [_vm._v("Purchases an insurance product with no concern for investment objective or performance.")]), _vm._v(" "), _c('li', [_vm._v("\n                Purchases an insurance product with unknown or unverifiable sources of funds, such as cash, official checks or sequentially numbered money\n                orders.\n              ")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("Activity Inconsistent With Business")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Transactions patterns show a sudden change inconsistent with normal activities.")]), _vm._v(" "), _c('li', [_vm._v("Unusual transfers of funds or journal entries among accounts without any apparent business purpose.")]), _vm._v(" "), _c('li', [_vm._v("\n                Maintains multiple accounts, or maintains accounts in the names of family members or corporate entities with no apparent business or other\n                purpose.\n              ")]), _vm._v(" "), _c('li', [_vm._v("Appears to be acting as an agent for an undisclosed principal, but is reluctant to provide information.")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("Other Suspicious Customer Activity")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Unexplained high level of account activity with very low levels of securities transactions.")]), _vm._v(" "), _c('li', [_vm._v("\n                Funds deposits for purchase of a long-term investment followed shortly by a request to liquidate the position and transfer the proceeds out of\n                the account.\n              ")]), _vm._v(" "), _c('li', [_vm._v("Law enforcement subpoenas.")]), _vm._v(" "), _c('li', [_vm._v("Large numbers of securities transactions across a number of jurisdictions.")]), _vm._v(" "), _c('li', [_vm._v("Buying and selling securities with no purpose or in unusual circumstances (e.g., churning at customer’s request).")]), _vm._v(" "), _c('li', [_vm._v("Payment by third-party check or money transfer without an apparent connection to the customer.")]), _vm._v(" "), _c('li', [_vm._v("Payments to third-party without apparent connection to customer.")]), _vm._v(" "), _c('li', [_vm._v("No concern regarding the cost of transactions or fees (i.e., surrender fees, higher than necessary commissions, etc.).")])]), _vm._v(" "), _c('h5', {
    staticClass: "mt-2"
  }, [_c('strong', [_vm._v("c. Responding to Red Flags and Suspicious Activity")])]), _vm._v(" "), _c('p', [_vm._v("\n              When an employee of the firm detects any red flag, or other activity that may be suspicious, he or she will notify relevant entities Under the\n              direction of the AML Compliance Person, the firm will determine whether or not and how to further investigate the matter. This may include gathering\n              additional information internally or from third-party sources, contacting the government, freezing the account and/or filing a SAR-SF.\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("12. Suspicious Transactions and BSA Reporting")]), _vm._v(" "), _c('h5', {
    staticClass: "mt-2"
  }, [_c('strong', [_vm._v("a. Filing a SAR-SF")])]), _vm._v(" "), _c('p', [_vm._v("\n              We will file SAR-SFs with FinCEN for any transactions (including deposits and transfers) conducted or attempted by, at or through our firm involving\n              $5,000 or more of funds or assets (either individually or in the aggregate) where we know, suspect or have reason to suspect:\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                (1) the transaction involves funds derived from illegal activity or is intended or conducted in order to hide or disguise funds or assets\n                derived from illegal activity as part of a plan to violate or evade federal law or regulation or to avoid any transaction reporting requirement\n                under federal law or regulation;\n              ")]), _vm._v(" "), _c('li', [_vm._v("(2) the transaction is designed, whether through structuring or otherwise, to evade any requirements of the BSA regulations;")]), _vm._v(" "), _c('li', [_vm._v("\n                (3) the transaction has no business or apparent lawful purpose or is not the sort in which the customer would normally be expected to engage,\n                and after examining the background, possible purpose of the transaction and other facts, we know of no reasonable explanation for the\n                transaction; or\n              ")]), _vm._v(" "), _c('li', [_vm._v("(4) the transaction involves the use of the firm to facilitate criminal activity.")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("\n              We will also file a SAR-SF and notify the appropriate law enforcement authority in situations involving violations that require immediate attention,\n              such as terrorist financing or ongoing money laundering schemes. In addition, although we are not required to, we may contact that SEC in cases\n              where a SAR-SF we have filed may require immediate attention by the SEC. See Section 11 for contact numbers. We also understand that, even if we\n              notify a regulator of a violation, unless it is specifically covered by one of the exceptions in the SAR rule, we must file a SAR-SF reporting the\n              violation.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We may file a voluntary SAR-SF for any suspicious transaction that we believe is relevant to the possible violation of any law or regulation but\n              that is not required to be reported by us under the SAR rule. It is our policy that all SAR-SFs will be reported regularly to the Board of Directors\n              and appropriate senior management, with a clear reminder of the need to maintain the confidentiality of the SAR-SF.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will report suspicious transactions by completing a SAR-SF, and we will collect and maintain supporting documentation as required by the BSA\n              regulations. We will file a SAR-SF no later than 30 calendar days after the date of the initial detection of the facts that constitute a basis for\n              filing a SAR-SF. If no suspect is identified on the date of initial detection, we may delay filing the SAR-SF for an additional 30 calendar days\n              pending identification of a suspect, but in no case will the reporting be delayed more than 60 calendar days after the date of initial detection.\n              The phrase “initial detection” does not mean the moment a transaction is highlighted for review. The 30-day (or 60-day) period begins when an\n              appropriate review is conducted and a determination is made that the transaction under review is “suspicious” within the meaning of the SAR\n              requirements. A review must be initiated promptly upon identification of unusual activity that warrants investigation.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will retain copies of any SAR-SF filed and the original or business record equivalent of any supporting documentation for five years from the\n              date of filing the SAR-SF. We will identify and maintain supporting documentation and make such information available to FinCEN, any other\n              appropriate law enforcement agencies, federal or state securities regulators or SROs upon request.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will not notify any person involved in the transaction that the transaction has been reported, except as permitted by the BSA regulations. We\n              understand that anyone who is subpoenaed or required to disclose a SAR-SF or the information contained in the SAR-SF will, except where disclosure\n              is requested by FinCEN, the SEC, or another appropriate law enforcement or regulatory agency, or an SRO registered with the SEC, decline to produce\n              the SAR-SF or to provide any information that would disclose that a SAR-SF was prepared or filed. We will notify FinCEN of any such request and our\n              response.\n              "), _c('br'), _vm._v("Rules: 31 C.F.R. §103.19, FINRA Rule 3310(a).\n              "), _c('br'), _vm._v("Resources: FinCEN’s Web site contains additional information, including information on the BSA E-Filing System, the SAR-SF Form (fill-in version),\n              and the biannual SAR Activity Reviews and SAR Bulletins, which discuss trends in suspicious reporting and give helpful tips. SAR Activity Review,\n              Issue 10 (May 2006) (documentation of decision not to file a SAR; grand jury subpoenas and suspicious activity reporting, and commencement of 30-day\n              time period to file a SAR); FinCEN SAR Narrative Guidance Package (11/2003), FinCEN Suggestions for Addressing Common Errors Noted in Suspicious\n              Activity Reporting (10/10/2007);NTM 02-21; NTM 02-47.\n            ")]), _vm._v(" "), _c('h5', {
    staticClass: "mt-2"
  }, [_c('strong', [_vm._v("b. Foreign Bank and Financial Accounts Reports")])]), _vm._v(" "), _c('p', [_vm._v("\n              We will file a FBAR with the IRS for any financial accounts of more than $10,000 that we hold, or for which we have signature or other authority\n              over, in a foreign country. We will use the FBAR Form provided on the IRS’s Web site.\n              "), _c('br'), _vm._v("Rule: 31 C.F.R. §103.24.\n              "), _c('br'), _vm._v("Resource: FBAR Form.\n            ")]), _vm._v(" "), _c('h5', {
    staticClass: "mt-2"
  }, [_c('strong', [_vm._v("e. Monetary Instrument Purchases")])]), _vm._v(" "), _c('p', [_vm._v("\n              When we issue or sell a bank check or draft, cashier’s check, money order or traveler’s check in the amounts of $3,000 to $10,000 inclusive, we will\n              maintain records of the following information:\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                (a) (1) If the purchaser has a deposit account with us:\n                "), _c('ol', [_vm._v("(i) (A) the name of the purchaser;")]), _vm._v(" "), _c('ol', [_vm._v("(B) the date of purchase;")]), _vm._v(" "), _c('ol', [_vm._v("(C) the type(s) of instrument(s) purchased;")]), _vm._v(" "), _c('ol', [_vm._v("(D) the serial number(s) of each of the instrument(s) purchased; and")]), _vm._v(" "), _c('ol', [_vm._v("(E) the amount in dollars of each of the instrument(s) purchased.")]), _vm._v(" "), _c('ol', [_vm._v("(2) If the purchaser does not have a deposit account with us:")]), _vm._v(" "), _c('ol', [_vm._v("(i) (A) the name and address of the purchaser;")]), _vm._v(" "), _c('ol', [_vm._v("\n                  (B) the Social Security number of the purchaser, or if the purchaser is an alien and does not have a Social Security number, the alien\n                  identification number;\n                ")]), _vm._v(" "), _c('ol', [_vm._v("(C) the date of birth of the purchaser;")]), _vm._v(" "), _c('ol', [_vm._v("(D) the date of purchase;")]), _vm._v(" "), _c('ol', [_vm._v("(E) the type(s) of instrument(s) purchased;")]), _vm._v(" "), _c('ol', [_vm._v("(F) the serial number(s) of the instrument(s) purchased; and")]), _vm._v(" "), _c('ol', [_vm._v("(G) the amount in dollars of each of the instrument(s) purchased.")]), _vm._v(" "), _c('ol', [_vm._v("\n                  (ii) In addition, we shall verify the purchaser’s name and address by examination of a document which is normally acceptable within the\n                  community as a means of identification when cashing checks for nonde positors and which contains the name and address of the purchaser, and\n                  shall record the specific identifying information (e.g., driver’s license number and state of issuance).\n                ")])]), _vm._v(" "), _c('li', [_vm._v("\n                (b) Contemporaneous purchases of the same or different types of instruments totaling $3,000 or more shall be treated as one purchase. Multiple\n                purchases during one business day totaling $3,000 or more shall be treated as one purchase if an individual employee, director, officer or\n                partner of the [Name of Firm] has knowledge that these purchases have occurred.\n              ")]), _vm._v(" "), _c('li', [_vm._v("\n                (c) We shall keep records required to be kept for a period of five years, and such records shall be made available to the federal and state\n                authorities or SROs upon request at any time.\n              ")])]), _vm._v(" "), _c('p', [_vm._v("\n              Rule: 31 C.F.R. § 103.29. See also 31 C.F.R. 103.22(b). Resources: 52 Fed. Reg. 52250 (October 17, 1994) (Final Rule Amendments to BSA Regulations\n              Relating to Identification Required to Purchase Bank Checks and Drafts, Cashier’s Checks, Money Orders, and Traveler’s Checks).\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("f. Funds Transmittals of $3,000 or More Under the Travel Rule")])]), _vm._v(" "), _c('p', [_vm._v("\n              When we are the transmitter’s financial institution in funds of $3,000 or more, we will retain either the original or a copy (e.g., microfilm,\n              electronic record) of the transmittal order. We will also record on the transmittal order the following information: (1) the name and address of the\n              transmitter; (2) if the payment is ordered from an account, the account number; (3) the amount of the transmittal order; (4) the execution date of\n              the transmittal order; and (5) the identity of the recipient’s financial institution. In addition, we will include on the transmittal order as many\n              of the following items of information as are received with the transmittal order: (1) the name and address of the recipient; (2) the account number\n              of the recipient; (3) any other specific identifier of the recipient; and (4) any form relating to the transmittal of funds that is completed or\n              signed by the person placing the transmittal order.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will also verify the identity of the person placing the transmittal order (if we are the transmitting firm), provided the transmittal order is\n              placed in person and the transmittor is not an established customer of the firm (i.e., a customer of the firm who has not previously maintained an\n              account with us or for whom we have not obtained and maintained a file with the customer’s name, address, taxpayer identification number, or, if\n              none, alien identification number or passport number and country of issuance). If a transmittor or recipient is conducting business in person, we\n              will obtain: (1) the person’s name and address; (2) the type of identification reviewed and the number of the identification document (e.g.,\n              driver’s license); and (3) the person’s taxpayer identification number (e.g., Social Security or employer identification number) or, if none, alien\n              identification number or passport number and country of issuance, or a notation in the record the lack thereof. If a transmittor or recipient is not\n              conducting business in person, we shall obtain the person’s name, address, and a copy or record of the method of payment (e.g., check or credit card\n              transaction). In the case of transmittors only, we shall also obtain the transmittor’s taxpayer identification number (e.g., Social Security or\n              employer identification number) or, if none, alien identification number or passport number and country of issuance, or a notation in the record of\n              the lack thereof. In the case of recipients only, we shall obtain the name and address of the person to which the transmittal was sent.\n            ")]), _vm._v(" "), _c('p', [_vm._v("Rule: 31 C.F.R. §103.33(f) and (g).")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("13. AML Recordkeeping")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("a. Responsibility for Required AML Records and SAR-SF Filing")])]), _vm._v(" "), _c('p', [_vm._v("\n              Our AML Compliance Person and his or her designee will be responsible for ensuring that AML records are maintained properly and that SAR-SFs are\n              filed as required.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              In addition, as part of our AML program, our firm will create and maintain SAR-SFs, CTRs, CMIRs, FBARs, and relevant documentation on customer\n              identity and verification (See Section 5 above) and funds transmittals. We will maintain SAR-SFs and their accompanying documentation for at least\n              five years. We will keep other documents according to existing BSA and other recordkeeping requirements, including certain SEC rules that require\n              six-year retention periods (e.g., Exchange Act Rule 17a-4(a) requiring firms to preserve for a period of not less than six years, all records\n              required to be retained by Exchange Act Rule 17a-3(a)(1)-(3), (a)(5), and (a)(21)-(22) and Exchange Act Rule 17a-4(e)(5) requiring firms to retain\n              for six years account record information required pursuant to Exchange Act Rule 17a-3(a)(17)).\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Rules: 31 C.F.R. § 103.38, Exchange Act Rule 17a-8 (requiring registered broker-dealers subject to the Currency and Foreign Transactions Reporting\n              Act of 1970 to comply with the BSA regulations regarding reporting, recordkeeping and record retention requirements), FINRA Rule 3310.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("b. SAR-SF Maintenance and Confidentiality")])]), _vm._v("We will hold SAR-SFs and any supporting documentation confidential. We will not inform anyone outside of FinCEN, the SEC, an SRO registered with the SEC\n            or other appropriate law enforcement or regulatory agency about a SAR-SF. We will refuse any subpoena requests for SAR-SFs or for information that would\n            disclose that a SAR-SF has been prepared or filed and immediately notify FinCEN of any such subpoena requests that we receive. See Section 11 for\n            contact numbers. We will segregate SAR-SF filings and copies of supporting documentation from other firm books and records to avoid disclosing SAR-SF\n            filings. Our AML Compliance Person will handle all subpoenas or other requests for SAR-SFs. [Describe any other retention or confidentiality procedures\n            of your firm for SAR-SFs.] We may share information with another financial institution about suspicious transactions in order to determine whether we\n            will jointly file a SAR according to the provisions of Section 3.d. In cases in which we file a joint SAR for a transaction that has been handled both\n            by us and another financial institution, both financial institutions will maintain a copy of the filed SAR.\n            "), _c('p', [_vm._v("\n              Rules: 31 C.F.R. §103.19(e); 67 Fed. Reg. 44048, 44054 (July 1, 2002).\n              "), _c('br'), _vm._v("Resources: NTM 02-47.\n            ")]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("c. Additional Records")])]), _vm._v(" "), _c('p', [_vm._v("We shall retain either the original or a microfilm or other copy or reproduction of each of the following:")]), _vm._v(" "), _c('p', [_vm._v("\n              A record of each extension of credit in an amount in excess of $10,000, except an extension of credit secured by an interest in real property. The\n              record shall contain the name and address of the person to whom the extension of credit is made, the amount thereof, the nature or purpose thereof\n              and the date thereof;\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              A record of each advice, request or instruction received or given regarding any transaction resulting (or intended to result and later canceled if\n              such a record is normally made) in the transfer of currency or other monetary instruments, funds, checks, investment securities or credit, of more\n              than $10,000 to or from any person, account or place outside the U.S.;\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              A record of each advice, request or instruction given to another financial institution (which includes broker-dealers) or other person located\n              within or without the U.S., regarding a transaction intended to result in the transfer of funds, or of currency, other monetary instruments, checks,\n              investment securities or credit, of more than $10,000 to a person, account or place outside the U.S.;>\n            ")]), _vm._v(" "), _c('p', [_vm._v("Each document granting signature or trading authority over each customer’s account;")]), _vm._v(" "), _c('p', [_vm._v("\n              Each record described in Exchange Act Rule 17a-3(a): (1) (blotters), (2) (ledgers for assets and liabilities, income, and expense and capital\n              accounts), (3) (ledgers for cash and margin accounts), (4) (securities log), (5) (ledgers for securities in transfer, dividends and interest\n              received, and securities borrowed and loaned), (6) (order tickets), (7) (purchase and sale tickets), (8) (confirms), and (9) (identity of owners of\n              cash and margin accounts);\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              A record of each remittance or transfer of funds, or of currency, checks, other monetary instruments, investment securities or credit, of more than\n              $10,000 to a person, account or place, outside the U.S.; and\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              A record of each receipt of currency, other monetary instruments, checks or investment securities and of each transfer of funds or credit, of more\n              than $10,000 received on any one occasion directly and not through a domestic financial institution, from any person, account or place outside the\n              U.S.\n            ")]), _vm._v(" "), _c('p', [_vm._v("Rules: 31 C.F.R. §§ 103.33, 103.35(b).")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("14. Clearing/Introducing Firm Relationships")]), _vm._v(" "), _c('p', [_vm._v("\n              We will work closely with our clearing firm to detect money laundering. We will exchange information, records, data and exception reports as\n              necessary to comply [with our contractual obligations and] with AML laws. Both our firm and our clearing firm have filed (and kept updated) the\n              necessary annual certifications for such information sharing, which can be found on FinCEN’s Web site. As a general matter, we will obtain and use\n              the exception reports offered by our clearing firm in order to monitor customer activity and we will provide our clearing firm with proper customer\n              identification and due diligence information as required to successfully monitor customer transactions. We have discussed how each firm will\n              apportion customer and transaction functions and how we will share information and set forth our understanding in a written document. We understand\n              that the apportionment of functions will not relieve either of us from our independent obligation to comply with AML laws, except as specifically\n              allowed under the BSA and its implementing regulations.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Rules: 31 CFR 103.110; FINRA Rule 3310, NASD Rule 3230. Resources: FIN-2006-G003: Frequently Asked Questions: Foreign Bank Recertifications under 31\n              C.F.R. § 103.77 (February 3, 2006).\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("15. Training Programs")]), _vm._v(" "), _c('p', [_vm._v("\n              We will develop ongoing employee training under the leadership of the AML Compliance Person and senior management. Our training will occur on at\n              least an annual basis. It will be based on our firm’s size, its customer base, and its resources and be updated as necessary to reflect any new\n              developments in the law.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Our training will include, at a minimum: (1) how to identify red flags and signs of money laundering that arise during the course of the employees’\n              duties; (2) what to do once the risk is identified (including how, when and to whom to escalate unusual customer activity or other red flags for\n              analysis and, where appropriate, the filing of SAR-SFs); (3) what employees’ roles are in the firm’s compliance efforts and how to perform them; (4)\n              the firm’s record retention policy; and (5) the disciplinary consequences (including civil and criminal penalties) for non-compliance with the BSA.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will develop training in our firm, or contract for it. Delivery of the training may include educational pamphlets, videos, intranet systems,\n              in-person lectures and explanatory memos. We will maintain records to show the persons trained, the dates of training and the subject matter of\n              their training.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We will review our operations to see if certain employees, such as those in compliance, margin and corporate security, require specialized\n              additional training. Our written procedures will be updated to reflect any such changes.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Rule: FINRA Rule 3310. Resources: See NTM 02-21, FinCEN SAR Narrative Guidance Package (11/2003), FinCEN Suggestions for Addressing Common Errors\n              Noted in Suspicious Activity Reporting (10/10/2007).\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("16. Program to Independently Test AML Program")]), _vm._v(" "), _c('p', [_vm._v("\n              The testing of our AML program will be performed at least annually (on a calendar year basis) by an independent third party. We will evaluate the\n              qualifications of the independent third party to ensure they have a working knowledge of applicable requirements under the BSA and its implementing\n              regulations. Independent testing will be performed more frequently if circumstances warrant.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Rules: 31 C.F.R. § 103.120; FINRA Rule 3310.?\n              "), _c('br'), _vm._v("Resource: NTM 06-07.\n            ")]), _vm._v(" "), _c('p', [_vm._v("b. Evaluation and Reporting")]), _vm._v(" "), _c('p', [_vm._v("\n              After we have completed the independent testing, staff will report its findings to senior management. We will promptly address each of the resulting\n              recommendations and keep a record of how each noted deficiency was resolved.\n            ")]), _vm._v(" "), _c('p', [_vm._v("Rules: 31 C.F.R. § 103.120; FINRA Rule 3310.")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("17. Monitoring Employee Conduct and Accounts")]), _vm._v(" "), _c('p', [_vm._v("\n              We will subject employee accounts to the same AML procedures as customer accounts, under the supervision of the AML Compliance Person. We will also\n              review the AML performance of supervisors, as part of their annual performance review. The AML Compliance Person’s accounts will be reviewed by Yale\n              ReiSoleil.\n            ")]), _vm._v(" "), _c('p', [_vm._v("Rules: 31 C.F.R. §§ 103.19, 103.120; FINRA Rule 3310.")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("18. Confidential Reporting of AML Non-Compliance")]), _vm._v(" "), _c('p', [_vm._v("\n              Employees will promptly report any potential violations of the firm’s AML compliance program to the AML Compliance Person, unless the violations\n              implicate the AML Compliance Person, in which case the employee shall report to Yale ReiSoleil. Such reports will be confidential, and the employee\n              will suffer no retaliation for making them.\n            ")]), _vm._v(" "), _c('p', [_vm._v("Rules: 31 C.F.R. § 103.120; FINRA Rule 3310.")]), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("19. Additional Risk Areas")]), _vm._v(" "), _c('p', [_vm._v("\n              The firm has reviewed all areas of its business to identify potential money laundering risks that may not be covered in the procedures described\n              above.\n            ")])])])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "drag"
  }, [_c('div', {
    staticClass: "drag_bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "drag_text"
  }, [_vm._v(_vm._s(_vm.confirmWords))]), _vm._v(" "), _c('div', {
    staticClass: "handler handler_bg",
    on: {
      "mousedown": function($event) {
        return _vm.mousedownFn($event)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "pa-0": "",
      "mt-5": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "sm6": "",
      "mt-5": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('div', {
    staticClass: "error-text primary--text text-xs-center"
  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
    staticClass: "font-20 text-xs-center mt-4"
  }, [_vm._v(_vm._s(_vm.$t("page500.serverError")))]), _vm._v(" "), _c('div', {
    staticClass: "font-18 text-xs-center mt-4 mb-4"
  }, [_vm._v(_vm._s(_vm.$t("page500.hintMessage")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "flat": "",
      "outline": "",
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("page500.homepageButton")))])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-hidden"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": ""
    }
  }, [
    [_c('v-card', [_c('v-container', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-1 primary--text",
      attrs: {
        "xs12": "",
        "md12": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "fw-700 font-16"
    }, [_vm._v(_vm._s(_vm.$t('right.myWallet')))])]), _vm._v(" "), (!_vm.isLogin) ? _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md12": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-16 fw-400 pointer"
    }, [_c('span', {
      on: {
        "click": _vm.gotoRegister
      }
    }, [_vm._v(_vm._s(_vm.$t('right.signUp')))]), _vm._v(" "), _c('span', {
      on: {
        "click": _vm.login
      }
    }, [_vm._v(" / " + _vm._s(_vm.$t('right.login')))])])]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-16 pointer"
    }, [_c('span', {
      staticClass: "font-28 primary--text fw-700"
    }, [_vm._v(_vm._s(_vm._f("NumFormat")(((_vm.user != null ? _vm.user.iobPower : 0).toFixed(2)))))]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-500"
    }, [_vm._v("IOB Power / " + _vm._s(_vm._f("NumFormat")(((_vm.user != null ? _vm.user.iobPower : 0).toFixed(2)))) + " USD")])])]) : _vm._e()], 1)], 1)], 1)], _vm._v(" "), [_c('v-card', {
      staticClass: "mt-3"
    }, [_c('v-container', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md12": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-16 primary--text"
    }, [_vm._v(_vm._s(_vm.$t('right.iobannouncements')))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, _vm._l((_vm.bulletinBoardData), function(msg) {
      return _c('span', {
        staticClass: "font-14"
      }, [_vm._v("\n                    " + _vm._s(_vm.$t(msg.before))), _c('span', {
        staticClass: "primary--text"
      }, [_vm._v(_vm._s(_vm._f("NumFormat")(msg.data)))]), _vm._v(_vm._s(_vm.$t(msg.after)) + "\n                  ")])
    }), 0)], 1)], 1)], 1)], _vm._v(" "), [_c('v-card', {
      staticClass: "mt-3"
    }, [_c('v-container', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md12": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "fw-700 font-16 primary--text"
    }, [_vm._v(_vm._s(_vm.$t('right.links')))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 fw-500 pointer",
      on: {
        "click": _vm.goMyFeed
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.myFeed')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 fw-500 pointer",
      on: {
        "click": _vm.goUserData
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.myBlog')) + "\n                  ")])])], 1)], 1)], 1)], _vm._v(" "), [_c('v-card', {
      staticClass: "mt-3"
    }, [_c('v-container', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md12": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-16 primary--text"
    }, [_vm._v(_vm._s(_vm.$t('right.sort')))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.gotoHot
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.hot')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.gotoNew
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.new')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.gotoNewsTopic
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.industryNews')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.findByTelegramList
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.IOBOfficialTelegram')) + "\n                  ")])])], 1)], 1)], 1)], _vm._v(" "), [_c('v-card', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "mt-3 ml-3 mr-3"
    }, [_c('label', {
      staticClass: "mt-3 primary--text font-16"
    }, [_vm._v("\n                " + _vm._s(_vm.$t("right.allTags")) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 mb-3"
    }, _vm._l((_vm.tagList), function(tag, index) {
      return _c('Tag', {
        key: tag.tagId,
        staticClass: "font-14",
        attrs: {
          "type": "border"
        }
      }, [_c('span', {
        on: {
          "click": function($event) {
            return _vm.findtagposting(tag.tagName)
          }
        }
      }, [_vm._v(_vm._s(tag.tagName))])])
    }), 1)])])], _vm._v(" "), [_c('v-card', {
      staticClass: "mt-3"
    }, [_c('v-container', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-1 primary--text",
      attrs: {
        "xs12": "",
        "md12": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-16"
    }, [_vm._v(_vm._s(_vm.$t("right.hotTopics")))])]), _vm._v(" "), _vm._l((_vm.marketsList), function(market) {
      return _c('v-flex', {
        key: market.marketId,
        staticClass: "pa-1",
        attrs: {
          "xs12": "",
          "md8": "",
          "lg12": ""
        }
      }, [_c('span', {
        staticClass: "font-14 pointer",
        on: {
          "click": function($event) {
            return _vm.findByMarkets(market)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(market.name) + "\n                  ")])])
    }), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.findByTelegramList
      }
    }, [_vm._v("\n                    IOB Official Telegram\n                  ")])])], 2)], 1)], 1)], _vm._v(" "), [_c('v-card', {
      staticClass: "mt-3"
    }, [_c('v-container', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-1 primary--text",
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": ""
      }
    }, [_c('span', {
      staticClass: "font-16"
    }, [_vm._v("IOB LLC")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": "",
        "pa-1": ""
      }
    }, [_c('div', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.goAbout
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.about')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": "",
        "pa-1": ""
      }
    }, [_c('div', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.goIobots
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.iobots')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": "",
        "pa-1": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.goPoet
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.poet')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": "",
        "pa-1": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.goIr
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.investorRelations')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": "",
        "pa-1": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.goFaq
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.faq')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": "",
        "pa-1": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.goContact
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.contact')) + "\n                  ")])])], 1)], 1)], 1)]
  ], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "img-upload"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel),
      expression: "panel"
    }],
    staticClass: "img-container"
  }, [_c('div', [_c('img', {
    attrs: {
      "id": "image",
      "src": _vm.url,
      "alt": "Picture"
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "id": "img-button-cancel"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "id": "img-button-submit"
    },
    on: {
      "click": _vm.crop
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('div', {
    staticClass: "picture"
  }, [_c('div', {
    staticClass: "user-image text-xs-center mb-3"
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "multiple": "",
      "name": "upfile",
      "max-size": 1024,
      "format": ['jpg', 'jpeg', 'png'],
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "show-upload-list": false,
      "on-success": _vm.uploadSuccess,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('img', {
    staticClass: "img-responsive rounded-circle",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "alt": "",
      "title": _vm.$t('userSetting.uploadImgTitle'),
      "src": _vm.url
    }
  })])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pa-0": ""
    }
  }, [_c('V-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "mb-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-24"
  }, [_vm._v("Financial Forecasts & Token Economics")]), _vm._v(" "), _c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("Unaudited Projections Based on Company's Latest Financial Models")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-5": "",
      "mb-5": ""
    }
  }, [_c('v-container', {
    attrs: {
      "pa-0": "",
      "grid-list-xl": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-16 primary--text"
  }, [_vm._v("2018-21 IOB QUALIFIED RESERVE")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/ir/qr.png",
      "contain": "",
      "height": "400px"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-16 primary--text"
  }, [_vm._v("2018-21 IOB REVENUE PROJECTION")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/ir/pr.png",
      "contain": "",
      "height": "400px"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-16 primary--text"
  }, [_vm._v("2018-21 IOB NET REVENUE & NET INCOME")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/ir/nr.png",
      "contain": "",
      "height": "400px"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-16 primary--text"
  }, [_vm._v("2017-21 IOB TOKEN SOLD")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/ir/ts.png",
      "contain": "",
      "height": "400px"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-16 primary--text"
  }, [_vm._v("IOB TOTAL TOKENS")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/ir/tt.png",
      "contain": "",
      "height": "400px"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-16 primary--text"
  }, [_vm._v("2018-19 FUNDING")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/ir/funding.png",
      "contain": "",
      "height": "400px"
    }
  })], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-24"
  }, [_vm._v(" IOB Token Address & Code")]), _vm._v(" "), _c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("Please double check the token address on your wallet")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-3 py-3"
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("ERC20 CONTRACT ADDRESS")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("0x6130ff302f24267380753e52ECe48B852be3Dd38")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("ETHERSCAN CONTRACT ADDRESS")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
    attrs: {
      "href": "https://etherscan.io/address/0x6130ff302f24267380753e52ece48b852be3dd38#"
    }
  }, [_vm._v("https://etherscan.io/address/0x6130ff302f24267380753e52ece48b852be3dd38")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("GITHUB CONTRACT REPOSITORIES")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
    attrs: {
      "href": "https://github.com/IOBteam?tab=repositories"
    }
  }, [_vm._v("https://github.com/IOBteam?tab=repositories")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-lg-right",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": "",
      "mt-5": ""
    }
  }, [_c('div', [_c('a', {
    attrs: {
      "href": _vm.domainName
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey",
      "size": "20"
    }
  }, [_vm._v("arrow_back")])], 1)])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("\n\t\t\t\t \n\t\t\t")]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "background-color": "#f8f8f9",
      "border-radius": "5%"
    },
    attrs: {
      "span": "12"
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('Row', [_c('Col', [_c('label', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "font-family": "'Helvetica Neue'"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tUpdate 2-Factor Authentication\n\t\t\t\t\t\t\t")])])], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "30px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#41B8BC",
      "font-size": "16px"
    }
  }, [_vm._v("Step 1. ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Install the Google Authenticator app on your phone.")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": __webpack_require__(87)
    }
  })]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "16px"
    },
    attrs: {
      "span": "10"
    }
  }, [_c('label', [_vm._v("IOS        ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-family": "Helvetica",
      "color": "#41B8BC"
    },
    attrs: {
      "href": "https://itunes.apple.com/cn/app/google-authenticator/id388497605",
      "target": "_blank"
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('label', [_vm._v(" | ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-family": "Helvetica",
      "color": "#41B8BC"
    },
    attrs: {
      "href": "https://bigone.zendesk.com/hc/zh-cn/articles/115004699233",
      "target": "_blank"
    }
  }, [_vm._v("User Guide")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Android  ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-family": "Helvetica",
      "color": "#41B8BC"
    },
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      "target": "_blank"
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('label', [_vm._v(" | ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-family": "Helvetica",
      "color": "#41B8BC"
    },
    attrs: {
      "href": "https://bigone.zendesk.com/hc/zh-cn/articles/115004714734",
      "target": "_blank"
    }
  }, [_vm._v("User Guide")])])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "30px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#41B8BC",
      "font-size": "16px"
    }
  }, [_vm._v("Step 2. ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Scan the QR code below with the authenticator app.")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "160px",
      "height": "160px"
    },
    attrs: {
      "src": _vm.qrcode
    }
  })])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "30px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#41B8BC",
      "font-size": "16px"
    }
  }, [_vm._v("Step 3. ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Write down this secret key and keep it in a safe place:")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "100px",
      "margin-top": "20px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v(_vm._s(_vm.formCustom.authenticationSecret))]), _vm._v("  \n                    "), _c('Icon', {
    staticClass: "secretKey",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "ios-copy-outline",
      "size": "20",
      "title": "Copy secret key",
      "data-clipboard-text": this.formCustom.authenticationSecret,
      "color": "#41B8BC"
    },
    on: {
      "click": _vm.copySecretKey
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("It may take up to "), _c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("7 business days")]), _vm._v(" if you try to restore 2FA without this key (e.g. your phone got lost or erased).")])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "30px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#41B8BC",
      "font-size": "16px"
    }
  }, [_vm._v("Step 4. ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Enter the 6-digit code displayed on your authenticator app below:")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-left": "100px",
      "margin-top": "30px"
    }
  }, [_c('Form', {
    ref: "formCustom",
    attrs: {
      "model": _vm.formCustom,
      "rules": _vm.ruleCustom
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "randomCode"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100px",
      "height": "30px",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "000000",
      "size": "large",
      "maxlength": 6
    },
    model: {
      value: (_vm.formCustom.randomCode),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "randomCode", $$v)
      },
      expression: "formCustom.randomCode"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "30px",
      "background": "#41B8BC"
    },
    attrs: {
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formCustom')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Helvetica",
      "color": "#FFFFFF"
    }
  }, [_vm._v("Submit")])])], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "type": "hidden",
      "disabled": ""
    },
    model: {
      value: (_vm.formCustom.id),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "id", $$v)
      },
      expression: "formCustom.id"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "authenticationSecret"
    }
  }, [_c('Input', {
    attrs: {
      "type": "hidden",
      "disabled": ""
    },
    model: {
      value: (_vm.formCustom.authenticationSecret),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "authenticationSecret", $$v)
      },
      expression: "formCustom.authenticationSecret"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "qrcode"
    }
  }, [_c('Input', {
    attrs: {
      "type": "hidden",
      "disabled": ""
    },
    model: {
      value: (_vm.formCustom.qrcode),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "qrcode", $$v)
      },
      expression: "formCustom.qrcode"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("\n\t\t\t\t \n\t\t\t")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "mt-70"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('v-card', {
    staticClass: "mb-3"
  }, [_c('v-img', {
    attrs: {
      "height": "200",
      "src": "https://t3.ftcdn.net/jpg/02/28/15/94/240_F_228159438_ws17802otLr1ZG9SK2ga7ducWtwrt2tg.jpg"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "headline white--text ml-3",
    domProps: {
      "textContent": _vm._s(_vm.telegramName)
    }
  })])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_vm._l((_vm.telegramGroupList), function(item, index) {
    return [_c('div', {
      key: index,
      staticClass: "mt-3 mb-3 ml-3 mr-3"
    }, [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.viewUserTelegramInfo(item.userName)
        }
      }
    }, [(item.photoUrl) ? _c('img', {
      attrs: {
        "src": item.photoUrl
      }
    }) : _c('span', {
      staticClass: "white--text headline"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.firstName != null),
        expression: "item.firstName != null"
      }]
    }, [_vm._v(_vm._s(item.firstName != null ? item.firstName.trim().substring(0, 1) : ''))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.firstName == null && item.lastName != null),
        expression: "item.firstName == null && item.lastName != null"
      }]
    }, [_vm._v(_vm._s(item.lastName != null ? item.lastName.trim().substring(0, 1) : ''))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.firstName == null && item.lastName == null && item.userName != null),
        expression: "item.firstName == null && item.lastName == null && item.userName != null"
      }]
    }, [_vm._v(_vm._s(item.userName != null ? item.userName.trim().substring(0, 1) : ''))])])]), _vm._v(" "), _c('span', {
      staticClass: "ml-3 pointer hover-color",
      on: {
        "click": function($event) {
          return _vm.viewUserTelegramInfo(item.userName)
        }
      }
    }, [(item.firstName != null) ? _c('span', {
      staticClass: "fw-bold font-lg"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.firstName != null ? item.firstName : '') + " " + _vm._s(item.lastName != null ? item.lastName : '') + "\n\t\t\t\t\t\t\t\t\t\t\t")]) : _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.userName != null ? item.userName : '') + "\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-3 fw-bold font-14"
    }, [_c('v-icon', {
      attrs: {
        "size": "18"
      }
    }, [_vm._v("schedule")]), _vm._v("  \n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.dateFormat(parseInt(item.date * 1000))) + "\n\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-3 ml-5 pl-2 font-md fw-400 overflow-hidden"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t\t\t\t\t\t\t\t")])], 1)]
  })], 2), _vm._v(" "), _c('keep-alive', [_c('infinite-loading', {
    ref: "infiniteLoading",
    staticClass: "mb-3",
    attrs: {
      "identifier": _vm.changeDate
    },
    on: {
      "infinite": _vm.findTelegramUserMsg
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("noMore")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("noResults")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md1": "",
      "lg4": ""
    }
  }, [_c('app-right')], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('app-header'), _vm._v(" "), _c('div', {
    class: _vm.isLogin ? 'mt-70' : ''
  }), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md7": "",
      "lg10": ""
    }
  }, [_c('div', [_c('h1', {
    staticClass: "fw-700 mb-5 text-center"
  }, [_vm._v("SiP Content Policy")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 mb-4 fw-400"
  }, [_vm._v("\n            SiP is a platform for communities to discuss, connect, and share in an open environment, home to some of the most authentic content anywhere online. The\n            nature of this content might be funny, serious, offensive, or anywhere in between. While participating, it’s important to keep in mind this value above\n            all others: show enough respect to others so that we all may continue to enjoy SiP for what it is.\n          ")]), _vm._v(" "), _c('h3', {
    staticClass: "mb-4 fw-700"
  }, [_vm._v("Unwelcome content")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 mb-3 fw-400"
  }, [_vm._v("\n            While SiP generally provides a lot of leeway in what content is acceptable, here are some guidelines for content that is not. Please keep in mind the\n            spirit in which these were written, and know that looking for loopholes is a waste of time.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 mb-3 fw-400"
  }, [_vm._v("\n            Content is prohibited if it\n            "), _c('ul', {
    staticClass: "mt-3 ml-3"
  }, [_c('li', [_vm._v("Is illegal")]), _vm._v(" "), _c('li', [_vm._v("\n                Is involuntary pornography\n                "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_c('li', {
    staticClass: "mb-1"
  }, [_vm._v("\n                    SiP prohibits the dissemination of images or video depicting any person in a state of nudity or engaged in any act of sexual conduct\n                    apparently created or posted without their permission, including depictions that have been faked.\n                  ")]), _vm._v(" "), _c('li', [_vm._v("\n                    Images or video of intimate parts of a person’s body, even if the person is clothed or in public, are also not allowed if apparently\n                    created or posted without their permission and contextualized in a salacious manner (e.g., “creepshots” or “upskirt” imagery).\n                    Additionally, do not post images or video of another person for the specific purpose of faking explicit content or soliciting\n                    “lookalike” pornography.\n                  ")])])]), _vm._v(" "), _c('li', {
    staticClass: "mt-2"
  }, [_vm._v("\n                Is sexual or suggestive content involving minors\n                "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_c('li', [_vm._v("\n                    This includes child sexual abuse imagery, child pornography, and any other content, including fantasy content (e.g. stories,\n                    “loli”/anime cartoons), that depicts encourages or promotes pedophilia, child sexual exploitation, or otherwise sexualizes minors or\n                    someone who appears to be a minor. Depending on the context, this can in some cases include depictions of minors that are fully clothed\n                    and not engaged in overtly sexual acts.\n                    If you are unsure about a piece of content involving a minor or someone who appears to be a minor, do not post it.\n                  ")])])]), _vm._v(" "), _c('li', {
    staticClass: "mt-2"
  }, [_vm._v("\n                Encourages or incites violence\n                "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_c('li', [_vm._v("\n                    Do not post content that encourages, glorifies, incites, or calls for violence or physical harm against an individual or a group of\n                    people; likewise, do not post content that glorifies or encourages the abuse of animals. We understand there are sometimes reasons to\n                    post violent content (e.g., educational, newsworthy, artistic, satire, documentary, etc.) so if you’re going to post something violent\n                    in nature that does not violate these terms, ensure you provide context to the viewer so the reason for posting is clear. If your\n                    content is borderline, please use a NSFW tag. Even mild violence can be difficult for someone to explain to others if they open it\n                    unexpectedly\n                  ")])])]), _vm._v(" "), _c('li', {
    staticClass: "mt-2"
  }, [_vm._v("\n                Threatens, harasses, or bullies or encourages others to do so\n                "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_c('li', [_vm._v("We do not tolerate the harassment of people on our site, nor do we tolerate communities dedicated to fostering harassing behavior. Harassment on SiP is defined as systematic and/or continued actions to torment or demean someone in a way that would make a reasonable person conclude that SiP is not a safe platform to express their ideas or participate in the conversation, or fear for their safety or the safety of those around them. Being annoying, vote brigading, or participating in a heated argument is not harassment, but following an individual or group of users, online or off, to the point where they no longer feel that it's safe to post online or are in fear of their real life safety is.")])])]), _vm._v(" "), _c('li', {
    staticClass: "mt-2"
  }, [_vm._v("\n                Is personal and confidential information\n                "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_vm._v("It is not okay to post someone's personal information or post links to personal information. This includes links to public Facebook pages and screenshots of Facebook pages with the names still legible. Posting someone's personal information will get you banned. When posting screenshots, be sure to edit out any personally identifiable information to avoid running afoul of this rule. Public figures can be an exception to this rule, such as posting professional links to contact a congressman or the CEO of a company. But don't post anything inviting harassment, don't harass, and don't cheer on or upvote obvious vigilantism.")])]), _vm._v(" "), _c('li', {
    staticClass: "mt-2"
  }, [_vm._v("\n                Impersonates someone in a misleading or deceptive manner\n                "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_c('li', [_vm._v("SiP does not allow users to impersonate someone in a misleading or deceptive manner. However, we do permit satire and parody accounts and subSIPs pertaining to public figures. If you believe someone is impersonating you in contravention of these guidelines, please contact the admins and we will review the account.")])])]), _vm._v(" "), _c('li', {
    staticClass: "mt-2"
  }, [_vm._v("\n                Uses SIP to solicit or facilitate any transaction or gift involving certain goods and services\n                "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_c('li', [_vm._v("\n                    Content is prohibited if it uses SiP to solicit or facilitate any transaction or gift involving certain goods and services. You may not use SiP to solicit or facilitate any transaction or gift involving certain goods and services, including\n                    "), _c('ul', [_c('li', [_vm._v("Firearms, ammunition, bump-stock-type devices, explosives, or 3D printing files to produce firearms or bump-stock-type devices;")]), _vm._v(" "), _c('li', [_vm._v("Drugs, including alcohol and tobacco, or any controlled substances;")]), _vm._v(" "), _c('li', [_vm._v("Paid services involving physical sexual contact;")]), _vm._v(" "), _c('li', [_vm._v("Stolen goods;")]), _vm._v(" "), _c('li', [_vm._v("Personal information;")]), _vm._v(" "), _c('li', [_vm._v("Falsified official documents or currency;")]), _vm._v(" "), _c('li', [_vm._v("Fraudulent services;")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "mt-2"
  }, [_vm._v("\n                Is spam\n                "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_c('li', [_vm._v("Spam on SiP is generally defined as repeated, unwanted, and/or unsolicited actions, whether automated or manual, that negatively affect SiP users, SiP communities, and/or SiP itself. Spam is punishable by content removal and account suspension or termination. As spam-like behaviors evolve, SiP will continue to adjust how we mitigate and prevent the spread of spam content.")])])]), _vm._v(" "), _c('li', {
    staticClass: "mt-2"
  }, [_c('span', {
    staticClass: "fw-700"
  }, [_vm._v("The following are examples of behavior that may be considered spam and are subject to removal/suspension:")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_c('li', [_vm._v("Sending large amounts of private messages to users who are not expecting them.")]), _vm._v(" "), _c('li', [_vm._v("Repeatedly posting the same or similar comments.")]), _vm._v(" "), _c('li', [_vm._v("Repeatedly posting unrelated/off-topic/link-farmed content.")]), _vm._v(" "), _c('li', [_vm._v("Posting content that includes link redirects as a way to circumvent an existing domain block and/or to disguise a link’s source.")]), _vm._v(" "), _c('li', [_vm._v("Linking to harmful third-party content, such as malware, phishing, deceptive pop-ups, etc.")]), _vm._v(" "), _c('li', [_vm._v("Programming bots that harm/break SiP, including bots intended to promote content/products/services.")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "mb-4 mt-4 fw-700"
  }, [_vm._v("Prohibited behavior")]), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_vm._v("\n              In addition to not submitting unwelcome content, the following behaviors are prohibited on SiP\n              "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_c('li', {
    staticClass: "mt-2"
  }, [_vm._v("\n                  Asking for votes or engaging in vote manipulation\n                  "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_c('li', [_vm._v("Vote manipulation is against the SiP rules, whether it is manual, programmatic, or otherwise. Some common forms of vote cheating are:")])])]), _vm._v(" "), _c('li', {
    staticClass: "mt-2"
  }, [_vm._v("Using multiple accounts, voting services, or any other software to increase or decrease vote scores.")]), _vm._v(" "), _c('li', [_vm._v("Asking people to vote up or down certain posts, either on SiP itself or through social networks, messaging, etc. for personal gain.")]), _vm._v(" "), _c('li', [_vm._v("Forming or joining a group that votes together, either on a specific post, a user's posts, posts from a domain, etc.")]), _vm._v(" "), _c('li', [_vm._v("\n                  Breaking SiP or doing anything that interferes with the normal use of SiP\n                  "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_c('li', [_vm._v("Don't break the site or do anything that interferes with normal use of the site. Do not interrupt the serving of SiP, introduce malicious code onto SiP, make it difficult for anyone else to use SiP due to your actions, block sponsored headlines, create programs that violate any of our other API rules, or assist anyone in misusing SiP in any way.")])])]), _vm._v(" "), _c('li', {
    staticClass: "mt-2"
  }, [_vm._v("Creating multiple accounts to evade punishment or avoid restrictions")])])]), _vm._v(" "), _c('h3', {
    staticClass: "mb-4 mt-4 fw-700"
  }, [_vm._v("NSFW (Not Safe For Work) content")]), _vm._v(" "), _c('div', {
    staticClass: "mb-4"
  }, [_vm._v("Content that contains nudity, pornography, or profanity, which a reasonable viewer may not want to be seen accessing in a public or formal setting such as in a workplace should be tagged as NSFW. This tag can be applied to individual pieces of content or to entire communities.")]), _vm._v(" "), _c('h3', {
    staticClass: "mb-4 mt-4 fw-700"
  }, [_vm._v("Enforcement")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 mb-3 fw-400"
  }, [_vm._v("\n              We have a variety of ways of enforcing our rules, including, but not limited to\n              "), _c('ul', {
    staticClass: "mt-2 ml-3"
  }, [_c('li', [_vm._v("Asking you nicely to knock it off.")]), _vm._v(" "), _c('li', [_vm._v("Asking you less nicely.")]), _vm._v(" "), _c('li', [_vm._v("Temporary or permanent suspension of accounts.")]), _vm._v(" "), _c('li', [_vm._v("Removal of privileges from, or adding restrictions to, accounts.")]), _vm._v(" "), _c('li', [_vm._v("Removal of content.")])])])])])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    class: _vm.isLogin ? 'mt-70' : ''
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('div', [_vm._l((_vm.postList), function(post, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-4"
    }, [_c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media"
    }, _vm._l((_vm.userDetailList), function(user, index) {
      return (post.postingUserId == user.userId) ? _c('div', {
        key: index,
        staticClass: "ml-2 pt-3 mr-2"
      }, [_c('div', {
        staticClass: "mb-3"
      }, [_c('v-avatar', {
        staticClass: "pointer",
        attrs: {
          "color": "primary",
          "size": "34"
        },
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image != null),
          expression: "user.image != null"
        }],
        attrs: {
          "src": user.image,
          "alt": user.userName
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image == null),
          expression: "user.image == null"
        }],
        staticClass: "headline white--text"
      }, [_vm._v("\n                              " + _vm._s(user.userName
        .trim()
        .substring(0, 1)
        .toLocaleUpperCase()) + "\n                            ")])]), _vm._v(" "), _c('span', {
        staticClass: "pl-2 pointer hover-color font-16",
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_vm._v("\n                            " + _vm._s(user.nickName) + "\n                            "), _c('span', [_vm._v("(" + _vm._s(user.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
        staticClass: "px-2 font-14"
      }, [_c('v-icon', {
        attrs: {
          "size": "18"
        }
      }, [_vm._v("schedule")]), _vm._v("\n                            " + _vm._s(_vm.dateFormat(post.postingTime)) + "\n                          ")], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_vm._l((_vm.userDetailList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('div', {
          key: index,
          staticClass: "px-0"
        }, [(post.postingImg != '') ? _c('span', {
          staticClass: "rounded-circle mr-4 img-responsive posts-image pointer",
          domProps: {
            "innerHTML": _vm._s(post.postingImg)
          },
          on: {
            "click": function($event) {
              return _vm.findsel(post)
            }
          }
        }) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), _c('div', {
        staticClass: "media-body"
      }, [_c('h3', {
        staticClass: "pointer break-word",
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v(_vm._s(post.postingTitle))]), _vm._v(" "), _c('h5', {
        staticClass: "mb-3 py-2",
        domProps: {
          "innerHTML": _vm._s(post.postingContent)
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "mt-1 justify-space-between"
      }, [_c('div', {
        staticClass: "social"
      }, [_c('span', {
        staticClass: "pointer"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.bonus')
        }
      }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
        staticClass: "font-12 ml-1"
      }, [_vm._v(_vm._s(post.bonus.toFixed(2)))])], 1), _vm._v(" "), (post.postingStatus == 0) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == 1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == -1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.comment')
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingCountComments))])], 1), _vm._v(" "), _vm._l((_vm.userDetailList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('span', {
          staticClass: "ml-2"
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.retweet')
          },
          on: {
            "click": function($event) {
              return _vm.modalzf(post, user)
            }
          }
        }, [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(post.postingCountForword))])], 1) : _vm._e()
      }), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [(post.postingCollection == 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("\n                                    fa fa-star\n                                  ")]) : _vm._e()], 1), _vm._v(" "), _c('span', [(post.postingCollection != 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("fa fa-star")]) : _vm._e()], 1)], 2)])])], 2), _vm._v(" "), _c('div', {
        staticClass: "mt-3"
      }, _vm._l((_vm.commentList), function(postcomments, index) {
        return (post.postingId == postcomments.commentsPostingId) ? _c('span', {
          key: index,
          staticClass: "flex-middle"
        }, [_vm._l((_vm.commentUserDetailList), function(userpopular, index) {
          return (postcomments.commentsUserId == userpopular.userId) ? _c('span', {
            key: index
          }, [_c('v-avatar', {
            staticClass: "pointer",
            attrs: {
              "color": "primary",
              "size": "32"
            },
            on: {
              "click": function($event) {
                return _vm.goUserData(userpopular.userName)
              }
            }
          }, [_c('img', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (userpopular.image != null),
              expression: "userpopular.image != null"
            }],
            attrs: {
              "src": userpopular.image,
              "alt": userpopular.userName
            }
          }), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (userpopular.image == null),
              expression: "userpopular.image == null"
            }],
            staticClass: "headline white--text"
          }, [_vm._v("\n                                  " + _vm._s(userpopular.userName
            .trim()
            .substring(0, 1)
            .toLocaleUpperCase()) + "\n                                ")])])], 1) : _vm._e()
        }), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-2"
        }, [(post.postingContent.length > 20) ? _c('span', [_vm._v(_vm._s(postcomments.commentsContext))]) : _c('span', [_vm._v(_vm._s(postcomments.commentsContext) + "……")])])], 2) : _vm._e()
      }), 0)]) : _vm._e()
    }), 0)])])])
  }), _vm._v(" "), _c('infinite-loading', {
    staticClass: "mb-3",
    attrs: {
      "identifier": _vm.postsTabName
    },
    on: {
      "infinite": _vm.getPostsByTagName
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t('posting.noMore')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t('posting.noResults')))])])], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.forwardModal),
      callback: function($$v) {
        _vm.forwardModal = $$v
      },
      expression: "forwardModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "font-30"
  }, [_vm._v(_vm._s(_vm.$t('posting.retweet')))])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "32"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage != null),
      expression: "postUserImage != null"
    }],
    attrs: {
      "src": _vm.postUserImage,
      "alt": _vm.postUserName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage == null),
      expression: "postUserImage == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v("\n                            " + _vm._s(_vm.postUserName
    .trim()
    .substring(0, 1)
    .toLocaleUpperCase()) + "\n                          ")])])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
    staticClass: "pointer font-18",
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_vm._v(_vm._s(_vm.postNickName))]), _vm._v(" "), _c('span', {
    staticClass: "px-2 font-16"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('common.at')) + "\n                            "), _c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("schedule")]), _vm._v("\n                            " + _vm._s(_vm.dateFormat(_vm.postDate)) + "\n                          ")], 1)]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', {
    staticClass: "font-14"
  }, [_vm._v(_vm._s(_vm.postTitle))])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-form', {
    ref: "formValidatezf"
  }, [_c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "input-7-4"
    },
    model: {
      value: (_vm.formValidatezf.postingForwardContext),
      callback: function($$v) {
        _vm.$set(_vm.formValidatezf, "postingForwardContext", $$v)
      },
      expression: "formValidatezf.postingForwardContext"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.forwardModal = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.postingforward
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "lg4": ""
    }
  }, [_c('app-right')], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUploadDiv),
      expression: "isShowUploadDiv"
    }]
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "mt-7": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "font-2x fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("uploadMaterial.selfie")))]), _vm._v(" "), _c('div', {
    staticClass: "font-lg mt-3"
  }, [_vm._v(_vm._s(_vm.userRequest.regEmail + ',') + _vm._s(_vm.$t("uploadMaterial.attachMessage")))]), _vm._v(" "), _c('v-form', {
    staticClass: "font-lg mt-3"
  }, [_c('Upload', {
    attrs: {
      "type": "drag",
      "enctype": "multipart/form-data",
      "action": "",
      "name": "upfile",
      "before-upload": _vm.beforeUpload,
      "show-upload-list": false
    }
  }, [_c('Icon', {
    staticClass: "primary--text",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "50"
    }
  }), _vm._v(" "), (_vm.file !== null) ? _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadFile")) + ": " + _vm._s(_vm.file.name))]) : _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadHint")))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text mt-3",
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.clearFile
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("common.clear")) + "\n                                ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text mt-3",
    attrs: {
      "outline": "",
      "loading": _vm.uploadLoading,
      "disabled": _vm.file == null
    },
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("uploadMaterial.upload")) + "\n                                    "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("cloud_upload")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowUploadDiv),
      expression: "!isShowUploadDiv"
    }]
  }, [_c('app-link-invalid')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    class: _vm.isLogin ? 'mt-70' : ''
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": "",
      "pl-0": "",
      "pr-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(this.$store.getters.pageTitle == 'hot') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('div', [_vm._l((_vm.postHotList), function(post, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-4"
    }, [_c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media"
    }, _vm._l((_vm.userDetailHotList), function(user, index) {
      return (post.postingUserId == user.userId) ? _c('div', {
        key: index,
        staticClass: "ml-2 pt-3 mr-2"
      }, [_c('div', {
        staticClass: "mb-3"
      }, [_c('v-avatar', {
        staticClass: "pointer",
        attrs: {
          "color": "primary",
          "size": "34"
        },
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image != null),
          expression: "user.image != null"
        }],
        attrs: {
          "src": user.image,
          "alt": user.userName
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image == null),
          expression: "user.image == null"
        }],
        staticClass: "headline white--text"
      }, [_vm._v("\n                                " + _vm._s(user.userName
        .trim()
        .substring(0, 1)
        .toLocaleUpperCase()) + "\n                              ")])]), _vm._v(" "), _c('span', {
        staticClass: "pl-2 pointer hover-color font-16",
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_vm._v("\n                              " + _vm._s(user.nickName) + "\n                              "), _c('span', [_vm._v("(" + _vm._s(user.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
        staticClass: "px-2 fw-500 font-14"
      }, [_c('v-icon', {
        attrs: {
          "size": "16"
        }
      }, [_vm._v("schedule")]), _vm._v("\n                              " + _vm._s(_vm.dateFormat(post.postingTime)) + "\n                            ")], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_vm._l((_vm.userDetailHotList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('div', {
          key: index,
          staticClass: "px-0"
        }, [(post.postingImg != '') ? _c('span', {
          staticClass: "rounded-circle mr-4 img-responsive posts-image pointer",
          domProps: {
            "innerHTML": _vm._s(post.postingImg)
          },
          on: {
            "click": function($event) {
              return _vm.findsel(post)
            }
          }
        }) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), _c('div', {
        staticClass: "media-body"
      }, [_c('div', {
        staticClass: "pointer break-word font-20",
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v(_vm._s(post.postingTitle))]), _vm._v(" "), _c('div', {
        staticClass: "mb-3 py-2 font-14",
        domProps: {
          "innerHTML": _vm._s(post.postingContent)
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "mt-1 justify-space-between"
      }, [_c('div', {
        staticClass: "social"
      }, [_c('span', {
        staticClass: "pointer"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.bonus')
        }
      }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
        staticClass: "font-1x fw-400 ml-1"
      }, [_vm._v(_vm._s(post.bonus.toFixed(2)))])], 1), _vm._v(" "), (post.postingStatus == 0) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == 1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == -1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.comment')
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 fw-400 ml-1"
      }, [_vm._v(_vm._s(post.postingCountComments))])], 1), _vm._v(" "), _vm._l((_vm.userDetailHotList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('span', {
          staticClass: "ml-2"
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.retweet')
          },
          on: {
            "click": function($event) {
              return _vm.modalzf(post, user)
            }
          }
        }, [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 fw-400 ml-1"
        }, [_vm._v(_vm._s(post.postingCountForword))])], 1) : _vm._e()
      }), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [(post.postingCollection == 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("\n                                      fa fa-star\n                                    ")]) : _vm._e()], 1), _vm._v(" "), _c('span', [(post.postingCollection != 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("fa fa-star")]) : _vm._e()], 1)], 2)])])], 2), _vm._v(" "), _c('div', {
        staticClass: "mt-3"
      }, _vm._l((_vm.commentHotList), function(postcomments, index) {
        return (post.postingId == postcomments.commentsPostingId) ? _c('span', {
          key: index,
          staticClass: "flex-middle"
        }, [_vm._l((_vm.commentUserHotList), function(userpopular, index) {
          return (postcomments.commentsUserId == userpopular.userId) ? _c('span', {
            key: index
          }, [_c('v-avatar', {
            staticClass: "pointer",
            attrs: {
              "color": "primary",
              "size": "32"
            },
            on: {
              "click": function($event) {
                return _vm.goUserData(userpopular.userName)
              }
            }
          }, [_c('img', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (userpopular.image != null),
              expression: "userpopular.image != null"
            }],
            attrs: {
              "src": userpopular.image,
              "alt": userpopular.userName
            }
          }), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (userpopular.image == null),
              expression: "userpopular.image == null"
            }],
            staticClass: "headline white--text"
          }, [_vm._v("\n                                    " + _vm._s(userpopular.userName
            .trim()
            .substring(0, 1)
            .toLocaleUpperCase()) + "\n                                  ")])])], 1) : _vm._e()
        }), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-2"
        }, [(post.postingContent.length > 20) ? _c('span', [_vm._v(_vm._s(postcomments.commentsContext))]) : _c('span', [_vm._v(_vm._s(postcomments.commentsContext) + "……")])])], 2) : _vm._e()
      }), 0)]) : _vm._e()
    }), 0)])])])
  }), _vm._v(" "), _c('infinite-loading', {
    staticClass: "mb-3",
    attrs: {
      "identifier": _vm.tabName
    },
    on: {
      "infinite": _vm.getPostHotList
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t("posting.noMore")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t("posting.noResults")))])])], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.forwardModal),
      callback: function($$v) {
        _vm.forwardModal = $$v
      },
      expression: "forwardModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "font-30"
  }, [_vm._v(_vm._s(_vm.$t('posting.retweet')))])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "34"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage != null),
      expression: "postUserImage != null"
    }],
    attrs: {
      "src": _vm.postUserImage,
      "alt": _vm.postUserName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage == null),
      expression: "postUserImage == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v("\n                              " + _vm._s(_vm.postUserName
    .trim()
    .substring(0, 1)
    .toLocaleUpperCase()) + "\n                            ")])])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
    staticClass: "pointer font-18",
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_vm._v(_vm._s(_vm.postNickName))]), _vm._v(" "), _c('span', {
    staticClass: "px-2 font-16"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('common.at')) + "\n                              "), _c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("schedule")]), _vm._v("\n                              " + _vm._s(_vm.dateFormat(_vm.postDate)) + "\n                            ")], 1)]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', {
    staticClass: "font-14"
  }, [_vm._v(_vm._s(_vm.postTitle))])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-form', {
    ref: "formValidatezf"
  }, [_c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "input-7-4"
    },
    model: {
      value: (_vm.formValidatezf.postingForwardContext),
      callback: function($$v) {
        _vm.$set(_vm.formValidatezf, "postingForwardContext", $$v)
      },
      expression: "formValidatezf.postingForwardContext"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.forwardModal = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.postingforward
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.pageTitle == 'new') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "lg8": ""
    }
  }, [_vm._l((_vm.postNewList), function(post, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-4"
    }, [_c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media"
    }, _vm._l((_vm.userDetailNewList), function(user, index) {
      return (post.postingUserId == user.userId) ? _c('div', {
        key: index,
        staticClass: "ml-2 pt-3 mr-2"
      }, [_c('div', {
        staticClass: "mb-3"
      }, [_c('v-avatar', {
        staticClass: "pointer",
        attrs: {
          "color": "primary",
          "size": "34"
        },
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image != null),
          expression: "user.image != null"
        }],
        attrs: {
          "src": user.image,
          "alt": user.userName
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (user.image == null),
          expression: "user.image == null"
        }],
        staticClass: "headline white--text"
      }, [_vm._v("\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(user.userName
        .trim()
        .substring(0, 1)
        .toLocaleUpperCase()) + "\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('span', {
        staticClass: "pl-2 pointer hover-color font-16",
        on: {
          "click": function($event) {
            return _vm.goUserData(user.userName)
          }
        }
      }, [_vm._v("\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(user.nickName) + "\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v("(" + _vm._s(user.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
        staticClass: "px-2 fw-500 font-14"
      }, [_c('v-icon', {
        attrs: {
          "size": "16"
        }
      }, [_vm._v("schedule")]), _vm._v("\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.dateFormat(post.postingTime)) + "\n  \t\t\t\t\t\t\t\t\t\t\t\t\t")], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_vm._l((_vm.userDetailNewList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('div', {
          key: index,
          staticClass: "px-0"
        }, [(post.postingImg != '') ? _c('span', {
          staticClass: "mr-4 img-responsive posts-image pointer",
          domProps: {
            "innerHTML": _vm._s(post.postingImg)
          },
          on: {
            "click": function($event) {
              return _vm.findsel(post)
            }
          }
        }) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), _c('div', {
        staticClass: "media-body"
      }, [_c('div', {
        staticClass: "pointer break-word font-20",
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v(_vm._s(post.postingTitle))]), _vm._v(" "), _c('div', {
        staticClass: "mb-3 py-2 font-12",
        domProps: {
          "innerHTML": _vm._s(post.postingContent)
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "mt-1 justify-space-between"
      }, [_c('div', {
        staticClass: "social"
      }, [_c('span', {
        staticClass: "pointer"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.bonus')
        }
      }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
        staticClass: "font-1x ml-1"
      }, [_vm._v(_vm._s(post.bonus.toFixed(2)))])], 1), _vm._v(" "), (post.postingStatus == 0) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == 1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), (post.postingStatus == -1) ? _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.changesup(post)
          }
        }
      }, [_vm._v("thumb_up")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingGoodnums))]), _vm._v(" "), _c('v-icon', {
        staticClass: "ml-2",
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.changesdown(post)
          }
        }
      }, [_vm._v("thumb_down")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingStepnums))])], 1) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.comment')
        },
        on: {
          "click": function($event) {
            return _vm.findsel(post)
          }
        }
      }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
        staticClass: "font-14 ml-1"
      }, [_vm._v(_vm._s(post.postingCountComments))])], 1), _vm._v(" "), _vm._l((_vm.userDetailNewList), function(user, index) {
        return (post.postingUserId == user.userId) ? _c('span', {
          staticClass: "ml-2"
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.retweet')
          },
          on: {
            "click": function($event) {
              return _vm.modalzf(post, user)
            }
          }
        }, [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(post.postingCountForword))])], 1) : _vm._e()
      }), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [(post.postingCollection == 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "color": "primary",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfa fa-star\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('span', [(post.postingCollection != 0) ? _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.save')
        },
        on: {
          "click": function($event) {
            return _vm.collectionPosting(post)
          }
        }
      }, [_vm._v("fa fa-star")]) : _vm._e()], 1)], 2)])])], 2), _vm._v(" "), _c('div', {
        staticClass: "mt-3"
      }, _vm._l((_vm.commentNewList), function(postcomments, index) {
        return (post.postingId == postcomments.commentsPostingId) ? _c('span', {
          key: index,
          staticClass: "flex-middle"
        }, [_vm._l((_vm.commentUserNewList), function(userpopular, index) {
          return (postcomments.commentsUserId == userpopular.userId) ? _c('span', {
            key: index
          }, [_c('v-avatar', {
            staticClass: "pointer",
            attrs: {
              "color": "primary",
              "size": "32"
            },
            on: {
              "click": function($event) {
                return _vm.goUserData(userpopular.userName)
              }
            }
          }, [_c('img', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (userpopular.image != null),
              expression: "userpopular.image != null"
            }],
            attrs: {
              "src": userpopular.image,
              "alt": userpopular.userName
            }
          }), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (userpopular.image == null),
              expression: "userpopular.image == null"
            }],
            staticClass: "headline white--text"
          }, [_vm._v("\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(userpopular.userName
            .trim()
            .substring(0, 1)
            .toLocaleUpperCase()) + "\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])], 1) : _vm._e()
        }), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-2"
        }, [(post.postingContent.length > 20) ? _c('span', [_vm._v(_vm._s(postcomments.commentsContext))]) : _c('span', [_vm._v(_vm._s(postcomments.commentsContext) + "……")])])], 2) : _vm._e()
      }), 0)]) : _vm._e()
    }), 0)])])])
  }), _vm._v(" "), _c('keep-alive', [_c('infinite-loading', {
    staticClass: "mb-3",
    attrs: {
      "identifier": _vm.tabName
    },
    on: {
      "infinite": _vm.getPostNewList
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t('posting.noMore')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v(_vm._s(_vm.$t('posting.noResults')))])])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.forwardModal),
      callback: function($$v) {
        _vm.forwardModal = $$v
      },
      expression: "forwardModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "font-30"
  }, [_vm._v(_vm._s(_vm.$t('posting.retweet')))])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "34"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage != null),
      expression: "postUserImage != null"
    }],
    attrs: {
      "src": _vm.postUserImage,
      "alt": _vm.postUserName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postUserImage == null),
      expression: "postUserImage == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v("\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.postUserName
    .trim()
    .substring(0, 1)
    .toLocaleUpperCase()) + "\n  \t\t\t\t\t\t\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
    staticClass: "pointer font-18",
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.postUserName)
      }
    }
  }, [_vm._v(_vm._s(_vm.postNickName))]), _vm._v(" "), _c('span', {
    staticClass: "px-2 font-16"
  }, [_vm._v("\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('common.at')) + "\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("schedule")]), _vm._v("\n  \t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.dateFormat(_vm.postDate)) + "\n  \t\t\t\t\t\t\t\t\t\t\t\t\t")], 1)]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', {
    staticClass: "font-14"
  }, [_vm._v(_vm._s(_vm.postTitle))])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-form', {
    ref: "formValidatezf"
  }, [_c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "input-7-4"
    },
    model: {
      value: (_vm.formValidatezf.postingForwardContext),
      callback: function($$v) {
        _vm.$set(_vm.formValidatezf, "postingForwardContext", $$v)
      },
      expression: "formValidatezf.postingForwardContext"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.forwardModal = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.postingforward
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "lg4": ""
    }
  }, [_c('app-right')], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 477 */,
/* 478 */,
/* 479 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[179]);


// WEBPACK FOOTER //
// static/js/app.6319a173cb8b005eba68.js